/* eslint-disable */
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

export type AbortTripInput = {
  tripIds: Array<Scalars['String']['input']>;
};

export type AbortTripResponse = {
  __typename?: 'AbortTripResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type AcceptInputOption = {
  __typename?: 'AcceptInputOption';
  acceptInput: Scalars['Boolean']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  value?: Maybe<Scalars['Int']['output']>;
};

export type AcceptResponse = {
  __typename?: 'AcceptResponse';
  accepted: Scalars['Boolean']['output'];
  error?: Maybe<Error>;
  id: Scalars['String']['output'];
};

export type AccidentIssue = {
  __typename?: 'AccidentIssue';
  accidentDatetime: Scalars['String']['output'];
  additionalDriverScheduled?: Maybe<Scalars['Int']['output']>;
  anyoneInjured: AccidentIssueAnyoneInjuredEnum;
  canVehicleBeDriven: AccidentIssueCanVehicleBeDrivenEnum;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  damageToOtherVehicles?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  didDriverCallHelp: AccidentIssueDidDriverCallHelpEnum;
  dispatcherContactedManager?: Maybe<Scalars['Int']['output']>;
  dispatcherId: Scalars['String']['output'];
  driverContactedManager?: Maybe<Scalars['Int']['output']>;
  driverId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  infoOfCrewMembers?: Maybe<Scalars['String']['output']>;
  infoOfInjuredParties?: Maybe<Scalars['String']['output']>;
  medicalNeeded: AccidentIssueMedicalNeededEnum;
  outboundDatetime?: Maybe<Scalars['String']['output']>;
  outboundFlightName?: Maybe<Scalars['String']['output']>;
  outboundFlightNumber?: Maybe<Scalars['Int']['output']>;
  safetyId: Scalars['String']['output'];
  safetyNotified: AccidentIssueSafetyNotifiedEnum;
  samsaraCameraWorking?: Maybe<AccidentIssueSamsaraCameraWorkingEnum>;
  specificLocation: Scalars['String']['output'];
  stationText: Scalars['String']['output'];
  thirdPartyInformation?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  tripId?: Maybe<Scalars['String']['output']>;
  typeOfMedicalAttention?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId: Scalars['String']['output'];
  wasCeoCalled: AccidentIssueWasCeoCalledEnum;
  wasCrewInvolved: AccidentIssueWasCrewInvolvedEnum;
  wasDriverAtFault: AccidentIssueWasDriverAtFaultEnum;
  wasThirdPartyInvolved: AccidentIssueWasThirdPartyInvolvedEnum;
};

export type AccidentIssueActivityConnection = {
  __typename?: 'AccidentIssueActivityConnection';
  edges?: Maybe<Array<Maybe<AccidentIssueActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AccidentIssueActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AccidentIssueActivityEdge = {
  __typename?: 'AccidentIssueActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AccidentIssueAndDocument = {
  __typename?: 'AccidentIssueAndDocument';
  document?: Maybe<Array<AccidentIssueDocumentAndPresignedUrl>>;
  issue: AccidentIssue;
};

export enum AccidentIssueAnyoneInjuredEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueAnyoneInjuredEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueAnyoneInjuredEnum>;
};

export enum AccidentIssueCanVehicleBeDrivenEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueCanVehicleBeDrivenEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueCanVehicleBeDrivenEnum>;
};

export type AccidentIssueConnection = {
  __typename?: 'AccidentIssueConnection';
  edges?: Maybe<Array<Maybe<AccidentIssueEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AccidentIssueConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AccidentIssueMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AccidentIssueSearch>>;
};

export enum AccidentIssueDidDriverCallHelpEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueDidDriverCallHelpEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueDidDriverCallHelpEnum>;
};

export type AccidentIssueDocument = {
  __typename?: 'AccidentIssueDocument';
  contentType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  fileLocation: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  issueId: Scalars['String']['output'];
  md5: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AccidentIssueDocumentActivityConnection = {
  __typename?: 'AccidentIssueDocumentActivityConnection';
  edges?: Maybe<Array<Maybe<AccidentIssueDocumentActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AccidentIssueDocumentActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AccidentIssueDocumentActivityEdge = {
  __typename?: 'AccidentIssueDocumentActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AccidentIssueDocumentAndPresignedUrl = {
  __typename?: 'AccidentIssueDocumentAndPresignedURL';
  document?: Maybe<AccidentIssueDocument>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

export type AccidentIssueDocumentConnection = {
  __typename?: 'AccidentIssueDocumentConnection';
  edges?: Maybe<Array<Maybe<AccidentIssueDocumentEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AccidentIssueDocumentConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AccidentIssueDocumentMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AccidentIssueDocumentSearch>>;
};

export type AccidentIssueDocumentEdge = {
  __typename?: 'AccidentIssueDocumentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AccidentIssueDocument>;
};

export type AccidentIssueDocumentMaskInput = {
  contentType?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  fileSize?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  issueId?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AccidentIssueDocumentSearch = {
  contentType?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  fileSize?: InputMaybe<Array<IntSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  issueId?: InputMaybe<Array<StringSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type AccidentIssueEdge = {
  __typename?: 'AccidentIssueEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AccidentIssue>;
};

export type AccidentIssueMaskInput = {
  accidentDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  additionalDriverScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  anyoneInjured?: InputMaybe<Scalars['Boolean']['input']>;
  canVehicleBeDriven?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  damageToOtherVehicles?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  didDriverCallHelp?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherContactedManager?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherId?: InputMaybe<Scalars['Boolean']['input']>;
  driverContactedManager?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  infoOfCrewMembers?: InputMaybe<Scalars['Boolean']['input']>;
  infoOfInjuredParties?: InputMaybe<Scalars['Boolean']['input']>;
  medicalNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  outboundDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightName?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  safetyId?: InputMaybe<Scalars['Boolean']['input']>;
  safetyNotified?: InputMaybe<Scalars['Boolean']['input']>;
  samsaraCameraWorking?: InputMaybe<Scalars['Boolean']['input']>;
  specificLocation?: InputMaybe<Scalars['Boolean']['input']>;
  stationText?: InputMaybe<Scalars['Boolean']['input']>;
  thirdPartyInformation?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  typeOfMedicalAttention?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  wasCeoCalled?: InputMaybe<Scalars['Boolean']['input']>;
  wasCrewInvolved?: InputMaybe<Scalars['Boolean']['input']>;
  wasDriverAtFault?: InputMaybe<Scalars['Boolean']['input']>;
  wasThirdPartyInvolved?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AccidentIssueMedicalNeededEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueMedicalNeededEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueMedicalNeededEnum>;
};

export enum AccidentIssueSafetyNotifiedEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueSafetyNotifiedEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueSafetyNotifiedEnum>;
};

export enum AccidentIssueSamsaraCameraWorkingEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueSamsaraCameraWorkingEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueSamsaraCameraWorkingEnum>;
};

export type AccidentIssueSearch = {
  accidentDatetime?: InputMaybe<Array<StringSearch>>;
  additionalDriverScheduled?: InputMaybe<Array<IntSearch>>;
  anyoneInjured?: InputMaybe<Array<AccidentIssueAnyoneInjuredEnumSearch>>;
  canVehicleBeDriven?: InputMaybe<Array<AccidentIssueCanVehicleBeDrivenEnumSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  damageToOtherVehicles?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  didDriverCallHelp?: InputMaybe<Array<AccidentIssueDidDriverCallHelpEnumSearch>>;
  dispatcherContactedManager?: InputMaybe<Array<IntSearch>>;
  dispatcherId?: InputMaybe<Array<StringSearch>>;
  driverContactedManager?: InputMaybe<Array<IntSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  infoOfCrewMembers?: InputMaybe<Array<StringSearch>>;
  infoOfInjuredParties?: InputMaybe<Array<StringSearch>>;
  medicalNeeded?: InputMaybe<Array<AccidentIssueMedicalNeededEnumSearch>>;
  outboundDatetime?: InputMaybe<Array<StringSearch>>;
  outboundFlightName?: InputMaybe<Array<StringSearch>>;
  outboundFlightNumber?: InputMaybe<Array<IntSearch>>;
  safetyId?: InputMaybe<Array<StringSearch>>;
  safetyNotified?: InputMaybe<Array<AccidentIssueSafetyNotifiedEnumSearch>>;
  samsaraCameraWorking?: InputMaybe<Array<AccidentIssueSamsaraCameraWorkingEnumSearch>>;
  specificLocation?: InputMaybe<Array<StringSearch>>;
  stationText?: InputMaybe<Array<StringSearch>>;
  thirdPartyInformation?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  typeOfMedicalAttention?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  wasCeoCalled?: InputMaybe<Array<AccidentIssueWasCeoCalledEnumSearch>>;
  wasCrewInvolved?: InputMaybe<Array<AccidentIssueWasCrewInvolvedEnumSearch>>;
  wasDriverAtFault?: InputMaybe<Array<AccidentIssueWasDriverAtFaultEnumSearch>>;
  wasThirdPartyInvolved?: InputMaybe<Array<AccidentIssueWasThirdPartyInvolvedEnumSearch>>;
};

export enum AccidentIssueWasCeoCalledEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWasCeoCalledEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWasCeoCalledEnum>;
};

export enum AccidentIssueWasCrewInvolvedEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWasCrewInvolvedEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWasCrewInvolvedEnum>;
};

export enum AccidentIssueWasDriverAtFaultEnum {
  Investigating = 'INVESTIGATING',
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWasDriverAtFaultEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWasDriverAtFaultEnum>;
};

export enum AccidentIssueWasThirdPartyInvolvedEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWasThirdPartyInvolvedEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWasThirdPartyInvolvedEnum>;
};

export type AccidentIssueWithCache = {
  __typename?: 'AccidentIssueWithCache';
  accidentDatetime: Scalars['String']['output'];
  additionalDriverScheduled?: Maybe<Scalars['Int']['output']>;
  anyoneInjured: AccidentIssueWithCacheAnyoneInjuredEnum;
  canVehicleBeDriven: AccidentIssueWithCacheCanVehicleBeDrivenEnum;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  damageToOtherVehicles?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  didDriverCallHelp: AccidentIssueWithCacheDidDriverCallHelpEnum;
  dispatcherContactedManager?: Maybe<Scalars['Int']['output']>;
  dispatcherEmployeeId?: Maybe<Scalars['String']['output']>;
  dispatcherFirstName: Scalars['String']['output'];
  dispatcherId: Scalars['String']['output'];
  dispatcherLastName: Scalars['String']['output'];
  driverContactedManager?: Maybe<Scalars['Int']['output']>;
  driverEmployeeId?: Maybe<Scalars['String']['output']>;
  driverFirstName: Scalars['String']['output'];
  driverId: Scalars['String']['output'];
  driverLastName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  infoOfCrewMembers?: Maybe<Scalars['String']['output']>;
  infoOfInjuredParties?: Maybe<Scalars['String']['output']>;
  medicalNeeded: AccidentIssueWithCacheMedicalNeededEnum;
  outboundDatetime?: Maybe<Scalars['String']['output']>;
  outboundFlightName?: Maybe<Scalars['String']['output']>;
  outboundFlightNumber?: Maybe<Scalars['Int']['output']>;
  safetyEmployeeId?: Maybe<Scalars['String']['output']>;
  safetyFirstName: Scalars['String']['output'];
  safetyId: Scalars['String']['output'];
  safetyLastName: Scalars['String']['output'];
  safetyNotified: AccidentIssueWithCacheSafetyNotifiedEnum;
  samsaraCameraWorking?: Maybe<AccidentIssueWithCacheSamsaraCameraWorkingEnum>;
  specificLocation: Scalars['String']['output'];
  stationText: Scalars['String']['output'];
  thirdPartyInformation?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  tripFlightNumber: Scalars['Int']['output'];
  tripId?: Maybe<Scalars['String']['output']>;
  tripLoopName: Scalars['String']['output'];
  tripScheduled: Scalars['String']['output'];
  tripServicerIataAirlineCode: Scalars['String']['output'];
  typeOfMedicalAttention?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId: Scalars['String']['output'];
  vehicleTrackingId: Scalars['String']['output'];
  wasCeoCalled: AccidentIssueWithCacheWasCeoCalledEnum;
  wasCrewInvolved: AccidentIssueWithCacheWasCrewInvolvedEnum;
  wasDriverAtFault: AccidentIssueWithCacheWasDriverAtFaultEnum;
  wasThirdPartyInvolved: AccidentIssueWithCacheWasThirdPartyInvolvedEnum;
};

export type AccidentIssueWithCacheActivityConnection = {
  __typename?: 'AccidentIssueWithCacheActivityConnection';
  edges?: Maybe<Array<Maybe<AccidentIssueWithCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AccidentIssueWithCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AccidentIssueWithCacheActivityEdge = {
  __typename?: 'AccidentIssueWithCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum AccidentIssueWithCacheAnyoneInjuredEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWithCacheAnyoneInjuredEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWithCacheAnyoneInjuredEnum>;
};

export enum AccidentIssueWithCacheCanVehicleBeDrivenEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWithCacheCanVehicleBeDrivenEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWithCacheCanVehicleBeDrivenEnum>;
};

export type AccidentIssueWithCacheConnection = {
  __typename?: 'AccidentIssueWithCacheConnection';
  edges?: Maybe<Array<Maybe<AccidentIssueWithCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AccidentIssueWithCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AccidentIssueWithCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AccidentIssueWithCacheSearch>>;
};

export enum AccidentIssueWithCacheDidDriverCallHelpEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWithCacheDidDriverCallHelpEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWithCacheDidDriverCallHelpEnum>;
};

export type AccidentIssueWithCacheEdge = {
  __typename?: 'AccidentIssueWithCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AccidentIssueWithCache>;
};

export type AccidentIssueWithCacheMaskInput = {
  accidentDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  additionalDriverScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  anyoneInjured?: InputMaybe<Scalars['Boolean']['input']>;
  canVehicleBeDriven?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  damageToOtherVehicles?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  didDriverCallHelp?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherContactedManager?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherId?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherLastName?: InputMaybe<Scalars['Boolean']['input']>;
  driverContactedManager?: InputMaybe<Scalars['Boolean']['input']>;
  driverEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  driverFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  driverLastName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  infoOfCrewMembers?: InputMaybe<Scalars['Boolean']['input']>;
  infoOfInjuredParties?: InputMaybe<Scalars['Boolean']['input']>;
  medicalNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  outboundDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightName?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  safetyEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  safetyFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  safetyId?: InputMaybe<Scalars['Boolean']['input']>;
  safetyLastName?: InputMaybe<Scalars['Boolean']['input']>;
  safetyNotified?: InputMaybe<Scalars['Boolean']['input']>;
  samsaraCameraWorking?: InputMaybe<Scalars['Boolean']['input']>;
  specificLocation?: InputMaybe<Scalars['Boolean']['input']>;
  stationText?: InputMaybe<Scalars['Boolean']['input']>;
  thirdPartyInformation?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  tripFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  tripLoopName?: InputMaybe<Scalars['Boolean']['input']>;
  tripScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  tripServicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  typeOfMedicalAttention?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTrackingId?: InputMaybe<Scalars['Boolean']['input']>;
  wasCeoCalled?: InputMaybe<Scalars['Boolean']['input']>;
  wasCrewInvolved?: InputMaybe<Scalars['Boolean']['input']>;
  wasDriverAtFault?: InputMaybe<Scalars['Boolean']['input']>;
  wasThirdPartyInvolved?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AccidentIssueWithCacheMedicalNeededEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWithCacheMedicalNeededEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWithCacheMedicalNeededEnum>;
};

export enum AccidentIssueWithCacheSafetyNotifiedEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWithCacheSafetyNotifiedEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWithCacheSafetyNotifiedEnum>;
};

export enum AccidentIssueWithCacheSamsaraCameraWorkingEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWithCacheSamsaraCameraWorkingEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWithCacheSamsaraCameraWorkingEnum>;
};

export type AccidentIssueWithCacheSearch = {
  accidentDatetime?: InputMaybe<Array<StringSearch>>;
  additionalDriverScheduled?: InputMaybe<Array<IntSearch>>;
  anyoneInjured?: InputMaybe<Array<AccidentIssueWithCacheAnyoneInjuredEnumSearch>>;
  canVehicleBeDriven?: InputMaybe<Array<AccidentIssueWithCacheCanVehicleBeDrivenEnumSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  damageToOtherVehicles?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  didDriverCallHelp?: InputMaybe<Array<AccidentIssueWithCacheDidDriverCallHelpEnumSearch>>;
  dispatcherContactedManager?: InputMaybe<Array<IntSearch>>;
  dispatcherEmployeeId?: InputMaybe<Array<StringSearch>>;
  dispatcherFirstName?: InputMaybe<Array<StringSearch>>;
  dispatcherId?: InputMaybe<Array<StringSearch>>;
  dispatcherLastName?: InputMaybe<Array<StringSearch>>;
  driverContactedManager?: InputMaybe<Array<IntSearch>>;
  driverEmployeeId?: InputMaybe<Array<StringSearch>>;
  driverFirstName?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  driverLastName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  infoOfCrewMembers?: InputMaybe<Array<StringSearch>>;
  infoOfInjuredParties?: InputMaybe<Array<StringSearch>>;
  medicalNeeded?: InputMaybe<Array<AccidentIssueWithCacheMedicalNeededEnumSearch>>;
  outboundDatetime?: InputMaybe<Array<StringSearch>>;
  outboundFlightName?: InputMaybe<Array<StringSearch>>;
  outboundFlightNumber?: InputMaybe<Array<IntSearch>>;
  safetyEmployeeId?: InputMaybe<Array<StringSearch>>;
  safetyFirstName?: InputMaybe<Array<StringSearch>>;
  safetyId?: InputMaybe<Array<StringSearch>>;
  safetyLastName?: InputMaybe<Array<StringSearch>>;
  safetyNotified?: InputMaybe<Array<AccidentIssueWithCacheSafetyNotifiedEnumSearch>>;
  samsaraCameraWorking?: InputMaybe<Array<AccidentIssueWithCacheSamsaraCameraWorkingEnumSearch>>;
  specificLocation?: InputMaybe<Array<StringSearch>>;
  stationText?: InputMaybe<Array<StringSearch>>;
  thirdPartyInformation?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  tripFlightNumber?: InputMaybe<Array<IntSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  tripLoopName?: InputMaybe<Array<StringSearch>>;
  tripScheduled?: InputMaybe<Array<StringSearch>>;
  tripServicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  typeOfMedicalAttention?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  vehicleTrackingId?: InputMaybe<Array<StringSearch>>;
  wasCeoCalled?: InputMaybe<Array<AccidentIssueWithCacheWasCeoCalledEnumSearch>>;
  wasCrewInvolved?: InputMaybe<Array<AccidentIssueWithCacheWasCrewInvolvedEnumSearch>>;
  wasDriverAtFault?: InputMaybe<Array<AccidentIssueWithCacheWasDriverAtFaultEnumSearch>>;
  wasThirdPartyInvolved?: InputMaybe<Array<AccidentIssueWithCacheWasThirdPartyInvolvedEnumSearch>>;
};

export enum AccidentIssueWithCacheWasCeoCalledEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWithCacheWasCeoCalledEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWithCacheWasCeoCalledEnum>;
};

export enum AccidentIssueWithCacheWasCrewInvolvedEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWithCacheWasCrewInvolvedEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWithCacheWasCrewInvolvedEnum>;
};

export enum AccidentIssueWithCacheWasDriverAtFaultEnum {
  Investigating = 'INVESTIGATING',
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWithCacheWasDriverAtFaultEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWithCacheWasDriverAtFaultEnum>;
};

export enum AccidentIssueWithCacheWasThirdPartyInvolvedEnum {
  No = 'NO',
  Yes = 'YES'
}

export type AccidentIssueWithCacheWasThirdPartyInvolvedEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AccidentIssueWithCacheWasThirdPartyInvolvedEnum>;
};

export type Activity = {
  __typename?: 'Activity';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdAtInLocation?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  formerObject?: Maybe<ActivityObject>;
  formerObjectId?: Maybe<Scalars['String']['output']>;
  formerValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  object?: Maybe<ActivityObject>;
  objectId?: Maybe<Scalars['String']['output']>;
  sourceId?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<ActivitySubject>;
  subjectId: Scalars['String']['output'];
  tripId: Scalars['String']['output'];
  type: ActivityTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedAtInLocation?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
  via?: Maybe<Scalars['String']['output']>;
};

export enum ActivityActionEnum {
  ActCreate = 'ACT_Create',
  ActDelete = 'ACT_Delete',
  ActUpdate = 'ACT_Update'
}

export type ActivityActivityConnection = {
  __typename?: 'ActivityActivityConnection';
  edges?: Maybe<Array<Maybe<ActivityActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ActivityActivityEdge = {
  __typename?: 'ActivityActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ActivityConnection = {
  __typename?: 'ActivityConnection';
  edges?: Maybe<Array<Maybe<ActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ActivityMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Array<ActivitySearch>>;
};

export type ActivityDisplayMessage = {
  __typename?: 'ActivityDisplayMessage';
  activityLogId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  displayMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ActivityDisplayMessageActivityConnection = {
  __typename?: 'ActivityDisplayMessageActivityConnection';
  edges?: Maybe<Array<Maybe<ActivityDisplayMessageActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityDisplayMessageActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ActivityDisplayMessageActivityEdge = {
  __typename?: 'ActivityDisplayMessageActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ActivityDisplayMessageConnection = {
  __typename?: 'ActivityDisplayMessageConnection';
  edges?: Maybe<Array<Maybe<ActivityDisplayMessageEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityDisplayMessageConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ActivityDisplayMessageMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityDisplayMessageSearch>>;
};

export type ActivityDisplayMessageEdge = {
  __typename?: 'ActivityDisplayMessageEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityDisplayMessage>;
};

export type ActivityDisplayMessageMaskInput = {
  activityLogId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayMessage?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityDisplayMessageSearch = {
  activityLogId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  displayMessage?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type ActivityEdge = {
  __typename?: 'ActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Activity>;
};

export type ActivityLog = {
  __typename?: 'ActivityLog';
  action: Scalars['String']['output'];
  children?: Maybe<Array<ActivityLogPayloadChild>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByAvatar?: Maybe<Scalars['String']['output']>;
  createdByEmployeeId?: Maybe<Scalars['String']['output']>;
  createdByFirstName: Scalars['String']['output'];
  createdByLastName: Scalars['String']['output'];
  createdByPrimaryAirportCode?: Maybe<Scalars['String']['output']>;
  createdByRoleId: Scalars['String']['output'];
  displayMessage?: Maybe<Scalars['String']['output']>;
  eventTraceId: Scalars['String']['output'];
  field?: Maybe<Scalars['String']['output']>;
  formerValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  namespace: Scalars['String']['output'];
  parentNamespace?: Maybe<Scalars['String']['output']>;
  parentResource?: Maybe<Scalars['String']['output']>;
  parentResourceId?: Maybe<Scalars['String']['output']>;
  payloadCurrent?: Maybe<Scalars['String']['output']>;
  payloadId?: Maybe<Scalars['String']['output']>;
  payloadPrevious?: Maybe<Scalars['String']['output']>;
  platformName: ActivityLogPlatformNameEnum;
  resource: Scalars['String']['output'];
  resourceId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogActivityConnection = {
  __typename?: 'ActivityLogActivityConnection';
  edges?: Maybe<Array<Maybe<ActivityLogActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityLogActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ActivityLogActivityEdge = {
  __typename?: 'ActivityLogActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ActivityLogConnection = {
  __typename?: 'ActivityLogConnection';
  edges?: Maybe<Array<Maybe<ActivityLogEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityLogConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ActivityLogMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ActivityLogEdge = {
  __typename?: 'ActivityLogEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ActivityLogMaskInput = {
  action?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  eventTraceId?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<Scalars['Boolean']['input']>;
  formerValue?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['Boolean']['input']>;
  namespace?: InputMaybe<Scalars['Boolean']['input']>;
  parentNamespace?: InputMaybe<Scalars['Boolean']['input']>;
  parentResource?: InputMaybe<Scalars['Boolean']['input']>;
  parentResourceId?: InputMaybe<Scalars['Boolean']['input']>;
  payloadId?: InputMaybe<Scalars['Boolean']['input']>;
  platformName?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['Boolean']['input']>;
  resourceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityLogPayload = {
  __typename?: 'ActivityLogPayload';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  current?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  previous?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogPayloadActivityConnection = {
  __typename?: 'ActivityLogPayloadActivityConnection';
  edges?: Maybe<Array<Maybe<ActivityLogPayloadActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityLogPayloadActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ActivityLogPayloadActivityEdge = {
  __typename?: 'ActivityLogPayloadActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ActivityLogPayloadChild = {
  __typename?: 'ActivityLogPayloadChild';
  activityLogPayloadId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  data: Scalars['String']['output'];
  field: Scalars['String']['output'];
  id: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  resourceDisplayName?: Maybe<Scalars['String']['output']>;
  resourceId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogPayloadChildActivityConnection = {
  __typename?: 'ActivityLogPayloadChildActivityConnection';
  edges?: Maybe<Array<Maybe<ActivityLogPayloadChildActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityLogPayloadChildActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ActivityLogPayloadChildActivityEdge = {
  __typename?: 'ActivityLogPayloadChildActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ActivityLogPayloadChildConnection = {
  __typename?: 'ActivityLogPayloadChildConnection';
  edges?: Maybe<Array<Maybe<ActivityLogPayloadChildEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityLogPayloadChildConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ActivityLogPayloadChildMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogPayloadChildSearch>>;
};

export type ActivityLogPayloadChildEdge = {
  __typename?: 'ActivityLogPayloadChildEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLogPayloadChild>;
};

export type ActivityLogPayloadChildMaskInput = {
  activityLogPayloadId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  namespace?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['Boolean']['input']>;
  resourceDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  resourceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityLogPayloadChildSearch = {
  activityLogPayloadId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  data?: InputMaybe<Array<StringSearch>>;
  field?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  namespace?: InputMaybe<Array<StringSearch>>;
  resource?: InputMaybe<Array<StringSearch>>;
  resourceDisplayName?: InputMaybe<Array<StringSearch>>;
  resourceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type ActivityLogPayloadConnection = {
  __typename?: 'ActivityLogPayloadConnection';
  edges?: Maybe<Array<Maybe<ActivityLogPayloadEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityLogPayloadConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ActivityLogPayloadMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogPayloadSearch>>;
};

export type ActivityLogPayloadEdge = {
  __typename?: 'ActivityLogPayloadEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLogPayload>;
};

export type ActivityLogPayloadMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  current?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  previous?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityLogPayloadSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  current?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  previous?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum ActivityLogPlatformNameEnum {
  Crew = 'CREW',
  Driver = 'DRIVER',
  Portal = 'PORTAL',
  System = 'SYSTEM'
}

export type ActivityLogPlatformNameEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ActivityLogPlatformNameEnum>;
};

export type ActivityLogSearch = {
  action?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  eventTraceId?: InputMaybe<Array<StringSearch>>;
  field?: InputMaybe<Array<StringSearch>>;
  formerValue?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  message?: InputMaybe<Array<StringSearch>>;
  namespace?: InputMaybe<Array<StringSearch>>;
  parentNamespace?: InputMaybe<Array<StringSearch>>;
  parentResource?: InputMaybe<Array<StringSearch>>;
  parentResourceId?: InputMaybe<Array<StringSearch>>;
  payloadId?: InputMaybe<Array<StringSearch>>;
  platformName?: InputMaybe<Array<ActivityLogPlatformNameEnumSearch>>;
  resource?: InputMaybe<Array<StringSearch>>;
  resourceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  value?: InputMaybe<Array<StringSearch>>;
};

export type ActivityLogWithCache = {
  __typename?: 'ActivityLogWithCache';
  action: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByAvatar?: Maybe<Scalars['String']['output']>;
  createdByEmployeeId?: Maybe<Scalars['String']['output']>;
  createdByFirstName: Scalars['String']['output'];
  createdByLastName: Scalars['String']['output'];
  createdByPrimaryAirportCode?: Maybe<Scalars['String']['output']>;
  createdByRoleId: Scalars['String']['output'];
  displayMessage?: Maybe<Scalars['String']['output']>;
  eventTraceId: Scalars['String']['output'];
  field?: Maybe<Scalars['String']['output']>;
  formerValue?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  namespace: Scalars['String']['output'];
  parentNamespace?: Maybe<Scalars['String']['output']>;
  parentResource?: Maybe<Scalars['String']['output']>;
  parentResourceId?: Maybe<Scalars['String']['output']>;
  payloadCurrent?: Maybe<Scalars['String']['output']>;
  payloadId?: Maybe<Scalars['String']['output']>;
  payloadPrevious?: Maybe<Scalars['String']['output']>;
  platformName: ActivityLogWithCachePlatformNameEnum;
  resource: Scalars['String']['output'];
  resourceId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type ActivityLogWithCacheActivityConnection = {
  __typename?: 'ActivityLogWithCacheActivityConnection';
  edges?: Maybe<Array<Maybe<ActivityLogWithCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityLogWithCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ActivityLogWithCacheActivityEdge = {
  __typename?: 'ActivityLogWithCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ActivityLogWithCacheConnection = {
  __typename?: 'ActivityLogWithCacheConnection';
  edges?: Maybe<Array<Maybe<ActivityLogWithCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityLogWithCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ActivityLogWithCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogWithCacheSearch>>;
};

export type ActivityLogWithCacheEdge = {
  __typename?: 'ActivityLogWithCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLogWithCache>;
};

export type ActivityLogWithCacheMaskInput = {
  action?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  createdByAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  createdByEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  createdByFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  createdByLastName?: InputMaybe<Scalars['Boolean']['input']>;
  createdByPrimaryAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdByRoleId?: InputMaybe<Scalars['Boolean']['input']>;
  displayMessage?: InputMaybe<Scalars['Boolean']['input']>;
  eventTraceId?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<Scalars['Boolean']['input']>;
  formerValue?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['Boolean']['input']>;
  namespace?: InputMaybe<Scalars['Boolean']['input']>;
  parentNamespace?: InputMaybe<Scalars['Boolean']['input']>;
  parentResource?: InputMaybe<Scalars['Boolean']['input']>;
  parentResourceId?: InputMaybe<Scalars['Boolean']['input']>;
  payloadCurrent?: InputMaybe<Scalars['Boolean']['input']>;
  payloadId?: InputMaybe<Scalars['Boolean']['input']>;
  payloadPrevious?: InputMaybe<Scalars['Boolean']['input']>;
  platformName?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['Boolean']['input']>;
  resourceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ActivityLogWithCachePlatformNameEnum {
  Crew = 'CREW',
  Driver = 'DRIVER',
  Portal = 'PORTAL',
  System = 'SYSTEM'
}

export type ActivityLogWithCachePlatformNameEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ActivityLogWithCachePlatformNameEnum>;
};

export type ActivityLogWithCacheSearch = {
  action?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  createdByAvatar?: InputMaybe<Array<StringSearch>>;
  createdByEmployeeId?: InputMaybe<Array<StringSearch>>;
  createdByFirstName?: InputMaybe<Array<StringSearch>>;
  createdByLastName?: InputMaybe<Array<StringSearch>>;
  createdByPrimaryAirportCode?: InputMaybe<Array<StringSearch>>;
  createdByRoleId?: InputMaybe<Array<StringSearch>>;
  displayMessage?: InputMaybe<Array<StringSearch>>;
  eventTraceId?: InputMaybe<Array<StringSearch>>;
  field?: InputMaybe<Array<StringSearch>>;
  formerValue?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  message?: InputMaybe<Array<StringSearch>>;
  namespace?: InputMaybe<Array<StringSearch>>;
  parentNamespace?: InputMaybe<Array<StringSearch>>;
  parentResource?: InputMaybe<Array<StringSearch>>;
  parentResourceId?: InputMaybe<Array<StringSearch>>;
  payloadCurrent?: InputMaybe<Array<StringSearch>>;
  payloadId?: InputMaybe<Array<StringSearch>>;
  payloadPrevious?: InputMaybe<Array<StringSearch>>;
  platformName?: InputMaybe<Array<ActivityLogWithCachePlatformNameEnumSearch>>;
  resource?: InputMaybe<Array<StringSearch>>;
  resourceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  value?: InputMaybe<Array<StringSearch>>;
};

export type ActivityMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  field?: InputMaybe<Scalars['Boolean']['input']>;
  formerObjectId?: InputMaybe<Scalars['Boolean']['input']>;
  formerValue?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['Boolean']['input']>;
  objectId?: InputMaybe<Scalars['Boolean']['input']>;
  sourceId?: InputMaybe<Scalars['Boolean']['input']>;
  subjectId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
  via?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ActivityNamespaceEnum {
  NsActivity = 'NS_Activity',
  NsAirport = 'NS_Airport',
  NsAssets = 'NS_Assets',
  NsAutomation = 'NS_Automation',
  NsChat = 'NS_Chat',
  NsContract = 'NS_Contract',
  NsDrivetimereport = 'NS_Drivetimereport',
  NsEvent = 'NS_Event',
  NsFlight = 'NS_Flight',
  NsInvoice = 'NS_Invoice',
  NsLocation = 'NS_Location',
  NsManifest = 'NS_Manifest',
  NsPdfgenerator = 'NS_Pdfgenerator',
  NsPunch = 'NS_Punch',
  NsReport = 'NS_Report',
  NsTraining = 'NS_Training',
  NsTrip = 'NS_Trip',
  NsUser = 'NS_User'
}

export type ActivityObject = {
  __typename?: 'ActivityObject';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type ActivityObjectActivityConnection = {
  __typename?: 'ActivityObjectActivityConnection';
  edges?: Maybe<Array<Maybe<ActivityObjectActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityObjectActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ActivityObjectActivityEdge = {
  __typename?: 'ActivityObjectActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ActivityObjectConnection = {
  __typename?: 'ActivityObjectConnection';
  edges?: Maybe<Array<Maybe<ActivityObjectEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityObjectConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ActivityObjectMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityObjectSearch>>;
};

export type ActivityObjectEdge = {
  __typename?: 'ActivityObjectEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityObject>;
};

export type ActivityObjectMaskInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityObjectSearch = {
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<StringSearch>>;
  url?: InputMaybe<Array<StringSearch>>;
};

export enum ActivityResourceTypeEnum {
  RsAssetsDriverVehicleAssignment = 'RS_Assets_DriverVehicleAssignment',
  RsAssetsDvir = 'RS_Assets_Dvir',
  RsChatMessage = 'RS_Chat_Message',
  RsContractAutoCombineRule = 'RS_Contract_AutoCombineRule',
  RsContractBufferTime = 'RS_Contract_BufferTime',
  RsContractCancellationRule = 'RS_Contract_CancellationRule',
  RsContractCombineRule = 'RS_Contract_CombineRule',
  RsContractCombineRuleHistory = 'RS_Contract_CombineRuleHistory',
  RsContractCompany = 'RS_Contract_Company',
  RsContractContract = 'RS_Contract_Contract',
  RsContractContractEmail = 'RS_Contract_ContractEmail',
  RsContractContractNumber = 'RS_Contract_ContractNumber',
  RsContractEmail = 'RS_Contract_Email',
  RsContractEquivalentTrip = 'RS_Contract_EquivalentTrip',
  RsContractInvoiceTerm = 'RS_Contract_InvoiceTerm',
  RsContractMessage = 'RS_Contract_Message',
  RsContractProvider = 'RS_Contract_Provider',
  RsContractProviderAlias = 'RS_Contract_ProviderAlias',
  RsContractProviderLocationMapping = 'RS_Contract_ProviderLocationMapping',
  RsContractSettings = 'RS_Contract_Settings',
  RsContractSocialDistanceRule = 'RS_Contract_SocialDistanceRule',
  RsContractUpdateStrategy = 'RS_Contract_UpdateStrategy',
  RsContractVariableTime = 'RS_Contract_VariableTime',
  RsDrivetimereportManifestHistoryRoute = 'RS_Drivetimereport_ManifestHistoryRoute',
  RsDrivetimereportQueryHistory = 'RS_Drivetimereport_QueryHistory',
  RsInvoiceInvoice = 'RS_Invoice_Invoice',
  RsInvoiceInvoiceClient = 'RS_Invoice_InvoiceClient',
  RsInvoiceInvoiceDocument = 'RS_Invoice_InvoiceDocument',
  RsInvoiceInvoiceDocumentSummary = 'RS_Invoice_InvoiceDocumentSummary',
  RsInvoiceInvoiceTotalSummary = 'RS_Invoice_InvoiceTotalSummary',
  RsLocationLocation = 'RS_Location_Location',
  RsPdfgeneratorGeneratedDocument = 'RS_Pdfgenerator_GeneratedDocument',
  RsTripAccidentIssue = 'RS_Trip_AccidentIssue',
  RsTripCheckinEvent = 'RS_Trip_CheckinEvent',
  RsTripCommunication = 'RS_Trip_Communication',
  RsTripCompletion = 'RS_Trip_Completion',
  RsTripDispatchIssue = 'RS_Trip_DispatchIssue',
  RsTripDispatchSummary = 'RS_Trip_DispatchSummary',
  RsTripFcr = 'RS_Trip_Fcr',
  RsTripIncidentIssue = 'RS_Trip_IncidentIssue',
  RsTripLostAndFoundIssue = 'RS_Trip_LostAndFoundIssue',
  RsTripTrackFlight = 'RS_Trip_TrackFlight',
  RsTripTrip = 'RS_Trip_Trip',
  RsTripTripDocument = 'RS_Trip_TripDocument',
  RsTripTripScheduleTrigger = 'RS_Trip_TripScheduleTrigger',
  RsTripVehicle = 'RS_Trip_Vehicle',
  RsUserCharity = 'RS_User_Charity',
  RsUserCharityAmountHistory = 'RS_User_CharityAmountHistory',
  RsUserPendingLoginEvent = 'RS_User_PendingLoginEvent',
  RsUserRating = 'RS_User_Rating',
  RsUserRatingRemark = 'RS_User_RatingRemark',
  RsUserUser = 'RS_User_User',
  RsUserUserAvailability = 'RS_User_UserAvailability'
}

export type ActivityResourceTypeFilterInput = {
  namespace?: InputMaybe<Array<ActivityNamespaceEnum>>;
};

export type ActivitySearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  field?: InputMaybe<Array<StringSearch>>;
  formerObjectId?: InputMaybe<Array<StringSearch>>;
  formerValue?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  message?: InputMaybe<Array<StringSearch>>;
  objectId?: InputMaybe<Array<StringSearch>>;
  sourceId?: InputMaybe<Array<StringSearch>>;
  subjectId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<ActivityTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  value?: InputMaybe<Array<StringSearch>>;
  via?: InputMaybe<Array<StringSearch>>;
};

export type ActivitySubject = {
  __typename?: 'ActivitySubject';
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
};

export enum ActivityTypeEnum {
  Client = 'CLIENT',
  Combine = 'COMBINE',
  Completion = 'COMPLETION',
  Import = 'IMPORT',
  Location = 'LOCATION',
  Rate = 'RATE',
  TrackFlight = 'TRACK_FLIGHT',
  Trip = 'TRIP',
  User = 'USER',
  Vehicle = 'VEHICLE'
}

export type ActivityTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ActivityTypeEnum>;
};

export type ActivityUserCache = {
  __typename?: 'ActivityUserCache';
  avatar?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  primaryAirportCode?: Maybe<Scalars['String']['output']>;
  roleId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type ActivityUserCacheActivityConnection = {
  __typename?: 'ActivityUserCacheActivityConnection';
  edges?: Maybe<Array<Maybe<ActivityUserCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityUserCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ActivityUserCacheActivityEdge = {
  __typename?: 'ActivityUserCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ActivityUserCacheConnection = {
  __typename?: 'ActivityUserCacheConnection';
  edges?: Maybe<Array<Maybe<ActivityUserCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ActivityUserCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ActivityUserCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityUserCacheSearch>>;
};

export type ActivityUserCacheEdge = {
  __typename?: 'ActivityUserCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityUserCache>;
};

export type ActivityUserCacheMaskInput = {
  avatar?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ActivityUserCacheSearch = {
  avatar?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  employeeId?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  primaryAirportCode?: InputMaybe<Array<StringSearch>>;
  roleId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type AddLocationAliasesInput = {
  locations: Array<AliasInput>;
};

export type AddLocationAliasesResponse = {
  __typename?: 'AddLocationAliasesResponse';
  airportCodes?: Maybe<Array<AirportHasLocation>>;
  aliases?: Maybe<Array<Maybe<Alias>>>;
};

export enum AirlineTripsTableColumnsEnum {
  Activity = 'ACTIVITY',
  Actual = 'ACTUAL',
  AirportCode = 'AIRPORT_CODE',
  Attendant = 'ATTENDANT',
  Client = 'CLIENT',
  Combine = 'COMBINE',
  Completion = 'COMPLETION',
  DoLocation = 'DO_LOCATION',
  Driver = 'DRIVER',
  Eta = 'ETA',
  Fcr = 'FCR',
  Flags = 'FLAGS',
  FlightNumber = 'FLIGHT_NUMBER',
  IataCode = 'IATA_CODE',
  Pilot = 'PILOT',
  PuLocation = 'PU_LOCATION',
  Rate = 'RATE',
  ScheduledDate = 'SCHEDULED_DATE',
  ScheduledTime = 'SCHEDULED_TIME',
  Type = 'TYPE',
  Vehicle = 'VEHICLE'
}

export type Airport = {
  __typename?: 'Airport';
  cityCode: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  elevation: Scalars['Int']['output'];
  icao: Scalars['String']['output'];
  location: Point;
  name: Scalars['String']['output'];
  stateCode: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AirportActivityConnection = {
  __typename?: 'AirportActivityConnection';
  edges?: Maybe<Array<Maybe<AirportActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AirportActivityEdge = {
  __typename?: 'AirportActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AirportConnection = {
  __typename?: 'AirportConnection';
  edges?: Maybe<Array<Maybe<AirportEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AirportMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AirportSearch>>;
};

export type AirportEdge = {
  __typename?: 'AirportEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Airport>;
};

export type AirportGroup = {
  __typename?: 'AirportGroup';
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AirportGroupActivityConnection = {
  __typename?: 'AirportGroupActivityConnection';
  edges?: Maybe<Array<Maybe<AirportGroupActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportGroupActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AirportGroupActivityEdge = {
  __typename?: 'AirportGroupActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AirportGroupConnection = {
  __typename?: 'AirportGroupConnection';
  edges?: Maybe<Array<Maybe<AirportGroupEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportGroupConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AirportGroupMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AirportGroupSearch>>;
};

export type AirportGroupEdge = {
  __typename?: 'AirportGroupEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AirportGroup>;
};

export type AirportGroupMaskInput = {
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AirportGroupSearch = {
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type AirportHasCompany = {
  __typename?: 'AirportHasCompany';
  airportCode: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
};

export type AirportHasCompanyActivityConnection = {
  __typename?: 'AirportHasCompanyActivityConnection';
  edges?: Maybe<Array<Maybe<AirportHasCompanyActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportHasCompanyActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AirportHasCompanyActivityEdge = {
  __typename?: 'AirportHasCompanyActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AirportHasCompanyConnection = {
  __typename?: 'AirportHasCompanyConnection';
  edges?: Maybe<Array<Maybe<AirportHasCompanyEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportHasCompanyConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AirportHasCompanyMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AirportHasCompanySearch>>;
};

export type AirportHasCompanyEdge = {
  __typename?: 'AirportHasCompanyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AirportHasCompany>;
};

export type AirportHasCompanyMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AirportHasCompanySearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
};

export type AirportHasGroup = {
  __typename?: 'AirportHasGroup';
  airportCode: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
};

export type AirportHasGroupActivityConnection = {
  __typename?: 'AirportHasGroupActivityConnection';
  edges?: Maybe<Array<Maybe<AirportHasGroupActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportHasGroupActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AirportHasGroupActivityEdge = {
  __typename?: 'AirportHasGroupActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AirportHasGroupConnection = {
  __typename?: 'AirportHasGroupConnection';
  edges?: Maybe<Array<Maybe<AirportHasGroupEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportHasGroupConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AirportHasGroupMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AirportHasGroupSearch>>;
};

export type AirportHasGroupEdge = {
  __typename?: 'AirportHasGroupEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AirportHasGroup>;
};

export type AirportHasGroupMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AirportHasGroupSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  groupId?: InputMaybe<Array<StringSearch>>;
};

export type AirportHasLocation = {
  __typename?: 'AirportHasLocation';
  airportCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AirportHasLocationActivityConnection = {
  __typename?: 'AirportHasLocationActivityConnection';
  edges?: Maybe<Array<Maybe<AirportHasLocationActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportHasLocationActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AirportHasLocationActivityEdge = {
  __typename?: 'AirportHasLocationActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AirportHasLocationConnection = {
  __typename?: 'AirportHasLocationConnection';
  edges?: Maybe<Array<Maybe<AirportHasLocationEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportHasLocationConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AirportHasLocationMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AirportHasLocationSearch>>;
};

export type AirportHasLocationEdge = {
  __typename?: 'AirportHasLocationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AirportHasLocation>;
};

export type AirportHasLocationMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AirportHasLocationSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  locationId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type AirportHasManagerEmail = {
  __typename?: 'AirportHasManagerEmail';
  airportCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  emailAddress: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AirportHasManagerEmailActivityConnection = {
  __typename?: 'AirportHasManagerEmailActivityConnection';
  edges?: Maybe<Array<Maybe<AirportHasManagerEmailActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportHasManagerEmailActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AirportHasManagerEmailActivityEdge = {
  __typename?: 'AirportHasManagerEmailActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AirportHasManagerEmailConnection = {
  __typename?: 'AirportHasManagerEmailConnection';
  edges?: Maybe<Array<Maybe<AirportHasManagerEmailEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportHasManagerEmailConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AirportHasManagerEmailMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AirportHasManagerEmailSearch>>;
};

export type AirportHasManagerEmailEdge = {
  __typename?: 'AirportHasManagerEmailEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AirportHasManagerEmail>;
};

export type AirportHasManagerEmailMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  emailAddress?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AirportHasManagerEmailSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  emailAddress?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type AirportHasRate = {
  __typename?: 'AirportHasRate';
  airportCode: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
};

export type AirportHasRateActivityConnection = {
  __typename?: 'AirportHasRateActivityConnection';
  edges?: Maybe<Array<Maybe<AirportHasRateActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportHasRateActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AirportHasRateActivityEdge = {
  __typename?: 'AirportHasRateActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AirportHasRateConnection = {
  __typename?: 'AirportHasRateConnection';
  edges?: Maybe<Array<Maybe<AirportHasRateEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportHasRateConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AirportHasRateMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AirportHasRateSearch>>;
};

export type AirportHasRateEdge = {
  __typename?: 'AirportHasRateEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AirportHasRate>;
};

export type AirportHasRateMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AirportHasRateSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  rate?: InputMaybe<Array<FloatSearch>>;
};

export type AirportHasUser = {
  __typename?: 'AirportHasUser';
  airportCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  permissionId?: Maybe<Scalars['String']['output']>;
};

export type AirportHasVehicle = {
  __typename?: 'AirportHasVehicle';
  airportCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<Vehicle>;
  vehicleId: Scalars['String']['output'];
};

export type AirportHasVehicleActivityConnection = {
  __typename?: 'AirportHasVehicleActivityConnection';
  edges?: Maybe<Array<Maybe<AirportHasVehicleActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportHasVehicleActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AirportHasVehicleActivityEdge = {
  __typename?: 'AirportHasVehicleActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AirportHasVehicleConnection = {
  __typename?: 'AirportHasVehicleConnection';
  edges?: Maybe<Array<Maybe<AirportHasVehicleEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportHasVehicleConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AirportHasVehicleMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AirportHasVehicleSearch>>;
};

export type AirportHasVehicleEdge = {
  __typename?: 'AirportHasVehicleEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AirportHasVehicle>;
};

export type AirportHasVehicleMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AirportHasVehicleSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
};

export type AirportMaskInput = {
  cityCode?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['Boolean']['input']>;
  countryId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  elevation?: InputMaybe<Scalars['Boolean']['input']>;
  icao?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AirportSearch = {
  cityCode?: InputMaybe<Array<StringSearch>>;
  cityName?: InputMaybe<Array<StringSearch>>;
  code?: InputMaybe<Array<StringSearch>>;
  country?: InputMaybe<Array<StringSearch>>;
  countryId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  elevation?: InputMaybe<Array<IntSearch>>;
  icao?: InputMaybe<Array<StringSearch>>;
  location?: InputMaybe<Array<PointSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  timezone?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  url?: InputMaybe<Array<StringSearch>>;
};

export type AirportWithCompany = {
  __typename?: 'AirportWithCompany';
  cityCode: Scalars['String']['output'];
  cityName: Scalars['String']['output'];
  code: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  elevation: Scalars['Int']['output'];
  icao: Scalars['String']['output'];
  location: Point;
  name: Scalars['String']['output'];
  stateCode: Scalars['String']['output'];
  timezone: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  url: Scalars['String']['output'];
};

export type AirportWithCompanyActivityConnection = {
  __typename?: 'AirportWithCompanyActivityConnection';
  edges?: Maybe<Array<Maybe<AirportWithCompanyActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportWithCompanyActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AirportWithCompanyActivityEdge = {
  __typename?: 'AirportWithCompanyActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AirportWithCompanyConnection = {
  __typename?: 'AirportWithCompanyConnection';
  edges?: Maybe<Array<Maybe<AirportWithCompanyEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportWithCompanyConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AirportWithCompanyMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AirportWithCompanySearch>>;
};

export type AirportWithCompanyEdge = {
  __typename?: 'AirportWithCompanyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AirportWithCompany>;
};

export type AirportWithCompanyMaskInput = {
  cityCode?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['Boolean']['input']>;
  countryId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  elevation?: InputMaybe<Scalars['Boolean']['input']>;
  icao?: InputMaybe<Scalars['Boolean']['input']>;
  location?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  url?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AirportWithCompanySearch = {
  cityCode?: InputMaybe<Array<StringSearch>>;
  cityName?: InputMaybe<Array<StringSearch>>;
  code?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  country?: InputMaybe<Array<StringSearch>>;
  countryId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  elevation?: InputMaybe<Array<IntSearch>>;
  icao?: InputMaybe<Array<StringSearch>>;
  location?: InputMaybe<Array<PointSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  timezone?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  url?: InputMaybe<Array<StringSearch>>;
};

export type AirportWithGroup = {
  __typename?: 'AirportWithGroup';
  airportCode: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AirportWithGroupActivityConnection = {
  __typename?: 'AirportWithGroupActivityConnection';
  edges?: Maybe<Array<Maybe<AirportWithGroupActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportWithGroupActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AirportWithGroupActivityEdge = {
  __typename?: 'AirportWithGroupActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AirportWithGroupConnection = {
  __typename?: 'AirportWithGroupConnection';
  edges?: Maybe<Array<Maybe<AirportWithGroupEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportWithGroupConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AirportWithGroupMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AirportWithGroupSearch>>;
};

export type AirportWithGroupEdge = {
  __typename?: 'AirportWithGroupEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AirportWithGroup>;
};

export type AirportWithGroupMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AirportWithGroupSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  groupId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type AirportWithLocation = {
  __typename?: 'AirportWithLocation';
  active: Scalars['Int']['output'];
  address: Scalars['String']['output'];
  airportCode: Scalars['String']['output'];
  cityName?: Maybe<Scalars['String']['output']>;
  coordinates: Point;
  countryCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legacyId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primaryAirportCode?: Maybe<Scalars['String']['output']>;
  radius: Scalars['Int']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  type: AirportWithLocationTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AirportWithLocationActivityConnection = {
  __typename?: 'AirportWithLocationActivityConnection';
  edges?: Maybe<Array<Maybe<AirportWithLocationActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportWithLocationActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AirportWithLocationActivityEdge = {
  __typename?: 'AirportWithLocationActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AirportWithLocationConnection = {
  __typename?: 'AirportWithLocationConnection';
  edges?: Maybe<Array<Maybe<AirportWithLocationEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportWithLocationConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AirportWithLocationMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AirportWithLocationSearch>>;
};

export type AirportWithLocationEdge = {
  __typename?: 'AirportWithLocationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AirportWithLocation>;
};

export type AirportWithLocationMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  radius?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AirportWithLocationSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  address?: InputMaybe<Array<StringSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  cityName?: InputMaybe<Array<StringSearch>>;
  coordinates?: InputMaybe<Array<PointSearch>>;
  countryCode?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  legacyId?: InputMaybe<Array<IntSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  phoneNumber?: InputMaybe<Array<StringSearch>>;
  primaryAirportCode?: InputMaybe<Array<StringSearch>>;
  radius?: InputMaybe<Array<IntSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<AirportWithLocationTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  zipCode?: InputMaybe<Array<StringSearch>>;
};

export enum AirportWithLocationTypeEnum {
  Airport = 'AIRPORT',
  Exchange = 'EXCHANGE',
  Hotel = 'HOTEL'
}

export type AirportWithLocationTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AirportWithLocationTypeEnum>;
};

export type AirportWithVehicle = {
  __typename?: 'AirportWithVehicle';
  active: Scalars['Int']['output'];
  airportCode: Scalars['String']['output'];
  airportPermitExpirationDate?: Maybe<Scalars['String']['output']>;
  capacity: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  emissionPermitExpirationDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  locationId: Scalars['String']['output'];
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  registrationExpirationDate?: Maybe<Scalars['String']['output']>;
  stateRegistered?: Maybe<Scalars['String']['output']>;
  tollTag?: Maybe<Scalars['String']['output']>;
  tracker: AirportWithVehicleTrackerEnum;
  trackingId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vin: Scalars['String']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type AirportWithVehicleActivityConnection = {
  __typename?: 'AirportWithVehicleActivityConnection';
  edges?: Maybe<Array<Maybe<AirportWithVehicleActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportWithVehicleActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AirportWithVehicleActivityEdge = {
  __typename?: 'AirportWithVehicleActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AirportWithVehicleConnection = {
  __typename?: 'AirportWithVehicleConnection';
  edges?: Maybe<Array<Maybe<AirportWithVehicleEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AirportWithVehicleConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AirportWithVehicleMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AirportWithVehicleSearch>>;
};

export type AirportWithVehicleEdge = {
  __typename?: 'AirportWithVehicleEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AirportWithVehicle>;
};

export type AirportWithVehicleMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  airportPermitExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  emissionPermitExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  licensePlate?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Boolean']['input']>;
  make?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  registrationExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  stateRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  tollTag?: InputMaybe<Scalars['Boolean']['input']>;
  tracker?: InputMaybe<Scalars['Boolean']['input']>;
  trackingId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vin?: InputMaybe<Scalars['Boolean']['input']>;
  year?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AirportWithVehicleSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  airportPermitExpirationDate?: InputMaybe<Array<StringSearch>>;
  capacity?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  emissionPermitExpirationDate?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  licensePlate?: InputMaybe<Array<StringSearch>>;
  locationId?: InputMaybe<Array<StringSearch>>;
  make?: InputMaybe<Array<StringSearch>>;
  model?: InputMaybe<Array<StringSearch>>;
  phoneNumber?: InputMaybe<Array<StringSearch>>;
  registrationExpirationDate?: InputMaybe<Array<StringSearch>>;
  stateRegistered?: InputMaybe<Array<StringSearch>>;
  tollTag?: InputMaybe<Array<StringSearch>>;
  tracker?: InputMaybe<Array<AirportWithVehicleTrackerEnumSearch>>;
  trackingId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vin?: InputMaybe<Array<StringSearch>>;
  year?: InputMaybe<Array<IntSearch>>;
};

export enum AirportWithVehicleTrackerEnum {
  PhoneGps = 'PHONE_GPS',
  VanTracking = 'VAN_TRACKING'
}

export type AirportWithVehicleTrackerEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AirportWithVehicleTrackerEnum>;
};

export type AlertSubscription = {
  __typename?: 'AlertSubscription';
  airportCode: Scalars['String']['output'];
  arrivalDate: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  externalAlertId: Scalars['String']['output'];
  externalVendor: AlertSubscriptionExternalVendorEnum;
  flightNumber: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  raw: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AlertSubscriptionActivityConnection = {
  __typename?: 'AlertSubscriptionActivityConnection';
  edges?: Maybe<Array<Maybe<AlertSubscriptionActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AlertSubscriptionActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AlertSubscriptionActivityEdge = {
  __typename?: 'AlertSubscriptionActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AlertSubscriptionConnection = {
  __typename?: 'AlertSubscriptionConnection';
  edges?: Maybe<Array<Maybe<AlertSubscriptionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AlertSubscriptionConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AlertSubscriptionMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AlertSubscriptionSearch>>;
};

export type AlertSubscriptionEdge = {
  __typename?: 'AlertSubscriptionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AlertSubscription>;
};

export enum AlertSubscriptionExternalVendorEnum {
  FlightAware = 'FLIGHT_AWARE',
  FlightStats = 'FLIGHT_STATS'
}

export type AlertSubscriptionExternalVendorEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AlertSubscriptionExternalVendorEnum>;
};

export type AlertSubscriptionMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalDate?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  externalAlertId?: InputMaybe<Scalars['Boolean']['input']>;
  externalVendor?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  raw?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AlertSubscriptionSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  arrivalDate?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  externalAlertId?: InputMaybe<Array<StringSearch>>;
  externalVendor?: InputMaybe<Array<AlertSubscriptionExternalVendorEnumSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  raw?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type Alias = {
  __typename?: 'Alias';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AliasActivityConnection = {
  __typename?: 'AliasActivityConnection';
  edges?: Maybe<Array<Maybe<AliasActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AliasActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AliasActivityEdge = {
  __typename?: 'AliasActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AliasConnection = {
  __typename?: 'AliasConnection';
  edges?: Maybe<Array<Maybe<AliasEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AliasConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AliasMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AliasSearch>>;
};

export type AliasEdge = {
  __typename?: 'AliasEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Alias>;
};

export type AliasInput = {
  airportCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  aliases: Array<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
};

export type AliasMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AliasSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  locationId?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type ApiKey = {
  __typename?: 'ApiKey';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  expiresAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  keyHash: Scalars['String']['output'];
  keyHint?: Maybe<Scalars['String']['output']>;
  lastUsedAt?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type ApiKeyActivityConnection = {
  __typename?: 'ApiKeyActivityConnection';
  edges?: Maybe<Array<Maybe<ApiKeyActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ApiKeyActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ApiKeyActivityEdge = {
  __typename?: 'ApiKeyActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ApiKeyConnection = {
  __typename?: 'ApiKeyConnection';
  edges?: Maybe<Array<Maybe<ApiKeyEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ApiKeyConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ApiKeyMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ApiKeySearch>>;
};

export type ApiKeyEdge = {
  __typename?: 'ApiKeyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ApiKey>;
};

export type ApiKeyMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  expiresAt?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  keyHash?: InputMaybe<Scalars['Boolean']['input']>;
  keyHint?: InputMaybe<Scalars['Boolean']['input']>;
  lastUsedAt?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ApiKeySearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  expiresAt?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  keyHash?: InputMaybe<Array<StringSearch>>;
  keyHint?: InputMaybe<Array<StringSearch>>;
  lastUsedAt?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type ApproveUserAvailabilityDriverAppInput = {
  approved: Scalars['Int']['input'];
  ids: Array<Scalars['String']['input']>;
};

export type ApproveUserAvailabilityDriverAppResponse = {
  __typename?: 'ApproveUserAvailabilityDriverAppResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type ApproveUserAvailabilityInput = {
  approved: Scalars['Int']['input'];
  ids: Array<Scalars['String']['input']>;
};

export type ApproveUserAvailabilityResponse = {
  __typename?: 'ApproveUserAvailabilityResponse';
  updated: Scalars['Int']['output'];
};

export type AssignDriverInput = {
  driverId: Scalars['String']['input'];
  scheduled?: InputMaybe<Scalars['String']['input']>;
  tripId: Scalars['String']['input'];
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type AssignDriverResponse = {
  __typename?: 'AssignDriverResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type AssignVehicleInput = {
  tripId: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type AssignVehicleResponse = {
  __typename?: 'AssignVehicleResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type AssignVehicleToDriverInput = {
  scheduled?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type AssignVehicleToDriverResponse = {
  __typename?: 'AssignVehicleToDriverResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type AuditSnapshot = {
  __typename?: 'AuditSnapshot';
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  data: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AuditSnapshotActivityConnection = {
  __typename?: 'AuditSnapshotActivityConnection';
  edges?: Maybe<Array<Maybe<AuditSnapshotActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditSnapshotActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AuditSnapshotActivityEdge = {
  __typename?: 'AuditSnapshotActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AuditSnapshotConnection = {
  __typename?: 'AuditSnapshotConnection';
  edges?: Maybe<Array<Maybe<AuditSnapshotEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditSnapshotConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AuditSnapshotMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AuditSnapshotSearch>>;
};

export type AuditSnapshotEdge = {
  __typename?: 'AuditSnapshotEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AuditSnapshot>;
};

export type AuditSnapshotMaskInput = {
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  data?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuditSnapshotSearch = {
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  data?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type AuditSnapshotWithName = {
  __typename?: 'AuditSnapshotWithName';
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AuditSnapshotWithNameActivityConnection = {
  __typename?: 'AuditSnapshotWithNameActivityConnection';
  edges?: Maybe<Array<Maybe<AuditSnapshotWithNameActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditSnapshotWithNameActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AuditSnapshotWithNameActivityEdge = {
  __typename?: 'AuditSnapshotWithNameActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AuditSnapshotWithNameConnection = {
  __typename?: 'AuditSnapshotWithNameConnection';
  edges?: Maybe<Array<Maybe<AuditSnapshotWithNameEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AuditSnapshotWithNameConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AuditSnapshotWithNameMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AuditSnapshotWithNameSearch>>;
};

export type AuditSnapshotWithNameEdge = {
  __typename?: 'AuditSnapshotWithNameEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AuditSnapshotWithName>;
};

export type AuditSnapshotWithNameMaskInput = {
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AuditSnapshotWithNameSearch = {
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
};

export type Auth = {
  __typename?: 'Auth';
  allowApproveUserAvailability: Scalars['Boolean']['output'];
  allowCreateUserAvailability: Scalars['Boolean']['output'];
  allowDeleteUserAvailability: Scalars['Boolean']['output'];
  allowGetLeaderboardReport: Scalars['Boolean']['output'];
  allowGetMyPerformanceReport: Scalars['Boolean']['output'];
  allowGetPerformanceReport: Scalars['Boolean']['output'];
  allowRatingsAndReviewsReport: Scalars['Boolean']['output'];
  allowSearchUserAvailability: Scalars['Boolean']['output'];
  allowSubscribeToPushNotifications: Scalars['Boolean']['output'];
  allowTripAssignDriver: Scalars['Boolean']['output'];
  allowUpdateUserAvailability: Scalars['Boolean']['output'];
};

export type AutoCombineRule = {
  __typename?: 'AutoCombineRule';
  combineStrategy: AutoCombineRuleCombineStrategyEnum;
  considerVehicle: Scalars['Int']['output'];
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  importType?: Maybe<AutoCombineRuleImportTypeEnum>;
  kind: AutoCombineRuleKindEnum;
  maxCombine: Scalars['Int']['output'];
  maxCombineType: AutoCombineRuleMaxCombineTypeEnum;
  pickupWindow: Scalars['Int']['output'];
  updateScheduled: AutoCombineRuleUpdateScheduledEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AutoCombineRuleActivityConnection = {
  __typename?: 'AutoCombineRuleActivityConnection';
  edges?: Maybe<Array<Maybe<AutoCombineRuleActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutoCombineRuleActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AutoCombineRuleActivityEdge = {
  __typename?: 'AutoCombineRuleActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum AutoCombineRuleCombineStrategyEnum {
  AggregateTrips = 'AGGREGATE_TRIPS',
  LinkTrips = 'LINK_TRIPS'
}

export type AutoCombineRuleCombineStrategyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutoCombineRuleCombineStrategyEnum>;
};

export type AutoCombineRuleConnection = {
  __typename?: 'AutoCombineRuleConnection';
  edges?: Maybe<Array<Maybe<AutoCombineRuleEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutoCombineRuleConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AutoCombineRuleMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AutoCombineRuleSearch>>;
};

export type AutoCombineRuleEdge = {
  __typename?: 'AutoCombineRuleEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AutoCombineRule>;
};

export enum AutoCombineRuleImportTypeEnum {
  Addon = 'ADDON',
  Manifest = 'MANIFEST'
}

export type AutoCombineRuleImportTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutoCombineRuleImportTypeEnum>;
};

export enum AutoCombineRuleKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type AutoCombineRuleKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutoCombineRuleKindEnum>;
};

export type AutoCombineRuleMaskInput = {
  combineStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  considerVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importType?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  maxCombine?: InputMaybe<Scalars['Boolean']['input']>;
  maxCombineType?: InputMaybe<Scalars['Boolean']['input']>;
  pickupWindow?: InputMaybe<Scalars['Boolean']['input']>;
  updateScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AutoCombineRuleMaxCombineTypeEnum {
  Crew = 'CREW',
  Trip = 'TRIP'
}

export type AutoCombineRuleMaxCombineTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutoCombineRuleMaxCombineTypeEnum>;
};

export type AutoCombineRuleSearch = {
  combineStrategy?: InputMaybe<Array<AutoCombineRuleCombineStrategyEnumSearch>>;
  considerVehicle?: InputMaybe<Array<IntSearch>>;
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importType?: InputMaybe<Array<AutoCombineRuleImportTypeEnumSearch>>;
  kind?: InputMaybe<Array<AutoCombineRuleKindEnumSearch>>;
  maxCombine?: InputMaybe<Array<IntSearch>>;
  maxCombineType?: InputMaybe<Array<AutoCombineRuleMaxCombineTypeEnumSearch>>;
  pickupWindow?: InputMaybe<Array<IntSearch>>;
  updateScheduled?: InputMaybe<Array<AutoCombineRuleUpdateScheduledEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum AutoCombineRuleUpdateScheduledEnum {
  Earliest = 'EARLIEST',
  Latest = 'LATEST',
  None = 'NONE'
}

export type AutoCombineRuleUpdateScheduledEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutoCombineRuleUpdateScheduledEnum>;
};

export type AutoCombineRuleWithContract = {
  __typename?: 'AutoCombineRuleWithContract';
  combineStrategy: AutoCombineRuleWithContractCombineStrategyEnum;
  companyId: Scalars['String']['output'];
  considerVehicle: Scalars['Int']['output'];
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  importType?: Maybe<AutoCombineRuleWithContractImportTypeEnum>;
  kind: AutoCombineRuleWithContractKindEnum;
  maxCombine: Scalars['Int']['output'];
  maxCombineType: AutoCombineRuleWithContractMaxCombineTypeEnum;
  pickupWindow: Scalars['Int']['output'];
  providerId: Scalars['String']['output'];
  updateScheduled: AutoCombineRuleWithContractUpdateScheduledEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AutoCombineRuleWithContractActivityConnection = {
  __typename?: 'AutoCombineRuleWithContractActivityConnection';
  edges?: Maybe<Array<Maybe<AutoCombineRuleWithContractActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutoCombineRuleWithContractActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AutoCombineRuleWithContractActivityEdge = {
  __typename?: 'AutoCombineRuleWithContractActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum AutoCombineRuleWithContractCombineStrategyEnum {
  AggregateTrips = 'AGGREGATE_TRIPS',
  LinkTrips = 'LINK_TRIPS'
}

export type AutoCombineRuleWithContractCombineStrategyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutoCombineRuleWithContractCombineStrategyEnum>;
};

export type AutoCombineRuleWithContractConnection = {
  __typename?: 'AutoCombineRuleWithContractConnection';
  edges?: Maybe<Array<Maybe<AutoCombineRuleWithContractEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutoCombineRuleWithContractConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AutoCombineRuleWithContractMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AutoCombineRuleWithContractSearch>>;
};

export type AutoCombineRuleWithContractEdge = {
  __typename?: 'AutoCombineRuleWithContractEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AutoCombineRuleWithContract>;
};

export enum AutoCombineRuleWithContractImportTypeEnum {
  Addon = 'ADDON',
  Manifest = 'MANIFEST'
}

export type AutoCombineRuleWithContractImportTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutoCombineRuleWithContractImportTypeEnum>;
};

export enum AutoCombineRuleWithContractKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type AutoCombineRuleWithContractKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutoCombineRuleWithContractKindEnum>;
};

export type AutoCombineRuleWithContractMaskInput = {
  combineStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  considerVehicle?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importType?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  maxCombine?: InputMaybe<Scalars['Boolean']['input']>;
  maxCombineType?: InputMaybe<Scalars['Boolean']['input']>;
  pickupWindow?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  updateScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum AutoCombineRuleWithContractMaxCombineTypeEnum {
  Crew = 'CREW',
  Trip = 'TRIP'
}

export type AutoCombineRuleWithContractMaxCombineTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutoCombineRuleWithContractMaxCombineTypeEnum>;
};

export type AutoCombineRuleWithContractSearch = {
  combineStrategy?: InputMaybe<Array<AutoCombineRuleWithContractCombineStrategyEnumSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  considerVehicle?: InputMaybe<Array<IntSearch>>;
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importType?: InputMaybe<Array<AutoCombineRuleWithContractImportTypeEnumSearch>>;
  kind?: InputMaybe<Array<AutoCombineRuleWithContractKindEnumSearch>>;
  maxCombine?: InputMaybe<Array<IntSearch>>;
  maxCombineType?: InputMaybe<Array<AutoCombineRuleWithContractMaxCombineTypeEnumSearch>>;
  pickupWindow?: InputMaybe<Array<IntSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  updateScheduled?: InputMaybe<Array<AutoCombineRuleWithContractUpdateScheduledEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum AutoCombineRuleWithContractUpdateScheduledEnum {
  Earliest = 'EARLIEST',
  Latest = 'LATEST',
  None = 'NONE'
}

export type AutoCombineRuleWithContractUpdateScheduledEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutoCombineRuleWithContractUpdateScheduledEnum>;
};

export type AutomationHistory = {
  __typename?: 'AutomationHistory';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  driverAssigmentFailedCount: Scalars['Int']['output'];
  endDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  startDatetime: Scalars['String']['output'];
  status: AutomationHistoryStatusEnum;
  totalTripsProcessed: Scalars['Int']['output'];
  totalTripsToBeProcessed: Scalars['Int']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AutomationHistoryActivityConnection = {
  __typename?: 'AutomationHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<AutomationHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AutomationHistoryActivityEdge = {
  __typename?: 'AutomationHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AutomationHistoryAirport = {
  __typename?: 'AutomationHistoryAirport';
  airportCode: Scalars['String']['output'];
  automationHistoryId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AutomationHistoryAirportActivityConnection = {
  __typename?: 'AutomationHistoryAirportActivityConnection';
  edges?: Maybe<Array<Maybe<AutomationHistoryAirportActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationHistoryAirportActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AutomationHistoryAirportActivityEdge = {
  __typename?: 'AutomationHistoryAirportActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AutomationHistoryAirportConnection = {
  __typename?: 'AutomationHistoryAirportConnection';
  edges?: Maybe<Array<Maybe<AutomationHistoryAirportEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationHistoryAirportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AutomationHistoryAirportMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AutomationHistoryAirportSearch>>;
};

export type AutomationHistoryAirportEdge = {
  __typename?: 'AutomationHistoryAirportEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AutomationHistoryAirport>;
};

export type AutomationHistoryAirportMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  automationHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomationHistoryAirportSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  automationHistoryId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type AutomationHistoryConnection = {
  __typename?: 'AutomationHistoryConnection';
  edges?: Maybe<Array<Maybe<AutomationHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AutomationHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AutomationHistorySearch>>;
};

export type AutomationHistoryEdge = {
  __typename?: 'AutomationHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AutomationHistory>;
};

export type AutomationHistoryLog = {
  __typename?: 'AutomationHistoryLog';
  automationHistoryId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AutomationHistoryLogActivityConnection = {
  __typename?: 'AutomationHistoryLogActivityConnection';
  edges?: Maybe<Array<Maybe<AutomationHistoryLogActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationHistoryLogActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AutomationHistoryLogActivityEdge = {
  __typename?: 'AutomationHistoryLogActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AutomationHistoryLogConnection = {
  __typename?: 'AutomationHistoryLogConnection';
  edges?: Maybe<Array<Maybe<AutomationHistoryLogEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationHistoryLogConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AutomationHistoryLogMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AutomationHistoryLogSearch>>;
};

export type AutomationHistoryLogEdge = {
  __typename?: 'AutomationHistoryLogEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AutomationHistoryLog>;
};

export type AutomationHistoryLogMaskInput = {
  automationHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomationHistoryLogSearch = {
  automationHistoryId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  message?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type AutomationHistoryMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  driverAssigmentFailedCount?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  totalTripsProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  totalTripsToBeProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomationHistorySearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  driverAssigmentFailedCount?: InputMaybe<Array<IntSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<AutomationHistoryStatusEnumSearch>>;
  totalTripsProcessed?: InputMaybe<Array<IntSearch>>;
  totalTripsToBeProcessed?: InputMaybe<Array<IntSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum AutomationHistoryStatusEnum {
  AssigningDrivers = 'ASSIGNING_DRIVERS',
  AssigningDriversQueued = 'ASSIGNING_DRIVERS_QUEUED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InQueue = 'IN_QUEUE',
  ProcessingData = 'PROCESSING_DATA',
  ReadyToAssign = 'READY_TO_ASSIGN'
}

export type AutomationHistoryStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutomationHistoryStatusEnum>;
};

export type AutomationHistoryWithAirport = {
  __typename?: 'AutomationHistoryWithAirport';
  airportCodes: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  driverAssigmentFailedCount: Scalars['Int']['output'];
  endDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  startDatetime: Scalars['String']['output'];
  status: AutomationHistoryWithAirportStatusEnum;
  totalTripsProcessed: Scalars['Int']['output'];
  totalTripsToBeProcessed: Scalars['Int']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AutomationHistoryWithAirportActivityConnection = {
  __typename?: 'AutomationHistoryWithAirportActivityConnection';
  edges?: Maybe<Array<Maybe<AutomationHistoryWithAirportActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationHistoryWithAirportActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AutomationHistoryWithAirportActivityEdge = {
  __typename?: 'AutomationHistoryWithAirportActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AutomationHistoryWithAirportConnection = {
  __typename?: 'AutomationHistoryWithAirportConnection';
  edges?: Maybe<Array<Maybe<AutomationHistoryWithAirportEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationHistoryWithAirportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AutomationHistoryWithAirportMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AutomationHistoryWithAirportSearch>>;
};

export type AutomationHistoryWithAirportEdge = {
  __typename?: 'AutomationHistoryWithAirportEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AutomationHistoryWithAirport>;
};

export type AutomationHistoryWithAirportMaskInput = {
  airportCodes?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  driverAssigmentFailedCount?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  totalTripsProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  totalTripsToBeProcessed?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomationHistoryWithAirportSearch = {
  airportCodes?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum AutomationHistoryWithAirportStatusEnum {
  AssigningDrivers = 'ASSIGNING_DRIVERS',
  AssigningDriversQueued = 'ASSIGNING_DRIVERS_QUEUED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InQueue = 'IN_QUEUE',
  ProcessingData = 'PROCESSING_DATA',
  ReadyToAssign = 'READY_TO_ASSIGN'
}

export type AutomationHistoryWithAirportStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutomationHistoryWithAirportStatusEnum>;
};

export type AutomationReport = {
  __typename?: 'AutomationReport';
  automatedTrips: Scalars['Int']['output'];
  automationHistoryId: Scalars['String']['output'];
  changedTrips: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  cutoffAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  manualTrips: Scalars['Int']['output'];
  timeSavedSeconds: Scalars['Int']['output'];
  totalTrips: Scalars['Int']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  unchangedTrips: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AutomationReportActivityConnection = {
  __typename?: 'AutomationReportActivityConnection';
  edges?: Maybe<Array<Maybe<AutomationReportActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationReportActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AutomationReportActivityEdge = {
  __typename?: 'AutomationReportActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AutomationReportConnection = {
  __typename?: 'AutomationReportConnection';
  edges?: Maybe<Array<Maybe<AutomationReportEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationReportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AutomationReportMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AutomationReportSearch>>;
};

export type AutomationReportEdge = {
  __typename?: 'AutomationReportEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AutomationReport>;
};

export type AutomationReportMaskInput = {
  automatedTrips?: InputMaybe<Scalars['Boolean']['input']>;
  automationHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  changedTrips?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  cutoffAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  manualTrips?: InputMaybe<Scalars['Boolean']['input']>;
  timeSavedSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  totalTrips?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  unchangedTrips?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomationReportSearch = {
  automatedTrips?: InputMaybe<Array<IntSearch>>;
  automationHistoryId?: InputMaybe<Array<StringSearch>>;
  changedTrips?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  cutoffAt?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  manualTrips?: InputMaybe<Array<IntSearch>>;
  timeSavedSeconds?: InputMaybe<Array<IntSearch>>;
  totalTrips?: InputMaybe<Array<IntSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  unchangedTrips?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type AutomationReportWithAutomationHistory = {
  __typename?: 'AutomationReportWithAutomationHistory';
  airportCodes: Scalars['String']['output'];
  automatedTrips: Scalars['Int']['output'];
  automationCreatedAt?: Maybe<Scalars['String']['output']>;
  automationCreatedBy?: Maybe<Scalars['String']['output']>;
  automationHistoryId: Scalars['String']['output'];
  automationStatus: AutomationReportWithAutomationHistoryAutomationStatusEnum;
  changedTrips: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  cutoffAt: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  endDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  manualTrips: Scalars['Int']['output'];
  startDatetime: Scalars['String']['output'];
  timeSavedSeconds: Scalars['Int']['output'];
  totalTrips: Scalars['Int']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  unchangedTrips: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AutomationReportWithAutomationHistoryActivityConnection = {
  __typename?: 'AutomationReportWithAutomationHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<AutomationReportWithAutomationHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationReportWithAutomationHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AutomationReportWithAutomationHistoryActivityEdge = {
  __typename?: 'AutomationReportWithAutomationHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum AutomationReportWithAutomationHistoryAutomationStatusEnum {
  AssigningDrivers = 'ASSIGNING_DRIVERS',
  AssigningDriversQueued = 'ASSIGNING_DRIVERS_QUEUED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InQueue = 'IN_QUEUE',
  ProcessingData = 'PROCESSING_DATA',
  ReadyToAssign = 'READY_TO_ASSIGN'
}

export type AutomationReportWithAutomationHistoryAutomationStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutomationReportWithAutomationHistoryAutomationStatusEnum>;
};

export type AutomationReportWithAutomationHistoryConnection = {
  __typename?: 'AutomationReportWithAutomationHistoryConnection';
  edges?: Maybe<Array<Maybe<AutomationReportWithAutomationHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationReportWithAutomationHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AutomationReportWithAutomationHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AutomationReportWithAutomationHistorySearch>>;
};

export type AutomationReportWithAutomationHistoryEdge = {
  __typename?: 'AutomationReportWithAutomationHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AutomationReportWithAutomationHistory>;
};

export type AutomationReportWithAutomationHistoryMaskInput = {
  airportCodes?: InputMaybe<Scalars['Boolean']['input']>;
  automatedTrips?: InputMaybe<Scalars['Boolean']['input']>;
  automationCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  automationCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  automationHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  automationStatus?: InputMaybe<Scalars['Boolean']['input']>;
  changedTrips?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  cutoffAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  manualTrips?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  timeSavedSeconds?: InputMaybe<Scalars['Boolean']['input']>;
  totalTrips?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  unchangedTrips?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomationReportWithAutomationHistorySearch = {
  airportCodes?: InputMaybe<Array<StringSearch>>;
  automatedTrips?: InputMaybe<Array<IntSearch>>;
  automationCreatedAt?: InputMaybe<Array<StringSearch>>;
  automationCreatedBy?: InputMaybe<Array<StringSearch>>;
  automationHistoryId?: InputMaybe<Array<StringSearch>>;
  automationStatus?: InputMaybe<Array<AutomationReportWithAutomationHistoryAutomationStatusEnumSearch>>;
  changedTrips?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  cutoffAt?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  manualTrips?: InputMaybe<Array<IntSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  timeSavedSeconds?: InputMaybe<Array<IntSearch>>;
  totalTrips?: InputMaybe<Array<IntSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  unchangedTrips?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type AutomationTrip = {
  __typename?: 'AutomationTrip';
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  automationHistoryId: Scalars['String']['output'];
  cachedDoLocationId?: Maybe<Scalars['String']['output']>;
  cachedPayerProviderId?: Maybe<Scalars['String']['output']>;
  cachedPuLocationId?: Maybe<Scalars['String']['output']>;
  combineId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  doLocationCoordinates?: Maybe<Point>;
  doLocationName?: Maybe<Scalars['String']['output']>;
  driverAtCutoffFullName?: Maybe<Scalars['String']['output']>;
  driverAtCutoffId?: Maybe<Scalars['String']['output']>;
  driverFirstName?: Maybe<Scalars['String']['output']>;
  driverFullName?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  driverLastName?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  kind: AutomationTripKindEnum;
  loopName?: Maybe<Scalars['String']['output']>;
  newDriverFullName?: Maybe<Scalars['String']['output']>;
  newDriverId?: Maybe<Scalars['String']['output']>;
  offset: Scalars['String']['output'];
  payerProviderDisplayName?: Maybe<Scalars['String']['output']>;
  pilots: Scalars['Int']['output'];
  puGpsDatetime?: Maybe<Scalars['String']['output']>;
  puLocationCoordinates?: Maybe<Point>;
  puLocationName?: Maybe<Scalars['String']['output']>;
  scheduled: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  status: AutomationTripStatusEnum;
  traceId?: Maybe<Scalars['String']['output']>;
  tripId: Scalars['String']['output'];
  type: AutomationTripTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
  vehicleTrackingId?: Maybe<Scalars['String']['output']>;
};

export type AutomationTripActivityConnection = {
  __typename?: 'AutomationTripActivityConnection';
  edges?: Maybe<Array<Maybe<AutomationTripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationTripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AutomationTripActivityEdge = {
  __typename?: 'AutomationTripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AutomationTripAssignmentReason = {
  __typename?: 'AutomationTripAssignmentReason';
  automationTripId: Scalars['String']['output'];
  code: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  displayMessage: Scalars['String']['output'];
  errorMessage: Scalars['String']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AutomationTripAssignmentReasonActivityConnection = {
  __typename?: 'AutomationTripAssignmentReasonActivityConnection';
  edges?: Maybe<Array<Maybe<AutomationTripAssignmentReasonActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationTripAssignmentReasonActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AutomationTripAssignmentReasonActivityEdge = {
  __typename?: 'AutomationTripAssignmentReasonActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AutomationTripAssignmentReasonConnection = {
  __typename?: 'AutomationTripAssignmentReasonConnection';
  edges?: Maybe<Array<Maybe<AutomationTripAssignmentReasonEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationTripAssignmentReasonConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AutomationTripAssignmentReasonMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AutomationTripAssignmentReasonSearch>>;
};

export type AutomationTripAssignmentReasonEdge = {
  __typename?: 'AutomationTripAssignmentReasonEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AutomationTripAssignmentReason>;
};

export type AutomationTripAssignmentReasonMaskInput = {
  automationTripId?: InputMaybe<Scalars['Boolean']['input']>;
  code?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayMessage?: InputMaybe<Scalars['Boolean']['input']>;
  errorMessage?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  title?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomationTripAssignmentReasonSearch = {
  automationTripId?: InputMaybe<Array<StringSearch>>;
  code?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  displayMessage?: InputMaybe<Array<StringSearch>>;
  errorMessage?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  title?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type AutomationTripConnection = {
  __typename?: 'AutomationTripConnection';
  edges?: Maybe<Array<Maybe<AutomationTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AutomationTripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AutomationTripSearch>>;
};

export type AutomationTripEdge = {
  __typename?: 'AutomationTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AutomationTrip>;
};

export enum AutomationTripKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type AutomationTripKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutomationTripKindEnum>;
};

export type AutomationTripLog = {
  __typename?: 'AutomationTripLog';
  automationTripId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type AutomationTripLogActivityConnection = {
  __typename?: 'AutomationTripLogActivityConnection';
  edges?: Maybe<Array<Maybe<AutomationTripLogActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationTripLogActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type AutomationTripLogActivityEdge = {
  __typename?: 'AutomationTripLogActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type AutomationTripLogConnection = {
  __typename?: 'AutomationTripLogConnection';
  edges?: Maybe<Array<Maybe<AutomationTripLogEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type AutomationTripLogConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<AutomationTripLogMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<AutomationTripLogSearch>>;
};

export type AutomationTripLogEdge = {
  __typename?: 'AutomationTripLogEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AutomationTripLog>;
};

export type AutomationTripLogMaskInput = {
  automationTripId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomationTripLogSearch = {
  automationTripId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  message?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type AutomationTripMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  automationHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  cachedDoLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  cachedPayerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  cachedPuLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationCoordinates?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationName?: InputMaybe<Scalars['Boolean']['input']>;
  driverAtCutoffFullName?: InputMaybe<Scalars['Boolean']['input']>;
  driverAtCutoffId?: InputMaybe<Scalars['Boolean']['input']>;
  driverFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  driverFullName?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  driverLastName?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  newDriverFullName?: InputMaybe<Scalars['Boolean']['input']>;
  newDriverId?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  puGpsDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationCoordinates?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationName?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTrackingId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type AutomationTripSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  automationHistoryId?: InputMaybe<Array<StringSearch>>;
  cachedDoLocationId?: InputMaybe<Array<StringSearch>>;
  cachedPayerProviderId?: InputMaybe<Array<StringSearch>>;
  cachedPuLocationId?: InputMaybe<Array<StringSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  doLocationCoordinates?: InputMaybe<Array<PointSearch>>;
  doLocationName?: InputMaybe<Array<StringSearch>>;
  driverAtCutoffFullName?: InputMaybe<Array<StringSearch>>;
  driverAtCutoffId?: InputMaybe<Array<StringSearch>>;
  driverFirstName?: InputMaybe<Array<StringSearch>>;
  driverFullName?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  driverLastName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  kind?: InputMaybe<Array<AutomationTripKindEnumSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  newDriverFullName?: InputMaybe<Array<StringSearch>>;
  newDriverId?: InputMaybe<Array<StringSearch>>;
  offset?: InputMaybe<Array<StringSearch>>;
  payerProviderDisplayName?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  puGpsDatetime?: InputMaybe<Array<StringSearch>>;
  puLocationCoordinates?: InputMaybe<Array<PointSearch>>;
  puLocationName?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<AutomationTripStatusEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<AutomationTripTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  vehicleTrackingId?: InputMaybe<Array<StringSearch>>;
};

export enum AutomationTripStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type AutomationTripStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutomationTripStatusEnum>;
};

export enum AutomationTripTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type AutomationTripTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<AutomationTripTypeEnum>;
};

export type AvailabilityType = {
  __typename?: 'AvailabilityType';
  approved?: Maybe<Scalars['Int']['output']>;
  color: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  legendDisplayName?: Maybe<Scalars['String']['output']>;
  repeat?: Maybe<Scalars['Int']['output']>;
  type: UserAvailabilityTypeEnum;
};

export enum AvailabilityTypeEnum {
  ApprovedOff = 'APPROVED_OFF',
  ApprovedOn = 'APPROVED_ON',
  RequestOff = 'REQUEST_OFF',
  RequestOn = 'REQUEST_ON'
}

export type BooleanSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<Scalars['Boolean']['input']>;
};

export type BufferTime = {
  __typename?: 'BufferTime';
  active: Scalars['Int']['output'];
  airportCode: Scalars['String']['output'];
  bufferMinutes: Scalars['Int']['output'];
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  endLocation?: Maybe<Location>;
  endLocationDisplayName: Scalars['String']['output'];
  endLocationId?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['String']['output']>;
  startLocation?: Maybe<Location>;
  startLocationDisplayName: Scalars['String']['output'];
  startLocationId: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type BufferTimeActivityConnection = {
  __typename?: 'BufferTimeActivityConnection';
  edges?: Maybe<Array<Maybe<BufferTimeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BufferTimeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type BufferTimeActivityEdge = {
  __typename?: 'BufferTimeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type BufferTimeConnection = {
  __typename?: 'BufferTimeConnection';
  edges?: Maybe<Array<Maybe<BufferTimeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BufferTimeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<BufferTimeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<BufferTimeSearch>>;
};

export type BufferTimeEdge = {
  __typename?: 'BufferTimeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<BufferTime>;
};

export type BufferTimeInput = {
  buffer: Scalars['Int']['input'];
  contractId: Scalars['String']['input'];
  dropoffLocationId?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  pickupLocationId: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type BufferTimeMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  bufferMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  endLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  startLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BufferTimeResponse = {
  __typename?: 'BufferTimeResponse';
  bufferTime?: Maybe<BufferTime>;
  error?: Maybe<Scalars['String']['output']>;
};

export type BufferTimeSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  bufferMinutes?: InputMaybe<Array<IntSearch>>;
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  endLocationId?: InputMaybe<Array<StringSearch>>;
  endTime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  startLocationId?: InputMaybe<Array<StringSearch>>;
  startTime?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type BufferTimeWithContract = {
  __typename?: 'BufferTimeWithContract';
  active: Scalars['Int']['output'];
  airportCode: Scalars['String']['output'];
  bufferMinutes: Scalars['Int']['output'];
  companyId: Scalars['String']['output'];
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  endLocationId?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  startLocationId: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type BufferTimeWithContractActivityConnection = {
  __typename?: 'BufferTimeWithContractActivityConnection';
  edges?: Maybe<Array<Maybe<BufferTimeWithContractActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BufferTimeWithContractActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type BufferTimeWithContractActivityEdge = {
  __typename?: 'BufferTimeWithContractActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type BufferTimeWithContractConnection = {
  __typename?: 'BufferTimeWithContractConnection';
  edges?: Maybe<Array<Maybe<BufferTimeWithContractEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type BufferTimeWithContractConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<BufferTimeWithContractMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<BufferTimeWithContractSearch>>;
};

export type BufferTimeWithContractEdge = {
  __typename?: 'BufferTimeWithContractEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<BufferTimeWithContract>;
};

export type BufferTimeWithContractMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  bufferMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  endLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  startLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type BufferTimeWithContractSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  bufferMinutes?: InputMaybe<Array<IntSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  endLocationId?: InputMaybe<Array<StringSearch>>;
  endTime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  startLocationId?: InputMaybe<Array<StringSearch>>;
  startTime?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type CancelTripInput = {
  tripIds: Array<Scalars['String']['input']>;
};

export type CancelTripResponse = {
  __typename?: 'CancelTripResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type CancellationRule = {
  __typename?: 'CancellationRule';
  airportCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  endLocationId: Scalars['String']['output'];
  from: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  percentage: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  startLocationId: Scalars['String']['output'];
  to: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CancellationRuleActivityConnection = {
  __typename?: 'CancellationRuleActivityConnection';
  edges?: Maybe<Array<Maybe<CancellationRuleActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CancellationRuleActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CancellationRuleActivityEdge = {
  __typename?: 'CancellationRuleActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CancellationRuleConnection = {
  __typename?: 'CancellationRuleConnection';
  edges?: Maybe<Array<Maybe<CancellationRuleEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CancellationRuleConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CancellationRuleMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CancellationRuleSearch>>;
};

export type CancellationRuleEdge = {
  __typename?: 'CancellationRuleEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CancellationRule>;
};

export type CancellationRuleMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  endLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  percentage?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  startLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  to?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CancellationRuleSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  endLocationId?: InputMaybe<Array<StringSearch>>;
  from?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  percentage?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  startLocationId?: InputMaybe<Array<StringSearch>>;
  to?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type Charity = {
  __typename?: 'Charity';
  active: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewFindDriverBannerDisplayMessage?: Maybe<Scalars['String']['output']>;
  crewRateDriverTooltipDisplayMessage?: Maybe<Scalars['String']['output']>;
  crewTripCompleteBannerDisplayMessage?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  driverLoginBannerDisplayMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  totalGoalAmount: Scalars['Float']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CharityActivityConnection = {
  __typename?: 'CharityActivityConnection';
  edges?: Maybe<Array<Maybe<CharityActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharityActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CharityActivityEdge = {
  __typename?: 'CharityActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CharityAmountHistory = {
  __typename?: 'CharityAmountHistory';
  amount: Scalars['Float']['output'];
  charityId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
};

export type CharityAmountHistoryActivityConnection = {
  __typename?: 'CharityAmountHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<CharityAmountHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharityAmountHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CharityAmountHistoryActivityEdge = {
  __typename?: 'CharityAmountHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CharityAmountHistoryConnection = {
  __typename?: 'CharityAmountHistoryConnection';
  edges?: Maybe<Array<Maybe<CharityAmountHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharityAmountHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CharityAmountHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CharityAmountHistorySearch>>;
};

export type CharityAmountHistoryEdge = {
  __typename?: 'CharityAmountHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CharityAmountHistory>;
};

export type CharityAmountHistoryMaskInput = {
  amount?: InputMaybe<Scalars['Boolean']['input']>;
  charityId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CharityAmountHistorySearch = {
  amount?: InputMaybe<Array<FloatSearch>>;
  charityId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
};

export type CharityConnection = {
  __typename?: 'CharityConnection';
  edges?: Maybe<Array<Maybe<CharityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CharityMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CharitySearch>>;
};

export type CharityEdge = {
  __typename?: 'CharityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Charity>;
};

export type CharityLeaderboardDriver = {
  __typename?: 'CharityLeaderboardDriver';
  avatar: Scalars['String']['output'];
  bubbleName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  markets: Array<Scalars['String']['output']>;
  totalRatings: Scalars['Int']['output'];
  userId: Scalars['String']['output'];
};

export type CharityLeaderboardInput = {
  airportCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  charityId?: InputMaybe<Scalars['String']['input']>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
};

export type CharityLeaderboardProgressBar = {
  __typename?: 'CharityLeaderboardProgressBar';
  part: Scalars['Float']['output'];
  percent: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
};

export type CharityLeaderboardResponse = {
  __typename?: 'CharityLeaderboardResponse';
  drivers: Array<CharityLeaderboardDriver>;
  progressBar: CharityLeaderboardProgressBar;
  totalCount: Scalars['Int']['output'];
};

export type CharityMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewFindDriverBannerDisplayMessage?: InputMaybe<Scalars['Boolean']['input']>;
  crewRateDriverTooltipDisplayMessage?: InputMaybe<Scalars['Boolean']['input']>;
  crewTripCompleteBannerDisplayMessage?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  driverLoginBannerDisplayMessage?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  totalGoalAmount?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CharityRatingHistory = {
  __typename?: 'CharityRatingHistory';
  airportCode: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  charityId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  providerDisplayName?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  ratingId: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
};

export type CharityRatingHistoryActivityConnection = {
  __typename?: 'CharityRatingHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<CharityRatingHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharityRatingHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CharityRatingHistoryActivityEdge = {
  __typename?: 'CharityRatingHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CharityRatingHistoryConnection = {
  __typename?: 'CharityRatingHistoryConnection';
  edges?: Maybe<Array<Maybe<CharityRatingHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharityRatingHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CharityRatingHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CharityRatingHistorySearch>>;
};

export type CharityRatingHistoryEdge = {
  __typename?: 'CharityRatingHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CharityRatingHistory>;
};

export type CharityRatingHistoryMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Boolean']['input']>;
  charityId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  providerDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Boolean']['input']>;
  ratingId?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CharityRatingHistoryReport = {
  __typename?: 'CharityRatingHistoryReport';
  airportCode: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  charityId: Scalars['String']['output'];
  charityName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  providerDisplayName?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  ratingId: Scalars['String']['output'];
  userFirstName?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  userLastName?: Maybe<Scalars['String']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type CharityRatingHistoryReportActivityConnection = {
  __typename?: 'CharityRatingHistoryReportActivityConnection';
  edges?: Maybe<Array<Maybe<CharityRatingHistoryReportActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharityRatingHistoryReportActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CharityRatingHistoryReportActivityEdge = {
  __typename?: 'CharityRatingHistoryReportActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CharityRatingHistoryReportConnection = {
  __typename?: 'CharityRatingHistoryReportConnection';
  edges?: Maybe<Array<Maybe<CharityRatingHistoryReportEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharityRatingHistoryReportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CharityRatingHistoryReportMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CharityRatingHistoryReportSearch>>;
};

export type CharityRatingHistoryReportEdge = {
  __typename?: 'CharityRatingHistoryReportEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CharityRatingHistoryReport>;
};

export type CharityRatingHistoryReportMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['Boolean']['input']>;
  charityId?: InputMaybe<Scalars['Boolean']['input']>;
  charityName?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  providerDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Boolean']['input']>;
  ratingId?: InputMaybe<Scalars['Boolean']['input']>;
  userFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
  userLastName?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CharityRatingHistoryReportSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  amount?: InputMaybe<Array<FloatSearch>>;
  avatar?: InputMaybe<Array<StringSearch>>;
  charityId?: InputMaybe<Array<StringSearch>>;
  charityName?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  providerDisplayName?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  rating?: InputMaybe<Array<IntSearch>>;
  ratingId?: InputMaybe<Array<StringSearch>>;
  userFirstName?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
  userLastName?: InputMaybe<Array<StringSearch>>;
  username?: InputMaybe<Array<StringSearch>>;
};

export type CharityRatingHistorySearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  amount?: InputMaybe<Array<FloatSearch>>;
  charityId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  providerDisplayName?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  rating?: InputMaybe<Array<IntSearch>>;
  ratingId?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type CharityRatingHistoryWithUser = {
  __typename?: 'CharityRatingHistoryWithUser';
  airportCode: Scalars['String']['output'];
  amount: Scalars['Float']['output'];
  charityId: Scalars['String']['output'];
  charityName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  providerDisplayName?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  ratingId: Scalars['String']['output'];
  userFirstName: Scalars['String']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  userLastName: Scalars['String']['output'];
};

export type CharityRatingHistoryWithUserActivityConnection = {
  __typename?: 'CharityRatingHistoryWithUserActivityConnection';
  edges?: Maybe<Array<Maybe<CharityRatingHistoryWithUserActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharityRatingHistoryWithUserActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CharityRatingHistoryWithUserActivityEdge = {
  __typename?: 'CharityRatingHistoryWithUserActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CharityRatingHistoryWithUserConnection = {
  __typename?: 'CharityRatingHistoryWithUserConnection';
  edges?: Maybe<Array<Maybe<CharityRatingHistoryWithUserEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharityRatingHistoryWithUserConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CharityRatingHistoryWithUserMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CharityRatingHistoryWithUserSearch>>;
};

export type CharityRatingHistoryWithUserEdge = {
  __typename?: 'CharityRatingHistoryWithUserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CharityRatingHistoryWithUser>;
};

export type CharityRatingHistoryWithUserMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Boolean']['input']>;
  charityId?: InputMaybe<Scalars['Boolean']['input']>;
  charityName?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  providerDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Boolean']['input']>;
  ratingId?: InputMaybe<Scalars['Boolean']['input']>;
  userFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
  userLastName?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CharityRatingHistoryWithUserSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  amount?: InputMaybe<Array<FloatSearch>>;
  charityId?: InputMaybe<Array<StringSearch>>;
  charityName?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  providerDisplayName?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  rating?: InputMaybe<Array<IntSearch>>;
  ratingId?: InputMaybe<Array<StringSearch>>;
  userFirstName?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
  userLastName?: InputMaybe<Array<StringSearch>>;
};

export type CharitySearch = {
  active?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewFindDriverBannerDisplayMessage?: InputMaybe<Array<StringSearch>>;
  crewRateDriverTooltipDisplayMessage?: InputMaybe<Array<StringSearch>>;
  crewTripCompleteBannerDisplayMessage?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  driverLoginBannerDisplayMessage?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  logoUrl?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  totalGoalAmount?: InputMaybe<Array<FloatSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type CharityWithAmountHistory = {
  __typename?: 'CharityWithAmountHistory';
  active: Scalars['Int']['output'];
  amount: Scalars['Float']['output'];
  amountCreatedAt?: Maybe<Scalars['String']['output']>;
  amountCreatedBy?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewFindDriverBannerDisplayMessage?: Maybe<Scalars['String']['output']>;
  crewRateDriverTooltipDisplayMessage?: Maybe<Scalars['String']['output']>;
  crewTripCompleteBannerDisplayMessage?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  driverLoginBannerDisplayMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  logoUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  totalGoalAmount: Scalars['Float']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CharityWithAmountHistoryActivityConnection = {
  __typename?: 'CharityWithAmountHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<CharityWithAmountHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharityWithAmountHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CharityWithAmountHistoryActivityEdge = {
  __typename?: 'CharityWithAmountHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CharityWithAmountHistoryConnection = {
  __typename?: 'CharityWithAmountHistoryConnection';
  edges?: Maybe<Array<Maybe<CharityWithAmountHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CharityWithAmountHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CharityWithAmountHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CharityWithAmountHistorySearch>>;
};

export type CharityWithAmountHistoryEdge = {
  __typename?: 'CharityWithAmountHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CharityWithAmountHistory>;
};

export type CharityWithAmountHistoryMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  amount?: InputMaybe<Scalars['Boolean']['input']>;
  amountCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  amountCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewFindDriverBannerDisplayMessage?: InputMaybe<Scalars['Boolean']['input']>;
  crewRateDriverTooltipDisplayMessage?: InputMaybe<Scalars['Boolean']['input']>;
  crewTripCompleteBannerDisplayMessage?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  driverLoginBannerDisplayMessage?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  logoUrl?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  totalGoalAmount?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CharityWithAmountHistorySearch = {
  active?: InputMaybe<Array<IntSearch>>;
  amount?: InputMaybe<Array<FloatSearch>>;
  amountCreatedAt?: InputMaybe<Array<StringSearch>>;
  amountCreatedBy?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewFindDriverBannerDisplayMessage?: InputMaybe<Array<StringSearch>>;
  crewRateDriverTooltipDisplayMessage?: InputMaybe<Array<StringSearch>>;
  crewTripCompleteBannerDisplayMessage?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  driverLoginBannerDisplayMessage?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  logoUrl?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  totalGoalAmount?: InputMaybe<Array<FloatSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type ChatHistoryMessage = {
  __typename?: 'ChatHistoryMessage';
  airline: Scalars['String']['output'];
  content: Scalars['String']['output'];
  datetime: Scalars['String']['output'];
  roomName: Scalars['String']['output'];
  userName: Scalars['String']['output'];
};

export type ChatQuickReplyMessage = {
  __typename?: 'ChatQuickReplyMessage';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  name: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ChatQuickReplyMessageActivityConnection = {
  __typename?: 'ChatQuickReplyMessageActivityConnection';
  edges?: Maybe<Array<Maybe<ChatQuickReplyMessageActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChatQuickReplyMessageActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ChatQuickReplyMessageActivityEdge = {
  __typename?: 'ChatQuickReplyMessageActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ChatQuickReplyMessageConnection = {
  __typename?: 'ChatQuickReplyMessageConnection';
  edges?: Maybe<Array<Maybe<ChatQuickReplyMessageEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ChatQuickReplyMessageConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ChatQuickReplyMessageMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ChatQuickReplyMessageSearch>>;
};

export type ChatQuickReplyMessageEdge = {
  __typename?: 'ChatQuickReplyMessageEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ChatQuickReplyMessage>;
};

export type ChatQuickReplyMessageMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatQuickReplyMessageSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  message?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  sortOrder?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type CheckEvaluationEligibilityInput = {
  subjectUserId: Scalars['String']['input'];
};

export type CheckEvaluationEligibilityResponse = {
  __typename?: 'CheckEvaluationEligibilityResponse';
  categories: Array<EvaluationEligibilityCategory>;
  error?: Maybe<Error>;
  hasActiveQuestionnaire: Scalars['Boolean']['output'];
  inProgressAttemptId?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  totalAttempts: Scalars['Int']['output'];
};

export type CheckinEvent = {
  __typename?: 'CheckinEvent';
  app: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datetime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  ipAddress: Scalars['String']['output'];
  platform: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  tripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userAgent: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type CheckinEventActivityConnection = {
  __typename?: 'CheckinEventActivityConnection';
  edges?: Maybe<Array<Maybe<CheckinEventActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CheckinEventActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CheckinEventActivityEdge = {
  __typename?: 'CheckinEventActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CheckinEventConnection = {
  __typename?: 'CheckinEventConnection';
  edges?: Maybe<Array<Maybe<CheckinEventEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CheckinEventConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CheckinEventMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CheckinEventSearch>>;
};

export type CheckinEventEdge = {
  __typename?: 'CheckinEventEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CheckinEvent>;
};

export type CheckinEventMaskInput = {
  app?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  datetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  ipAddress?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Scalars['Boolean']['input']>;
  sessionId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userAgent?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CheckinEventSearch = {
  app?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  datetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  ipAddress?: InputMaybe<Array<StringSearch>>;
  platform?: InputMaybe<Array<StringSearch>>;
  sessionId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userAgent?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export enum ClientSummaryReportGroupByListItem {
  GroupByCity = 'GROUP_BY_CITY',
  GroupByClient = 'GROUP_BY_CLIENT',
  GroupByDay = 'GROUP_BY_DAY',
  GroupByMonth = 'GROUP_BY_MONTH',
  GroupByQuarter = 'GROUP_BY_QUARTER',
  GroupByWeek = 'GROUP_BY_WEEK',
  GroupByYear = 'GROUP_BY_YEAR'
}

export type ClosestRateItem = {
  __typename?: 'ClosestRateItem';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: ClosestRateItemCurrencyEnum;
  endDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  rateGroupId: Scalars['String']['output'];
  rn: Scalars['String']['output'];
  startDatetime: Scalars['String']['output'];
  type: ClosestRateItemTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ClosestRateItemActivityConnection = {
  __typename?: 'ClosestRateItemActivityConnection';
  edges?: Maybe<Array<Maybe<ClosestRateItemActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClosestRateItemActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ClosestRateItemActivityEdge = {
  __typename?: 'ClosestRateItemActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ClosestRateItemConnection = {
  __typename?: 'ClosestRateItemConnection';
  edges?: Maybe<Array<Maybe<ClosestRateItemEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ClosestRateItemConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ClosestRateItemMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ClosestRateItemSearch>>;
};

export enum ClosestRateItemCurrencyEnum {
  Usd = 'USD'
}

export type ClosestRateItemCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ClosestRateItemCurrencyEnum>;
};

export type ClosestRateItemEdge = {
  __typename?: 'ClosestRateItemEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ClosestRateItem>;
};

export type ClosestRateItemMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  rateGroupId?: InputMaybe<Scalars['Boolean']['input']>;
  rn?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ClosestRateItemSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  currency?: InputMaybe<Array<ClosestRateItemCurrencyEnumSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  rateGroupId?: InputMaybe<Array<StringSearch>>;
  rn?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<ClosestRateItemTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum ClosestRateItemTypeEnum {
  Contract = 'CONTRACT',
  NonContract = 'NON_CONTRACT'
}

export type ClosestRateItemTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ClosestRateItemTypeEnum>;
};

export type ColumnObject = {
  key: Scalars['String']['input'];
};

export type ColumnObjectFilter = {
  __typename?: 'ColumnObjectFilter';
  key: Scalars['String']['output'];
};

export type CombinableTripEdge = {
  __typename?: 'CombinableTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Trip>;
};

export type CombineRule = {
  __typename?: 'CombineRule';
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<User>;
  discount?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  illegalCombine: CombineRuleIllegalCombineEnum;
  pickupWindow: Scalars['Int']['output'];
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['String']['output']>;
  turnaroundThreshold: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CombineRuleActivityConnection = {
  __typename?: 'CombineRuleActivityConnection';
  edges?: Maybe<Array<Maybe<CombineRuleActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CombineRuleActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CombineRuleActivityEdge = {
  __typename?: 'CombineRuleActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CombineRuleConnection = {
  __typename?: 'CombineRuleConnection';
  edges?: Maybe<Array<Maybe<CombineRuleEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CombineRuleConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CombineRuleMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CombineRuleSearch>>;
};

export type CombineRuleEdge = {
  __typename?: 'CombineRuleEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CombineRule>;
};

export type CombineRuleHistory = {
  __typename?: 'CombineRuleHistory';
  combineRuleId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  discount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  startDatetime: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CombineRuleHistoryActivityConnection = {
  __typename?: 'CombineRuleHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<CombineRuleHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CombineRuleHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CombineRuleHistoryActivityEdge = {
  __typename?: 'CombineRuleHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CombineRuleHistoryConnection = {
  __typename?: 'CombineRuleHistoryConnection';
  edges?: Maybe<Array<Maybe<CombineRuleHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CombineRuleHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CombineRuleHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CombineRuleHistorySearch>>;
};

export type CombineRuleHistoryEdge = {
  __typename?: 'CombineRuleHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CombineRuleHistory>;
};

export type CombineRuleHistoryMaskInput = {
  combineRuleId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  discount?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CombineRuleHistorySearch = {
  combineRuleId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  discount?: InputMaybe<Array<FloatSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type CombineRuleHistoryWithContract = {
  __typename?: 'CombineRuleHistoryWithContract';
  combineRuleId: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  discount: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  startDatetime: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CombineRuleHistoryWithContractActivityConnection = {
  __typename?: 'CombineRuleHistoryWithContractActivityConnection';
  edges?: Maybe<Array<Maybe<CombineRuleHistoryWithContractActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CombineRuleHistoryWithContractActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CombineRuleHistoryWithContractActivityEdge = {
  __typename?: 'CombineRuleHistoryWithContractActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CombineRuleHistoryWithContractConnection = {
  __typename?: 'CombineRuleHistoryWithContractConnection';
  edges?: Maybe<Array<Maybe<CombineRuleHistoryWithContractEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CombineRuleHistoryWithContractConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CombineRuleHistoryWithContractMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CombineRuleHistoryWithContractSearch>>;
};

export type CombineRuleHistoryWithContractEdge = {
  __typename?: 'CombineRuleHistoryWithContractEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CombineRuleHistoryWithContract>;
};

export type CombineRuleHistoryWithContractMaskInput = {
  combineRuleId?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  discount?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CombineRuleHistoryWithContractSearch = {
  combineRuleId?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  discount?: InputMaybe<Array<FloatSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum CombineRuleIllegalCombineEnum {
  Block = 'BLOCK',
  None = 'NONE',
  Warning = 'WARNING'
}

export type CombineRuleIllegalCombineEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<CombineRuleIllegalCombineEnum>;
};

export type CombineRuleMaskInput = {
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  discount?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  illegalCombine?: InputMaybe<Scalars['Boolean']['input']>;
  pickupWindow?: InputMaybe<Scalars['Boolean']['input']>;
  turnaroundThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CombineRuleSearch = {
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  discount?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  illegalCombine?: InputMaybe<Array<CombineRuleIllegalCombineEnumSearch>>;
  pickupWindow?: InputMaybe<Array<IntSearch>>;
  turnaroundThreshold?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type CombineRuleWithCombineRuleHistoryInput = {
  combineRule: CreateCombineRuleInput;
  combineRuleHistoryList?: InputMaybe<Array<CreateCombineRuleHistoryForBulkInput>>;
};

export type CombineRuleWithCombineRuleHistoryOutput = {
  __typename?: 'CombineRuleWithCombineRuleHistoryOutput';
  combineRule: CombineRule;
  combineRuleHistoryList: Array<CombineRuleHistory>;
};

export type CombineRuleWithContract = {
  __typename?: 'CombineRuleWithContract';
  companyId: Scalars['String']['output'];
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  discount?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  illegalCombine: CombineRuleWithContractIllegalCombineEnum;
  pickupWindow: Scalars['Int']['output'];
  providerId: Scalars['String']['output'];
  turnaroundThreshold: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CombineRuleWithContractActivityConnection = {
  __typename?: 'CombineRuleWithContractActivityConnection';
  edges?: Maybe<Array<Maybe<CombineRuleWithContractActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CombineRuleWithContractActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CombineRuleWithContractActivityEdge = {
  __typename?: 'CombineRuleWithContractActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CombineRuleWithContractConnection = {
  __typename?: 'CombineRuleWithContractConnection';
  edges?: Maybe<Array<Maybe<CombineRuleWithContractEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CombineRuleWithContractConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CombineRuleWithContractMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CombineRuleWithContractSearch>>;
};

export type CombineRuleWithContractEdge = {
  __typename?: 'CombineRuleWithContractEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CombineRuleWithContract>;
};

export enum CombineRuleWithContractIllegalCombineEnum {
  Block = 'BLOCK',
  None = 'NONE',
  Warning = 'WARNING'
}

export type CombineRuleWithContractIllegalCombineEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<CombineRuleWithContractIllegalCombineEnum>;
};

export type CombineRuleWithContractMaskInput = {
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  discount?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  illegalCombine?: InputMaybe<Scalars['Boolean']['input']>;
  pickupWindow?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  turnaroundThreshold?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CombineRuleWithContractSearch = {
  companyId?: InputMaybe<Array<StringSearch>>;
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  discount?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  illegalCombine?: InputMaybe<Array<CombineRuleWithContractIllegalCombineEnumSearch>>;
  pickupWindow?: InputMaybe<Array<IntSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  turnaroundThreshold?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type CombineTripInput = {
  combineType: TripCombineTypeEnum;
  tripIds: Array<Scalars['String']['input']>;
};

export type Communication = Node & {
  __typename?: 'Communication';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<User>;
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  tripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CommunicationActivityConnection = {
  __typename?: 'CommunicationActivityConnection';
  edges?: Maybe<Array<Maybe<CommunicationActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CommunicationActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CommunicationActivityEdge = {
  __typename?: 'CommunicationActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CommunicationConnection = {
  __typename?: 'CommunicationConnection';
  edges?: Maybe<Array<Maybe<CommunicationEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CommunicationConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CommunicationMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CommunicationSearch>>;
};

export type CommunicationEdge = {
  __typename?: 'CommunicationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Communication>;
};

export type CommunicationMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CommunicationSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  message?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type Company = {
  __typename?: 'Company';
  address?: Maybe<Scalars['String']['output']>;
  adminEmail?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dispatchPhone: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceEmail?: Maybe<Scalars['String']['output']>;
  invoiceFax?: Maybe<Scalars['String']['output']>;
  invoicePhone?: Maybe<Scalars['String']['output']>;
  logo?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  settingsId: Scalars['String']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type CompanyActivityConnection = {
  __typename?: 'CompanyActivityConnection';
  edges?: Maybe<Array<Maybe<CompanyActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CompanyActivityEdge = {
  __typename?: 'CompanyActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CompanyConnection = {
  __typename?: 'CompanyConnection';
  edges?: Maybe<Array<Maybe<CompanyEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompanyConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CompanyMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CompanySearch>>;
};

export type CompanyEdge = {
  __typename?: 'CompanyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Company>;
};

export type CompanyMaskInput = {
  address?: InputMaybe<Scalars['Boolean']['input']>;
  adminEmail?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  dispatchPhone?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceEmail?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceFax?: InputMaybe<Scalars['Boolean']['input']>;
  invoicePhone?: InputMaybe<Scalars['Boolean']['input']>;
  logo?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  settingsId?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompanySearch = {
  address?: InputMaybe<Array<StringSearch>>;
  adminEmail?: InputMaybe<Array<StringSearch>>;
  cityName?: InputMaybe<Array<StringSearch>>;
  countryCode?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  dispatchPhone?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  invoiceEmail?: InputMaybe<Array<StringSearch>>;
  invoiceFax?: InputMaybe<Array<StringSearch>>;
  invoicePhone?: InputMaybe<Array<StringSearch>>;
  logo?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  settingsId?: InputMaybe<Array<StringSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  website?: InputMaybe<Array<StringSearch>>;
  zipCode?: InputMaybe<Array<StringSearch>>;
};

export type CompleteDtrManifestImportInput = {
  locationMapping: Array<LocationMapping>;
  manifestImportId: Scalars['ID']['input'];
  tripIds: Array<Scalars['ID']['input']>;
};

export type CompleteDtrManifestImportResponse = {
  __typename?: 'CompleteDtrManifestImportResponse';
  manifestHistoryId: Scalars['ID']['output'];
};

export type Completion = {
  __typename?: 'Completion';
  comment: Scalars['String']['output'];
  completionTypeId: Scalars['String']['output'];
  cost: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: CompletionCurrencyEnum;
  datetime: Scalars['String']['output'];
  distanceMeters: Scalars['Int']['output'];
  efficiency: Scalars['Float']['output'];
  equivalency: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CompletionActivityConnection = {
  __typename?: 'CompletionActivityConnection';
  edges?: Maybe<Array<Maybe<CompletionActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompletionActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CompletionActivityEdge = {
  __typename?: 'CompletionActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CompletionConnection = {
  __typename?: 'CompletionConnection';
  edges?: Maybe<Array<Maybe<CompletionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompletionConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CompletionMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CompletionSearch>>;
};

export enum CompletionCurrencyEnum {
  Usd = 'USD'
}

export type CompletionCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<CompletionCurrencyEnum>;
};

export type CompletionEdge = {
  __typename?: 'CompletionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Completion>;
};

export type CompletionMaskInput = {
  comment?: InputMaybe<Scalars['Boolean']['input']>;
  completionTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  cost?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  datetime?: InputMaybe<Scalars['Boolean']['input']>;
  distanceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  efficiency?: InputMaybe<Scalars['Boolean']['input']>;
  equivalency?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompletionSearch = {
  comment?: InputMaybe<Array<StringSearch>>;
  completionTypeId?: InputMaybe<Array<StringSearch>>;
  cost?: InputMaybe<Array<FloatSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  currency?: InputMaybe<Array<CompletionCurrencyEnumSearch>>;
  datetime?: InputMaybe<Array<StringSearch>>;
  distanceMeters?: InputMaybe<Array<IntSearch>>;
  efficiency?: InputMaybe<Array<FloatSearch>>;
  equivalency?: InputMaybe<Array<FloatSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum CompletionStatusEnum {
  Isnotnull = 'ISNOTNULL',
  Isnull = 'ISNULL',
  Or = 'OR'
}

export type CompletionType = {
  __typename?: 'CompletionType';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CompletionTypeActivityConnection = {
  __typename?: 'CompletionTypeActivityConnection';
  edges?: Maybe<Array<Maybe<CompletionTypeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompletionTypeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CompletionTypeActivityEdge = {
  __typename?: 'CompletionTypeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CompletionTypeConnection = {
  __typename?: 'CompletionTypeConnection';
  edges?: Maybe<Array<Maybe<CompletionTypeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompletionTypeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CompletionTypeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CompletionTypeSearch>>;
};

export type CompletionTypeEdge = {
  __typename?: 'CompletionTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompletionType>;
};

export type CompletionTypeMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompletionTypeSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type CompletionWithType = {
  __typename?: 'CompletionWithType';
  comment: Scalars['String']['output'];
  completionTypeId: Scalars['String']['output'];
  cost: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: CompletionWithTypeCurrencyEnum;
  datetime: Scalars['String']['output'];
  distanceMeters: Scalars['Int']['output'];
  efficiency: Scalars['Float']['output'];
  equivalency: Scalars['Float']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CompletionWithTypeActivityConnection = {
  __typename?: 'CompletionWithTypeActivityConnection';
  edges?: Maybe<Array<Maybe<CompletionWithTypeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompletionWithTypeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CompletionWithTypeActivityEdge = {
  __typename?: 'CompletionWithTypeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CompletionWithTypeConnection = {
  __typename?: 'CompletionWithTypeConnection';
  edges?: Maybe<Array<Maybe<CompletionWithTypeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CompletionWithTypeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CompletionWithTypeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CompletionWithTypeSearch>>;
};

export enum CompletionWithTypeCurrencyEnum {
  Usd = 'USD'
}

export type CompletionWithTypeCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<CompletionWithTypeCurrencyEnum>;
};

export type CompletionWithTypeEdge = {
  __typename?: 'CompletionWithTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CompletionWithType>;
};

export type CompletionWithTypeMaskInput = {
  comment?: InputMaybe<Scalars['Boolean']['input']>;
  completionTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  cost?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  datetime?: InputMaybe<Scalars['Boolean']['input']>;
  distanceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  efficiency?: InputMaybe<Scalars['Boolean']['input']>;
  equivalency?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CompletionWithTypeSearch = {
  comment?: InputMaybe<Array<StringSearch>>;
  completionTypeId?: InputMaybe<Array<StringSearch>>;
  cost?: InputMaybe<Array<FloatSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  currency?: InputMaybe<Array<CompletionWithTypeCurrencyEnumSearch>>;
  datetime?: InputMaybe<Array<StringSearch>>;
  distanceMeters?: InputMaybe<Array<IntSearch>>;
  efficiency?: InputMaybe<Array<FloatSearch>>;
  equivalency?: InputMaybe<Array<FloatSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type Contract = {
  __typename?: 'Contract';
  active: Scalars['Int']['output'];
  allowCombines: Scalars['Int']['output'];
  allowCrewCreateTrip: Scalars['Int']['output'];
  automateAddons: Scalars['Int']['output'];
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  enableBufferTime: Scalars['Int']['output'];
  enableSocialDistancing: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  invoiceTermId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ContractActivityConnection = {
  __typename?: 'ContractActivityConnection';
  edges?: Maybe<Array<Maybe<ContractActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContractActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ContractActivityEdge = {
  __typename?: 'ContractActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ContractConnection = {
  __typename?: 'ContractConnection';
  edges?: Maybe<Array<Maybe<ContractEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContractConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ContractMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ContractSearch>>;
};

export type ContractEdge = {
  __typename?: 'ContractEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Contract>;
};

export type ContractEmail = {
  __typename?: 'ContractEmail';
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: ContractEmailTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ContractEmailActivityConnection = {
  __typename?: 'ContractEmailActivityConnection';
  edges?: Maybe<Array<Maybe<ContractEmailActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContractEmailActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ContractEmailActivityEdge = {
  __typename?: 'ContractEmailActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ContractEmailConnection = {
  __typename?: 'ContractEmailConnection';
  edges?: Maybe<Array<Maybe<ContractEmailEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContractEmailConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ContractEmailMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ContractEmailSearch>>;
};

export type ContractEmailEdge = {
  __typename?: 'ContractEmailEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ContractEmail>;
};

export type ContractEmailMaskInput = {
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractEmailSearch = {
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  email?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<ContractEmailTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum ContractEmailTypeEnum {
  Other = 'OTHER'
}

export type ContractEmailTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ContractEmailTypeEnum>;
};

export type ContractMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowCombines?: InputMaybe<Scalars['Boolean']['input']>;
  allowCrewCreateTrip?: InputMaybe<Scalars['Boolean']['input']>;
  automateAddons?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  enableBufferTime?: InputMaybe<Scalars['Boolean']['input']>;
  enableSocialDistancing?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceTermId?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractNumber = {
  __typename?: 'ContractNumber';
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  type: ContractNumberTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ContractNumberActivityConnection = {
  __typename?: 'ContractNumberActivityConnection';
  edges?: Maybe<Array<Maybe<ContractNumberActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContractNumberActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ContractNumberActivityEdge = {
  __typename?: 'ContractNumberActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ContractNumberConnection = {
  __typename?: 'ContractNumberConnection';
  edges?: Maybe<Array<Maybe<ContractNumberEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ContractNumberConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ContractNumberMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ContractNumberSearch>>;
};

export type ContractNumberEdge = {
  __typename?: 'ContractNumberEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ContractNumber>;
};

export type ContractNumberMaskInput = {
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ContractNumberSearch = {
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  email?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<ContractNumberTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum ContractNumberTypeEnum {
  Other = 'OTHER'
}

export type ContractNumberTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ContractNumberTypeEnum>;
};

export type ContractSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  allowCombines?: InputMaybe<Array<IntSearch>>;
  allowCrewCreateTrip?: InputMaybe<Array<IntSearch>>;
  automateAddons?: InputMaybe<Array<IntSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  enableBufferTime?: InputMaybe<Array<IntSearch>>;
  enableSocialDistancing?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  invoiceTermId?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type CountryRegion = {
  __typename?: 'CountryRegion';
  active: Scalars['Int']['output'];
  country: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  stateAbbrev?: Maybe<Scalars['String']['output']>;
  stateProvince: Scalars['String']['output'];
};

export type CountryRegionActivityConnection = {
  __typename?: 'CountryRegionActivityConnection';
  edges?: Maybe<Array<Maybe<CountryRegionActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryRegionActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CountryRegionActivityEdge = {
  __typename?: 'CountryRegionActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CountryRegionConnection = {
  __typename?: 'CountryRegionConnection';
  edges?: Maybe<Array<Maybe<CountryRegionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CountryRegionConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CountryRegionMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CountryRegionSearch>>;
};

export type CountryRegionEdge = {
  __typename?: 'CountryRegionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CountryRegion>;
};

export type CountryRegionMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  country?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  stateAbbrev?: InputMaybe<Scalars['Boolean']['input']>;
  stateProvince?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CountryRegionSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  country?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  stateAbbrev?: InputMaybe<Array<StringSearch>>;
  stateProvince?: InputMaybe<Array<StringSearch>>;
};

export type CreateAccidentIssueBulkInput = {
  values: Array<CreateAccidentIssueInput>;
};

export type CreateAccidentIssueBulkResponse = {
  __typename?: 'CreateAccidentIssueBulkResponse';
  output: Array<CreateAccidentIssueResponse>;
};

export type CreateAccidentIssueDocumentBulkInput = {
  values: Array<CreateAccidentIssueDocumentInput>;
};

export type CreateAccidentIssueDocumentBulkResponse = {
  __typename?: 'CreateAccidentIssueDocumentBulkResponse';
  output: Array<CreateAccidentIssueDocumentResponse>;
};

export type CreateAccidentIssueDocumentInput = {
  contentType: Scalars['String']['input'];
  fileLocation: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  issueId: Scalars['String']['input'];
  md5: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAccidentIssueDocumentResponse = {
  __typename?: 'CreateAccidentIssueDocumentResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AccidentIssueDocument;
};

export type CreateAccidentIssueInput = {
  accidentDatetime: Scalars['String']['input'];
  additionalDriverScheduled?: InputMaybe<Scalars['Int']['input']>;
  anyoneInjured: AccidentIssueAnyoneInjuredEnum;
  canVehicleBeDriven: AccidentIssueCanVehicleBeDrivenEnum;
  damageToOtherVehicles?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  didDriverCallHelp: AccidentIssueDidDriverCallHelpEnum;
  dispatcherContactedManager?: InputMaybe<Scalars['Int']['input']>;
  dispatcherId: Scalars['String']['input'];
  documents?: InputMaybe<Array<CreateAccidentIssueDocumentInput>>;
  driverContactedManager?: InputMaybe<Scalars['Int']['input']>;
  driverId: Scalars['String']['input'];
  infoOfCrewMembers?: InputMaybe<Scalars['String']['input']>;
  infoOfInjuredParties?: InputMaybe<Scalars['String']['input']>;
  medicalNeeded: AccidentIssueMedicalNeededEnum;
  outboundDatetime?: InputMaybe<Scalars['String']['input']>;
  outboundFlightName?: InputMaybe<Scalars['String']['input']>;
  outboundFlightNumber?: InputMaybe<Scalars['Int']['input']>;
  safetyId: Scalars['String']['input'];
  safetyNotified: AccidentIssueSafetyNotifiedEnum;
  samsaraCameraWorking?: InputMaybe<AccidentIssueSamsaraCameraWorkingEnum>;
  specificLocation: Scalars['String']['input'];
  stationText: Scalars['String']['input'];
  thirdPartyInformation?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Scalars['String']['input']>;
  typeOfMedicalAttention?: InputMaybe<Scalars['String']['input']>;
  vehicleId: Scalars['String']['input'];
  wasCeoCalled: AccidentIssueWasCeoCalledEnum;
  wasCrewInvolved: AccidentIssueWasCrewInvolvedEnum;
  wasDriverAtFault: AccidentIssueWasDriverAtFaultEnum;
  wasThirdPartyInvolved: AccidentIssueWasThirdPartyInvolvedEnum;
};

export type CreateAccidentIssueResponse = {
  __typename?: 'CreateAccidentIssueResponse';
  error?: Maybe<Scalars['String']['output']>;
  output: AccidentIssueAndDocument;
};

export type CreateActivityBulkInput = {
  values: Array<CreateActivityInput>;
};

export type CreateActivityBulkResponse = {
  __typename?: 'CreateActivityBulkResponse';
  output: Array<CreateActivityResponse>;
};

export type CreateActivityInput = {
  field?: InputMaybe<Scalars['String']['input']>;
  formerObjectId?: InputMaybe<Scalars['String']['input']>;
  formerValue?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  objectId?: InputMaybe<Scalars['String']['input']>;
  sourceId?: InputMaybe<Scalars['String']['input']>;
  subjectId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
  type: ActivityTypeEnum;
  value?: InputMaybe<Scalars['String']['input']>;
  via?: InputMaybe<Scalars['String']['input']>;
};

export type CreateActivityObjectBulkInput = {
  values: Array<CreateActivityObjectInput>;
};

export type CreateActivityObjectBulkResponse = {
  __typename?: 'CreateActivityObjectBulkResponse';
  output: Array<CreateActivityObjectResponse>;
};

export type CreateActivityObjectInput = {
  name: Scalars['String']['input'];
  type: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateActivityObjectResponse = {
  __typename?: 'CreateActivityObjectResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ActivityObject;
};

export type CreateActivityResponse = {
  __typename?: 'CreateActivityResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Activity;
};

export type CreateAirportBulkInput = {
  values: Array<CreateAirportInput>;
};

export type CreateAirportBulkResponse = {
  __typename?: 'CreateAirportBulkResponse';
  output: Array<CreateAirportResponse>;
};

export type CreateAirportGroupBulkInput = {
  values: Array<CreateAirportGroupInput>;
};

export type CreateAirportGroupBulkResponse = {
  __typename?: 'CreateAirportGroupBulkResponse';
  output: Array<CreateAirportGroupResponse>;
};

export type CreateAirportGroupInput = {
  companyId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateAirportGroupResponse = {
  __typename?: 'CreateAirportGroupResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AirportGroup;
};

export type CreateAirportHasCompanyBulkInput = {
  values: Array<CreateAirportHasCompanyInput>;
};

export type CreateAirportHasCompanyBulkResponse = {
  __typename?: 'CreateAirportHasCompanyBulkResponse';
  output: Array<CreateAirportHasCompanyResponse>;
};

export type CreateAirportHasCompanyInput = {
  airportCode: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};

export type CreateAirportHasCompanyResponse = {
  __typename?: 'CreateAirportHasCompanyResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AirportHasCompany;
};

export type CreateAirportHasGroupBulkInput = {
  values: Array<CreateAirportHasGroupInput>;
};

export type CreateAirportHasGroupBulkResponse = {
  __typename?: 'CreateAirportHasGroupBulkResponse';
  output: Array<CreateAirportHasGroupResponse>;
};

export type CreateAirportHasGroupInput = {
  airportCode: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
};

export type CreateAirportHasGroupResponse = {
  __typename?: 'CreateAirportHasGroupResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AirportHasGroup;
};

export type CreateAirportHasLocationBulkInput = {
  values: Array<CreateAirportHasLocationInput>;
};

export type CreateAirportHasLocationBulkResponse = {
  __typename?: 'CreateAirportHasLocationBulkResponse';
  output: Array<CreateAirportHasLocationResponse>;
};

export type CreateAirportHasLocationInput = {
  airportCode: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type CreateAirportHasLocationResponse = {
  __typename?: 'CreateAirportHasLocationResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AirportHasLocation;
};

export type CreateAirportHasManagerEmailBulkInput = {
  values: Array<CreateAirportHasManagerEmailInput>;
};

export type CreateAirportHasManagerEmailBulkResponse = {
  __typename?: 'CreateAirportHasManagerEmailBulkResponse';
  output: Array<CreateAirportHasManagerEmailResponse>;
};

export type CreateAirportHasManagerEmailInput = {
  airportCode: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
};

export type CreateAirportHasManagerEmailResponse = {
  __typename?: 'CreateAirportHasManagerEmailResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AirportHasManagerEmail;
};

export type CreateAirportHasRateBulkInput = {
  values: Array<CreateAirportHasRateInput>;
};

export type CreateAirportHasRateBulkResponse = {
  __typename?: 'CreateAirportHasRateBulkResponse';
  output: Array<CreateAirportHasRateResponse>;
};

export type CreateAirportHasRateInput = {
  airportCode: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
};

export type CreateAirportHasRateResponse = {
  __typename?: 'CreateAirportHasRateResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AirportHasRate;
};

export type CreateAirportHasVehicleBulkInput = {
  values: Array<CreateAirportHasVehicleInput>;
};

export type CreateAirportHasVehicleBulkResponse = {
  __typename?: 'CreateAirportHasVehicleBulkResponse';
  output: Array<CreateAirportHasVehicleResponse>;
};

export type CreateAirportHasVehicleInput = {
  airportCode: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type CreateAirportHasVehicleResponse = {
  __typename?: 'CreateAirportHasVehicleResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AirportHasVehicle;
};

export type CreateAirportInput = {
  cityCode: Scalars['String']['input'];
  cityName: Scalars['String']['input'];
  code: Scalars['String']['input'];
  country: Scalars['String']['input'];
  countryId: Scalars['String']['input'];
  elevation: Scalars['Int']['input'];
  icao: Scalars['String']['input'];
  location: PointInput;
  name: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
  url: Scalars['String']['input'];
};

export type CreateAirportResponse = {
  __typename?: 'CreateAirportResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Airport;
};

export type CreateAlertSubscriptionBulkInput = {
  values: Array<CreateAlertSubscriptionInput>;
};

export type CreateAlertSubscriptionBulkResponse = {
  __typename?: 'CreateAlertSubscriptionBulkResponse';
  output: Array<CreateAlertSubscriptionResponse>;
};

export type CreateAlertSubscriptionInput = {
  airportCode: Scalars['String']['input'];
  arrivalDate: Scalars['String']['input'];
  externalAlertId: Scalars['String']['input'];
  externalVendor: AlertSubscriptionExternalVendorEnum;
  flightNumber: Scalars['Int']['input'];
  raw: Scalars['String']['input'];
  servicerIataAirlineCode: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAlertSubscriptionResponse = {
  __typename?: 'CreateAlertSubscriptionResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AlertSubscription;
};

export type CreateAliasBulkInput = {
  values: Array<CreateAliasInput>;
};

export type CreateAliasBulkResponse = {
  __typename?: 'CreateAliasBulkResponse';
  output: Array<CreateAliasResponse>;
};

export type CreateAliasInput = {
  locationId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateAliasResponse = {
  __typename?: 'CreateAliasResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Alias;
};

export type CreateApiKeyBulkInput = {
  values: Array<CreateApiKeyInput>;
};

export type CreateApiKeyBulkResponse = {
  __typename?: 'CreateApiKeyBulkResponse';
  output: Array<CreateApiKeyResponse>;
};

export type CreateApiKeyInput = {
  expiresAt?: InputMaybe<Scalars['String']['input']>;
  keyHash: Scalars['String']['input'];
  keyHint?: InputMaybe<Scalars['String']['input']>;
  lastUsedAt?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CreateApiKeyResponse = {
  __typename?: 'CreateApiKeyResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ApiKey;
};

export type CreateAuditSnapshotBulkInput = {
  values: Array<CreateAuditSnapshotInput>;
};

export type CreateAuditSnapshotBulkResponse = {
  __typename?: 'CreateAuditSnapshotBulkResponse';
  output: Array<CreateAuditSnapshotResponse>;
};

export type CreateAuditSnapshotInput = {
  companyId: Scalars['String']['input'];
  data: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateAuditSnapshotResponse = {
  __typename?: 'CreateAuditSnapshotResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AuditSnapshot;
};

export type CreateAutoCombineRuleBulkInput = {
  values: Array<CreateAutoCombineRuleInput>;
};

export type CreateAutoCombineRuleBulkResponse = {
  __typename?: 'CreateAutoCombineRuleBulkResponse';
  output: Array<CreateAutoCombineRuleResponse>;
};

export type CreateAutoCombineRuleInput = {
  combineStrategy: AutoCombineRuleCombineStrategyEnum;
  considerVehicle: Scalars['Int']['input'];
  contractId: Scalars['String']['input'];
  importType?: InputMaybe<AutoCombineRuleImportTypeEnum>;
  kind: AutoCombineRuleKindEnum;
  maxCombine: Scalars['Int']['input'];
  maxCombineType: AutoCombineRuleMaxCombineTypeEnum;
  pickupWindow: Scalars['Int']['input'];
  updateScheduled: AutoCombineRuleUpdateScheduledEnum;
};

export type CreateAutoCombineRuleResponse = {
  __typename?: 'CreateAutoCombineRuleResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AutoCombineRule;
};

export type CreateAutomationHistoryAirportBulkInput = {
  values: Array<CreateAutomationHistoryAirportInput>;
};

export type CreateAutomationHistoryAirportBulkResponse = {
  __typename?: 'CreateAutomationHistoryAirportBulkResponse';
  output: Array<CreateAutomationHistoryAirportResponse>;
};

export type CreateAutomationHistoryAirportInput = {
  airportCode: Scalars['String']['input'];
  automationHistoryId: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAutomationHistoryAirportResponse = {
  __typename?: 'CreateAutomationHistoryAirportResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AutomationHistoryAirport;
};

export type CreateAutomationHistoryBulkInput = {
  values: Array<CreateAutomationHistoryInput>;
};

export type CreateAutomationHistoryBulkResponse = {
  __typename?: 'CreateAutomationHistoryBulkResponse';
  output: Array<CreateAutomationHistoryResponse>;
};

export type CreateAutomationHistoryInput = {
  driverAssigmentFailedCount: Scalars['Int']['input'];
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  startDatetime: Scalars['String']['input'];
  status: AutomationHistoryStatusEnum;
  totalTripsProcessed: Scalars['Int']['input'];
  totalTripsToBeProcessed: Scalars['Int']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAutomationHistoryLogBulkInput = {
  values: Array<CreateAutomationHistoryLogInput>;
};

export type CreateAutomationHistoryLogBulkResponse = {
  __typename?: 'CreateAutomationHistoryLogBulkResponse';
  output: Array<CreateAutomationHistoryLogResponse>;
};

export type CreateAutomationHistoryLogInput = {
  automationHistoryId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAutomationHistoryLogResponse = {
  __typename?: 'CreateAutomationHistoryLogResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AutomationHistoryLog;
};

export type CreateAutomationHistoryResponse = {
  __typename?: 'CreateAutomationHistoryResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AutomationHistory;
};

export type CreateAutomationReportBulkInput = {
  values: Array<CreateAutomationReportInput>;
};

export type CreateAutomationReportBulkResponse = {
  __typename?: 'CreateAutomationReportBulkResponse';
  output: Array<CreateAutomationReportResponse>;
};

export type CreateAutomationReportInput = {
  automatedTrips: Scalars['Int']['input'];
  automationHistoryId: Scalars['String']['input'];
  changedTrips: Scalars['Int']['input'];
  cutoffAt: Scalars['String']['input'];
  manualTrips: Scalars['Int']['input'];
  timeSavedSeconds: Scalars['Int']['input'];
  totalTrips: Scalars['Int']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
  unchangedTrips: Scalars['Int']['input'];
};

export type CreateAutomationReportResponse = {
  __typename?: 'CreateAutomationReportResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AutomationReport;
};

export type CreateAutomationTripAssignmentReasonBulkInput = {
  values: Array<CreateAutomationTripAssignmentReasonInput>;
};

export type CreateAutomationTripAssignmentReasonBulkResponse = {
  __typename?: 'CreateAutomationTripAssignmentReasonBulkResponse';
  output: Array<CreateAutomationTripAssignmentReasonResponse>;
};

export type CreateAutomationTripAssignmentReasonInput = {
  automationTripId: Scalars['String']['input'];
  code: Scalars['String']['input'];
  displayMessage: Scalars['String']['input'];
  errorMessage: Scalars['String']['input'];
  title: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAutomationTripAssignmentReasonResponse = {
  __typename?: 'CreateAutomationTripAssignmentReasonResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AutomationTripAssignmentReason;
};

export type CreateAutomationTripBulkInput = {
  values: Array<CreateAutomationTripInput>;
};

export type CreateAutomationTripBulkResponse = {
  __typename?: 'CreateAutomationTripBulkResponse';
  output: Array<CreateAutomationTripResponse>;
};

export type CreateAutomationTripInput = {
  airportCode: Scalars['String']['input'];
  attendants: Scalars['Int']['input'];
  automationHistoryId: Scalars['String']['input'];
  cachedDoLocationId?: InputMaybe<Scalars['String']['input']>;
  cachedPayerProviderId?: InputMaybe<Scalars['String']['input']>;
  cachedPuLocationId?: InputMaybe<Scalars['String']['input']>;
  combineId?: InputMaybe<Scalars['String']['input']>;
  doLocationCoordinates?: InputMaybe<PointInput>;
  doLocationName?: InputMaybe<Scalars['String']['input']>;
  driverAtCutoffFullName?: InputMaybe<Scalars['String']['input']>;
  driverAtCutoffId?: InputMaybe<Scalars['String']['input']>;
  driverFirstName?: InputMaybe<Scalars['String']['input']>;
  driverFullName?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  driverLastName?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['Int']['input']>;
  kind: AutomationTripKindEnum;
  loopName?: InputMaybe<Scalars['String']['input']>;
  newDriverFullName?: InputMaybe<Scalars['String']['input']>;
  newDriverId?: InputMaybe<Scalars['String']['input']>;
  offset: Scalars['String']['input'];
  payerProviderDisplayName?: InputMaybe<Scalars['String']['input']>;
  pilots: Scalars['Int']['input'];
  puGpsDatetime?: InputMaybe<Scalars['String']['input']>;
  puLocationCoordinates?: InputMaybe<PointInput>;
  puLocationName?: InputMaybe<Scalars['String']['input']>;
  scheduled: Scalars['String']['input'];
  servicerIataAirlineCode: Scalars['String']['input'];
  status: AutomationTripStatusEnum;
  traceId?: InputMaybe<Scalars['String']['input']>;
  tripId: Scalars['String']['input'];
  type: AutomationTripTypeEnum;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
  vehicleTrackingId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAutomationTripLogBulkInput = {
  values: Array<CreateAutomationTripLogInput>;
};

export type CreateAutomationTripLogBulkResponse = {
  __typename?: 'CreateAutomationTripLogBulkResponse';
  output: Array<CreateAutomationTripLogResponse>;
};

export type CreateAutomationTripLogInput = {
  automationTripId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateAutomationTripLogResponse = {
  __typename?: 'CreateAutomationTripLogResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AutomationTripLog;
};

export type CreateAutomationTripResponse = {
  __typename?: 'CreateAutomationTripResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: AutomationTrip;
};

export type CreateBufferTimeBulkInput = {
  values: Array<CreateBufferTimeInput>;
};

export type CreateBufferTimeBulkResponse = {
  __typename?: 'CreateBufferTimeBulkResponse';
  output: Array<CreateBufferTimeResponse>;
};

export type CreateBufferTimeInput = {
  active: Scalars['Int']['input'];
  airportCode: Scalars['String']['input'];
  bufferMinutes: Scalars['Int']['input'];
  contractId: Scalars['String']['input'];
  endLocationId?: InputMaybe<Scalars['String']['input']>;
  endTime: Scalars['String']['input'];
  startLocationId: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
};

export type CreateBufferTimeResponse = {
  __typename?: 'CreateBufferTimeResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: BufferTime;
};

export type CreateBufferTimesInput = {
  bufferTimes: Array<BufferTimeInput>;
};

export type CreateBufferTimesResponse = {
  __typename?: 'CreateBufferTimesResponse';
  bufferTimes?: Maybe<Array<Maybe<BufferTimeResponse>>>;
};

export type CreateCancellationRuleBulkInput = {
  values: Array<CreateCancellationRuleInput>;
};

export type CreateCancellationRuleBulkResponse = {
  __typename?: 'CreateCancellationRuleBulkResponse';
  output: Array<CreateCancellationRuleResponse>;
};

export type CreateCancellationRuleInput = {
  airportCode: Scalars['String']['input'];
  endLocationId: Scalars['String']['input'];
  from: Scalars['Int']['input'];
  percentage: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
  startLocationId: Scalars['String']['input'];
  to: Scalars['Int']['input'];
};

export type CreateCancellationRuleResponse = {
  __typename?: 'CreateCancellationRuleResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: CancellationRule;
};

export type CreateCharityAmountHistoryBulkInput = {
  values: Array<CreateCharityAmountHistoryInput>;
};

export type CreateCharityAmountHistoryBulkResponse = {
  __typename?: 'CreateCharityAmountHistoryBulkResponse';
  output: Array<CreateCharityAmountHistoryResponse>;
};

export type CreateCharityAmountHistoryInput = {
  amount: Scalars['Float']['input'];
  charityId: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCharityAmountHistoryResponse = {
  __typename?: 'CreateCharityAmountHistoryResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: CharityAmountHistory;
};

export type CreateCharityBulkInput = {
  values: Array<CreateCharityInput>;
};

export type CreateCharityBulkResponse = {
  __typename?: 'CreateCharityBulkResponse';
  output: Array<CreateCharityResponse>;
};

export type CreateCharityInput = {
  active: Scalars['Int']['input'];
  crewFindDriverBannerDisplayMessage?: InputMaybe<Scalars['String']['input']>;
  crewRateDriverTooltipDisplayMessage?: InputMaybe<Scalars['String']['input']>;
  crewTripCompleteBannerDisplayMessage?: InputMaybe<Scalars['String']['input']>;
  driverLoginBannerDisplayMessage?: InputMaybe<Scalars['String']['input']>;
  logoUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  totalGoalAmount: Scalars['Float']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCharityRatingHistoryBulkInput = {
  values: Array<CreateCharityRatingHistoryInput>;
};

export type CreateCharityRatingHistoryBulkResponse = {
  __typename?: 'CreateCharityRatingHistoryBulkResponse';
  output: Array<CreateCharityRatingHistoryResponse>;
};

export type CreateCharityRatingHistoryInput = {
  airportCode: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  charityId: Scalars['String']['input'];
  providerDisplayName?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
  ratingId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCharityRatingHistoryReportBulkInput = {
  values: Array<CreateCharityRatingHistoryReportInput>;
};

export type CreateCharityRatingHistoryReportBulkResponse = {
  __typename?: 'CreateCharityRatingHistoryReportBulkResponse';
  output: Array<CreateCharityRatingHistoryReportResponse>;
};

export type CreateCharityRatingHistoryReportInput = {
  airportCode: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  avatar?: InputMaybe<Scalars['String']['input']>;
  charityId: Scalars['String']['input'];
  charityName?: InputMaybe<Scalars['String']['input']>;
  providerDisplayName?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
  rating: Scalars['Int']['input'];
  ratingId: Scalars['String']['input'];
  userFirstName?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  userLastName?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCharityRatingHistoryReportResponse = {
  __typename?: 'CreateCharityRatingHistoryReportResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: CharityRatingHistoryReport;
};

export type CreateCharityRatingHistoryResponse = {
  __typename?: 'CreateCharityRatingHistoryResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: CharityRatingHistory;
};

export type CreateCharityResponse = {
  __typename?: 'CreateCharityResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Charity;
};

export type CreateChatQuickReplyMessageBulkInput = {
  values: Array<CreateChatQuickReplyMessageInput>;
};

export type CreateChatQuickReplyMessageBulkResponse = {
  __typename?: 'CreateChatQuickReplyMessageBulkResponse';
  output: Array<CreateChatQuickReplyMessageResponse>;
};

export type CreateChatQuickReplyMessageInput = {
  message: Scalars['String']['input'];
  name: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type CreateChatQuickReplyMessageResponse = {
  __typename?: 'CreateChatQuickReplyMessageResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ChatQuickReplyMessage;
};

export type CreateCheckinEventBulkInput = {
  values: Array<CreateCheckinEventInput>;
};

export type CreateCheckinEventBulkResponse = {
  __typename?: 'CreateCheckinEventBulkResponse';
  output: Array<CreateCheckinEventResponse>;
};

export type CreateCheckinEventInput = {
  app: Scalars['String']['input'];
  datetime: Scalars['String']['input'];
  ipAddress: Scalars['String']['input'];
  platform: Scalars['String']['input'];
  sessionId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateCheckinEventResponse = {
  __typename?: 'CreateCheckinEventResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: CheckinEvent;
};

export type CreateCombineRuleBulkInput = {
  values: Array<CreateCombineRuleInput>;
};

export type CreateCombineRuleBulkResponse = {
  __typename?: 'CreateCombineRuleBulkResponse';
  output: Array<CreateCombineRuleResponse>;
};

export type CreateCombineRuleHistoryBulkInput = {
  values: Array<CreateCombineRuleHistoryInput>;
};

export type CreateCombineRuleHistoryBulkResponse = {
  __typename?: 'CreateCombineRuleHistoryBulkResponse';
  output: Array<CreateCombineRuleHistoryResponse>;
};

export type CreateCombineRuleHistoryForBulkInput = {
  discount: Scalars['Float']['input'];
  startDatetime: Scalars['String']['input'];
};

export type CreateCombineRuleHistoryInput = {
  combineRuleId: Scalars['String']['input'];
  discount: Scalars['Float']['input'];
  startDatetime: Scalars['String']['input'];
};

export type CreateCombineRuleHistoryResponse = {
  __typename?: 'CreateCombineRuleHistoryResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: CombineRuleHistory;
};

export type CreateCombineRuleInput = {
  contractId: Scalars['String']['input'];
  discount?: InputMaybe<Scalars['String']['input']>;
  illegalCombine: CombineRuleIllegalCombineEnum;
  pickupWindow: Scalars['Int']['input'];
  turnaroundThreshold: Scalars['Int']['input'];
};

export type CreateCombineRuleResponse = {
  __typename?: 'CreateCombineRuleResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: CombineRule;
};

export type CreateCombineRuleWithCombineRuleHistoryBulkInput = {
  input: Array<CombineRuleWithCombineRuleHistoryInput>;
};

export type CreateCombineRuleWithCombineRuleHistoryBulkResponse = {
  __typename?: 'CreateCombineRuleWithCombineRuleHistoryBulkResponse';
  output: Array<CombineRuleWithCombineRuleHistoryOutput>;
};

export type CreateCombineTripInput = {
  combineType?: InputMaybe<TripCombineTypeEnum>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  tripIds: Array<Scalars['String']['input']>;
  values?: InputMaybe<UpdateTripValuesInput>;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCombineTripResponse = {
  __typename?: 'CreateCombineTripResponse';
  combineId?: Maybe<Scalars['String']['output']>;
  combineType?: Maybe<TripCombineTypeEnum>;
  error?: Maybe<Scalars['String']['output']>;
  updated: Scalars['Boolean']['output'];
};

export type CreateCommunicationBulkInput = {
  values: Array<CreateCommunicationInput>;
};

export type CreateCommunicationBulkResponse = {
  __typename?: 'CreateCommunicationBulkResponse';
  output: Array<CreateCommunicationResponse>;
};

export type CreateCommunicationInput = {
  message: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};

export type CreateCommunicationResponse = {
  __typename?: 'CreateCommunicationResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Communication;
};

export type CreateCompanyBulkInput = {
  values: Array<CreateCompanyInput>;
};

export type CreateCompanyBulkResponse = {
  __typename?: 'CreateCompanyBulkResponse';
  output: Array<CreateCompanyResponse>;
};

export type CreateCompanyInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  adminEmail?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  dispatchPhone: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  invoiceEmail?: InputMaybe<Scalars['String']['input']>;
  invoiceFax?: InputMaybe<Scalars['String']['input']>;
  invoicePhone?: InputMaybe<Scalars['String']['input']>;
  logo?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  settingsId: Scalars['String']['input'];
  stateCode?: InputMaybe<Scalars['String']['input']>;
  website?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCompanyResponse = {
  __typename?: 'CreateCompanyResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Company;
};

export type CreateCompletionBulkInput = {
  values: Array<CreateCompletionInput>;
};

export type CreateCompletionBulkResponse = {
  __typename?: 'CreateCompletionBulkResponse';
  output: Array<CreateCompletionResponse>;
};

export type CreateCompletionInput = {
  comment: Scalars['String']['input'];
  completionTypeId: Scalars['String']['input'];
  cost: Scalars['Float']['input'];
  currency: CompletionCurrencyEnum;
  datetime: Scalars['String']['input'];
  distanceMeters: Scalars['Int']['input'];
  efficiency: Scalars['Float']['input'];
  equivalency: Scalars['Float']['input'];
};

export type CreateCompletionResponse = {
  __typename?: 'CreateCompletionResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Completion;
};

export type CreateCompletionTypeBulkInput = {
  values: Array<CreateCompletionTypeInput>;
};

export type CreateCompletionTypeBulkResponse = {
  __typename?: 'CreateCompletionTypeBulkResponse';
  output: Array<CreateCompletionTypeResponse>;
};

export type CreateCompletionTypeInput = {
  name: Scalars['String']['input'];
};

export type CreateCompletionTypeResponse = {
  __typename?: 'CreateCompletionTypeResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: CompletionType;
};

export type CreateContractBulkInput = {
  values: Array<CreateContractInput>;
};

export type CreateContractBulkResponse = {
  __typename?: 'CreateContractBulkResponse';
  output: Array<CreateContractResponse>;
};

export type CreateContractEmailBulkInput = {
  values: Array<CreateContractEmailInput>;
};

export type CreateContractEmailBulkResponse = {
  __typename?: 'CreateContractEmailBulkResponse';
  output: Array<CreateContractEmailResponse>;
};

export type CreateContractEmailInput = {
  contractId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  type: ContractEmailTypeEnum;
};

export type CreateContractEmailResponse = {
  __typename?: 'CreateContractEmailResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ContractEmail;
};

export type CreateContractInput = {
  active: Scalars['Int']['input'];
  allowCombines: Scalars['Int']['input'];
  allowCrewCreateTrip: Scalars['Int']['input'];
  automateAddons: Scalars['Int']['input'];
  companyId: Scalars['String']['input'];
  enableBufferTime: Scalars['Int']['input'];
  enableSocialDistancing: Scalars['Int']['input'];
  invoiceTermId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};

export type CreateContractNumberBulkInput = {
  values: Array<CreateContractNumberInput>;
};

export type CreateContractNumberBulkResponse = {
  __typename?: 'CreateContractNumberBulkResponse';
  output: Array<CreateContractNumberResponse>;
};

export type CreateContractNumberInput = {
  contractId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  type: ContractNumberTypeEnum;
};

export type CreateContractNumberResponse = {
  __typename?: 'CreateContractNumberResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ContractNumber;
};

export type CreateContractResponse = {
  __typename?: 'CreateContractResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Contract;
};

export type CreateCountryRegionBulkInput = {
  values: Array<CreateCountryRegionInput>;
};

export type CreateCountryRegionBulkResponse = {
  __typename?: 'CreateCountryRegionBulkResponse';
  output: Array<CreateCountryRegionResponse>;
};

export type CreateCountryRegionInput = {
  active: Scalars['Int']['input'];
  country: Scalars['String']['input'];
  stateAbbrev?: InputMaybe<Scalars['String']['input']>;
  stateProvince: Scalars['String']['input'];
};

export type CreateCountryRegionResponse = {
  __typename?: 'CreateCountryRegionResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: CountryRegion;
};

export type CreateCrewCountRequirementBulkInput = {
  values: Array<CreateCrewCountRequirementInput>;
};

export type CreateCrewCountRequirementBulkResponse = {
  __typename?: 'CreateCrewCountRequirementBulkResponse';
  output: Array<CreateCrewCountRequirementResponse>;
};

export type CreateCrewCountRequirementInput = {
  airportCode?: InputMaybe<Scalars['String']['input']>;
  enabled: Scalars['Int']['input'];
  flightNumber?: InputMaybe<Scalars['String']['input']>;
  payerProviderId?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCrewCountRequirementResponse = {
  __typename?: 'CreateCrewCountRequirementResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: CrewCountRequirement;
};

export type CreateCrewTripInput = {
  input: CreateTripInput;
};

export type CreateCrewTripResponse = {
  __typename?: 'CreateCrewTripResponse';
  response: TripResponse;
};

export type CreateDashboardBulkInput = {
  values: Array<CreateDashboardInput>;
};

export type CreateDashboardBulkResponse = {
  __typename?: 'CreateDashboardBulkResponse';
  output: Array<CreateDashboardResponse>;
};

export type CreateDashboardInput = {
  name: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateDashboardResponse = {
  __typename?: 'CreateDashboardResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Dashboard;
};

export type CreateDefectBulkInput = {
  values: Array<CreateDefectInput>;
};

export type CreateDefectBulkResponse = {
  __typename?: 'CreateDefectBulkResponse';
  output: Array<CreateDefectResponse>;
};

export type CreateDefectInput = {
  comment: Scalars['String']['input'];
  dvirId: Scalars['String']['input'];
  externalCreatedAt?: InputMaybe<Scalars['String']['input']>;
  externalDefectId: Scalars['String']['input'];
  externalResolvedBy?: InputMaybe<Scalars['String']['input']>;
  isResolved: Scalars['Int']['input'];
  mechanicNotes?: InputMaybe<Scalars['String']['input']>;
  mechanicNotesUpdatedAt?: InputMaybe<Scalars['String']['input']>;
  resolvedAt?: InputMaybe<Scalars['String']['input']>;
  resolvedByUserName?: InputMaybe<Scalars['String']['input']>;
  resolvedByUserType?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
};

export type CreateDefectResponse = {
  __typename?: 'CreateDefectResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Defect;
};

export type CreateDeviceBulkInput = {
  values: Array<CreateDeviceInput>;
};

export type CreateDeviceBulkResponse = {
  __typename?: 'CreateDeviceBulkResponse';
  output: Array<CreateDeviceResponse>;
};

export type CreateDeviceInput = {
  active: Scalars['Int']['input'];
  appName?: InputMaybe<Scalars['String']['input']>;
  lastSeenAt?: InputMaybe<Scalars['String']['input']>;
  platform?: InputMaybe<Scalars['String']['input']>;
  token: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateDeviceMetricBulkInput = {
  values: Array<CreateDeviceMetricInput>;
};

export type CreateDeviceMetricBulkResponse = {
  __typename?: 'CreateDeviceMetricBulkResponse';
  output: Array<CreateDeviceMetricResponse>;
};

export type CreateDeviceMetricInput = {
  metricName: DeviceMetricMetricNameEnum;
  userId: Scalars['String']['input'];
};

export type CreateDeviceMetricResponse = {
  __typename?: 'CreateDeviceMetricResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: DeviceMetric;
};

export type CreateDeviceResponse = {
  __typename?: 'CreateDeviceResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Device;
};

export type CreateDispatchIssueBulkInput = {
  values: Array<CreateDispatchIssueInput>;
};

export type CreateDispatchIssueBulkResponse = {
  __typename?: 'CreateDispatchIssueBulkResponse';
  output: Array<CreateDispatchIssueResponse>;
};

export type CreateDispatchIssueCausedByBulkInput = {
  values: Array<CreateDispatchIssueCausedByInput>;
};

export type CreateDispatchIssueCausedByBulkResponse = {
  __typename?: 'CreateDispatchIssueCausedByBulkResponse';
  output: Array<CreateDispatchIssueCausedByResponse>;
};

export type CreateDispatchIssueCausedByInput = {
  causedById: Scalars['String']['input'];
  dispatchIssueId: Scalars['String']['input'];
};

export type CreateDispatchIssueCausedByResponse = {
  __typename?: 'CreateDispatchIssueCausedByResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: DispatchIssueCausedBy;
};

export type CreateDispatchIssueDocumentBulkInput = {
  values: Array<CreateDispatchIssueDocumentInput>;
};

export type CreateDispatchIssueDocumentBulkResponse = {
  __typename?: 'CreateDispatchIssueDocumentBulkResponse';
  output: Array<CreateDispatchIssueDocumentResponse>;
};

export type CreateDispatchIssueDocumentInput = {
  contentType: Scalars['String']['input'];
  fileLocation: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  issueId: Scalars['String']['input'];
  md5: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDispatchIssueDocumentResponse = {
  __typename?: 'CreateDispatchIssueDocumentResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: DispatchIssueDocument;
};

export type CreateDispatchIssueInput = {
  causedBy?: InputMaybe<Array<CreateDispatchIssueCausedByInput>>;
  crewMemberGiftCardCount?: InputMaybe<Scalars['Int']['input']>;
  crewMemberName?: InputMaybe<Scalars['String']['input']>;
  crewMemberPhone?: InputMaybe<Scalars['String']['input']>;
  datetime: Scalars['String']['input'];
  dispatcherId?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<CreateDispatchIssueDocumentInput>>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  driverPhone?: InputMaybe<Scalars['String']['input']>;
  flightIssueDescription: Scalars['String']['input'];
  flightLate: DispatchIssueFlightLateEnum;
  flightType?: InputMaybe<DispatchIssueFlightTypeEnum>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  outboundFlightInfo?: InputMaybe<Scalars['String']['input']>;
  pushTime?: InputMaybe<Scalars['String']['input']>;
  recoveryCompleted?: InputMaybe<DispatchIssueRecoveryCompletedEnum>;
  recoveryFlightDatetime?: InputMaybe<Scalars['String']['input']>;
  recoveryFlightName?: InputMaybe<Scalars['String']['input']>;
  recoveryFlightNumber?: InputMaybe<Scalars['Int']['input']>;
  recoveryNeeded: DispatchIssueRecoveryNeededEnum;
  rootCause: DispatchIssueRootCauseEnum;
  rootCauseDescription: Scalars['String']['input'];
  scheduledTime?: InputMaybe<Scalars['String']['input']>;
  station: Scalars['String']['input'];
  taxiCost?: InputMaybe<Scalars['Float']['input']>;
  taxiDetails?: InputMaybe<DispatchIssueTaxiDetailsEnum>;
  taxiUsed?: InputMaybe<DispatchIssueTaxiUsedEnum>;
  traceId?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Scalars['String']['input']>;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDispatchIssueResponse = {
  __typename?: 'CreateDispatchIssueResponse';
  error?: Maybe<Scalars['String']['output']>;
  output: DispatchIssueAndDocument;
};

export type CreateDispatchSummaryBulkInput = {
  values: Array<CreateDispatchSummaryInput>;
};

export type CreateDispatchSummaryBulkResponse = {
  __typename?: 'CreateDispatchSummaryBulkResponse';
  output: Array<CreateDispatchSummaryResponse>;
};

export type CreateDispatchSummaryDocumentBulkInput = {
  values: Array<CreateDispatchSummaryDocumentInput>;
};

export type CreateDispatchSummaryDocumentBulkResponse = {
  __typename?: 'CreateDispatchSummaryDocumentBulkResponse';
  output: Array<CreateDispatchSummaryDocumentResponse>;
};

export type CreateDispatchSummaryDocumentInput = {
  contentType: Scalars['String']['input'];
  fileLocation: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  md5: Scalars['String']['input'];
  summaryId: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDispatchSummaryDocumentResponse = {
  __typename?: 'CreateDispatchSummaryDocumentResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: DispatchSummaryDocument;
};

export type CreateDispatchSummaryInput = {
  callVolume: DispatchSummaryCallVolumeEnum;
  chatVolume?: InputMaybe<DispatchSummaryChatVolumeEnum>;
  commentsFaxallCheck?: InputMaybe<Scalars['String']['input']>;
  commentsRepeatDistractedOffenders: Scalars['String']['input'];
  commentsRepeatSpeedingOffenders: Scalars['String']['input'];
  dispatcherAssetCamerasWorking: DispatchSummaryDispatcherAssetCamerasWorkingEnum;
  dispatcherAssetCamerasWorkingNotes: Scalars['String']['input'];
  dispatcherDayOverview: Scalars['String']['input'];
  dispatcherEightByEightIssue?: InputMaybe<Scalars['String']['input']>;
  dispatcherId: Scalars['String']['input'];
  dispatcherPassdown: Scalars['String']['input'];
  dispatcherServiceIssues?: InputMaybe<Scalars['String']['input']>;
  dispatcherShift: DispatchSummaryDispatcherShiftEnum;
  dispatcherSoftwareIssues: Scalars['String']['input'];
  dispatcherStation?: InputMaybe<Scalars['String']['input']>;
  dispatcherStationVansIssues?: InputMaybe<Scalars['String']['input']>;
  dispatcherWasThereEightByEightIssue?: InputMaybe<DispatchSummaryDispatcherWasThereEightByEightIssueEnum>;
  manifestsDrivingIssues: Scalars['String']['input'];
  manifestsTaxis: Scalars['String']['input'];
  manifestsTrainingIssues: Scalars['String']['input'];
  marketComments?: InputMaybe<Array<CreateDispatchSummaryMarketInput>>;
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDispatchSummaryMarketBulkInput = {
  values: Array<CreateDispatchSummaryMarketInput>;
};

export type CreateDispatchSummaryMarketBulkResponse = {
  __typename?: 'CreateDispatchSummaryMarketBulkResponse';
  output: Array<CreateDispatchSummaryMarketResponse>;
};

export type CreateDispatchSummaryMarketInput = {
  airportCode: Scalars['String']['input'];
  comment: Scalars['String']['input'];
  dispatchSummaryId: Scalars['String']['input'];
};

export type CreateDispatchSummaryMarketResponse = {
  __typename?: 'CreateDispatchSummaryMarketResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: DispatchSummaryMarket;
};

export type CreateDispatchSummaryResponse = {
  __typename?: 'CreateDispatchSummaryResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: DispatchSummary;
};

export type CreateDistanceBulkInput = {
  values: Array<CreateDistanceInput>;
};

export type CreateDistanceBulkResponse = {
  __typename?: 'CreateDistanceBulkResponse';
  output: Array<CreateDistanceResponse>;
};

export type CreateDistanceInput = {
  cachedAt: Scalars['String']['input'];
  distanceText: Scalars['String']['input'];
  distanceValue: Scalars['Int']['input'];
  durationInTrafficText: Scalars['String']['input'];
  durationInTrafficValue: Scalars['Int']['input'];
  durationText: Scalars['String']['input'];
  durationValue: Scalars['Int']['input'];
  fromLocationId: Scalars['String']['input'];
  toLocationId: Scalars['String']['input'];
};

export type CreateDistanceResponse = {
  __typename?: 'CreateDistanceResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Distance;
};

export type CreateDownloadImportUrLsInput = {
  ids: Array<Scalars['String']['input']>;
};

export type CreateDownloadImportUrLsResponse = {
  __typename?: 'CreateDownloadImportURLsResponse';
  imports: Array<DownloadImportResponse>;
};

export type CreateDriverEtaBulkInput = {
  values: Array<CreateDriverEtaInput>;
};

export type CreateDriverEtaBulkResponse = {
  __typename?: 'CreateDriverEtaBulkResponse';
  output: Array<CreateDriverEtaResponse>;
};

export type CreateDriverEtaInput = {
  driverId: Scalars['String']['input'];
  etaDatetime: Scalars['String']['input'];
  etaMinutes: Scalars['Int']['input'];
  previousTripId?: InputMaybe<Scalars['String']['input']>;
  tripId: Scalars['String']['input'];
};

export type CreateDriverEtaResponse = {
  __typename?: 'CreateDriverEtaResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: DriverEta;
};

export type CreateDriverVehicleAssignmentBulkInput = {
  values: Array<CreateDriverVehicleAssignmentInput>;
};

export type CreateDriverVehicleAssignmentBulkResponse = {
  __typename?: 'CreateDriverVehicleAssignmentBulkResponse';
  output: Array<CreateDriverVehicleAssignmentResponse>;
};

export type CreateDriverVehicleAssignmentInput = {
  driverId?: InputMaybe<Scalars['String']['input']>;
  driverName: Scalars['String']['input'];
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  externalDriverId: Scalars['String']['input'];
  externalVehicleId: Scalars['String']['input'];
  externalVendor: Scalars['String']['input'];
  startDatetime: Scalars['String']['input'];
  type: Scalars['String']['input'];
  vehicleTrackingId: Scalars['String']['input'];
};

export type CreateDriverVehicleAssignmentResponse = {
  __typename?: 'CreateDriverVehicleAssignmentResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: DriverVehicleAssignment;
};

export type CreateDtrImportInput = {
  filename: Scalars['String']['input'];
  md5: Scalars['String']['input'];
};

export type CreateDtrLocationBulkInput = {
  values: Array<CreateDtrLocationInput>;
};

export type CreateDtrLocationBulkResponse = {
  __typename?: 'CreateDtrLocationBulkResponse';
  output: Array<CreateDtrLocationResponse>;
};

export type CreateDtrLocationInput = {
  address: Scalars['String']['input'];
  airportCode?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  coordinates: PointInput;
  countryCode: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateDtrLocationResponse = {
  __typename?: 'CreateDtrLocationResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: DtrLocation;
};

export type CreateDvirBulkInput = {
  values: Array<CreateDvirInput>;
};

export type CreateDvirBulkResponse = {
  __typename?: 'CreateDvirBulkResponse';
  output: Array<CreateDvirResponse>;
};

export type CreateDvirInput = {
  driverId?: InputMaybe<Scalars['String']['input']>;
  driverName: Scalars['String']['input'];
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  eventDatetime?: InputMaybe<Scalars['String']['input']>;
  eventType: Scalars['String']['input'];
  externalDriverId: Scalars['String']['input'];
  externalDvirId: Scalars['String']['input'];
  externalEventId: Scalars['String']['input'];
  externalOrgId: Scalars['String']['input'];
  externalTrailerId?: InputMaybe<Scalars['String']['input']>;
  externalVehicleId: Scalars['String']['input'];
  externalVendor: DvirExternalVendorEnum;
  externalWebhookId: Scalars['String']['input'];
  formattedLocation: Scalars['String']['input'];
  mechanicNotes?: InputMaybe<Scalars['String']['input']>;
  needsCorrection: Scalars['Int']['input'];
  odometerMeters?: InputMaybe<Scalars['String']['input']>;
  safetyStatus: Scalars['String']['input'];
  startDatetime?: InputMaybe<Scalars['String']['input']>;
  trailerName?: InputMaybe<Scalars['String']['input']>;
  type: Scalars['String']['input'];
  vehicleLicensePlate: Scalars['String']['input'];
  vehicleModel: Scalars['String']['input'];
  vehicleSerial: Scalars['String']['input'];
  vehicleTrackingId: Scalars['String']['input'];
  vehicleVin: Scalars['String']['input'];
};

export type CreateDvirResponse = {
  __typename?: 'CreateDvirResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Dvir;
};

export type CreateDvirSignatureBulkInput = {
  values: Array<CreateDvirSignatureInput>;
};

export type CreateDvirSignatureBulkResponse = {
  __typename?: 'CreateDvirSignatureBulkResponse';
  output: Array<CreateDvirSignatureResponse>;
};

export type CreateDvirSignatureInput = {
  dvirId: Scalars['String']['input'];
  externalUserId: Scalars['String']['input'];
  signedAt: Scalars['String']['input'];
  type: Scalars['String']['input'];
  userName: Scalars['String']['input'];
  userType: Scalars['String']['input'];
};

export type CreateDvirSignatureResponse = {
  __typename?: 'CreateDvirSignatureResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: DvirSignature;
};

export type CreateEmailBulkInput = {
  values: Array<CreateEmailInput>;
};

export type CreateEmailBulkResponse = {
  __typename?: 'CreateEmailBulkResponse';
  output: Array<CreateEmailResponse>;
};

export type CreateEmailInput = {
  address: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
  type: EmailTypeEnum;
};

export type CreateEmailResponse = {
  __typename?: 'CreateEmailResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Email;
};

export type CreateEquivalentTripBulkInput = {
  values: Array<CreateEquivalentTripInput>;
};

export type CreateEquivalentTripBulkResponse = {
  __typename?: 'CreateEquivalentTripBulkResponse';
  output: Array<CreateEquivalentTripResponse>;
};

export type CreateEquivalentTripInput = {
  companyId: Scalars['String']['input'];
  count?: InputMaybe<Scalars['Int']['input']>;
  endLocationId?: InputMaybe<Scalars['String']['input']>;
  startLocationId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateEquivalentTripResponse = {
  __typename?: 'CreateEquivalentTripResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: EquivalentTrip;
};

export type CreateEventBulkInput = {
  values: Array<CreateEventInput>;
};

export type CreateEventBulkResponse = {
  __typename?: 'CreateEventBulkResponse';
  output: Array<CreateEventResponse>;
};

export type CreateEventInput = {
  active?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<EventStatusEnum>;
};

export type CreateEventResponse = {
  __typename?: 'CreateEventResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Event;
};

export type CreateFcrBulkInput = {
  values: Array<CreateFcrInput>;
};

export type CreateFcrBulkResponse = {
  __typename?: 'CreateFcrBulkResponse';
  output: Array<CreateFcrResponse>;
};

export type CreateFcrInput = {
  cause?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  fcrReporter?: InputMaybe<FcrFcrReporterEnum>;
  fcrTypeId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};

export type CreateFcrResponse = {
  __typename?: 'CreateFcrResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Fcr;
};

export type CreateFcrTypeBulkInput = {
  values: Array<CreateFcrTypeInput>;
};

export type CreateFcrTypeBulkResponse = {
  __typename?: 'CreateFcrTypeBulkResponse';
  output: Array<CreateFcrTypeResponse>;
};

export type CreateFcrTypeInput = {
  name: Scalars['String']['input'];
};

export type CreateFcrTypeResponse = {
  __typename?: 'CreateFcrTypeResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: FcrType;
};

export type CreateFlagBulkInput = {
  values: Array<CreateFlagInput>;
};

export type CreateFlagBulkResponse = {
  __typename?: 'CreateFlagBulkResponse';
  output: Array<CreateFlagResponse>;
};

export type CreateFlagHasPotentialTripBulkInput = {
  values: Array<CreateFlagHasPotentialTripInput>;
};

export type CreateFlagHasPotentialTripBulkResponse = {
  __typename?: 'CreateFlagHasPotentialTripBulkResponse';
  output: Array<CreateFlagHasPotentialTripResponse>;
};

export type CreateFlagHasPotentialTripInput = {
  flagId: Scalars['String']['input'];
  potentialTripId: Scalars['String']['input'];
};

export type CreateFlagHasPotentialTripResponse = {
  __typename?: 'CreateFlagHasPotentialTripResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: FlagHasPotentialTrip;
};

export type CreateFlagHasStagedTripBulkInput = {
  values: Array<CreateFlagHasStagedTripInput>;
};

export type CreateFlagHasStagedTripBulkResponse = {
  __typename?: 'CreateFlagHasStagedTripBulkResponse';
  output: Array<CreateFlagHasStagedTripResponse>;
};

export type CreateFlagHasStagedTripInput = {
  flagId: Scalars['String']['input'];
  stagedTripId: Scalars['String']['input'];
};

export type CreateFlagHasStagedTripResponse = {
  __typename?: 'CreateFlagHasStagedTripResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: FlagHasStagedTrip;
};

export type CreateFlagHasTripBulkInput = {
  values: Array<CreateFlagHasTripInput>;
};

export type CreateFlagHasTripBulkResponse = {
  __typename?: 'CreateFlagHasTripBulkResponse';
  output: Array<CreateFlagHasTripResponse>;
};

export type CreateFlagHasTripInput = {
  flagId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};

export type CreateFlagHasTripResponse = {
  __typename?: 'CreateFlagHasTripResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: FlagHasTrip;
};

export type CreateFlagInput = {
  active: Scalars['Int']['input'];
  color: Scalars['String']['input'];
  companyId?: InputMaybe<Scalars['String']['input']>;
  global: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateFlagResponse = {
  __typename?: 'CreateFlagResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Flag;
};

export type CreateFlightHistoryBulkInput = {
  values: Array<CreateFlightHistoryInput>;
};

export type CreateFlightHistoryBulkResponse = {
  __typename?: 'CreateFlightHistoryBulkResponse';
  output: Array<CreateFlightHistoryResponse>;
};

export type CreateFlightHistoryInput = {
  actual?: InputMaybe<Scalars['String']['input']>;
  actualUtc?: InputMaybe<Scalars['String']['input']>;
  arrivalAirportCode: Scalars['String']['input'];
  arrivalDatetime?: InputMaybe<Scalars['String']['input']>;
  arrivalDatetimeUtc?: InputMaybe<Scalars['String']['input']>;
  arrivalDelayMinutes: Scalars['Int']['input'];
  arrivalGate?: InputMaybe<Scalars['String']['input']>;
  arrivalTerminal?: InputMaybe<Scalars['String']['input']>;
  arrivalTimezone?: InputMaybe<Scalars['String']['input']>;
  arrivalUtcOffsetHours?: InputMaybe<Scalars['String']['input']>;
  departureAirportCode: Scalars['String']['input'];
  departureDatetime?: InputMaybe<Scalars['String']['input']>;
  departureDatetimeUtc?: InputMaybe<Scalars['String']['input']>;
  departureDelayMinutes: Scalars['Int']['input'];
  departureGate?: InputMaybe<Scalars['String']['input']>;
  departureTerminal?: InputMaybe<Scalars['String']['input']>;
  departureTimezone?: InputMaybe<Scalars['String']['input']>;
  departureUtcOffsetHours?: InputMaybe<Scalars['String']['input']>;
  divertedAirportCode?: InputMaybe<Scalars['String']['input']>;
  estimatedArrivalDatetime?: InputMaybe<Scalars['String']['input']>;
  estimatedArrivalDatetimeUtc?: InputMaybe<Scalars['String']['input']>;
  estimatedDepartureDatetime?: InputMaybe<Scalars['String']['input']>;
  estimatedDepartureDatetimeUtc?: InputMaybe<Scalars['String']['input']>;
  externalAlertId: Scalars['String']['input'];
  externalId: Scalars['String']['input'];
  externalVendor: FlightHistoryExternalVendorEnum;
  flightNumber: Scalars['String']['input'];
  label: FlightHistoryLabelEnum;
  landedDatetime?: InputMaybe<Scalars['String']['input']>;
  landedDatetimeUtc?: InputMaybe<Scalars['String']['input']>;
  raw: Scalars['String']['input'];
  scheduled: Scalars['String']['input'];
  scheduledUtc: Scalars['String']['input'];
  servicerIataAirlineCode: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  type: FlightHistoryTypeEnum;
};

export type CreateFlightHistoryResponse = {
  __typename?: 'CreateFlightHistoryResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: FlightHistory;
};

export type CreateGeneratedDocumentBulkInput = {
  values: Array<CreateGeneratedDocumentInput>;
};

export type CreateGeneratedDocumentBulkResponse = {
  __typename?: 'CreateGeneratedDocumentBulkResponse';
  output: Array<CreateGeneratedDocumentResponse>;
};

export type CreateGeneratedDocumentInput = {
  docSource: Scalars['String']['input'];
  fileLocation: Scalars['String']['input'];
  fileS3Bucket: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  generationCompletedAt?: InputMaybe<Scalars['String']['input']>;
  generationStartedAt?: InputMaybe<Scalars['String']['input']>;
  resourceId?: InputMaybe<Scalars['String']['input']>;
  status: GeneratedDocumentStatusEnum;
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGeneratedDocumentLogBulkInput = {
  values: Array<CreateGeneratedDocumentLogInput>;
};

export type CreateGeneratedDocumentLogBulkResponse = {
  __typename?: 'CreateGeneratedDocumentLogBulkResponse';
  output: Array<CreateGeneratedDocumentLogResponse>;
};

export type CreateGeneratedDocumentLogInput = {
  generatedDocumentId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateGeneratedDocumentLogResponse = {
  __typename?: 'CreateGeneratedDocumentLogResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: GeneratedDocumentLog;
};

export type CreateGeneratedDocumentResponse = {
  __typename?: 'CreateGeneratedDocumentResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: GeneratedDocument;
};

export type CreateGroupBulkInput = {
  values: Array<CreateGroupInput>;
};

export type CreateGroupBulkResponse = {
  __typename?: 'CreateGroupBulkResponse';
  output: Array<CreateGroupResponse>;
};

export type CreateGroupHasPermissionBulkInput = {
  values: Array<CreateGroupHasPermissionInput>;
};

export type CreateGroupHasPermissionBulkResponse = {
  __typename?: 'CreateGroupHasPermissionBulkResponse';
  output: Array<CreateGroupHasPermissionResponse>;
};

export type CreateGroupHasPermissionInput = {
  groupId: Scalars['String']['input'];
  permissionId: Scalars['String']['input'];
};

export type CreateGroupHasPermissionResponse = {
  __typename?: 'CreateGroupHasPermissionResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: GroupHasPermission;
};

export type CreateGroupHasUserBulkInput = {
  values: Array<CreateGroupHasUserInput>;
};

export type CreateGroupHasUserBulkResponse = {
  __typename?: 'CreateGroupHasUserBulkResponse';
  output: Array<CreateGroupHasUserResponse>;
};

export type CreateGroupHasUserInput = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateGroupHasUserResponse = {
  __typename?: 'CreateGroupHasUserResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: GroupHasUser;
};

export type CreateGroupInput = {
  active: Scalars['Int']['input'];
  companyId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  type: GroupTypeEnum;
};

export type CreateGroupResponse = {
  __typename?: 'CreateGroupResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Group;
};

export type CreateImageBulkInput = {
  generateUploadUrl?: InputMaybe<Scalars['Int']['input']>;
  values: Array<CreateImageInput>;
};

export type CreateImageBulkResponse = {
  __typename?: 'CreateImageBulkResponse';
  output: Array<CreateImageResponse>;
};

export type CreateImageInput = {
  filename: Scalars['String']['input'];
  md5: Scalars['String']['input'];
  path: Scalars['String']['input'];
  pickupPointId: Scalars['String']['input'];
};

export type CreateImageResponse = {
  __typename?: 'CreateImageResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Image;
};

export type CreateImportBulkInput = {
  values: Array<CreateImportInput>;
};

export type CreateImportBulkResponse = {
  __typename?: 'CreateImportBulkResponse';
  output: Array<CreateImportResponse>;
};

export type CreateImportEmailBulkInput = {
  values: Array<CreateImportEmailInput>;
};

export type CreateImportEmailBulkResponse = {
  __typename?: 'CreateImportEmailBulkResponse';
  output: Array<CreateImportEmailResponse>;
};

export type CreateImportEmailInput = {
  date?: InputMaybe<Scalars['String']['input']>;
  fileLocation?: InputMaybe<Scalars['String']['input']>;
  filename?: InputMaybe<Scalars['String']['input']>;
  from?: InputMaybe<Scalars['String']['input']>;
  md5: Scalars['String']['input'];
  originalFileLocation: Scalars['String']['input'];
  subject: Scalars['String']['input'];
};

export type CreateImportEmailResponse = {
  __typename?: 'CreateImportEmailResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ImportEmail;
};

export type CreateImportFailureBulkInput = {
  values: Array<CreateImportFailureInput>;
};

export type CreateImportFailureBulkResponse = {
  __typename?: 'CreateImportFailureBulkResponse';
  output: Array<CreateImportFailureResponse>;
};

export type CreateImportFailureInput = {
  companyId: Scalars['String']['input'];
  errorCode?: InputMaybe<Scalars['Int']['input']>;
  errorMessage: Scalars['String']['input'];
  importId: Scalars['String']['input'];
  importType: ImportFailureImportTypeEnum;
  ingestAction?: InputMaybe<ImportFailureIngestActionEnum>;
  providerId: Scalars['String']['input'];
  stagedTripId?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Scalars['String']['input']>;
  type: ImportFailureTypeEnum;
};

export type CreateImportFailureResponse = {
  __typename?: 'CreateImportFailureResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ImportFailure;
};

export type CreateImportInput = {
  filename: Scalars['String']['input'];
  md5: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};

export type CreateImportLogBulkInput = {
  values: Array<CreateImportLogInput>;
};

export type CreateImportLogBulkResponse = {
  __typename?: 'CreateImportLogBulkResponse';
  output: Array<CreateImportLogResponse>;
};

export type CreateImportLogInput = {
  importId: Scalars['String']['input'];
  message: Scalars['String']['input'];
};

export type CreateImportLogResponse = {
  __typename?: 'CreateImportLogResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ImportLog;
};

export type CreateImportOcrCacheBulkInput = {
  values: Array<CreateImportOcrCacheInput>;
};

export type CreateImportOcrCacheBulkResponse = {
  __typename?: 'CreateImportOcrCacheBulkResponse';
  output: Array<CreateImportOcrCacheResponse>;
};

export type CreateImportOcrCacheInput = {
  importId: Scalars['String']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
  text: Scalars['String']['input'];
};

export type CreateImportOcrCacheResponse = {
  __typename?: 'CreateImportOcrCacheResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ImportOcrCache;
};

export type CreateImportResponse = {
  __typename?: 'CreateImportResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Import;
};

export type CreateImportsInput = {
  imports: Array<CreateImportInput>;
};

export type CreateImportsResponse = {
  __typename?: 'CreateImportsResponse';
  imports?: Maybe<Array<ImportResponse>>;
};

export type CreateIncidentIssueBulkInput = {
  values: Array<CreateIncidentIssueInput>;
};

export type CreateIncidentIssueBulkResponse = {
  __typename?: 'CreateIncidentIssueBulkResponse';
  output: Array<CreateIncidentIssueResponse>;
};

export type CreateIncidentIssueDocumentBulkInput = {
  values: Array<CreateIncidentIssueDocumentInput>;
};

export type CreateIncidentIssueDocumentBulkResponse = {
  __typename?: 'CreateIncidentIssueDocumentBulkResponse';
  output: Array<CreateIncidentIssueDocumentResponse>;
};

export type CreateIncidentIssueDocumentInput = {
  contentType: Scalars['String']['input'];
  fileLocation: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  issueId: Scalars['String']['input'];
  md5: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateIncidentIssueDocumentResponse = {
  __typename?: 'CreateIncidentIssueDocumentResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: IncidentIssueDocument;
};

export type CreateIncidentIssueInput = {
  crewInfo?: InputMaybe<Scalars['String']['input']>;
  crewInvolved: IncidentIssueCrewInvolvedEnum;
  description: Scalars['String']['input'];
  dispatcherId: Scalars['String']['input'];
  documents?: InputMaybe<Array<CreateIncidentIssueDocumentInput>>;
  driverId: Scalars['String']['input'];
  incidentDatetime: Scalars['String']['input'];
  incidentOccurance: IncidentIssueIncidentOccuranceEnum;
  incidentOccuranceOther?: InputMaybe<Scalars['String']['input']>;
  incidentWitnesses?: InputMaybe<Scalars['String']['input']>;
  managerId?: InputMaybe<Scalars['String']['input']>;
  medicalAttentionType?: InputMaybe<Scalars['String']['input']>;
  medicalInjuries?: InputMaybe<IncidentIssueMedicalInjuriesEnum>;
  medicalNeeded?: InputMaybe<IncidentIssueMedicalNeededEnum>;
  outboundDatetime?: InputMaybe<Scalars['String']['input']>;
  outboundFlightName?: InputMaybe<Scalars['String']['input']>;
  outboundFlightNumber?: InputMaybe<Scalars['Int']['input']>;
  propertyDamage: IncidentIssuePropertyDamageEnum;
  propertyDamageDescription?: InputMaybe<Scalars['String']['input']>;
  recoveryInfo?: InputMaybe<Scalars['String']['input']>;
  samsaraCameraWorking?: InputMaybe<IncidentIssueSamsaraCameraWorkingEnum>;
  station?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Scalars['String']['input']>;
  vehicleId: Scalars['String']['input'];
};

export type CreateIncidentIssueResponse = {
  __typename?: 'CreateIncidentIssueResponse';
  error?: Maybe<Scalars['String']['output']>;
  output: IncidentIssueAndDocument;
};

export type CreateIndexBulkInput = {
  values: Array<CreateIndexInput>;
};

export type CreateIndexBulkResponse = {
  __typename?: 'CreateIndexBulkResponse';
  output: Array<CreateIndexResponse>;
};

export type CreateIndexInput = {
  checkpoint: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateIndexResponse = {
  __typename?: 'CreateIndexResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Index;
};

export type CreateInvoiceAirportBulkInput = {
  values: Array<CreateInvoiceAirportInput>;
};

export type CreateInvoiceAirportBulkResponse = {
  __typename?: 'CreateInvoiceAirportBulkResponse';
  output: Array<CreateInvoiceAirportResponse>;
};

export type CreateInvoiceAirportInput = {
  code: Scalars['String']['input'];
  invoiceId: Scalars['Int']['input'];
};

export type CreateInvoiceAirportResponse = {
  __typename?: 'CreateInvoiceAirportResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceAirport;
};

export type CreateInvoiceBulkInput = {
  values: Array<CreateInvoiceInput>;
};

export type CreateInvoiceBulkResponse = {
  __typename?: 'CreateInvoiceBulkResponse';
  output: Array<CreateInvoiceResponse>;
};

export type CreateInvoiceClientBulkInput = {
  values: Array<CreateInvoiceClientInput>;
};

export type CreateInvoiceClientBulkResponse = {
  __typename?: 'CreateInvoiceClientBulkResponse';
  output: Array<CreateInvoiceClientResponse>;
};

export type CreateInvoiceClientInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  invoiceId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};

export type CreateInvoiceClientResponse = {
  __typename?: 'CreateInvoiceClientResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceClient;
};

export type CreateInvoiceCustomChargeBulkInput = {
  values: Array<CreateInvoiceCustomChargeInput>;
};

export type CreateInvoiceCustomChargeBulkResponse = {
  __typename?: 'CreateInvoiceCustomChargeBulkResponse';
  output: Array<CreateInvoiceCustomChargeResponse>;
};

export type CreateInvoiceCustomChargeInput = {
  cost: Scalars['Float']['input'];
  index: Scalars['Int']['input'];
  invoiceId: Scalars['Int']['input'];
  note: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateInvoiceCustomChargeResponse = {
  __typename?: 'CreateInvoiceCustomChargeResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceCustomCharge;
};

export type CreateInvoiceDocumentBulkInput = {
  values: Array<CreateInvoiceDocumentInput>;
};

export type CreateInvoiceDocumentBulkResponse = {
  __typename?: 'CreateInvoiceDocumentBulkResponse';
  output: Array<CreateInvoiceDocumentResponse>;
};

export type CreateInvoiceDocumentInput = {
  amendment?: InputMaybe<Scalars['String']['input']>;
  fileLocation: Scalars['String']['input'];
  filename: Scalars['String']['input'];
  genDocumentId?: InputMaybe<Scalars['String']['input']>;
  genDocumentStatus?: InputMaybe<InvoiceDocumentGenDocumentStatusEnum>;
  index: Scalars['Int']['input'];
  invoiceId: Scalars['Int']['input'];
  md5: Scalars['String']['input'];
  sendEmailOnCompletion?: InputMaybe<Scalars['Int']['input']>;
  sendEmailRecipients?: InputMaybe<Scalars['String']['input']>;
  sentAt?: InputMaybe<Scalars['String']['input']>;
  sentBy?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvoiceDocumentResponse = {
  __typename?: 'CreateInvoiceDocumentResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceDocument;
};

export type CreateInvoiceEmailBulkInput = {
  values: Array<CreateInvoiceEmailInput>;
};

export type CreateInvoiceEmailBulkResponse = {
  __typename?: 'CreateInvoiceEmailBulkResponse';
  output: Array<CreateInvoiceEmailResponse>;
};

export type CreateInvoiceEmailInput = {
  address: Scalars['String']['input'];
  invoiceId: Scalars['Int']['input'];
};

export type CreateInvoiceEmailResponse = {
  __typename?: 'CreateInvoiceEmailResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceEmail;
};

export type CreateInvoiceHeaderBulkInput = {
  values: Array<CreateInvoiceHeaderInput>;
};

export type CreateInvoiceHeaderBulkResponse = {
  __typename?: 'CreateInvoiceHeaderBulkResponse';
  output: Array<CreateInvoiceHeaderResponse>;
};

export type CreateInvoiceHeaderInput = {
  invoiceId: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type CreateInvoiceHeaderResponse = {
  __typename?: 'CreateInvoiceHeaderResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceHeader;
};

export type CreateInvoiceIataCodeBulkInput = {
  values: Array<CreateInvoiceIataCodeInput>;
};

export type CreateInvoiceIataCodeBulkResponse = {
  __typename?: 'CreateInvoiceIataCodeBulkResponse';
  output: Array<CreateInvoiceIataCodeResponse>;
};

export type CreateInvoiceIataCodeInput = {
  iataCode: Scalars['String']['input'];
  invoiceId: Scalars['Int']['input'];
};

export type CreateInvoiceIataCodeResponse = {
  __typename?: 'CreateInvoiceIataCodeResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceIataCode;
};

export type CreateInvoiceInput = {
  chargeType: InvoiceChargeTypeEnum;
  companyId: Scalars['String']['input'];
  due: Scalars['String']['input'];
  endDatetime: Scalars['String']['input'];
  format: InvoiceFormatEnum;
  grandSubtotal?: InputMaybe<Scalars['Float']['input']>;
  grandTotal: Scalars['Float']['input'];
  hasDiscounts?: InputMaybe<Scalars['Int']['input']>;
  invoiced: Scalars['String']['input'];
  name: Scalars['String']['input'];
  netBillableTrips?: InputMaybe<Scalars['Int']['input']>;
  payerProviderId: Scalars['String']['input'];
  startDatetime: Scalars['String']['input'];
  status: InvoiceStatusEnum;
  subTotal?: InputMaybe<Scalars['Float']['input']>;
  total: Scalars['Float']['input'];
  totalDiscountedTrips?: InputMaybe<Scalars['Int']['input']>;
  totalSavings?: InputMaybe<Scalars['Float']['input']>;
  totalTripsBilled?: InputMaybe<Scalars['Int']['input']>;
  uniqueId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvoiceLineItemBulkInput = {
  values: Array<CreateInvoiceLineItemInput>;
};

export type CreateInvoiceLineItemBulkResponse = {
  __typename?: 'CreateInvoiceLineItemBulkResponse';
  output: Array<CreateInvoiceLineItemResponse>;
};

export type CreateInvoiceLineItemInput = {
  invoiceId: Scalars['Int']['input'];
  lineItemTypeId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateInvoiceLineItemResponse = {
  __typename?: 'CreateInvoiceLineItemResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceLineItem;
};

export type CreateInvoiceProviderCacheBulkInput = {
  values: Array<CreateInvoiceProviderCacheInput>;
};

export type CreateInvoiceProviderCacheBulkResponse = {
  __typename?: 'CreateInvoiceProviderCacheBulkResponse';
  output: Array<CreateInvoiceProviderCacheResponse>;
};

export type CreateInvoiceProviderCacheInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
};

export type CreateInvoiceProviderCacheResponse = {
  __typename?: 'CreateInvoiceProviderCacheResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceProviderCache;
};

export type CreateInvoiceResponse = {
  __typename?: 'CreateInvoiceResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Invoice;
};

export type CreateInvoiceTermBulkInput = {
  values: Array<CreateInvoiceTermInput>;
};

export type CreateInvoiceTermBulkResponse = {
  __typename?: 'CreateInvoiceTermBulkResponse';
  output: Array<CreateInvoiceTermResponse>;
};

export type CreateInvoiceTermInput = {
  type: Scalars['String']['input'];
};

export type CreateInvoiceTermResponse = {
  __typename?: 'CreateInvoiceTermResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceTerm;
};

export type CreateInvoiceTotalSummaryBulkInput = {
  values: Array<CreateInvoiceTotalSummaryInput>;
};

export type CreateInvoiceTotalSummaryBulkResponse = {
  __typename?: 'CreateInvoiceTotalSummaryBulkResponse';
  output: Array<CreateInvoiceTotalSummaryResponse>;
};

export type CreateInvoiceTotalSummaryInput = {
  airlines?: InputMaybe<Scalars['String']['input']>;
  airports?: InputMaybe<Scalars['String']['input']>;
  chargeType: InvoiceTotalSummaryChargeTypeEnum;
  clientAddress?: InputMaybe<Scalars['String']['input']>;
  clientName?: InputMaybe<Scalars['String']['input']>;
  dueDatetime: Scalars['String']['input'];
  emails?: InputMaybe<Scalars['String']['input']>;
  endDatetime: Scalars['String']['input'];
  format: InvoiceTotalSummaryFormatEnum;
  grandSubtotal?: InputMaybe<Scalars['Float']['input']>;
  grandTotal: Scalars['Float']['input'];
  headers?: InputMaybe<Scalars['String']['input']>;
  invoiceDate: Scalars['String']['input'];
  invoiceDocumentId: Scalars['String']['input'];
  invoiceId: Scalars['Int']['input'];
  lineItemCount?: InputMaybe<Scalars['Int']['input']>;
  lineItemTotal?: InputMaybe<Scalars['Float']['input']>;
  payerProviderId: Scalars['String']['input'];
  startDatetime: Scalars['String']['input'];
  status: InvoiceTotalSummaryStatusEnum;
  subtotal?: InputMaybe<Scalars['Float']['input']>;
  totalSavings?: InputMaybe<Scalars['Float']['input']>;
  totalTrips?: InputMaybe<Scalars['Int']['input']>;
  totalTripsBilled?: InputMaybe<Scalars['Int']['input']>;
  tripStatuses?: InputMaybe<Scalars['String']['input']>;
  tripTypes?: InputMaybe<Scalars['String']['input']>;
  uniqueId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInvoiceTotalSummaryResponse = {
  __typename?: 'CreateInvoiceTotalSummaryResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceTotalSummary;
};

export type CreateInvoiceTripBulkInput = {
  values: Array<CreateInvoiceTripInput>;
};

export type CreateInvoiceTripBulkResponse = {
  __typename?: 'CreateInvoiceTripBulkResponse';
  output: Array<CreateInvoiceTripResponse>;
};

export type CreateInvoiceTripInput = {
  airportCode: Scalars['String']['input'];
  attendants: Scalars['Int']['input'];
  combineId?: InputMaybe<Scalars['String']['input']>;
  combineType?: InputMaybe<InvoiceTripCombineTypeEnum>;
  crewId?: InputMaybe<Scalars['Int']['input']>;
  currency?: InputMaybe<InvoiceTripCurrencyEnum>;
  discount: Scalars['Float']['input'];
  doLocation: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  flightNumber: Scalars['Int']['input'];
  importTime?: InputMaybe<Scalars['String']['input']>;
  index: Scalars['Int']['input'];
  invoiceId: Scalars['Int']['input'];
  kind: InvoiceTripKindEnum;
  lastName?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  pilots: Scalars['Int']['input'];
  puLocation: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
  rateId: Scalars['String']['input'];
  savings?: InputMaybe<Scalars['Float']['input']>;
  scheduled: Scalars['String']['input'];
  servicerIataAirlineCode: Scalars['String']['input'];
  status: InvoiceTripStatusEnum;
  tripId: Scalars['String']['input'];
  type: InvoiceTripTypeEnum;
};

export type CreateInvoiceTripResponse = {
  __typename?: 'CreateInvoiceTripResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceTrip;
};

export type CreateInvoiceTripStatusBulkInput = {
  values: Array<CreateInvoiceTripStatusInput>;
};

export type CreateInvoiceTripStatusBulkResponse = {
  __typename?: 'CreateInvoiceTripStatusBulkResponse';
  output: Array<CreateInvoiceTripStatusResponse>;
};

export type CreateInvoiceTripStatusInput = {
  invoiceId: Scalars['Int']['input'];
  status: InvoiceTripStatusStatusEnum;
};

export type CreateInvoiceTripStatusResponse = {
  __typename?: 'CreateInvoiceTripStatusResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceTripStatus;
};

export type CreateInvoiceTypeBulkInput = {
  values: Array<CreateInvoiceTypeInput>;
};

export type CreateInvoiceTypeBulkResponse = {
  __typename?: 'CreateInvoiceTypeBulkResponse';
  output: Array<CreateInvoiceTypeResponse>;
};

export type CreateInvoiceTypeInput = {
  invoiceId: Scalars['Int']['input'];
  type: InvoiceTypeTypeEnum;
};

export type CreateInvoiceTypeResponse = {
  __typename?: 'CreateInvoiceTypeResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceType;
};

export type CreateInvoiceUserCacheBulkInput = {
  values: Array<CreateInvoiceUserCacheInput>;
};

export type CreateInvoiceUserCacheBulkResponse = {
  __typename?: 'CreateInvoiceUserCacheBulkResponse';
  output: Array<CreateInvoiceUserCacheResponse>;
};

export type CreateInvoiceUserCacheInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateInvoiceUserCacheResponse = {
  __typename?: 'CreateInvoiceUserCacheResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: InvoiceUserCache;
};

export type CreateIssueBulkInput = {
  values: Array<CreateIssueInput>;
};

export type CreateIssueBulkResponse = {
  __typename?: 'CreateIssueBulkResponse';
  output: Array<CreateIssueResponse>;
};

export type CreateIssueDownloadUrlInput = {
  issueId: Array<Scalars['String']['input']>;
};

export type CreateIssueDownloadUrlResponse = {
  __typename?: 'CreateIssueDownloadUrlResponse';
  urls?: Maybe<Array<IssueDownloadUrlObject>>;
};

export type CreateIssueInput = {
  driverId: Scalars['String']['input'];
  message: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};

export type CreateIssuePresignedUrlInput = {
  fileSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  issueId: Scalars['String']['input'];
  md5: Scalars['String']['input'];
};

export type CreateIssuePresignedUrlResponse = {
  __typename?: 'CreateIssuePresignedUrlResponse';
  contentType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateIssueResponse = {
  __typename?: 'CreateIssueResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Issue;
};

export type CreateLicenseBulkInput = {
  values: Array<CreateLicenseInput>;
};

export type CreateLicenseBulkResponse = {
  __typename?: 'CreateLicenseBulkResponse';
  output: Array<CreateLicenseResponse>;
};

export type CreateLicenseInput = {
  expirationDate?: InputMaybe<Scalars['String']['input']>;
  licenseTypeId: Scalars['String']['input'];
  number: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateLicenseResponse = {
  __typename?: 'CreateLicenseResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: License;
};

export type CreateLicenseTypeBulkInput = {
  values: Array<CreateLicenseTypeInput>;
};

export type CreateLicenseTypeBulkResponse = {
  __typename?: 'CreateLicenseTypeBulkResponse';
  output: Array<CreateLicenseTypeResponse>;
};

export type CreateLicenseTypeInput = {
  displayName: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CreateLicenseTypeResponse = {
  __typename?: 'CreateLicenseTypeResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: LicenseType;
};

export type CreateLineItemTypeBulkInput = {
  values: Array<CreateLineItemTypeInput>;
};

export type CreateLineItemTypeBulkResponse = {
  __typename?: 'CreateLineItemTypeBulkResponse';
  output: Array<CreateLineItemTypeResponse>;
};

export type CreateLineItemTypeInput = {
  name: Scalars['String']['input'];
};

export type CreateLineItemTypeResponse = {
  __typename?: 'CreateLineItemTypeResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: LineItemType;
};

export type CreateLocationBulkInput = {
  values: Array<CreateLocationInput>;
};

export type CreateLocationBulkResponse = {
  __typename?: 'CreateLocationBulkResponse';
  output: Array<CreateLocationResponse>;
};

export type CreateLocationInput = {
  active: Scalars['Int']['input'];
  address: Scalars['String']['input'];
  airportCodes: Array<Scalars['String']['input']>;
  aliases: Array<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  coordinates: PointInput;
  countryCode: Scalars['String']['input'];
  legacyId?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  primaryAirportCode?: InputMaybe<Scalars['String']['input']>;
  radius: Scalars['Int']['input'];
  stateCode?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
  type: LocationTypeEnum;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLocationResponse = {
  __typename?: 'CreateLocationResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Location;
};

export type CreateLocationsInput = {
  locations: Array<LocationInput>;
};

export type CreateLocationsResponse = {
  __typename?: 'CreateLocationsResponse';
  locations: Array<LocationResponse>;
};

export type CreateLoginEventBulkInput = {
  values: Array<CreateLoginEventInput>;
};

export type CreateLoginEventBulkResponse = {
  __typename?: 'CreateLoginEventBulkResponse';
  output: Array<CreateLoginEventResponse>;
};

export type CreateLoginEventInput = {
  cityName?: InputMaybe<Scalars['String']['input']>;
  datetime?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['Int']['input']>;
  ipAddress?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CreateLoginEventResponse = {
  __typename?: 'CreateLoginEventResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: LoginEvent;
};

export type CreateLostAndFoundIssueBulkInput = {
  values: Array<CreateLostAndFoundIssueInput>;
};

export type CreateLostAndFoundIssueBulkResponse = {
  __typename?: 'CreateLostAndFoundIssueBulkResponse';
  output: Array<CreateLostAndFoundIssueResponse>;
};

export type CreateLostAndFoundIssueCrewInput = {
  crewAirportCode: Scalars['String']['input'];
  crewDriverName?: InputMaybe<Scalars['String']['input']>;
  crewFlightName: Scalars['String']['input'];
  crewFlightNumber?: InputMaybe<Scalars['Int']['input']>;
  crewMemberEmail?: InputMaybe<Scalars['String']['input']>;
  crewMemberName: Scalars['String']['input'];
  crewMemberPhoneNumber: Scalars['String']['input'];
  dateReported: Scalars['String']['input'];
  description: Scalars['String']['input'];
  shippingAddress: Scalars['String']['input'];
  shippingCity: Scalars['String']['input'];
  shippingStateCode: Scalars['String']['input'];
  shippingZipCode: Scalars['String']['input'];
  tripId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLostAndFoundIssueCrewResponse = {
  __typename?: 'CreateLostAndFoundIssueCrewResponse';
  error?: Maybe<Error>;
  node?: Maybe<LostAndFoundIssue>;
};

export type CreateLostAndFoundIssueDocumentBulkInput = {
  values: Array<CreateLostAndFoundIssueDocumentInput>;
};

export type CreateLostAndFoundIssueDocumentBulkResponse = {
  __typename?: 'CreateLostAndFoundIssueDocumentBulkResponse';
  output: Array<CreateLostAndFoundIssueDocumentResponse>;
};

export type CreateLostAndFoundIssueDocumentInput = {
  contentType: Scalars['String']['input'];
  fileLocation: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  issueId: Scalars['String']['input'];
  md5: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLostAndFoundIssueDocumentResponse = {
  __typename?: 'CreateLostAndFoundIssueDocumentResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: LostAndFoundIssueDocument;
};

export type CreateLostAndFoundIssueInput = {
  crewAirportCode?: InputMaybe<Scalars['String']['input']>;
  crewDriverName?: InputMaybe<Scalars['String']['input']>;
  crewFlightName?: InputMaybe<Scalars['String']['input']>;
  crewFlightNumber?: InputMaybe<Scalars['Int']['input']>;
  crewMemberEmail?: InputMaybe<Scalars['String']['input']>;
  crewMemberName: Scalars['String']['input'];
  crewMemberPhone: Scalars['String']['input'];
  datetime?: InputMaybe<Scalars['String']['input']>;
  description: Scalars['String']['input'];
  dispatcherId?: InputMaybe<Scalars['String']['input']>;
  documents?: InputMaybe<Array<CreateLostAndFoundIssueDocumentInput>>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  itemLost?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  outboundDatetime?: InputMaybe<Scalars['String']['input']>;
  outboundFlightName?: InputMaybe<Scalars['String']['input']>;
  outboundFlightNumber?: InputMaybe<Scalars['Int']['input']>;
  returnStatus?: InputMaybe<LostAndFoundIssueReturnStatusEnum>;
  shippingAddress?: InputMaybe<Scalars['String']['input']>;
  shippingCity?: InputMaybe<Scalars['String']['input']>;
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  shippingStateCode?: InputMaybe<Scalars['String']['input']>;
  shippingZipCode?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
  trackingNumber?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Scalars['String']['input']>;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateLostAndFoundIssueResponse = {
  __typename?: 'CreateLostAndFoundIssueResponse';
  error?: Maybe<Scalars['String']['output']>;
  output: LostAndFoundIssueAndDocument;
};

export type CreateManifestHistoryBulkInput = {
  values: Array<CreateManifestHistoryInput>;
};

export type CreateManifestHistoryBulkResponse = {
  __typename?: 'CreateManifestHistoryBulkResponse';
  output: Array<CreateManifestHistoryResponse>;
};

export type CreateManifestHistoryInput = {
  filename?: InputMaybe<Scalars['String']['input']>;
  manifestImportId: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CreateManifestHistoryResponse = {
  __typename?: 'CreateManifestHistoryResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ManifestHistory;
};

export type CreateManifestHistoryRouteBulkInput = {
  values: Array<CreateManifestHistoryRouteInput>;
};

export type CreateManifestHistoryRouteBulkResponse = {
  __typename?: 'CreateManifestHistoryRouteBulkResponse';
  output: Array<CreateManifestHistoryRouteResponse>;
};

export type CreateManifestHistoryRouteInput = {
  doLocationId: Scalars['String']['input'];
  manifestHistoryId: Scalars['String']['input'];
  puLocationId: Scalars['String']['input'];
  status: ManifestHistoryRouteStatusEnum;
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateManifestHistoryRouteResponse = {
  __typename?: 'CreateManifestHistoryRouteResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ManifestHistoryRoute;
};

export type CreateManifestProviderCacheBulkInput = {
  values: Array<CreateManifestProviderCacheInput>;
};

export type CreateManifestProviderCacheBulkResponse = {
  __typename?: 'CreateManifestProviderCacheBulkResponse';
  output: Array<CreateManifestProviderCacheResponse>;
};

export type CreateManifestProviderCacheInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  providerId: Scalars['String']['input'];
};

export type CreateManifestProviderCacheResponse = {
  __typename?: 'CreateManifestProviderCacheResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ManifestProviderCache;
};

export type CreateManifestUserCacheBulkInput = {
  values: Array<CreateManifestUserCacheInput>;
};

export type CreateManifestUserCacheBulkResponse = {
  __typename?: 'CreateManifestUserCacheBulkResponse';
  output: Array<CreateManifestUserCacheResponse>;
};

export type CreateManifestUserCacheInput = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateManifestUserCacheResponse = {
  __typename?: 'CreateManifestUserCacheResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ManifestUserCache;
};

export type CreateMessageBulkInput = {
  values: Array<CreateMessageInput>;
};

export type CreateMessageBulkResponse = {
  __typename?: 'CreateMessageBulkResponse';
  output: Array<CreateMessageResponse>;
};

export type CreateMessageInput = {
  companyId: Scalars['String']['input'];
  content: Scalars['String']['input'];
  type: MessageTypeEnum;
};

export type CreateMessageResponse = {
  __typename?: 'CreateMessageResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Message;
};

export type CreateNotificationBulkInput = {
  values: Array<CreateNotificationInput>;
};

export type CreateNotificationBulkResponse = {
  __typename?: 'CreateNotificationBulkResponse';
  output: Array<CreateNotificationResponse>;
};

export type CreateNotificationHasEventBulkInput = {
  values: Array<CreateNotificationHasEventInput>;
};

export type CreateNotificationHasEventBulkResponse = {
  __typename?: 'CreateNotificationHasEventBulkResponse';
  output: Array<CreateNotificationHasEventResponse>;
};

export type CreateNotificationHasEventInput = {
  eventId: Scalars['String']['input'];
  responseId: Scalars['String']['input'];
};

export type CreateNotificationHasEventResponse = {
  __typename?: 'CreateNotificationHasEventResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: NotificationHasEvent;
};

export type CreateNotificationInput = {
  active: Scalars['Int']['input'];
  allProvider: Scalars['Int']['input'];
  allVendors: Scalars['Int']['input'];
  company: Scalars['String']['input'];
  method: NotificationMethodEnum;
  vendor: Scalars['String']['input'];
};

export type CreateNotificationResponse = {
  __typename?: 'CreateNotificationResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Notification;
};

export type CreateParsedTripBulkInput = {
  values: Array<CreateParsedTripInput>;
};

export type CreateParsedTripBulkResponse = {
  __typename?: 'CreateParsedTripBulkResponse';
  output: Array<CreateParsedTripResponse>;
};

export type CreateParsedTripInput = {
  airportCode: Scalars['String']['input'];
  attendants: Scalars['Int']['input'];
  doLocation: Scalars['String']['input'];
  doLocationId?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['Int']['input']>;
  fromManifest: Scalars['Int']['input'];
  importId: Scalars['String']['input'];
  importTime?: InputMaybe<Scalars['String']['input']>;
  kind: ParsedTripKindEnum;
  loopName?: InputMaybe<Scalars['String']['input']>;
  pilots: Scalars['Int']['input'];
  puLocation: Scalars['String']['input'];
  puLocationId?: InputMaybe<Scalars['String']['input']>;
  scheduled: Scalars['String']['input'];
  servicerIataAirlineCode: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
  typeName?: InputMaybe<ParsedTripTypeNameEnum>;
};

export type CreateParsedTripResponse = {
  __typename?: 'CreateParsedTripResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ParsedTrip;
};

export type CreatePermissionBulkInput = {
  values: Array<CreatePermissionInput>;
};

export type CreatePermissionBulkResponse = {
  __typename?: 'CreatePermissionBulkResponse';
  output: Array<CreatePermissionResponse>;
};

export type CreatePermissionHasRoleBulkInput = {
  values: Array<CreatePermissionHasRoleInput>;
};

export type CreatePermissionHasRoleBulkResponse = {
  __typename?: 'CreatePermissionHasRoleBulkResponse';
  output: Array<CreatePermissionHasRoleResponse>;
};

export type CreatePermissionHasRoleInput = {
  permissionId: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

export type CreatePermissionHasRoleResponse = {
  __typename?: 'CreatePermissionHasRoleResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: PermissionHasRole;
};

export type CreatePermissionHasUserBulkInput = {
  values: Array<CreatePermissionHasUserInput>;
};

export type CreatePermissionHasUserBulkResponse = {
  __typename?: 'CreatePermissionHasUserBulkResponse';
  output: Array<CreatePermissionHasUserResponse>;
};

export type CreatePermissionHasUserInput = {
  effect: PermissionHasUserEffectEnum;
  permissionId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreatePermissionHasUserResponse = {
  __typename?: 'CreatePermissionHasUserResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: PermissionHasUser;
};

export type CreatePermissionInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  displayGroup: Scalars['String']['input'];
  displayName: Scalars['String']['input'];
  effect: PermissionEffectEnum;
  entity: Scalars['String']['input'];
  resource: Scalars['String']['input'];
  verb: Scalars['String']['input'];
};

export type CreatePermissionResponse = {
  __typename?: 'CreatePermissionResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Permission;
};

export type CreatePickupPointBulkInput = {
  generateUploadUrl?: InputMaybe<Scalars['Int']['input']>;
  values: Array<CreatePickupPointInput>;
};

export type CreatePickupPointBulkResponse = {
  __typename?: 'CreatePickupPointBulkResponse';
  output: Array<CreatePickupPointResponse>;
};

export type CreatePickupPointInput = {
  coordinates: PointInput;
  endDatetime: Scalars['String']['input'];
  images: Array<CreateImageInput>;
  instructions: Scalars['String']['input'];
  keyword: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
  radius: Scalars['Int']['input'];
  startDatetime: Scalars['String']['input'];
};

export type CreatePickupPointResponse = {
  __typename?: 'CreatePickupPointResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: PickupPoint;
};

export type CreatePotentialTripBulkInput = {
  values: Array<CreatePotentialTripInput>;
};

export type CreatePotentialTripBulkResponse = {
  __typename?: 'CreatePotentialTripBulkResponse';
  output: Array<CreatePotentialTripResponse>;
};

export type CreatePotentialTripInput = {
  airportCode: Scalars['String']['input'];
  attendants: Scalars['Int']['input'];
  bufferMinutes: Scalars['Int']['input'];
  combineId?: InputMaybe<Scalars['String']['input']>;
  crewId?: InputMaybe<Scalars['Int']['input']>;
  doLocationId: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['Int']['input']>;
  fromManifest: Scalars['Int']['input'];
  importId: Scalars['String']['input'];
  importTime?: InputMaybe<Scalars['String']['input']>;
  kind: PotentialTripKindEnum;
  lastName?: InputMaybe<Scalars['String']['input']>;
  loopName?: InputMaybe<Scalars['String']['input']>;
  payerProviderId: Scalars['String']['input'];
  pilots: Scalars['Int']['input'];
  puLocationId: Scalars['String']['input'];
  scheduled: Scalars['String']['input'];
  servicerIataAirlineCode: Scalars['String']['input'];
  split: Scalars['Int']['input'];
  tripId: Scalars['String']['input'];
  typeName?: InputMaybe<PotentialTripTypeNameEnum>;
};

export type CreatePotentialTripResponse = {
  __typename?: 'CreatePotentialTripResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: PotentialTrip;
};

export type CreateProviderAliasBulkInput = {
  values: Array<CreateProviderAliasInput>;
};

export type CreateProviderAliasBulkResponse = {
  __typename?: 'CreateProviderAliasBulkResponse';
  output: Array<CreateProviderAliasResponse>;
};

export type CreateProviderAliasInput = {
  alias: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};

export type CreateProviderAliasResponse = {
  __typename?: 'CreateProviderAliasResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ProviderAlias;
};

export type CreateProviderBulkInput = {
  values: Array<CreateProviderInput>;
};

export type CreateProviderBulkResponse = {
  __typename?: 'CreateProviderBulkResponse';
  output: Array<CreateProviderResponse>;
};

export type CreateProviderCacheBulkInput = {
  values: Array<CreateProviderCacheInput>;
};

export type CreateProviderCacheBulkResponse = {
  __typename?: 'CreateProviderCacheBulkResponse';
  output: Array<CreateProviderCacheResponse>;
};

export type CreateProviderCacheInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProviderCacheResponse = {
  __typename?: 'CreateProviderCacheResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ProviderCache;
};

export type CreateProviderInput = {
  active: Scalars['Int']['input'];
  addonAutomationAutoIngest?: InputMaybe<Scalars['Int']['input']>;
  billFrequency?: InputMaybe<Scalars['String']['input']>;
  billingAddress?: InputMaybe<Scalars['String']['input']>;
  billingCityCode?: InputMaybe<Scalars['String']['input']>;
  billingStateCode?: InputMaybe<Scalars['String']['input']>;
  billingZipCode?: InputMaybe<Scalars['Int']['input']>;
  companyId: Scalars['String']['input'];
  contactPerson?: InputMaybe<Scalars['String']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  faxNumber?: InputMaybe<Scalars['String']['input']>;
  iataAirlineCode?: InputMaybe<Scalars['String']['input']>;
  importCode?: InputMaybe<ProviderImportCodeEnum>;
  invoiceTermId?: InputMaybe<Scalars['String']['input']>;
  mobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  occPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  primaryAddress?: InputMaybe<Scalars['String']['input']>;
  primaryCityCode?: InputMaybe<Scalars['String']['input']>;
  primaryEmail?: InputMaybe<Scalars['String']['input']>;
  primaryLogoUrl?: InputMaybe<Scalars['String']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  primaryStateCode?: InputMaybe<Scalars['String']['input']>;
  primaryZipCode?: InputMaybe<Scalars['Int']['input']>;
  referenceNumber?: InputMaybe<Scalars['String']['input']>;
  requiresCrewInfo?: InputMaybe<Scalars['Int']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
  type: ProviderTypeEnum;
  website?: InputMaybe<Scalars['String']['input']>;
};

export type CreateProviderLocationMappingBulkInput = {
  values: Array<CreateProviderLocationMappingInput>;
};

export type CreateProviderLocationMappingBulkResponse = {
  __typename?: 'CreateProviderLocationMappingBulkResponse';
  output: Array<CreateProviderLocationMappingResponse>;
};

export type CreateProviderLocationMappingInput = {
  active: Scalars['Int']['input'];
  contractId: Scalars['String']['input'];
  doLocationId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
  puLocationId: Scalars['String']['input'];
};

export type CreateProviderLocationMappingResponse = {
  __typename?: 'CreateProviderLocationMappingResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: ProviderLocationMapping;
};

export type CreateProviderResponse = {
  __typename?: 'CreateProviderResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Provider;
};

export type CreatePunchBulkInput = {
  values: Array<CreatePunchInput>;
};

export type CreatePunchBulkResponse = {
  __typename?: 'CreatePunchBulkResponse';
  output: Array<CreatePunchResponse>;
};

export type CreatePunchHistoryBulkInput = {
  values: Array<CreatePunchHistoryInput>;
};

export type CreatePunchHistoryBulkResponse = {
  __typename?: 'CreatePunchHistoryBulkResponse';
  output: Array<CreatePunchHistoryResponse>;
};

export type CreatePunchHistoryInput = {
  approvalEmployee?: InputMaybe<Scalars['Int']['input']>;
  approvalSupervisor?: InputMaybe<Scalars['Int']['input']>;
  approvalSupervisorBy?: InputMaybe<Scalars['String']['input']>;
  companyCode: Scalars['String']['input'];
  date: Scalars['String']['input'];
  durationOt1?: InputMaybe<Scalars['Float']['input']>;
  durationOt2?: InputMaybe<Scalars['Float']['input']>;
  durationRegular?: InputMaybe<Scalars['Float']['input']>;
  employeeId: Scalars['String']['input'];
  fileLocation?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  payType: Scalars['String']['input'];
  punchInTime: Scalars['String']['input'];
  punchInType: PunchHistoryPunchInTypeEnum;
  punchOutTime: Scalars['String']['input'];
  punchOutType: PunchHistoryPunchOutTypeEnum;
  unpaidDuration?: InputMaybe<Scalars['Float']['input']>;
};

export type CreatePunchHistoryResponse = {
  __typename?: 'CreatePunchHistoryResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: PunchHistory;
};

export type CreatePunchInput = {
  airportCode: Scalars['String']['input'];
  coordinates?: InputMaybe<PointInput>;
  paylocityCompanyId: Scalars['String']['input'];
  paylocityJobCodeId: Scalars['String']['input'];
  punchDatetime: Scalars['String']['input'];
  type: PunchTypeEnum;
  userId: Scalars['String']['input'];
};

export type CreatePunchPolicyBulkInput = {
  values: Array<CreatePunchPolicyInput>;
};

export type CreatePunchPolicyBulkResponse = {
  __typename?: 'CreatePunchPolicyBulkResponse';
  output: Array<CreatePunchPolicyResponse>;
};

export type CreatePunchPolicyInput = {
  companyId: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  eventEndDatetime?: InputMaybe<Scalars['String']['input']>;
  eventStartDatetime?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  minutesIn: Scalars['Int']['input'];
  minutesOut: Scalars['Int']['input'];
  startTime: Scalars['String']['input'];
};

export type CreatePunchPolicyResponse = {
  __typename?: 'CreatePunchPolicyResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: PunchPolicy;
};

export type CreatePunchResponse = {
  __typename?: 'CreatePunchResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Punch;
};

export type CreateQueryHistoryBulkInput = {
  values: Array<CreateQueryHistoryInput>;
};

export type CreateQueryHistoryBulkResponse = {
  __typename?: 'CreateQueryHistoryBulkResponse';
  output: Array<CreateQueryHistoryResponse>;
};

export type CreateQueryHistoryInput = {
  doLocationId: Scalars['String']['input'];
  endDate: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  puLocationId: Scalars['String']['input'];
  startDate: Scalars['String']['input'];
};

export type CreateQueryHistoryResponse = {
  __typename?: 'CreateQueryHistoryResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: QueryHistory;
};

export type CreateQuestionnaireAnswerOptionBulkInput = {
  values: Array<CreateQuestionnaireAnswerOptionInput>;
};

export type CreateQuestionnaireAnswerOptionBulkResponse = {
  __typename?: 'CreateQuestionnaireAnswerOptionBulkResponse';
  output: Array<CreateQuestionnaireAnswerOptionResponse>;
};

export type CreateQuestionnaireAnswerOptionInput = {
  active: Scalars['Int']['input'];
  answerTypeId: Scalars['String']['input'];
  color?: InputMaybe<Scalars['String']['input']>;
  displayLabel: Scalars['String']['input'];
  showsNotes: Scalars['Int']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type CreateQuestionnaireAnswerOptionResponse = {
  __typename?: 'CreateQuestionnaireAnswerOptionResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: QuestionnaireAnswerOption;
};

export type CreateQuestionnaireAnswerTypeBulkInput = {
  values: Array<CreateQuestionnaireAnswerTypeInput>;
};

export type CreateQuestionnaireAnswerTypeBulkResponse = {
  __typename?: 'CreateQuestionnaireAnswerTypeBulkResponse';
  output: Array<CreateQuestionnaireAnswerTypeResponse>;
};

export type CreateQuestionnaireAnswerTypeInput = {
  active: Scalars['Int']['input'];
  allowsNotes: Scalars['Int']['input'];
  displayName: Scalars['String']['input'];
  notesPlaceholder?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuestionnaireAnswerTypeResponse = {
  __typename?: 'CreateQuestionnaireAnswerTypeResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: QuestionnaireAnswerType;
};

export type CreateQuestionnaireAttemptAnswerOptionSnapshotBulkInput = {
  values: Array<CreateQuestionnaireAttemptAnswerOptionSnapshotInput>;
};

export type CreateQuestionnaireAttemptAnswerOptionSnapshotBulkResponse = {
  __typename?: 'CreateQuestionnaireAttemptAnswerOptionSnapshotBulkResponse';
  output: Array<CreateQuestionnaireAttemptAnswerOptionSnapshotResponse>;
};

export type CreateQuestionnaireAttemptAnswerOptionSnapshotInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  displayLabel: Scalars['String']['input'];
  questionnaireAttemptQuestionSnapshotId: Scalars['String']['input'];
  showsNotes: Scalars['Int']['input'];
  sortOrder: Scalars['Int']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuestionnaireAttemptAnswerOptionSnapshotResponse = {
  __typename?: 'CreateQuestionnaireAttemptAnswerOptionSnapshotResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: QuestionnaireAttemptAnswerOptionSnapshot;
};

export type CreateQuestionnaireAttemptBulkInput = {
  values: Array<CreateQuestionnaireAttemptInput>;
};

export type CreateQuestionnaireAttemptBulkResponse = {
  __typename?: 'CreateQuestionnaireAttemptBulkResponse';
  output: Array<CreateQuestionnaireAttemptResponse>;
};

export type CreateQuestionnaireAttemptCategorySnapshotAllowedGroupBulkInput = {
  values: Array<CreateQuestionnaireAttemptCategorySnapshotAllowedGroupInput>;
};

export type CreateQuestionnaireAttemptCategorySnapshotAllowedGroupBulkResponse = {
  __typename?: 'CreateQuestionnaireAttemptCategorySnapshotAllowedGroupBulkResponse';
  output: Array<CreateQuestionnaireAttemptCategorySnapshotAllowedGroupResponse>;
};

export type CreateQuestionnaireAttemptCategorySnapshotAllowedGroupInput = {
  groupId: Scalars['String']['input'];
  questionnaireAttemptCategorySnapshotId: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuestionnaireAttemptCategorySnapshotAllowedGroupResponse = {
  __typename?: 'CreateQuestionnaireAttemptCategorySnapshotAllowedGroupResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: QuestionnaireAttemptCategorySnapshotAllowedGroup;
};

export type CreateQuestionnaireAttemptCategorySnapshotBulkInput = {
  values: Array<CreateQuestionnaireAttemptCategorySnapshotInput>;
};

export type CreateQuestionnaireAttemptCategorySnapshotBulkResponse = {
  __typename?: 'CreateQuestionnaireAttemptCategorySnapshotBulkResponse';
  output: Array<CreateQuestionnaireAttemptCategorySnapshotResponse>;
};

export type CreateQuestionnaireAttemptCategorySnapshotGroupBulkInput = {
  values: Array<CreateQuestionnaireAttemptCategorySnapshotGroupInput>;
};

export type CreateQuestionnaireAttemptCategorySnapshotGroupBulkResponse = {
  __typename?: 'CreateQuestionnaireAttemptCategorySnapshotGroupBulkResponse';
  output: Array<CreateQuestionnaireAttemptCategorySnapshotGroupResponse>;
};

export type CreateQuestionnaireAttemptCategorySnapshotGroupInput = {
  groupId: Scalars['String']['input'];
  groupName: Scalars['String']['input'];
  questionnaireAttemptCategorySnapshotId: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuestionnaireAttemptCategorySnapshotGroupResponse = {
  __typename?: 'CreateQuestionnaireAttemptCategorySnapshotGroupResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: QuestionnaireAttemptCategorySnapshotGroup;
};

export type CreateQuestionnaireAttemptCategorySnapshotInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  questionnaireAttemptId: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
  submittedAt?: InputMaybe<Scalars['String']['input']>;
  submittedBy?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuestionnaireAttemptCategorySnapshotResponse = {
  __typename?: 'CreateQuestionnaireAttemptCategorySnapshotResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: QuestionnaireAttemptCategorySnapshot;
};

export type CreateQuestionnaireAttemptInput = {
  overallResult?: InputMaybe<QuestionnaireAttemptOverallResultEnum>;
  roleId: Scalars['String']['input'];
  subjectHireDate: Scalars['String']['input'];
  subjectUserId: Scalars['String']['input'];
  submittedAt?: InputMaybe<Scalars['String']['input']>;
  submittedBy?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuestionnaireAttemptNoteBulkInput = {
  values: Array<CreateQuestionnaireAttemptNoteInput>;
};

export type CreateQuestionnaireAttemptNoteBulkResponse = {
  __typename?: 'CreateQuestionnaireAttemptNoteBulkResponse';
  output: Array<CreateQuestionnaireAttemptNoteResponse>;
};

export type CreateQuestionnaireAttemptNoteInput = {
  note: Scalars['String']['input'];
  questionnaireAttemptId: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuestionnaireAttemptNoteResponse = {
  __typename?: 'CreateQuestionnaireAttemptNoteResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: QuestionnaireAttemptNote;
};

export type CreateQuestionnaireAttemptQuestionSnapshotBulkInput = {
  values: Array<CreateQuestionnaireAttemptQuestionSnapshotInput>;
};

export type CreateQuestionnaireAttemptQuestionSnapshotBulkResponse = {
  __typename?: 'CreateQuestionnaireAttemptQuestionSnapshotBulkResponse';
  output: Array<CreateQuestionnaireAttemptQuestionSnapshotResponse>;
};

export type CreateQuestionnaireAttemptQuestionSnapshotInput = {
  answerTypeAllowsNotes: Scalars['Int']['input'];
  answerTypeDisplayName: Scalars['String']['input'];
  answerTypeNotesPlaceholder?: InputMaybe<Scalars['String']['input']>;
  helperText?: InputMaybe<Scalars['String']['input']>;
  questionText: Scalars['String']['input'];
  questionnaireAttemptCategorySnapshotId: Scalars['String']['input'];
  selectedAnswerNote?: InputMaybe<Scalars['String']['input']>;
  selectedAnswerOptionId?: InputMaybe<Scalars['String']['input']>;
  sortOrder: Scalars['Int']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateQuestionnaireAttemptQuestionSnapshotResponse = {
  __typename?: 'CreateQuestionnaireAttemptQuestionSnapshotResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: QuestionnaireAttemptQuestionSnapshot;
};

export type CreateQuestionnaireAttemptResponse = {
  __typename?: 'CreateQuestionnaireAttemptResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: QuestionnaireAttempt;
};

export type CreateQuestionnaireCategoryBulkInput = {
  values: Array<CreateQuestionnaireCategoryInput>;
};

export type CreateQuestionnaireCategoryBulkResponse = {
  __typename?: 'CreateQuestionnaireCategoryBulkResponse';
  output: Array<CreateQuestionnaireCategoryResponse>;
};

export type CreateQuestionnaireCategoryInput = {
  active: Scalars['Int']['input'];
  answerTypeId?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type CreateQuestionnaireCategoryResponse = {
  __typename?: 'CreateQuestionnaireCategoryResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: QuestionnaireCategory;
};

export type CreateQuestionnaireCategoryWithGroupsInput = {
  values: Array<CreateQuestionnaireCategoryWithGroupsItemInput>;
};

export type CreateQuestionnaireCategoryWithGroupsItemInput = {
  category: CreateQuestionnaireCategoryInput;
  groupIds: Array<Scalars['String']['input']>;
};

export type CreateQuestionnaireCategoryWithGroupsResponse = {
  __typename?: 'CreateQuestionnaireCategoryWithGroupsResponse';
  output: Array<QuestionnaireCategoryWithGroups>;
};

export type CreateQuestionnaireQuestionBulkInput = {
  values: Array<CreateQuestionnaireQuestionInput>;
};

export type CreateQuestionnaireQuestionBulkResponse = {
  __typename?: 'CreateQuestionnaireQuestionBulkResponse';
  output: Array<CreateQuestionnaireQuestionResponse>;
};

export type CreateQuestionnaireQuestionInput = {
  active: Scalars['Int']['input'];
  answerTypeId: Scalars['String']['input'];
  helperText?: InputMaybe<Scalars['String']['input']>;
  questionText: Scalars['String']['input'];
  questionnaireCategoryId: Scalars['String']['input'];
  sortOrder: Scalars['Int']['input'];
};

export type CreateQuestionnaireQuestionResponse = {
  __typename?: 'CreateQuestionnaireQuestionResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: QuestionnaireQuestion;
};

export type CreateRateBulkInput = {
  values: Array<CreateRateInput>;
};

export type CreateRateBulkResponse = {
  __typename?: 'CreateRateBulkResponse';
  output: Array<CreateRateResponse>;
};

export type CreateRateForTripsInput = {
  createRateRequest: CreateRateInput;
  tripIds: Array<Scalars['String']['input']>;
};

export type CreateRateForTripsResponse = {
  __typename?: 'CreateRateForTripsResponse';
  count?: Maybe<Scalars['Int']['output']>;
  rate?: Maybe<Rate>;
};

export type CreateRateGroupBulkInput = {
  values: Array<CreateRateGroupInput>;
};

export type CreateRateGroupBulkResponse = {
  __typename?: 'CreateRateGroupBulkResponse';
  output: Array<CreateRateGroupResponse>;
};

export type CreateRateGroupInput = {
  airportCode?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  duration?: InputMaybe<Scalars['Int']['input']>;
  items: Array<CreateRateItemAndAmountInput>;
  payerProviderId?: InputMaybe<Scalars['String']['input']>;
  thatLocationId: Scalars['String']['input'];
  thisLocationId: Scalars['String']['input'];
  tripDistance?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateRateGroupResponse = {
  __typename?: 'CreateRateGroupResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: RateGroup;
};

export type CreateRateHistoryBulkInput = {
  values: Array<CreateRateHistoryInput>;
};

export type CreateRateHistoryBulkResponse = {
  __typename?: 'CreateRateHistoryBulkResponse';
  output: Array<CreateRateHistoryResponse>;
};

export type CreateRateHistoryInput = {
  currency: RateHistoryCurrencyEnum;
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  rate: Scalars['Float']['input'];
  rateGroupId: Scalars['String']['input'];
  rateItemId?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['String']['input']>;
  type: RateHistoryTypeEnum;
};

export type CreateRateHistoryResponse = {
  __typename?: 'CreateRateHistoryResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: RateHistory;
};

export type CreateRateInput = {
  airportCode?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  contractEndDatetime?: InputMaybe<Scalars['String']['input']>;
  contractId?: InputMaybe<Scalars['String']['input']>;
  contractStartDatetime?: InputMaybe<Scalars['String']['input']>;
  currency: RateCurrencyEnum;
  duration?: InputMaybe<Scalars['Int']['input']>;
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  notes: Scalars['String']['input'];
  payerProviderId?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  radius: Scalars['Int']['input'];
  rate: Scalars['Float']['input'];
  startDatetime?: InputMaybe<Scalars['String']['input']>;
  thatLocationId: Scalars['String']['input'];
  thisLocationId: Scalars['String']['input'];
  tripDistance?: InputMaybe<Scalars['Int']['input']>;
  type: RateTypeEnum;
};

export type CreateRateItemAndAmountInput = {
  currency: RateItemCurrencyEnum;
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  rate: Scalars['Float']['input'];
  startDatetime: Scalars['String']['input'];
  type: RateItemTypeEnum;
};

export type CreateRateItemBulkInput = {
  values: Array<CreateRateItemInput>;
};

export type CreateRateItemBulkResponse = {
  __typename?: 'CreateRateItemBulkResponse';
  output: Array<CreateRateItemResponse>;
};

export type CreateRateItemInput = {
  currency: RateItemCurrencyEnum;
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  rate: Scalars['Float']['input'];
  rateGroupId: Scalars['String']['input'];
  startDatetime: Scalars['String']['input'];
  type: RateItemTypeEnum;
};

export type CreateRateItemResponse = {
  __typename?: 'CreateRateItemResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: RateItem;
};

export type CreateRateResponse = {
  __typename?: 'CreateRateResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Rate;
};

export type CreateRatingBulkInput = {
  values: Array<CreateRatingInput>;
};

export type CreateRatingBulkResponse = {
  __typename?: 'CreateRatingBulkResponse';
  output: Array<CreateRatingResponse>;
};

export type CreateRatingCacheBulkInput = {
  values: Array<CreateRatingCacheInput>;
};

export type CreateRatingCacheBulkResponse = {
  __typename?: 'CreateRatingCacheBulkResponse';
  output: Array<CreateRatingCacheResponse>;
};

export type CreateRatingCacheInput = {
  airportCode?: InputMaybe<Scalars['String']['input']>;
  airportGroupName?: InputMaybe<Scalars['String']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  companyId?: InputMaybe<Scalars['String']['input']>;
  companyName?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['Int']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  payerProviderId?: InputMaybe<Scalars['String']['input']>;
  payerProviderName?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
  ratingCreatedAt: Scalars['String']['input'];
  ratingScore?: InputMaybe<Scalars['Float']['input']>;
  ratingTypeName?: InputMaybe<Scalars['String']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['String']['input']>;
  tripId: Scalars['String']['input'];
  tripScheduled?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CreateRatingCacheRemarkBulkInput = {
  values: Array<CreateRatingCacheRemarkInput>;
};

export type CreateRatingCacheRemarkBulkResponse = {
  __typename?: 'CreateRatingCacheRemarkBulkResponse';
  output: Array<CreateRatingCacheRemarkResponse>;
};

export type CreateRatingCacheRemarkInput = {
  ratingCacheId: Scalars['String']['input'];
  remark: Scalars['String']['input'];
};

export type CreateRatingCacheRemarkResponse = {
  __typename?: 'CreateRatingCacheRemarkResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: RatingCacheRemark;
};

export type CreateRatingCacheResponse = {
  __typename?: 'CreateRatingCacheResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: RatingCache;
};

export type CreateRatingInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  rating: Scalars['Int']['input'];
  ratingScore?: InputMaybe<Scalars['Float']['input']>;
  ratingTypeId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateRatingRemarkBulkInput = {
  values: Array<CreateRatingRemarkInput>;
};

export type CreateRatingRemarkBulkResponse = {
  __typename?: 'CreateRatingRemarkBulkResponse';
  output: Array<CreateRatingRemarkResponse>;
};

export type CreateRatingRemarkInput = {
  ratingId: Scalars['String']['input'];
  remark: Scalars['String']['input'];
};

export type CreateRatingRemarkResponse = {
  __typename?: 'CreateRatingRemarkResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: RatingRemark;
};

export type CreateRatingResponse = {
  __typename?: 'CreateRatingResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Rating;
};

export type CreateRatingTypeBulkInput = {
  values: Array<CreateRatingTypeInput>;
};

export type CreateRatingTypeBulkResponse = {
  __typename?: 'CreateRatingTypeBulkResponse';
  output: Array<CreateRatingTypeResponse>;
};

export type CreateRatingTypeInput = {
  name: Scalars['String']['input'];
};

export type CreateRatingTypeResponse = {
  __typename?: 'CreateRatingTypeResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: RatingType;
};

export type CreateRemarksInput = {
  remarks: Array<RemarkInput>;
};

export type CreateRemarksResponse = {
  __typename?: 'CreateRemarksResponse';
  remarks: Array<RemarkResponse>;
};

export type CreateRoleBulkInput = {
  values: Array<CreateRoleInput>;
};

export type CreateRoleBulkResponse = {
  __typename?: 'CreateRoleBulkResponse';
  output: Array<CreateRoleResponse>;
};

export type CreateRoleInput = {
  name: Scalars['String']['input'];
};

export type CreateRoleResponse = {
  __typename?: 'CreateRoleResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Role;
};

export type CreateSettingsBulkInput = {
  values: Array<CreateSettingsInput>;
};

export type CreateSettingsBulkResponse = {
  __typename?: 'CreateSettingsBulkResponse';
  output: Array<CreateSettingsResponse>;
};

export type CreateSettingsInput = {
  chatReadTime?: InputMaybe<Scalars['Int']['input']>;
  crewChatReadTime?: InputMaybe<Scalars['Int']['input']>;
  messageReadTime?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  outboundLateAlertMinutes?: InputMaybe<Scalars['Int']['input']>;
  passwordExpirationDays?: InputMaybe<Scalars['Int']['input']>;
  vehicleTrackingVendor?: InputMaybe<SettingsVehicleTrackingVendorEnum>;
  vehicleTrackingVendorToken?: InputMaybe<Scalars['String']['input']>;
};

export type CreateSettingsResponse = {
  __typename?: 'CreateSettingsResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Settings;
};

export type CreateSocialDistanceRuleBulkInput = {
  values: Array<CreateSocialDistanceRuleInput>;
};

export type CreateSocialDistanceRuleBulkResponse = {
  __typename?: 'CreateSocialDistanceRuleBulkResponse';
  output: Array<CreateSocialDistanceRuleResponse>;
};

export type CreateSocialDistanceRuleInput = {
  active: Scalars['Int']['input'];
  contractId: Scalars['String']['input'];
  max: Scalars['Int']['input'];
  type?: InputMaybe<SocialDistanceRuleTypeEnum>;
};

export type CreateSocialDistanceRuleResponse = {
  __typename?: 'CreateSocialDistanceRuleResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: SocialDistanceRule;
};

export type CreateStagedTripBulkInput = {
  values: Array<CreateStagedTripInput>;
};

export type CreateStagedTripBulkResponse = {
  __typename?: 'CreateStagedTripBulkResponse';
  output: Array<CreateStagedTripResponse>;
};

export type CreateStagedTripInput = {
  airportCode: Scalars['String']['input'];
  attendants: Scalars['Int']['input'];
  bufferMinutes: Scalars['Int']['input'];
  combineId?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  crewId?: InputMaybe<Scalars['Int']['input']>;
  doLocationId: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  flightNumber?: InputMaybe<Scalars['Int']['input']>;
  fromManifest: Scalars['Int']['input'];
  importId: Scalars['String']['input'];
  importTime?: InputMaybe<Scalars['String']['input']>;
  ingestAction: StagedTripIngestActionEnum;
  kind: StagedTripKindEnum;
  lastName?: InputMaybe<Scalars['String']['input']>;
  loopName?: InputMaybe<Scalars['String']['input']>;
  payerProviderId: Scalars['String']['input'];
  pilots: Scalars['Int']['input'];
  potentialTripId?: InputMaybe<Scalars['String']['input']>;
  puLocationId: Scalars['String']['input'];
  scheduled: Scalars['String']['input'];
  servicerIataAirlineCode: Scalars['String']['input'];
  split: Scalars['Int']['input'];
  statusName: StagedTripStatusNameEnum;
  traceId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
  typeName: StagedTripTypeNameEnum;
};

export type CreateStagedTripResponse = {
  __typename?: 'CreateStagedTripResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: StagedTrip;
};

export type CreateStopBulkInput = {
  values: Array<CreateStopInput>;
};

export type CreateStopBulkResponse = {
  __typename?: 'CreateStopBulkResponse';
  output: Array<CreateStopResponse>;
};

export type CreateStopInput = {
  actual?: InputMaybe<Scalars['String']['input']>;
  airportCode?: InputMaybe<Scalars['String']['input']>;
  completed?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  scheduled: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
  type: StopTypeEnum;
};

export type CreateStopResponse = {
  __typename?: 'CreateStopResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Stop;
};

export type CreateStorageBulkInput = {
  values: Array<CreateStorageInput>;
};

export type CreateStorageBulkResponse = {
  __typename?: 'CreateStorageBulkResponse';
  output: Array<CreateStorageResponse>;
};

export type CreateStorageInput = {
  key: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['String']['input'];
};

export type CreateStorageResponse = {
  __typename?: 'CreateStorageResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Storage;
};

export type CreateTimeFrameBulkInput = {
  values: Array<CreateTimeFrameInput>;
};

export type CreateTimeFrameBulkResponse = {
  __typename?: 'CreateTimeFrameBulkResponse';
  output: Array<CreateTimeFrameResponse>;
};

export type CreateTimeFrameInput = {
  name: Scalars['String']['input'];
};

export type CreateTimeFrameRangeBulkInput = {
  values: Array<CreateTimeFrameRangeInput>;
};

export type CreateTimeFrameRangeBulkResponse = {
  __typename?: 'CreateTimeFrameRangeBulkResponse';
  output: Array<CreateTimeFrameRangeResponse>;
};

export type CreateTimeFrameRangeInput = {
  endTime: Scalars['String']['input'];
  name: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  timeFrameId: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTimeFrameRangeResponse = {
  __typename?: 'CreateTimeFrameRangeResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: TimeFrameRange;
};

export type CreateTimeFrameResponse = {
  __typename?: 'CreateTimeFrameResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: TimeFrame;
};

export type CreateTrackFlightBulkInput = {
  values: Array<CreateTrackFlightInput>;
};

export type CreateTrackFlightBulkResponse = {
  __typename?: 'CreateTrackFlightBulkResponse';
  output: Array<CreateTrackFlightResponse>;
};

export type CreateTrackFlightInput = {
  actual?: InputMaybe<Scalars['String']['input']>;
  arrivalGate?: InputMaybe<Scalars['String']['input']>;
  arrivalTerminal?: InputMaybe<Scalars['String']['input']>;
  arrivalTimezone?: InputMaybe<Scalars['String']['input']>;
  arrivalUtcOffsetHours?: InputMaybe<Scalars['String']['input']>;
  departureGate?: InputMaybe<Scalars['String']['input']>;
  departureTerminal?: InputMaybe<Scalars['String']['input']>;
  departureTimezone?: InputMaybe<Scalars['String']['input']>;
  departureUtcOffsetHours?: InputMaybe<Scalars['String']['input']>;
  flightHistoryId?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<TrackFlightLabelEnum>;
  landedAt?: InputMaybe<Scalars['String']['input']>;
  lastPingTime?: InputMaybe<Scalars['String']['input']>;
  lastWebhookReceivedAt?: InputMaybe<Scalars['String']['input']>;
  nextPingTime?: InputMaybe<Scalars['String']['input']>;
  number: Scalars['Int']['input'];
  raw: Scalars['String']['input'];
  scheduled: Scalars['String']['input'];
  servicerIataAirlineCode: Scalars['String']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
  trackerProvider?: InputMaybe<Scalars['String']['input']>;
  tripId: Scalars['String']['input'];
  type?: InputMaybe<TrackFlightTypeEnum>;
};

export type CreateTrackFlightResponse = {
  __typename?: 'CreateTrackFlightResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: TrackFlight;
};

export type CreateTrainingUserCacheBulkInput = {
  values: Array<CreateTrainingUserCacheInput>;
};

export type CreateTrainingUserCacheBulkResponse = {
  __typename?: 'CreateTrainingUserCacheBulkResponse';
  output: Array<CreateTrainingUserCacheResponse>;
};

export type CreateTrainingUserCacheInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  primaryAirportCode?: InputMaybe<Scalars['String']['input']>;
  roleId?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
};

export type CreateTrainingUserCacheResponse = {
  __typename?: 'CreateTrainingUserCacheResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: TrainingUserCache;
};

export type CreateTripBulkInput = {
  values: Array<CreateTripInput>;
};

export type CreateTripBulkResponse = {
  __typename?: 'CreateTripBulkResponse';
  output: Array<CreateTripResponse>;
};

export type CreateTripDocumentBulkInput = {
  values: Array<CreateTripDocumentInput>;
};

export type CreateTripDocumentBulkResponse = {
  __typename?: 'CreateTripDocumentBulkResponse';
  output: Array<CreateTripDocumentResponse>;
};

export type CreateTripDocumentInput = {
  contentType: Scalars['String']['input'];
  fileLocation: Scalars['String']['input'];
  fileSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  md5: Scalars['String']['input'];
  traceId?: InputMaybe<Scalars['String']['input']>;
  tripId: Scalars['String']['input'];
};

export type CreateTripDocumentPresignedUploadUrlInput = {
  fileSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  md5: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};

export type CreateTripDocumentPresignedUploadUrlResponse = {
  __typename?: 'CreateTripDocumentPresignedUploadUrlResponse';
  contentType?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type CreateTripDocumentResponse = {
  __typename?: 'CreateTripDocumentResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: TripDocument;
};

export type CreateTripDownloadUrlInput = {
  tripId: Array<Scalars['String']['input']>;
};

export type CreateTripDownloadUrlResponse = {
  __typename?: 'CreateTripDownloadUrlResponse';
  urls?: Maybe<Array<TripDownloadUrlObject>>;
};

export type CreateTripHasImportBulkInput = {
  values: Array<CreateTripHasImportInput>;
};

export type CreateTripHasImportBulkResponse = {
  __typename?: 'CreateTripHasImportBulkResponse';
  output: Array<CreateTripHasImportResponse>;
};

export type CreateTripHasImportInput = {
  importId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};

export type CreateTripHasImportResponse = {
  __typename?: 'CreateTripHasImportResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: TripHasImport;
};

export type CreateTripInput = {
  airportCode: Scalars['String']['input'];
  attendants: Scalars['Int']['input'];
  comments?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  completionId?: InputMaybe<Scalars['String']['input']>;
  crewId?: InputMaybe<Scalars['Int']['input']>;
  doActualDatetime?: InputMaybe<Scalars['String']['input']>;
  doAirportCode?: InputMaybe<Scalars['String']['input']>;
  doLocationId: Scalars['String']['input'];
  documents?: InputMaybe<Array<CreateTripDocumentInput>>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  flightNumber: Scalars['Int']['input'];
  fromManifest: Scalars['Boolean']['input'];
  kind: TripKindEnum;
  lastName?: InputMaybe<Scalars['String']['input']>;
  loopName: Scalars['String']['input'];
  manifestImportId?: InputMaybe<Scalars['String']['input']>;
  payerProviderId: Scalars['String']['input'];
  pilots: Scalars['Int']['input'];
  providerId?: InputMaybe<Scalars['String']['input']>;
  puActualDatetime?: InputMaybe<Scalars['String']['input']>;
  puCompletedDatetime?: InputMaybe<Scalars['String']['input']>;
  puLocationId: Scalars['String']['input'];
  rateId?: InputMaybe<Scalars['String']['input']>;
  scheduled: Scalars['String']['input'];
  servicerIataAirlineCode: Scalars['String']['input'];
  split: Scalars['Int']['input'];
  status: TripStatusEnum;
  traceId?: InputMaybe<Scalars['String']['input']>;
  trackFlightId?: InputMaybe<Scalars['String']['input']>;
  type: TripTypeEnum;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTripResponse = {
  __typename?: 'CreateTripResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Trip;
};

export type CreateTripScheduleTriggerBulkInput = {
  values: Array<CreateTripScheduleTriggerInput>;
};

export type CreateTripScheduleTriggerBulkResponse = {
  __typename?: 'CreateTripScheduleTriggerBulkResponse';
  output: Array<CreateTripScheduleTriggerResponse>;
};

export type CreateTripScheduleTriggerInput = {
  accidentIssueCount?: InputMaybe<Scalars['Int']['input']>;
  communicationCount: Scalars['Int']['input'];
  completionTypeDisplayName?: InputMaybe<Scalars['String']['input']>;
  dispatchIssueCount?: InputMaybe<Scalars['Int']['input']>;
  doLocationAddress?: InputMaybe<Scalars['String']['input']>;
  doLocationCityName?: InputMaybe<Scalars['String']['input']>;
  doLocationCoordinates?: InputMaybe<PointInput>;
  doLocationId?: InputMaybe<Scalars['String']['input']>;
  doLocationName?: InputMaybe<Scalars['String']['input']>;
  doLocationPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  doLocationStateCode?: InputMaybe<Scalars['String']['input']>;
  doLocationZipCode?: InputMaybe<Scalars['String']['input']>;
  driverAvatar?: InputMaybe<Scalars['String']['input']>;
  driverEmployeeId?: InputMaybe<Scalars['String']['input']>;
  driverEtaDatetime?: InputMaybe<Scalars['String']['input']>;
  driverEtaId?: InputMaybe<Scalars['String']['input']>;
  driverEtaMinutes?: InputMaybe<Scalars['Int']['input']>;
  driverFirstName?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  driverLastName?: InputMaybe<Scalars['String']['input']>;
  fcrCount: Scalars['Int']['input'];
  flagColors?: InputMaybe<Scalars['String']['input']>;
  hasPaperwork?: InputMaybe<Scalars['Int']['input']>;
  incidentIssueCount?: InputMaybe<Scalars['Int']['input']>;
  latestScheduled?: InputMaybe<Scalars['String']['input']>;
  latestScheduledUtc?: InputMaybe<Scalars['String']['input']>;
  latestTriggerUsed?: InputMaybe<Scalars['String']['input']>;
  lostAndFoundIssueCount?: InputMaybe<Scalars['Int']['input']>;
  payerProviderDisplayName?: InputMaybe<Scalars['String']['input']>;
  payerProviderId?: InputMaybe<Scalars['String']['input']>;
  puLocationAddress?: InputMaybe<Scalars['String']['input']>;
  puLocationCityName?: InputMaybe<Scalars['String']['input']>;
  puLocationCoordinates?: InputMaybe<PointInput>;
  puLocationId?: InputMaybe<Scalars['String']['input']>;
  puLocationName?: InputMaybe<Scalars['String']['input']>;
  puLocationPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  puLocationStateCode?: InputMaybe<Scalars['String']['input']>;
  puLocationZipCode?: InputMaybe<Scalars['String']['input']>;
  scheduledUtc: Scalars['String']['input'];
  stopCount: Scalars['Int']['input'];
  tripId: Scalars['String']['input'];
  vehicleCapacity?: InputMaybe<Scalars['Int']['input']>;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
  vehicleMake?: InputMaybe<Scalars['String']['input']>;
  vehicleModel?: InputMaybe<Scalars['String']['input']>;
  vehiclePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  vehicleTrackingId?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTripScheduleTriggerResponse = {
  __typename?: 'CreateTripScheduleTriggerResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: TripScheduleTrigger;
};

export type CreateTripsInput = {
  values: Array<CreateTripInput>;
};

export type CreateTripsResponse = {
  __typename?: 'CreateTripsResponse';
  response: Array<TripResponse>;
};

export type CreateUpdateStrategyBulkInput = {
  values: Array<CreateUpdateStrategyInput>;
};

export type CreateUpdateStrategyBulkResponse = {
  __typename?: 'CreateUpdateStrategyBulkResponse';
  output: Array<CreateUpdateStrategyResponse>;
};

export type CreateUpdateStrategyInput = {
  active: Scalars['Int']['input'];
  addonScheduledComparisonWindowMinutes?: InputMaybe<Scalars['Int']['input']>;
  addonStrategy: UpdateStrategyAddonStrategyEnum;
  addonType: UpdateStrategyAddonTypeEnum;
  contractId: Scalars['String']['input'];
  customAddonToleranceMinutes?: InputMaybe<Scalars['Int']['input']>;
  dailyStrategy: UpdateStrategyDailyStrategyEnum;
  importNameIncludesHotels: Scalars['Int']['input'];
  manifestAutomationDeleteStrategy: UpdateStrategyManifestAutomationDeleteStrategyEnum;
  manifestStrategy: UpdateStrategyManifestStrategyEnum;
  previewTimeoutMinutes?: InputMaybe<Scalars['Int']['input']>;
  strategy: UpdateStrategyStrategyEnum;
  updateKindFromLocations: Scalars['Int']['input'];
};

export type CreateUpdateStrategyResponse = {
  __typename?: 'CreateUpdateStrategyResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: UpdateStrategy;
};

export type CreateUserAvailabilityBulkInput = {
  values: Array<CreateUserAvailabilityInput>;
};

export type CreateUserAvailabilityBulkResponse = {
  __typename?: 'CreateUserAvailabilityBulkResponse';
  output: Array<CreateUserAvailabilityResponse>;
};

export type CreateUserAvailabilityDriverAppInput = {
  values: Array<CreateUserAvailabilityInput>;
};

export type CreateUserAvailabilityDriverAppResponse = {
  __typename?: 'CreateUserAvailabilityDriverAppResponse';
  Output?: Maybe<Array<Maybe<CreateUserAvailabilityResponse>>>;
  error?: Maybe<Error>;
};

export type CreateUserAvailabilityInput = {
  approved?: InputMaybe<Scalars['Int']['input']>;
  availabilityType?: InputMaybe<Scalars['String']['input']>;
  dayOfWeek: Scalars['Int']['input'];
  endDate: Scalars['String']['input'];
  endTime: Scalars['String']['input'];
  reason?: InputMaybe<Scalars['String']['input']>;
  repeatUntil?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  startTime: Scalars['String']['input'];
  type?: InputMaybe<UserAvailabilityTypeEnum>;
  userId: Scalars['String']['input'];
};

export type CreateUserAvailabilityResponse = {
  __typename?: 'CreateUserAvailabilityResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: UserAvailability;
};

export type CreateUserBulkInput = {
  values: Array<CreateUserInput>;
};

export type CreateUserBulkResponse = {
  __typename?: 'CreateUserBulkResponse';
  output: Array<CreateUserResponse>;
};

export type CreateUserCacheBulkInput = {
  values: Array<CreateUserCacheInput>;
};

export type CreateUserCacheBulkResponse = {
  __typename?: 'CreateUserCacheBulkResponse';
  output: Array<CreateUserCacheResponse>;
};

export type CreateUserCacheInput = {
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
};

export type CreateUserCacheResponse = {
  __typename?: 'CreateUserCacheResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: UserCache;
};

export type CreateUserHasAirportBulkInput = {
  values: Array<CreateUserHasAirportInput>;
};

export type CreateUserHasAirportBulkResponse = {
  __typename?: 'CreateUserHasAirportBulkResponse';
  output: Array<CreateUserHasAirportResponse>;
};

export type CreateUserHasAirportInput = {
  airportCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type CreateUserHasAirportResponse = {
  __typename?: 'CreateUserHasAirportResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: UserHasAirport;
};

export type CreateUserInput = {
  active: Scalars['Int']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  cityName?: InputMaybe<Scalars['String']['input']>;
  companyId: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['Int']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  lastLogin?: InputMaybe<Scalars['String']['input']>;
  lastLoginOffset?: InputMaybe<Scalars['String']['input']>;
  lastLoginTimezone?: InputMaybe<Scalars['String']['input']>;
  lastLoginUtc?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  longTrip?: InputMaybe<Scalars['Int']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  phone?: InputMaybe<Scalars['String']['input']>;
  primaryAirportCode?: InputMaybe<Scalars['String']['input']>;
  providerId?: InputMaybe<Scalars['String']['input']>;
  resetClientIp?: InputMaybe<Scalars['String']['input']>;
  resetCode?: InputMaybe<Scalars['String']['input']>;
  resetCreatedAtUtc?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
  startDate?: InputMaybe<Scalars['String']['input']>;
  stateCode?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  traceId?: InputMaybe<Scalars['String']['input']>;
  username: Scalars['String']['input'];
  vehicleId?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUserResponse = {
  __typename?: 'CreateUserResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: User;
};

export type CreateVariableTimeBulkInput = {
  values: Array<CreateVariableTimeInput>;
};

export type CreateVariableTimeBulkResponse = {
  __typename?: 'CreateVariableTimeBulkResponse';
  output: Array<CreateVariableTimeResponse>;
};

export type CreateVariableTimeInput = {
  airportCode: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
  inboundDomestic?: InputMaybe<Scalars['Int']['input']>;
  inboundInternational?: InputMaybe<Scalars['Int']['input']>;
  outbound?: InputMaybe<Scalars['Int']['input']>;
  servicerIataAirlineCode: Scalars['String']['input'];
};

export type CreateVariableTimeResponse = {
  __typename?: 'CreateVariableTimeResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: VariableTime;
};

export type CreateVehicleBulkInput = {
  values: Array<CreateVehicleInput>;
};

export type CreateVehicleBulkResponse = {
  __typename?: 'CreateVehicleBulkResponse';
  output: Array<CreateVehicleResponse>;
};

export type CreateVehicleInput = {
  active: Scalars['Int']['input'];
  airportPermitExpirationDate?: InputMaybe<Scalars['String']['input']>;
  capacity: Scalars['Int']['input'];
  emissionPermitExpirationDate?: InputMaybe<Scalars['String']['input']>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  locationId: Scalars['String']['input'];
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  registrationExpirationDate?: InputMaybe<Scalars['String']['input']>;
  stateRegistered?: InputMaybe<Scalars['String']['input']>;
  tollTag?: InputMaybe<Scalars['String']['input']>;
  tracker: VehicleTrackerEnum;
  trackingId: Scalars['String']['input'];
  vin: Scalars['String']['input'];
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateVehicleResponse = {
  __typename?: 'CreateVehicleResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Vehicle;
};

export type CreateWidgetBulkInput = {
  values: Array<CreateWidgetInput>;
};

export type CreateWidgetBulkResponse = {
  __typename?: 'CreateWidgetBulkResponse';
  output: Array<CreateWidgetResponse>;
};

export type CreateWidgetFilterBulkInput = {
  values: Array<CreateWidgetFilterInput>;
};

export type CreateWidgetFilterBulkResponse = {
  __typename?: 'CreateWidgetFilterBulkResponse';
  output: Array<CreateWidgetFilterResponse>;
};

export type CreateWidgetFilterInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type CreateWidgetFilterResponse = {
  __typename?: 'CreateWidgetFilterResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: WidgetFilter;
};

export type CreateWidgetInput = {
  dashboardId: Scalars['String']['input'];
  filters?: InputMaybe<Array<InputMaybe<CreateWidgetFilterInput>>>;
  height: Scalars['Int']['input'];
  positionX: Scalars['Int']['input'];
  positionY: Scalars['Int']['input'];
  type: Scalars['String']['input'];
  width: Scalars['Int']['input'];
};

export type CreateWidgetResponse = {
  __typename?: 'CreateWidgetResponse';
  error?: Maybe<Scalars['String']['output']>;
  node: Widget;
};

export type CrewCheckinInput = {
  curbsideDatetimeUtc?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  tripId: Array<Scalars['String']['input']>;
};

export type CrewCheckinResponse = {
  __typename?: 'CrewCheckinResponse';
  error?: Maybe<Error>;
};

export type CrewCountRequirement = {
  __typename?: 'CrewCountRequirement';
  airportCode?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  enabled: Scalars['Int']['output'];
  flightNumber?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  payerProviderId?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type CrewCountRequirementActivityConnection = {
  __typename?: 'CrewCountRequirementActivityConnection';
  edges?: Maybe<Array<Maybe<CrewCountRequirementActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CrewCountRequirementActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type CrewCountRequirementActivityEdge = {
  __typename?: 'CrewCountRequirementActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type CrewCountRequirementConnection = {
  __typename?: 'CrewCountRequirementConnection';
  edges?: Maybe<Array<Maybe<CrewCountRequirementEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type CrewCountRequirementConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<CrewCountRequirementMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<CrewCountRequirementSearch>>;
};

export type CrewCountRequirementEdge = {
  __typename?: 'CrewCountRequirementEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<CrewCountRequirement>;
};

export type CrewCountRequirementMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CrewCountRequirementSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  enabled?: InputMaybe<Array<IntSearch>>;
  flightNumber?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type CrewNoShowInput = {
  comment: Scalars['String']['input'];
  datetime: Scalars['String']['input'];
  tripId?: InputMaybe<Scalars['String']['input']>;
  tripIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CrewNoShowResponse = {
  __typename?: 'CrewNoShowResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type Dashboard = {
  __typename?: 'Dashboard';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type DashboardActivityConnection = {
  __typename?: 'DashboardActivityConnection';
  edges?: Maybe<Array<Maybe<DashboardActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DashboardActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DashboardActivityEdge = {
  __typename?: 'DashboardActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DashboardConnection = {
  __typename?: 'DashboardConnection';
  edges?: Maybe<Array<Maybe<DashboardEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DashboardConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DashboardMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DashboardSearch>>;
};

export type DashboardEdge = {
  __typename?: 'DashboardEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Dashboard>;
};

export type DashboardMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DashboardSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export enum DatetimeFormatEnum {
  DfDate = 'DF_DATE',
  DfDatetime = 'DF_DATETIME',
  DfTime = 'DF_TIME'
}

export type Defect = {
  __typename?: 'Defect';
  comment: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dvirId: Scalars['String']['output'];
  externalCreatedAt?: Maybe<Scalars['String']['output']>;
  externalDefectId: Scalars['String']['output'];
  externalResolvedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isResolved: Scalars['Int']['output'];
  mechanicNotes?: Maybe<Scalars['String']['output']>;
  mechanicNotesUpdatedAt?: Maybe<Scalars['String']['output']>;
  resolvedAt?: Maybe<Scalars['String']['output']>;
  resolvedByUserName?: Maybe<Scalars['String']['output']>;
  resolvedByUserType?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DefectActivityConnection = {
  __typename?: 'DefectActivityConnection';
  edges?: Maybe<Array<Maybe<DefectActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DefectActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DefectActivityEdge = {
  __typename?: 'DefectActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DefectConnection = {
  __typename?: 'DefectConnection';
  edges?: Maybe<Array<Maybe<DefectEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DefectConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DefectMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DefectSearch>>;
};

export type DefectEdge = {
  __typename?: 'DefectEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Defect>;
};

export type DefectMaskInput = {
  comment?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  dvirId?: InputMaybe<Scalars['Boolean']['input']>;
  externalCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  externalDefectId?: InputMaybe<Scalars['Boolean']['input']>;
  externalResolvedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  mechanicNotes?: InputMaybe<Scalars['Boolean']['input']>;
  mechanicNotesUpdatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedAt?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedByUserName?: InputMaybe<Scalars['Boolean']['input']>;
  resolvedByUserType?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DefectSearch = {
  comment?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  dvirId?: InputMaybe<Array<StringSearch>>;
  externalCreatedAt?: InputMaybe<Array<StringSearch>>;
  externalDefectId?: InputMaybe<Array<StringSearch>>;
  externalResolvedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  isResolved?: InputMaybe<Array<IntSearch>>;
  mechanicNotes?: InputMaybe<Array<StringSearch>>;
  mechanicNotesUpdatedAt?: InputMaybe<Array<StringSearch>>;
  resolvedAt?: InputMaybe<Array<StringSearch>>;
  resolvedByUserName?: InputMaybe<Array<StringSearch>>;
  resolvedByUserType?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type DeleteAccidentIssueBulkInput = {
  search: Array<DeleteAccidentIssueInput>;
};

export type DeleteAccidentIssueBulkResponse = {
  __typename?: 'DeleteAccidentIssueBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAccidentIssueDocumentBulkInput = {
  search: Array<DeleteAccidentIssueDocumentInput>;
};

export type DeleteAccidentIssueDocumentBulkResponse = {
  __typename?: 'DeleteAccidentIssueDocumentBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAccidentIssueDocumentInput = {
  id: Scalars['String']['input'];
};

export type DeleteAccidentIssueInput = {
  id: Scalars['String']['input'];
};

export type DeleteActivityBulkInput = {
  search: Array<DeleteActivityInput>;
};

export type DeleteActivityBulkResponse = {
  __typename?: 'DeleteActivityBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteActivityInput = {
  id: Scalars['String']['input'];
};

export type DeleteActivityObjectBulkInput = {
  search: Array<DeleteActivityObjectInput>;
};

export type DeleteActivityObjectBulkResponse = {
  __typename?: 'DeleteActivityObjectBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteActivityObjectInput = {
  id: Scalars['String']['input'];
};

export type DeleteAirportBulkInput = {
  search: Array<DeleteAirportInput>;
};

export type DeleteAirportBulkResponse = {
  __typename?: 'DeleteAirportBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAirportGroupBulkInput = {
  search: Array<DeleteAirportGroupInput>;
};

export type DeleteAirportGroupBulkResponse = {
  __typename?: 'DeleteAirportGroupBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAirportGroupInput = {
  id: Scalars['String']['input'];
};

export type DeleteAirportHasCompanyBulkInput = {
  search: Array<DeleteAirportHasCompanyInput>;
};

export type DeleteAirportHasCompanyBulkResponse = {
  __typename?: 'DeleteAirportHasCompanyBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAirportHasCompanyInput = {
  airportCode: Scalars['String']['input'];
  companyId: Scalars['String']['input'];
};

export type DeleteAirportHasGroupBulkInput = {
  search: Array<DeleteAirportHasGroupInput>;
};

export type DeleteAirportHasGroupBulkResponse = {
  __typename?: 'DeleteAirportHasGroupBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAirportHasGroupInput = {
  airportCode: Scalars['String']['input'];
  groupId: Scalars['String']['input'];
};

export type DeleteAirportHasLocationBulkInput = {
  search: Array<DeleteAirportHasLocationInput>;
};

export type DeleteAirportHasLocationBulkResponse = {
  __typename?: 'DeleteAirportHasLocationBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAirportHasLocationInput = {
  airportCode: Scalars['String']['input'];
  locationId: Scalars['String']['input'];
};

export type DeleteAirportHasManagerEmailBulkInput = {
  search: Array<DeleteAirportHasManagerEmailInput>;
};

export type DeleteAirportHasManagerEmailBulkResponse = {
  __typename?: 'DeleteAirportHasManagerEmailBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAirportHasManagerEmailInput = {
  airportCode: Scalars['String']['input'];
  emailAddress: Scalars['String']['input'];
};

export type DeleteAirportHasRateBulkInput = {
  search: Array<DeleteAirportHasRateInput>;
};

export type DeleteAirportHasRateBulkResponse = {
  __typename?: 'DeleteAirportHasRateBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAirportHasRateInput = {
  airportCode: Scalars['String']['input'];
};

export type DeleteAirportHasVehicleBulkInput = {
  search: Array<DeleteAirportHasVehicleInput>;
};

export type DeleteAirportHasVehicleBulkResponse = {
  __typename?: 'DeleteAirportHasVehicleBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAirportHasVehicleInput = {
  airportCode: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type DeleteAirportInput = {
  code: Scalars['String']['input'];
};

export type DeleteAlertSubscriptionBulkInput = {
  search: Array<DeleteAlertSubscriptionInput>;
};

export type DeleteAlertSubscriptionBulkResponse = {
  __typename?: 'DeleteAlertSubscriptionBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAlertSubscriptionInput = {
  id: Scalars['String']['input'];
};

export type DeleteAliasBulkInput = {
  search: Array<DeleteAliasInput>;
};

export type DeleteAliasBulkResponse = {
  __typename?: 'DeleteAliasBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAliasInput = {
  id: Scalars['String']['input'];
};

export type DeleteApiKeyBulkInput = {
  search: Array<DeleteApiKeyInput>;
};

export type DeleteApiKeyBulkResponse = {
  __typename?: 'DeleteApiKeyBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteApiKeyInput = {
  id: Scalars['String']['input'];
};

export type DeleteAuditSnapshotBulkInput = {
  search: Array<DeleteAuditSnapshotInput>;
};

export type DeleteAuditSnapshotBulkResponse = {
  __typename?: 'DeleteAuditSnapshotBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAuditSnapshotInput = {
  id: Scalars['String']['input'];
};

export type DeleteAutoCombineRuleBulkInput = {
  search: Array<DeleteAutoCombineRuleInput>;
};

export type DeleteAutoCombineRuleBulkResponse = {
  __typename?: 'DeleteAutoCombineRuleBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAutoCombineRuleInput = {
  id: Scalars['String']['input'];
};

export type DeleteAutomationHistoryAirportBulkInput = {
  search: Array<DeleteAutomationHistoryAirportInput>;
};

export type DeleteAutomationHistoryAirportBulkResponse = {
  __typename?: 'DeleteAutomationHistoryAirportBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAutomationHistoryAirportInput = {
  id: Scalars['String']['input'];
};

export type DeleteAutomationHistoryBulkInput = {
  search: Array<DeleteAutomationHistoryInput>;
};

export type DeleteAutomationHistoryBulkResponse = {
  __typename?: 'DeleteAutomationHistoryBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAutomationHistoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteAutomationHistoryLogBulkInput = {
  search: Array<DeleteAutomationHistoryLogInput>;
};

export type DeleteAutomationHistoryLogBulkResponse = {
  __typename?: 'DeleteAutomationHistoryLogBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAutomationHistoryLogInput = {
  id: Scalars['String']['input'];
};

export type DeleteAutomationReportBulkInput = {
  search: Array<DeleteAutomationReportInput>;
};

export type DeleteAutomationReportBulkResponse = {
  __typename?: 'DeleteAutomationReportBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAutomationReportInput = {
  id: Scalars['String']['input'];
};

export type DeleteAutomationTripAssignmentReasonBulkInput = {
  search: Array<DeleteAutomationTripAssignmentReasonInput>;
};

export type DeleteAutomationTripAssignmentReasonBulkResponse = {
  __typename?: 'DeleteAutomationTripAssignmentReasonBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAutomationTripAssignmentReasonInput = {
  id: Scalars['String']['input'];
};

export type DeleteAutomationTripBulkInput = {
  search: Array<DeleteAutomationTripInput>;
};

export type DeleteAutomationTripBulkResponse = {
  __typename?: 'DeleteAutomationTripBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAutomationTripInput = {
  id: Scalars['String']['input'];
};

export type DeleteAutomationTripLogBulkInput = {
  search: Array<DeleteAutomationTripLogInput>;
};

export type DeleteAutomationTripLogBulkResponse = {
  __typename?: 'DeleteAutomationTripLogBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteAutomationTripLogInput = {
  id: Scalars['String']['input'];
};

export type DeleteBufferTimeBulkInput = {
  search: Array<DeleteBufferTimeInput>;
};

export type DeleteBufferTimeBulkResponse = {
  __typename?: 'DeleteBufferTimeBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteBufferTimeInput = {
  id: Scalars['String']['input'];
};

export type DeleteBufferTimesInput = {
  ids: Array<Scalars['String']['input']>;
};

export type DeleteBufferTimesResponse = {
  __typename?: 'DeleteBufferTimesResponse';
  bufferTimes: Array<DeleteResponse>;
};

export type DeleteCancellationRuleBulkInput = {
  search: Array<DeleteCancellationRuleInput>;
};

export type DeleteCancellationRuleBulkResponse = {
  __typename?: 'DeleteCancellationRuleBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCancellationRuleInput = {
  id: Scalars['String']['input'];
};

export type DeleteCharityAmountHistoryBulkInput = {
  search: Array<DeleteCharityAmountHistoryInput>;
};

export type DeleteCharityAmountHistoryBulkResponse = {
  __typename?: 'DeleteCharityAmountHistoryBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCharityAmountHistoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteCharityBulkInput = {
  search: Array<DeleteCharityInput>;
};

export type DeleteCharityBulkResponse = {
  __typename?: 'DeleteCharityBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCharityInput = {
  id: Scalars['String']['input'];
};

export type DeleteCharityRatingHistoryBulkInput = {
  search: Array<DeleteCharityRatingHistoryInput>;
};

export type DeleteCharityRatingHistoryBulkResponse = {
  __typename?: 'DeleteCharityRatingHistoryBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCharityRatingHistoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteCharityRatingHistoryReportBulkInput = {
  search: Array<DeleteCharityRatingHistoryReportInput>;
};

export type DeleteCharityRatingHistoryReportBulkResponse = {
  __typename?: 'DeleteCharityRatingHistoryReportBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCharityRatingHistoryReportInput = {
  id: Scalars['String']['input'];
};

export type DeleteChatQuickReplyMessageBulkInput = {
  search: Array<DeleteChatQuickReplyMessageInput>;
};

export type DeleteChatQuickReplyMessageBulkResponse = {
  __typename?: 'DeleteChatQuickReplyMessageBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteChatQuickReplyMessageInput = {
  id: Scalars['String']['input'];
};

export type DeleteCheckinEventBulkInput = {
  search: Array<DeleteCheckinEventInput>;
};

export type DeleteCheckinEventBulkResponse = {
  __typename?: 'DeleteCheckinEventBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCheckinEventInput = {
  id: Scalars['String']['input'];
};

export type DeleteCombineRuleBulkInput = {
  search: Array<DeleteCombineRuleInput>;
};

export type DeleteCombineRuleBulkResponse = {
  __typename?: 'DeleteCombineRuleBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCombineRuleHistoryBulkInput = {
  search: Array<DeleteCombineRuleHistoryInput>;
};

export type DeleteCombineRuleHistoryBulkResponse = {
  __typename?: 'DeleteCombineRuleHistoryBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCombineRuleHistoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteCombineRuleInput = {
  id: Scalars['String']['input'];
};

export type DeleteCommunicationBulkInput = {
  search: Array<DeleteCommunicationInput>;
};

export type DeleteCommunicationBulkResponse = {
  __typename?: 'DeleteCommunicationBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCommunicationInput = {
  id: Scalars['String']['input'];
};

export type DeleteCompanyBulkInput = {
  search: Array<DeleteCompanyInput>;
};

export type DeleteCompanyBulkResponse = {
  __typename?: 'DeleteCompanyBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCompanyInput = {
  id: Scalars['String']['input'];
};

export type DeleteCompletionBulkInput = {
  search: Array<DeleteCompletionInput>;
};

export type DeleteCompletionBulkResponse = {
  __typename?: 'DeleteCompletionBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCompletionInput = {
  id: Scalars['String']['input'];
};

export type DeleteCompletionTypeBulkInput = {
  search: Array<DeleteCompletionTypeInput>;
};

export type DeleteCompletionTypeBulkResponse = {
  __typename?: 'DeleteCompletionTypeBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCompletionTypeInput = {
  id: Scalars['String']['input'];
};

export type DeleteContractBulkInput = {
  search: Array<DeleteContractInput>;
};

export type DeleteContractBulkResponse = {
  __typename?: 'DeleteContractBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteContractEmailBulkInput = {
  search: Array<DeleteContractEmailInput>;
};

export type DeleteContractEmailBulkResponse = {
  __typename?: 'DeleteContractEmailBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteContractEmailInput = {
  id: Scalars['String']['input'];
};

export type DeleteContractInput = {
  id: Scalars['String']['input'];
};

export type DeleteContractNumberBulkInput = {
  search: Array<DeleteContractNumberInput>;
};

export type DeleteContractNumberBulkResponse = {
  __typename?: 'DeleteContractNumberBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteContractNumberInput = {
  id: Scalars['String']['input'];
};

export type DeleteCountryRegionBulkInput = {
  search: Array<DeleteCountryRegionInput>;
};

export type DeleteCountryRegionBulkResponse = {
  __typename?: 'DeleteCountryRegionBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCountryRegionInput = {
  id: Scalars['String']['input'];
};

export type DeleteCrewCountRequirementBulkInput = {
  search: Array<DeleteCrewCountRequirementInput>;
};

export type DeleteCrewCountRequirementBulkResponse = {
  __typename?: 'DeleteCrewCountRequirementBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteCrewCountRequirementInput = {
  id: Scalars['String']['input'];
};

export type DeleteDashboardBulkInput = {
  search: Array<DeleteDashboardInput>;
};

export type DeleteDashboardBulkResponse = {
  __typename?: 'DeleteDashboardBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDashboardInput = {
  id: Scalars['String']['input'];
};

export type DeleteDefectBulkInput = {
  search: Array<DeleteDefectInput>;
};

export type DeleteDefectBulkResponse = {
  __typename?: 'DeleteDefectBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDefectInput = {
  id: Scalars['String']['input'];
};

export type DeleteDeviceBulkInput = {
  search: Array<DeleteDeviceInput>;
};

export type DeleteDeviceBulkResponse = {
  __typename?: 'DeleteDeviceBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDeviceInput = {
  id: Scalars['String']['input'];
};

export type DeleteDeviceMetricBulkInput = {
  search: Array<DeleteDeviceMetricInput>;
};

export type DeleteDeviceMetricBulkResponse = {
  __typename?: 'DeleteDeviceMetricBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDeviceMetricInput = {
  id: Scalars['String']['input'];
};

export type DeleteDispatchIssueBulkInput = {
  search: Array<DeleteDispatchIssueInput>;
};

export type DeleteDispatchIssueBulkResponse = {
  __typename?: 'DeleteDispatchIssueBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDispatchIssueCausedByBulkInput = {
  search: Array<DeleteDispatchIssueCausedByInput>;
};

export type DeleteDispatchIssueCausedByBulkResponse = {
  __typename?: 'DeleteDispatchIssueCausedByBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDispatchIssueCausedByInput = {
  id: Scalars['String']['input'];
};

export type DeleteDispatchIssueDocumentBulkInput = {
  search: Array<DeleteDispatchIssueDocumentInput>;
};

export type DeleteDispatchIssueDocumentBulkResponse = {
  __typename?: 'DeleteDispatchIssueDocumentBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDispatchIssueDocumentInput = {
  id: Scalars['String']['input'];
};

export type DeleteDispatchIssueInput = {
  id: Scalars['String']['input'];
};

export type DeleteDispatchSummaryBulkInput = {
  search: Array<DeleteDispatchSummaryInput>;
};

export type DeleteDispatchSummaryBulkResponse = {
  __typename?: 'DeleteDispatchSummaryBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDispatchSummaryDocumentBulkInput = {
  search: Array<DeleteDispatchSummaryDocumentInput>;
};

export type DeleteDispatchSummaryDocumentBulkResponse = {
  __typename?: 'DeleteDispatchSummaryDocumentBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDispatchSummaryDocumentInput = {
  id: Scalars['String']['input'];
};

export type DeleteDispatchSummaryInput = {
  id: Scalars['String']['input'];
};

export type DeleteDispatchSummaryMarketBulkInput = {
  search: Array<DeleteDispatchSummaryMarketInput>;
};

export type DeleteDispatchSummaryMarketBulkResponse = {
  __typename?: 'DeleteDispatchSummaryMarketBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDispatchSummaryMarketInput = {
  id: Scalars['String']['input'];
};

export type DeleteDistanceBulkInput = {
  search: Array<DeleteDistanceInput>;
};

export type DeleteDistanceBulkResponse = {
  __typename?: 'DeleteDistanceBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDistanceInput = {
  id: Scalars['String']['input'];
};

export type DeleteDriverEtaBulkInput = {
  search: Array<DeleteDriverEtaInput>;
};

export type DeleteDriverEtaBulkResponse = {
  __typename?: 'DeleteDriverEtaBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDriverEtaInput = {
  id: Scalars['String']['input'];
};

export type DeleteDriverVehicleAssignmentBulkInput = {
  search: Array<DeleteDriverVehicleAssignmentInput>;
};

export type DeleteDriverVehicleAssignmentBulkResponse = {
  __typename?: 'DeleteDriverVehicleAssignmentBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDriverVehicleAssignmentInput = {
  id: Scalars['String']['input'];
};

export type DeleteDtrLocationBulkInput = {
  search: Array<DeleteDtrLocationInput>;
};

export type DeleteDtrLocationBulkResponse = {
  __typename?: 'DeleteDtrLocationBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDtrLocationInput = {
  id: Scalars['String']['input'];
};

export type DeleteDvirBulkInput = {
  search: Array<DeleteDvirInput>;
};

export type DeleteDvirBulkResponse = {
  __typename?: 'DeleteDvirBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDvirInput = {
  id: Scalars['String']['input'];
};

export type DeleteDvirSignatureBulkInput = {
  search: Array<DeleteDvirSignatureInput>;
};

export type DeleteDvirSignatureBulkResponse = {
  __typename?: 'DeleteDvirSignatureBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteDvirSignatureInput = {
  id: Scalars['String']['input'];
};

export type DeleteEmailBulkInput = {
  search: Array<DeleteEmailInput>;
};

export type DeleteEmailBulkResponse = {
  __typename?: 'DeleteEmailBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteEmailInput = {
  id: Scalars['String']['input'];
};

export type DeleteEquivalentTripBulkInput = {
  search: Array<DeleteEquivalentTripInput>;
};

export type DeleteEquivalentTripBulkResponse = {
  __typename?: 'DeleteEquivalentTripBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteEquivalentTripInput = {
  id: Scalars['String']['input'];
};

export type DeleteEventBulkInput = {
  search: Array<DeleteEventInput>;
};

export type DeleteEventBulkResponse = {
  __typename?: 'DeleteEventBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteEventInput = {
  id: Scalars['String']['input'];
};

export type DeleteFcrBulkInput = {
  search: Array<DeleteFcrInput>;
};

export type DeleteFcrBulkResponse = {
  __typename?: 'DeleteFcrBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteFcrInput = {
  id: Scalars['String']['input'];
};

export type DeleteFcrTypeBulkInput = {
  search: Array<DeleteFcrTypeInput>;
};

export type DeleteFcrTypeBulkResponse = {
  __typename?: 'DeleteFcrTypeBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteFcrTypeInput = {
  id: Scalars['String']['input'];
};

export type DeleteFlagBulkInput = {
  search: Array<DeleteFlagInput>;
};

export type DeleteFlagBulkResponse = {
  __typename?: 'DeleteFlagBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteFlagHasPotentialTripBulkInput = {
  search: Array<DeleteFlagHasPotentialTripInput>;
};

export type DeleteFlagHasPotentialTripBulkResponse = {
  __typename?: 'DeleteFlagHasPotentialTripBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteFlagHasPotentialTripInput = {
  flagId: Scalars['String']['input'];
  potentialTripId: Scalars['String']['input'];
};

export type DeleteFlagHasStagedTripBulkInput = {
  search: Array<DeleteFlagHasStagedTripInput>;
};

export type DeleteFlagHasStagedTripBulkResponse = {
  __typename?: 'DeleteFlagHasStagedTripBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteFlagHasStagedTripInput = {
  flagId: Scalars['String']['input'];
  stagedTripId: Scalars['String']['input'];
};

export type DeleteFlagHasTripBulkInput = {
  search: Array<DeleteFlagHasTripInput>;
};

export type DeleteFlagHasTripBulkResponse = {
  __typename?: 'DeleteFlagHasTripBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteFlagHasTripInput = {
  flagId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};

export type DeleteFlagInput = {
  id: Scalars['String']['input'];
};

export type DeleteFlightHistoryBulkInput = {
  search: Array<DeleteFlightHistoryInput>;
};

export type DeleteFlightHistoryBulkResponse = {
  __typename?: 'DeleteFlightHistoryBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteFlightHistoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteGeneratedDocumentBulkInput = {
  search: Array<DeleteGeneratedDocumentInput>;
};

export type DeleteGeneratedDocumentBulkResponse = {
  __typename?: 'DeleteGeneratedDocumentBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteGeneratedDocumentInput = {
  id: Scalars['String']['input'];
};

export type DeleteGeneratedDocumentLogBulkInput = {
  search: Array<DeleteGeneratedDocumentLogInput>;
};

export type DeleteGeneratedDocumentLogBulkResponse = {
  __typename?: 'DeleteGeneratedDocumentLogBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteGeneratedDocumentLogInput = {
  id: Scalars['String']['input'];
};

export type DeleteGroupBulkInput = {
  search: Array<DeleteGroupInput>;
};

export type DeleteGroupBulkResponse = {
  __typename?: 'DeleteGroupBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteGroupHasPermissionBulkInput = {
  search: Array<DeleteGroupHasPermissionInput>;
};

export type DeleteGroupHasPermissionBulkResponse = {
  __typename?: 'DeleteGroupHasPermissionBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteGroupHasPermissionInput = {
  groupId: Scalars['String']['input'];
  permissionId: Scalars['String']['input'];
};

export type DeleteGroupHasUserBulkInput = {
  search: Array<DeleteGroupHasUserInput>;
};

export type DeleteGroupHasUserBulkResponse = {
  __typename?: 'DeleteGroupHasUserBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteGroupHasUserInput = {
  groupId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type DeleteGroupInput = {
  id: Scalars['String']['input'];
};

export type DeleteImageBulkInput = {
  search: Array<DeleteImageInput>;
};

export type DeleteImageBulkResponse = {
  __typename?: 'DeleteImageBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteImageInput = {
  id: Scalars['String']['input'];
};

export type DeleteImportBulkInput = {
  search: Array<DeleteImportInput>;
};

export type DeleteImportBulkResponse = {
  __typename?: 'DeleteImportBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteImportEmailBulkInput = {
  search: Array<DeleteImportEmailInput>;
};

export type DeleteImportEmailBulkResponse = {
  __typename?: 'DeleteImportEmailBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteImportEmailInput = {
  id: Scalars['String']['input'];
};

export type DeleteImportFailureBulkInput = {
  search: Array<DeleteImportFailureInput>;
};

export type DeleteImportFailureBulkResponse = {
  __typename?: 'DeleteImportFailureBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteImportFailureInput = {
  id: Scalars['String']['input'];
};

export type DeleteImportInput = {
  id: Scalars['String']['input'];
};

export type DeleteImportLogBulkInput = {
  search: Array<DeleteImportLogInput>;
};

export type DeleteImportLogBulkResponse = {
  __typename?: 'DeleteImportLogBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteImportLogInput = {
  id: Scalars['String']['input'];
};

export type DeleteImportOcrCacheBulkInput = {
  search: Array<DeleteImportOcrCacheInput>;
};

export type DeleteImportOcrCacheBulkResponse = {
  __typename?: 'DeleteImportOcrCacheBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteImportOcrCacheInput = {
  id: Scalars['String']['input'];
};

export type DeleteIncidentIssueBulkInput = {
  search: Array<DeleteIncidentIssueInput>;
};

export type DeleteIncidentIssueBulkResponse = {
  __typename?: 'DeleteIncidentIssueBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteIncidentIssueDocumentBulkInput = {
  search: Array<DeleteIncidentIssueDocumentInput>;
};

export type DeleteIncidentIssueDocumentBulkResponse = {
  __typename?: 'DeleteIncidentIssueDocumentBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteIncidentIssueDocumentInput = {
  id: Scalars['String']['input'];
};

export type DeleteIncidentIssueInput = {
  id: Scalars['String']['input'];
};

export type DeleteIndexBulkInput = {
  search: Array<DeleteIndexInput>;
};

export type DeleteIndexBulkResponse = {
  __typename?: 'DeleteIndexBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteIndexInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceAirportBulkInput = {
  search: Array<DeleteInvoiceAirportInput>;
};

export type DeleteInvoiceAirportBulkResponse = {
  __typename?: 'DeleteInvoiceAirportBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceAirportInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceBulkInput = {
  search: Array<DeleteInvoiceInput>;
};

export type DeleteInvoiceBulkResponse = {
  __typename?: 'DeleteInvoiceBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceClientBulkInput = {
  search: Array<DeleteInvoiceClientInput>;
};

export type DeleteInvoiceClientBulkResponse = {
  __typename?: 'DeleteInvoiceClientBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceClientInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceCustomChargeBulkInput = {
  search: Array<DeleteInvoiceCustomChargeInput>;
};

export type DeleteInvoiceCustomChargeBulkResponse = {
  __typename?: 'DeleteInvoiceCustomChargeBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceCustomChargeInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceDocumentBulkInput = {
  search: Array<DeleteInvoiceDocumentInput>;
};

export type DeleteInvoiceDocumentBulkResponse = {
  __typename?: 'DeleteInvoiceDocumentBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceDocumentInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceEmailBulkInput = {
  search: Array<DeleteInvoiceEmailInput>;
};

export type DeleteInvoiceEmailBulkResponse = {
  __typename?: 'DeleteInvoiceEmailBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceEmailInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceHeaderBulkInput = {
  search: Array<DeleteInvoiceHeaderInput>;
};

export type DeleteInvoiceHeaderBulkResponse = {
  __typename?: 'DeleteInvoiceHeaderBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceHeaderInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceIataCodeBulkInput = {
  search: Array<DeleteInvoiceIataCodeInput>;
};

export type DeleteInvoiceIataCodeBulkResponse = {
  __typename?: 'DeleteInvoiceIataCodeBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceIataCodeInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceInput = {
  id: Scalars['Int']['input'];
};

export type DeleteInvoiceLineItemBulkInput = {
  search: Array<DeleteInvoiceLineItemInput>;
};

export type DeleteInvoiceLineItemBulkResponse = {
  __typename?: 'DeleteInvoiceLineItemBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceLineItemInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceProviderCacheBulkInput = {
  search: Array<DeleteInvoiceProviderCacheInput>;
};

export type DeleteInvoiceProviderCacheBulkResponse = {
  __typename?: 'DeleteInvoiceProviderCacheBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceProviderCacheInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceTermBulkInput = {
  search: Array<DeleteInvoiceTermInput>;
};

export type DeleteInvoiceTermBulkResponse = {
  __typename?: 'DeleteInvoiceTermBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceTermInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceTotalSummaryBulkInput = {
  search: Array<DeleteInvoiceTotalSummaryInput>;
};

export type DeleteInvoiceTotalSummaryBulkResponse = {
  __typename?: 'DeleteInvoiceTotalSummaryBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceTotalSummaryInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceTripBulkInput = {
  search: Array<DeleteInvoiceTripInput>;
};

export type DeleteInvoiceTripBulkResponse = {
  __typename?: 'DeleteInvoiceTripBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceTripInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceTripStatusBulkInput = {
  search: Array<DeleteInvoiceTripStatusInput>;
};

export type DeleteInvoiceTripStatusBulkResponse = {
  __typename?: 'DeleteInvoiceTripStatusBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceTripStatusInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceTypeBulkInput = {
  search: Array<DeleteInvoiceTypeInput>;
};

export type DeleteInvoiceTypeBulkResponse = {
  __typename?: 'DeleteInvoiceTypeBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceTypeInput = {
  id: Scalars['String']['input'];
};

export type DeleteInvoiceUserCacheBulkInput = {
  search: Array<DeleteInvoiceUserCacheInput>;
};

export type DeleteInvoiceUserCacheBulkResponse = {
  __typename?: 'DeleteInvoiceUserCacheBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteInvoiceUserCacheInput = {
  id: Scalars['String']['input'];
};

export type DeleteIssueBulkInput = {
  search: Array<DeleteIssueInput>;
};

export type DeleteIssueBulkResponse = {
  __typename?: 'DeleteIssueBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteIssueInput = {
  id: Scalars['String']['input'];
};

export type DeleteLicenseBulkInput = {
  search: Array<DeleteLicenseInput>;
};

export type DeleteLicenseBulkResponse = {
  __typename?: 'DeleteLicenseBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteLicenseInput = {
  id: Scalars['String']['input'];
};

export type DeleteLicenseTypeBulkInput = {
  search: Array<DeleteLicenseTypeInput>;
};

export type DeleteLicenseTypeBulkResponse = {
  __typename?: 'DeleteLicenseTypeBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteLicenseTypeInput = {
  id: Scalars['String']['input'];
};

export type DeleteLineItemTypeBulkInput = {
  search: Array<DeleteLineItemTypeInput>;
};

export type DeleteLineItemTypeBulkResponse = {
  __typename?: 'DeleteLineItemTypeBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteLineItemTypeInput = {
  id: Scalars['String']['input'];
};

export type DeleteLocationBulkInput = {
  search: Array<DeleteLocationInput>;
};

export type DeleteLocationBulkResponse = {
  __typename?: 'DeleteLocationBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteLocationInput = {
  id: Scalars['String']['input'];
};

export type DeleteLocationsInput = {
  ids: Array<Scalars['String']['input']>;
};

export type DeleteLocationsResponse = {
  __typename?: 'DeleteLocationsResponse';
  locations: Array<DeleteResponse>;
};

export type DeleteLoginEventBulkInput = {
  search: Array<DeleteLoginEventInput>;
};

export type DeleteLoginEventBulkResponse = {
  __typename?: 'DeleteLoginEventBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteLoginEventInput = {
  id: Scalars['String']['input'];
};

export type DeleteLostAndFoundIssueBulkInput = {
  search: Array<DeleteLostAndFoundIssueInput>;
};

export type DeleteLostAndFoundIssueBulkResponse = {
  __typename?: 'DeleteLostAndFoundIssueBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteLostAndFoundIssueDocumentBulkInput = {
  search: Array<DeleteLostAndFoundIssueDocumentInput>;
};

export type DeleteLostAndFoundIssueDocumentBulkResponse = {
  __typename?: 'DeleteLostAndFoundIssueDocumentBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteLostAndFoundIssueDocumentInput = {
  id: Scalars['String']['input'];
};

export type DeleteLostAndFoundIssueInput = {
  id: Scalars['String']['input'];
};

export type DeleteManifestHistoryBulkInput = {
  search: Array<DeleteManifestHistoryInput>;
};

export type DeleteManifestHistoryBulkResponse = {
  __typename?: 'DeleteManifestHistoryBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteManifestHistoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteManifestHistoryRouteBulkInput = {
  search: Array<DeleteManifestHistoryRouteInput>;
};

export type DeleteManifestHistoryRouteBulkResponse = {
  __typename?: 'DeleteManifestHistoryRouteBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteManifestHistoryRouteInput = {
  id: Scalars['String']['input'];
};

export type DeleteManifestProviderCacheBulkInput = {
  search: Array<DeleteManifestProviderCacheInput>;
};

export type DeleteManifestProviderCacheBulkResponse = {
  __typename?: 'DeleteManifestProviderCacheBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteManifestProviderCacheInput = {
  id: Scalars['String']['input'];
};

export type DeleteManifestUserCacheBulkInput = {
  search: Array<DeleteManifestUserCacheInput>;
};

export type DeleteManifestUserCacheBulkResponse = {
  __typename?: 'DeleteManifestUserCacheBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteManifestUserCacheInput = {
  id: Scalars['String']['input'];
};

export type DeleteMessageBulkInput = {
  search: Array<DeleteMessageInput>;
};

export type DeleteMessageBulkResponse = {
  __typename?: 'DeleteMessageBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteMessageInput = {
  id: Scalars['String']['input'];
};

export type DeleteNotificationBulkInput = {
  search: Array<DeleteNotificationInput>;
};

export type DeleteNotificationBulkResponse = {
  __typename?: 'DeleteNotificationBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteNotificationHasEventBulkInput = {
  search: Array<DeleteNotificationHasEventInput>;
};

export type DeleteNotificationHasEventBulkResponse = {
  __typename?: 'DeleteNotificationHasEventBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteNotificationHasEventInput = {
  eventId: Scalars['String']['input'];
  responseId: Scalars['String']['input'];
};

export type DeleteNotificationInput = {
  id: Scalars['String']['input'];
};

export type DeleteParsedTripBulkInput = {
  search: Array<DeleteParsedTripInput>;
};

export type DeleteParsedTripBulkResponse = {
  __typename?: 'DeleteParsedTripBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteParsedTripInput = {
  id: Scalars['String']['input'];
};

export type DeletePermissionBulkInput = {
  search: Array<DeletePermissionInput>;
};

export type DeletePermissionBulkResponse = {
  __typename?: 'DeletePermissionBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeletePermissionHasRoleBulkInput = {
  search: Array<DeletePermissionHasRoleInput>;
};

export type DeletePermissionHasRoleBulkResponse = {
  __typename?: 'DeletePermissionHasRoleBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeletePermissionHasRoleInput = {
  permissionId: Scalars['String']['input'];
  roleId: Scalars['String']['input'];
};

export type DeletePermissionHasUserBulkInput = {
  search: Array<DeletePermissionHasUserInput>;
};

export type DeletePermissionHasUserBulkResponse = {
  __typename?: 'DeletePermissionHasUserBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeletePermissionHasUserInput = {
  permissionId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type DeletePermissionInput = {
  id: Scalars['String']['input'];
};

export type DeletePickupPointBulkInput = {
  search: Array<DeletePickupPointInput>;
};

export type DeletePickupPointBulkResponse = {
  __typename?: 'DeletePickupPointBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeletePickupPointInput = {
  id: Scalars['String']['input'];
};

export type DeletePotentialTripBulkInput = {
  search: Array<DeletePotentialTripInput>;
};

export type DeletePotentialTripBulkResponse = {
  __typename?: 'DeletePotentialTripBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeletePotentialTripInput = {
  id: Scalars['String']['input'];
};

export type DeleteProviderAliasBulkInput = {
  search: Array<DeleteProviderAliasInput>;
};

export type DeleteProviderAliasBulkResponse = {
  __typename?: 'DeleteProviderAliasBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteProviderAliasInput = {
  id: Scalars['String']['input'];
};

export type DeleteProviderBulkInput = {
  search: Array<DeleteProviderInput>;
};

export type DeleteProviderBulkResponse = {
  __typename?: 'DeleteProviderBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteProviderCacheBulkInput = {
  search: Array<DeleteProviderCacheInput>;
};

export type DeleteProviderCacheBulkResponse = {
  __typename?: 'DeleteProviderCacheBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteProviderCacheInput = {
  id: Scalars['String']['input'];
};

export type DeleteProviderInput = {
  id: Scalars['String']['input'];
};

export type DeleteProviderLocationMappingBulkInput = {
  search: Array<DeleteProviderLocationMappingInput>;
};

export type DeleteProviderLocationMappingBulkResponse = {
  __typename?: 'DeleteProviderLocationMappingBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteProviderLocationMappingInput = {
  id: Scalars['String']['input'];
};

export type DeletePunchBulkInput = {
  search: Array<DeletePunchInput>;
};

export type DeletePunchBulkResponse = {
  __typename?: 'DeletePunchBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeletePunchHistoryBulkInput = {
  search: Array<DeletePunchHistoryInput>;
};

export type DeletePunchHistoryBulkResponse = {
  __typename?: 'DeletePunchHistoryBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeletePunchHistoryInput = {
  id: Scalars['String']['input'];
};

export type DeletePunchInput = {
  id: Scalars['String']['input'];
};

export type DeletePunchPolicyBulkInput = {
  search: Array<DeletePunchPolicyInput>;
};

export type DeletePunchPolicyBulkResponse = {
  __typename?: 'DeletePunchPolicyBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeletePunchPolicyInput = {
  id: Scalars['String']['input'];
};

export type DeleteQueryHistoryBulkInput = {
  search: Array<DeleteQueryHistoryInput>;
};

export type DeleteQueryHistoryBulkResponse = {
  __typename?: 'DeleteQueryHistoryBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteQueryHistoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteQuestionnaireAnswerOptionBulkInput = {
  search: Array<DeleteQuestionnaireAnswerOptionInput>;
};

export type DeleteQuestionnaireAnswerOptionBulkResponse = {
  __typename?: 'DeleteQuestionnaireAnswerOptionBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteQuestionnaireAnswerOptionInput = {
  id: Scalars['String']['input'];
};

export type DeleteQuestionnaireAnswerTypeBulkInput = {
  search: Array<DeleteQuestionnaireAnswerTypeInput>;
};

export type DeleteQuestionnaireAnswerTypeBulkResponse = {
  __typename?: 'DeleteQuestionnaireAnswerTypeBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteQuestionnaireAnswerTypeInput = {
  id: Scalars['String']['input'];
};

export type DeleteQuestionnaireAttemptAnswerOptionSnapshotBulkInput = {
  search: Array<DeleteQuestionnaireAttemptAnswerOptionSnapshotInput>;
};

export type DeleteQuestionnaireAttemptAnswerOptionSnapshotBulkResponse = {
  __typename?: 'DeleteQuestionnaireAttemptAnswerOptionSnapshotBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteQuestionnaireAttemptAnswerOptionSnapshotInput = {
  id: Scalars['String']['input'];
};

export type DeleteQuestionnaireAttemptBulkInput = {
  search: Array<DeleteQuestionnaireAttemptInput>;
};

export type DeleteQuestionnaireAttemptBulkResponse = {
  __typename?: 'DeleteQuestionnaireAttemptBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteQuestionnaireAttemptCategorySnapshotAllowedGroupBulkInput = {
  search: Array<DeleteQuestionnaireAttemptCategorySnapshotAllowedGroupInput>;
};

export type DeleteQuestionnaireAttemptCategorySnapshotAllowedGroupBulkResponse = {
  __typename?: 'DeleteQuestionnaireAttemptCategorySnapshotAllowedGroupBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteQuestionnaireAttemptCategorySnapshotAllowedGroupInput = {
  id: Scalars['String']['input'];
};

export type DeleteQuestionnaireAttemptCategorySnapshotBulkInput = {
  search: Array<DeleteQuestionnaireAttemptCategorySnapshotInput>;
};

export type DeleteQuestionnaireAttemptCategorySnapshotBulkResponse = {
  __typename?: 'DeleteQuestionnaireAttemptCategorySnapshotBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteQuestionnaireAttemptCategorySnapshotGroupBulkInput = {
  search: Array<DeleteQuestionnaireAttemptCategorySnapshotGroupInput>;
};

export type DeleteQuestionnaireAttemptCategorySnapshotGroupBulkResponse = {
  __typename?: 'DeleteQuestionnaireAttemptCategorySnapshotGroupBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteQuestionnaireAttemptCategorySnapshotGroupInput = {
  id: Scalars['String']['input'];
};

export type DeleteQuestionnaireAttemptCategorySnapshotInput = {
  id: Scalars['String']['input'];
};

export type DeleteQuestionnaireAttemptInput = {
  id: Scalars['String']['input'];
};

export type DeleteQuestionnaireAttemptNoteBulkInput = {
  search: Array<DeleteQuestionnaireAttemptNoteInput>;
};

export type DeleteQuestionnaireAttemptNoteBulkResponse = {
  __typename?: 'DeleteQuestionnaireAttemptNoteBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteQuestionnaireAttemptNoteInput = {
  id: Scalars['String']['input'];
};

export type DeleteQuestionnaireAttemptQuestionSnapshotBulkInput = {
  search: Array<DeleteQuestionnaireAttemptQuestionSnapshotInput>;
};

export type DeleteQuestionnaireAttemptQuestionSnapshotBulkResponse = {
  __typename?: 'DeleteQuestionnaireAttemptQuestionSnapshotBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteQuestionnaireAttemptQuestionSnapshotInput = {
  id: Scalars['String']['input'];
};

export type DeleteQuestionnaireCategoryBulkInput = {
  search: Array<DeleteQuestionnaireCategoryInput>;
};

export type DeleteQuestionnaireCategoryBulkResponse = {
  __typename?: 'DeleteQuestionnaireCategoryBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteQuestionnaireCategoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteQuestionnaireQuestionBulkInput = {
  search: Array<DeleteQuestionnaireQuestionInput>;
};

export type DeleteQuestionnaireQuestionBulkResponse = {
  __typename?: 'DeleteQuestionnaireQuestionBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteQuestionnaireQuestionInput = {
  id: Scalars['String']['input'];
};

export type DeleteRateBulkInput = {
  search: Array<DeleteRateInput>;
};

export type DeleteRateBulkResponse = {
  __typename?: 'DeleteRateBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteRateGroupBulkInput = {
  search: Array<DeleteRateGroupInput>;
};

export type DeleteRateGroupBulkResponse = {
  __typename?: 'DeleteRateGroupBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteRateGroupInput = {
  id: Scalars['String']['input'];
};

export type DeleteRateHistoryBulkInput = {
  search: Array<DeleteRateHistoryInput>;
};

export type DeleteRateHistoryBulkResponse = {
  __typename?: 'DeleteRateHistoryBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteRateHistoryInput = {
  id: Scalars['String']['input'];
};

export type DeleteRateInput = {
  id: Scalars['String']['input'];
};

export type DeleteRateItemBulkInput = {
  search: Array<DeleteRateItemInput>;
};

export type DeleteRateItemBulkResponse = {
  __typename?: 'DeleteRateItemBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteRateItemInput = {
  id: Scalars['String']['input'];
};

export type DeleteRatingBulkInput = {
  search: Array<DeleteRatingInput>;
};

export type DeleteRatingBulkResponse = {
  __typename?: 'DeleteRatingBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteRatingCacheBulkInput = {
  search: Array<DeleteRatingCacheInput>;
};

export type DeleteRatingCacheBulkResponse = {
  __typename?: 'DeleteRatingCacheBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteRatingCacheInput = {
  id: Scalars['String']['input'];
};

export type DeleteRatingCacheRemarkBulkInput = {
  search: Array<DeleteRatingCacheRemarkInput>;
};

export type DeleteRatingCacheRemarkBulkResponse = {
  __typename?: 'DeleteRatingCacheRemarkBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteRatingCacheRemarkInput = {
  id: Scalars['String']['input'];
};

export type DeleteRatingInput = {
  id: Scalars['String']['input'];
};

export type DeleteRatingRemarkBulkInput = {
  search: Array<DeleteRatingRemarkInput>;
};

export type DeleteRatingRemarkBulkResponse = {
  __typename?: 'DeleteRatingRemarkBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteRatingRemarkInput = {
  id: Scalars['String']['input'];
};

export type DeleteRatingTypeBulkInput = {
  search: Array<DeleteRatingTypeInput>;
};

export type DeleteRatingTypeBulkResponse = {
  __typename?: 'DeleteRatingTypeBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteRatingTypeInput = {
  id: Scalars['String']['input'];
};

export type DeleteRemarksInput = {
  ids: Array<Scalars['String']['input']>;
};

export type DeleteRemarksResponse = {
  __typename?: 'DeleteRemarksResponse';
  remarks: Array<DeleteResponse>;
};

export type DeleteResponse = {
  __typename?: 'DeleteResponse';
  deleted: Scalars['Boolean']['output'];
  error?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
};

export type DeleteRoleBulkInput = {
  search: Array<DeleteRoleInput>;
};

export type DeleteRoleBulkResponse = {
  __typename?: 'DeleteRoleBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteRoleInput = {
  id: Scalars['String']['input'];
};

export type DeleteSettingsBulkInput = {
  search: Array<DeleteSettingsInput>;
};

export type DeleteSettingsBulkResponse = {
  __typename?: 'DeleteSettingsBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteSettingsInput = {
  id: Scalars['String']['input'];
};

export type DeleteSocialDistanceRuleBulkInput = {
  search: Array<DeleteSocialDistanceRuleInput>;
};

export type DeleteSocialDistanceRuleBulkResponse = {
  __typename?: 'DeleteSocialDistanceRuleBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteSocialDistanceRuleInput = {
  id: Scalars['String']['input'];
};

export type DeleteStagedTripBulkInput = {
  search: Array<DeleteStagedTripInput>;
};

export type DeleteStagedTripBulkResponse = {
  __typename?: 'DeleteStagedTripBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteStagedTripInput = {
  id: Scalars['String']['input'];
};

export type DeleteStopBulkInput = {
  search: Array<DeleteStopInput>;
};

export type DeleteStopBulkResponse = {
  __typename?: 'DeleteStopBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteStopInput = {
  id: Scalars['String']['input'];
};

export type DeleteStorageBulkInput = {
  search: Array<DeleteStorageInput>;
};

export type DeleteStorageBulkResponse = {
  __typename?: 'DeleteStorageBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteStorageInput = {
  id: Scalars['String']['input'];
};

export type DeleteTimeFrameBulkInput = {
  search: Array<DeleteTimeFrameInput>;
};

export type DeleteTimeFrameBulkResponse = {
  __typename?: 'DeleteTimeFrameBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteTimeFrameInput = {
  id: Scalars['String']['input'];
};

export type DeleteTimeFrameRangeBulkInput = {
  search: Array<DeleteTimeFrameRangeInput>;
};

export type DeleteTimeFrameRangeBulkResponse = {
  __typename?: 'DeleteTimeFrameRangeBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteTimeFrameRangeInput = {
  id: Scalars['String']['input'];
};

export type DeleteTrackFlightBulkInput = {
  search: Array<DeleteTrackFlightInput>;
};

export type DeleteTrackFlightBulkResponse = {
  __typename?: 'DeleteTrackFlightBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteTrackFlightInput = {
  id: Scalars['String']['input'];
};

export type DeleteTrainingUserCacheBulkInput = {
  search: Array<DeleteTrainingUserCacheInput>;
};

export type DeleteTrainingUserCacheBulkResponse = {
  __typename?: 'DeleteTrainingUserCacheBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteTrainingUserCacheInput = {
  id: Scalars['String']['input'];
};

export type DeleteTripBulkInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  search: Array<DeleteTripInput>;
};

export type DeleteTripBulkResponse = {
  __typename?: 'DeleteTripBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteTripDocumentBulkInput = {
  search: Array<DeleteTripDocumentInput>;
};

export type DeleteTripDocumentBulkResponse = {
  __typename?: 'DeleteTripDocumentBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteTripDocumentInput = {
  id: Scalars['String']['input'];
};

export type DeleteTripHardBulkInput = {
  tripIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeleteTripHardBulkResponse = {
  __typename?: 'DeleteTripHardBulkResponse';
  deleted: Scalars['Int']['output'];
  error?: Maybe<Error>;
};

export type DeleteTripHasImportBulkInput = {
  search: Array<DeleteTripHasImportInput>;
};

export type DeleteTripHasImportBulkResponse = {
  __typename?: 'DeleteTripHasImportBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteTripHasImportInput = {
  importId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};

export type DeleteTripInput = {
  id: Scalars['String']['input'];
};

export type DeleteTripScheduleTriggerBulkInput = {
  search: Array<DeleteTripScheduleTriggerInput>;
};

export type DeleteTripScheduleTriggerBulkResponse = {
  __typename?: 'DeleteTripScheduleTriggerBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteTripScheduleTriggerInput = {
  id: Scalars['String']['input'];
};

export type DeleteUpdateStrategyBulkInput = {
  search: Array<DeleteUpdateStrategyInput>;
};

export type DeleteUpdateStrategyBulkResponse = {
  __typename?: 'DeleteUpdateStrategyBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteUpdateStrategyInput = {
  id: Scalars['String']['input'];
};

export type DeleteUserAvailabilityBulkInput = {
  search: Array<DeleteUserAvailabilityInput>;
};

export type DeleteUserAvailabilityBulkResponse = {
  __typename?: 'DeleteUserAvailabilityBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteUserAvailabilityDriverAppInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeleteUserAvailabilityDriverAppResponse = {
  __typename?: 'DeleteUserAvailabilityDriverAppResponse';
  deleted: Scalars['Int']['output'];
  error?: Maybe<Error>;
};

export type DeleteUserAvailabilityInput = {
  id: Scalars['String']['input'];
};

export type DeleteUserAvailabilitySeriesDriverAppInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type DeleteUserAvailabilitySeriesDriverAppResponse = {
  __typename?: 'DeleteUserAvailabilitySeriesDriverAppResponse';
  deleted: Scalars['Int']['output'];
  error?: Maybe<Error>;
};

export type DeleteUserBulkInput = {
  search: Array<DeleteUserInput>;
};

export type DeleteUserBulkResponse = {
  __typename?: 'DeleteUserBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteUserCacheBulkInput = {
  search: Array<DeleteUserCacheInput>;
};

export type DeleteUserCacheBulkResponse = {
  __typename?: 'DeleteUserCacheBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteUserCacheInput = {
  id: Scalars['String']['input'];
};

export type DeleteUserHasAirportBulkInput = {
  search: Array<DeleteUserHasAirportInput>;
};

export type DeleteUserHasAirportBulkResponse = {
  __typename?: 'DeleteUserHasAirportBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteUserHasAirportInput = {
  airportCode: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type DeleteUserInput = {
  id: Scalars['String']['input'];
};

export type DeleteUsersInput = {
  ids: Array<Scalars['String']['input']>;
};

export type DeleteUsersResponse = {
  __typename?: 'DeleteUsersResponse';
  users: Array<DeleteResponse>;
};

export type DeleteVariableTimeBulkInput = {
  search: Array<DeleteVariableTimeInput>;
};

export type DeleteVariableTimeBulkResponse = {
  __typename?: 'DeleteVariableTimeBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteVariableTimeInput = {
  id: Scalars['String']['input'];
};

export type DeleteVehicleBulkInput = {
  search: Array<DeleteVehicleInput>;
};

export type DeleteVehicleBulkResponse = {
  __typename?: 'DeleteVehicleBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteVehicleInput = {
  id: Scalars['String']['input'];
};

export type DeleteWidgetBulkInput = {
  search: Array<DeleteWidgetInput>;
};

export type DeleteWidgetBulkResponse = {
  __typename?: 'DeleteWidgetBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteWidgetFilterBulkInput = {
  search: Array<DeleteWidgetFilterInput>;
};

export type DeleteWidgetFilterBulkResponse = {
  __typename?: 'DeleteWidgetFilterBulkResponse';
  deleted: Scalars['Int']['output'];
};

export type DeleteWidgetFilterInput = {
  id: Scalars['String']['input'];
};

export type DeleteWidgetInput = {
  id: Scalars['String']['input'];
};

export type Description = {
  __typename?: 'Description';
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum Device {
  AndroidCrewV1 = 'ANDROID_CREW_V1',
  AndroidDriverV1 = 'ANDROID_DRIVER_V1',
  IosCrewV1 = 'IOS_CREW_V1',
  IosDriverV1 = 'IOS_DRIVER_V1',
  PortalV1 = 'PORTAL_V1'
}

export type DeviceActivityConnection = {
  __typename?: 'DeviceActivityConnection';
  edges?: Maybe<Array<Maybe<DeviceActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DeviceActivityEdge = {
  __typename?: 'DeviceActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DeviceConnection = {
  __typename?: 'DeviceConnection';
  edges?: Maybe<Array<Maybe<DeviceEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DeviceMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DeviceSearch>>;
};

export type DeviceEdge = {
  __typename?: 'DeviceEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Device>;
};

export type DeviceEventInput = {
  datetime: Scalars['String']['input'];
  eventType: DeviceEventTypeEnum;
  geoLocation?: InputMaybe<GeoLocation>;
  tripIds: Array<Scalars['String']['input']>;
};

export type DeviceEventResponse = {
  __typename?: 'DeviceEventResponse';
  output?: Maybe<Array<UpdateResponse>>;
};

export enum DeviceEventTypeEnum {
  ArrivedAtPickup = 'ARRIVED_AT_PICKUP',
  MarkedDroppedOff = 'MARKED_DROPPED_OFF',
  MarkedPickedUp = 'MARKED_PICKED_UP'
}

export type DeviceMapStyle = {
  __typename?: 'DeviceMapStyle';
  elementType: Scalars['String']['output'];
  featureType: Scalars['String']['output'];
  stylers: Array<Styler>;
};

export type DeviceMaps = {
  __typename?: 'DeviceMaps';
  style: Array<DeviceMapStyle>;
};

export type DeviceMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  appName?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  lastSeenAt?: InputMaybe<Scalars['Boolean']['input']>;
  platform?: InputMaybe<Scalars['Boolean']['input']>;
  token?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DeviceMetric = {
  __typename?: 'DeviceMetric';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metricName: DeviceMetricMetricNameEnum;
  userId: Scalars['String']['output'];
};

export type DeviceMetricActivityConnection = {
  __typename?: 'DeviceMetricActivityConnection';
  edges?: Maybe<Array<Maybe<DeviceMetricActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceMetricActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DeviceMetricActivityEdge = {
  __typename?: 'DeviceMetricActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DeviceMetricConnection = {
  __typename?: 'DeviceMetricConnection';
  edges?: Maybe<Array<Maybe<DeviceMetricEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceMetricConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DeviceMetricMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DeviceMetricSearch>>;
};

export type DeviceMetricEdge = {
  __typename?: 'DeviceMetricEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DeviceMetric>;
};

export type DeviceMetricMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  metricName?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DeviceMetricMetricNameEnum {
  DriverUsedCrewApp = 'DRIVER_USED_CREW_APP'
}

export type DeviceMetricMetricNameEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DeviceMetricMetricNameEnum>;
};

export type DeviceMetricSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  metricName?: InputMaybe<Array<DeviceMetricMetricNameEnumSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type DeviceMetricWithUser = {
  __typename?: 'DeviceMetricWithUser';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  metricName: DeviceMetricWithUserMetricNameEnum;
  userFirstName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  userLastName: Scalars['String']['output'];
};

export type DeviceMetricWithUserActivityConnection = {
  __typename?: 'DeviceMetricWithUserActivityConnection';
  edges?: Maybe<Array<Maybe<DeviceMetricWithUserActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceMetricWithUserActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DeviceMetricWithUserActivityEdge = {
  __typename?: 'DeviceMetricWithUserActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DeviceMetricWithUserConnection = {
  __typename?: 'DeviceMetricWithUserConnection';
  edges?: Maybe<Array<Maybe<DeviceMetricWithUserEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DeviceMetricWithUserConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DeviceMetricWithUserMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DeviceMetricWithUserSearch>>;
};

export type DeviceMetricWithUserEdge = {
  __typename?: 'DeviceMetricWithUserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DeviceMetricWithUser>;
};

export type DeviceMetricWithUserMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  metricName?: InputMaybe<Scalars['Boolean']['input']>;
  userFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
  userLastName?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DeviceMetricWithUserMetricNameEnum {
  DriverUsedCrewApp = 'DRIVER_USED_CREW_APP'
}

export type DeviceMetricWithUserMetricNameEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DeviceMetricWithUserMetricNameEnum>;
};

export type DeviceMetricWithUserSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  metricName?: InputMaybe<Array<DeviceMetricWithUserMetricNameEnumSearch>>;
  userFirstName?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
  userLastName?: InputMaybe<Array<StringSearch>>;
};

export type DeviceMutationResponse = {
  __typename?: 'DeviceMutationResponse';
  abortTrip: AbortTripResponse;
  approveUserAvailabilityDriverApp: ApproveUserAvailabilityDriverAppResponse;
  assignDriver?: Maybe<AssignDriverResponse>;
  assignVehicle?: Maybe<AssignVehicleResponse>;
  assignVehicleToDriver?: Maybe<AssignVehicleToDriverResponse>;
  cancelTrip: CancelTripResponse;
  createCrewTrip: CreateCrewTripResponse;
  createDeviceMetricBulk: CreateDeviceMetricBulkResponse;
  createLostAndFoundIssueCrew: CreateLostAndFoundIssueCrewResponse;
  createRatingBulk: CreateRatingBulkResponse;
  createRatingRemarkBulk: CreateRatingRemarkBulkResponse;
  createUserAvailabilityDriverApp: CreateUserAvailabilityDriverAppResponse;
  crewCheckin?: Maybe<CrewCheckinResponse>;
  crewNoShow: CrewNoShowResponse;
  deleteUserAvailabilityAndUnassignDriverApp: DeleteUserAvailabilityDriverAppResponse;
  deleteUserAvailabilityDriverApp: DeleteUserAvailabilityDriverAppResponse;
  deleteUserAvailabilitySeriesAndUnassignDriverApp: DeleteUserAvailabilitySeriesDriverAppResponse;
  deleteUserAvailabilitySeriesDriverApp: DeleteUserAvailabilitySeriesDriverAppResponse;
  deviceEvent: DeviceEventResponse;
  deviceRegistration: DeviceRegistrationResponse;
  dropoffActual?: Maybe<DropoffActualResponse>;
  dropoffCompleted?: Maybe<DropoffCompletedResponse>;
  dropoffIncomplete?: Maybe<DropoffIncompleteResponse>;
  forgotPasswordCrew: ForgotPasswordCrewResponse;
  forgotPasswordDriver: ForgotPasswordDriverResponse;
  login: LoginResponse;
  pickupActual?: Maybe<PickupActualResponse>;
  pickupCompleted?: Maybe<PickupCompletedResponse>;
  pickupIncomplete?: Maybe<PickupIncompleteResponse>;
  reportProblemCrew?: Maybe<ReportProblemCrewResponse>;
  reportProblemDriver?: Maybe<ReportProblemDriverResponse>;
  stealTrips: StealTripsResponse;
  submitFeedbackDriver?: Maybe<SubmitFeedbackDriverResponse>;
  submitFitForDutyDriver?: Maybe<SubmitFitForDutyDriverResponse>;
  updateDriverCrewCount?: Maybe<UpdateDriverCrewCountResponse>;
  updateUserAvailabilityDriverApp: UpdateUserAvailabilityDriverAppResponse;
  updateUserAvailabilitySeriesDriverApp: UpdateUserAvailabilitySeriesDriverAppResponse;
};


export type DeviceMutationResponseAbortTripArgs = {
  input: AbortTripInput;
};


export type DeviceMutationResponseApproveUserAvailabilityDriverAppArgs = {
  input: ApproveUserAvailabilityDriverAppInput;
};


export type DeviceMutationResponseAssignDriverArgs = {
  input: AssignDriverInput;
};


export type DeviceMutationResponseAssignVehicleArgs = {
  input: AssignVehicleInput;
};


export type DeviceMutationResponseAssignVehicleToDriverArgs = {
  input: AssignVehicleToDriverInput;
};


export type DeviceMutationResponseCancelTripArgs = {
  input: CancelTripInput;
};


export type DeviceMutationResponseCreateCrewTripArgs = {
  input: CreateCrewTripInput;
};


export type DeviceMutationResponseCreateDeviceMetricBulkArgs = {
  input: CreateDeviceMetricBulkInput;
};


export type DeviceMutationResponseCreateLostAndFoundIssueCrewArgs = {
  input: CreateLostAndFoundIssueCrewInput;
};


export type DeviceMutationResponseCreateRatingBulkArgs = {
  input: CreateRatingBulkInput;
};


export type DeviceMutationResponseCreateRatingRemarkBulkArgs = {
  input: CreateRatingRemarkBulkInput;
};


export type DeviceMutationResponseCreateUserAvailabilityDriverAppArgs = {
  input: CreateUserAvailabilityDriverAppInput;
};


export type DeviceMutationResponseCrewCheckinArgs = {
  input: CrewCheckinInput;
};


export type DeviceMutationResponseCrewNoShowArgs = {
  input: CrewNoShowInput;
};


export type DeviceMutationResponseDeleteUserAvailabilityAndUnassignDriverAppArgs = {
  input: DeleteUserAvailabilityDriverAppInput;
};


export type DeviceMutationResponseDeleteUserAvailabilityDriverAppArgs = {
  input: DeleteUserAvailabilityDriverAppInput;
};


export type DeviceMutationResponseDeleteUserAvailabilitySeriesAndUnassignDriverAppArgs = {
  input: DeleteUserAvailabilitySeriesDriverAppInput;
};


export type DeviceMutationResponseDeleteUserAvailabilitySeriesDriverAppArgs = {
  input: DeleteUserAvailabilitySeriesDriverAppInput;
};


export type DeviceMutationResponseDeviceEventArgs = {
  input: DeviceEventInput;
};


export type DeviceMutationResponseDeviceRegistrationArgs = {
  input: DeviceRegistrationInput;
};


export type DeviceMutationResponseDropoffActualArgs = {
  input: DropoffActualInput;
};


export type DeviceMutationResponseDropoffCompletedArgs = {
  input: DropoffCompletedInput;
};


export type DeviceMutationResponseDropoffIncompleteArgs = {
  input: DropoffIncompleteInput;
};


export type DeviceMutationResponseForgotPasswordCrewArgs = {
  input: ForgotPasswordCrewInput;
};


export type DeviceMutationResponseForgotPasswordDriverArgs = {
  input: ForgotPasswordDriverInput;
};


export type DeviceMutationResponseLoginArgs = {
  input: LoginInput;
};


export type DeviceMutationResponsePickupActualArgs = {
  input: PickupActualInput;
};


export type DeviceMutationResponsePickupCompletedArgs = {
  input: PickupCompletedInput;
};


export type DeviceMutationResponsePickupIncompleteArgs = {
  input: PickupIncompleteInput;
};


export type DeviceMutationResponseReportProblemCrewArgs = {
  input: ReportProblemCrewInput;
};


export type DeviceMutationResponseReportProblemDriverArgs = {
  input: ReportProblemDriverInput;
};


export type DeviceMutationResponseStealTripsArgs = {
  input: StealTripsInput;
};


export type DeviceMutationResponseSubmitFeedbackDriverArgs = {
  input: SubmitFeedbackDriverInput;
};


export type DeviceMutationResponseSubmitFitForDutyDriverArgs = {
  input: SubmitFitForDutyDriverInput;
};


export type DeviceMutationResponseUpdateDriverCrewCountArgs = {
  input: UpdateDriverCrewCountInput;
};


export type DeviceMutationResponseUpdateUserAvailabilityDriverAppArgs = {
  input: UpdateUserAvailabilityDriverAppInput;
};


export type DeviceMutationResponseUpdateUserAvailabilitySeriesDriverAppArgs = {
  input: UpdateUserAvailabilitySeriesDriverAppInput;
};

export type DeviceNavigation = {
  __typename?: 'DeviceNavigation';
  items: Array<DeviceNavigationItem>;
  type: DeviceNavigationTypeEnum;
};

export type DeviceNavigationItem = {
  __typename?: 'DeviceNavigationItem';
  key: Scalars['String']['output'];
  title: Scalars['String']['output'];
  type: DeviceNavigationItemTypeEnum;
};

export enum DeviceNavigationItemTypeEnum {
  Availability = 'AVAILABILITY',
  CallAirline = 'CALL_AIRLINE',
  CompanyFeedbackCrew = 'COMPANY_FEEDBACK_CREW',
  ContactDispatcher = 'CONTACT_DISPATCHER',
  ContactUs = 'CONTACT_US',
  CurrentTrip = 'CURRENT_TRIP',
  EmailManager = 'EMAIL_MANAGER',
  EmailUs = 'EMAIL_US',
  FlightLookup = 'FLIGHT_LOOKUP',
  FlightLookupAhead = 'FLIGHT_LOOKUP_AHEAD',
  Help = 'HELP',
  Home = 'HOME',
  IssueWithApp = 'ISSUE_WITH_APP',
  JobsList = 'JOBS_LIST',
  Leaderboard = 'LEADERBOARD',
  Legal = 'LEGAL',
  Logout = 'LOGOUT',
  LostAndFoundCrew = 'LOST_AND_FOUND_CREW',
  Messages = 'MESSAGES',
  Notifications = 'NOTIFICATIONS',
  PasswordReset = 'PASSWORD_RESET',
  Performance = 'PERFORMANCE',
  Privacy = 'PRIVACY',
  Profile = 'PROFILE',
  ProfileImageEdit = 'PROFILE_IMAGE_EDIT',
  ProfileSettings = 'PROFILE_SETTINGS',
  ReviewsAndRatings = 'REVIEWS_AND_RATINGS',
  SocialFacebook = 'SOCIAL_FACEBOOK',
  SocialInstagram = 'SOCIAL_INSTAGRAM',
  SocialTwitter = 'SOCIAL_TWITTER',
  Stats = 'STATS',
  SubmitFeedback = 'SUBMIT_FEEDBACK',
  SuggestionBoxCrew = 'SUGGESTION_BOX_CREW',
  Trips = 'TRIPS',
  VisitOurWebsite = 'VISIT_OUR_WEBSITE'
}

export enum DeviceNavigationTypeEnum {
  ContactUs = 'CONTACT_US',
  Main = 'MAIN',
  Profile = 'PROFILE',
  UserMenu = 'USER_MENU'
}

export type DeviceQueryResponse = {
  __typename?: 'DeviceQueryResponse';
  airportHasCompanyConnection?: Maybe<AirportHasCompanyConnection>;
  airportWithLocationConnection?: Maybe<AirportWithLocationConnection>;
  charityLeaderboard: CharityLeaderboardResponse;
  companyConnection?: Maybe<CompanyConnection>;
  flightLookupCrewApp?: Maybe<TripConnection>;
  getAvailableUsersForTrip: GetAvailableUsersForTripResponse;
  getCharityWithAmountHistory?: Maybe<CharityWithAmountHistoryConnection>;
  getConfig: GetDeviceConfigResponse;
  getDriverPerformanceReports: GetDriverPerformanceReportsResponse;
  getDrivers: GetDriversResponse;
  getFaq: GetFaqResponse;
  getFilters: GetFiltersResponse;
  getFitForDrivingQuestions: GetFitForDrivingQuestionsResponse;
  getFlightStatus: GetFlightStatusResponse;
  getUserOfficeLocationsDriverApp?: Maybe<GetUserOfficeLocationDriverAppResponse>;
  getVehicles: GetVehiclesResponse;
  getVehiclesForTrip: GetVehiclesForTripResponse;
  jobLookupDriverApp?: Maybe<TripConnection>;
  leaderboardDriverApp?: Maybe<LeaderboardDriverAppResponse>;
  myDriverPerformance?: Maybe<DriverPerformance>;
  performanceReport?: Maybe<PerformanceReport>;
  ratingsAndReviewsDriverApp?: Maybe<RatingsAndReviewsDriverAppResponse>;
  searchUserAvailabilityDriverApp?: Maybe<UserConnection>;
  tripConnectionCrewApp?: Maybe<TripConnection>;
  tripConnectionDriverApp?: Maybe<TripConnection>;
  tripRequiresDriverCrewCount: TripRequiresDriverCrewCountResponse;
  userConnection?: Maybe<UserConnection>;
};


export type DeviceQueryResponseAirportHasCompanyConnectionArgs = {
  input?: InputMaybe<AirportHasCompanyConnectionInput>;
};


export type DeviceQueryResponseAirportWithLocationConnectionArgs = {
  input?: InputMaybe<AirportWithLocationConnectionInput>;
};


export type DeviceQueryResponseCharityLeaderboardArgs = {
  input?: InputMaybe<CharityLeaderboardInput>;
};


export type DeviceQueryResponseCompanyConnectionArgs = {
  input?: InputMaybe<CompanyConnectionInput>;
};


export type DeviceQueryResponseFlightLookupCrewAppArgs = {
  input?: InputMaybe<FlightLookupCrewAppInput>;
};


export type DeviceQueryResponseGetAvailableUsersForTripArgs = {
  input: GetAvailableUsersForTripInput;
};


export type DeviceQueryResponseGetCharityWithAmountHistoryArgs = {
  input?: InputMaybe<CharityWithAmountHistoryConnectionInput>;
};


export type DeviceQueryResponseGetConfigArgs = {
  input: GetDeviceConfigInput;
};


export type DeviceQueryResponseGetDriverPerformanceReportsArgs = {
  input: GetDriverPerformanceReportsInput;
};


export type DeviceQueryResponseGetFaqArgs = {
  input: GetFaqInput;
};


export type DeviceQueryResponseGetFlightStatusArgs = {
  input: GetFlightStatusInput;
};


export type DeviceQueryResponseGetVehiclesForTripArgs = {
  input: GetVehiclesForTripInput;
};


export type DeviceQueryResponseJobLookupDriverAppArgs = {
  input?: InputMaybe<JobLookupDriverAppInput>;
};


export type DeviceQueryResponseLeaderboardDriverAppArgs = {
  input?: InputMaybe<LeaderboardDriverAppInput>;
};


export type DeviceQueryResponseMyDriverPerformanceArgs = {
  input?: InputMaybe<DriverPerformanceSearchInput>;
};


export type DeviceQueryResponsePerformanceReportArgs = {
  input?: InputMaybe<PerformanceReportInput>;
};


export type DeviceQueryResponseRatingsAndReviewsDriverAppArgs = {
  input?: InputMaybe<RatingsAndReviewsDriverAppInput>;
};


export type DeviceQueryResponseSearchUserAvailabilityDriverAppArgs = {
  input?: InputMaybe<SearchUserAvailabilityDriverAppInput>;
};


export type DeviceQueryResponseTripConnectionCrewAppArgs = {
  input?: InputMaybe<TripConnectionInput>;
};


export type DeviceQueryResponseTripConnectionDriverAppArgs = {
  input?: InputMaybe<TripConnectionInput>;
};


export type DeviceQueryResponseTripRequiresDriverCrewCountArgs = {
  input: TripRequiresDriverCrewCountInput;
};


export type DeviceQueryResponseUserConnectionArgs = {
  input?: InputMaybe<UserConnectionInput>;
};

export type DeviceRegistrationInput = {
  token: Scalars['String']['input'];
};

export type DeviceRegistrationResponse = {
  __typename?: 'DeviceRegistrationResponse';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type DeviceSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  appName?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  lastSeenAt?: InputMaybe<Array<StringSearch>>;
  platform?: InputMaybe<Array<StringSearch>>;
  token?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type DeviceUserString = {
  __typename?: 'DeviceUserString';
  id: Scalars['String']['output'];
  value: DeviceUserStringItem;
};

export type DeviceUserStringItem = {
  __typename?: 'DeviceUserStringItem';
  longDescription?: Maybe<Scalars['String']['output']>;
  shortDescription?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type DispatchIssue = {
  __typename?: 'DispatchIssue';
  causedBy?: Maybe<Array<DispatchIssueCausedBy>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewMemberGiftCardCount?: Maybe<Scalars['Int']['output']>;
  crewMemberName?: Maybe<Scalars['String']['output']>;
  crewMemberPhone?: Maybe<Scalars['String']['output']>;
  datetime: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  dispatcherId?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  driverPhone?: Maybe<Scalars['String']['output']>;
  flightIssueDescription: Scalars['String']['output'];
  flightLate: DispatchIssueFlightLateEnum;
  flightType?: Maybe<DispatchIssueFlightTypeEnum>;
  id: Scalars['String']['output'];
  managerId?: Maybe<Scalars['String']['output']>;
  outboundFlightInfo?: Maybe<Scalars['String']['output']>;
  pushTime?: Maybe<Scalars['String']['output']>;
  recoveryCompleted?: Maybe<DispatchIssueRecoveryCompletedEnum>;
  recoveryFlightDatetime?: Maybe<Scalars['String']['output']>;
  recoveryFlightName?: Maybe<Scalars['String']['output']>;
  recoveryFlightNumber?: Maybe<Scalars['Int']['output']>;
  recoveryNeeded: DispatchIssueRecoveryNeededEnum;
  rootCause: DispatchIssueRootCauseEnum;
  rootCauseDescription: Scalars['String']['output'];
  scheduledTime?: Maybe<Scalars['String']['output']>;
  station: Scalars['String']['output'];
  taxiCost?: Maybe<Scalars['Float']['output']>;
  taxiDetails?: Maybe<DispatchIssueTaxiDetailsEnum>;
  taxiUsed?: Maybe<DispatchIssueTaxiUsedEnum>;
  traceId?: Maybe<Scalars['String']['output']>;
  tripId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
};

export type DispatchIssueActivityConnection = {
  __typename?: 'DispatchIssueActivityConnection';
  edges?: Maybe<Array<Maybe<DispatchIssueActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchIssueActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DispatchIssueActivityEdge = {
  __typename?: 'DispatchIssueActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DispatchIssueAndDocument = {
  __typename?: 'DispatchIssueAndDocument';
  causedBy?: Maybe<Array<DispatchIssueCausedBy>>;
  document?: Maybe<Array<DispatchIssueDocumentAndPresignedUrl>>;
  issue: DispatchIssue;
};

export type DispatchIssueCausedBy = {
  __typename?: 'DispatchIssueCausedBy';
  causedById: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dispatchIssueId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DispatchIssueCausedByActivityConnection = {
  __typename?: 'DispatchIssueCausedByActivityConnection';
  edges?: Maybe<Array<Maybe<DispatchIssueCausedByActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchIssueCausedByActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DispatchIssueCausedByActivityEdge = {
  __typename?: 'DispatchIssueCausedByActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DispatchIssueCausedByConnection = {
  __typename?: 'DispatchIssueCausedByConnection';
  edges?: Maybe<Array<Maybe<DispatchIssueCausedByEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchIssueCausedByConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DispatchIssueCausedByMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DispatchIssueCausedBySearch>>;
};

export type DispatchIssueCausedByEdge = {
  __typename?: 'DispatchIssueCausedByEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DispatchIssueCausedBy>;
};

export type DispatchIssueCausedByMaskInput = {
  causedById?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  dispatchIssueId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchIssueCausedBySearch = {
  causedById?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  dispatchIssueId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type DispatchIssueCausedByWithCache = {
  __typename?: 'DispatchIssueCausedByWithCache';
  causedByFirstName: Scalars['String']['output'];
  causedById: Scalars['String']['output'];
  causedByLastName: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dispatchIssueId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DispatchIssueCausedByWithCacheActivityConnection = {
  __typename?: 'DispatchIssueCausedByWithCacheActivityConnection';
  edges?: Maybe<Array<Maybe<DispatchIssueCausedByWithCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchIssueCausedByWithCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DispatchIssueCausedByWithCacheActivityEdge = {
  __typename?: 'DispatchIssueCausedByWithCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DispatchIssueCausedByWithCacheConnection = {
  __typename?: 'DispatchIssueCausedByWithCacheConnection';
  edges?: Maybe<Array<Maybe<DispatchIssueCausedByWithCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchIssueCausedByWithCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DispatchIssueCausedByWithCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DispatchIssueCausedByWithCacheSearch>>;
};

export type DispatchIssueCausedByWithCacheEdge = {
  __typename?: 'DispatchIssueCausedByWithCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DispatchIssueCausedByWithCache>;
};

export type DispatchIssueCausedByWithCacheMaskInput = {
  causedByFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  causedById?: InputMaybe<Scalars['Boolean']['input']>;
  causedByLastName?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  dispatchIssueId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchIssueCausedByWithCacheSearch = {
  causedByFirstName?: InputMaybe<Array<StringSearch>>;
  causedById?: InputMaybe<Array<StringSearch>>;
  causedByLastName?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  dispatchIssueId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type DispatchIssueConnection = {
  __typename?: 'DispatchIssueConnection';
  edges?: Maybe<Array<Maybe<DispatchIssueEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchIssueConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DispatchIssueMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DispatchIssueSearch>>;
};

export type DispatchIssueDocument = {
  __typename?: 'DispatchIssueDocument';
  contentType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  fileLocation: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  issueId: Scalars['String']['output'];
  md5: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DispatchIssueDocumentActivityConnection = {
  __typename?: 'DispatchIssueDocumentActivityConnection';
  edges?: Maybe<Array<Maybe<DispatchIssueDocumentActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchIssueDocumentActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DispatchIssueDocumentActivityEdge = {
  __typename?: 'DispatchIssueDocumentActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DispatchIssueDocumentAndPresignedUrl = {
  __typename?: 'DispatchIssueDocumentAndPresignedURL';
  document?: Maybe<DispatchIssueDocument>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

export type DispatchIssueDocumentConnection = {
  __typename?: 'DispatchIssueDocumentConnection';
  edges?: Maybe<Array<Maybe<DispatchIssueDocumentEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchIssueDocumentConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DispatchIssueDocumentMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DispatchIssueDocumentSearch>>;
};

export type DispatchIssueDocumentEdge = {
  __typename?: 'DispatchIssueDocumentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DispatchIssueDocument>;
};

export type DispatchIssueDocumentMaskInput = {
  contentType?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  fileSize?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  issueId?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchIssueDocumentSearch = {
  contentType?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  fileSize?: InputMaybe<Array<IntSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  issueId?: InputMaybe<Array<StringSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type DispatchIssueEdge = {
  __typename?: 'DispatchIssueEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DispatchIssue>;
};

export enum DispatchIssueFlightLateEnum {
  No = 'NO',
  Yes = 'YES'
}

export type DispatchIssueFlightLateEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueFlightLateEnum>;
};

export enum DispatchIssueFlightTypeEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type DispatchIssueFlightTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueFlightTypeEnum>;
};

export type DispatchIssueMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewMemberGiftCardCount?: InputMaybe<Scalars['Boolean']['input']>;
  crewMemberName?: InputMaybe<Scalars['Boolean']['input']>;
  crewMemberPhone?: InputMaybe<Scalars['Boolean']['input']>;
  datetime?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherId?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  driverPhone?: InputMaybe<Scalars['Boolean']['input']>;
  flightIssueDescription?: InputMaybe<Scalars['Boolean']['input']>;
  flightLate?: InputMaybe<Scalars['Boolean']['input']>;
  flightType?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  managerId?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightInfo?: InputMaybe<Scalars['Boolean']['input']>;
  pushTime?: InputMaybe<Scalars['Boolean']['input']>;
  recoveryCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  recoveryFlightDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  recoveryFlightName?: InputMaybe<Scalars['Boolean']['input']>;
  recoveryFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  recoveryNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  rootCause?: InputMaybe<Scalars['Boolean']['input']>;
  rootCauseDescription?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledTime?: InputMaybe<Scalars['Boolean']['input']>;
  station?: InputMaybe<Scalars['Boolean']['input']>;
  taxiCost?: InputMaybe<Scalars['Boolean']['input']>;
  taxiDetails?: InputMaybe<Scalars['Boolean']['input']>;
  taxiUsed?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DispatchIssueRecoveryCompletedEnum {
  No = 'NO',
  Yes = 'YES'
}

export type DispatchIssueRecoveryCompletedEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueRecoveryCompletedEnum>;
};

export enum DispatchIssueRecoveryNeededEnum {
  No = 'NO',
  Yes = 'YES'
}

export type DispatchIssueRecoveryNeededEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueRecoveryNeededEnum>;
};

export enum DispatchIssueRootCauseEnum {
  Accident = 'ACCIDENT',
  Dispatch = 'DISPATCH',
  Other = 'OTHER',
  Station = 'STATION'
}

export type DispatchIssueRootCauseEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueRootCauseEnum>;
};

export type DispatchIssueSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewMemberGiftCardCount?: InputMaybe<Array<IntSearch>>;
  crewMemberName?: InputMaybe<Array<StringSearch>>;
  crewMemberPhone?: InputMaybe<Array<StringSearch>>;
  datetime?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  dispatcherId?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  driverPhone?: InputMaybe<Array<StringSearch>>;
  flightIssueDescription?: InputMaybe<Array<StringSearch>>;
  flightLate?: InputMaybe<Array<DispatchIssueFlightLateEnumSearch>>;
  flightType?: InputMaybe<Array<DispatchIssueFlightTypeEnumSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  managerId?: InputMaybe<Array<StringSearch>>;
  outboundFlightInfo?: InputMaybe<Array<StringSearch>>;
  pushTime?: InputMaybe<Array<StringSearch>>;
  recoveryCompleted?: InputMaybe<Array<DispatchIssueRecoveryCompletedEnumSearch>>;
  recoveryFlightDatetime?: InputMaybe<Array<StringSearch>>;
  recoveryFlightName?: InputMaybe<Array<StringSearch>>;
  recoveryFlightNumber?: InputMaybe<Array<IntSearch>>;
  recoveryNeeded?: InputMaybe<Array<DispatchIssueRecoveryNeededEnumSearch>>;
  rootCause?: InputMaybe<Array<DispatchIssueRootCauseEnumSearch>>;
  rootCauseDescription?: InputMaybe<Array<StringSearch>>;
  scheduledTime?: InputMaybe<Array<StringSearch>>;
  station?: InputMaybe<Array<StringSearch>>;
  taxiCost?: InputMaybe<Array<FloatSearch>>;
  taxiDetails?: InputMaybe<Array<DispatchIssueTaxiDetailsEnumSearch>>;
  taxiUsed?: InputMaybe<Array<DispatchIssueTaxiUsedEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
};

export enum DispatchIssueTaxiDetailsEnum {
  CrewPaid = 'CREW_PAID',
  ShgPaid = 'SHG_PAID',
  ShgTaxi = 'SHG_TAXI'
}

export type DispatchIssueTaxiDetailsEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueTaxiDetailsEnum>;
};

export enum DispatchIssueTaxiUsedEnum {
  No = 'NO',
  Yes = 'YES'
}

export type DispatchIssueTaxiUsedEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueTaxiUsedEnum>;
};

export type DispatchIssueWithCache = {
  __typename?: 'DispatchIssueWithCache';
  causedBy?: Maybe<Array<DispatchIssueCausedByWithCache>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewMemberGiftCardCount?: Maybe<Scalars['Int']['output']>;
  crewMemberName?: Maybe<Scalars['String']['output']>;
  crewMemberPhone?: Maybe<Scalars['String']['output']>;
  datetime: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  dispatcherEmployeeId?: Maybe<Scalars['String']['output']>;
  dispatcherFirstName: Scalars['String']['output'];
  dispatcherId?: Maybe<Scalars['String']['output']>;
  dispatcherLastName: Scalars['String']['output'];
  driverEmployeeId?: Maybe<Scalars['String']['output']>;
  driverFirstName: Scalars['String']['output'];
  driverId?: Maybe<Scalars['String']['output']>;
  driverLastName: Scalars['String']['output'];
  driverPhone?: Maybe<Scalars['String']['output']>;
  flightIssueDescription: Scalars['String']['output'];
  flightLate: DispatchIssueWithCacheFlightLateEnum;
  flightType?: Maybe<DispatchIssueWithCacheFlightTypeEnum>;
  id: Scalars['String']['output'];
  managerEmployeeId?: Maybe<Scalars['String']['output']>;
  managerFirstName: Scalars['String']['output'];
  managerId?: Maybe<Scalars['String']['output']>;
  managerLastName: Scalars['String']['output'];
  outboundFlightInfo?: Maybe<Scalars['String']['output']>;
  pushTime?: Maybe<Scalars['String']['output']>;
  recoveryCompleted?: Maybe<DispatchIssueWithCacheRecoveryCompletedEnum>;
  recoveryFlightDatetime?: Maybe<Scalars['String']['output']>;
  recoveryFlightName?: Maybe<Scalars['String']['output']>;
  recoveryFlightNumber?: Maybe<Scalars['Int']['output']>;
  recoveryNeeded: DispatchIssueWithCacheRecoveryNeededEnum;
  rootCause: DispatchIssueWithCacheRootCauseEnum;
  rootCauseDescription: Scalars['String']['output'];
  scheduledTime?: Maybe<Scalars['String']['output']>;
  station: Scalars['String']['output'];
  taxiCost?: Maybe<Scalars['Float']['output']>;
  taxiDetails?: Maybe<DispatchIssueWithCacheTaxiDetailsEnum>;
  taxiUsed?: Maybe<DispatchIssueWithCacheTaxiUsedEnum>;
  traceId?: Maybe<Scalars['String']['output']>;
  tripAirportCode: Scalars['String']['output'];
  tripFlightNumber: Scalars['Int']['output'];
  tripId?: Maybe<Scalars['String']['output']>;
  tripKind: DispatchIssueWithCacheTripKindEnum;
  tripLoopName: Scalars['String']['output'];
  tripScheduled: Scalars['String']['output'];
  tripServicerIataAirlineCode: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
  vehicleTrackingId: Scalars['String']['output'];
};

export type DispatchIssueWithCacheActivityConnection = {
  __typename?: 'DispatchIssueWithCacheActivityConnection';
  edges?: Maybe<Array<Maybe<DispatchIssueWithCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchIssueWithCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DispatchIssueWithCacheActivityEdge = {
  __typename?: 'DispatchIssueWithCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DispatchIssueWithCacheConnection = {
  __typename?: 'DispatchIssueWithCacheConnection';
  edges?: Maybe<Array<Maybe<DispatchIssueWithCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchIssueWithCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DispatchIssueWithCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DispatchIssueWithCacheSearch>>;
};

export type DispatchIssueWithCacheEdge = {
  __typename?: 'DispatchIssueWithCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DispatchIssueWithCache>;
};

export enum DispatchIssueWithCacheFlightLateEnum {
  No = 'NO',
  Yes = 'YES'
}

export type DispatchIssueWithCacheFlightLateEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueWithCacheFlightLateEnum>;
};

export enum DispatchIssueWithCacheFlightTypeEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type DispatchIssueWithCacheFlightTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueWithCacheFlightTypeEnum>;
};

export type DispatchIssueWithCacheMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewMemberGiftCardCount?: InputMaybe<Scalars['Boolean']['input']>;
  crewMemberName?: InputMaybe<Scalars['Boolean']['input']>;
  crewMemberPhone?: InputMaybe<Scalars['Boolean']['input']>;
  datetime?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherId?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherLastName?: InputMaybe<Scalars['Boolean']['input']>;
  driverEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  driverFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  driverLastName?: InputMaybe<Scalars['Boolean']['input']>;
  driverPhone?: InputMaybe<Scalars['Boolean']['input']>;
  flightIssueDescription?: InputMaybe<Scalars['Boolean']['input']>;
  flightLate?: InputMaybe<Scalars['Boolean']['input']>;
  flightType?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  managerEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  managerFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  managerId?: InputMaybe<Scalars['Boolean']['input']>;
  managerLastName?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightInfo?: InputMaybe<Scalars['Boolean']['input']>;
  pushTime?: InputMaybe<Scalars['Boolean']['input']>;
  recoveryCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  recoveryFlightDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  recoveryFlightName?: InputMaybe<Scalars['Boolean']['input']>;
  recoveryFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  recoveryNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  rootCause?: InputMaybe<Scalars['Boolean']['input']>;
  rootCauseDescription?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledTime?: InputMaybe<Scalars['Boolean']['input']>;
  station?: InputMaybe<Scalars['Boolean']['input']>;
  taxiCost?: InputMaybe<Scalars['Boolean']['input']>;
  taxiDetails?: InputMaybe<Scalars['Boolean']['input']>;
  taxiUsed?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  tripAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  tripFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  tripKind?: InputMaybe<Scalars['Boolean']['input']>;
  tripLoopName?: InputMaybe<Scalars['Boolean']['input']>;
  tripScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  tripServicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTrackingId?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum DispatchIssueWithCacheRecoveryCompletedEnum {
  No = 'NO',
  Yes = 'YES'
}

export type DispatchIssueWithCacheRecoveryCompletedEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueWithCacheRecoveryCompletedEnum>;
};

export enum DispatchIssueWithCacheRecoveryNeededEnum {
  No = 'NO',
  Yes = 'YES'
}

export type DispatchIssueWithCacheRecoveryNeededEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueWithCacheRecoveryNeededEnum>;
};

export enum DispatchIssueWithCacheRootCauseEnum {
  Accident = 'ACCIDENT',
  Dispatch = 'DISPATCH',
  Other = 'OTHER',
  Station = 'STATION'
}

export type DispatchIssueWithCacheRootCauseEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueWithCacheRootCauseEnum>;
};

export type DispatchIssueWithCacheSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewMemberGiftCardCount?: InputMaybe<Array<IntSearch>>;
  crewMemberName?: InputMaybe<Array<StringSearch>>;
  crewMemberPhone?: InputMaybe<Array<StringSearch>>;
  datetime?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  dispatcherEmployeeId?: InputMaybe<Array<StringSearch>>;
  dispatcherFirstName?: InputMaybe<Array<StringSearch>>;
  dispatcherId?: InputMaybe<Array<StringSearch>>;
  dispatcherLastName?: InputMaybe<Array<StringSearch>>;
  driverEmployeeId?: InputMaybe<Array<StringSearch>>;
  driverFirstName?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  driverLastName?: InputMaybe<Array<StringSearch>>;
  driverPhone?: InputMaybe<Array<StringSearch>>;
  flightIssueDescription?: InputMaybe<Array<StringSearch>>;
  flightLate?: InputMaybe<Array<DispatchIssueWithCacheFlightLateEnumSearch>>;
  flightType?: InputMaybe<Array<DispatchIssueWithCacheFlightTypeEnumSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  managerEmployeeId?: InputMaybe<Array<StringSearch>>;
  managerFirstName?: InputMaybe<Array<StringSearch>>;
  managerId?: InputMaybe<Array<StringSearch>>;
  managerLastName?: InputMaybe<Array<StringSearch>>;
  outboundFlightInfo?: InputMaybe<Array<StringSearch>>;
  pushTime?: InputMaybe<Array<StringSearch>>;
  recoveryCompleted?: InputMaybe<Array<DispatchIssueWithCacheRecoveryCompletedEnumSearch>>;
  recoveryFlightDatetime?: InputMaybe<Array<StringSearch>>;
  recoveryFlightName?: InputMaybe<Array<StringSearch>>;
  recoveryFlightNumber?: InputMaybe<Array<IntSearch>>;
  recoveryNeeded?: InputMaybe<Array<DispatchIssueWithCacheRecoveryNeededEnumSearch>>;
  rootCause?: InputMaybe<Array<DispatchIssueWithCacheRootCauseEnumSearch>>;
  rootCauseDescription?: InputMaybe<Array<StringSearch>>;
  scheduledTime?: InputMaybe<Array<StringSearch>>;
  station?: InputMaybe<Array<StringSearch>>;
  taxiCost?: InputMaybe<Array<FloatSearch>>;
  taxiDetails?: InputMaybe<Array<DispatchIssueWithCacheTaxiDetailsEnumSearch>>;
  taxiUsed?: InputMaybe<Array<DispatchIssueWithCacheTaxiUsedEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  tripAirportCode?: InputMaybe<Array<StringSearch>>;
  tripFlightNumber?: InputMaybe<Array<IntSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  tripKind?: InputMaybe<Array<DispatchIssueWithCacheTripKindEnumSearch>>;
  tripLoopName?: InputMaybe<Array<StringSearch>>;
  tripScheduled?: InputMaybe<Array<StringSearch>>;
  tripServicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  vehicleTrackingId?: InputMaybe<Array<StringSearch>>;
};

export enum DispatchIssueWithCacheTaxiDetailsEnum {
  CrewPaid = 'CREW_PAID',
  ShgPaid = 'SHG_PAID',
  ShgTaxi = 'SHG_TAXI'
}

export type DispatchIssueWithCacheTaxiDetailsEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueWithCacheTaxiDetailsEnum>;
};

export enum DispatchIssueWithCacheTaxiUsedEnum {
  No = 'NO',
  Yes = 'YES'
}

export type DispatchIssueWithCacheTaxiUsedEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueWithCacheTaxiUsedEnum>;
};

export enum DispatchIssueWithCacheTripKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type DispatchIssueWithCacheTripKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchIssueWithCacheTripKindEnum>;
};

export type DispatchSummary = {
  __typename?: 'DispatchSummary';
  callVolume: DispatchSummaryCallVolumeEnum;
  chatVolume?: Maybe<DispatchSummaryChatVolumeEnum>;
  commentsFaxallCheck?: Maybe<Scalars['String']['output']>;
  commentsRepeatDistractedOffenders: Scalars['String']['output'];
  commentsRepeatSpeedingOffenders: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  dispatcherAssetCamerasWorking: DispatchSummaryDispatcherAssetCamerasWorkingEnum;
  dispatcherAssetCamerasWorkingNotes: Scalars['String']['output'];
  dispatcherDayOverview: Scalars['String']['output'];
  dispatcherEightByEightIssue?: Maybe<Scalars['String']['output']>;
  dispatcherId: Scalars['String']['output'];
  dispatcherPassdown: Scalars['String']['output'];
  dispatcherServiceIssues?: Maybe<Scalars['String']['output']>;
  dispatcherShift: DispatchSummaryDispatcherShiftEnum;
  dispatcherSoftwareIssues: Scalars['String']['output'];
  dispatcherStation?: Maybe<Scalars['String']['output']>;
  dispatcherStationVansIssues?: Maybe<Scalars['String']['output']>;
  dispatcherWasThereEightByEightIssue?: Maybe<DispatchSummaryDispatcherWasThereEightByEightIssueEnum>;
  id: Scalars['String']['output'];
  manifestsDrivingIssues: Scalars['String']['output'];
  manifestsTaxis: Scalars['String']['output'];
  manifestsTrainingIssues: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DispatchSummaryActivityConnection = {
  __typename?: 'DispatchSummaryActivityConnection';
  edges?: Maybe<Array<Maybe<DispatchSummaryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchSummaryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DispatchSummaryActivityEdge = {
  __typename?: 'DispatchSummaryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum DispatchSummaryCallVolumeEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Nominal = 'NOMINAL'
}

export type DispatchSummaryCallVolumeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchSummaryCallVolumeEnum>;
};

export enum DispatchSummaryChatVolumeEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type DispatchSummaryChatVolumeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchSummaryChatVolumeEnum>;
};

export type DispatchSummaryConnection = {
  __typename?: 'DispatchSummaryConnection';
  edges?: Maybe<Array<Maybe<DispatchSummaryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchSummaryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DispatchSummaryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DispatchSummarySearch>>;
};

export enum DispatchSummaryDispatcherAssetCamerasWorkingEnum {
  No = 'NO',
  Yes = 'YES'
}

export type DispatchSummaryDispatcherAssetCamerasWorkingEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchSummaryDispatcherAssetCamerasWorkingEnum>;
};

export enum DispatchSummaryDispatcherShiftEnum {
  Evening = 'EVENING',
  Morning = 'MORNING',
  Other = 'OTHER',
  Overnight = 'OVERNIGHT'
}

export type DispatchSummaryDispatcherShiftEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchSummaryDispatcherShiftEnum>;
};

export enum DispatchSummaryDispatcherWasThereEightByEightIssueEnum {
  No = 'NO',
  Yes = 'YES'
}

export type DispatchSummaryDispatcherWasThereEightByEightIssueEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchSummaryDispatcherWasThereEightByEightIssueEnum>;
};

export type DispatchSummaryDocument = {
  __typename?: 'DispatchSummaryDocument';
  contentType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  fileLocation: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  md5: Scalars['String']['output'];
  summaryId: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DispatchSummaryDocumentActivityConnection = {
  __typename?: 'DispatchSummaryDocumentActivityConnection';
  edges?: Maybe<Array<Maybe<DispatchSummaryDocumentActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchSummaryDocumentActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DispatchSummaryDocumentActivityEdge = {
  __typename?: 'DispatchSummaryDocumentActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DispatchSummaryDocumentConnection = {
  __typename?: 'DispatchSummaryDocumentConnection';
  edges?: Maybe<Array<Maybe<DispatchSummaryDocumentEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchSummaryDocumentConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DispatchSummaryDocumentMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DispatchSummaryDocumentSearch>>;
};

export type DispatchSummaryDocumentEdge = {
  __typename?: 'DispatchSummaryDocumentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DispatchSummaryDocument>;
};

export type DispatchSummaryDocumentMaskInput = {
  contentType?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  fileSize?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  summaryId?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchSummaryDocumentSearch = {
  contentType?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  fileSize?: InputMaybe<Array<IntSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  summaryId?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type DispatchSummaryEdge = {
  __typename?: 'DispatchSummaryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DispatchSummary>;
};

export type DispatchSummaryMarket = {
  __typename?: 'DispatchSummaryMarket';
  airportCode: Scalars['String']['output'];
  comment: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dispatchSummaryId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DispatchSummaryMarketActivityConnection = {
  __typename?: 'DispatchSummaryMarketActivityConnection';
  edges?: Maybe<Array<Maybe<DispatchSummaryMarketActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchSummaryMarketActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DispatchSummaryMarketActivityEdge = {
  __typename?: 'DispatchSummaryMarketActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DispatchSummaryMarketConnection = {
  __typename?: 'DispatchSummaryMarketConnection';
  edges?: Maybe<Array<Maybe<DispatchSummaryMarketEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchSummaryMarketConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DispatchSummaryMarketMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DispatchSummaryMarketSearch>>;
};

export type DispatchSummaryMarketEdge = {
  __typename?: 'DispatchSummaryMarketEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DispatchSummaryMarket>;
};

export type DispatchSummaryMarketMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  dispatchSummaryId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchSummaryMarketSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  comment?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  dispatchSummaryId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type DispatchSummaryMaskInput = {
  callVolume?: InputMaybe<Scalars['Boolean']['input']>;
  chatVolume?: InputMaybe<Scalars['Boolean']['input']>;
  commentsFaxallCheck?: InputMaybe<Scalars['Boolean']['input']>;
  commentsRepeatDistractedOffenders?: InputMaybe<Scalars['Boolean']['input']>;
  commentsRepeatSpeedingOffenders?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherAssetCamerasWorking?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherAssetCamerasWorkingNotes?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherDayOverview?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherEightByEightIssue?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherId?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherPassdown?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherServiceIssues?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherShift?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherSoftwareIssues?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherStation?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherStationVansIssues?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherWasThereEightByEightIssue?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  manifestsDrivingIssues?: InputMaybe<Scalars['Boolean']['input']>;
  manifestsTaxis?: InputMaybe<Scalars['Boolean']['input']>;
  manifestsTrainingIssues?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchSummarySearch = {
  callVolume?: InputMaybe<Array<DispatchSummaryCallVolumeEnumSearch>>;
  chatVolume?: InputMaybe<Array<DispatchSummaryChatVolumeEnumSearch>>;
  commentsFaxallCheck?: InputMaybe<Array<StringSearch>>;
  commentsRepeatDistractedOffenders?: InputMaybe<Array<StringSearch>>;
  commentsRepeatSpeedingOffenders?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  dispatcherAssetCamerasWorking?: InputMaybe<Array<DispatchSummaryDispatcherAssetCamerasWorkingEnumSearch>>;
  dispatcherAssetCamerasWorkingNotes?: InputMaybe<Array<StringSearch>>;
  dispatcherDayOverview?: InputMaybe<Array<StringSearch>>;
  dispatcherEightByEightIssue?: InputMaybe<Array<StringSearch>>;
  dispatcherId?: InputMaybe<Array<StringSearch>>;
  dispatcherPassdown?: InputMaybe<Array<StringSearch>>;
  dispatcherServiceIssues?: InputMaybe<Array<StringSearch>>;
  dispatcherShift?: InputMaybe<Array<DispatchSummaryDispatcherShiftEnumSearch>>;
  dispatcherSoftwareIssues?: InputMaybe<Array<StringSearch>>;
  dispatcherStation?: InputMaybe<Array<StringSearch>>;
  dispatcherStationVansIssues?: InputMaybe<Array<StringSearch>>;
  dispatcherWasThereEightByEightIssue?: InputMaybe<Array<DispatchSummaryDispatcherWasThereEightByEightIssueEnumSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  manifestsDrivingIssues?: InputMaybe<Array<StringSearch>>;
  manifestsTaxis?: InputMaybe<Array<StringSearch>>;
  manifestsTrainingIssues?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type DispatchSummaryWithCache = {
  __typename?: 'DispatchSummaryWithCache';
  callVolume: DispatchSummaryWithCacheCallVolumeEnum;
  chatVolume?: Maybe<DispatchSummaryWithCacheChatVolumeEnum>;
  commentsFaxallCheck?: Maybe<Scalars['String']['output']>;
  commentsRepeatDistractedOffenders: Scalars['String']['output'];
  commentsRepeatSpeedingOffenders: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  dispatcherAssetCamerasWorking: DispatchSummaryWithCacheDispatcherAssetCamerasWorkingEnum;
  dispatcherAssetCamerasWorkingNotes: Scalars['String']['output'];
  dispatcherDayOverview: Scalars['String']['output'];
  dispatcherEightByEightIssue?: Maybe<Scalars['String']['output']>;
  dispatcherEmployeeId?: Maybe<Scalars['String']['output']>;
  dispatcherFirstName: Scalars['String']['output'];
  dispatcherId: Scalars['String']['output'];
  dispatcherLastName: Scalars['String']['output'];
  dispatcherPassdown: Scalars['String']['output'];
  dispatcherServiceIssues?: Maybe<Scalars['String']['output']>;
  dispatcherShift: DispatchSummaryWithCacheDispatcherShiftEnum;
  dispatcherSoftwareIssues: Scalars['String']['output'];
  dispatcherStation?: Maybe<Scalars['String']['output']>;
  dispatcherStationVansIssues?: Maybe<Scalars['String']['output']>;
  dispatcherWasThereEightByEightIssue?: Maybe<DispatchSummaryWithCacheDispatcherWasThereEightByEightIssueEnum>;
  id: Scalars['String']['output'];
  manifestsDrivingIssues: Scalars['String']['output'];
  manifestsTaxis: Scalars['String']['output'];
  manifestsTrainingIssues: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DispatchSummaryWithCacheActivityConnection = {
  __typename?: 'DispatchSummaryWithCacheActivityConnection';
  edges?: Maybe<Array<Maybe<DispatchSummaryWithCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchSummaryWithCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DispatchSummaryWithCacheActivityEdge = {
  __typename?: 'DispatchSummaryWithCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum DispatchSummaryWithCacheCallVolumeEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Nominal = 'NOMINAL'
}

export type DispatchSummaryWithCacheCallVolumeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchSummaryWithCacheCallVolumeEnum>;
};

export enum DispatchSummaryWithCacheChatVolumeEnum {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM'
}

export type DispatchSummaryWithCacheChatVolumeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchSummaryWithCacheChatVolumeEnum>;
};

export type DispatchSummaryWithCacheConnection = {
  __typename?: 'DispatchSummaryWithCacheConnection';
  edges?: Maybe<Array<Maybe<DispatchSummaryWithCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DispatchSummaryWithCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DispatchSummaryWithCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DispatchSummaryWithCacheSearch>>;
};

export enum DispatchSummaryWithCacheDispatcherAssetCamerasWorkingEnum {
  No = 'NO',
  Yes = 'YES'
}

export type DispatchSummaryWithCacheDispatcherAssetCamerasWorkingEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchSummaryWithCacheDispatcherAssetCamerasWorkingEnum>;
};

export enum DispatchSummaryWithCacheDispatcherShiftEnum {
  Evening = 'EVENING',
  Morning = 'MORNING',
  Other = 'OTHER',
  Overnight = 'OVERNIGHT'
}

export type DispatchSummaryWithCacheDispatcherShiftEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchSummaryWithCacheDispatcherShiftEnum>;
};

export enum DispatchSummaryWithCacheDispatcherWasThereEightByEightIssueEnum {
  No = 'NO',
  Yes = 'YES'
}

export type DispatchSummaryWithCacheDispatcherWasThereEightByEightIssueEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DispatchSummaryWithCacheDispatcherWasThereEightByEightIssueEnum>;
};

export type DispatchSummaryWithCacheEdge = {
  __typename?: 'DispatchSummaryWithCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DispatchSummaryWithCache>;
};

export type DispatchSummaryWithCacheMaskInput = {
  callVolume?: InputMaybe<Scalars['Boolean']['input']>;
  chatVolume?: InputMaybe<Scalars['Boolean']['input']>;
  commentsFaxallCheck?: InputMaybe<Scalars['Boolean']['input']>;
  commentsRepeatDistractedOffenders?: InputMaybe<Scalars['Boolean']['input']>;
  commentsRepeatSpeedingOffenders?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherAssetCamerasWorking?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherAssetCamerasWorkingNotes?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherDayOverview?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherEightByEightIssue?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherId?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherLastName?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherPassdown?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherServiceIssues?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherShift?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherSoftwareIssues?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherStation?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherStationVansIssues?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherWasThereEightByEightIssue?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  manifestsDrivingIssues?: InputMaybe<Scalars['Boolean']['input']>;
  manifestsTaxis?: InputMaybe<Scalars['Boolean']['input']>;
  manifestsTrainingIssues?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DispatchSummaryWithCacheSearch = {
  callVolume?: InputMaybe<Array<DispatchSummaryWithCacheCallVolumeEnumSearch>>;
  chatVolume?: InputMaybe<Array<DispatchSummaryWithCacheChatVolumeEnumSearch>>;
  commentsFaxallCheck?: InputMaybe<Array<StringSearch>>;
  commentsRepeatDistractedOffenders?: InputMaybe<Array<StringSearch>>;
  commentsRepeatSpeedingOffenders?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  dispatcherAssetCamerasWorking?: InputMaybe<Array<DispatchSummaryWithCacheDispatcherAssetCamerasWorkingEnumSearch>>;
  dispatcherAssetCamerasWorkingNotes?: InputMaybe<Array<StringSearch>>;
  dispatcherDayOverview?: InputMaybe<Array<StringSearch>>;
  dispatcherEightByEightIssue?: InputMaybe<Array<StringSearch>>;
  dispatcherEmployeeId?: InputMaybe<Array<StringSearch>>;
  dispatcherFirstName?: InputMaybe<Array<StringSearch>>;
  dispatcherId?: InputMaybe<Array<StringSearch>>;
  dispatcherLastName?: InputMaybe<Array<StringSearch>>;
  dispatcherPassdown?: InputMaybe<Array<StringSearch>>;
  dispatcherServiceIssues?: InputMaybe<Array<StringSearch>>;
  dispatcherShift?: InputMaybe<Array<DispatchSummaryWithCacheDispatcherShiftEnumSearch>>;
  dispatcherSoftwareIssues?: InputMaybe<Array<StringSearch>>;
  dispatcherStation?: InputMaybe<Array<StringSearch>>;
  dispatcherStationVansIssues?: InputMaybe<Array<StringSearch>>;
  dispatcherWasThereEightByEightIssue?: InputMaybe<Array<DispatchSummaryWithCacheDispatcherWasThereEightByEightIssueEnumSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  manifestsDrivingIssues?: InputMaybe<Array<StringSearch>>;
  manifestsTaxis?: InputMaybe<Array<StringSearch>>;
  manifestsTrainingIssues?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type Distance = {
  __typename?: 'Distance';
  cachedAt: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  distanceText: Scalars['String']['output'];
  distanceValue: Scalars['Int']['output'];
  durationInTrafficText: Scalars['String']['output'];
  durationInTrafficValue: Scalars['Int']['output'];
  durationText: Scalars['String']['output'];
  durationValue: Scalars['Int']['output'];
  fromLocationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  toLocationId: Scalars['String']['output'];
};

export type DistanceActivityConnection = {
  __typename?: 'DistanceActivityConnection';
  edges?: Maybe<Array<Maybe<DistanceActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DistanceActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DistanceActivityEdge = {
  __typename?: 'DistanceActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DistanceConnection = {
  __typename?: 'DistanceConnection';
  edges?: Maybe<Array<Maybe<DistanceEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DistanceConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DistanceMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DistanceSearch>>;
};

export type DistanceEdge = {
  __typename?: 'DistanceEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Distance>;
};

export type DistanceMaskInput = {
  cachedAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  distanceText?: InputMaybe<Scalars['Boolean']['input']>;
  distanceValue?: InputMaybe<Scalars['Boolean']['input']>;
  durationInTrafficText?: InputMaybe<Scalars['Boolean']['input']>;
  durationInTrafficValue?: InputMaybe<Scalars['Boolean']['input']>;
  durationText?: InputMaybe<Scalars['Boolean']['input']>;
  durationValue?: InputMaybe<Scalars['Boolean']['input']>;
  fromLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  toLocationId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DistanceSearch = {
  cachedAt?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  distanceText?: InputMaybe<Array<StringSearch>>;
  distanceValue?: InputMaybe<Array<IntSearch>>;
  durationInTrafficText?: InputMaybe<Array<StringSearch>>;
  durationInTrafficValue?: InputMaybe<Array<IntSearch>>;
  durationText?: InputMaybe<Array<StringSearch>>;
  durationValue?: InputMaybe<Array<IntSearch>>;
  fromLocationId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  toLocationId?: InputMaybe<Array<StringSearch>>;
};

export type DownloadAccidentIssueAsCsvInput = {
  columns?: InputMaybe<AccidentIssueMaskInput>;
  customColumns?: InputMaybe<Array<TripAccidentIssueCsvColumn>>;
  query: Array<AccidentIssueSearch>;
};

export type DownloadAccidentIssueAsCsvResponse = {
  __typename?: 'DownloadAccidentIssueAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAccidentIssueDocumentAsCsvInput = {
  columns?: InputMaybe<AccidentIssueDocumentMaskInput>;
  customColumns?: InputMaybe<Array<TripAccidentIssueDocumentCsvColumn>>;
  query: Array<AccidentIssueDocumentSearch>;
};

export type DownloadAccidentIssueDocumentAsCsvResponse = {
  __typename?: 'DownloadAccidentIssueDocumentAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAccidentIssueWithCacheAsCsvInput = {
  columns?: InputMaybe<AccidentIssueWithCacheMaskInput>;
  customColumns?: InputMaybe<Array<TripAccidentIssueWithCacheCsvColumn>>;
  query: Array<AccidentIssueWithCacheSearch>;
};

export type DownloadAccidentIssueWithCacheAsCsvResponse = {
  __typename?: 'DownloadAccidentIssueWithCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadActivityAsCsvInput = {
  columns?: InputMaybe<ActivityMaskInput>;
  customColumns?: InputMaybe<Array<TripActivityCsvColumn>>;
  query: Array<ActivitySearch>;
};

export type DownloadActivityAsCsvResponse = {
  __typename?: 'DownloadActivityAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadActivityDisplayMessageAsCsvInput = {
  columns?: InputMaybe<ActivityDisplayMessageMaskInput>;
  customColumns?: InputMaybe<Array<ActivityActivityDisplayMessageCsvColumn>>;
  query: Array<ActivityDisplayMessageSearch>;
};

export type DownloadActivityDisplayMessageAsCsvResponse = {
  __typename?: 'DownloadActivityDisplayMessageAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadActivityLogAsCsvInput = {
  columns?: InputMaybe<ActivityLogMaskInput>;
  customColumns?: InputMaybe<Array<ActivityActivityLogCsvColumn>>;
  query: Array<ActivityLogSearch>;
};

export type DownloadActivityLogAsCsvResponse = {
  __typename?: 'DownloadActivityLogAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadActivityLogPayloadAsCsvInput = {
  columns?: InputMaybe<ActivityLogPayloadMaskInput>;
  customColumns?: InputMaybe<Array<ActivityActivityLogPayloadCsvColumn>>;
  query: Array<ActivityLogPayloadSearch>;
};

export type DownloadActivityLogPayloadAsCsvResponse = {
  __typename?: 'DownloadActivityLogPayloadAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadActivityLogPayloadChildAsCsvInput = {
  columns?: InputMaybe<ActivityLogPayloadChildMaskInput>;
  customColumns?: InputMaybe<Array<ActivityActivityLogPayloadChildCsvColumn>>;
  query: Array<ActivityLogPayloadChildSearch>;
};

export type DownloadActivityLogPayloadChildAsCsvResponse = {
  __typename?: 'DownloadActivityLogPayloadChildAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadActivityLogWithCacheAsCsvInput = {
  columns?: InputMaybe<ActivityLogWithCacheMaskInput>;
  customColumns?: InputMaybe<Array<ActivityActivityLogWithCacheCsvColumn>>;
  query: Array<ActivityLogWithCacheSearch>;
};

export type DownloadActivityLogWithCacheAsCsvResponse = {
  __typename?: 'DownloadActivityLogWithCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadActivityObjectAsCsvInput = {
  columns?: InputMaybe<ActivityObjectMaskInput>;
  customColumns?: InputMaybe<Array<TripActivityObjectCsvColumn>>;
  query: Array<ActivityObjectSearch>;
};

export type DownloadActivityObjectAsCsvResponse = {
  __typename?: 'DownloadActivityObjectAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadActivityUserCacheAsCsvInput = {
  columns?: InputMaybe<ActivityUserCacheMaskInput>;
  customColumns?: InputMaybe<Array<ActivityActivityUserCacheCsvColumn>>;
  query: Array<ActivityUserCacheSearch>;
};

export type DownloadActivityUserCacheAsCsvResponse = {
  __typename?: 'DownloadActivityUserCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAirportAsCsvInput = {
  columns?: InputMaybe<AirportMaskInput>;
  customColumns?: InputMaybe<Array<AirportAirportCsvColumn>>;
  query: Array<AirportSearch>;
};

export type DownloadAirportAsCsvResponse = {
  __typename?: 'DownloadAirportAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAirportGroupAsCsvInput = {
  columns?: InputMaybe<AirportGroupMaskInput>;
  customColumns?: InputMaybe<Array<AirportAirportGroupCsvColumn>>;
  query: Array<AirportGroupSearch>;
};

export type DownloadAirportGroupAsCsvResponse = {
  __typename?: 'DownloadAirportGroupAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAirportHasCompanyAsCsvInput = {
  columns?: InputMaybe<AirportHasCompanyMaskInput>;
  customColumns?: InputMaybe<Array<AirportAirportHasCompanyCsvColumn>>;
  query: Array<AirportHasCompanySearch>;
};

export type DownloadAirportHasCompanyAsCsvResponse = {
  __typename?: 'DownloadAirportHasCompanyAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAirportHasGroupAsCsvInput = {
  columns?: InputMaybe<AirportHasGroupMaskInput>;
  customColumns?: InputMaybe<Array<AirportAirportHasGroupCsvColumn>>;
  query: Array<AirportHasGroupSearch>;
};

export type DownloadAirportHasGroupAsCsvResponse = {
  __typename?: 'DownloadAirportHasGroupAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAirportHasLocationAsCsvInput = {
  columns?: InputMaybe<AirportHasLocationMaskInput>;
  customColumns?: InputMaybe<Array<LocationAirportHasLocationCsvColumn>>;
  query: Array<AirportHasLocationSearch>;
};

export type DownloadAirportHasLocationAsCsvResponse = {
  __typename?: 'DownloadAirportHasLocationAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAirportHasManagerEmailAsCsvInput = {
  columns?: InputMaybe<AirportHasManagerEmailMaskInput>;
  customColumns?: InputMaybe<Array<TripAirportHasManagerEmailCsvColumn>>;
  query: Array<AirportHasManagerEmailSearch>;
};

export type DownloadAirportHasManagerEmailAsCsvResponse = {
  __typename?: 'DownloadAirportHasManagerEmailAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAirportHasRateAsCsvInput = {
  columns?: InputMaybe<AirportHasRateMaskInput>;
  customColumns?: InputMaybe<Array<AirportAirportHasRateCsvColumn>>;
  query: Array<AirportHasRateSearch>;
};

export type DownloadAirportHasRateAsCsvResponse = {
  __typename?: 'DownloadAirportHasRateAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAirportHasVehicleAsCsvInput = {
  columns?: InputMaybe<AirportHasVehicleMaskInput>;
  customColumns?: InputMaybe<Array<TripAirportHasVehicleCsvColumn>>;
  query: Array<AirportHasVehicleSearch>;
};

export type DownloadAirportHasVehicleAsCsvResponse = {
  __typename?: 'DownloadAirportHasVehicleAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAirportWithCompanyAsCsvInput = {
  columns?: InputMaybe<AirportWithCompanyMaskInput>;
  customColumns?: InputMaybe<Array<AirportAirportWithCompanyCsvColumn>>;
  query: Array<AirportWithCompanySearch>;
};

export type DownloadAirportWithCompanyAsCsvResponse = {
  __typename?: 'DownloadAirportWithCompanyAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAirportWithGroupAsCsvInput = {
  columns?: InputMaybe<AirportWithGroupMaskInput>;
  customColumns?: InputMaybe<Array<AirportAirportWithGroupCsvColumn>>;
  query: Array<AirportWithGroupSearch>;
};

export type DownloadAirportWithGroupAsCsvResponse = {
  __typename?: 'DownloadAirportWithGroupAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAirportWithLocationAsCsvInput = {
  columns?: InputMaybe<AirportWithLocationMaskInput>;
  customColumns?: InputMaybe<Array<LocationAirportWithLocationCsvColumn>>;
  query: Array<AirportWithLocationSearch>;
};

export type DownloadAirportWithLocationAsCsvResponse = {
  __typename?: 'DownloadAirportWithLocationAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAirportWithVehicleAsCsvInput = {
  columns?: InputMaybe<AirportWithVehicleMaskInput>;
  customColumns?: InputMaybe<Array<TripAirportWithVehicleCsvColumn>>;
  query: Array<AirportWithVehicleSearch>;
};

export type DownloadAirportWithVehicleAsCsvResponse = {
  __typename?: 'DownloadAirportWithVehicleAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAlertSubscriptionAsCsvInput = {
  columns?: InputMaybe<AlertSubscriptionMaskInput>;
  customColumns?: InputMaybe<Array<FlightAlertSubscriptionCsvColumn>>;
  query: Array<AlertSubscriptionSearch>;
};

export type DownloadAlertSubscriptionAsCsvResponse = {
  __typename?: 'DownloadAlertSubscriptionAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAliasAsCsvInput = {
  columns?: InputMaybe<AliasMaskInput>;
  customColumns?: InputMaybe<Array<LocationAliasCsvColumn>>;
  query: Array<AliasSearch>;
};

export type DownloadAliasAsCsvResponse = {
  __typename?: 'DownloadAliasAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadApiKeyAsCsvInput = {
  columns?: InputMaybe<ApiKeyMaskInput>;
  customColumns?: InputMaybe<Array<UserApiKeyCsvColumn>>;
  query: Array<ApiKeySearch>;
};

export type DownloadApiKeyAsCsvResponse = {
  __typename?: 'DownloadApiKeyAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAuditSnapshotAsCsvInput = {
  columns?: InputMaybe<AuditSnapshotMaskInput>;
  customColumns?: InputMaybe<Array<ReportAuditSnapshotCsvColumn>>;
  query: Array<AuditSnapshotSearch>;
};

export type DownloadAuditSnapshotAsCsvResponse = {
  __typename?: 'DownloadAuditSnapshotAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAuditSnapshotWithNameAsCsvInput = {
  columns?: InputMaybe<AuditSnapshotWithNameMaskInput>;
  customColumns?: InputMaybe<Array<ReportAuditSnapshotWithNameCsvColumn>>;
  query: Array<AuditSnapshotWithNameSearch>;
};

export type DownloadAuditSnapshotWithNameAsCsvResponse = {
  __typename?: 'DownloadAuditSnapshotWithNameAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAutoCombineRuleAsCsvInput = {
  columns?: InputMaybe<AutoCombineRuleMaskInput>;
  customColumns?: InputMaybe<Array<ContractAutoCombineRuleCsvColumn>>;
  query: Array<AutoCombineRuleSearch>;
};

export type DownloadAutoCombineRuleAsCsvResponse = {
  __typename?: 'DownloadAutoCombineRuleAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAutoCombineRuleWithContractAsCsvInput = {
  columns?: InputMaybe<AutoCombineRuleWithContractMaskInput>;
  customColumns?: InputMaybe<Array<ContractAutoCombineRuleWithContractCsvColumn>>;
  query: Array<AutoCombineRuleWithContractSearch>;
};

export type DownloadAutoCombineRuleWithContractAsCsvResponse = {
  __typename?: 'DownloadAutoCombineRuleWithContractAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAutomationHistoryAirportAsCsvInput = {
  columns?: InputMaybe<AutomationHistoryAirportMaskInput>;
  customColumns?: InputMaybe<Array<AutomationAutomationHistoryAirportCsvColumn>>;
  query: Array<AutomationHistoryAirportSearch>;
};

export type DownloadAutomationHistoryAirportAsCsvResponse = {
  __typename?: 'DownloadAutomationHistoryAirportAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAutomationHistoryAsCsvInput = {
  columns?: InputMaybe<AutomationHistoryMaskInput>;
  customColumns?: InputMaybe<Array<AutomationAutomationHistoryCsvColumn>>;
  query: Array<AutomationHistorySearch>;
};

export type DownloadAutomationHistoryAsCsvResponse = {
  __typename?: 'DownloadAutomationHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAutomationHistoryLogAsCsvInput = {
  columns?: InputMaybe<AutomationHistoryLogMaskInput>;
  customColumns?: InputMaybe<Array<AutomationAutomationHistoryLogCsvColumn>>;
  query: Array<AutomationHistoryLogSearch>;
};

export type DownloadAutomationHistoryLogAsCsvResponse = {
  __typename?: 'DownloadAutomationHistoryLogAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAutomationHistoryWithAirportAsCsvInput = {
  columns?: InputMaybe<AutomationHistoryWithAirportMaskInput>;
  customColumns?: InputMaybe<Array<AutomationAutomationHistoryWithAirportCsvColumn>>;
  query: Array<AutomationHistoryWithAirportSearch>;
};

export type DownloadAutomationHistoryWithAirportAsCsvResponse = {
  __typename?: 'DownloadAutomationHistoryWithAirportAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAutomationReportAsCsvInput = {
  columns?: InputMaybe<AutomationReportMaskInput>;
  customColumns?: InputMaybe<Array<AutomationAutomationReportCsvColumn>>;
  query: Array<AutomationReportSearch>;
};

export type DownloadAutomationReportAsCsvResponse = {
  __typename?: 'DownloadAutomationReportAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAutomationReportWithAutomationHistoryAsCsvInput = {
  columns?: InputMaybe<AutomationReportWithAutomationHistoryMaskInput>;
  customColumns?: InputMaybe<Array<AutomationAutomationReportWithAutomationHistoryCsvColumn>>;
  query: Array<AutomationReportWithAutomationHistorySearch>;
};

export type DownloadAutomationReportWithAutomationHistoryAsCsvResponse = {
  __typename?: 'DownloadAutomationReportWithAutomationHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAutomationTripAsCsvInput = {
  columns?: InputMaybe<AutomationTripMaskInput>;
  customColumns?: InputMaybe<Array<AutomationAutomationTripCsvColumn>>;
  query: Array<AutomationTripSearch>;
};

export type DownloadAutomationTripAsCsvResponse = {
  __typename?: 'DownloadAutomationTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAutomationTripAssignmentReasonAsCsvInput = {
  columns?: InputMaybe<AutomationTripAssignmentReasonMaskInput>;
  customColumns?: InputMaybe<Array<AutomationAutomationTripAssignmentReasonCsvColumn>>;
  query: Array<AutomationTripAssignmentReasonSearch>;
};

export type DownloadAutomationTripAssignmentReasonAsCsvResponse = {
  __typename?: 'DownloadAutomationTripAssignmentReasonAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadAutomationTripLogAsCsvInput = {
  columns?: InputMaybe<AutomationTripLogMaskInput>;
  customColumns?: InputMaybe<Array<AutomationAutomationTripLogCsvColumn>>;
  query: Array<AutomationTripLogSearch>;
};

export type DownloadAutomationTripLogAsCsvResponse = {
  __typename?: 'DownloadAutomationTripLogAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadBufferTimeAsCsvInput = {
  columns?: InputMaybe<BufferTimeMaskInput>;
  customColumns?: InputMaybe<Array<ContractBufferTimeCsvColumn>>;
  query: Array<BufferTimeSearch>;
};

export type DownloadBufferTimeAsCsvResponse = {
  __typename?: 'DownloadBufferTimeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadBufferTimeWithContractAsCsvInput = {
  columns?: InputMaybe<BufferTimeWithContractMaskInput>;
  customColumns?: InputMaybe<Array<ContractBufferTimeWithContractCsvColumn>>;
  query: Array<BufferTimeWithContractSearch>;
};

export type DownloadBufferTimeWithContractAsCsvResponse = {
  __typename?: 'DownloadBufferTimeWithContractAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCancellationRuleAsCsvInput = {
  columns?: InputMaybe<CancellationRuleMaskInput>;
  customColumns?: InputMaybe<Array<ContractCancellationRuleCsvColumn>>;
  query: Array<CancellationRuleSearch>;
};

export type DownloadCancellationRuleAsCsvResponse = {
  __typename?: 'DownloadCancellationRuleAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCharityAmountHistoryAsCsvInput = {
  columns?: InputMaybe<CharityAmountHistoryMaskInput>;
  customColumns?: InputMaybe<Array<UserCharityAmountHistoryCsvColumn>>;
  query: Array<CharityAmountHistorySearch>;
};

export type DownloadCharityAmountHistoryAsCsvResponse = {
  __typename?: 'DownloadCharityAmountHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCharityAsCsvInput = {
  columns?: InputMaybe<CharityMaskInput>;
  customColumns?: InputMaybe<Array<UserCharityCsvColumn>>;
  query: Array<CharitySearch>;
};

export type DownloadCharityAsCsvResponse = {
  __typename?: 'DownloadCharityAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCharityRatingHistoryAsCsvInput = {
  columns?: InputMaybe<CharityRatingHistoryMaskInput>;
  customColumns?: InputMaybe<Array<UserCharityRatingHistoryCsvColumn>>;
  query: Array<CharityRatingHistorySearch>;
};

export type DownloadCharityRatingHistoryAsCsvResponse = {
  __typename?: 'DownloadCharityRatingHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCharityRatingHistoryReportAsCsvInput = {
  columns?: InputMaybe<CharityRatingHistoryReportMaskInput>;
  customColumns?: InputMaybe<Array<ReportCharityRatingHistoryReportCsvColumn>>;
  query: Array<CharityRatingHistoryReportSearch>;
};

export type DownloadCharityRatingHistoryReportAsCsvResponse = {
  __typename?: 'DownloadCharityRatingHistoryReportAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCharityRatingHistoryWithUserAsCsvInput = {
  columns?: InputMaybe<CharityRatingHistoryWithUserMaskInput>;
  customColumns?: InputMaybe<Array<UserCharityRatingHistoryWithUserCsvColumn>>;
  query: Array<CharityRatingHistoryWithUserSearch>;
};

export type DownloadCharityRatingHistoryWithUserAsCsvResponse = {
  __typename?: 'DownloadCharityRatingHistoryWithUserAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCharityWithAmountHistoryAsCsvInput = {
  columns?: InputMaybe<CharityWithAmountHistoryMaskInput>;
  customColumns?: InputMaybe<Array<UserCharityWithAmountHistoryCsvColumn>>;
  query: Array<CharityWithAmountHistorySearch>;
};

export type DownloadCharityWithAmountHistoryAsCsvResponse = {
  __typename?: 'DownloadCharityWithAmountHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadChatQuickReplyMessageAsCsvInput = {
  columns?: InputMaybe<ChatQuickReplyMessageMaskInput>;
  customColumns?: InputMaybe<Array<TripChatQuickReplyMessageCsvColumn>>;
  query: Array<ChatQuickReplyMessageSearch>;
};

export type DownloadChatQuickReplyMessageAsCsvResponse = {
  __typename?: 'DownloadChatQuickReplyMessageAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCheckinEventAsCsvInput = {
  columns?: InputMaybe<CheckinEventMaskInput>;
  customColumns?: InputMaybe<Array<TripCheckinEventCsvColumn>>;
  query: Array<CheckinEventSearch>;
};

export type DownloadCheckinEventAsCsvResponse = {
  __typename?: 'DownloadCheckinEventAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadClosestRateItemAsCsvInput = {
  columns?: InputMaybe<ClosestRateItemMaskInput>;
  customColumns?: InputMaybe<Array<TripClosestRateItemCsvColumn>>;
  query: Array<ClosestRateItemSearch>;
};

export type DownloadClosestRateItemAsCsvResponse = {
  __typename?: 'DownloadClosestRateItemAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCombineRuleAsCsvInput = {
  columns?: InputMaybe<CombineRuleMaskInput>;
  customColumns?: InputMaybe<Array<ContractCombineRuleCsvColumn>>;
  query: Array<CombineRuleSearch>;
};

export type DownloadCombineRuleAsCsvResponse = {
  __typename?: 'DownloadCombineRuleAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCombineRuleHistoryAsCsvInput = {
  columns?: InputMaybe<CombineRuleHistoryMaskInput>;
  customColumns?: InputMaybe<Array<ContractCombineRuleHistoryCsvColumn>>;
  query: Array<CombineRuleHistorySearch>;
};

export type DownloadCombineRuleHistoryAsCsvResponse = {
  __typename?: 'DownloadCombineRuleHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCombineRuleHistoryWithContractAsCsvInput = {
  columns?: InputMaybe<CombineRuleHistoryWithContractMaskInput>;
  customColumns?: InputMaybe<Array<ContractCombineRuleHistoryWithContractCsvColumn>>;
  query: Array<CombineRuleHistoryWithContractSearch>;
};

export type DownloadCombineRuleHistoryWithContractAsCsvResponse = {
  __typename?: 'DownloadCombineRuleHistoryWithContractAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCombineRuleWithContractAsCsvInput = {
  columns?: InputMaybe<CombineRuleWithContractMaskInput>;
  customColumns?: InputMaybe<Array<ContractCombineRuleWithContractCsvColumn>>;
  query: Array<CombineRuleWithContractSearch>;
};

export type DownloadCombineRuleWithContractAsCsvResponse = {
  __typename?: 'DownloadCombineRuleWithContractAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCommunicationAsCsvInput = {
  columns?: InputMaybe<CommunicationMaskInput>;
  customColumns?: InputMaybe<Array<TripCommunicationCsvColumn>>;
  query: Array<CommunicationSearch>;
};

export type DownloadCommunicationAsCsvResponse = {
  __typename?: 'DownloadCommunicationAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCompanyAsCsvInput = {
  columns?: InputMaybe<CompanyMaskInput>;
  customColumns?: InputMaybe<Array<ContractCompanyCsvColumn>>;
  query: Array<CompanySearch>;
};

export type DownloadCompanyAsCsvResponse = {
  __typename?: 'DownloadCompanyAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCompletionAsCsvInput = {
  columns?: InputMaybe<CompletionMaskInput>;
  customColumns?: InputMaybe<Array<TripCompletionCsvColumn>>;
  query: Array<CompletionSearch>;
};

export type DownloadCompletionAsCsvResponse = {
  __typename?: 'DownloadCompletionAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCompletionTypeAsCsvInput = {
  columns?: InputMaybe<CompletionTypeMaskInput>;
  customColumns?: InputMaybe<Array<TripCompletionTypeCsvColumn>>;
  query: Array<CompletionTypeSearch>;
};

export type DownloadCompletionTypeAsCsvResponse = {
  __typename?: 'DownloadCompletionTypeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCompletionWithTypeAsCsvInput = {
  columns?: InputMaybe<CompletionWithTypeMaskInput>;
  customColumns?: InputMaybe<Array<TripCompletionWithTypeCsvColumn>>;
  query: Array<CompletionWithTypeSearch>;
};

export type DownloadCompletionWithTypeAsCsvResponse = {
  __typename?: 'DownloadCompletionWithTypeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadContractAsCsvInput = {
  columns?: InputMaybe<ContractMaskInput>;
  customColumns?: InputMaybe<Array<ContractContractCsvColumn>>;
  query: Array<ContractSearch>;
};

export type DownloadContractAsCsvResponse = {
  __typename?: 'DownloadContractAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadContractEmailAsCsvInput = {
  columns?: InputMaybe<ContractEmailMaskInput>;
  customColumns?: InputMaybe<Array<ContractContractEmailCsvColumn>>;
  query: Array<ContractEmailSearch>;
};

export type DownloadContractEmailAsCsvResponse = {
  __typename?: 'DownloadContractEmailAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadContractNumberAsCsvInput = {
  columns?: InputMaybe<ContractNumberMaskInput>;
  customColumns?: InputMaybe<Array<ContractContractNumberCsvColumn>>;
  query: Array<ContractNumberSearch>;
};

export type DownloadContractNumberAsCsvResponse = {
  __typename?: 'DownloadContractNumberAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCountryRegionAsCsvInput = {
  columns?: InputMaybe<CountryRegionMaskInput>;
  customColumns?: InputMaybe<Array<LocationCountryRegionCsvColumn>>;
  query: Array<CountryRegionSearch>;
};

export type DownloadCountryRegionAsCsvResponse = {
  __typename?: 'DownloadCountryRegionAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadCrewCountRequirementAsCsvInput = {
  columns?: InputMaybe<CrewCountRequirementMaskInput>;
  customColumns?: InputMaybe<Array<TripCrewCountRequirementCsvColumn>>;
  query: Array<CrewCountRequirementSearch>;
};

export type DownloadCrewCountRequirementAsCsvResponse = {
  __typename?: 'DownloadCrewCountRequirementAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDashboardAsCsvInput = {
  columns?: InputMaybe<DashboardMaskInput>;
  customColumns?: InputMaybe<Array<ReportDashboardCsvColumn>>;
  query: Array<DashboardSearch>;
};

export type DownloadDashboardAsCsvResponse = {
  __typename?: 'DownloadDashboardAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDefectAsCsvInput = {
  columns?: InputMaybe<DefectMaskInput>;
  customColumns?: InputMaybe<Array<AssetsDefectCsvColumn>>;
  query: Array<DefectSearch>;
};

export type DownloadDefectAsCsvResponse = {
  __typename?: 'DownloadDefectAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDeviceAsCsvInput = {
  columns?: InputMaybe<DeviceMaskInput>;
  customColumns?: InputMaybe<Array<UserDeviceCsvColumn>>;
  query: Array<DeviceSearch>;
};

export type DownloadDeviceAsCsvResponse = {
  __typename?: 'DownloadDeviceAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDeviceMetricAsCsvInput = {
  columns?: InputMaybe<DeviceMetricMaskInput>;
  customColumns?: InputMaybe<Array<UserDeviceMetricCsvColumn>>;
  query: Array<DeviceMetricSearch>;
};

export type DownloadDeviceMetricAsCsvResponse = {
  __typename?: 'DownloadDeviceMetricAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDeviceMetricWithUserAsCsvInput = {
  columns?: InputMaybe<DeviceMetricWithUserMaskInput>;
  customColumns?: InputMaybe<Array<UserDeviceMetricWithUserCsvColumn>>;
  query: Array<DeviceMetricWithUserSearch>;
};

export type DownloadDeviceMetricWithUserAsCsvResponse = {
  __typename?: 'DownloadDeviceMetricWithUserAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDispatchIssueAsCsvInput = {
  columns?: InputMaybe<DispatchIssueMaskInput>;
  customColumns?: InputMaybe<Array<TripDispatchIssueCsvColumn>>;
  query: Array<DispatchIssueSearch>;
};

export type DownloadDispatchIssueAsCsvResponse = {
  __typename?: 'DownloadDispatchIssueAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDispatchIssueCausedByAsCsvInput = {
  columns?: InputMaybe<DispatchIssueCausedByMaskInput>;
  customColumns?: InputMaybe<Array<TripDispatchIssueCausedByCsvColumn>>;
  query: Array<DispatchIssueCausedBySearch>;
};

export type DownloadDispatchIssueCausedByAsCsvResponse = {
  __typename?: 'DownloadDispatchIssueCausedByAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDispatchIssueCausedByWithCacheAsCsvInput = {
  columns?: InputMaybe<DispatchIssueCausedByWithCacheMaskInput>;
  customColumns?: InputMaybe<Array<TripDispatchIssueCausedByWithCacheCsvColumn>>;
  query: Array<DispatchIssueCausedByWithCacheSearch>;
};

export type DownloadDispatchIssueCausedByWithCacheAsCsvResponse = {
  __typename?: 'DownloadDispatchIssueCausedByWithCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDispatchIssueDocumentAsCsvInput = {
  columns?: InputMaybe<DispatchIssueDocumentMaskInput>;
  customColumns?: InputMaybe<Array<TripDispatchIssueDocumentCsvColumn>>;
  query: Array<DispatchIssueDocumentSearch>;
};

export type DownloadDispatchIssueDocumentAsCsvResponse = {
  __typename?: 'DownloadDispatchIssueDocumentAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDispatchIssueWithCacheAsCsvInput = {
  columns?: InputMaybe<DispatchIssueWithCacheMaskInput>;
  customColumns?: InputMaybe<Array<TripDispatchIssueWithCacheCsvColumn>>;
  query: Array<DispatchIssueWithCacheSearch>;
};

export type DownloadDispatchIssueWithCacheAsCsvResponse = {
  __typename?: 'DownloadDispatchIssueWithCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDispatchSummaryAsCsvInput = {
  columns?: InputMaybe<DispatchSummaryMaskInput>;
  customColumns?: InputMaybe<Array<TripDispatchSummaryCsvColumn>>;
  query: Array<DispatchSummarySearch>;
};

export type DownloadDispatchSummaryAsCsvResponse = {
  __typename?: 'DownloadDispatchSummaryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDispatchSummaryDocumentAsCsvInput = {
  columns?: InputMaybe<DispatchSummaryDocumentMaskInput>;
  customColumns?: InputMaybe<Array<TripDispatchSummaryDocumentCsvColumn>>;
  query: Array<DispatchSummaryDocumentSearch>;
};

export type DownloadDispatchSummaryDocumentAsCsvResponse = {
  __typename?: 'DownloadDispatchSummaryDocumentAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDispatchSummaryMarketAsCsvInput = {
  columns?: InputMaybe<DispatchSummaryMarketMaskInput>;
  customColumns?: InputMaybe<Array<TripDispatchSummaryMarketCsvColumn>>;
  query: Array<DispatchSummaryMarketSearch>;
};

export type DownloadDispatchSummaryMarketAsCsvResponse = {
  __typename?: 'DownloadDispatchSummaryMarketAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDispatchSummaryWithCacheAsCsvInput = {
  columns?: InputMaybe<DispatchSummaryWithCacheMaskInput>;
  customColumns?: InputMaybe<Array<TripDispatchSummaryWithCacheCsvColumn>>;
  query: Array<DispatchSummaryWithCacheSearch>;
};

export type DownloadDispatchSummaryWithCacheAsCsvResponse = {
  __typename?: 'DownloadDispatchSummaryWithCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDistanceAsCsvInput = {
  columns?: InputMaybe<DistanceMaskInput>;
  customColumns?: InputMaybe<Array<LocationDistanceCsvColumn>>;
  query: Array<DistanceSearch>;
};

export type DownloadDistanceAsCsvResponse = {
  __typename?: 'DownloadDistanceAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDriveTimeReportPdfInput = {
  fileLocation: Scalars['String']['input'];
};

export type DownloadDriveTimeReportPdfResponse = {
  __typename?: 'DownloadDriveTimeReportPDFResponse';
  presignedUrl: Scalars['String']['output'];
};

export type DownloadDriverEtaAsCsvInput = {
  columns?: InputMaybe<DriverEtaMaskInput>;
  customColumns?: InputMaybe<Array<TripDriverEtaCsvColumn>>;
  query: Array<DriverEtaSearch>;
};

export type DownloadDriverEtaAsCsvResponse = {
  __typename?: 'DownloadDriverEtaAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDriverEtaWithPreviousTripAsCsvInput = {
  columns?: InputMaybe<DriverEtaWithPreviousTripMaskInput>;
  customColumns?: InputMaybe<Array<TripDriverEtaWithPreviousTripCsvColumn>>;
  query: Array<DriverEtaWithPreviousTripSearch>;
};

export type DownloadDriverEtaWithPreviousTripAsCsvResponse = {
  __typename?: 'DownloadDriverEtaWithPreviousTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDriverVehicleAssignmentAsCsvInput = {
  columns?: InputMaybe<DriverVehicleAssignmentMaskInput>;
  customColumns?: InputMaybe<Array<AssetsDriverVehicleAssignmentCsvColumn>>;
  query: Array<DriverVehicleAssignmentSearch>;
};

export type DownloadDriverVehicleAssignmentAsCsvResponse = {
  __typename?: 'DownloadDriverVehicleAssignmentAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDtrLocationAsCsvInput = {
  columns?: InputMaybe<DtrLocationMaskInput>;
  customColumns?: InputMaybe<Array<DrivetimereportDtrLocationCsvColumn>>;
  query: Array<DtrLocationSearch>;
};

export type DownloadDtrLocationAsCsvResponse = {
  __typename?: 'DownloadDtrLocationAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDvirAsCsvInput = {
  columns?: InputMaybe<DvirMaskInput>;
  customColumns?: InputMaybe<Array<AssetsDvirCsvColumn>>;
  query: Array<DvirSearch>;
};

export type DownloadDvirAsCsvResponse = {
  __typename?: 'DownloadDvirAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadDvirSignatureAsCsvInput = {
  columns?: InputMaybe<DvirSignatureMaskInput>;
  customColumns?: InputMaybe<Array<AssetsDvirSignatureCsvColumn>>;
  query: Array<DvirSignatureSearch>;
};

export type DownloadDvirSignatureAsCsvResponse = {
  __typename?: 'DownloadDvirSignatureAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadEmailAsCsvInput = {
  columns?: InputMaybe<EmailMaskInput>;
  customColumns?: InputMaybe<Array<ContractEmailCsvColumn>>;
  query: Array<EmailSearch>;
};

export type DownloadEmailAsCsvResponse = {
  __typename?: 'DownloadEmailAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadEquivalentTripAsCsvInput = {
  columns?: InputMaybe<EquivalentTripMaskInput>;
  customColumns?: InputMaybe<Array<ContractEquivalentTripCsvColumn>>;
  query: Array<EquivalentTripSearch>;
};

export type DownloadEquivalentTripAsCsvResponse = {
  __typename?: 'DownloadEquivalentTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadEventAsCsvInput = {
  columns?: InputMaybe<EventMaskInput>;
  customColumns?: InputMaybe<Array<EventEventCsvColumn>>;
  query: Array<EventSearch>;
};

export type DownloadEventAsCsvResponse = {
  __typename?: 'DownloadEventAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadFcrAsCsvInput = {
  columns?: InputMaybe<FcrMaskInput>;
  customColumns?: InputMaybe<Array<TripFcrCsvColumn>>;
  query: Array<FcrSearch>;
};

export type DownloadFcrAsCsvResponse = {
  __typename?: 'DownloadFcrAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadFcrTypeAsCsvInput = {
  columns?: InputMaybe<FcrTypeMaskInput>;
  customColumns?: InputMaybe<Array<TripFcrTypeCsvColumn>>;
  query: Array<FcrTypeSearch>;
};

export type DownloadFcrTypeAsCsvResponse = {
  __typename?: 'DownloadFcrTypeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadFlagAsCsvInput = {
  columns?: InputMaybe<FlagMaskInput>;
  customColumns?: InputMaybe<Array<TripFlagCsvColumn>>;
  query: Array<FlagSearch>;
};

export type DownloadFlagAsCsvResponse = {
  __typename?: 'DownloadFlagAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadFlagHasPotentialTripAsCsvInput = {
  columns?: InputMaybe<FlagHasPotentialTripMaskInput>;
  customColumns?: InputMaybe<Array<ManifestFlagHasPotentialTripCsvColumn>>;
  query: Array<FlagHasPotentialTripSearch>;
};

export type DownloadFlagHasPotentialTripAsCsvResponse = {
  __typename?: 'DownloadFlagHasPotentialTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadFlagHasStagedTripAsCsvInput = {
  columns?: InputMaybe<FlagHasStagedTripMaskInput>;
  customColumns?: InputMaybe<Array<ManifestFlagHasStagedTripCsvColumn>>;
  query: Array<FlagHasStagedTripSearch>;
};

export type DownloadFlagHasStagedTripAsCsvResponse = {
  __typename?: 'DownloadFlagHasStagedTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadFlagHasTripAsCsvInput = {
  columns?: InputMaybe<FlagHasTripMaskInput>;
  customColumns?: InputMaybe<Array<TripFlagHasTripCsvColumn>>;
  query: Array<FlagHasTripSearch>;
};

export type DownloadFlagHasTripAsCsvResponse = {
  __typename?: 'DownloadFlagHasTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadFlagWithTripAsCsvInput = {
  columns?: InputMaybe<FlagWithTripMaskInput>;
  customColumns?: InputMaybe<Array<TripFlagWithTripCsvColumn>>;
  query: Array<FlagWithTripSearch>;
};

export type DownloadFlagWithTripAsCsvResponse = {
  __typename?: 'DownloadFlagWithTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadFlightHistoryAsCsvInput = {
  columns?: InputMaybe<FlightHistoryMaskInput>;
  customColumns?: InputMaybe<Array<FlightFlightHistoryCsvColumn>>;
  query: Array<FlightHistorySearch>;
};

export type DownloadFlightHistoryAsCsvResponse = {
  __typename?: 'DownloadFlightHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadGeneratedDocumentAsCsvInput = {
  columns?: InputMaybe<GeneratedDocumentMaskInput>;
  customColumns?: InputMaybe<Array<PdfgeneratorGeneratedDocumentCsvColumn>>;
  query: Array<GeneratedDocumentSearch>;
};

export type DownloadGeneratedDocumentAsCsvResponse = {
  __typename?: 'DownloadGeneratedDocumentAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadGeneratedDocumentLogAsCsvInput = {
  columns?: InputMaybe<GeneratedDocumentLogMaskInput>;
  customColumns?: InputMaybe<Array<PdfgeneratorGeneratedDocumentLogCsvColumn>>;
  query: Array<GeneratedDocumentLogSearch>;
};

export type DownloadGeneratedDocumentLogAsCsvResponse = {
  __typename?: 'DownloadGeneratedDocumentLogAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadGroupAsCsvInput = {
  columns?: InputMaybe<GroupMaskInput>;
  customColumns?: InputMaybe<Array<UserGroupCsvColumn>>;
  query: Array<GroupSearch>;
};

export type DownloadGroupAsCsvResponse = {
  __typename?: 'DownloadGroupAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadGroupHasPermissionAsCsvInput = {
  columns?: InputMaybe<GroupHasPermissionMaskInput>;
  customColumns?: InputMaybe<Array<UserGroupHasPermissionCsvColumn>>;
  query: Array<GroupHasPermissionSearch>;
};

export type DownloadGroupHasPermissionAsCsvResponse = {
  __typename?: 'DownloadGroupHasPermissionAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadGroupHasUserAsCsvInput = {
  columns?: InputMaybe<GroupHasUserMaskInput>;
  customColumns?: InputMaybe<Array<UserGroupHasUserCsvColumn>>;
  query: Array<GroupHasUserSearch>;
};

export type DownloadGroupHasUserAsCsvResponse = {
  __typename?: 'DownloadGroupHasUserAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadGroupHasUserWithPermissionsAsCsvInput = {
  columns?: InputMaybe<GroupHasUserWithPermissionsMaskInput>;
  customColumns?: InputMaybe<Array<UserGroupHasUserWithPermissionsCsvColumn>>;
  query: Array<GroupHasUserWithPermissionsSearch>;
};

export type DownloadGroupHasUserWithPermissionsAsCsvResponse = {
  __typename?: 'DownloadGroupHasUserWithPermissionsAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadImageAsCsvInput = {
  columns?: InputMaybe<ImageMaskInput>;
  customColumns?: InputMaybe<Array<LocationImageCsvColumn>>;
  query: Array<ImageSearch>;
};

export type DownloadImageAsCsvResponse = {
  __typename?: 'DownloadImageAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadImportAsCsvInput = {
  columns?: InputMaybe<ImportMaskInput>;
  customColumns?: InputMaybe<Array<ManifestImportCsvColumn>>;
  query: Array<ImportSearch>;
};

export type DownloadImportAsCsvResponse = {
  __typename?: 'DownloadImportAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadImportEmailAsCsvInput = {
  columns?: InputMaybe<ImportEmailMaskInput>;
  customColumns?: InputMaybe<Array<ManifestImportEmailCsvColumn>>;
  query: Array<ImportEmailSearch>;
};

export type DownloadImportEmailAsCsvResponse = {
  __typename?: 'DownloadImportEmailAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadImportFailureAsCsvInput = {
  columns?: InputMaybe<ImportFailureMaskInput>;
  customColumns?: InputMaybe<Array<ManifestImportFailureCsvColumn>>;
  query: Array<ImportFailureSearch>;
};

export type DownloadImportFailureAsCsvResponse = {
  __typename?: 'DownloadImportFailureAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadImportLogAsCsvInput = {
  columns?: InputMaybe<ImportLogMaskInput>;
  customColumns?: InputMaybe<Array<ManifestImportLogCsvColumn>>;
  query: Array<ImportLogSearch>;
};

export type DownloadImportLogAsCsvResponse = {
  __typename?: 'DownloadImportLogAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadImportOcrCacheAsCsvInput = {
  columns?: InputMaybe<ImportOcrCacheMaskInput>;
  customColumns?: InputMaybe<Array<ManifestImportOcrCacheCsvColumn>>;
  query: Array<ImportOcrCacheSearch>;
};

export type DownloadImportOcrCacheAsCsvResponse = {
  __typename?: 'DownloadImportOcrCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadImportResponse = {
  __typename?: 'DownloadImportResponse';
  error?: Maybe<Scalars['String']['output']>;
  import?: Maybe<Import>;
};

export type DownloadImportUrlResponse = {
  __typename?: 'DownloadImportUrlResponse';
  contentType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  id: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type DownloadImportWithAirportAsCsvInput = {
  columns?: InputMaybe<ImportWithAirportMaskInput>;
  customColumns?: InputMaybe<Array<ManifestImportWithAirportCsvColumn>>;
  query: Array<ImportWithAirportSearch>;
};

export type DownloadImportWithAirportAsCsvResponse = {
  __typename?: 'DownloadImportWithAirportAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadImportWithAirportWithCacheAsCsvInput = {
  columns?: InputMaybe<ImportWithAirportWithCacheMaskInput>;
  customColumns?: InputMaybe<Array<ManifestImportWithAirportWithCacheCsvColumn>>;
  query: Array<ImportWithAirportWithCacheSearch>;
};

export type DownloadImportWithAirportWithCacheAsCsvResponse = {
  __typename?: 'DownloadImportWithAirportWithCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadIncidentIssueAsCsvInput = {
  columns?: InputMaybe<IncidentIssueMaskInput>;
  customColumns?: InputMaybe<Array<TripIncidentIssueCsvColumn>>;
  query: Array<IncidentIssueSearch>;
};

export type DownloadIncidentIssueAsCsvResponse = {
  __typename?: 'DownloadIncidentIssueAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadIncidentIssueDocumentAsCsvInput = {
  columns?: InputMaybe<IncidentIssueDocumentMaskInput>;
  customColumns?: InputMaybe<Array<TripIncidentIssueDocumentCsvColumn>>;
  query: Array<IncidentIssueDocumentSearch>;
};

export type DownloadIncidentIssueDocumentAsCsvResponse = {
  __typename?: 'DownloadIncidentIssueDocumentAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadIncidentIssueWithCacheAsCsvInput = {
  columns?: InputMaybe<IncidentIssueWithCacheMaskInput>;
  customColumns?: InputMaybe<Array<TripIncidentIssueWithCacheCsvColumn>>;
  query: Array<IncidentIssueWithCacheSearch>;
};

export type DownloadIncidentIssueWithCacheAsCsvResponse = {
  __typename?: 'DownloadIncidentIssueWithCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadIndexAsCsvInput = {
  columns?: InputMaybe<IndexMaskInput>;
  customColumns?: InputMaybe<Array<ReportIndexCsvColumn>>;
  query: Array<IndexSearch>;
};

export type DownloadIndexAsCsvResponse = {
  __typename?: 'DownloadIndexAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceAirportAsCsvInput = {
  columns?: InputMaybe<InvoiceAirportMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceAirportCsvColumn>>;
  query: Array<InvoiceAirportSearch>;
};

export type DownloadInvoiceAirportAsCsvResponse = {
  __typename?: 'DownloadInvoiceAirportAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceAsCsvInput = {
  columns?: InputMaybe<InvoiceMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceCsvColumn>>;
  query: Array<InvoiceSearch>;
};

export type DownloadInvoiceAsCsvResponse = {
  __typename?: 'DownloadInvoiceAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceClientAsCsvInput = {
  columns?: InputMaybe<InvoiceClientMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceClientCsvColumn>>;
  query: Array<InvoiceClientSearch>;
};

export type DownloadInvoiceClientAsCsvResponse = {
  __typename?: 'DownloadInvoiceClientAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceCustomChargeAsCsvInput = {
  columns?: InputMaybe<InvoiceCustomChargeMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceCustomChargeCsvColumn>>;
  query: Array<InvoiceCustomChargeSearch>;
};

export type DownloadInvoiceCustomChargeAsCsvResponse = {
  __typename?: 'DownloadInvoiceCustomChargeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceDocumentAsCsvInput = {
  columns?: InputMaybe<InvoiceDocumentMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceDocumentCsvColumn>>;
  query: Array<InvoiceDocumentSearch>;
};

export type DownloadInvoiceDocumentAsCsvResponse = {
  __typename?: 'DownloadInvoiceDocumentAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceDocumentInput = {
  invoiceDocumentId: Scalars['String']['input'];
};

export type DownloadInvoiceDocumentResponse = {
  __typename?: 'DownloadInvoiceDocumentResponse';
  presignedUrl: Scalars['String']['output'];
};

export type DownloadInvoiceDocumentWithSummaryAsCsvInput = {
  columns?: InputMaybe<InvoiceDocumentWithSummaryMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceDocumentWithSummaryCsvColumn>>;
  query: Array<InvoiceDocumentWithSummarySearch>;
};

export type DownloadInvoiceDocumentWithSummaryAsCsvResponse = {
  __typename?: 'DownloadInvoiceDocumentWithSummaryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceEmailAsCsvInput = {
  columns?: InputMaybe<InvoiceEmailMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceEmailCsvColumn>>;
  query: Array<InvoiceEmailSearch>;
};

export type DownloadInvoiceEmailAsCsvResponse = {
  __typename?: 'DownloadInvoiceEmailAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceHeaderAsCsvInput = {
  columns?: InputMaybe<InvoiceHeaderMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceHeaderCsvColumn>>;
  query: Array<InvoiceHeaderSearch>;
};

export type DownloadInvoiceHeaderAsCsvResponse = {
  __typename?: 'DownloadInvoiceHeaderAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceIataCodeAsCsvInput = {
  columns?: InputMaybe<InvoiceIataCodeMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceIataCodeCsvColumn>>;
  query: Array<InvoiceIataCodeSearch>;
};

export type DownloadInvoiceIataCodeAsCsvResponse = {
  __typename?: 'DownloadInvoiceIataCodeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceLineItemAsCsvInput = {
  columns?: InputMaybe<InvoiceLineItemMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceLineItemCsvColumn>>;
  query: Array<InvoiceLineItemSearch>;
};

export type DownloadInvoiceLineItemAsCsvResponse = {
  __typename?: 'DownloadInvoiceLineItemAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceProviderCacheAsCsvInput = {
  columns?: InputMaybe<InvoiceProviderCacheMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceProviderCacheCsvColumn>>;
  query: Array<InvoiceProviderCacheSearch>;
};

export type DownloadInvoiceProviderCacheAsCsvResponse = {
  __typename?: 'DownloadInvoiceProviderCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceResponse = {
  __typename?: 'DownloadInvoiceResponse';
  error?: Maybe<Error>;
  id: Scalars['Int']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type DownloadInvoiceTermAsCsvInput = {
  columns?: InputMaybe<InvoiceTermMaskInput>;
  customColumns?: InputMaybe<Array<ContractInvoiceTermCsvColumn>>;
  query: Array<InvoiceTermSearch>;
};

export type DownloadInvoiceTermAsCsvResponse = {
  __typename?: 'DownloadInvoiceTermAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceTotalSummaryAsCsvInput = {
  columns?: InputMaybe<InvoiceTotalSummaryMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceTotalSummaryCsvColumn>>;
  query: Array<InvoiceTotalSummarySearch>;
};

export type DownloadInvoiceTotalSummaryAsCsvResponse = {
  __typename?: 'DownloadInvoiceTotalSummaryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceTripAsCsvInput = {
  columns?: InputMaybe<InvoiceTripMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceTripCsvColumn>>;
  query: Array<InvoiceTripSearch>;
};

export type DownloadInvoiceTripAsCsvResponse = {
  __typename?: 'DownloadInvoiceTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceTripStatusAsCsvInput = {
  columns?: InputMaybe<InvoiceTripStatusMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceTripStatusCsvColumn>>;
  query: Array<InvoiceTripStatusSearch>;
};

export type DownloadInvoiceTripStatusAsCsvResponse = {
  __typename?: 'DownloadInvoiceTripStatusAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceTypeAsCsvInput = {
  columns?: InputMaybe<InvoiceTypeMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceTypeCsvColumn>>;
  query: Array<InvoiceTypeSearch>;
};

export type DownloadInvoiceTypeAsCsvResponse = {
  __typename?: 'DownloadInvoiceTypeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadInvoiceUserCacheAsCsvInput = {
  columns?: InputMaybe<InvoiceUserCacheMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceInvoiceUserCacheCsvColumn>>;
  query: Array<InvoiceUserCacheSearch>;
};

export type DownloadInvoiceUserCacheAsCsvResponse = {
  __typename?: 'DownloadInvoiceUserCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadIssueAsCsvInput = {
  columns?: InputMaybe<IssueMaskInput>;
  customColumns?: InputMaybe<Array<TripIssueCsvColumn>>;
  query: Array<IssueSearch>;
};

export type DownloadIssueAsCsvResponse = {
  __typename?: 'DownloadIssueAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadLatestRateAsCsvInput = {
  columns?: InputMaybe<LatestRateMaskInput>;
  customColumns?: InputMaybe<Array<TripLatestRateCsvColumn>>;
  query: Array<LatestRateSearch>;
};

export type DownloadLatestRateAsCsvResponse = {
  __typename?: 'DownloadLatestRateAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadLatestRateHistoryAsCsvInput = {
  columns?: InputMaybe<LatestRateHistoryMaskInput>;
  customColumns?: InputMaybe<Array<TripLatestRateHistoryCsvColumn>>;
  query: Array<LatestRateHistorySearch>;
};

export type DownloadLatestRateHistoryAsCsvResponse = {
  __typename?: 'DownloadLatestRateHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadLicenseAsCsvInput = {
  columns?: InputMaybe<LicenseMaskInput>;
  customColumns?: InputMaybe<Array<UserLicenseCsvColumn>>;
  query: Array<LicenseSearch>;
};

export type DownloadLicenseAsCsvResponse = {
  __typename?: 'DownloadLicenseAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadLicenseTypeAsCsvInput = {
  columns?: InputMaybe<LicenseTypeMaskInput>;
  customColumns?: InputMaybe<Array<UserLicenseTypeCsvColumn>>;
  query: Array<LicenseTypeSearch>;
};

export type DownloadLicenseTypeAsCsvResponse = {
  __typename?: 'DownloadLicenseTypeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadLineItemTypeAsCsvInput = {
  columns?: InputMaybe<LineItemTypeMaskInput>;
  customColumns?: InputMaybe<Array<InvoiceLineItemTypeCsvColumn>>;
  query: Array<LineItemTypeSearch>;
};

export type DownloadLineItemTypeAsCsvResponse = {
  __typename?: 'DownloadLineItemTypeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadLocationAsCsvInput = {
  columns?: InputMaybe<LocationMaskInput>;
  customColumns?: InputMaybe<Array<LocationLocationCsvColumn>>;
  query: Array<LocationSearch>;
};

export type DownloadLocationAsCsvResponse = {
  __typename?: 'DownloadLocationAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadLocationWithAirportAndAliasAsCsvInput = {
  columns?: InputMaybe<LocationWithAirportAndAliasMaskInput>;
  customColumns?: InputMaybe<Array<LocationLocationWithAirportAndAliasCsvColumn>>;
  query: Array<LocationWithAirportAndAliasSearch>;
};

export type DownloadLocationWithAirportAndAliasAsCsvResponse = {
  __typename?: 'DownloadLocationWithAirportAndAliasAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadLocationWithPunchPolicyAsCsvInput = {
  columns?: InputMaybe<LocationWithPunchPolicyMaskInput>;
  customColumns?: InputMaybe<Array<LocationLocationWithPunchPolicyCsvColumn>>;
  query: Array<LocationWithPunchPolicySearch>;
};

export type DownloadLocationWithPunchPolicyAsCsvResponse = {
  __typename?: 'DownloadLocationWithPunchPolicyAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadLoginEventAsCsvInput = {
  columns?: InputMaybe<LoginEventMaskInput>;
  customColumns?: InputMaybe<Array<UserLoginEventCsvColumn>>;
  query: Array<LoginEventSearch>;
};

export type DownloadLoginEventAsCsvResponse = {
  __typename?: 'DownloadLoginEventAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadLostAndFoundIssueAsCsvInput = {
  columns?: InputMaybe<LostAndFoundIssueMaskInput>;
  customColumns?: InputMaybe<Array<TripLostAndFoundIssueCsvColumn>>;
  query: Array<LostAndFoundIssueSearch>;
};

export type DownloadLostAndFoundIssueAsCsvResponse = {
  __typename?: 'DownloadLostAndFoundIssueAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadLostAndFoundIssueDocumentAsCsvInput = {
  columns?: InputMaybe<LostAndFoundIssueDocumentMaskInput>;
  customColumns?: InputMaybe<Array<TripLostAndFoundIssueDocumentCsvColumn>>;
  query: Array<LostAndFoundIssueDocumentSearch>;
};

export type DownloadLostAndFoundIssueDocumentAsCsvResponse = {
  __typename?: 'DownloadLostAndFoundIssueDocumentAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadLostAndFoundIssueWithCacheAsCsvInput = {
  columns?: InputMaybe<LostAndFoundIssueWithCacheMaskInput>;
  customColumns?: InputMaybe<Array<TripLostAndFoundIssueWithCacheCsvColumn>>;
  query: Array<LostAndFoundIssueWithCacheSearch>;
};

export type DownloadLostAndFoundIssueWithCacheAsCsvResponse = {
  __typename?: 'DownloadLostAndFoundIssueWithCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadManifestHistoryAsCsvInput = {
  columns?: InputMaybe<ManifestHistoryMaskInput>;
  customColumns?: InputMaybe<Array<DrivetimereportManifestHistoryCsvColumn>>;
  query: Array<ManifestHistorySearch>;
};

export type DownloadManifestHistoryAsCsvResponse = {
  __typename?: 'DownloadManifestHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadManifestHistoryRouteAsCsvInput = {
  columns?: InputMaybe<ManifestHistoryRouteMaskInput>;
  customColumns?: InputMaybe<Array<DrivetimereportManifestHistoryRouteCsvColumn>>;
  query: Array<ManifestHistoryRouteSearch>;
};

export type DownloadManifestHistoryRouteAsCsvResponse = {
  __typename?: 'DownloadManifestHistoryRouteAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadManifestHistoryWithRouteAsCsvInput = {
  columns?: InputMaybe<ManifestHistoryWithRouteMaskInput>;
  customColumns?: InputMaybe<Array<DrivetimereportManifestHistoryWithRouteCsvColumn>>;
  query: Array<ManifestHistoryWithRouteSearch>;
};

export type DownloadManifestHistoryWithRouteAsCsvResponse = {
  __typename?: 'DownloadManifestHistoryWithRouteAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadManifestProviderCacheAsCsvInput = {
  columns?: InputMaybe<ManifestProviderCacheMaskInput>;
  customColumns?: InputMaybe<Array<ManifestManifestProviderCacheCsvColumn>>;
  query: Array<ManifestProviderCacheSearch>;
};

export type DownloadManifestProviderCacheAsCsvResponse = {
  __typename?: 'DownloadManifestProviderCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadManifestUserCacheAsCsvInput = {
  columns?: InputMaybe<ManifestUserCacheMaskInput>;
  customColumns?: InputMaybe<Array<ManifestManifestUserCacheCsvColumn>>;
  query: Array<ManifestUserCacheSearch>;
};

export type DownloadManifestUserCacheAsCsvResponse = {
  __typename?: 'DownloadManifestUserCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadMessageAsCsvInput = {
  columns?: InputMaybe<MessageMaskInput>;
  customColumns?: InputMaybe<Array<ContractMessageCsvColumn>>;
  query: Array<MessageSearch>;
};

export type DownloadMessageAsCsvResponse = {
  __typename?: 'DownloadMessageAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadNotificationAsCsvInput = {
  columns?: InputMaybe<NotificationMaskInput>;
  customColumns?: InputMaybe<Array<EventNotificationCsvColumn>>;
  query: Array<NotificationSearch>;
};

export type DownloadNotificationAsCsvResponse = {
  __typename?: 'DownloadNotificationAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadNotificationHasEventAsCsvInput = {
  columns?: InputMaybe<NotificationHasEventMaskInput>;
  customColumns?: InputMaybe<Array<EventNotificationHasEventCsvColumn>>;
  query: Array<NotificationHasEventSearch>;
};

export type DownloadNotificationHasEventAsCsvResponse = {
  __typename?: 'DownloadNotificationHasEventAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadParsedTripAsCsvInput = {
  columns?: InputMaybe<ParsedTripMaskInput>;
  customColumns?: InputMaybe<Array<ManifestParsedTripCsvColumn>>;
  query: Array<ParsedTripSearch>;
};

export type DownloadParsedTripAsCsvResponse = {
  __typename?: 'DownloadParsedTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadPermissionAsCsvInput = {
  columns?: InputMaybe<PermissionMaskInput>;
  customColumns?: InputMaybe<Array<UserPermissionCsvColumn>>;
  query: Array<PermissionSearch>;
};

export type DownloadPermissionAsCsvResponse = {
  __typename?: 'DownloadPermissionAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadPermissionHasRoleAsCsvInput = {
  columns?: InputMaybe<PermissionHasRoleMaskInput>;
  customColumns?: InputMaybe<Array<UserPermissionHasRoleCsvColumn>>;
  query: Array<PermissionHasRoleSearch>;
};

export type DownloadPermissionHasRoleAsCsvResponse = {
  __typename?: 'DownloadPermissionHasRoleAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadPermissionHasRoleWithPermissionsAsCsvInput = {
  columns?: InputMaybe<PermissionHasRoleWithPermissionsMaskInput>;
  customColumns?: InputMaybe<Array<UserPermissionHasRoleWithPermissionsCsvColumn>>;
  query: Array<PermissionHasRoleWithPermissionsSearch>;
};

export type DownloadPermissionHasRoleWithPermissionsAsCsvResponse = {
  __typename?: 'DownloadPermissionHasRoleWithPermissionsAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadPermissionHasUserAsCsvInput = {
  columns?: InputMaybe<PermissionHasUserMaskInput>;
  customColumns?: InputMaybe<Array<UserPermissionHasUserCsvColumn>>;
  query: Array<PermissionHasUserSearch>;
};

export type DownloadPermissionHasUserAsCsvResponse = {
  __typename?: 'DownloadPermissionHasUserAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadPermissionHasUserWithPermissionsAsCsvInput = {
  columns?: InputMaybe<PermissionHasUserWithPermissionsMaskInput>;
  customColumns?: InputMaybe<Array<UserPermissionHasUserWithPermissionsCsvColumn>>;
  query: Array<PermissionHasUserWithPermissionsSearch>;
};

export type DownloadPermissionHasUserWithPermissionsAsCsvResponse = {
  __typename?: 'DownloadPermissionHasUserWithPermissionsAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadPickupPointAsCsvInput = {
  columns?: InputMaybe<PickupPointMaskInput>;
  customColumns?: InputMaybe<Array<LocationPickupPointCsvColumn>>;
  query: Array<PickupPointSearch>;
};

export type DownloadPickupPointAsCsvResponse = {
  __typename?: 'DownloadPickupPointAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadPotentialTripAsCsvInput = {
  columns?: InputMaybe<PotentialTripMaskInput>;
  customColumns?: InputMaybe<Array<ManifestPotentialTripCsvColumn>>;
  query: Array<PotentialTripSearch>;
};

export type DownloadPotentialTripAsCsvResponse = {
  __typename?: 'DownloadPotentialTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadProviderAliasAsCsvInput = {
  columns?: InputMaybe<ProviderAliasMaskInput>;
  customColumns?: InputMaybe<Array<ContractProviderAliasCsvColumn>>;
  query: Array<ProviderAliasSearch>;
};

export type DownloadProviderAliasAsCsvResponse = {
  __typename?: 'DownloadProviderAliasAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadProviderAsCsvInput = {
  columns?: InputMaybe<ProviderMaskInput>;
  customColumns?: InputMaybe<Array<ContractProviderCsvColumn>>;
  query: Array<ProviderSearch>;
};

export type DownloadProviderAsCsvResponse = {
  __typename?: 'DownloadProviderAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadProviderCacheAsCsvInput = {
  columns?: InputMaybe<ProviderCacheMaskInput>;
  customColumns?: InputMaybe<Array<TripProviderCacheCsvColumn>>;
  query: Array<ProviderCacheSearch>;
};

export type DownloadProviderCacheAsCsvResponse = {
  __typename?: 'DownloadProviderCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadProviderLocationMappingAsCsvInput = {
  columns?: InputMaybe<ProviderLocationMappingMaskInput>;
  customColumns?: InputMaybe<Array<ContractProviderLocationMappingCsvColumn>>;
  query: Array<ProviderLocationMappingSearch>;
};

export type DownloadProviderLocationMappingAsCsvResponse = {
  __typename?: 'DownloadProviderLocationMappingAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadProviderWithAliasAsCsvInput = {
  columns?: InputMaybe<ProviderWithAliasMaskInput>;
  customColumns?: InputMaybe<Array<ContractProviderWithAliasCsvColumn>>;
  query: Array<ProviderWithAliasSearch>;
};

export type DownloadProviderWithAliasAsCsvResponse = {
  __typename?: 'DownloadProviderWithAliasAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadProviderWithContractAsCsvInput = {
  columns?: InputMaybe<ProviderWithContractMaskInput>;
  customColumns?: InputMaybe<Array<ContractProviderWithContractCsvColumn>>;
  query: Array<ProviderWithContractSearch>;
};

export type DownloadProviderWithContractAsCsvResponse = {
  __typename?: 'DownloadProviderWithContractAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadProviderWithUpdateStrategyAsCsvInput = {
  columns?: InputMaybe<ProviderWithUpdateStrategyMaskInput>;
  customColumns?: InputMaybe<Array<ContractProviderWithUpdateStrategyCsvColumn>>;
  query: Array<ProviderWithUpdateStrategySearch>;
};

export type DownloadProviderWithUpdateStrategyAsCsvResponse = {
  __typename?: 'DownloadProviderWithUpdateStrategyAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadPunchAsCsvInput = {
  columns?: InputMaybe<PunchMaskInput>;
  customColumns?: InputMaybe<Array<PunchPunchCsvColumn>>;
  query: Array<PunchSearch>;
};

export type DownloadPunchAsCsvResponse = {
  __typename?: 'DownloadPunchAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadPunchHistoryAsCsvInput = {
  columns?: InputMaybe<PunchHistoryMaskInput>;
  customColumns?: InputMaybe<Array<UserPunchHistoryCsvColumn>>;
  query: Array<PunchHistorySearch>;
};

export type DownloadPunchHistoryAsCsvResponse = {
  __typename?: 'DownloadPunchHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadPunchPolicyAsCsvInput = {
  columns?: InputMaybe<PunchPolicyMaskInput>;
  customColumns?: InputMaybe<Array<LocationPunchPolicyCsvColumn>>;
  query: Array<PunchPolicySearch>;
};

export type DownloadPunchPolicyAsCsvResponse = {
  __typename?: 'DownloadPunchPolicyAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadQueryHistoryAsCsvInput = {
  columns?: InputMaybe<QueryHistoryMaskInput>;
  customColumns?: InputMaybe<Array<DrivetimereportQueryHistoryCsvColumn>>;
  query: Array<QueryHistorySearch>;
};

export type DownloadQueryHistoryAsCsvResponse = {
  __typename?: 'DownloadQueryHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadQuestionnaireAnswerOptionAsCsvInput = {
  columns?: InputMaybe<QuestionnaireAnswerOptionMaskInput>;
  customColumns?: InputMaybe<Array<TrainingQuestionnaireAnswerOptionCsvColumn>>;
  query: Array<QuestionnaireAnswerOptionSearch>;
};

export type DownloadQuestionnaireAnswerOptionAsCsvResponse = {
  __typename?: 'DownloadQuestionnaireAnswerOptionAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadQuestionnaireAnswerTypeAsCsvInput = {
  columns?: InputMaybe<QuestionnaireAnswerTypeMaskInput>;
  customColumns?: InputMaybe<Array<TrainingQuestionnaireAnswerTypeCsvColumn>>;
  query: Array<QuestionnaireAnswerTypeSearch>;
};

export type DownloadQuestionnaireAnswerTypeAsCsvResponse = {
  __typename?: 'DownloadQuestionnaireAnswerTypeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadQuestionnaireAttemptAnswerOptionSnapshotAsCsvInput = {
  columns?: InputMaybe<QuestionnaireAttemptAnswerOptionSnapshotMaskInput>;
  customColumns?: InputMaybe<Array<TrainingQuestionnaireAttemptAnswerOptionSnapshotCsvColumn>>;
  query: Array<QuestionnaireAttemptAnswerOptionSnapshotSearch>;
};

export type DownloadQuestionnaireAttemptAnswerOptionSnapshotAsCsvResponse = {
  __typename?: 'DownloadQuestionnaireAttemptAnswerOptionSnapshotAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadQuestionnaireAttemptAsCsvInput = {
  columns?: InputMaybe<QuestionnaireAttemptMaskInput>;
  customColumns?: InputMaybe<Array<TrainingQuestionnaireAttemptCsvColumn>>;
  query: Array<QuestionnaireAttemptSearch>;
};

export type DownloadQuestionnaireAttemptAsCsvResponse = {
  __typename?: 'DownloadQuestionnaireAttemptAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadQuestionnaireAttemptCategorySnapshotAllowedGroupAsCsvInput = {
  columns?: InputMaybe<QuestionnaireAttemptCategorySnapshotAllowedGroupMaskInput>;
  customColumns?: InputMaybe<Array<TrainingQuestionnaireAttemptCategorySnapshotAllowedGroupCsvColumn>>;
  query: Array<QuestionnaireAttemptCategorySnapshotAllowedGroupSearch>;
};

export type DownloadQuestionnaireAttemptCategorySnapshotAllowedGroupAsCsvResponse = {
  __typename?: 'DownloadQuestionnaireAttemptCategorySnapshotAllowedGroupAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadQuestionnaireAttemptCategorySnapshotAsCsvInput = {
  columns?: InputMaybe<QuestionnaireAttemptCategorySnapshotMaskInput>;
  customColumns?: InputMaybe<Array<TrainingQuestionnaireAttemptCategorySnapshotCsvColumn>>;
  query: Array<QuestionnaireAttemptCategorySnapshotSearch>;
};

export type DownloadQuestionnaireAttemptCategorySnapshotAsCsvResponse = {
  __typename?: 'DownloadQuestionnaireAttemptCategorySnapshotAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadQuestionnaireAttemptCategorySnapshotGroupAsCsvInput = {
  columns?: InputMaybe<QuestionnaireAttemptCategorySnapshotGroupMaskInput>;
  customColumns?: InputMaybe<Array<TrainingQuestionnaireAttemptCategorySnapshotGroupCsvColumn>>;
  query: Array<QuestionnaireAttemptCategorySnapshotGroupSearch>;
};

export type DownloadQuestionnaireAttemptCategorySnapshotGroupAsCsvResponse = {
  __typename?: 'DownloadQuestionnaireAttemptCategorySnapshotGroupAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadQuestionnaireAttemptNoteAsCsvInput = {
  columns?: InputMaybe<QuestionnaireAttemptNoteMaskInput>;
  customColumns?: InputMaybe<Array<TrainingQuestionnaireAttemptNoteCsvColumn>>;
  query: Array<QuestionnaireAttemptNoteSearch>;
};

export type DownloadQuestionnaireAttemptNoteAsCsvResponse = {
  __typename?: 'DownloadQuestionnaireAttemptNoteAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadQuestionnaireAttemptQuestionSnapshotAsCsvInput = {
  columns?: InputMaybe<QuestionnaireAttemptQuestionSnapshotMaskInput>;
  customColumns?: InputMaybe<Array<TrainingQuestionnaireAttemptQuestionSnapshotCsvColumn>>;
  query: Array<QuestionnaireAttemptQuestionSnapshotSearch>;
};

export type DownloadQuestionnaireAttemptQuestionSnapshotAsCsvResponse = {
  __typename?: 'DownloadQuestionnaireAttemptQuestionSnapshotAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadQuestionnaireCategoryAsCsvInput = {
  columns?: InputMaybe<QuestionnaireCategoryMaskInput>;
  customColumns?: InputMaybe<Array<TrainingQuestionnaireCategoryCsvColumn>>;
  query: Array<QuestionnaireCategorySearch>;
};

export type DownloadQuestionnaireCategoryAsCsvResponse = {
  __typename?: 'DownloadQuestionnaireCategoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadQuestionnaireQuestionAsCsvInput = {
  columns?: InputMaybe<QuestionnaireQuestionMaskInput>;
  customColumns?: InputMaybe<Array<TrainingQuestionnaireQuestionCsvColumn>>;
  query: Array<QuestionnaireQuestionSearch>;
};

export type DownloadQuestionnaireQuestionAsCsvResponse = {
  __typename?: 'DownloadQuestionnaireQuestionAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRateAsCsvInput = {
  columns?: InputMaybe<RateMaskInput>;
  customColumns?: InputMaybe<Array<TripRateCsvColumn>>;
  query: Array<RateSearch>;
};

export type DownloadRateAsCsvResponse = {
  __typename?: 'DownloadRateAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRateGroupAsCsvInput = {
  columns?: InputMaybe<RateGroupMaskInput>;
  customColumns?: InputMaybe<Array<TripRateGroupCsvColumn>>;
  query: Array<RateGroupSearch>;
};

export type DownloadRateGroupAsCsvResponse = {
  __typename?: 'DownloadRateGroupAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRateGroupWithLatestRateHistoryAsCsvInput = {
  columns?: InputMaybe<RateGroupWithLatestRateHistoryMaskInput>;
  customColumns?: InputMaybe<Array<TripRateGroupWithLatestRateHistoryCsvColumn>>;
  query: Array<RateGroupWithLatestRateHistorySearch>;
};

export type DownloadRateGroupWithLatestRateHistoryAsCsvResponse = {
  __typename?: 'DownloadRateGroupWithLatestRateHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRateHistoryAsCsvInput = {
  columns?: InputMaybe<RateHistoryMaskInput>;
  customColumns?: InputMaybe<Array<TripRateHistoryCsvColumn>>;
  query: Array<RateHistorySearch>;
};

export type DownloadRateHistoryAsCsvResponse = {
  __typename?: 'DownloadRateHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRateHistoryWithRateGroupAsCsvInput = {
  columns?: InputMaybe<RateHistoryWithRateGroupMaskInput>;
  customColumns?: InputMaybe<Array<TripRateHistoryWithRateGroupCsvColumn>>;
  query: Array<RateHistoryWithRateGroupSearch>;
};

export type DownloadRateHistoryWithRateGroupAsCsvResponse = {
  __typename?: 'DownloadRateHistoryWithRateGroupAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRateItemAsCsvInput = {
  columns?: InputMaybe<RateItemMaskInput>;
  customColumns?: InputMaybe<Array<TripRateItemCsvColumn>>;
  query: Array<RateItemSearch>;
};

export type DownloadRateItemAsCsvResponse = {
  __typename?: 'DownloadRateItemAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRateItemWithLatestRateHistoryAsCsvInput = {
  columns?: InputMaybe<RateItemWithLatestRateHistoryMaskInput>;
  customColumns?: InputMaybe<Array<TripRateItemWithLatestRateHistoryCsvColumn>>;
  query: Array<RateItemWithLatestRateHistorySearch>;
};

export type DownloadRateItemWithLatestRateHistoryAsCsvResponse = {
  __typename?: 'DownloadRateItemWithLatestRateHistoryAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRatingAsCsvInput = {
  columns?: InputMaybe<RatingMaskInput>;
  customColumns?: InputMaybe<Array<UserRatingCsvColumn>>;
  query: Array<RatingSearch>;
};

export type DownloadRatingAsCsvResponse = {
  __typename?: 'DownloadRatingAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRatingCacheAsCsvInput = {
  columns?: InputMaybe<RatingCacheMaskInput>;
  customColumns?: InputMaybe<Array<ReportRatingCacheCsvColumn>>;
  query: Array<RatingCacheSearch>;
};

export type DownloadRatingCacheAsCsvResponse = {
  __typename?: 'DownloadRatingCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRatingCacheRemarkAsCsvInput = {
  columns?: InputMaybe<RatingCacheRemarkMaskInput>;
  customColumns?: InputMaybe<Array<ReportRatingCacheRemarkCsvColumn>>;
  query: Array<RatingCacheRemarkSearch>;
};

export type DownloadRatingCacheRemarkAsCsvResponse = {
  __typename?: 'DownloadRatingCacheRemarkAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRatingRemarkAsCsvInput = {
  columns?: InputMaybe<RatingRemarkMaskInput>;
  customColumns?: InputMaybe<Array<UserRatingRemarkCsvColumn>>;
  query: Array<RatingRemarkSearch>;
};

export type DownloadRatingRemarkAsCsvResponse = {
  __typename?: 'DownloadRatingRemarkAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRatingRemarksWithRatingAsCsvInput = {
  columns?: InputMaybe<RatingRemarksWithRatingMaskInput>;
  customColumns?: InputMaybe<Array<UserRatingRemarksWithRatingCsvColumn>>;
  query: Array<RatingRemarksWithRatingSearch>;
};

export type DownloadRatingRemarksWithRatingAsCsvResponse = {
  __typename?: 'DownloadRatingRemarksWithRatingAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRatingTypeAsCsvInput = {
  columns?: InputMaybe<RatingTypeMaskInput>;
  customColumns?: InputMaybe<Array<UserRatingTypeCsvColumn>>;
  query: Array<RatingTypeSearch>;
};

export type DownloadRatingTypeAsCsvResponse = {
  __typename?: 'DownloadRatingTypeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRatingWithRemarksAsCsvInput = {
  columns?: InputMaybe<RatingWithRemarksMaskInput>;
  customColumns?: InputMaybe<Array<UserRatingWithRemarksCsvColumn>>;
  query: Array<RatingWithRemarksSearch>;
};

export type DownloadRatingWithRemarksAsCsvResponse = {
  __typename?: 'DownloadRatingWithRemarksAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadRoleAsCsvInput = {
  columns?: InputMaybe<RoleMaskInput>;
  customColumns?: InputMaybe<Array<UserRoleCsvColumn>>;
  query: Array<RoleSearch>;
};

export type DownloadRoleAsCsvResponse = {
  __typename?: 'DownloadRoleAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadSettingsAsCsvInput = {
  columns?: InputMaybe<SettingsMaskInput>;
  customColumns?: InputMaybe<Array<ContractSettingsCsvColumn>>;
  query: Array<SettingsSearch>;
};

export type DownloadSettingsAsCsvResponse = {
  __typename?: 'DownloadSettingsAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadSocialDistanceRuleAsCsvInput = {
  columns?: InputMaybe<SocialDistanceRuleMaskInput>;
  customColumns?: InputMaybe<Array<ContractSocialDistanceRuleCsvColumn>>;
  query: Array<SocialDistanceRuleSearch>;
};

export type DownloadSocialDistanceRuleAsCsvResponse = {
  __typename?: 'DownloadSocialDistanceRuleAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadStagedTripAsCsvInput = {
  columns?: InputMaybe<StagedTripMaskInput>;
  customColumns?: InputMaybe<Array<ManifestStagedTripCsvColumn>>;
  query: Array<StagedTripSearch>;
};

export type DownloadStagedTripAsCsvResponse = {
  __typename?: 'DownloadStagedTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadStopAsCsvInput = {
  columns?: InputMaybe<StopMaskInput>;
  customColumns?: InputMaybe<Array<TripStopCsvColumn>>;
  query: Array<StopSearch>;
};

export type DownloadStopAsCsvResponse = {
  __typename?: 'DownloadStopAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadStorageAsCsvInput = {
  columns?: InputMaybe<StorageMaskInput>;
  customColumns?: InputMaybe<Array<UserStorageCsvColumn>>;
  query: Array<StorageSearch>;
};

export type DownloadStorageAsCsvResponse = {
  __typename?: 'DownloadStorageAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTimeFrameAsCsvInput = {
  columns?: InputMaybe<TimeFrameMaskInput>;
  customColumns?: InputMaybe<Array<DrivetimereportTimeFrameCsvColumn>>;
  query: Array<TimeFrameSearch>;
};

export type DownloadTimeFrameAsCsvResponse = {
  __typename?: 'DownloadTimeFrameAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTimeFrameRangeAsCsvInput = {
  columns?: InputMaybe<TimeFrameRangeMaskInput>;
  customColumns?: InputMaybe<Array<DrivetimereportTimeFrameRangeCsvColumn>>;
  query: Array<TimeFrameRangeSearch>;
};

export type DownloadTimeFrameRangeAsCsvResponse = {
  __typename?: 'DownloadTimeFrameRangeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTrackFlightAsCsvInput = {
  columns?: InputMaybe<TrackFlightMaskInput>;
  customColumns?: InputMaybe<Array<TripTrackFlightCsvColumn>>;
  query: Array<TrackFlightSearch>;
};

export type DownloadTrackFlightAsCsvResponse = {
  __typename?: 'DownloadTrackFlightAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTrainingReportPdfInput = {
  fileLocation: Scalars['String']['input'];
};

export type DownloadTrainingReportPdfResponse = {
  __typename?: 'DownloadTrainingReportPDFResponse';
  presignedUrl: Scalars['String']['output'];
};

export type DownloadTrainingUserCacheAsCsvInput = {
  columns?: InputMaybe<TrainingUserCacheMaskInput>;
  customColumns?: InputMaybe<Array<TrainingTrainingUserCacheCsvColumn>>;
  query: Array<TrainingUserCacheSearch>;
};

export type DownloadTrainingUserCacheAsCsvResponse = {
  __typename?: 'DownloadTrainingUserCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripAsCsvInput = {
  columns?: InputMaybe<TripMaskInput>;
  customColumns?: InputMaybe<Array<TripTripCsvColumn>>;
  query: Array<TripSearch>;
};

export type DownloadTripAsCsvResponse = {
  __typename?: 'DownloadTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripDocumentAsCsvInput = {
  columns?: InputMaybe<TripDocumentMaskInput>;
  customColumns?: InputMaybe<Array<TripTripDocumentCsvColumn>>;
  query: Array<TripDocumentSearch>;
};

export type DownloadTripDocumentAsCsvResponse = {
  __typename?: 'DownloadTripDocumentAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripDocumentWithCacheAsCsvInput = {
  columns?: InputMaybe<TripDocumentWithCacheMaskInput>;
  customColumns?: InputMaybe<Array<TripTripDocumentWithCacheCsvColumn>>;
  query: Array<TripDocumentWithCacheSearch>;
};

export type DownloadTripDocumentWithCacheAsCsvResponse = {
  __typename?: 'DownloadTripDocumentWithCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripHasImportAsCsvInput = {
  columns?: InputMaybe<TripHasImportMaskInput>;
  customColumns?: InputMaybe<Array<TripTripHasImportCsvColumn>>;
  query: Array<TripHasImportSearch>;
};

export type DownloadTripHasImportAsCsvResponse = {
  __typename?: 'DownloadTripHasImportAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripScheduleTriggerAsCsvInput = {
  columns?: InputMaybe<TripScheduleTriggerMaskInput>;
  customColumns?: InputMaybe<Array<TripTripScheduleTriggerCsvColumn>>;
  query: Array<TripScheduleTriggerSearch>;
};

export type DownloadTripScheduleTriggerAsCsvResponse = {
  __typename?: 'DownloadTripScheduleTriggerAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripTableAsCsvInput = {
  customColumns?: InputMaybe<Array<TripTripWithCompletionAndRateCsvColumn>>;
  format: TripTableFormatEnum;
  query: Array<TripWithCompletionAndRateSearch>;
};

export type DownloadTripWithCompletionAndRateAsCsvInput = {
  columns?: InputMaybe<TripWithCompletionAndRateMaskInput>;
  customColumns?: InputMaybe<Array<TripTripWithCompletionAndRateCsvColumn>>;
  query: Array<TripWithCompletionAndRateSearch>;
};

export type DownloadTripWithCompletionAndRateAsCsvResponse = {
  __typename?: 'DownloadTripWithCompletionAndRateAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripWithCompletionAsCsvInput = {
  columns?: InputMaybe<TripWithCompletionMaskInput>;
  customColumns?: InputMaybe<Array<TripTripWithCompletionCsvColumn>>;
  query: Array<TripWithCompletionSearch>;
};

export type DownloadTripWithCompletionAsCsvResponse = {
  __typename?: 'DownloadTripWithCompletionAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripWithFcrInnerJoinAsCsvInput = {
  columns?: InputMaybe<TripWithFcrInnerJoinMaskInput>;
  customColumns?: InputMaybe<Array<TripTripWithFcrInnerJoinCsvColumn>>;
  query: Array<TripWithFcrInnerJoinSearch>;
};

export type DownloadTripWithFcrInnerJoinAsCsvResponse = {
  __typename?: 'DownloadTripWithFcrInnerJoinAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripWithFlagInnerJoinAsCsvInput = {
  columns?: InputMaybe<TripWithFlagInnerJoinMaskInput>;
  customColumns?: InputMaybe<Array<TripTripWithFlagInnerJoinCsvColumn>>;
  query: Array<TripWithFlagInnerJoinSearch>;
};

export type DownloadTripWithFlagInnerJoinAsCsvResponse = {
  __typename?: 'DownloadTripWithFlagInnerJoinAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripWithRateAsCsvInput = {
  columns?: InputMaybe<TripWithRateMaskInput>;
  customColumns?: InputMaybe<Array<TripTripWithRateCsvColumn>>;
  query: Array<TripWithRateSearch>;
};

export type DownloadTripWithRateAsCsvResponse = {
  __typename?: 'DownloadTripWithRateAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripWithRateForAuditReportAsCsvInput = {
  columns?: InputMaybe<TripWithRateForAuditReportMaskInput>;
  customColumns?: InputMaybe<Array<TripTripWithRateForAuditReportCsvColumn>>;
  query: Array<TripWithRateForAuditReportSearch>;
};

export type DownloadTripWithRateForAuditReportAsCsvResponse = {
  __typename?: 'DownloadTripWithRateForAuditReportAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripWithTrackFlightAsCsvInput = {
  columns?: InputMaybe<TripWithTrackFlightMaskInput>;
  customColumns?: InputMaybe<Array<TripTripWithTrackFlightCsvColumn>>;
  query: Array<TripWithTrackFlightSearch>;
};

export type DownloadTripWithTrackFlightAsCsvResponse = {
  __typename?: 'DownloadTripWithTrackFlightAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadTripWithUtcAsCsvInput = {
  columns?: InputMaybe<TripWithUtcMaskInput>;
  customColumns?: InputMaybe<Array<TripTripWithUtcCsvColumn>>;
  query: Array<TripWithUtcSearch>;
};

export type DownloadTripWithUtcAsCsvResponse = {
  __typename?: 'DownloadTripWithUtcAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadUniqueTripAsCsvInput = {
  columns?: InputMaybe<UniqueTripMaskInput>;
  customColumns?: InputMaybe<Array<TripUniqueTripCsvColumn>>;
  query: Array<UniqueTripSearch>;
};

export type DownloadUniqueTripAsCsvResponse = {
  __typename?: 'DownloadUniqueTripAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadUpdateStrategyAsCsvInput = {
  columns?: InputMaybe<UpdateStrategyMaskInput>;
  customColumns?: InputMaybe<Array<ContractUpdateStrategyCsvColumn>>;
  query: Array<UpdateStrategySearch>;
};

export type DownloadUpdateStrategyAsCsvResponse = {
  __typename?: 'DownloadUpdateStrategyAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadUserAsCsvInput = {
  columns?: InputMaybe<UserMaskInput>;
  customColumns?: InputMaybe<Array<UserUserCsvColumn>>;
  query: Array<UserSearch>;
};

export type DownloadUserAsCsvResponse = {
  __typename?: 'DownloadUserAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadUserAvailabilityAsCsvInput = {
  columns?: InputMaybe<UserAvailabilityMaskInput>;
  customColumns?: InputMaybe<Array<UserUserAvailabilityCsvColumn>>;
  query: Array<UserAvailabilitySearch>;
};

export type DownloadUserAvailabilityAsCsvResponse = {
  __typename?: 'DownloadUserAvailabilityAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadUserAvailabilityWithDatetimesAsCsvInput = {
  columns?: InputMaybe<UserAvailabilityWithDatetimesMaskInput>;
  customColumns?: InputMaybe<Array<UserUserAvailabilityWithDatetimesCsvColumn>>;
  query: Array<UserAvailabilityWithDatetimesSearch>;
};

export type DownloadUserAvailabilityWithDatetimesAsCsvResponse = {
  __typename?: 'DownloadUserAvailabilityWithDatetimesAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadUserCacheAsCsvInput = {
  columns?: InputMaybe<UserCacheMaskInput>;
  customColumns?: InputMaybe<Array<TripUserCacheCsvColumn>>;
  query: Array<UserCacheSearch>;
};

export type DownloadUserCacheAsCsvResponse = {
  __typename?: 'DownloadUserCacheAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadUserHasAirportAsCsvInput = {
  columns?: InputMaybe<UserHasAirportMaskInput>;
  customColumns?: InputMaybe<Array<UserUserHasAirportCsvColumn>>;
  query: Array<UserHasAirportSearch>;
};

export type DownloadUserHasAirportAsCsvResponse = {
  __typename?: 'DownloadUserHasAirportAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadUserWithAvailabilityAndPermissionsAsCsvInput = {
  columns?: InputMaybe<UserWithAvailabilityAndPermissionsMaskInput>;
  customColumns?: InputMaybe<Array<UserUserWithAvailabilityAndPermissionsCsvColumn>>;
  query: Array<UserWithAvailabilityAndPermissionsSearch>;
};

export type DownloadUserWithAvailabilityAndPermissionsAsCsvResponse = {
  __typename?: 'DownloadUserWithAvailabilityAndPermissionsAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadUserWithMarketAsCsvInput = {
  columns?: InputMaybe<UserWithMarketMaskInput>;
  customColumns?: InputMaybe<Array<UserUserWithMarketCsvColumn>>;
  query: Array<UserWithMarketSearch>;
};

export type DownloadUserWithMarketAsCsvResponse = {
  __typename?: 'DownloadUserWithMarketAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadUserWithPermissionsAsCsvInput = {
  columns?: InputMaybe<UserWithPermissionsMaskInput>;
  customColumns?: InputMaybe<Array<UserUserWithPermissionsCsvColumn>>;
  query: Array<UserWithPermissionsSearch>;
};

export type DownloadUserWithPermissionsAsCsvResponse = {
  __typename?: 'DownloadUserWithPermissionsAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadVariableTimeAsCsvInput = {
  columns?: InputMaybe<VariableTimeMaskInput>;
  customColumns?: InputMaybe<Array<ContractVariableTimeCsvColumn>>;
  query: Array<VariableTimeSearch>;
};

export type DownloadVariableTimeAsCsvResponse = {
  __typename?: 'DownloadVariableTimeAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadVehicleAsCsvInput = {
  columns?: InputMaybe<VehicleMaskInput>;
  customColumns?: InputMaybe<Array<TripVehicleCsvColumn>>;
  query: Array<VehicleSearch>;
};

export type DownloadVehicleAsCsvResponse = {
  __typename?: 'DownloadVehicleAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadWidgetAsCsvInput = {
  columns?: InputMaybe<WidgetMaskInput>;
  customColumns?: InputMaybe<Array<ReportWidgetCsvColumn>>;
  query: Array<WidgetSearch>;
};

export type DownloadWidgetAsCsvResponse = {
  __typename?: 'DownloadWidgetAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DownloadWidgetFilterAsCsvInput = {
  columns?: InputMaybe<WidgetFilterMaskInput>;
  customColumns?: InputMaybe<Array<ReportWidgetFilterCsvColumn>>;
  query: Array<WidgetFilterSearch>;
};

export type DownloadWidgetFilterAsCsvResponse = {
  __typename?: 'DownloadWidgetFilterAsCSVResponse';
  data: Scalars['String']['output'];
};

export type DriveTimeReport = {
  __typename?: 'DriveTimeReport';
  tables?: Maybe<Array<Maybe<DriveTimeReportTable>>>;
};

export type DriveTimeReportBucket = {
  hour: Scalars['Int']['input'];
  minute: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type DriveTimeReportChild = {
  __typename?: 'DriveTimeReportChild';
  averageDifference: Scalars['Float']['output'];
  fri: Scalars['Int']['output'];
  holidayAvgDriveMinutes: Scalars['Float']['output'];
  mon: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  sat: Scalars['Int']['output'];
  sun: Scalars['Int']['output'];
  thr: Scalars['Int']['output'];
  totalTrips: Scalars['Int']['output'];
  tue: Scalars['Int']['output'];
  wed: Scalars['Int']['output'];
  weekdayAvgDriveMinutes: Scalars['Float']['output'];
  weekendAvgDriveMinutes: Scalars['Float']['output'];
};

export enum DriveTimeReportFormatEnum {
  Airline = 'AIRLINE',
  Client = 'CLIENT'
}

export type DriveTimeReportRow = {
  __typename?: 'DriveTimeReportRow';
  averageDifference: Scalars['Float']['output'];
  children: Array<Maybe<DriveTimeReportChild>>;
  dropoff: Scalars['String']['output'];
  fri: Scalars['Int']['output'];
  holidayAvgDriveMinutes: Scalars['Float']['output'];
  mon: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  pickup: Scalars['String']['output'];
  sat: Scalars['Int']['output'];
  sun: Scalars['Int']['output'];
  thr: Scalars['Int']['output'];
  totalTrips: Scalars['Int']['output'];
  tue: Scalars['Int']['output'];
  wed: Scalars['Int']['output'];
  weekdayAvgDriveMinutes: Scalars['Float']['output'];
  weekendAvgDriveMinutes: Scalars['Float']['output'];
};

export type DriveTimeReportTable = {
  __typename?: 'DriveTimeReportTable';
  averageDifference: Scalars['Float']['output'];
  holidayAvgDriveMinutes: Scalars['Float']['output'];
  holidayTrips: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  overallDriveMinutes: Scalars['Float']['output'];
  rows: Array<Maybe<DriveTimeReportRow>>;
  totalTrips: Scalars['Int']['output'];
  weekdayAvgDriveMinutes: Scalars['Float']['output'];
  weekdayTrips: Scalars['Int']['output'];
  weekendAvgDriveMinutes: Scalars['Float']['output'];
  weekendTrips: Scalars['Int']['output'];
};

export type DriverEta = {
  __typename?: 'DriverEta';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  driverId: Scalars['String']['output'];
  etaDatetime: Scalars['String']['output'];
  etaMinutes: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  previousTripId?: Maybe<Scalars['String']['output']>;
  tripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DriverEtaActivityConnection = {
  __typename?: 'DriverEtaActivityConnection';
  edges?: Maybe<Array<Maybe<DriverEtaActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DriverEtaActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DriverEtaActivityEdge = {
  __typename?: 'DriverEtaActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DriverEtaConnection = {
  __typename?: 'DriverEtaConnection';
  edges?: Maybe<Array<Maybe<DriverEtaEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DriverEtaConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DriverEtaMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DriverEtaSearch>>;
};

export type DriverEtaEdge = {
  __typename?: 'DriverEtaEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DriverEta>;
};

export type DriverEtaMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  etaDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  etaMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  previousTripId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DriverEtaSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  etaDatetime?: InputMaybe<Array<StringSearch>>;
  etaMinutes?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  previousTripId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type DriverEtaWithPreviousTrip = {
  __typename?: 'DriverEtaWithPreviousTrip';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  driverId: Scalars['String']['output'];
  etaDatetime: Scalars['String']['output'];
  etaMinutes: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  previousTripFlightNumber: Scalars['Int']['output'];
  previousTripId?: Maybe<Scalars['String']['output']>;
  previousTripScheduled: Scalars['String']['output'];
  previousTripServicerIataAirlineCode: Scalars['String']['output'];
  tripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type DriverEtaWithPreviousTripActivityConnection = {
  __typename?: 'DriverEtaWithPreviousTripActivityConnection';
  edges?: Maybe<Array<Maybe<DriverEtaWithPreviousTripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DriverEtaWithPreviousTripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DriverEtaWithPreviousTripActivityEdge = {
  __typename?: 'DriverEtaWithPreviousTripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DriverEtaWithPreviousTripConnection = {
  __typename?: 'DriverEtaWithPreviousTripConnection';
  edges?: Maybe<Array<Maybe<DriverEtaWithPreviousTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DriverEtaWithPreviousTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DriverEtaWithPreviousTripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DriverEtaWithPreviousTripSearch>>;
};

export type DriverEtaWithPreviousTripEdge = {
  __typename?: 'DriverEtaWithPreviousTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DriverEtaWithPreviousTrip>;
};

export type DriverEtaWithPreviousTripMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  etaDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  etaMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  previousTripFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  previousTripId?: InputMaybe<Scalars['Boolean']['input']>;
  previousTripScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  previousTripServicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DriverEtaWithPreviousTripSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  etaDatetime?: InputMaybe<Array<StringSearch>>;
  etaMinutes?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  previousTripFlightNumber?: InputMaybe<Array<IntSearch>>;
  previousTripId?: InputMaybe<Array<StringSearch>>;
  previousTripScheduled?: InputMaybe<Array<StringSearch>>;
  previousTripServicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type DriverPerformance = {
  __typename?: 'DriverPerformance';
  error?: Maybe<Error>;
  inbound?: Maybe<TripPerformance>;
  outbound?: Maybe<TripPerformance>;
  overall?: Maybe<OverallPerformance>;
};

export type DriverPerformanceReport = {
  __typename?: 'DriverPerformanceReport';
  averageRatings?: Maybe<Scalars['Float']['output']>;
  completedTrips?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  onTimeOverall?: Maybe<Scalars['Float']['output']>;
};

export type DriverPerformanceSearchInput = {
  endDateTime?: InputMaybe<Scalars['String']['input']>;
  startDateTime?: InputMaybe<Scalars['String']['input']>;
  tripType?: InputMaybe<TripKindEnumSearch>;
};

export type DriverVehicleAssignment = {
  __typename?: 'DriverVehicleAssignment';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  driverName: Scalars['String']['output'];
  endDatetime?: Maybe<Scalars['String']['output']>;
  externalDriverId: Scalars['String']['output'];
  externalVehicleId: Scalars['String']['output'];
  externalVendor: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startDatetime: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleTrackingId: Scalars['String']['output'];
};

export type DriverVehicleAssignmentActivityConnection = {
  __typename?: 'DriverVehicleAssignmentActivityConnection';
  edges?: Maybe<Array<Maybe<DriverVehicleAssignmentActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DriverVehicleAssignmentActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DriverVehicleAssignmentActivityEdge = {
  __typename?: 'DriverVehicleAssignmentActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DriverVehicleAssignmentConnection = {
  __typename?: 'DriverVehicleAssignmentConnection';
  edges?: Maybe<Array<Maybe<DriverVehicleAssignmentEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DriverVehicleAssignmentConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DriverVehicleAssignmentMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DriverVehicleAssignmentSearch>>;
};

export type DriverVehicleAssignmentEdge = {
  __typename?: 'DriverVehicleAssignmentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DriverVehicleAssignment>;
};

export type DriverVehicleAssignmentMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  driverName?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  externalDriverId?: InputMaybe<Scalars['Boolean']['input']>;
  externalVehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  externalVendor?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTrackingId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DriverVehicleAssignmentSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  driverName?: InputMaybe<Array<StringSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  externalDriverId?: InputMaybe<Array<StringSearch>>;
  externalVehicleId?: InputMaybe<Array<StringSearch>>;
  externalVendor?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleTrackingId?: InputMaybe<Array<StringSearch>>;
};

export type DropoffActualInput = {
  doActualDatetime: Scalars['String']['input'];
  tripId: Array<Scalars['String']['input']>;
};

export type DropoffActualResponse = {
  __typename?: 'DropoffActualResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type DropoffCompletedInput = {
  doCompletedDatetime: Scalars['String']['input'];
  tripId: Array<Scalars['String']['input']>;
};

export type DropoffCompletedResponse = {
  __typename?: 'DropoffCompletedResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type DropoffIncompleteInput = {
  tripId: Array<Scalars['String']['input']>;
};

export type DropoffIncompleteResponse = {
  __typename?: 'DropoffIncompleteResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type DtrLocation = {
  __typename?: 'DtrLocation';
  address: Scalars['String']['output'];
  airportCode?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  coordinates: Point;
  countryCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type DtrLocationActivityConnection = {
  __typename?: 'DtrLocationActivityConnection';
  edges?: Maybe<Array<Maybe<DtrLocationActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DtrLocationActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DtrLocationActivityEdge = {
  __typename?: 'DtrLocationActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DtrLocationConnection = {
  __typename?: 'DtrLocationConnection';
  edges?: Maybe<Array<Maybe<DtrLocationEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DtrLocationConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DtrLocationMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DtrLocationSearch>>;
};

export type DtrLocationEdge = {
  __typename?: 'DtrLocationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DtrLocation>;
};

export type DtrLocationMaskInput = {
  address?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DtrLocationSearch = {
  address?: InputMaybe<Array<StringSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  cityName?: InputMaybe<Array<StringSearch>>;
  coordinates?: InputMaybe<Array<PointSearch>>;
  countryCode?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
  zipCode?: InputMaybe<Array<StringSearch>>;
};

export type DtrParsedTrip = {
  __typename?: 'DtrParsedTrip';
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  doLocation: Scalars['String']['output'];
  flightNumber?: Maybe<Scalars['Int']['output']>;
  fromManifest: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  importId: Scalars['String']['output'];
  importTime: Scalars['String']['output'];
  kind: ParsedTripKindEnum;
  loopName?: Maybe<Scalars['String']['output']>;
  pilots: Scalars['Int']['output'];
  puLocation: Scalars['String']['output'];
  scheduled: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  typeName?: Maybe<ParsedTripTypeNameEnum>;
};

export type Dvir = {
  __typename?: 'Dvir';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  driverName: Scalars['String']['output'];
  endDatetime?: Maybe<Scalars['String']['output']>;
  eventDatetime?: Maybe<Scalars['String']['output']>;
  eventType: Scalars['String']['output'];
  externalDriverId: Scalars['String']['output'];
  externalDvirId: Scalars['String']['output'];
  externalEventId: Scalars['String']['output'];
  externalOrgId: Scalars['String']['output'];
  externalTrailerId?: Maybe<Scalars['String']['output']>;
  externalVehicleId: Scalars['String']['output'];
  externalVendor: DvirExternalVendorEnum;
  externalWebhookId: Scalars['String']['output'];
  formattedLocation: Scalars['String']['output'];
  id: Scalars['String']['output'];
  mechanicNotes?: Maybe<Scalars['String']['output']>;
  needsCorrection: Scalars['Int']['output'];
  odometerMeters?: Maybe<Scalars['String']['output']>;
  safetyStatus: Scalars['String']['output'];
  startDatetime?: Maybe<Scalars['String']['output']>;
  trailerName?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleLicensePlate: Scalars['String']['output'];
  vehicleModel: Scalars['String']['output'];
  vehicleSerial: Scalars['String']['output'];
  vehicleTrackingId: Scalars['String']['output'];
  vehicleVin: Scalars['String']['output'];
};

export type DvirActivityConnection = {
  __typename?: 'DvirActivityConnection';
  edges?: Maybe<Array<Maybe<DvirActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DvirActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DvirActivityEdge = {
  __typename?: 'DvirActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DvirConnection = {
  __typename?: 'DvirConnection';
  edges?: Maybe<Array<Maybe<DvirEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DvirConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DvirMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DvirSearch>>;
};

export type DvirEdge = {
  __typename?: 'DvirEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Dvir>;
};

export enum DvirExternalVendorEnum {
  Samsara = 'SAMSARA'
}

export type DvirExternalVendorEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<DvirExternalVendorEnum>;
};

export type DvirMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  driverName?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  eventDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  eventType?: InputMaybe<Scalars['Boolean']['input']>;
  externalDriverId?: InputMaybe<Scalars['Boolean']['input']>;
  externalDvirId?: InputMaybe<Scalars['Boolean']['input']>;
  externalEventId?: InputMaybe<Scalars['Boolean']['input']>;
  externalOrgId?: InputMaybe<Scalars['Boolean']['input']>;
  externalTrailerId?: InputMaybe<Scalars['Boolean']['input']>;
  externalVehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  externalVendor?: InputMaybe<Scalars['Boolean']['input']>;
  externalWebhookId?: InputMaybe<Scalars['Boolean']['input']>;
  formattedLocation?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  mechanicNotes?: InputMaybe<Scalars['Boolean']['input']>;
  needsCorrection?: InputMaybe<Scalars['Boolean']['input']>;
  odometerMeters?: InputMaybe<Scalars['Boolean']['input']>;
  safetyStatus?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  trailerName?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleLicensePlate?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleModel?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleSerial?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTrackingId?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleVin?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DvirSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  driverName?: InputMaybe<Array<StringSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  eventDatetime?: InputMaybe<Array<StringSearch>>;
  eventType?: InputMaybe<Array<StringSearch>>;
  externalDriverId?: InputMaybe<Array<StringSearch>>;
  externalDvirId?: InputMaybe<Array<StringSearch>>;
  externalEventId?: InputMaybe<Array<StringSearch>>;
  externalOrgId?: InputMaybe<Array<StringSearch>>;
  externalTrailerId?: InputMaybe<Array<StringSearch>>;
  externalVehicleId?: InputMaybe<Array<StringSearch>>;
  externalVendor?: InputMaybe<Array<DvirExternalVendorEnumSearch>>;
  externalWebhookId?: InputMaybe<Array<StringSearch>>;
  formattedLocation?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  mechanicNotes?: InputMaybe<Array<StringSearch>>;
  needsCorrection?: InputMaybe<Array<IntSearch>>;
  odometerMeters?: InputMaybe<Array<StringSearch>>;
  safetyStatus?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  trailerName?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleLicensePlate?: InputMaybe<Array<StringSearch>>;
  vehicleModel?: InputMaybe<Array<StringSearch>>;
  vehicleSerial?: InputMaybe<Array<StringSearch>>;
  vehicleTrackingId?: InputMaybe<Array<StringSearch>>;
  vehicleVin?: InputMaybe<Array<StringSearch>>;
};

export type DvirSignature = {
  __typename?: 'DvirSignature';
  dvirId: Scalars['String']['output'];
  externalUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  signedAt: Scalars['String']['output'];
  type: Scalars['String']['output'];
  userName: Scalars['String']['output'];
  userType: Scalars['String']['output'];
};

export type DvirSignatureActivityConnection = {
  __typename?: 'DvirSignatureActivityConnection';
  edges?: Maybe<Array<Maybe<DvirSignatureActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DvirSignatureActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type DvirSignatureActivityEdge = {
  __typename?: 'DvirSignatureActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type DvirSignatureConnection = {
  __typename?: 'DvirSignatureConnection';
  edges?: Maybe<Array<Maybe<DvirSignatureEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type DvirSignatureConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<DvirSignatureMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<DvirSignatureSearch>>;
};

export type DvirSignatureEdge = {
  __typename?: 'DvirSignatureEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<DvirSignature>;
};

export type DvirSignatureMaskInput = {
  dvirId?: InputMaybe<Scalars['Boolean']['input']>;
  externalUserId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  signedAt?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  userName?: InputMaybe<Scalars['Boolean']['input']>;
  userType?: InputMaybe<Scalars['Boolean']['input']>;
};

export type DvirSignatureSearch = {
  dvirId?: InputMaybe<Array<StringSearch>>;
  externalUserId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  signedAt?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<StringSearch>>;
  userName?: InputMaybe<Array<StringSearch>>;
  userType?: InputMaybe<Array<StringSearch>>;
};

export type Email = {
  __typename?: 'Email';
  address: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  type: EmailTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type EmailActivityConnection = {
  __typename?: 'EmailActivityConnection';
  edges?: Maybe<Array<Maybe<EmailActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EmailActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type EmailActivityEdge = {
  __typename?: 'EmailActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type EmailConnection = {
  __typename?: 'EmailConnection';
  edges?: Maybe<Array<Maybe<EmailEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EmailConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<EmailMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<EmailSearch>>;
};

export type EmailEdge = {
  __typename?: 'EmailEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Email>;
};

export type EmailMaskInput = {
  address?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EmailSearch = {
  address?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<EmailTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum EmailTypeEnum {
  Admin = 'ADMIN',
  Billing = 'BILLING',
  Confirmation = 'CONFIRMATION'
}

export type EmailTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<EmailTypeEnum>;
};

export type EnableFeature = {
  __typename?: 'EnableFeature';
  feature: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
};

export type Enabled = {
  __typename?: 'Enabled';
  enabled: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  value: Scalars['Float']['output'];
};

export type EquivalentTrip = {
  __typename?: 'EquivalentTrip';
  companyId: Scalars['String']['output'];
  count?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  endLocationId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  startLocationId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type EquivalentTripActivityConnection = {
  __typename?: 'EquivalentTripActivityConnection';
  edges?: Maybe<Array<Maybe<EquivalentTripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EquivalentTripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type EquivalentTripActivityEdge = {
  __typename?: 'EquivalentTripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type EquivalentTripConnection = {
  __typename?: 'EquivalentTripConnection';
  edges?: Maybe<Array<Maybe<EquivalentTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EquivalentTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<EquivalentTripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<EquivalentTripSearch>>;
};

export type EquivalentTripEdge = {
  __typename?: 'EquivalentTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<EquivalentTrip>;
};

export type EquivalentTripMaskInput = {
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  count?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  endLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  startLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EquivalentTripSearch = {
  companyId?: InputMaybe<Array<StringSearch>>;
  count?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  endLocationId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  startLocationId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type Error = {
  __typename?: 'Error';
  code: Scalars['Int']['output'];
  debug: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type Evaluation = {
  __typename?: 'Evaluation';
  attempt: QuestionnaireAttempt;
  categories: Array<EvaluationCategory>;
  notes: Array<QuestionnaireAttemptNote>;
};

export type EvaluationCategory = {
  __typename?: 'EvaluationCategory';
  canEvaluate: Scalars['Boolean']['output'];
  category: QuestionnaireAttemptCategorySnapshot;
  evaluatorGroups: Array<QuestionnaireAttemptCategorySnapshotGroup>;
  questions: Array<EvaluationQuestion>;
};

export type EvaluationEligibilityCategory = {
  __typename?: 'EvaluationEligibilityCategory';
  color?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  questionCount: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
};

export type EvaluationQuestion = {
  __typename?: 'EvaluationQuestion';
  options: Array<QuestionnaireAttemptAnswerOptionSnapshot>;
  question: QuestionnaireAttemptQuestionSnapshot;
};

export type Event = {
  __typename?: 'Event';
  active?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<EventStatusEnum>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type EventActivityConnection = {
  __typename?: 'EventActivityConnection';
  edges?: Maybe<Array<Maybe<EventActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type EventActivityEdge = {
  __typename?: 'EventActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type EventConnection = {
  __typename?: 'EventConnection';
  edges?: Maybe<Array<Maybe<EventEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type EventConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<EventMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<EventSearch>>;
};

export type EventEdge = {
  __typename?: 'EventEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Event>;
};

export type EventMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  source?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  source?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<EventStatusEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum EventStatusEnum {
  New = 'NEW',
  Ready = 'READY'
}

export type EventStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<EventStatusEnum>;
};

export type FaqResponse = {
  __typename?: 'FaqResponse';
  items: Array<Description>;
  lastUpdated: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type Fcr = Node & {
  __typename?: 'Fcr';
  cause?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<User>;
  description?: Maybe<Scalars['String']['output']>;
  fcrReporter?: Maybe<FcrFcrReporterEnum>;
  fcrType?: Maybe<FcrType>;
  fcrTypeId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  tripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FcrActivityConnection = {
  __typename?: 'FcrActivityConnection';
  edges?: Maybe<Array<Maybe<FcrActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FcrActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type FcrActivityEdge = {
  __typename?: 'FcrActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type FcrConnection = {
  __typename?: 'FcrConnection';
  edges?: Maybe<Array<Maybe<FcrEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FcrConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<FcrMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<FcrSearch>>;
};

export type FcrEdge = {
  __typename?: 'FcrEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Fcr>;
};

export enum FcrFcrReporterEnum {
  FlightAttendant = 'FLIGHT_ATTENDANT',
  Pilot = 'PILOT',
  Unknown = 'UNKNOWN'
}

export type FcrFcrReporterEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<FcrFcrReporterEnum>;
};

export type FcrMaskInput = {
  cause?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  fcrReporter?: InputMaybe<Scalars['Boolean']['input']>;
  fcrTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FcrSearch = {
  cause?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  fcrReporter?: InputMaybe<Array<FcrFcrReporterEnumSearch>>;
  fcrTypeId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type FcrType = {
  __typename?: 'FcrType';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FcrTypeActivityConnection = {
  __typename?: 'FcrTypeActivityConnection';
  edges?: Maybe<Array<Maybe<FcrTypeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FcrTypeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type FcrTypeActivityEdge = {
  __typename?: 'FcrTypeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type FcrTypeConnection = {
  __typename?: 'FcrTypeConnection';
  edges?: Maybe<Array<Maybe<FcrTypeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FcrTypeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<FcrTypeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<FcrTypeSearch>>;
};

export type FcrTypeEdge = {
  __typename?: 'FcrTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<FcrType>;
};

export type FcrTypeMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FcrTypeSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type FileForUploadInput = {
  filename: Scalars['String']['input'];
  importNameId: Scalars['String']['input'];
  md5: Scalars['String']['input'];
};

export type FilterObject = {
  __typename?: 'FilterObject';
  key: Scalars['String']['output'];
  options?: Maybe<Array<Scalars['String']['output']>>;
  value?: Maybe<Array<Scalars['String']['output']>>;
};

export type FilterOption = {
  __typename?: 'FilterOption';
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type Filters = Node & {
  __typename?: 'Filters';
  activityResourceType?: Maybe<Array<FilterOption>>;
  airline: Array<FilterOption>;
  airportGroupPermissions: Array<FilterOption>;
  airportGroups: Array<FilterOption>;
  airports: Array<FilterOption>;
  allAirportsAndAirportGroups: Array<FilterOption>;
  availabilityTypes?: Maybe<Array<FilterOption>>;
  charities: Array<FilterOption>;
  clients: Array<FilterOption>;
  companies: Array<FilterOption>;
  completionReasons: Array<AcceptInputOption>;
  complimentOptions: Array<AcceptInputOption>;
  exchangeLocations?: Maybe<Array<AcceptInputOption>>;
  fcrTypes?: Maybe<Array<AcceptInputOption>>;
  feedbackOptions: Array<AcceptInputOption>;
  flag: Array<FilterOption>;
  groups: Array<FilterOption>;
  id: Scalars['ID']['output'];
  importContractProvider: Array<FilterOption>;
  importProvider: Array<FilterOption>;
  imports?: Maybe<Array<FilterOption>>;
  invoiceTerms?: Maybe<Array<FilterOption>>;
  jobLookupFormat?: Maybe<Array<AcceptInputOption>>;
  kind: Array<FilterOption>;
  licenseType: Array<FilterOption>;
  lineItemType: Array<FilterOption>;
  locationType?: Maybe<Array<AcceptInputOption>>;
  locations: Array<FilterOption>;
  messageDriverOptions: Array<AcceptInputOption>;
  permissions: Array<FilterOption>;
  rateValue?: Maybe<RateValueResponse>;
  ratingType: Array<AcceptInputOption>;
  roles: Array<FilterOption>;
  servicerIataAirlineCode: Array<FilterOption>;
  states: Array<FilterOption>;
  status: Array<FilterOption>;
  statusOptions?: Maybe<Array<AcceptInputOption>>;
  summaryReportSnapshots?: Maybe<Array<FilterOption>>;
  transportCompany: Array<FilterOption>;
  type: Array<FilterOption>;
  vehicleMake?: Maybe<Array<AcceptInputOption>>;
  vehicleModel?: Maybe<VehicleModelResponse>;
  vehicleTracker?: Maybe<Array<AcceptInputOption>>;
};


export type FiltersActivityResourceTypeArgs = {
  input?: InputMaybe<ActivityResourceTypeFilterInput>;
};


export type FiltersRateValueArgs = {
  input: RateValueInput;
};


export type FiltersVehicleModelArgs = {
  input?: InputMaybe<VehicleModelInput>;
};

export type FitForDrivingQuestion = {
  __typename?: 'FitForDrivingQuestion';
  id: Scalars['Int']['output'];
  question: Scalars['String']['output'];
};

export type FitForDutyAnswer = {
  answer: Scalars['Int']['input'];
  id: Scalars['Int']['input'];
  question: Scalars['String']['input'];
};

export type Flag = {
  __typename?: 'Flag';
  active: Scalars['Int']['output'];
  color: Scalars['String']['output'];
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  global: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FlagActivityConnection = {
  __typename?: 'FlagActivityConnection';
  edges?: Maybe<Array<Maybe<FlagActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlagActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type FlagActivityEdge = {
  __typename?: 'FlagActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type FlagConnection = {
  __typename?: 'FlagConnection';
  edges?: Maybe<Array<Maybe<FlagEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlagConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<FlagMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<FlagSearch>>;
};

export type FlagEdge = {
  __typename?: 'FlagEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Flag>;
};

export type FlagHasPotentialTrip = {
  __typename?: 'FlagHasPotentialTrip';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  flagId: Scalars['String']['output'];
  potentialTripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FlagHasPotentialTripActivityConnection = {
  __typename?: 'FlagHasPotentialTripActivityConnection';
  edges?: Maybe<Array<Maybe<FlagHasPotentialTripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlagHasPotentialTripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type FlagHasPotentialTripActivityEdge = {
  __typename?: 'FlagHasPotentialTripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type FlagHasPotentialTripConnection = {
  __typename?: 'FlagHasPotentialTripConnection';
  edges?: Maybe<Array<Maybe<FlagHasPotentialTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlagHasPotentialTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<FlagHasPotentialTripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<FlagHasPotentialTripSearch>>;
};

export type FlagHasPotentialTripEdge = {
  __typename?: 'FlagHasPotentialTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<FlagHasPotentialTrip>;
};

export type FlagHasPotentialTripMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  flagId?: InputMaybe<Scalars['Boolean']['input']>;
  potentialTripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagHasPotentialTripSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  flagId?: InputMaybe<Array<StringSearch>>;
  potentialTripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type FlagHasStagedTrip = {
  __typename?: 'FlagHasStagedTrip';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  flagId: Scalars['String']['output'];
  stagedTripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FlagHasStagedTripActivityConnection = {
  __typename?: 'FlagHasStagedTripActivityConnection';
  edges?: Maybe<Array<Maybe<FlagHasStagedTripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlagHasStagedTripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type FlagHasStagedTripActivityEdge = {
  __typename?: 'FlagHasStagedTripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type FlagHasStagedTripConnection = {
  __typename?: 'FlagHasStagedTripConnection';
  edges?: Maybe<Array<Maybe<FlagHasStagedTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlagHasStagedTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<FlagHasStagedTripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<FlagHasStagedTripSearch>>;
};

export type FlagHasStagedTripEdge = {
  __typename?: 'FlagHasStagedTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<FlagHasStagedTrip>;
};

export type FlagHasStagedTripMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  flagId?: InputMaybe<Scalars['Boolean']['input']>;
  stagedTripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagHasStagedTripSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  flagId?: InputMaybe<Array<StringSearch>>;
  stagedTripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type FlagHasTrip = {
  __typename?: 'FlagHasTrip';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  flagId: Scalars['String']['output'];
  tripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FlagHasTripActivityConnection = {
  __typename?: 'FlagHasTripActivityConnection';
  edges?: Maybe<Array<Maybe<FlagHasTripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlagHasTripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type FlagHasTripActivityEdge = {
  __typename?: 'FlagHasTripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type FlagHasTripConnection = {
  __typename?: 'FlagHasTripConnection';
  edges?: Maybe<Array<Maybe<FlagHasTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlagHasTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<FlagHasTripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<FlagHasTripSearch>>;
};

export type FlagHasTripEdge = {
  __typename?: 'FlagHasTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<FlagHasTrip>;
};

export type FlagHasTripMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  flagId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagHasTripSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  flagId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type FlagMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  color?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  global?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type FlagWithTrip = {
  __typename?: 'FlagWithTrip';
  active: Scalars['Int']['output'];
  color: Scalars['String']['output'];
  companyId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  global: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  tripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FlagWithTripActivityConnection = {
  __typename?: 'FlagWithTripActivityConnection';
  edges?: Maybe<Array<Maybe<FlagWithTripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlagWithTripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type FlagWithTripActivityEdge = {
  __typename?: 'FlagWithTripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type FlagWithTripConnection = {
  __typename?: 'FlagWithTripConnection';
  edges?: Maybe<Array<Maybe<FlagWithTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlagWithTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<FlagWithTripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<FlagWithTripSearch>>;
};

export type FlagWithTripEdge = {
  __typename?: 'FlagWithTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<FlagWithTrip>;
};

export type FlagWithTripMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  global?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlagWithTripSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  color?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  global?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type FlightHistory = {
  __typename?: 'FlightHistory';
  actual?: Maybe<Scalars['String']['output']>;
  actualUtc?: Maybe<Scalars['String']['output']>;
  arrivalAirportCode: Scalars['String']['output'];
  arrivalDatetime?: Maybe<Scalars['String']['output']>;
  arrivalDatetimeUtc?: Maybe<Scalars['String']['output']>;
  arrivalDelayMinutes: Scalars['Int']['output'];
  arrivalGate?: Maybe<Scalars['String']['output']>;
  arrivalTerminal?: Maybe<Scalars['String']['output']>;
  arrivalTimezone?: Maybe<Scalars['String']['output']>;
  arrivalUtcOffsetHours?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  departureAirportCode: Scalars['String']['output'];
  departureDatetime?: Maybe<Scalars['String']['output']>;
  departureDatetimeUtc?: Maybe<Scalars['String']['output']>;
  departureDelayMinutes: Scalars['Int']['output'];
  departureGate?: Maybe<Scalars['String']['output']>;
  departureTerminal?: Maybe<Scalars['String']['output']>;
  departureTimezone?: Maybe<Scalars['String']['output']>;
  departureUtcOffsetHours?: Maybe<Scalars['String']['output']>;
  divertedAirportCode?: Maybe<Scalars['String']['output']>;
  estimatedArrivalDatetime?: Maybe<Scalars['String']['output']>;
  estimatedArrivalDatetimeUtc?: Maybe<Scalars['String']['output']>;
  estimatedDepartureDatetime?: Maybe<Scalars['String']['output']>;
  estimatedDepartureDatetimeUtc?: Maybe<Scalars['String']['output']>;
  externalAlertId: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  externalVendor: FlightHistoryExternalVendorEnum;
  flightNumber: Scalars['String']['output'];
  id: Scalars['String']['output'];
  label: FlightHistoryLabelEnum;
  landedDatetime?: Maybe<Scalars['String']['output']>;
  landedDatetimeUtc?: Maybe<Scalars['String']['output']>;
  raw: Scalars['String']['output'];
  scheduled: Scalars['String']['output'];
  scheduledUtc: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type: FlightHistoryTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type FlightHistoryActivityConnection = {
  __typename?: 'FlightHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<FlightHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlightHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type FlightHistoryActivityEdge = {
  __typename?: 'FlightHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type FlightHistoryConnection = {
  __typename?: 'FlightHistoryConnection';
  edges?: Maybe<Array<Maybe<FlightHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type FlightHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<FlightHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<FlightHistorySearch>>;
};

export type FlightHistoryEdge = {
  __typename?: 'FlightHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<FlightHistory>;
};

export enum FlightHistoryExternalVendorEnum {
  FlightAware = 'FLIGHT_AWARE',
  FlightStats = 'FLIGHT_STATS'
}

export type FlightHistoryExternalVendorEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<FlightHistoryExternalVendorEnum>;
};

export enum FlightHistoryLabelEnum {
  Delayed = 'DELAYED',
  EnRoute = 'EN_ROUTE',
  Gated = 'GATED',
  Landed = 'LANDED'
}

export type FlightHistoryLabelEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<FlightHistoryLabelEnum>;
};

export type FlightHistoryMaskInput = {
  actual?: InputMaybe<Scalars['Boolean']['input']>;
  actualUtc?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalDatetimeUtc?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalDelayMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalGate?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalUtcOffsetHours?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  departureAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  departureDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  departureDatetimeUtc?: InputMaybe<Scalars['Boolean']['input']>;
  departureDelayMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  departureGate?: InputMaybe<Scalars['Boolean']['input']>;
  departureTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  departureTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  departureUtcOffsetHours?: InputMaybe<Scalars['Boolean']['input']>;
  divertedAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  estimatedArrivalDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  estimatedArrivalDatetimeUtc?: InputMaybe<Scalars['Boolean']['input']>;
  estimatedDepartureDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  estimatedDepartureDatetimeUtc?: InputMaybe<Scalars['Boolean']['input']>;
  externalAlertId?: InputMaybe<Scalars['Boolean']['input']>;
  externalId?: InputMaybe<Scalars['Boolean']['input']>;
  externalVendor?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  landedDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  landedDatetimeUtc?: InputMaybe<Scalars['Boolean']['input']>;
  raw?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FlightHistorySearch = {
  actual?: InputMaybe<Array<StringSearch>>;
  actualUtc?: InputMaybe<Array<StringSearch>>;
  arrivalAirportCode?: InputMaybe<Array<StringSearch>>;
  arrivalDatetime?: InputMaybe<Array<StringSearch>>;
  arrivalDatetimeUtc?: InputMaybe<Array<StringSearch>>;
  arrivalDelayMinutes?: InputMaybe<Array<IntSearch>>;
  arrivalGate?: InputMaybe<Array<StringSearch>>;
  arrivalTerminal?: InputMaybe<Array<StringSearch>>;
  arrivalTimezone?: InputMaybe<Array<StringSearch>>;
  arrivalUtcOffsetHours?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  departureAirportCode?: InputMaybe<Array<StringSearch>>;
  departureDatetime?: InputMaybe<Array<StringSearch>>;
  departureDatetimeUtc?: InputMaybe<Array<StringSearch>>;
  departureDelayMinutes?: InputMaybe<Array<IntSearch>>;
  departureGate?: InputMaybe<Array<StringSearch>>;
  departureTerminal?: InputMaybe<Array<StringSearch>>;
  departureTimezone?: InputMaybe<Array<StringSearch>>;
  departureUtcOffsetHours?: InputMaybe<Array<StringSearch>>;
  divertedAirportCode?: InputMaybe<Array<StringSearch>>;
  estimatedArrivalDatetime?: InputMaybe<Array<StringSearch>>;
  estimatedArrivalDatetimeUtc?: InputMaybe<Array<StringSearch>>;
  estimatedDepartureDatetime?: InputMaybe<Array<StringSearch>>;
  estimatedDepartureDatetimeUtc?: InputMaybe<Array<StringSearch>>;
  externalAlertId?: InputMaybe<Array<StringSearch>>;
  externalId?: InputMaybe<Array<StringSearch>>;
  externalVendor?: InputMaybe<Array<FlightHistoryExternalVendorEnumSearch>>;
  flightNumber?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  label?: InputMaybe<Array<FlightHistoryLabelEnumSearch>>;
  landedDatetime?: InputMaybe<Array<StringSearch>>;
  landedDatetimeUtc?: InputMaybe<Array<StringSearch>>;
  raw?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  scheduledUtc?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<FlightHistoryTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum FlightHistoryTypeEnum {
  Domestic = 'DOMESTIC',
  International = 'INTERNATIONAL'
}

export type FlightHistoryTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<FlightHistoryTypeEnum>;
};

export type FlightLookupCrewAppInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  airportCode?: InputMaybe<Scalars['String']['input']>;
  completionStatus?: InputMaybe<CompletionStatusEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  flightLookup?: InputMaybe<Scalars['String']['input']>;
  scheduledEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduledStartTime?: InputMaybe<Scalars['String']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum FlightTypeEnum {
  Domestic = 'DOMESTIC',
  International = 'INTERNATIONAL'
}

export type FloatMetric = {
  __typename?: 'FloatMetric';
  count?: Maybe<Scalars['Int']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type FloatPipeline = {
  __typename?: 'FloatPipeline';
  bucketKey?: Maybe<Scalars['String']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['Float']['output']>;
};

export type FloatSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<Scalars['Float']['input']>;
};

export type ForgotPasswordCrewInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ForgotPasswordCrewResponse = {
  __typename?: 'ForgotPasswordCrewResponse';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ForgotPasswordDriverInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ForgotPasswordDriverResponse = {
  __typename?: 'ForgotPasswordDriverResponse';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ForgotPasswordInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type GenerateDriveTimeReportPdfInput = {
  manifestHistoryRouteId?: InputMaybe<Scalars['String']['input']>;
  queryHistoryId?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateDriveTimeReportPdfResponse = {
  __typename?: 'GenerateDriveTimeReportPDFResponse';
  generatedDocument: GeneratedDocumentPdf;
};

export type GenerateInvoiceDocumentInput = {
  invoiceId: Scalars['Int']['input'];
};

export type GenerateInvoiceDocumentResponse = {
  __typename?: 'GenerateInvoiceDocumentResponse';
  invoiceDocument: InvoiceDocument;
};

export type GenerateInvoiceDocumentUploadUrlInput = {
  fileSize: Scalars['Int']['input'];
  filename: Scalars['String']['input'];
  invoiceId: Scalars['Int']['input'];
  md5: Scalars['String']['input'];
};

export type GenerateInvoiceDocumentUploadUrlResponse = {
  __typename?: 'GenerateInvoiceDocumentUploadUrlResponse';
  contentType?: Maybe<Scalars['String']['output']>;
  documentId?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type GeneratePunchHistoryUploadUrlInput = {
  filename: Scalars['String']['input'];
  md5: Scalars['String']['input'];
};

export type GeneratePunchHistoryUploadUrlResponse = {
  __typename?: 'GeneratePunchHistoryUploadUrlResponse';
  contentType: Scalars['String']['output'];
  error?: Maybe<Error>;
  md5: Scalars['String']['output'];
  presignedUploadUrl: Scalars['String']['output'];
};

export type GeneratePunchHistoryUploadUrlsInput = {
  input: Array<GeneratePunchHistoryUploadUrlInput>;
};

export type GeneratePunchHistoryUploadUrlsResponse = {
  __typename?: 'GeneratePunchHistoryUploadUrlsResponse';
  output: Array<GeneratePunchHistoryUploadUrlResponse>;
};

export type GenerateTrainingReportPdfInput = {
  airports?: InputMaybe<Array<Scalars['String']['input']>>;
  drivers?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime: Scalars['String']['input'];
  roleIds: Array<Scalars['String']['input']>;
  startDatetime: Scalars['String']['input'];
  userSessionTimezone?: InputMaybe<Scalars['String']['input']>;
};

export type GenerateTrainingReportPdfResponse = {
  __typename?: 'GenerateTrainingReportPDFResponse';
  generatedDocument: GeneratedDocumentPdf;
};

export type GenerateUploadProfileImageUrlInput = {
  filename: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type GenerateUploadProfileImageUrlResponse = {
  __typename?: 'GenerateUploadProfileImageUrlResponse';
  contentType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  url?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type GeneratedDocument = {
  __typename?: 'GeneratedDocument';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  docSource: Scalars['String']['output'];
  fileLocation: Scalars['String']['output'];
  fileS3Bucket: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  generationCompletedAt?: Maybe<Scalars['String']['output']>;
  generationStartedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  status: GeneratedDocumentStatusEnum;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type GeneratedDocumentActivityConnection = {
  __typename?: 'GeneratedDocumentActivityConnection';
  edges?: Maybe<Array<Maybe<GeneratedDocumentActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GeneratedDocumentActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type GeneratedDocumentActivityEdge = {
  __typename?: 'GeneratedDocumentActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type GeneratedDocumentConnection = {
  __typename?: 'GeneratedDocumentConnection';
  edges?: Maybe<Array<Maybe<GeneratedDocumentEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GeneratedDocumentConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<GeneratedDocumentMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<GeneratedDocumentSearch>>;
};

export type GeneratedDocumentEdge = {
  __typename?: 'GeneratedDocumentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GeneratedDocument>;
};

export type GeneratedDocumentLog = {
  __typename?: 'GeneratedDocumentLog';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  generatedDocumentId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  message: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
};

export type GeneratedDocumentLogActivityConnection = {
  __typename?: 'GeneratedDocumentLogActivityConnection';
  edges?: Maybe<Array<Maybe<GeneratedDocumentLogActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GeneratedDocumentLogActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type GeneratedDocumentLogActivityEdge = {
  __typename?: 'GeneratedDocumentLogActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type GeneratedDocumentLogConnection = {
  __typename?: 'GeneratedDocumentLogConnection';
  edges?: Maybe<Array<Maybe<GeneratedDocumentLogEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GeneratedDocumentLogConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<GeneratedDocumentLogMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<GeneratedDocumentLogSearch>>;
};

export type GeneratedDocumentLogEdge = {
  __typename?: 'GeneratedDocumentLogEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GeneratedDocumentLog>;
};

export type GeneratedDocumentLogMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  generatedDocumentId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GeneratedDocumentLogSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  generatedDocumentId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  message?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
};

export type GeneratedDocumentMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  docSource?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  fileS3Bucket?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  generationCompletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  generationStartedAt?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  resourceId?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GeneratedDocumentPdf = {
  __typename?: 'GeneratedDocumentPDF';
  fileLocation: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  resourceId?: Maybe<Scalars['String']['output']>;
  status: GeneratedDocumentStatusEnum;
};

export type GeneratedDocumentSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  docSource?: InputMaybe<Array<StringSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  fileS3Bucket?: InputMaybe<Array<StringSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  generationCompletedAt?: InputMaybe<Array<StringSearch>>;
  generationStartedAt?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  resourceId?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<GeneratedDocumentStatusEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum GeneratedDocumentStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InQueue = 'IN_QUEUE',
  Running = 'RUNNING'
}

export type GeneratedDocumentStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<GeneratedDocumentStatusEnum>;
};

export type GeoLocation = {
  Latitude: Scalars['String']['input'];
  Longitude: Scalars['String']['input'];
};

export type GetAirportsResponse = {
  __typename?: 'GetAirportsResponse';
  airports: Array<Airport>;
};

export type GetAvailableUserForTripResponse = {
  __typename?: 'GetAvailableUserForTripResponse';
  employeeId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  userId: Scalars['String']['output'];
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars['String']['output']>;
};

export type GetAvailableUsersForTripInput = {
  actual?: InputMaybe<Scalars['String']['input']>;
  airportCode: Scalars['String']['input'];
  scheduled: Scalars['String']['input'];
  tripId?: InputMaybe<Scalars['String']['input']>;
};

export type GetAvailableUsersForTripResponse = {
  __typename?: 'GetAvailableUsersForTripResponse';
  output: Array<GetAvailableUserForTripResponse>;
};

export type GetCorrectRatesForTripsInput = {
  tripIds: Array<Scalars['String']['input']>;
};

export type GetCorrectRatesForTripsResponse = {
  __typename?: 'GetCorrectRatesForTripsResponse';
  output?: Maybe<Array<TripWithRateChange>>;
};

export type GetDeviceConfigInput = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  device: Device;
};

export type GetDeviceConfigResponse = {
  __typename?: 'GetDeviceConfigResponse';
  allowCheckinWithinMinutes: Scalars['Int']['output'];
  auth: Auth;
  availabilityTypes?: Maybe<Array<Maybe<AvailabilityType>>>;
  chatHistoryPageSize?: Maybe<Scalars['Int']['output']>;
  chatRetryBackoffSeconds?: Maybe<Scalars['Int']['output']>;
  chatRetryLimit?: Maybe<Scalars['Int']['output']>;
  clientApiEndpoint: Scalars['String']['output'];
  driverOpenChatNextTripCount?: Maybe<Scalars['Int']['output']>;
  driverOpenChatPreviousTripCount?: Maybe<Scalars['Int']['output']>;
  featureGates: Array<Enabled>;
  jobListPageSize: Scalars['Int']['output'];
  legalDocumentEndpoint: Scalars['String']['output'];
  maps: DeviceMaps;
  maxImageSizeMb: Scalars['Int']['output'];
  navigation: Array<DeviceNavigation>;
  notificationsNamespace?: Maybe<NotificationsNamespaceResponse>;
  providerHasFeature: Array<ProviderHasFeature>;
  readyForPickupNotification: Scalars['String']['output'];
  requireUpdate: Scalars['Boolean']['output'];
  sendChatMessageOnCheckinForOutbounds: Scalars['Boolean']['output'];
  userStrings?: Maybe<Array<Maybe<DeviceUserString>>>;
};

export type GetDriveTimeReportAsCsvInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  airports?: InputMaybe<Array<Scalars['String']['input']>>;
  buckets?: InputMaybe<Array<DriveTimeReportBucket>>;
  dropoffLocationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  format: DriveTimeReportFormatEnum;
  iataAirlineCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  lowerThreshold?: InputMaybe<Scalars['Int']['input']>;
  payerProviderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupLocationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDatetime: Scalars['String']['input'];
  upperThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type GetDriveTimeReportAsCsvResponse = {
  __typename?: 'GetDriveTimeReportAsCSVResponse';
  output: Scalars['String']['output'];
};

export type GetDriveTimeReportInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  airports?: InputMaybe<Array<Scalars['String']['input']>>;
  buckets?: InputMaybe<Array<DriveTimeReportBucket>>;
  dropoffLocationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  format: DriveTimeReportFormatEnum;
  iataAirlineCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  lowerThreshold?: InputMaybe<Scalars['Int']['input']>;
  payerProviderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupLocationIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDatetime: Scalars['String']['input'];
  upperThreshold?: InputMaybe<Scalars['Int']['input']>;
};

export type GetDriveTimeReportResponse = {
  __typename?: 'GetDriveTimeReportResponse';
  output?: Maybe<DriveTimeReport>;
};

export type GetDriverPerformanceReportsInput = {
  userIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetDriverPerformanceReportsResponse = {
  __typename?: 'GetDriverPerformanceReportsResponse';
  output?: Maybe<Array<DriverPerformanceReport>>;
};

export type GetDriversResponse = {
  __typename?: 'GetDriversResponse';
  drivers?: Maybe<Array<Maybe<User>>>;
  error?: Maybe<Error>;
};

export type GetDtrScatterPlotInput = {
  manifestHistoryRouteId?: InputMaybe<Scalars['String']['input']>;
  queryHistoryId?: InputMaybe<Scalars['String']['input']>;
};

export type GetDtrScatterPlotResponse = {
  __typename?: 'GetDtrScatterPlotResponse';
  output?: Maybe<ScatterPlot>;
};

export type GetDtrStatisticInput = {
  manifestHistoryRouteId?: InputMaybe<Scalars['String']['input']>;
  queryHistoryId?: InputMaybe<Scalars['String']['input']>;
};

export type GetDtrStatisticResponse = {
  __typename?: 'GetDtrStatisticResponse';
  output?: Maybe<Array<Maybe<Statistic>>>;
};

export type GetEvaluationInput = {
  evaluationId: Scalars['String']['input'];
};

export type GetEvaluationResponse = {
  __typename?: 'GetEvaluationResponse';
  error?: Maybe<Error>;
  evaluation?: Maybe<Evaluation>;
};

export type GetFaqInput = {
  device: Device;
};

export type GetFaqResponse = {
  __typename?: 'GetFaqResponse';
  faqs: Array<FaqResponse>;
};

export type GetFiltersResponse = {
  __typename?: 'GetFiltersResponse';
  filters?: Maybe<Filters>;
};

export type GetFitForDrivingQuestionsResponse = {
  __typename?: 'GetFitForDrivingQuestionsResponse';
  output: Array<FitForDrivingQuestion>;
};

export type GetFlightStatusInput = {
  airportCode?: InputMaybe<Scalars['String']['input']>;
  carrier: Scalars['String']['input'];
  flightNumber: Scalars['Int']['input'];
  kind: KindEnum;
  scheduledUtc?: InputMaybe<Scalars['String']['input']>;
};

export type GetFlightStatusResponse = {
  __typename?: 'GetFlightStatusResponse';
  airplaneType?: Maybe<Scalars['String']['output']>;
  airportArrivalGate?: Maybe<Scalars['String']['output']>;
  airportArrivalTerminal?: Maybe<Scalars['String']['output']>;
  airportDepartureGate?: Maybe<Scalars['String']['output']>;
  airportDepartureTerminal?: Maybe<Scalars['String']['output']>;
  arrivalAirportCode?: Maybe<Scalars['String']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  departureAirportCode?: Maybe<Scalars['String']['output']>;
  flightDuration?: Maybe<Scalars['String']['output']>;
  flightLatestArrivalLocaltime?: Maybe<Scalars['String']['output']>;
  flightLatestDepartureLocaltime?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['String']['output']>;
  flightStatus?: Maybe<Scalars['String']['output']>;
  originType?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Scalars['String']['output']>;
  responseType?: Maybe<Scalars['String']['output']>;
  statusLabel?: Maybe<Scalars['String']['output']>;
  statusTime?: Maybe<Scalars['String']['output']>;
};

export type GetHeadersInput = {
  tableNames: Array<Scalars['String']['input']>;
};

export type GetHeadersResponse = {
  __typename?: 'GetHeadersResponse';
  headers: Array<HeaderResponse>;
};

export type GetInvoiceInput = {
  invoiceId: Scalars['Int']['input'];
};

export type GetInvoiceResponse = {
  __typename?: 'GetInvoiceResponse';
  customChargesSummary?: Maybe<Array<InvoiceCustomChargeSummary>>;
  error?: Maybe<Error>;
  invoiceTerms?: Maybe<Scalars['String']['output']>;
  output?: Maybe<InvoiceResponse>;
  subtotals?: Maybe<Array<Maybe<InvoiceRateSubtotal>>>;
};

export type GetManifestParsedTripsInput = {
  manifestImportId: Scalars['String']['input'];
};

export type GetManifestParsedTripsResponse = {
  __typename?: 'GetManifestParsedTripsResponse';
  locations: Array<PotentialLocation>;
  trips: Array<DtrParsedTrip>;
};

export type GetMetricInput = {
  endDatetime: Scalars['String']['input'];
  interval: Scalars['String']['input'];
  keywordField: MetricKeywordFieldEnum;
  markets: Array<Scalars['String']['input']>;
  metrics: Array<Metric>;
  pipelines: Array<Pipeline>;
  providers: Array<Scalars['String']['input']>;
  sliceCount: Scalars['Int']['input'];
  startDatetime: Scalars['String']['input'];
};

export type GetMetricResponse = {
  __typename?: 'GetMetricResponse';
  history?: Maybe<Array<Maybe<HistoryMetric>>>;
  pipelines?: Maybe<Array<Maybe<FloatPipeline>>>;
};

export type GetNormalizedAddressInput = {
  address: Scalars['String']['input'];
  regionCode?: InputMaybe<Scalars['String']['input']>;
};

export type GetNormalizedAddressResponse = {
  __typename?: 'GetNormalizedAddressResponse';
  building?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  formattedAddress?: Maybe<Scalars['String']['output']>;
  geoLocationLat?: Maybe<Scalars['Float']['output']>;
  geoLocationLng?: Maybe<Scalars['Float']['output']>;
  locationId?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  stateAbbrev?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
};

export type GetOnTimePerformanceReportAsCsvInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  airports?: InputMaybe<Array<Scalars['String']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  format: OnTimePerformanceReportFormatEnum;
  iataAirlineCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  payerProviderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDatetime: Scalars['String']['input'];
};

export type GetOnTimePerformanceReportAsCsvResponse = {
  __typename?: 'GetOnTimePerformanceReportAsCSVResponse';
  output: Scalars['String']['output'];
};

export type GetOnTimePerformanceReportInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  airports?: InputMaybe<Array<Scalars['String']['input']>>;
  companyIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  format: OnTimePerformanceReportFormatEnum;
  iataAirlineCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  payerProviderIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDatetime: Scalars['String']['input'];
};

export type GetOnTimePerformanceReportResponse = {
  __typename?: 'GetOnTimePerformanceReportResponse';
  error?: Maybe<Error>;
  output?: Maybe<OnTimePerformanceReportTables>;
};

export type GetOverrideImportOptionsInput = {
  imports: Array<Scalars['String']['input']>;
};

export type GetOverrideImportOptionsResponse = {
  __typename?: 'GetOverrideImportOptionsResponse';
  imports: Array<OverrideOptionsResponse>;
};

export type GetPortalConfigInput = {
  device: Device;
};

export type GetPortalConfigResponse = {
  __typename?: 'GetPortalConfigResponse';
  auth: PortalAuth;
  driverRoleId: Scalars['String']['output'];
  genericLineItemTypeId: Scalars['String']['output'];
  getTripEtaAllowedWindowDurationBeforePickupMinutes: Scalars['Int']['output'];
  googleMapsApiKey: Scalars['String']['output'];
  highlightApiKey: Scalars['String']['output'];
  indexDBVersion: Scalars['Int']['output'];
  requestAvailabilityIntervalSeconds: Scalars['Int']['output'];
  supportedManifestFileTypes?: Maybe<Array<Scalars['String']['output']>>;
  upsProviderId: Scalars['String']['output'];
  userConfig?: Maybe<UserConfig>;
};

export type GetPredictiveDriveTimeReportAsCsvInput = {
  fieldsMapping?: InputMaybe<Array<FieldMapping>>;
  manifestHistoryRouteId?: InputMaybe<Scalars['ID']['input']>;
  queryHistoryId?: InputMaybe<Scalars['ID']['input']>;
  timeFrameId?: InputMaybe<Scalars['ID']['input']>;
};

export type GetPredictiveDriveTimeReportAsCsvResponse = {
  __typename?: 'GetPredictiveDriveTimeReportAsCSVResponse';
  output: Scalars['String']['output'];
};

export type GetPredictiveDriveTimeReportInput = {
  manifestHistoryRouteId?: InputMaybe<Scalars['String']['input']>;
  queryHistoryId?: InputMaybe<Scalars['String']['input']>;
  timeFrameId?: InputMaybe<Scalars['String']['input']>;
};

export type GetPredictiveDriveTimeReportResponse = {
  __typename?: 'GetPredictiveDriveTimeReportResponse';
  output?: Maybe<PredictiveDriveTimeReport>;
};

export type GetReportAsCsvResponse = {
  __typename?: 'GetReportAsCsvResponse';
  error?: Maybe<Scalars['String']['output']>;
  output: Scalars['String']['output'];
};

export type GetReportResponse = {
  __typename?: 'GetReportResponse';
  error?: Maybe<Scalars['String']['output']>;
  output: ReportData;
};

export type GetSummaryReportInput = {
  airport?: InputMaybe<Array<Scalars['String']['input']>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  currency?: InputMaybe<Array<RateCurrencyEnum>>;
  endDatetime: Scalars['String']['input'];
  format: SummaryReportFormatEnum;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
  startDatetime: Scalars['String']['input'];
  status?: InputMaybe<Array<TripStatusEnum>>;
  type?: InputMaybe<Array<TripTypeEnum>>;
};

export type GetSummaryReportResponse = {
  __typename?: 'GetSummaryReportResponse';
  error?: Maybe<Error>;
  summary?: Maybe<Summary>;
  tables?: Maybe<Array<Maybe<Summary>>>;
};

export type GetTripEtaInput = {
  tripId: Scalars['String']['input'];
};

export type GetTripEtaResponse = {
  __typename?: 'GetTripEtaResponse';
  arrivesAt: Scalars['String']['output'];
  arrivesAtUtc: Scalars['String']['output'];
  etaSeconds: Scalars['Int']['output'];
  isLate: Scalars['Boolean']['output'];
};

export type GetTripsWithWrongContractedRateInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  payerProviderId?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduledEndDatetime: Scalars['String']['input'];
  scheduledStartDatetime: Scalars['String']['input'];
};

export type GetTripsWithWrongContractedRateResponse = {
  __typename?: 'GetTripsWithWrongContractedRateResponse';
  output?: Maybe<Array<TripWithRateChange>>;
};

export type GetUserOfficeLocationDriverAppResponse = {
  __typename?: 'GetUserOfficeLocationDriverAppResponse';
  locations: Array<AirportWithLocation>;
};

export type GetVehiclesForTripInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  airportCode: Array<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  scheduled: Array<Scalars['String']['input']>;
  tripId: Array<Scalars['String']['input']>;
};

export type GetVehiclesForTripResponse = {
  __typename?: 'GetVehiclesForTripResponse';
  error?: Maybe<Error>;
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
};

export type GetVehiclesResponse = {
  __typename?: 'GetVehiclesResponse';
  error?: Maybe<Error>;
  vehicles?: Maybe<Array<Maybe<Vehicle>>>;
};

export type Group = {
  __typename?: 'Group';
  active: Scalars['Int']['output'];
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Permission>>;
  type: GroupTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  users?: Maybe<Array<User>>;
};

export type GroupActivityConnection = {
  __typename?: 'GroupActivityConnection';
  edges?: Maybe<Array<Maybe<GroupActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type GroupActivityEdge = {
  __typename?: 'GroupActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type GroupConnection = {
  __typename?: 'GroupConnection';
  edges?: Maybe<Array<Maybe<GroupEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<GroupMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<GroupSearch>>;
};

export type GroupEdge = {
  __typename?: 'GroupEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Group>;
};

export type GroupHasPermission = {
  __typename?: 'GroupHasPermission';
  groupId: Scalars['String']['output'];
  permissionId: Scalars['String']['output'];
};

export type GroupHasPermissionActivityConnection = {
  __typename?: 'GroupHasPermissionActivityConnection';
  edges?: Maybe<Array<Maybe<GroupHasPermissionActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupHasPermissionActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type GroupHasPermissionActivityEdge = {
  __typename?: 'GroupHasPermissionActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type GroupHasPermissionConnection = {
  __typename?: 'GroupHasPermissionConnection';
  edges?: Maybe<Array<Maybe<GroupHasPermissionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupHasPermissionConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<GroupHasPermissionMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<GroupHasPermissionSearch>>;
};

export type GroupHasPermissionEdge = {
  __typename?: 'GroupHasPermissionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GroupHasPermission>;
};

export type GroupHasPermissionMaskInput = {
  groupId?: InputMaybe<Scalars['Boolean']['input']>;
  permissionId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupHasPermissionSearch = {
  groupId?: InputMaybe<Array<StringSearch>>;
  permissionId?: InputMaybe<Array<StringSearch>>;
};

export type GroupHasUser = {
  __typename?: 'GroupHasUser';
  groupId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type GroupHasUserActivityConnection = {
  __typename?: 'GroupHasUserActivityConnection';
  edges?: Maybe<Array<Maybe<GroupHasUserActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupHasUserActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type GroupHasUserActivityEdge = {
  __typename?: 'GroupHasUserActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type GroupHasUserConnection = {
  __typename?: 'GroupHasUserConnection';
  edges?: Maybe<Array<Maybe<GroupHasUserEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupHasUserConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<GroupHasUserMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<GroupHasUserSearch>>;
};

export type GroupHasUserEdge = {
  __typename?: 'GroupHasUserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GroupHasUser>;
};

export type GroupHasUserMaskInput = {
  groupId?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupHasUserSearch = {
  groupId?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type GroupHasUserWithPermissions = {
  __typename?: 'GroupHasUserWithPermissions';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayGroup: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  effect: GroupHasUserWithPermissionsEffectEnum;
  entity: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  verb: Scalars['String']['output'];
};

export type GroupHasUserWithPermissionsActivityConnection = {
  __typename?: 'GroupHasUserWithPermissionsActivityConnection';
  edges?: Maybe<Array<Maybe<GroupHasUserWithPermissionsActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupHasUserWithPermissionsActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type GroupHasUserWithPermissionsActivityEdge = {
  __typename?: 'GroupHasUserWithPermissionsActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type GroupHasUserWithPermissionsConnection = {
  __typename?: 'GroupHasUserWithPermissionsConnection';
  edges?: Maybe<Array<Maybe<GroupHasUserWithPermissionsEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type GroupHasUserWithPermissionsConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<GroupHasUserWithPermissionsMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<GroupHasUserWithPermissionsSearch>>;
};

export type GroupHasUserWithPermissionsEdge = {
  __typename?: 'GroupHasUserWithPermissionsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<GroupHasUserWithPermissions>;
};

export enum GroupHasUserWithPermissionsEffectEnum {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export type GroupHasUserWithPermissionsEffectEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<GroupHasUserWithPermissionsEffectEnum>;
};

export type GroupHasUserWithPermissionsMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  displayGroup?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  effect?: InputMaybe<Scalars['Boolean']['input']>;
  entity?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
  verb?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupHasUserWithPermissionsSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  displayGroup?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  effect?: InputMaybe<Array<GroupHasUserWithPermissionsEffectEnumSearch>>;
  entity?: InputMaybe<Array<StringSearch>>;
  groupId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  resource?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
  verb?: InputMaybe<Array<StringSearch>>;
};

export type GroupMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type GroupSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<GroupTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum GroupTypeEnum {
  Airline = 'AIRLINE',
  Hotel = 'HOTEL',
  Transportation = 'TRANSPORTATION'
}

export type GroupTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<GroupTypeEnum>;
};

export type Header = {
  __typename?: 'Header';
  alt: Scalars['Boolean']['output'];
  center: Scalars['Boolean']['output'];
  edit: Scalars['Boolean']['output'];
  key: Scalars['String']['output'];
  left: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  omit: Scalars['Boolean']['output'];
  right: Scalars['Boolean']['output'];
  selector: Scalars['String']['output'];
  sortable: Scalars['Boolean']['output'];
  wrap: Scalars['Boolean']['output'];
};

export type HeaderResponse = {
  __typename?: 'HeaderResponse';
  columns: Array<Header>;
  dataPath: Scalars['String']['output'];
  error?: Maybe<Scalars['String']['output']>;
  tableName: Scalars['String']['output'];
};

export type HistoryMetric = {
  __typename?: 'HistoryMetric';
  buckets?: Maybe<Array<Maybe<FloatMetric>>>;
  count?: Maybe<Scalars['Int']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  pipelines?: Maybe<Array<Maybe<FloatPipeline>>>;
};

export type Image = {
  __typename?: 'Image';
  contentType?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  md5: Scalars['String']['output'];
  path: Scalars['String']['output'];
  pickupPointId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  uploadUrl?: Maybe<Scalars['String']['output']>;
};

export type ImageActivityConnection = {
  __typename?: 'ImageActivityConnection';
  edges?: Maybe<Array<Maybe<ImageActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImageActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ImageActivityEdge = {
  __typename?: 'ImageActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ImageConnection = {
  __typename?: 'ImageConnection';
  edges?: Maybe<Array<Maybe<ImageEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImageConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ImageMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ImageSearch>>;
};

export type ImageEdge = {
  __typename?: 'ImageEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Image>;
};

export type ImageMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  path?: InputMaybe<Scalars['Boolean']['input']>;
  pickupPointId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImageSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  path?: InputMaybe<Array<StringSearch>>;
  pickupPointId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type Import = {
  __typename?: 'Import';
  airlineIcaoCode: Scalars['String']['output'];
  archivedAt?: Maybe<Scalars['String']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  archivedByUser?: Maybe<Scalars['String']['output']>;
  cancelled?: Maybe<Scalars['Int']['output']>;
  companyId: Scalars['String']['output'];
  contentType?: Maybe<Scalars['String']['output']>;
  createTripTolerance?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  email?: Maybe<ImportEmail>;
  emailId?: Maybe<Scalars['String']['output']>;
  excluded?: Maybe<Scalars['Int']['output']>;
  fileLocation?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  importedBy?: Maybe<Scalars['String']['output']>;
  ingestCompleted?: Maybe<Scalars['String']['output']>;
  ingestStarted?: Maybe<Scalars['String']['output']>;
  ingestedBy?: Maybe<Scalars['String']['output']>;
  ingestedByUser?: Maybe<Scalars['String']['output']>;
  md5: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  noticeDatetime?: Maybe<Scalars['String']['output']>;
  potentialTrips?: Maybe<Array<PotentialTrip>>;
  previewType?: Maybe<ImportPreviewTypeEnum>;
  previewedAt?: Maybe<Scalars['String']['output']>;
  previousImportId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  providerId: Scalars['String']['output'];
  rollbackBy?: Maybe<Scalars['String']['output']>;
  rolledBackAt?: Maybe<Scalars['String']['output']>;
  rolledBackBy?: Maybe<Scalars['String']['output']>;
  rolledBackUser?: Maybe<User>;
  status: ImportStatusEnum;
  statusDisplayName?: Maybe<Scalars['String']['output']>;
  subject: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  type: ImportTypeEnum;
  unchanged?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type ImportActivityConnection = {
  __typename?: 'ImportActivityConnection';
  edges?: Maybe<Array<Maybe<ImportActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ImportActivityEdge = {
  __typename?: 'ImportActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ImportConnection = {
  __typename?: 'ImportConnection';
  edges?: Maybe<Array<Maybe<ImportEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ImportMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ImportSearch>>;
};

export type ImportEdge = {
  __typename?: 'ImportEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Import>;
};

export type ImportEmail = {
  __typename?: 'ImportEmail';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  fileLocation?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  md5: Scalars['String']['output'];
  originalFileLocation: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ImportEmailActivityConnection = {
  __typename?: 'ImportEmailActivityConnection';
  edges?: Maybe<Array<Maybe<ImportEmailActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportEmailActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ImportEmailActivityEdge = {
  __typename?: 'ImportEmailActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ImportEmailConnection = {
  __typename?: 'ImportEmailConnection';
  edges?: Maybe<Array<Maybe<ImportEmailEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportEmailConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ImportEmailMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ImportEmailSearch>>;
};

export type ImportEmailEdge = {
  __typename?: 'ImportEmailEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ImportEmail>;
};

export type ImportEmailMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  originalFileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportEmailSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  date?: InputMaybe<Array<StringSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  from?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  originalFileLocation?: InputMaybe<Array<StringSearch>>;
  subject?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type ImportFailure = {
  __typename?: 'ImportFailure';
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  errorCode?: Maybe<Scalars['Int']['output']>;
  errorMessage: Scalars['String']['output'];
  id: Scalars['String']['output'];
  importId: Scalars['String']['output'];
  importType: ImportFailureImportTypeEnum;
  ingestAction?: Maybe<ImportFailureIngestActionEnum>;
  providerId: Scalars['String']['output'];
  stagedTripId?: Maybe<Scalars['String']['output']>;
  tripId?: Maybe<Scalars['String']['output']>;
  type: ImportFailureTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ImportFailureActivityConnection = {
  __typename?: 'ImportFailureActivityConnection';
  edges?: Maybe<Array<Maybe<ImportFailureActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportFailureActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ImportFailureActivityEdge = {
  __typename?: 'ImportFailureActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ImportFailureConnection = {
  __typename?: 'ImportFailureConnection';
  edges?: Maybe<Array<Maybe<ImportFailureEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportFailureConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ImportFailureMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ImportFailureSearch>>;
};

export type ImportFailureEdge = {
  __typename?: 'ImportFailureEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ImportFailure>;
};

export enum ImportFailureImportTypeEnum {
  Addon = 'ADDON',
  Daily = 'DAILY',
  DriveTimeReportManifest = 'DRIVE_TIME_REPORT_MANIFEST',
  Manifest = 'MANIFEST',
  Training = 'TRAINING'
}

export type ImportFailureImportTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ImportFailureImportTypeEnum>;
};

export enum ImportFailureIngestActionEnum {
  Create = 'CREATE',
  Delete = 'DELETE',
  Exclude = 'EXCLUDE',
  Noop = 'NOOP',
  Not = 'NOT',
  Replace = 'REPLACE',
  Restore = 'RESTORE',
  SoftDelete = 'SOFT_DELETE',
  Update = 'UPDATE'
}

export type ImportFailureIngestActionEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ImportFailureIngestActionEnum>;
};

export type ImportFailureMaskInput = {
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  errorCode?: InputMaybe<Scalars['Boolean']['input']>;
  errorMessage?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importId?: InputMaybe<Scalars['Boolean']['input']>;
  importType?: InputMaybe<Scalars['Boolean']['input']>;
  ingestAction?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  stagedTripId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportFailureSearch = {
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  errorCode?: InputMaybe<Array<IntSearch>>;
  errorMessage?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importId?: InputMaybe<Array<StringSearch>>;
  importType?: InputMaybe<Array<ImportFailureImportTypeEnumSearch>>;
  ingestAction?: InputMaybe<Array<ImportFailureIngestActionEnumSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  stagedTripId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<ImportFailureTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum ImportFailureTypeEnum {
  Ingest = 'INGEST',
  Parse = 'PARSE',
  Preview = 'PREVIEW',
  Rollback = 'ROLLBACK'
}

export type ImportFailureTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ImportFailureTypeEnum>;
};

export type ImportLog = {
  __typename?: 'ImportLog';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  importId: Scalars['String']['output'];
  message: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ImportLogActivityConnection = {
  __typename?: 'ImportLogActivityConnection';
  edges?: Maybe<Array<Maybe<ImportLogActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportLogActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ImportLogActivityEdge = {
  __typename?: 'ImportLogActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ImportLogConnection = {
  __typename?: 'ImportLogConnection';
  edges?: Maybe<Array<Maybe<ImportLogEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportLogConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ImportLogMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ImportLogSearch>>;
};

export type ImportLogEdge = {
  __typename?: 'ImportLogEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ImportLog>;
};

export type ImportLogMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importId?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportLogSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importId?: InputMaybe<Array<StringSearch>>;
  message?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type ImportMaskInput = {
  airlineIcaoCode?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  archivedBy?: InputMaybe<Scalars['Boolean']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createTripTolerance?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  emailId?: InputMaybe<Scalars['Boolean']['input']>;
  excluded?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  ingestCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  ingestStarted?: InputMaybe<Scalars['Boolean']['input']>;
  ingestedBy?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  noticeDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  previewType?: InputMaybe<Scalars['Boolean']['input']>;
  previewedAt?: InputMaybe<Scalars['Boolean']['input']>;
  previousImportId?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  rollbackBy?: InputMaybe<Scalars['Boolean']['input']>;
  rolledBackAt?: InputMaybe<Scalars['Boolean']['input']>;
  rolledBackBy?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  total?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  unchanged?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportOcrCache = {
  __typename?: 'ImportOcrCache';
  createdAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  importId: Scalars['String']['output'];
  providerId?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export type ImportOcrCacheActivityConnection = {
  __typename?: 'ImportOcrCacheActivityConnection';
  edges?: Maybe<Array<Maybe<ImportOcrCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportOcrCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ImportOcrCacheActivityEdge = {
  __typename?: 'ImportOcrCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ImportOcrCacheConnection = {
  __typename?: 'ImportOcrCacheConnection';
  edges?: Maybe<Array<Maybe<ImportOcrCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportOcrCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ImportOcrCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ImportOcrCacheSearch>>;
};

export type ImportOcrCacheEdge = {
  __typename?: 'ImportOcrCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ImportOcrCache>;
};

export type ImportOcrCacheMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importId?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ImportOcrCacheSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importId?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  text?: InputMaybe<Array<StringSearch>>;
};

export enum ImportPreviewTypeEnum {
  Addon = 'ADDON',
  Manifest = 'MANIFEST'
}

export type ImportPreviewTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ImportPreviewTypeEnum>;
};

export type ImportResponse = {
  __typename?: 'ImportResponse';
  error?: Maybe<Error>;
  import?: Maybe<Import>;
};

export type ImportSearch = {
  airlineIcaoCode?: InputMaybe<Array<StringSearch>>;
  archivedAt?: InputMaybe<Array<StringSearch>>;
  archivedBy?: InputMaybe<Array<StringSearch>>;
  cancelled?: InputMaybe<Array<IntSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createTripTolerance?: InputMaybe<Array<IntSearch>>;
  created?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deleted?: InputMaybe<Array<IntSearch>>;
  emailId?: InputMaybe<Array<StringSearch>>;
  excluded?: InputMaybe<Array<IntSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  from?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  ingestCompleted?: InputMaybe<Array<StringSearch>>;
  ingestStarted?: InputMaybe<Array<StringSearch>>;
  ingestedBy?: InputMaybe<Array<StringSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  noticeDatetime?: InputMaybe<Array<StringSearch>>;
  previewType?: InputMaybe<Array<ImportPreviewTypeEnumSearch>>;
  previewedAt?: InputMaybe<Array<StringSearch>>;
  previousImportId?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  rollbackBy?: InputMaybe<Array<StringSearch>>;
  rolledBackAt?: InputMaybe<Array<StringSearch>>;
  rolledBackBy?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<ImportStatusEnumSearch>>;
  total?: InputMaybe<Array<IntSearch>>;
  type?: InputMaybe<Array<ImportTypeEnumSearch>>;
  unchanged?: InputMaybe<Array<IntSearch>>;
  updated?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  version?: InputMaybe<Array<IntSearch>>;
};

export enum ImportStatusEnum {
  Archived = 'ARCHIVED',
  Failed = 'FAILED',
  Ingested = 'INGESTED',
  Ingesting = 'INGESTING',
  New = 'NEW',
  NotParsed = 'NOT_PARSED',
  Parsed = 'PARSED',
  Potential = 'POTENTIAL',
  RolledBack = 'ROLLED_BACK',
  RollingBack = 'ROLLING_BACK',
  Staged = 'STAGED',
  Staging = 'STAGING',
  Uploaded = 'UPLOADED'
}

export type ImportStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ImportStatusEnum>;
};

export enum ImportTypeEnum {
  Addon = 'ADDON',
  Daily = 'DAILY',
  DriveTimeReportManifest = 'DRIVE_TIME_REPORT_MANIFEST',
  Manifest = 'MANIFEST',
  Training = 'TRAINING'
}

export type ImportTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ImportTypeEnum>;
};

export type ImportWithAirport = {
  __typename?: 'ImportWithAirport';
  airlineIcaoCode: Scalars['String']['output'];
  airportCode: Scalars['String']['output'];
  archivedAt?: Maybe<Scalars['String']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  cancelled?: Maybe<Scalars['Int']['output']>;
  companyId: Scalars['String']['output'];
  createTripTolerance?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deleted?: Maybe<Scalars['Int']['output']>;
  emailId?: Maybe<Scalars['String']['output']>;
  excluded?: Maybe<Scalars['Int']['output']>;
  fileLocation?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  ingestCompleted?: Maybe<Scalars['String']['output']>;
  ingestStarted?: Maybe<Scalars['String']['output']>;
  ingestedBy?: Maybe<Scalars['String']['output']>;
  md5: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  noticeDatetime?: Maybe<Scalars['String']['output']>;
  previewType?: Maybe<ImportWithAirportPreviewTypeEnum>;
  previewedAt?: Maybe<Scalars['String']['output']>;
  previousImportId?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  rollbackBy?: Maybe<Scalars['String']['output']>;
  rolledBackAt?: Maybe<Scalars['String']['output']>;
  rolledBackBy?: Maybe<Scalars['String']['output']>;
  status: ImportWithAirportStatusEnum;
  total?: Maybe<Scalars['Int']['output']>;
  type: ImportWithAirportTypeEnum;
  unchanged?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type ImportWithAirportActivityConnection = {
  __typename?: 'ImportWithAirportActivityConnection';
  edges?: Maybe<Array<Maybe<ImportWithAirportActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportWithAirportActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ImportWithAirportActivityEdge = {
  __typename?: 'ImportWithAirportActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ImportWithAirportConnection = {
  __typename?: 'ImportWithAirportConnection';
  edges?: Maybe<Array<Maybe<ImportWithAirportEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportWithAirportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ImportWithAirportMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ImportWithAirportSearch>>;
};

export type ImportWithAirportEdge = {
  __typename?: 'ImportWithAirportEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ImportWithAirport>;
};

export type ImportWithAirportMaskInput = {
  airlineIcaoCode?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  archivedBy?: InputMaybe<Scalars['Boolean']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createTripTolerance?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  emailId?: InputMaybe<Scalars['Boolean']['input']>;
  excluded?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  ingestCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  ingestStarted?: InputMaybe<Scalars['Boolean']['input']>;
  ingestedBy?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  noticeDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  previewType?: InputMaybe<Scalars['Boolean']['input']>;
  previewedAt?: InputMaybe<Scalars['Boolean']['input']>;
  previousImportId?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  rollbackBy?: InputMaybe<Scalars['Boolean']['input']>;
  rolledBackAt?: InputMaybe<Scalars['Boolean']['input']>;
  rolledBackBy?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  total?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  unchanged?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ImportWithAirportPreviewTypeEnum {
  Addon = 'ADDON',
  Manifest = 'MANIFEST'
}

export type ImportWithAirportPreviewTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ImportWithAirportPreviewTypeEnum>;
};

export type ImportWithAirportSearch = {
  airlineIcaoCode?: InputMaybe<Array<StringSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  archivedAt?: InputMaybe<Array<StringSearch>>;
  archivedBy?: InputMaybe<Array<StringSearch>>;
  cancelled?: InputMaybe<Array<IntSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createTripTolerance?: InputMaybe<Array<IntSearch>>;
  created?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deleted?: InputMaybe<Array<IntSearch>>;
  emailId?: InputMaybe<Array<StringSearch>>;
  excluded?: InputMaybe<Array<IntSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  from?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  ingestCompleted?: InputMaybe<Array<StringSearch>>;
  ingestStarted?: InputMaybe<Array<StringSearch>>;
  ingestedBy?: InputMaybe<Array<StringSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  noticeDatetime?: InputMaybe<Array<StringSearch>>;
  previewType?: InputMaybe<Array<ImportWithAirportPreviewTypeEnumSearch>>;
  previewedAt?: InputMaybe<Array<StringSearch>>;
  previousImportId?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  rollbackBy?: InputMaybe<Array<StringSearch>>;
  rolledBackAt?: InputMaybe<Array<StringSearch>>;
  rolledBackBy?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<ImportWithAirportStatusEnumSearch>>;
  total?: InputMaybe<Array<IntSearch>>;
  type?: InputMaybe<Array<ImportWithAirportTypeEnumSearch>>;
  unchanged?: InputMaybe<Array<IntSearch>>;
  updated?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  version?: InputMaybe<Array<IntSearch>>;
};

export enum ImportWithAirportStatusEnum {
  Archived = 'ARCHIVED',
  Failed = 'FAILED',
  Ingested = 'INGESTED',
  Ingesting = 'INGESTING',
  New = 'NEW',
  NotParsed = 'NOT_PARSED',
  Parsed = 'PARSED',
  Potential = 'POTENTIAL',
  RolledBack = 'ROLLED_BACK',
  RollingBack = 'ROLLING_BACK',
  Staged = 'STAGED',
  Staging = 'STAGING',
  Uploaded = 'UPLOADED'
}

export type ImportWithAirportStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ImportWithAirportStatusEnum>;
};

export enum ImportWithAirportTypeEnum {
  Addon = 'ADDON',
  Daily = 'DAILY',
  DriveTimeReportManifest = 'DRIVE_TIME_REPORT_MANIFEST',
  Manifest = 'MANIFEST',
  Training = 'TRAINING'
}

export type ImportWithAirportTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ImportWithAirportTypeEnum>;
};

export type ImportWithAirportWithCache = {
  __typename?: 'ImportWithAirportWithCache';
  airlineIcaoCode: Scalars['String']['output'];
  airportCode: Scalars['String']['output'];
  archivedAt?: Maybe<Scalars['String']['output']>;
  archivedBy?: Maybe<Scalars['String']['output']>;
  archivedByFirstName: Scalars['String']['output'];
  archivedByLastName: Scalars['String']['output'];
  cancelled?: Maybe<Scalars['Int']['output']>;
  companyId: Scalars['String']['output'];
  createTripTolerance?: Maybe<Scalars['Int']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByFirstName: Scalars['String']['output'];
  createdByLastName: Scalars['String']['output'];
  deleted?: Maybe<Scalars['Int']['output']>;
  emailId?: Maybe<Scalars['String']['output']>;
  excluded?: Maybe<Scalars['Int']['output']>;
  fileLocation?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  from?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  ingestCompleted?: Maybe<Scalars['String']['output']>;
  ingestStarted?: Maybe<Scalars['String']['output']>;
  ingestedBy?: Maybe<Scalars['String']['output']>;
  ingestedByFirstName: Scalars['String']['output'];
  ingestedByLastName: Scalars['String']['output'];
  md5: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  noticeDatetime?: Maybe<Scalars['String']['output']>;
  previewType?: Maybe<ImportWithAirportWithCachePreviewTypeEnum>;
  previewedAt?: Maybe<Scalars['String']['output']>;
  previousImportId?: Maybe<Scalars['String']['output']>;
  providerDisplayName?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  rollbackBy?: Maybe<Scalars['String']['output']>;
  rolledBackAt?: Maybe<Scalars['String']['output']>;
  rolledBackBy?: Maybe<Scalars['String']['output']>;
  rolledBackByFirstName: Scalars['String']['output'];
  rolledBackByLastName: Scalars['String']['output'];
  status: ImportWithAirportWithCacheStatusEnum;
  subject: Scalars['String']['output'];
  total?: Maybe<Scalars['Int']['output']>;
  type: ImportWithAirportWithCacheTypeEnum;
  unchanged?: Maybe<Scalars['Int']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  version: Scalars['Int']['output'];
};

export type ImportWithAirportWithCacheActivityConnection = {
  __typename?: 'ImportWithAirportWithCacheActivityConnection';
  edges?: Maybe<Array<Maybe<ImportWithAirportWithCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportWithAirportWithCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ImportWithAirportWithCacheActivityEdge = {
  __typename?: 'ImportWithAirportWithCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ImportWithAirportWithCacheConnection = {
  __typename?: 'ImportWithAirportWithCacheConnection';
  edges?: Maybe<Array<Maybe<ImportWithAirportWithCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ImportWithAirportWithCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ImportWithAirportWithCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ImportWithAirportWithCacheSearch>>;
};

export type ImportWithAirportWithCacheEdge = {
  __typename?: 'ImportWithAirportWithCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ImportWithAirportWithCache>;
};

export type ImportWithAirportWithCacheMaskInput = {
  airlineIcaoCode?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  archivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  archivedBy?: InputMaybe<Scalars['Boolean']['input']>;
  archivedByFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  archivedByLastName?: InputMaybe<Scalars['Boolean']['input']>;
  cancelled?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createTripTolerance?: InputMaybe<Scalars['Boolean']['input']>;
  created?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  createdByFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  createdByLastName?: InputMaybe<Scalars['Boolean']['input']>;
  deleted?: InputMaybe<Scalars['Boolean']['input']>;
  emailId?: InputMaybe<Scalars['Boolean']['input']>;
  excluded?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  from?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  ingestCompleted?: InputMaybe<Scalars['Boolean']['input']>;
  ingestStarted?: InputMaybe<Scalars['Boolean']['input']>;
  ingestedBy?: InputMaybe<Scalars['Boolean']['input']>;
  ingestedByFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  ingestedByLastName?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  noticeDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  previewType?: InputMaybe<Scalars['Boolean']['input']>;
  previewedAt?: InputMaybe<Scalars['Boolean']['input']>;
  previousImportId?: InputMaybe<Scalars['Boolean']['input']>;
  providerDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  rollbackBy?: InputMaybe<Scalars['Boolean']['input']>;
  rolledBackAt?: InputMaybe<Scalars['Boolean']['input']>;
  rolledBackBy?: InputMaybe<Scalars['Boolean']['input']>;
  rolledBackByFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  rolledBackByLastName?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  subject?: InputMaybe<Scalars['Boolean']['input']>;
  total?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  unchanged?: InputMaybe<Scalars['Boolean']['input']>;
  updated?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  version?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ImportWithAirportWithCachePreviewTypeEnum {
  Addon = 'ADDON',
  Manifest = 'MANIFEST'
}

export type ImportWithAirportWithCachePreviewTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ImportWithAirportWithCachePreviewTypeEnum>;
};

export type ImportWithAirportWithCacheSearch = {
  airlineIcaoCode?: InputMaybe<Array<StringSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  archivedAt?: InputMaybe<Array<StringSearch>>;
  archivedBy?: InputMaybe<Array<StringSearch>>;
  archivedByFirstName?: InputMaybe<Array<StringSearch>>;
  archivedByLastName?: InputMaybe<Array<StringSearch>>;
  cancelled?: InputMaybe<Array<IntSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createTripTolerance?: InputMaybe<Array<IntSearch>>;
  created?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  createdByFirstName?: InputMaybe<Array<StringSearch>>;
  createdByLastName?: InputMaybe<Array<StringSearch>>;
  deleted?: InputMaybe<Array<IntSearch>>;
  emailId?: InputMaybe<Array<StringSearch>>;
  excluded?: InputMaybe<Array<IntSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  from?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  ingestCompleted?: InputMaybe<Array<StringSearch>>;
  ingestStarted?: InputMaybe<Array<StringSearch>>;
  ingestedBy?: InputMaybe<Array<StringSearch>>;
  ingestedByFirstName?: InputMaybe<Array<StringSearch>>;
  ingestedByLastName?: InputMaybe<Array<StringSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  noticeDatetime?: InputMaybe<Array<StringSearch>>;
  previewType?: InputMaybe<Array<ImportWithAirportWithCachePreviewTypeEnumSearch>>;
  previewedAt?: InputMaybe<Array<StringSearch>>;
  previousImportId?: InputMaybe<Array<StringSearch>>;
  providerDisplayName?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  rollbackBy?: InputMaybe<Array<StringSearch>>;
  rolledBackAt?: InputMaybe<Array<StringSearch>>;
  rolledBackBy?: InputMaybe<Array<StringSearch>>;
  rolledBackByFirstName?: InputMaybe<Array<StringSearch>>;
  rolledBackByLastName?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<ImportWithAirportWithCacheStatusEnumSearch>>;
  subject?: InputMaybe<Array<StringSearch>>;
  total?: InputMaybe<Array<IntSearch>>;
  type?: InputMaybe<Array<ImportWithAirportWithCacheTypeEnumSearch>>;
  unchanged?: InputMaybe<Array<IntSearch>>;
  updated?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  version?: InputMaybe<Array<IntSearch>>;
};

export enum ImportWithAirportWithCacheStatusEnum {
  Archived = 'ARCHIVED',
  Failed = 'FAILED',
  Ingested = 'INGESTED',
  Ingesting = 'INGESTING',
  New = 'NEW',
  NotParsed = 'NOT_PARSED',
  Parsed = 'PARSED',
  Potential = 'POTENTIAL',
  RolledBack = 'ROLLED_BACK',
  RollingBack = 'ROLLING_BACK',
  Staged = 'STAGED',
  Staging = 'STAGING',
  Uploaded = 'UPLOADED'
}

export type ImportWithAirportWithCacheStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ImportWithAirportWithCacheStatusEnum>;
};

export enum ImportWithAirportWithCacheTypeEnum {
  Addon = 'ADDON',
  Daily = 'DAILY',
  DriveTimeReportManifest = 'DRIVE_TIME_REPORT_MANIFEST',
  Manifest = 'MANIFEST',
  Training = 'TRAINING'
}

export type ImportWithAirportWithCacheTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ImportWithAirportWithCacheTypeEnum>;
};

export type IncidentIssue = {
  __typename?: 'IncidentIssue';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewInfo?: Maybe<Scalars['String']['output']>;
  crewInvolved: IncidentIssueCrewInvolvedEnum;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  dispatcherId: Scalars['String']['output'];
  driverId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  incidentDatetime: Scalars['String']['output'];
  incidentOccurance: IncidentIssueIncidentOccuranceEnum;
  incidentOccuranceOther?: Maybe<Scalars['String']['output']>;
  incidentWitnesses?: Maybe<Scalars['String']['output']>;
  managerId?: Maybe<Scalars['String']['output']>;
  medicalAttentionType?: Maybe<Scalars['String']['output']>;
  medicalInjuries?: Maybe<IncidentIssueMedicalInjuriesEnum>;
  medicalNeeded?: Maybe<IncidentIssueMedicalNeededEnum>;
  outboundDatetime?: Maybe<Scalars['String']['output']>;
  outboundFlightName?: Maybe<Scalars['String']['output']>;
  outboundFlightNumber?: Maybe<Scalars['Int']['output']>;
  propertyDamage: IncidentIssuePropertyDamageEnum;
  propertyDamageDescription?: Maybe<Scalars['String']['output']>;
  recoveryInfo?: Maybe<Scalars['String']['output']>;
  samsaraCameraWorking?: Maybe<IncidentIssueSamsaraCameraWorkingEnum>;
  station?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  tripId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId: Scalars['String']['output'];
};

export type IncidentIssueActivityConnection = {
  __typename?: 'IncidentIssueActivityConnection';
  edges?: Maybe<Array<Maybe<IncidentIssueActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IncidentIssueActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type IncidentIssueActivityEdge = {
  __typename?: 'IncidentIssueActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type IncidentIssueAndDocument = {
  __typename?: 'IncidentIssueAndDocument';
  document?: Maybe<Array<IncidentIssueDocumentAndPresignedUrl>>;
  issue: IncidentIssue;
};

export type IncidentIssueConnection = {
  __typename?: 'IncidentIssueConnection';
  edges?: Maybe<Array<Maybe<IncidentIssueEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IncidentIssueConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<IncidentIssueMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<IncidentIssueSearch>>;
};

export enum IncidentIssueCrewInvolvedEnum {
  No = 'NO',
  Yes = 'YES'
}

export type IncidentIssueCrewInvolvedEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<IncidentIssueCrewInvolvedEnum>;
};

export type IncidentIssueDocument = {
  __typename?: 'IncidentIssueDocument';
  contentType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  fileLocation: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  issueId: Scalars['String']['output'];
  md5: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type IncidentIssueDocumentActivityConnection = {
  __typename?: 'IncidentIssueDocumentActivityConnection';
  edges?: Maybe<Array<Maybe<IncidentIssueDocumentActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IncidentIssueDocumentActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type IncidentIssueDocumentActivityEdge = {
  __typename?: 'IncidentIssueDocumentActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type IncidentIssueDocumentAndPresignedUrl = {
  __typename?: 'IncidentIssueDocumentAndPresignedURL';
  document?: Maybe<IncidentIssueDocument>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

export type IncidentIssueDocumentConnection = {
  __typename?: 'IncidentIssueDocumentConnection';
  edges?: Maybe<Array<Maybe<IncidentIssueDocumentEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IncidentIssueDocumentConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<IncidentIssueDocumentMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<IncidentIssueDocumentSearch>>;
};

export type IncidentIssueDocumentEdge = {
  __typename?: 'IncidentIssueDocumentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<IncidentIssueDocument>;
};

export type IncidentIssueDocumentMaskInput = {
  contentType?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  fileSize?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  issueId?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IncidentIssueDocumentSearch = {
  contentType?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  fileSize?: InputMaybe<Array<IntSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  issueId?: InputMaybe<Array<StringSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type IncidentIssueEdge = {
  __typename?: 'IncidentIssueEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<IncidentIssue>;
};

export enum IncidentIssueIncidentOccuranceEnum {
  Airport = 'AIRPORT',
  Hotel = 'HOTEL',
  Office = 'OFFICE',
  Other = 'OTHER'
}

export type IncidentIssueIncidentOccuranceEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<IncidentIssueIncidentOccuranceEnum>;
};

export type IncidentIssueMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewInfo?: InputMaybe<Scalars['Boolean']['input']>;
  crewInvolved?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherId?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  incidentDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  incidentOccurance?: InputMaybe<Scalars['Boolean']['input']>;
  incidentOccuranceOther?: InputMaybe<Scalars['Boolean']['input']>;
  incidentWitnesses?: InputMaybe<Scalars['Boolean']['input']>;
  managerId?: InputMaybe<Scalars['Boolean']['input']>;
  medicalAttentionType?: InputMaybe<Scalars['Boolean']['input']>;
  medicalInjuries?: InputMaybe<Scalars['Boolean']['input']>;
  medicalNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  outboundDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightName?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  propertyDamage?: InputMaybe<Scalars['Boolean']['input']>;
  propertyDamageDescription?: InputMaybe<Scalars['Boolean']['input']>;
  recoveryInfo?: InputMaybe<Scalars['Boolean']['input']>;
  samsaraCameraWorking?: InputMaybe<Scalars['Boolean']['input']>;
  station?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IncidentIssueMedicalInjuriesEnum {
  No = 'NO',
  Yes = 'YES'
}

export type IncidentIssueMedicalInjuriesEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<IncidentIssueMedicalInjuriesEnum>;
};

export enum IncidentIssueMedicalNeededEnum {
  No = 'NO',
  Yes = 'YES'
}

export type IncidentIssueMedicalNeededEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<IncidentIssueMedicalNeededEnum>;
};

export enum IncidentIssuePropertyDamageEnum {
  No = 'NO',
  Yes = 'YES'
}

export type IncidentIssuePropertyDamageEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<IncidentIssuePropertyDamageEnum>;
};

export enum IncidentIssueSamsaraCameraWorkingEnum {
  No = 'NO',
  Yes = 'YES'
}

export type IncidentIssueSamsaraCameraWorkingEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<IncidentIssueSamsaraCameraWorkingEnum>;
};

export type IncidentIssueSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewInfo?: InputMaybe<Array<StringSearch>>;
  crewInvolved?: InputMaybe<Array<IncidentIssueCrewInvolvedEnumSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  dispatcherId?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  incidentDatetime?: InputMaybe<Array<StringSearch>>;
  incidentOccurance?: InputMaybe<Array<IncidentIssueIncidentOccuranceEnumSearch>>;
  incidentOccuranceOther?: InputMaybe<Array<StringSearch>>;
  incidentWitnesses?: InputMaybe<Array<StringSearch>>;
  managerId?: InputMaybe<Array<StringSearch>>;
  medicalAttentionType?: InputMaybe<Array<StringSearch>>;
  medicalInjuries?: InputMaybe<Array<IncidentIssueMedicalInjuriesEnumSearch>>;
  medicalNeeded?: InputMaybe<Array<IncidentIssueMedicalNeededEnumSearch>>;
  outboundDatetime?: InputMaybe<Array<StringSearch>>;
  outboundFlightName?: InputMaybe<Array<StringSearch>>;
  outboundFlightNumber?: InputMaybe<Array<IntSearch>>;
  propertyDamage?: InputMaybe<Array<IncidentIssuePropertyDamageEnumSearch>>;
  propertyDamageDescription?: InputMaybe<Array<StringSearch>>;
  recoveryInfo?: InputMaybe<Array<StringSearch>>;
  samsaraCameraWorking?: InputMaybe<Array<IncidentIssueSamsaraCameraWorkingEnumSearch>>;
  station?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
};

export type IncidentIssueWithCache = {
  __typename?: 'IncidentIssueWithCache';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewInfo?: Maybe<Scalars['String']['output']>;
  crewInvolved: IncidentIssueWithCacheCrewInvolvedEnum;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  dispatcherEmployeeId?: Maybe<Scalars['String']['output']>;
  dispatcherFirstName: Scalars['String']['output'];
  dispatcherId: Scalars['String']['output'];
  dispatcherLastName: Scalars['String']['output'];
  driverEmployeeId?: Maybe<Scalars['String']['output']>;
  driverFirstName: Scalars['String']['output'];
  driverId: Scalars['String']['output'];
  driverLastName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  incidentDatetime: Scalars['String']['output'];
  incidentOccurance: IncidentIssueWithCacheIncidentOccuranceEnum;
  incidentOccuranceOther?: Maybe<Scalars['String']['output']>;
  incidentWitnesses?: Maybe<Scalars['String']['output']>;
  managerEmployeeId?: Maybe<Scalars['String']['output']>;
  managerFirstName: Scalars['String']['output'];
  managerId?: Maybe<Scalars['String']['output']>;
  managerLastName: Scalars['String']['output'];
  medicalAttentionType?: Maybe<Scalars['String']['output']>;
  medicalInjuries?: Maybe<IncidentIssueWithCacheMedicalInjuriesEnum>;
  medicalNeeded?: Maybe<IncidentIssueWithCacheMedicalNeededEnum>;
  outboundDatetime?: Maybe<Scalars['String']['output']>;
  outboundFlightName?: Maybe<Scalars['String']['output']>;
  outboundFlightNumber?: Maybe<Scalars['Int']['output']>;
  propertyDamage: IncidentIssueWithCachePropertyDamageEnum;
  propertyDamageDescription?: Maybe<Scalars['String']['output']>;
  recoveryInfo?: Maybe<Scalars['String']['output']>;
  samsaraCameraWorking?: Maybe<IncidentIssueWithCacheSamsaraCameraWorkingEnum>;
  station?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  tripFlightNumber: Scalars['Int']['output'];
  tripId?: Maybe<Scalars['String']['output']>;
  tripLoopName: Scalars['String']['output'];
  tripScheduled: Scalars['String']['output'];
  tripServicerIataAirlineCode: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId: Scalars['String']['output'];
  vehicleTrackingId: Scalars['String']['output'];
};

export type IncidentIssueWithCacheActivityConnection = {
  __typename?: 'IncidentIssueWithCacheActivityConnection';
  edges?: Maybe<Array<Maybe<IncidentIssueWithCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IncidentIssueWithCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type IncidentIssueWithCacheActivityEdge = {
  __typename?: 'IncidentIssueWithCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type IncidentIssueWithCacheConnection = {
  __typename?: 'IncidentIssueWithCacheConnection';
  edges?: Maybe<Array<Maybe<IncidentIssueWithCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IncidentIssueWithCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<IncidentIssueWithCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<IncidentIssueWithCacheSearch>>;
};

export enum IncidentIssueWithCacheCrewInvolvedEnum {
  No = 'NO',
  Yes = 'YES'
}

export type IncidentIssueWithCacheCrewInvolvedEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<IncidentIssueWithCacheCrewInvolvedEnum>;
};

export type IncidentIssueWithCacheEdge = {
  __typename?: 'IncidentIssueWithCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<IncidentIssueWithCache>;
};

export enum IncidentIssueWithCacheIncidentOccuranceEnum {
  Airport = 'AIRPORT',
  Hotel = 'HOTEL',
  Office = 'OFFICE',
  Other = 'OTHER'
}

export type IncidentIssueWithCacheIncidentOccuranceEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<IncidentIssueWithCacheIncidentOccuranceEnum>;
};

export type IncidentIssueWithCacheMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewInfo?: InputMaybe<Scalars['Boolean']['input']>;
  crewInvolved?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherId?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherLastName?: InputMaybe<Scalars['Boolean']['input']>;
  driverEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  driverFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  driverLastName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  incidentDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  incidentOccurance?: InputMaybe<Scalars['Boolean']['input']>;
  incidentOccuranceOther?: InputMaybe<Scalars['Boolean']['input']>;
  incidentWitnesses?: InputMaybe<Scalars['Boolean']['input']>;
  managerEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  managerFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  managerId?: InputMaybe<Scalars['Boolean']['input']>;
  managerLastName?: InputMaybe<Scalars['Boolean']['input']>;
  medicalAttentionType?: InputMaybe<Scalars['Boolean']['input']>;
  medicalInjuries?: InputMaybe<Scalars['Boolean']['input']>;
  medicalNeeded?: InputMaybe<Scalars['Boolean']['input']>;
  outboundDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightName?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  propertyDamage?: InputMaybe<Scalars['Boolean']['input']>;
  propertyDamageDescription?: InputMaybe<Scalars['Boolean']['input']>;
  recoveryInfo?: InputMaybe<Scalars['Boolean']['input']>;
  samsaraCameraWorking?: InputMaybe<Scalars['Boolean']['input']>;
  station?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  tripFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  tripLoopName?: InputMaybe<Scalars['Boolean']['input']>;
  tripScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  tripServicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTrackingId?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum IncidentIssueWithCacheMedicalInjuriesEnum {
  No = 'NO',
  Yes = 'YES'
}

export type IncidentIssueWithCacheMedicalInjuriesEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<IncidentIssueWithCacheMedicalInjuriesEnum>;
};

export enum IncidentIssueWithCacheMedicalNeededEnum {
  No = 'NO',
  Yes = 'YES'
}

export type IncidentIssueWithCacheMedicalNeededEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<IncidentIssueWithCacheMedicalNeededEnum>;
};

export enum IncidentIssueWithCachePropertyDamageEnum {
  No = 'NO',
  Yes = 'YES'
}

export type IncidentIssueWithCachePropertyDamageEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<IncidentIssueWithCachePropertyDamageEnum>;
};

export enum IncidentIssueWithCacheSamsaraCameraWorkingEnum {
  No = 'NO',
  Yes = 'YES'
}

export type IncidentIssueWithCacheSamsaraCameraWorkingEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<IncidentIssueWithCacheSamsaraCameraWorkingEnum>;
};

export type IncidentIssueWithCacheSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewInfo?: InputMaybe<Array<StringSearch>>;
  crewInvolved?: InputMaybe<Array<IncidentIssueWithCacheCrewInvolvedEnumSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  dispatcherEmployeeId?: InputMaybe<Array<StringSearch>>;
  dispatcherFirstName?: InputMaybe<Array<StringSearch>>;
  dispatcherId?: InputMaybe<Array<StringSearch>>;
  dispatcherLastName?: InputMaybe<Array<StringSearch>>;
  driverEmployeeId?: InputMaybe<Array<StringSearch>>;
  driverFirstName?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  driverLastName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  incidentDatetime?: InputMaybe<Array<StringSearch>>;
  incidentOccurance?: InputMaybe<Array<IncidentIssueWithCacheIncidentOccuranceEnumSearch>>;
  incidentOccuranceOther?: InputMaybe<Array<StringSearch>>;
  incidentWitnesses?: InputMaybe<Array<StringSearch>>;
  managerEmployeeId?: InputMaybe<Array<StringSearch>>;
  managerFirstName?: InputMaybe<Array<StringSearch>>;
  managerId?: InputMaybe<Array<StringSearch>>;
  managerLastName?: InputMaybe<Array<StringSearch>>;
  medicalAttentionType?: InputMaybe<Array<StringSearch>>;
  medicalInjuries?: InputMaybe<Array<IncidentIssueWithCacheMedicalInjuriesEnumSearch>>;
  medicalNeeded?: InputMaybe<Array<IncidentIssueWithCacheMedicalNeededEnumSearch>>;
  outboundDatetime?: InputMaybe<Array<StringSearch>>;
  outboundFlightName?: InputMaybe<Array<StringSearch>>;
  outboundFlightNumber?: InputMaybe<Array<IntSearch>>;
  propertyDamage?: InputMaybe<Array<IncidentIssueWithCachePropertyDamageEnumSearch>>;
  propertyDamageDescription?: InputMaybe<Array<StringSearch>>;
  recoveryInfo?: InputMaybe<Array<StringSearch>>;
  samsaraCameraWorking?: InputMaybe<Array<IncidentIssueWithCacheSamsaraCameraWorkingEnumSearch>>;
  station?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  tripFlightNumber?: InputMaybe<Array<IntSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  tripLoopName?: InputMaybe<Array<StringSearch>>;
  tripScheduled?: InputMaybe<Array<StringSearch>>;
  tripServicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  vehicleTrackingId?: InputMaybe<Array<StringSearch>>;
};

export type Index = {
  __typename?: 'Index';
  checkpoint: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type IndexActivityConnection = {
  __typename?: 'IndexActivityConnection';
  edges?: Maybe<Array<Maybe<IndexActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IndexActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type IndexActivityEdge = {
  __typename?: 'IndexActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type IndexConnection = {
  __typename?: 'IndexConnection';
  edges?: Maybe<Array<Maybe<IndexEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IndexConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<IndexMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<IndexSearch>>;
};

export type IndexEdge = {
  __typename?: 'IndexEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Index>;
};

export type IndexMaskInput = {
  checkpoint?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IndexSearch = {
  checkpoint?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum IngestActionEnum {
  Create = 'CREATE',
  Delete = 'DELETE',
  Noop = 'NOOP',
  Not = 'NOT',
  Update = 'UPDATE'
}

export type IngestFlagHasTripInput = {
  flagId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};

export type IngestImportResponse = {
  __typename?: 'IngestImportResponse';
  error?: Maybe<Error>;
  failures?: Maybe<Array<IngestTripError>>;
  id: Scalars['String']['output'];
};

export type IngestTripError = {
  __typename?: 'IngestTripError';
  action?: Maybe<IngestActionEnum>;
  error?: Maybe<Error>;
  id: Scalars['String']['output'];
};

export type IntSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<Scalars['Int']['input']>;
};

export type Invoice = {
  __typename?: 'Invoice';
  airports?: Maybe<Array<Scalars['String']['output']>>;
  chargeType: InvoiceChargeTypeEnum;
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<User>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  documents?: Maybe<Array<InvoiceDocument>>;
  due: Scalars['String']['output'];
  endDatetime: Scalars['String']['output'];
  format: InvoiceFormatEnum;
  grandSubtotal?: Maybe<Scalars['Float']['output']>;
  grandTotal: Scalars['Float']['output'];
  hasDiscounts?: Maybe<Scalars['Int']['output']>;
  id: Scalars['Int']['output'];
  invoiced: Scalars['String']['output'];
  name: Scalars['String']['output'];
  netBillableTrips?: Maybe<Scalars['Int']['output']>;
  payerProviderId: Scalars['String']['output'];
  provider?: Maybe<Provider>;
  startDatetime: Scalars['String']['output'];
  status: InvoiceStatusEnum;
  subTotal?: Maybe<Scalars['Float']['output']>;
  total: Scalars['Float']['output'];
  totalDiscountedTrips?: Maybe<Scalars['Int']['output']>;
  totalSavings?: Maybe<Scalars['Float']['output']>;
  totalTripsBilled?: Maybe<Scalars['Int']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type InvoiceActivityConnection = {
  __typename?: 'InvoiceActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceActivityEdge = {
  __typename?: 'InvoiceActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceAirport = {
  __typename?: 'InvoiceAirport';
  code: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceId: Scalars['Int']['output'];
};

export type InvoiceAirportActivityConnection = {
  __typename?: 'InvoiceAirportActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceAirportActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceAirportActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceAirportActivityEdge = {
  __typename?: 'InvoiceAirportActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceAirportConnection = {
  __typename?: 'InvoiceAirportConnection';
  edges?: Maybe<Array<Maybe<InvoiceAirportEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceAirportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceAirportMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceAirportSearch>>;
};

export type InvoiceAirportEdge = {
  __typename?: 'InvoiceAirportEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceAirport>;
};

export type InvoiceAirportInput = {
  code: Scalars['String']['input'];
};

export type InvoiceAirportMaskInput = {
  code?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceAirportSearch = {
  code?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
};

export type InvoiceAirportSummary = {
  __typename?: 'InvoiceAirportSummary';
  average: Scalars['Float']['output'];
  code: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  rates?: Maybe<Array<Maybe<InvoiceRateSubtotal>>>;
  total: Scalars['Float']['output'];
};

export enum InvoiceChargeTypeEnum {
  CustomCharge = 'CUSTOM_CHARGE',
  Trip = 'TRIP'
}

export type InvoiceChargeTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceChargeTypeEnum>;
};

export type InvoiceClient = {
  __typename?: 'InvoiceClient';
  address?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type InvoiceClientActivityConnection = {
  __typename?: 'InvoiceClientActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceClientActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceClientActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceClientActivityEdge = {
  __typename?: 'InvoiceClientActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceClientConnection = {
  __typename?: 'InvoiceClientConnection';
  edges?: Maybe<Array<Maybe<InvoiceClientEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceClientConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceClientMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceClientSearch>>;
};

export type InvoiceClientEdge = {
  __typename?: 'InvoiceClientEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceClient>;
};

export type InvoiceClientInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};

export type InvoiceClientMaskInput = {
  address?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceClientSearch = {
  address?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type InvoiceConnection = {
  __typename?: 'InvoiceConnection';
  edges?: Maybe<Array<Maybe<InvoiceEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceSearch>>;
};

export type InvoiceCustomCharge = {
  __typename?: 'InvoiceCustomCharge';
  cost: Scalars['Float']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  invoiceId: Scalars['Int']['output'];
  note: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type InvoiceCustomChargeActivityConnection = {
  __typename?: 'InvoiceCustomChargeActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceCustomChargeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceCustomChargeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceCustomChargeActivityEdge = {
  __typename?: 'InvoiceCustomChargeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceCustomChargeConnection = {
  __typename?: 'InvoiceCustomChargeConnection';
  edges?: Maybe<Array<Maybe<InvoiceCustomChargeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceCustomChargeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceCustomChargeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceCustomChargeSearch>>;
};

export type InvoiceCustomChargeEdge = {
  __typename?: 'InvoiceCustomChargeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceCustomCharge>;
};

export type InvoiceCustomChargeInput = {
  cost: Scalars['Float']['input'];
  note: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type InvoiceCustomChargeMaskInput = {
  cost?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceCustomChargeSearch = {
  cost?: InputMaybe<Array<FloatSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  index?: InputMaybe<Array<IntSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
  note?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type InvoiceCustomChargeSummary = {
  __typename?: 'InvoiceCustomChargeSummary';
  charges?: Maybe<Array<InvoiceCustomCharge>>;
  subtotal: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type InvoiceDocument = {
  __typename?: 'InvoiceDocument';
  amendment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  creator?: Maybe<User>;
  fileLocation: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  genDocumentID?: Maybe<Scalars['String']['output']>;
  genDocumentStatus?: Maybe<InvoiceDocumentGenDocumentStatusEnum>;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  invoiceId: Scalars['Int']['output'];
  md5: Scalars['String']['output'];
  sendEmailOnCompletion?: Maybe<Scalars['Int']['output']>;
  sendEmailRecipients?: Maybe<Scalars['String']['output']>;
  sender?: Maybe<User>;
  sentAt?: Maybe<Scalars['String']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
};

export type InvoiceDocumentActivityConnection = {
  __typename?: 'InvoiceDocumentActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceDocumentActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceDocumentActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceDocumentActivityEdge = {
  __typename?: 'InvoiceDocumentActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceDocumentConnection = {
  __typename?: 'InvoiceDocumentConnection';
  edges?: Maybe<Array<Maybe<InvoiceDocumentEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceDocumentConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceDocumentMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceDocumentSearch>>;
};

export type InvoiceDocumentEdge = {
  __typename?: 'InvoiceDocumentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceDocument>;
};

export enum InvoiceDocumentGenDocumentStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InQueue = 'IN_QUEUE',
  Running = 'RUNNING'
}

export type InvoiceDocumentGenDocumentStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceDocumentGenDocumentStatusEnum>;
};

export type InvoiceDocumentMaskInput = {
  amendment?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  genDocumentId?: InputMaybe<Scalars['Boolean']['input']>;
  genDocumentStatus?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmailOnCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmailRecipients?: InputMaybe<Scalars['Boolean']['input']>;
  sentAt?: InputMaybe<Scalars['Boolean']['input']>;
  sentBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceDocumentSearch = {
  amendment?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  genDocumentId?: InputMaybe<Array<StringSearch>>;
  genDocumentStatus?: InputMaybe<Array<InvoiceDocumentGenDocumentStatusEnumSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  index?: InputMaybe<Array<IntSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  sendEmailOnCompletion?: InputMaybe<Array<IntSearch>>;
  sendEmailRecipients?: InputMaybe<Array<StringSearch>>;
  sentAt?: InputMaybe<Array<StringSearch>>;
  sentBy?: InputMaybe<Array<StringSearch>>;
};

export type InvoiceDocumentWithSummary = {
  __typename?: 'InvoiceDocumentWithSummary';
  airlines?: Maybe<Scalars['String']['output']>;
  airports?: Maybe<Scalars['String']['output']>;
  amendment?: Maybe<Scalars['String']['output']>;
  chargeType: InvoiceDocumentWithSummaryChargeTypeEnum;
  clientAddress?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByFirstName: Scalars['String']['output'];
  createdByLastName: Scalars['String']['output'];
  dueDatetime: Scalars['String']['output'];
  emails?: Maybe<Scalars['String']['output']>;
  endDatetime: Scalars['String']['output'];
  fileLocation: Scalars['String']['output'];
  filename: Scalars['String']['output'];
  format: InvoiceDocumentWithSummaryFormatEnum;
  genDocumentId?: Maybe<Scalars['String']['output']>;
  genDocumentStatus?: Maybe<InvoiceDocumentWithSummaryGenDocumentStatusEnum>;
  grandSubtotal?: Maybe<Scalars['Float']['output']>;
  grandTotal: Scalars['Float']['output'];
  headers?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  index: Scalars['Int']['output'];
  invoiceDate: Scalars['String']['output'];
  invoiceDocumentId: Scalars['String']['output'];
  invoiceId: Scalars['Int']['output'];
  lineItemCount?: Maybe<Scalars['Int']['output']>;
  lineItemTotal?: Maybe<Scalars['Float']['output']>;
  md5: Scalars['String']['output'];
  payerProviderDisplayName?: Maybe<Scalars['String']['output']>;
  payerProviderId: Scalars['String']['output'];
  sendEmailOnCompletion?: Maybe<Scalars['Int']['output']>;
  sendEmailRecipients?: Maybe<Scalars['String']['output']>;
  sentAt?: Maybe<Scalars['String']['output']>;
  sentBy?: Maybe<Scalars['String']['output']>;
  sentByFirstName: Scalars['String']['output'];
  sentByLastName: Scalars['String']['output'];
  startDatetime: Scalars['String']['output'];
  status: InvoiceDocumentWithSummaryStatusEnum;
  subtotal?: Maybe<Scalars['Float']['output']>;
  summaryCreatedAt?: Maybe<Scalars['String']['output']>;
  summaryCreatedBy?: Maybe<Scalars['String']['output']>;
  summaryId: Scalars['String']['output'];
  summaryStatus: InvoiceDocumentWithSummarySummaryStatusEnum;
  totalSavings?: Maybe<Scalars['Float']['output']>;
  totalTrips?: Maybe<Scalars['Int']['output']>;
  totalTripsBilled?: Maybe<Scalars['Int']['output']>;
  tripStatuses?: Maybe<Scalars['String']['output']>;
  tripTypes?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
};

export type InvoiceDocumentWithSummaryActivityConnection = {
  __typename?: 'InvoiceDocumentWithSummaryActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceDocumentWithSummaryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceDocumentWithSummaryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceDocumentWithSummaryActivityEdge = {
  __typename?: 'InvoiceDocumentWithSummaryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum InvoiceDocumentWithSummaryChargeTypeEnum {
  CustomCharge = 'CUSTOM_CHARGE',
  Trip = 'TRIP'
}

export type InvoiceDocumentWithSummaryChargeTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceDocumentWithSummaryChargeTypeEnum>;
};

export type InvoiceDocumentWithSummaryConnection = {
  __typename?: 'InvoiceDocumentWithSummaryConnection';
  edges?: Maybe<Array<Maybe<InvoiceDocumentWithSummaryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceDocumentWithSummaryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceDocumentWithSummaryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceDocumentWithSummarySearch>>;
};

export type InvoiceDocumentWithSummaryEdge = {
  __typename?: 'InvoiceDocumentWithSummaryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceDocumentWithSummary>;
};

export enum InvoiceDocumentWithSummaryFormatEnum {
  Crew = 'CREW',
  Standard = 'STANDARD'
}

export type InvoiceDocumentWithSummaryFormatEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceDocumentWithSummaryFormatEnum>;
};

export enum InvoiceDocumentWithSummaryGenDocumentStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InQueue = 'IN_QUEUE',
  Running = 'RUNNING'
}

export type InvoiceDocumentWithSummaryGenDocumentStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceDocumentWithSummaryGenDocumentStatusEnum>;
};

export type InvoiceDocumentWithSummaryMaskInput = {
  airlines?: InputMaybe<Scalars['Boolean']['input']>;
  airports?: InputMaybe<Scalars['Boolean']['input']>;
  amendment?: InputMaybe<Scalars['Boolean']['input']>;
  chargeType?: InputMaybe<Scalars['Boolean']['input']>;
  clientAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clientName?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  createdByFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  createdByLastName?: InputMaybe<Scalars['Boolean']['input']>;
  dueDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  emails?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<Scalars['Boolean']['input']>;
  genDocumentId?: InputMaybe<Scalars['Boolean']['input']>;
  genDocumentStatus?: InputMaybe<Scalars['Boolean']['input']>;
  grandSubtotal?: InputMaybe<Scalars['Boolean']['input']>;
  grandTotal?: InputMaybe<Scalars['Boolean']['input']>;
  headers?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceDate?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceDocumentId?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemCount?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemTotal?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmailOnCompletion?: InputMaybe<Scalars['Boolean']['input']>;
  sendEmailRecipients?: InputMaybe<Scalars['Boolean']['input']>;
  sentAt?: InputMaybe<Scalars['Boolean']['input']>;
  sentBy?: InputMaybe<Scalars['Boolean']['input']>;
  sentByFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  sentByLastName?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  subtotal?: InputMaybe<Scalars['Boolean']['input']>;
  summaryCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  summaryCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  summaryId?: InputMaybe<Scalars['Boolean']['input']>;
  summaryStatus?: InputMaybe<Scalars['Boolean']['input']>;
  totalSavings?: InputMaybe<Scalars['Boolean']['input']>;
  totalTrips?: InputMaybe<Scalars['Boolean']['input']>;
  totalTripsBilled?: InputMaybe<Scalars['Boolean']['input']>;
  tripStatuses?: InputMaybe<Scalars['Boolean']['input']>;
  tripTypes?: InputMaybe<Scalars['Boolean']['input']>;
  uniqueId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceDocumentWithSummarySearch = {
  airlines?: InputMaybe<Array<StringSearch>>;
  airports?: InputMaybe<Array<StringSearch>>;
  amendment?: InputMaybe<Array<StringSearch>>;
  chargeType?: InputMaybe<Array<InvoiceDocumentWithSummaryChargeTypeEnumSearch>>;
  clientAddress?: InputMaybe<Array<StringSearch>>;
  clientName?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  createdByFirstName?: InputMaybe<Array<StringSearch>>;
  createdByLastName?: InputMaybe<Array<StringSearch>>;
  dueDatetime?: InputMaybe<Array<StringSearch>>;
  emails?: InputMaybe<Array<StringSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  format?: InputMaybe<Array<InvoiceDocumentWithSummaryFormatEnumSearch>>;
  genDocumentId?: InputMaybe<Array<StringSearch>>;
  genDocumentStatus?: InputMaybe<Array<InvoiceDocumentWithSummaryGenDocumentStatusEnumSearch>>;
  grandSubtotal?: InputMaybe<Array<FloatSearch>>;
  grandTotal?: InputMaybe<Array<FloatSearch>>;
  headers?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  index?: InputMaybe<Array<IntSearch>>;
  invoiceDate?: InputMaybe<Array<StringSearch>>;
  invoiceDocumentId?: InputMaybe<Array<StringSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
  lineItemCount?: InputMaybe<Array<IntSearch>>;
  lineItemTotal?: InputMaybe<Array<FloatSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  payerProviderDisplayName?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  sendEmailOnCompletion?: InputMaybe<Array<IntSearch>>;
  sendEmailRecipients?: InputMaybe<Array<StringSearch>>;
  sentAt?: InputMaybe<Array<StringSearch>>;
  sentBy?: InputMaybe<Array<StringSearch>>;
  sentByFirstName?: InputMaybe<Array<StringSearch>>;
  sentByLastName?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<InvoiceDocumentWithSummaryStatusEnumSearch>>;
  subtotal?: InputMaybe<Array<FloatSearch>>;
  summaryCreatedAt?: InputMaybe<Array<StringSearch>>;
  summaryCreatedBy?: InputMaybe<Array<StringSearch>>;
  summaryId?: InputMaybe<Array<StringSearch>>;
  summaryStatus?: InputMaybe<Array<InvoiceDocumentWithSummarySummaryStatusEnumSearch>>;
  totalSavings?: InputMaybe<Array<FloatSearch>>;
  totalTrips?: InputMaybe<Array<IntSearch>>;
  totalTripsBilled?: InputMaybe<Array<IntSearch>>;
  tripStatuses?: InputMaybe<Array<StringSearch>>;
  tripTypes?: InputMaybe<Array<StringSearch>>;
  uniqueId?: InputMaybe<Array<StringSearch>>;
};

export enum InvoiceDocumentWithSummaryStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type InvoiceDocumentWithSummaryStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceDocumentWithSummaryStatusEnum>;
};

export enum InvoiceDocumentWithSummarySummaryStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type InvoiceDocumentWithSummarySummaryStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceDocumentWithSummarySummaryStatusEnum>;
};

export type InvoiceEdge = {
  __typename?: 'InvoiceEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Invoice>;
};

export type InvoiceEmail = {
  __typename?: 'InvoiceEmail';
  address: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceId: Scalars['Int']['output'];
};

export type InvoiceEmailActivityConnection = {
  __typename?: 'InvoiceEmailActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceEmailActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceEmailActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceEmailActivityEdge = {
  __typename?: 'InvoiceEmailActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceEmailConnection = {
  __typename?: 'InvoiceEmailConnection';
  edges?: Maybe<Array<Maybe<InvoiceEmailEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceEmailConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceEmailMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceEmailSearch>>;
};

export type InvoiceEmailEdge = {
  __typename?: 'InvoiceEmailEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceEmail>;
};

export type InvoiceEmailInput = {
  address: Scalars['String']['input'];
};

export type InvoiceEmailMaskInput = {
  address?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceEmailSearch = {
  address?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
};

export enum InvoiceFormatEnum {
  Crew = 'CREW',
  Standard = 'STANDARD'
}

export type InvoiceFormatEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceFormatEnum>;
};

export type InvoiceHeader = {
  __typename?: 'InvoiceHeader';
  id: Scalars['String']['output'];
  invoiceId: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type InvoiceHeaderActivityConnection = {
  __typename?: 'InvoiceHeaderActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceHeaderActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceHeaderActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceHeaderActivityEdge = {
  __typename?: 'InvoiceHeaderActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceHeaderConnection = {
  __typename?: 'InvoiceHeaderConnection';
  edges?: Maybe<Array<Maybe<InvoiceHeaderEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceHeaderConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceHeaderMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceHeaderSearch>>;
};

export type InvoiceHeaderEdge = {
  __typename?: 'InvoiceHeaderEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceHeader>;
};

export type InvoiceHeaderInput = {
  name: Scalars['String']['input'];
};

export type InvoiceHeaderMaskInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceHeaderSearch = {
  id?: InputMaybe<Array<StringSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
};

export type InvoiceIataCode = {
  __typename?: 'InvoiceIataCode';
  iataCode: Scalars['String']['output'];
  id: Scalars['String']['output'];
  invoiceId: Scalars['Int']['output'];
};

export type InvoiceIataCodeActivityConnection = {
  __typename?: 'InvoiceIataCodeActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceIataCodeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceIataCodeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceIataCodeActivityEdge = {
  __typename?: 'InvoiceIataCodeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceIataCodeConnection = {
  __typename?: 'InvoiceIataCodeConnection';
  edges?: Maybe<Array<Maybe<InvoiceIataCodeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceIataCodeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceIataCodeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceIataCodeSearch>>;
};

export type InvoiceIataCodeEdge = {
  __typename?: 'InvoiceIataCodeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceIataCode>;
};

export type InvoiceIataCodeInput = {
  iataCode: Scalars['String']['input'];
};

export type InvoiceIataCodeMaskInput = {
  iataCode?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceIataCodeSearch = {
  iataCode?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
};

export type InvoiceInput = {
  airports: Array<InvoiceAirportInput>;
  chargeType: InvoiceChargeTypeEnum;
  client?: InputMaybe<InvoiceClientInput>;
  customCharges?: InputMaybe<Array<InvoiceCustomChargeInput>>;
  due: Scalars['String']['input'];
  emails: Array<InvoiceEmailInput>;
  endDatetime: Scalars['String']['input'];
  format: InvoiceFormatEnum;
  generatePdf?: InputMaybe<Scalars['Boolean']['input']>;
  grandSubtotal?: InputMaybe<Scalars['Float']['input']>;
  grandTotal: Scalars['Float']['input'];
  hasDiscounts?: InputMaybe<Scalars['Int']['input']>;
  headers: Array<InvoiceHeaderInput>;
  iataAirlineCodes?: InputMaybe<Array<InvoiceIataCodeInput>>;
  id?: InputMaybe<Scalars['Int']['input']>;
  invoiced: Scalars['String']['input'];
  items: Array<InvoiceLineItemInput>;
  name: Scalars['String']['input'];
  payerProviderId: Scalars['String']['input'];
  startDatetime: Scalars['String']['input'];
  status?: InputMaybe<InvoiceStatusEnum>;
  subTotal?: InputMaybe<Scalars['Float']['input']>;
  total: Scalars['Float']['input'];
  totalSavings?: InputMaybe<Scalars['Float']['input']>;
  totalTripsBilled?: InputMaybe<Scalars['Int']['input']>;
  tripStatus?: InputMaybe<Array<InvoiceTripStatusInput>>;
  trips?: InputMaybe<Array<InvoiceTripInput>>;
  types: Array<InvoiceTypeInput>;
};

export type InvoiceLineItem = {
  __typename?: 'InvoiceLineItem';
  id: Scalars['String']['output'];
  invoiceId: Scalars['Int']['output'];
  lineItemTypeId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  total?: Maybe<Scalars['Float']['output']>;
};

export type InvoiceLineItemActivityConnection = {
  __typename?: 'InvoiceLineItemActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceLineItemActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceLineItemActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceLineItemActivityEdge = {
  __typename?: 'InvoiceLineItemActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceLineItemConnection = {
  __typename?: 'InvoiceLineItemConnection';
  edges?: Maybe<Array<Maybe<InvoiceLineItemEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceLineItemConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceLineItemMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceLineItemSearch>>;
};

export type InvoiceLineItemEdge = {
  __typename?: 'InvoiceLineItemEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceLineItem>;
};

export type InvoiceLineItemInput = {
  lineItemTypeId: Scalars['String']['input'];
  name: Scalars['String']['input'];
  total?: InputMaybe<Scalars['Float']['input']>;
};

export type InvoiceLineItemMaskInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  total?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceLineItemSearch = {
  id?: InputMaybe<Array<StringSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
  lineItemTypeId?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  total?: InputMaybe<Array<FloatSearch>>;
};

export type InvoiceMaskInput = {
  chargeType?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  due?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<Scalars['Boolean']['input']>;
  grandSubtotal?: InputMaybe<Scalars['Boolean']['input']>;
  grandTotal?: InputMaybe<Scalars['Boolean']['input']>;
  hasDiscounts?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiced?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  netBillableTrips?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  subTotal?: InputMaybe<Scalars['Boolean']['input']>;
  total?: InputMaybe<Scalars['Boolean']['input']>;
  totalDiscountedTrips?: InputMaybe<Scalars['Boolean']['input']>;
  totalSavings?: InputMaybe<Scalars['Boolean']['input']>;
  totalTripsBilled?: InputMaybe<Scalars['Boolean']['input']>;
  uniqueId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceProviderCache = {
  __typename?: 'InvoiceProviderCache';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type InvoiceProviderCacheActivityConnection = {
  __typename?: 'InvoiceProviderCacheActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceProviderCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceProviderCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceProviderCacheActivityEdge = {
  __typename?: 'InvoiceProviderCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceProviderCacheConnection = {
  __typename?: 'InvoiceProviderCacheConnection';
  edges?: Maybe<Array<Maybe<InvoiceProviderCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceProviderCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceProviderCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceProviderCacheSearch>>;
};

export type InvoiceProviderCacheEdge = {
  __typename?: 'InvoiceProviderCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceProviderCache>;
};

export type InvoiceProviderCacheMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceProviderCacheSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type InvoiceRateSubtotal = {
  __typename?: 'InvoiceRateSubtotal';
  amount: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
};

export type InvoiceResponse = {
  __typename?: 'InvoiceResponse';
  airports: Array<InvoiceAirport>;
  client?: Maybe<InvoiceClient>;
  company: Company;
  customCharges?: Maybe<Array<InvoiceCustomCharge>>;
  documents?: Maybe<Array<InvoiceDocument>>;
  emails: Array<InvoiceEmail>;
  headers: Array<InvoiceHeader>;
  iataAirlineCodes?: Maybe<Array<InvoiceIataCode>>;
  invoice: Invoice;
  items: Array<InvoiceLineItem>;
  payerProvider: Provider;
  tripStatus?: Maybe<Array<InvoiceTripStatus>>;
  trips?: Maybe<Array<InvoiceTrip>>;
  types: Array<InvoiceType>;
};

export type InvoiceSearch = {
  chargeType?: InputMaybe<Array<InvoiceChargeTypeEnumSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  due?: InputMaybe<Array<StringSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  format?: InputMaybe<Array<InvoiceFormatEnumSearch>>;
  grandSubtotal?: InputMaybe<Array<FloatSearch>>;
  grandTotal?: InputMaybe<Array<FloatSearch>>;
  hasDiscounts?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<IntSearch>>;
  invoiced?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  netBillableTrips?: InputMaybe<Array<IntSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<InvoiceStatusEnumSearch>>;
  subTotal?: InputMaybe<Array<FloatSearch>>;
  total?: InputMaybe<Array<FloatSearch>>;
  totalDiscountedTrips?: InputMaybe<Array<IntSearch>>;
  totalSavings?: InputMaybe<Array<FloatSearch>>;
  totalTripsBilled?: InputMaybe<Array<IntSearch>>;
  uniqueId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum InvoiceStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type InvoiceStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceStatusEnum>;
};

export type InvoiceSummary = {
  __typename?: 'InvoiceSummary';
  airports?: Maybe<Array<Maybe<InvoiceAirportSummary>>>;
  average: Scalars['Float']['output'];
  client: Scalars['String']['output'];
  clientAddress: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
};

export type InvoiceTerm = {
  __typename?: 'InvoiceTerm';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type InvoiceTermActivityConnection = {
  __typename?: 'InvoiceTermActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceTermActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceTermActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceTermActivityEdge = {
  __typename?: 'InvoiceTermActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceTermConnection = {
  __typename?: 'InvoiceTermConnection';
  edges?: Maybe<Array<Maybe<InvoiceTermEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceTermConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceTermMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceTermSearch>>;
};

export type InvoiceTermEdge = {
  __typename?: 'InvoiceTermEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceTerm>;
};

export type InvoiceTermMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceTermSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type InvoiceTotalSummary = {
  __typename?: 'InvoiceTotalSummary';
  airlines?: Maybe<Scalars['String']['output']>;
  airports?: Maybe<Scalars['String']['output']>;
  chargeType: InvoiceTotalSummaryChargeTypeEnum;
  clientAddress?: Maybe<Scalars['String']['output']>;
  clientName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dueDatetime: Scalars['String']['output'];
  emails?: Maybe<Scalars['String']['output']>;
  endDatetime: Scalars['String']['output'];
  format: InvoiceTotalSummaryFormatEnum;
  grandSubtotal?: Maybe<Scalars['Float']['output']>;
  grandTotal: Scalars['Float']['output'];
  headers?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  invoiceDate: Scalars['String']['output'];
  invoiceDocumentId: Scalars['String']['output'];
  invoiceId: Scalars['Int']['output'];
  lineItemCount?: Maybe<Scalars['Int']['output']>;
  lineItemTotal?: Maybe<Scalars['Float']['output']>;
  payerProviderId: Scalars['String']['output'];
  startDatetime: Scalars['String']['output'];
  status: InvoiceTotalSummaryStatusEnum;
  subtotal?: Maybe<Scalars['Float']['output']>;
  totalSavings?: Maybe<Scalars['Float']['output']>;
  totalTrips?: Maybe<Scalars['Int']['output']>;
  totalTripsBilled?: Maybe<Scalars['Int']['output']>;
  tripStatuses?: Maybe<Scalars['String']['output']>;
  tripTypes?: Maybe<Scalars['String']['output']>;
  uniqueId?: Maybe<Scalars['String']['output']>;
};

export type InvoiceTotalSummaryActivityConnection = {
  __typename?: 'InvoiceTotalSummaryActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceTotalSummaryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceTotalSummaryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceTotalSummaryActivityEdge = {
  __typename?: 'InvoiceTotalSummaryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum InvoiceTotalSummaryChargeTypeEnum {
  CustomCharge = 'CUSTOM_CHARGE',
  Trip = 'TRIP'
}

export type InvoiceTotalSummaryChargeTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceTotalSummaryChargeTypeEnum>;
};

export type InvoiceTotalSummaryConnection = {
  __typename?: 'InvoiceTotalSummaryConnection';
  edges?: Maybe<Array<Maybe<InvoiceTotalSummaryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceTotalSummaryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceTotalSummaryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceTotalSummarySearch>>;
};

export type InvoiceTotalSummaryEdge = {
  __typename?: 'InvoiceTotalSummaryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceTotalSummary>;
};

export enum InvoiceTotalSummaryFormatEnum {
  Crew = 'CREW',
  Standard = 'STANDARD'
}

export type InvoiceTotalSummaryFormatEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceTotalSummaryFormatEnum>;
};

export type InvoiceTotalSummaryMaskInput = {
  airlines?: InputMaybe<Scalars['Boolean']['input']>;
  airports?: InputMaybe<Scalars['Boolean']['input']>;
  chargeType?: InputMaybe<Scalars['Boolean']['input']>;
  clientAddress?: InputMaybe<Scalars['Boolean']['input']>;
  clientName?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  dueDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  emails?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  format?: InputMaybe<Scalars['Boolean']['input']>;
  grandSubtotal?: InputMaybe<Scalars['Boolean']['input']>;
  grandTotal?: InputMaybe<Scalars['Boolean']['input']>;
  headers?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceDate?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceDocumentId?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemCount?: InputMaybe<Scalars['Boolean']['input']>;
  lineItemTotal?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  subtotal?: InputMaybe<Scalars['Boolean']['input']>;
  totalSavings?: InputMaybe<Scalars['Boolean']['input']>;
  totalTrips?: InputMaybe<Scalars['Boolean']['input']>;
  totalTripsBilled?: InputMaybe<Scalars['Boolean']['input']>;
  tripStatuses?: InputMaybe<Scalars['Boolean']['input']>;
  tripTypes?: InputMaybe<Scalars['Boolean']['input']>;
  uniqueId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceTotalSummarySearch = {
  airlines?: InputMaybe<Array<StringSearch>>;
  airports?: InputMaybe<Array<StringSearch>>;
  chargeType?: InputMaybe<Array<InvoiceTotalSummaryChargeTypeEnumSearch>>;
  clientAddress?: InputMaybe<Array<StringSearch>>;
  clientName?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  dueDatetime?: InputMaybe<Array<StringSearch>>;
  emails?: InputMaybe<Array<StringSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  format?: InputMaybe<Array<InvoiceTotalSummaryFormatEnumSearch>>;
  grandSubtotal?: InputMaybe<Array<FloatSearch>>;
  grandTotal?: InputMaybe<Array<FloatSearch>>;
  headers?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  invoiceDate?: InputMaybe<Array<StringSearch>>;
  invoiceDocumentId?: InputMaybe<Array<StringSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
  lineItemCount?: InputMaybe<Array<IntSearch>>;
  lineItemTotal?: InputMaybe<Array<FloatSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<InvoiceTotalSummaryStatusEnumSearch>>;
  subtotal?: InputMaybe<Array<FloatSearch>>;
  totalSavings?: InputMaybe<Array<FloatSearch>>;
  totalTrips?: InputMaybe<Array<IntSearch>>;
  totalTripsBilled?: InputMaybe<Array<IntSearch>>;
  tripStatuses?: InputMaybe<Array<StringSearch>>;
  tripTypes?: InputMaybe<Array<StringSearch>>;
  uniqueId?: InputMaybe<Array<StringSearch>>;
};

export enum InvoiceTotalSummaryStatusEnum {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED'
}

export type InvoiceTotalSummaryStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceTotalSummaryStatusEnum>;
};

export type InvoiceTrip = {
  __typename?: 'InvoiceTrip';
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  combineId?: Maybe<Scalars['String']['output']>;
  combineType?: Maybe<InvoiceTripCombineTypeEnum>;
  createdAt?: Maybe<Scalars['String']['output']>;
  crewId?: Maybe<Scalars['Int']['output']>;
  currency?: Maybe<InvoiceTripCurrencyEnum>;
  discount: Scalars['Float']['output'];
  doLocation: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  flightNumber: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  importTime?: Maybe<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
  invoiceId: Scalars['Int']['output'];
  kind: InvoiceTripKindEnum;
  lastName?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  pilots: Scalars['Int']['output'];
  puLocation: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  rateId: Scalars['String']['output'];
  savings?: Maybe<Scalars['Float']['output']>;
  scheduled: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  status: InvoiceTripStatusEnum;
  tripId: Scalars['String']['output'];
  type: InvoiceTripTypeEnum;
};

export type InvoiceTripActivityConnection = {
  __typename?: 'InvoiceTripActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceTripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceTripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceTripActivityEdge = {
  __typename?: 'InvoiceTripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum InvoiceTripCombineTypeEnum {
  Illegal = 'ILLEGAL',
  IllegalOverCapacity = 'ILLEGAL_OVER_CAPACITY',
  Legal = 'LEGAL',
  LegalOverCapacity = 'LEGAL_OVER_CAPACITY'
}

export type InvoiceTripCombineTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceTripCombineTypeEnum>;
};

export type InvoiceTripConnection = {
  __typename?: 'InvoiceTripConnection';
  edges?: Maybe<Array<Maybe<InvoiceTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceTripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceTripSearch>>;
};

export enum InvoiceTripCurrencyEnum {
  Usd = 'USD'
}

export type InvoiceTripCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceTripCurrencyEnum>;
};

export type InvoiceTripEdge = {
  __typename?: 'InvoiceTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceTrip>;
};

export type InvoiceTripInput = {
  index: Scalars['Int']['input'];
  rate: Scalars['Float']['input'];
  tripId: Scalars['String']['input'];
};

export enum InvoiceTripKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type InvoiceTripKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceTripKindEnum>;
};

export type InvoiceTripMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  combineType?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  crewId?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  discount?: InputMaybe<Scalars['Boolean']['input']>;
  doLocation?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importTime?: InputMaybe<Scalars['Boolean']['input']>;
  index?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  puLocation?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
  rateId?: InputMaybe<Scalars['Boolean']['input']>;
  savings?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceTripSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  combineType?: InputMaybe<Array<InvoiceTripCombineTypeEnumSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  crewId?: InputMaybe<Array<IntSearch>>;
  currency?: InputMaybe<Array<InvoiceTripCurrencyEnumSearch>>;
  discount?: InputMaybe<Array<FloatSearch>>;
  doLocation?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importTime?: InputMaybe<Array<StringSearch>>;
  index?: InputMaybe<Array<IntSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
  kind?: InputMaybe<Array<InvoiceTripKindEnumSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  puLocation?: InputMaybe<Array<StringSearch>>;
  rate?: InputMaybe<Array<FloatSearch>>;
  rateId?: InputMaybe<Array<StringSearch>>;
  savings?: InputMaybe<Array<FloatSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<InvoiceTripStatusEnumSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<InvoiceTripTypeEnumSearch>>;
};

export type InvoiceTripStatus = {
  __typename?: 'InvoiceTripStatus';
  id: Scalars['String']['output'];
  invoiceId: Scalars['Int']['output'];
  status: InvoiceTripStatusStatusEnum;
};

export type InvoiceTripStatusActivityConnection = {
  __typename?: 'InvoiceTripStatusActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceTripStatusActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceTripStatusActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceTripStatusActivityEdge = {
  __typename?: 'InvoiceTripStatusActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceTripStatusConnection = {
  __typename?: 'InvoiceTripStatusConnection';
  edges?: Maybe<Array<Maybe<InvoiceTripStatusEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceTripStatusConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceTripStatusMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceTripStatusSearch>>;
};

export type InvoiceTripStatusEdge = {
  __typename?: 'InvoiceTripStatusEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceTripStatus>;
};

export enum InvoiceTripStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type InvoiceTripStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceTripStatusEnum>;
};

export type InvoiceTripStatusInput = {
  status: TripStatusEnum;
};

export type InvoiceTripStatusMaskInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceTripStatusSearch = {
  id?: InputMaybe<Array<StringSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
  status?: InputMaybe<Array<InvoiceTripStatusStatusEnumSearch>>;
};

export enum InvoiceTripStatusStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type InvoiceTripStatusStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceTripStatusStatusEnum>;
};

export enum InvoiceTripTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type InvoiceTripTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceTripTypeEnum>;
};

export type InvoiceType = {
  __typename?: 'InvoiceType';
  id: Scalars['String']['output'];
  invoiceId: Scalars['Int']['output'];
  type: InvoiceTypeTypeEnum;
};

export type InvoiceTypeActivityConnection = {
  __typename?: 'InvoiceTypeActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceTypeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceTypeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceTypeActivityEdge = {
  __typename?: 'InvoiceTypeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceTypeConnection = {
  __typename?: 'InvoiceTypeConnection';
  edges?: Maybe<Array<Maybe<InvoiceTypeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceTypeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceTypeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceTypeSearch>>;
};

export type InvoiceTypeEdge = {
  __typename?: 'InvoiceTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceType>;
};

export type InvoiceTypeInput = {
  type: InvoiceTypeTypeEnum;
};

export type InvoiceTypeMaskInput = {
  id?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceTypeSearch = {
  id?: InputMaybe<Array<StringSearch>>;
  invoiceId?: InputMaybe<Array<IntSearch>>;
  type?: InputMaybe<Array<InvoiceTypeTypeEnumSearch>>;
};

export enum InvoiceTypeTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type InvoiceTypeTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<InvoiceTypeTypeEnum>;
};

export type InvoiceUserCache = {
  __typename?: 'InvoiceUserCache';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type InvoiceUserCacheActivityConnection = {
  __typename?: 'InvoiceUserCacheActivityConnection';
  edges?: Maybe<Array<Maybe<InvoiceUserCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceUserCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type InvoiceUserCacheActivityEdge = {
  __typename?: 'InvoiceUserCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type InvoiceUserCacheConnection = {
  __typename?: 'InvoiceUserCacheConnection';
  edges?: Maybe<Array<Maybe<InvoiceUserCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type InvoiceUserCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<InvoiceUserCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<InvoiceUserCacheSearch>>;
};

export type InvoiceUserCacheEdge = {
  __typename?: 'InvoiceUserCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<InvoiceUserCache>;
};

export type InvoiceUserCacheMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type InvoiceUserCacheSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type Issue = Node & {
  __typename?: 'Issue';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['String']['output'];
  driverId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  message: Scalars['String']['output'];
  tripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type IssueActivityConnection = {
  __typename?: 'IssueActivityConnection';
  edges?: Maybe<Array<Maybe<IssueActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IssueActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type IssueActivityEdge = {
  __typename?: 'IssueActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type IssueConnection = {
  __typename?: 'IssueConnection';
  edges?: Maybe<Array<Maybe<IssueEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type IssueConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<IssueMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<IssueSearch>>;
};

export type IssueDownloadUrlObject = {
  __typename?: 'IssueDownloadURLObject';
  contentType?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['String']['output'];
  error?: Maybe<Error>;
  issueId: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type IssueEdge = {
  __typename?: 'IssueEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Issue>;
};

export type IssueMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IssueSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  message?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum IssueTypeEnum {
  Accident = 'ACCIDENT',
  Dispatch = 'DISPATCH',
  Incident = 'INCIDENT',
  LostAndFound = 'LOST_AND_FOUND'
}

export type JobLookupDriverAppInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  airportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  completionStatus?: InputMaybe<CompletionStatusEnum>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  format?: InputMaybe<JobLookupFormatEnum>;
  formatType?: InputMaybe<Scalars['String']['input']>;
  scheduledEndTime?: InputMaybe<Scalars['String']['input']>;
  scheduledStartTime?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export enum JobLookupFormatEnum {
  Completed = 'COMPLETED',
  Myjobs = 'MYJOBS',
  NotCompleted = 'NOT_COMPLETED',
  Unassigned = 'UNASSIGNED'
}

export type KeyValue = {
  __typename?: 'KeyValue';
  description: Scalars['String']['output'];
  display?: Maybe<Array<StyledValue>>;
  key: Scalars['String']['output'];
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export enum KindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type LatestRate = {
  __typename?: 'LatestRate';
  airportCode?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: LatestRateCurrencyEnum;
  duration?: Maybe<Scalars['Int']['output']>;
  endDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  payerProvider?: Maybe<Provider>;
  payerProviderId?: Maybe<Scalars['String']['output']>;
  rate: Scalars['Float']['output'];
  rateHistoryId: Scalars['String']['output'];
  rateItemId: Scalars['String']['output'];
  startDatetime: Scalars['String']['output'];
  thatLocation?: Maybe<Location>;
  thatLocationId: Scalars['String']['output'];
  thisLocation?: Maybe<Location>;
  thisLocationId: Scalars['String']['output'];
  tripDistance?: Maybe<Scalars['Int']['output']>;
  type: LatestRateTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LatestRateActivityConnection = {
  __typename?: 'LatestRateActivityConnection';
  edges?: Maybe<Array<Maybe<LatestRateActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LatestRateActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type LatestRateActivityEdge = {
  __typename?: 'LatestRateActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type LatestRateConnection = {
  __typename?: 'LatestRateConnection';
  edges?: Maybe<Array<Maybe<LatestRateEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LatestRateConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LatestRateMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<LatestRateSearch>>;
};

export enum LatestRateCurrencyEnum {
  Usd = 'USD'
}

export type LatestRateCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<LatestRateCurrencyEnum>;
};

export type LatestRateEdge = {
  __typename?: 'LatestRateEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<LatestRate>;
};

export type LatestRateHistory = {
  __typename?: 'LatestRateHistory';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: LatestRateHistoryCurrencyEnum;
  endDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  rateGroupId: Scalars['String']['output'];
  rateItemId?: Maybe<Scalars['String']['output']>;
  rn?: Maybe<Scalars['String']['output']>;
  startDatetime?: Maybe<Scalars['String']['output']>;
  type: LatestRateHistoryTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LatestRateHistoryActivityConnection = {
  __typename?: 'LatestRateHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<LatestRateHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LatestRateHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type LatestRateHistoryActivityEdge = {
  __typename?: 'LatestRateHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type LatestRateHistoryConnection = {
  __typename?: 'LatestRateHistoryConnection';
  edges?: Maybe<Array<Maybe<LatestRateHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LatestRateHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LatestRateHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<LatestRateHistorySearch>>;
};

export enum LatestRateHistoryCurrencyEnum {
  Usd = 'USD'
}

export type LatestRateHistoryCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<LatestRateHistoryCurrencyEnum>;
};

export type LatestRateHistoryEdge = {
  __typename?: 'LatestRateHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<LatestRateHistory>;
};

export type LatestRateHistoryMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
  rateGroupId?: InputMaybe<Scalars['Boolean']['input']>;
  rateItemId?: InputMaybe<Scalars['Boolean']['input']>;
  rn?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LatestRateHistorySearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  currency?: InputMaybe<Array<LatestRateHistoryCurrencyEnumSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  rate?: InputMaybe<Array<FloatSearch>>;
  rateGroupId?: InputMaybe<Array<StringSearch>>;
  rateItemId?: InputMaybe<Array<StringSearch>>;
  rn?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<LatestRateHistoryTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum LatestRateHistoryTypeEnum {
  Adhoc = 'ADHOC',
  Contract = 'CONTRACT',
  NonContract = 'NON_CONTRACT',
  Override = 'OVERRIDE'
}

export type LatestRateHistoryTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<LatestRateHistoryTypeEnum>;
};

export type LatestRateMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
  rateHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  rateItemId?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  thatLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  thisLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  tripDistance?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LatestRateSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  currency?: InputMaybe<Array<LatestRateCurrencyEnumSearch>>;
  duration?: InputMaybe<Array<IntSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  rate?: InputMaybe<Array<FloatSearch>>;
  rateHistoryId?: InputMaybe<Array<StringSearch>>;
  rateItemId?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  thatLocationId?: InputMaybe<Array<StringSearch>>;
  thisLocationId?: InputMaybe<Array<StringSearch>>;
  tripDistance?: InputMaybe<Array<IntSearch>>;
  type?: InputMaybe<Array<LatestRateTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum LatestRateTypeEnum {
  Contract = 'CONTRACT',
  NonContract = 'NON_CONTRACT'
}

export type LatestRateTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<LatestRateTypeEnum>;
};

export type Leaderboard = Node & {
  __typename?: 'Leaderboard';
  avatar: Scalars['String']['output'];
  bubbleName: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  markets?: Maybe<Array<Scalars['String']['output']>>;
  ranking: LeaderboardRanking;
  userId: Scalars['String']['output'];
};

export type LeaderboardDriverAppInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  airportCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  groupBy: Scalars['String']['input'];
  rankingType?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['String']['input']>;
};

export type LeaderboardDriverAppResponse = {
  __typename?: 'LeaderboardDriverAppResponse';
  edges?: Maybe<Array<Maybe<LeaderboardEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LeaderboardEdge = {
  __typename?: 'LeaderboardEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Leaderboard>;
};

export type LeaderboardRanking = {
  __typename?: 'LeaderboardRanking';
  arrowUp?: Maybe<Scalars['Boolean']['output']>;
  percentage?: Maybe<Scalars['Int']['output']>;
  percentageLong?: Maybe<Scalars['Float']['output']>;
  tripsTotal?: Maybe<Scalars['Int']['output']>;
};

export type License = {
  __typename?: 'License';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  licenseTypeId: Scalars['String']['output'];
  number: Scalars['String']['output'];
  stateCode: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type LicenseActivityConnection = {
  __typename?: 'LicenseActivityConnection';
  edges?: Maybe<Array<Maybe<LicenseActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LicenseActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type LicenseActivityEdge = {
  __typename?: 'LicenseActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type LicenseConnection = {
  __typename?: 'LicenseConnection';
  edges?: Maybe<Array<Maybe<LicenseEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LicenseConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LicenseMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<LicenseSearch>>;
};

export type LicenseEdge = {
  __typename?: 'LicenseEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<License>;
};

export type LicenseMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  expirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  licenseTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LicenseSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  expirationDate?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  licenseTypeId?: InputMaybe<Array<StringSearch>>;
  number?: InputMaybe<Array<StringSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type LicenseType = {
  __typename?: 'LicenseType';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LicenseTypeActivityConnection = {
  __typename?: 'LicenseTypeActivityConnection';
  edges?: Maybe<Array<Maybe<LicenseTypeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LicenseTypeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type LicenseTypeActivityEdge = {
  __typename?: 'LicenseTypeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type LicenseTypeConnection = {
  __typename?: 'LicenseTypeConnection';
  edges?: Maybe<Array<Maybe<LicenseTypeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LicenseTypeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LicenseTypeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<LicenseTypeSearch>>;
};

export type LicenseTypeEdge = {
  __typename?: 'LicenseTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<LicenseType>;
};

export type LicenseTypeMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LicenseTypeSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type LineItemType = {
  __typename?: 'LineItemType';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LineItemTypeActivityConnection = {
  __typename?: 'LineItemTypeActivityConnection';
  edges?: Maybe<Array<Maybe<LineItemTypeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LineItemTypeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type LineItemTypeActivityEdge = {
  __typename?: 'LineItemTypeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type LineItemTypeConnection = {
  __typename?: 'LineItemTypeConnection';
  edges?: Maybe<Array<Maybe<LineItemTypeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LineItemTypeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LineItemTypeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<LineItemTypeSearch>>;
};

export type LineItemTypeEdge = {
  __typename?: 'LineItemTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<LineItemType>;
};

export type LineItemTypeMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LineItemTypeSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type Location = Node & {
  __typename?: 'Location';
  active: Scalars['Int']['output'];
  address: Scalars['String']['output'];
  airports?: Maybe<Array<AirportHasLocation>>;
  aliases?: Maybe<Array<Alias>>;
  cityName?: Maybe<Scalars['String']['output']>;
  coordinates: Point;
  countryCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  legacyId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  pickupPoints?: Maybe<Array<PickupPoint>>;
  primaryAirportCode?: Maybe<Scalars['String']['output']>;
  punchPolicies?: Maybe<Array<PunchPolicy>>;
  radius: Scalars['Int']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  type: LocationTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type LocationActivityConnection = {
  __typename?: 'LocationActivityConnection';
  edges?: Maybe<Array<Maybe<LocationActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type LocationActivityEdge = {
  __typename?: 'LocationActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type LocationConnection = {
  __typename?: 'LocationConnection';
  edges?: Maybe<Array<Maybe<LocationEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LocationMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<LocationSearch>>;
};

export type LocationEdge = {
  __typename?: 'LocationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Location>;
};

export type LocationInput = {
  address: Scalars['String']['input'];
  airportCodes: Array<Scalars['String']['input']>;
  aliases: Array<Scalars['String']['input']>;
  cityName: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  lat: Scalars['Float']['input'];
  lon: Scalars['Float']['input'];
  name: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  stateCode: Scalars['String']['input'];
  type: LocationTypeEnum;
  zipCode: Scalars['String']['input'];
};

export type LocationMap = {
  locationId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};

export type LocationMapping = {
  dtrLocationId: Scalars['ID']['input'];
  dtrLocationName: Scalars['String']['input'];
};

export type LocationMappingInput = {
  locationId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};

export type LocationMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  radius?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationResponse = {
  __typename?: 'LocationResponse';
  error?: Maybe<Scalars['String']['output']>;
  location: Location;
};

export type LocationSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  address?: InputMaybe<Array<StringSearch>>;
  cityName?: InputMaybe<Array<StringSearch>>;
  coordinates?: InputMaybe<Array<PointSearch>>;
  countryCode?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  legacyId?: InputMaybe<Array<IntSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  phoneNumber?: InputMaybe<Array<StringSearch>>;
  primaryAirportCode?: InputMaybe<Array<StringSearch>>;
  radius?: InputMaybe<Array<IntSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<LocationTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  zipCode?: InputMaybe<Array<StringSearch>>;
};

export enum LocationTypeEnum {
  Airport = 'AIRPORT',
  Exchange = 'EXCHANGE',
  Hotel = 'HOTEL'
}

export type LocationTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<LocationTypeEnum>;
};

export type LocationWithAirportAndAlias = {
  __typename?: 'LocationWithAirportAndAlias';
  active: Scalars['Int']['output'];
  address: Scalars['String']['output'];
  airportCode: Scalars['String']['output'];
  alias: Scalars['String']['output'];
  aliasCreatedAt?: Maybe<Scalars['String']['output']>;
  aliasCreatedBy?: Maybe<Scalars['String']['output']>;
  aliasId: Scalars['String']['output'];
  aliasUpdatedAt?: Maybe<Scalars['String']['output']>;
  aliasUpdatedBy?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  coordinates: Point;
  countryCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legacyId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primaryAirportCode?: Maybe<Scalars['String']['output']>;
  radius: Scalars['Int']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  type: LocationWithAirportAndAliasTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type LocationWithAirportAndAliasActivityConnection = {
  __typename?: 'LocationWithAirportAndAliasActivityConnection';
  edges?: Maybe<Array<Maybe<LocationWithAirportAndAliasActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationWithAirportAndAliasActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type LocationWithAirportAndAliasActivityEdge = {
  __typename?: 'LocationWithAirportAndAliasActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type LocationWithAirportAndAliasConnection = {
  __typename?: 'LocationWithAirportAndAliasConnection';
  edges?: Maybe<Array<Maybe<LocationWithAirportAndAliasEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationWithAirportAndAliasConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LocationWithAirportAndAliasMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<LocationWithAirportAndAliasSearch>>;
};

export type LocationWithAirportAndAliasEdge = {
  __typename?: 'LocationWithAirportAndAliasEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<LocationWithAirportAndAlias>;
};

export type LocationWithAirportAndAliasMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['Boolean']['input']>;
  aliasCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  aliasCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  aliasId?: InputMaybe<Scalars['Boolean']['input']>;
  aliasUpdatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  aliasUpdatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  radius?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationWithAirportAndAliasSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  address?: InputMaybe<Array<StringSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  alias?: InputMaybe<Array<StringSearch>>;
  aliasCreatedAt?: InputMaybe<Array<StringSearch>>;
  aliasCreatedBy?: InputMaybe<Array<StringSearch>>;
  aliasId?: InputMaybe<Array<StringSearch>>;
  aliasUpdatedAt?: InputMaybe<Array<StringSearch>>;
  aliasUpdatedBy?: InputMaybe<Array<StringSearch>>;
  cityName?: InputMaybe<Array<StringSearch>>;
  coordinates?: InputMaybe<Array<PointSearch>>;
  countryCode?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  legacyId?: InputMaybe<Array<IntSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  phoneNumber?: InputMaybe<Array<StringSearch>>;
  primaryAirportCode?: InputMaybe<Array<StringSearch>>;
  radius?: InputMaybe<Array<IntSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<LocationWithAirportAndAliasTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  zipCode?: InputMaybe<Array<StringSearch>>;
};

export enum LocationWithAirportAndAliasTypeEnum {
  Airport = 'AIRPORT',
  Exchange = 'EXCHANGE',
  Hotel = 'HOTEL'
}

export type LocationWithAirportAndAliasTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<LocationWithAirportAndAliasTypeEnum>;
};

export type LocationWithPunchPolicy = {
  __typename?: 'LocationWithPunchPolicy';
  active: Scalars['Int']['output'];
  address: Scalars['String']['output'];
  airportCode: Scalars['String']['output'];
  cityName?: Maybe<Scalars['String']['output']>;
  coordinates: Point;
  countryCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  eventEndDatetime?: Maybe<Scalars['String']['output']>;
  eventStartDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  legacyId?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  primaryAirportCode?: Maybe<Scalars['String']['output']>;
  punchPolicyCompanyId: Scalars['String']['output'];
  punchPolicyCreatedAt?: Maybe<Scalars['String']['output']>;
  punchPolicyCreatedBy?: Maybe<Scalars['String']['output']>;
  punchPolicyId: Scalars['String']['output'];
  punchPolicyMinutesIn: Scalars['Int']['output'];
  punchPolicyMinutesOut: Scalars['Int']['output'];
  punchPolicyUpdatedAt?: Maybe<Scalars['String']['output']>;
  punchPolicyUpdatedBy?: Maybe<Scalars['String']['output']>;
  radius: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
  stateCode?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  type: LocationWithPunchPolicyTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type LocationWithPunchPolicyActivityConnection = {
  __typename?: 'LocationWithPunchPolicyActivityConnection';
  edges?: Maybe<Array<Maybe<LocationWithPunchPolicyActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationWithPunchPolicyActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type LocationWithPunchPolicyActivityEdge = {
  __typename?: 'LocationWithPunchPolicyActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type LocationWithPunchPolicyConnection = {
  __typename?: 'LocationWithPunchPolicyConnection';
  edges?: Maybe<Array<Maybe<LocationWithPunchPolicyEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LocationWithPunchPolicyConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LocationWithPunchPolicyMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<LocationWithPunchPolicySearch>>;
};

export type LocationWithPunchPolicyEdge = {
  __typename?: 'LocationWithPunchPolicyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<LocationWithPunchPolicy>;
};

export type LocationWithPunchPolicyMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Boolean']['input']>;
  eventEndDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  eventStartDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  punchPolicyCompanyId?: InputMaybe<Scalars['Boolean']['input']>;
  punchPolicyCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  punchPolicyCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  punchPolicyId?: InputMaybe<Scalars['Boolean']['input']>;
  punchPolicyMinutesIn?: InputMaybe<Scalars['Boolean']['input']>;
  punchPolicyMinutesOut?: InputMaybe<Scalars['Boolean']['input']>;
  punchPolicyUpdatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  punchPolicyUpdatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  radius?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LocationWithPunchPolicySearch = {
  active?: InputMaybe<Array<IntSearch>>;
  address?: InputMaybe<Array<StringSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  cityName?: InputMaybe<Array<StringSearch>>;
  coordinates?: InputMaybe<Array<PointSearch>>;
  countryCode?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  endTime?: InputMaybe<Array<StringSearch>>;
  eventEndDatetime?: InputMaybe<Array<StringSearch>>;
  eventStartDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  legacyId?: InputMaybe<Array<IntSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  phoneNumber?: InputMaybe<Array<StringSearch>>;
  primaryAirportCode?: InputMaybe<Array<StringSearch>>;
  punchPolicyCompanyId?: InputMaybe<Array<StringSearch>>;
  punchPolicyCreatedAt?: InputMaybe<Array<StringSearch>>;
  punchPolicyCreatedBy?: InputMaybe<Array<StringSearch>>;
  punchPolicyId?: InputMaybe<Array<StringSearch>>;
  punchPolicyMinutesIn?: InputMaybe<Array<IntSearch>>;
  punchPolicyMinutesOut?: InputMaybe<Array<IntSearch>>;
  punchPolicyUpdatedAt?: InputMaybe<Array<StringSearch>>;
  punchPolicyUpdatedBy?: InputMaybe<Array<StringSearch>>;
  radius?: InputMaybe<Array<IntSearch>>;
  startTime?: InputMaybe<Array<StringSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<LocationWithPunchPolicyTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  zipCode?: InputMaybe<Array<StringSearch>>;
};

export enum LocationWithPunchPolicyTypeEnum {
  Airport = 'AIRPORT',
  Exchange = 'EXCHANGE',
  Hotel = 'HOTEL'
}

export type LocationWithPunchPolicyTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<LocationWithPunchPolicyTypeEnum>;
};

export type LoginEvent = {
  __typename?: 'LoginEvent';
  cityName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  datetime?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  ipAddress?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userAgent?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type LoginEventActivityConnection = {
  __typename?: 'LoginEventActivityConnection';
  edges?: Maybe<Array<Maybe<LoginEventActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LoginEventActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type LoginEventActivityEdge = {
  __typename?: 'LoginEventActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type LoginEventConnection = {
  __typename?: 'LoginEventConnection';
  edges?: Maybe<Array<Maybe<LoginEventEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LoginEventConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LoginEventMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<LoginEventSearch>>;
};

export type LoginEventEdge = {
  __typename?: 'LoginEventEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<LoginEvent>;
};

export type LoginEventMaskInput = {
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  datetime?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  ipAddress?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userAgent?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LoginEventSearch = {
  cityName?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  datetime?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  ipAddress?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userAgent?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type LoginInput = {
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
};

export type LoginResponse = {
  __typename?: 'LoginResponse';
  token: Scalars['String']['output'];
  user: User;
};

export type LostAndFoundIssue = {
  __typename?: 'LostAndFoundIssue';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewAirportCode?: Maybe<Scalars['String']['output']>;
  crewDriverName?: Maybe<Scalars['String']['output']>;
  crewFlightName?: Maybe<Scalars['String']['output']>;
  crewFlightNumber?: Maybe<Scalars['Int']['output']>;
  crewMemberEmail?: Maybe<Scalars['String']['output']>;
  crewMemberName: Scalars['String']['output'];
  crewMemberPhone: Scalars['String']['output'];
  datetime?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  dispatcherId?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  itemLost?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundDatetime?: Maybe<Scalars['String']['output']>;
  outboundFlightName?: Maybe<Scalars['String']['output']>;
  outboundFlightNumber?: Maybe<Scalars['Int']['output']>;
  returnStatus?: Maybe<LostAndFoundIssueReturnStatusEnum>;
  shippingAddress?: Maybe<Scalars['String']['output']>;
  shippingCity?: Maybe<Scalars['String']['output']>;
  shippingCost?: Maybe<Scalars['Float']['output']>;
  shippingMethod?: Maybe<Scalars['String']['output']>;
  shippingStateCode?: Maybe<Scalars['String']['output']>;
  shippingZipCode?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  tripId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
};

export type LostAndFoundIssueActivityConnection = {
  __typename?: 'LostAndFoundIssueActivityConnection';
  edges?: Maybe<Array<Maybe<LostAndFoundIssueActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LostAndFoundIssueActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type LostAndFoundIssueActivityEdge = {
  __typename?: 'LostAndFoundIssueActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type LostAndFoundIssueAndDocument = {
  __typename?: 'LostAndFoundIssueAndDocument';
  document?: Maybe<Array<LostAndFoundIssueDocumentAndPresignedUrl>>;
  issue: LostAndFoundIssue;
};

export type LostAndFoundIssueConnection = {
  __typename?: 'LostAndFoundIssueConnection';
  edges?: Maybe<Array<Maybe<LostAndFoundIssueEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LostAndFoundIssueConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LostAndFoundIssueMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<LostAndFoundIssueSearch>>;
};

export type LostAndFoundIssueDocument = {
  __typename?: 'LostAndFoundIssueDocument';
  contentType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  fileLocation: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  issueId: Scalars['String']['output'];
  md5: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type LostAndFoundIssueDocumentActivityConnection = {
  __typename?: 'LostAndFoundIssueDocumentActivityConnection';
  edges?: Maybe<Array<Maybe<LostAndFoundIssueDocumentActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LostAndFoundIssueDocumentActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type LostAndFoundIssueDocumentActivityEdge = {
  __typename?: 'LostAndFoundIssueDocumentActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type LostAndFoundIssueDocumentAndPresignedUrl = {
  __typename?: 'LostAndFoundIssueDocumentAndPresignedURL';
  document?: Maybe<LostAndFoundIssueDocument>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

export type LostAndFoundIssueDocumentConnection = {
  __typename?: 'LostAndFoundIssueDocumentConnection';
  edges?: Maybe<Array<Maybe<LostAndFoundIssueDocumentEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LostAndFoundIssueDocumentConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LostAndFoundIssueDocumentMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<LostAndFoundIssueDocumentSearch>>;
};

export type LostAndFoundIssueDocumentEdge = {
  __typename?: 'LostAndFoundIssueDocumentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<LostAndFoundIssueDocument>;
};

export type LostAndFoundIssueDocumentMaskInput = {
  contentType?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  fileSize?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  issueId?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type LostAndFoundIssueDocumentSearch = {
  contentType?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  fileSize?: InputMaybe<Array<IntSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  issueId?: InputMaybe<Array<StringSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type LostAndFoundIssueEdge = {
  __typename?: 'LostAndFoundIssueEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<LostAndFoundIssue>;
};

export type LostAndFoundIssueMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  crewDriverName?: InputMaybe<Scalars['Boolean']['input']>;
  crewFlightName?: InputMaybe<Scalars['Boolean']['input']>;
  crewFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  crewMemberEmail?: InputMaybe<Scalars['Boolean']['input']>;
  crewMemberName?: InputMaybe<Scalars['Boolean']['input']>;
  crewMemberPhone?: InputMaybe<Scalars['Boolean']['input']>;
  datetime?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherId?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  itemLost?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  outboundDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightName?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  returnStatus?: InputMaybe<Scalars['Boolean']['input']>;
  shippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  shippingCity?: InputMaybe<Scalars['Boolean']['input']>;
  shippingCost?: InputMaybe<Scalars['Boolean']['input']>;
  shippingMethod?: InputMaybe<Scalars['Boolean']['input']>;
  shippingStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  shippingZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  trackingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LostAndFoundIssueReturnStatusEnum {
  ReportedLost = 'REPORTED_LOST',
  Returned = 'RETURNED',
  Shipped = 'SHIPPED',
  Unclaimed = 'UNCLAIMED'
}

export type LostAndFoundIssueReturnStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<LostAndFoundIssueReturnStatusEnum>;
};

export type LostAndFoundIssueSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewAirportCode?: InputMaybe<Array<StringSearch>>;
  crewDriverName?: InputMaybe<Array<StringSearch>>;
  crewFlightName?: InputMaybe<Array<StringSearch>>;
  crewFlightNumber?: InputMaybe<Array<IntSearch>>;
  crewMemberEmail?: InputMaybe<Array<StringSearch>>;
  crewMemberName?: InputMaybe<Array<StringSearch>>;
  crewMemberPhone?: InputMaybe<Array<StringSearch>>;
  datetime?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  dispatcherId?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  itemLost?: InputMaybe<Array<StringSearch>>;
  notes?: InputMaybe<Array<StringSearch>>;
  outboundDatetime?: InputMaybe<Array<StringSearch>>;
  outboundFlightName?: InputMaybe<Array<StringSearch>>;
  outboundFlightNumber?: InputMaybe<Array<IntSearch>>;
  returnStatus?: InputMaybe<Array<LostAndFoundIssueReturnStatusEnumSearch>>;
  shippingAddress?: InputMaybe<Array<StringSearch>>;
  shippingCity?: InputMaybe<Array<StringSearch>>;
  shippingCost?: InputMaybe<Array<FloatSearch>>;
  shippingMethod?: InputMaybe<Array<StringSearch>>;
  shippingStateCode?: InputMaybe<Array<StringSearch>>;
  shippingZipCode?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  trackingNumber?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
};

export type LostAndFoundIssueWithCache = {
  __typename?: 'LostAndFoundIssueWithCache';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewAirportCode?: Maybe<Scalars['String']['output']>;
  crewDriverName?: Maybe<Scalars['String']['output']>;
  crewFlightName?: Maybe<Scalars['String']['output']>;
  crewFlightNumber?: Maybe<Scalars['Int']['output']>;
  crewMemberEmail?: Maybe<Scalars['String']['output']>;
  crewMemberName: Scalars['String']['output'];
  crewMemberPhone: Scalars['String']['output'];
  datetime?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  description: Scalars['String']['output'];
  dispatcherEmployeeId?: Maybe<Scalars['String']['output']>;
  dispatcherFirstName: Scalars['String']['output'];
  dispatcherId?: Maybe<Scalars['String']['output']>;
  dispatcherLastName: Scalars['String']['output'];
  driverEmployeeId?: Maybe<Scalars['String']['output']>;
  driverFirstName: Scalars['String']['output'];
  driverId?: Maybe<Scalars['String']['output']>;
  driverLastName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  itemLost?: Maybe<Scalars['String']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  outboundDatetime?: Maybe<Scalars['String']['output']>;
  outboundFlightName?: Maybe<Scalars['String']['output']>;
  outboundFlightNumber?: Maybe<Scalars['Int']['output']>;
  returnStatus?: Maybe<LostAndFoundIssueWithCacheReturnStatusEnum>;
  shippingAddress?: Maybe<Scalars['String']['output']>;
  shippingCity?: Maybe<Scalars['String']['output']>;
  shippingCost?: Maybe<Scalars['Float']['output']>;
  shippingMethod?: Maybe<Scalars['String']['output']>;
  shippingStateCode?: Maybe<Scalars['String']['output']>;
  shippingZipCode?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  trackingNumber?: Maybe<Scalars['String']['output']>;
  tripAirportCode: Scalars['String']['output'];
  tripFlightNumber: Scalars['Int']['output'];
  tripId?: Maybe<Scalars['String']['output']>;
  tripLoopName: Scalars['String']['output'];
  tripScheduled: Scalars['String']['output'];
  tripServicerIataAirlineCode: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
  vehicleTrackingId: Scalars['String']['output'];
};

export type LostAndFoundIssueWithCacheActivityConnection = {
  __typename?: 'LostAndFoundIssueWithCacheActivityConnection';
  edges?: Maybe<Array<Maybe<LostAndFoundIssueWithCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LostAndFoundIssueWithCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type LostAndFoundIssueWithCacheActivityEdge = {
  __typename?: 'LostAndFoundIssueWithCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type LostAndFoundIssueWithCacheConnection = {
  __typename?: 'LostAndFoundIssueWithCacheConnection';
  edges?: Maybe<Array<Maybe<LostAndFoundIssueWithCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type LostAndFoundIssueWithCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LostAndFoundIssueWithCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<LostAndFoundIssueWithCacheSearch>>;
};

export type LostAndFoundIssueWithCacheEdge = {
  __typename?: 'LostAndFoundIssueWithCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<LostAndFoundIssueWithCache>;
};

export type LostAndFoundIssueWithCacheMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  crewDriverName?: InputMaybe<Scalars['Boolean']['input']>;
  crewFlightName?: InputMaybe<Scalars['Boolean']['input']>;
  crewFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  crewMemberEmail?: InputMaybe<Scalars['Boolean']['input']>;
  crewMemberName?: InputMaybe<Scalars['Boolean']['input']>;
  crewMemberPhone?: InputMaybe<Scalars['Boolean']['input']>;
  datetime?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherId?: InputMaybe<Scalars['Boolean']['input']>;
  dispatcherLastName?: InputMaybe<Scalars['Boolean']['input']>;
  driverEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  driverFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  driverLastName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  itemLost?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  outboundDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightName?: InputMaybe<Scalars['Boolean']['input']>;
  outboundFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  returnStatus?: InputMaybe<Scalars['Boolean']['input']>;
  shippingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  shippingCity?: InputMaybe<Scalars['Boolean']['input']>;
  shippingCost?: InputMaybe<Scalars['Boolean']['input']>;
  shippingMethod?: InputMaybe<Scalars['Boolean']['input']>;
  shippingStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  shippingZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  trackingNumber?: InputMaybe<Scalars['Boolean']['input']>;
  tripAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  tripFlightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  tripLoopName?: InputMaybe<Scalars['Boolean']['input']>;
  tripScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  tripServicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTrackingId?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum LostAndFoundIssueWithCacheReturnStatusEnum {
  ReportedLost = 'REPORTED_LOST',
  Returned = 'RETURNED',
  Shipped = 'SHIPPED',
  Unclaimed = 'UNCLAIMED'
}

export type LostAndFoundIssueWithCacheReturnStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<LostAndFoundIssueWithCacheReturnStatusEnum>;
};

export type LostAndFoundIssueWithCacheSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewAirportCode?: InputMaybe<Array<StringSearch>>;
  crewDriverName?: InputMaybe<Array<StringSearch>>;
  crewFlightName?: InputMaybe<Array<StringSearch>>;
  crewFlightNumber?: InputMaybe<Array<IntSearch>>;
  crewMemberEmail?: InputMaybe<Array<StringSearch>>;
  crewMemberName?: InputMaybe<Array<StringSearch>>;
  crewMemberPhone?: InputMaybe<Array<StringSearch>>;
  datetime?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  dispatcherEmployeeId?: InputMaybe<Array<StringSearch>>;
  dispatcherFirstName?: InputMaybe<Array<StringSearch>>;
  dispatcherId?: InputMaybe<Array<StringSearch>>;
  dispatcherLastName?: InputMaybe<Array<StringSearch>>;
  driverEmployeeId?: InputMaybe<Array<StringSearch>>;
  driverFirstName?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  driverLastName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  itemLost?: InputMaybe<Array<StringSearch>>;
  notes?: InputMaybe<Array<StringSearch>>;
  outboundDatetime?: InputMaybe<Array<StringSearch>>;
  outboundFlightName?: InputMaybe<Array<StringSearch>>;
  outboundFlightNumber?: InputMaybe<Array<IntSearch>>;
  returnStatus?: InputMaybe<Array<LostAndFoundIssueWithCacheReturnStatusEnumSearch>>;
  shippingAddress?: InputMaybe<Array<StringSearch>>;
  shippingCity?: InputMaybe<Array<StringSearch>>;
  shippingCost?: InputMaybe<Array<FloatSearch>>;
  shippingMethod?: InputMaybe<Array<StringSearch>>;
  shippingStateCode?: InputMaybe<Array<StringSearch>>;
  shippingZipCode?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  trackingNumber?: InputMaybe<Array<StringSearch>>;
  tripAirportCode?: InputMaybe<Array<StringSearch>>;
  tripFlightNumber?: InputMaybe<Array<IntSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  tripLoopName?: InputMaybe<Array<StringSearch>>;
  tripScheduled?: InputMaybe<Array<StringSearch>>;
  tripServicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  vehicleTrackingId?: InputMaybe<Array<StringSearch>>;
};

export type ManifestHistory = {
  __typename?: 'ManifestHistory';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  manifestImportId: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type ManifestHistoryActivityConnection = {
  __typename?: 'ManifestHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<ManifestHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ManifestHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ManifestHistoryActivityEdge = {
  __typename?: 'ManifestHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ManifestHistoryConnection = {
  __typename?: 'ManifestHistoryConnection';
  edges?: Maybe<Array<Maybe<ManifestHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ManifestHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ManifestHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ManifestHistorySearch>>;
};

export type ManifestHistoryEdge = {
  __typename?: 'ManifestHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ManifestHistory>;
};

export type ManifestHistoryMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  manifestImportId?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ManifestHistoryRoute = {
  __typename?: 'ManifestHistoryRoute';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  doLocationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  manifestHistoryId: Scalars['String']['output'];
  puLocationId: Scalars['String']['output'];
  status: ManifestHistoryRouteStatusEnum;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ManifestHistoryRouteActivityConnection = {
  __typename?: 'ManifestHistoryRouteActivityConnection';
  edges?: Maybe<Array<Maybe<ManifestHistoryRouteActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ManifestHistoryRouteActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ManifestHistoryRouteActivityEdge = {
  __typename?: 'ManifestHistoryRouteActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ManifestHistoryRouteConnection = {
  __typename?: 'ManifestHistoryRouteConnection';
  edges?: Maybe<Array<Maybe<ManifestHistoryRouteEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ManifestHistoryRouteConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ManifestHistoryRouteMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ManifestHistoryRouteSearch>>;
};

export type ManifestHistoryRouteEdge = {
  __typename?: 'ManifestHistoryRouteEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ManifestHistoryRoute>;
};

export type ManifestHistoryRouteMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  manifestHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ManifestHistoryRouteSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  manifestHistoryId?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<ManifestHistoryRouteStatusEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum ManifestHistoryRouteStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InQueue = 'IN_QUEUE',
  Running = 'RUNNING'
}

export type ManifestHistoryRouteStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ManifestHistoryRouteStatusEnum>;
};

export type ManifestHistorySearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  manifestImportId?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type ManifestHistoryWithRoute = {
  __typename?: 'ManifestHistoryWithRoute';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  doLocationId: Scalars['String']['output'];
  filename?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  manifestHistoryId: Scalars['String']['output'];
  manifestImportId: Scalars['String']['output'];
  puLocationId: Scalars['String']['output'];
  routeCreatedAt?: Maybe<Scalars['String']['output']>;
  routeDeletedAt?: Maybe<Scalars['String']['output']>;
  routeId: Scalars['String']['output'];
  status: ManifestHistoryWithRouteStatusEnum;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type ManifestHistoryWithRouteActivityConnection = {
  __typename?: 'ManifestHistoryWithRouteActivityConnection';
  edges?: Maybe<Array<Maybe<ManifestHistoryWithRouteActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ManifestHistoryWithRouteActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ManifestHistoryWithRouteActivityEdge = {
  __typename?: 'ManifestHistoryWithRouteActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ManifestHistoryWithRouteConnection = {
  __typename?: 'ManifestHistoryWithRouteConnection';
  edges?: Maybe<Array<Maybe<ManifestHistoryWithRouteEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ManifestHistoryWithRouteConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ManifestHistoryWithRouteMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ManifestHistoryWithRouteSearch>>;
};

export type ManifestHistoryWithRouteEdge = {
  __typename?: 'ManifestHistoryWithRouteEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ManifestHistoryWithRoute>;
};

export type ManifestHistoryWithRouteMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  manifestHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  manifestImportId?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  routeCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  routeDeletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  routeId?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ManifestHistoryWithRouteSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  manifestHistoryId?: InputMaybe<Array<StringSearch>>;
  manifestImportId?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  routeCreatedAt?: InputMaybe<Array<StringSearch>>;
  routeDeletedAt?: InputMaybe<Array<StringSearch>>;
  routeId?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<ManifestHistoryWithRouteStatusEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export enum ManifestHistoryWithRouteStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InQueue = 'IN_QUEUE',
  Running = 'RUNNING'
}

export type ManifestHistoryWithRouteStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ManifestHistoryWithRouteStatusEnum>;
};

export type ManifestProviderCache = {
  __typename?: 'ManifestProviderCache';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ManifestProviderCacheActivityConnection = {
  __typename?: 'ManifestProviderCacheActivityConnection';
  edges?: Maybe<Array<Maybe<ManifestProviderCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ManifestProviderCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ManifestProviderCacheActivityEdge = {
  __typename?: 'ManifestProviderCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ManifestProviderCacheConnection = {
  __typename?: 'ManifestProviderCacheConnection';
  edges?: Maybe<Array<Maybe<ManifestProviderCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ManifestProviderCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ManifestProviderCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ManifestProviderCacheSearch>>;
};

export type ManifestProviderCacheEdge = {
  __typename?: 'ManifestProviderCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ManifestProviderCache>;
};

export type ManifestProviderCacheMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ManifestProviderCacheSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type ManifestUserCache = {
  __typename?: 'ManifestUserCache';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type ManifestUserCacheActivityConnection = {
  __typename?: 'ManifestUserCacheActivityConnection';
  edges?: Maybe<Array<Maybe<ManifestUserCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ManifestUserCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ManifestUserCacheActivityEdge = {
  __typename?: 'ManifestUserCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ManifestUserCacheConnection = {
  __typename?: 'ManifestUserCacheConnection';
  edges?: Maybe<Array<Maybe<ManifestUserCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ManifestUserCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ManifestUserCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ManifestUserCacheSearch>>;
};

export type ManifestUserCacheEdge = {
  __typename?: 'ManifestUserCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ManifestUserCache>;
};

export type ManifestUserCacheMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ManifestUserCacheSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  employeeId?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type Message = {
  __typename?: 'Message';
  companyId: Scalars['String']['output'];
  content: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  type: MessageTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type MessageActivityConnection = {
  __typename?: 'MessageActivityConnection';
  edges?: Maybe<Array<Maybe<MessageActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type MessageActivityEdge = {
  __typename?: 'MessageActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type MessageConnection = {
  __typename?: 'MessageConnection';
  edges?: Maybe<Array<Maybe<MessageEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type MessageConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<MessageMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<MessageSearch>>;
};

export type MessageEdge = {
  __typename?: 'MessageEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Message>;
};

export type MessageMaskInput = {
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  content?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MessageSearch = {
  companyId?: InputMaybe<Array<StringSearch>>;
  content?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<MessageTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum MessageTypeEnum {
  Crew = 'CREW',
  Curbside = 'CURBSIDE',
  Driver = 'DRIVER'
}

export type MessageTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<MessageTypeEnum>;
};

export type Metadata = {
  __typename?: 'Metadata';
  columns?: Maybe<Array<KeyValue>>;
  footer?: Maybe<Array<KeyValue>>;
  header?: Maybe<Array<KeyValue>>;
};

export type Metric = {
  key: Scalars['String']['input'];
  math: MetricMathEnum;
  numberField: MetricNumberFieldEnum;
};

export enum MetricFunctionEnum {
  AverageBucket = 'AVERAGE_BUCKET',
  SumBucket = 'SUM_BUCKET'
}

export enum MetricKeywordFieldEnum {
  Airport = 'AIRPORT',
  Client = 'CLIENT',
  Market = 'MARKET',
  Status = 'STATUS'
}

export enum MetricMathEnum {
  Average = 'AVERAGE',
  Count = 'COUNT',
  Sum = 'SUM'
}

export enum MetricNumberFieldEnum {
  Rate = 'RATE'
}

export type Mutation = {
  __typename?: 'Mutation';
  CompleteDtrManifestImport: CompleteDtrManifestImportResponse;
  addLocationAliases: AddLocationAliasesResponse;
  approveUserAvailability: ApproveUserAvailabilityResponse;
  combineTrips: CreateCombineTripResponse;
  createAccidentIssueBulk: CreateAccidentIssueBulkResponse;
  createAccidentIssueDocumentBulk: CreateAccidentIssueDocumentBulkResponse;
  createAccidentIssueDocumentPresignedUploadUrl: CreateIssuePresignedUrlResponse;
  createActivityBulk: CreateActivityBulkResponse;
  createAirlineBulk: CreateProviderBulkResponse;
  createAirportHasVehicleBulk: CreateAirportHasVehicleBulkResponse;
  createBufferTimeBulk: CreateBufferTimeBulkResponse;
  createBufferTimes: CreateBufferTimesResponse;
  createClientBulk: CreateProviderBulkResponse;
  createCombineRuleBulk: CreateCombineRuleBulkResponse;
  createCombineRuleHistoryBulk: CreateCombineRuleHistoryBulkResponse;
  createCombineRuleWithCombineRuleHistoryBulk: CreateCombineRuleWithCombineRuleHistoryBulkResponse;
  createCommunicationBulk: CreateCommunicationBulkResponse;
  createCompletionBulk: CreateCompletionBulkResponse;
  createCrewCountRequirementBulk: CreateCrewCountRequirementBulkResponse;
  createCrewTrip: CreateCrewTripResponse;
  createDashboardBulk: CreateDashboardBulkResponse;
  createDispatchIssueBulk: CreateDispatchIssueBulkResponse;
  createDispatchIssueCausedByBulk: CreateDispatchIssueCausedByBulkResponse;
  createDispatchIssueDocumentBulk: CreateDispatchIssueDocumentBulkResponse;
  createDispatchIssueDocumentPresignedUploadUrl: CreateIssuePresignedUrlResponse;
  createDispatchSummaryBulk: CreateDispatchSummaryBulkResponse;
  createDispatchSummaryDocumentBulk: CreateDispatchSummaryDocumentBulkResponse;
  createDispatchSummaryDocumentPresignedUploadUrl: CreateIssuePresignedUrlResponse;
  createDispatchSummaryMarketBulk: CreateDispatchSummaryMarketBulkResponse;
  createDownloadImportURLs: CreateDownloadImportUrLsResponse;
  createDtrImport: CreateImportsResponse;
  createDtrLocationBulk: CreateDtrLocationBulkResponse;
  createEmailBulk: CreateEmailBulkResponse;
  createFcrBulk: CreateFcrBulkResponse;
  createFlagBulk: CreateFlagBulkResponse;
  createFlagHasPotentialTripBulk: CreateFlagHasPotentialTripBulkResponse;
  createFlagHasTripBulk: CreateFlagHasTripBulkResponse;
  createGroupBulk: CreateGroupBulkResponse;
  createGroupHasPermissionBulk: CreateGroupHasPermissionBulkResponse;
  createGroupHasUserBulk: CreateGroupHasUserBulkResponse;
  createImageBulk: CreateImageBulkResponse;
  createImports: CreateImportsResponse;
  createIncidentIssueBulk: CreateIncidentIssueBulkResponse;
  createIncidentIssueDocumentBulk: CreateIncidentIssueDocumentBulkResponse;
  createIncidentIssueDocumentPresignedUploadUrl: CreateIssuePresignedUrlResponse;
  createLicenseBulk: CreateLicenseBulkResponse;
  createLocationBulk: CreateLocationBulkResponse;
  createLocations: CreateLocationsResponse;
  createLostAndFoundIssueBulk: CreateLostAndFoundIssueBulkResponse;
  createLostAndFoundIssueDocumentBulk: CreateLostAndFoundIssueDocumentBulkResponse;
  createLostAndFoundIssueDocumentPresignedUploadUrl: CreateIssuePresignedUrlResponse;
  createPermissionHasRoleBulk: CreatePermissionHasRoleBulkResponse;
  createPermissionHasUserBulk: CreatePermissionHasUserBulkResponse;
  createPickupPointBulk: CreatePickupPointBulkResponse;
  createPotentialTripBulk: CreatePotentialTripBulkResponse;
  createProviderBulk: CreateProviderBulkResponse;
  createProviderLocationMappingBulk: CreateProviderLocationMappingBulkResponse;
  createPunchPolicyBulk: CreatePunchPolicyBulkResponse;
  createQueryHistoryBulk: CreateQueryHistoryBulkResponse;
  createQuestionnaireAnswerOptionBulk: CreateQuestionnaireAnswerOptionBulkResponse;
  createQuestionnaireAnswerTypeBulk: CreateQuestionnaireAnswerTypeBulkResponse;
  createQuestionnaireCategoryBulk: CreateQuestionnaireCategoryBulkResponse;
  createQuestionnaireCategoryWithGroups: CreateQuestionnaireCategoryWithGroupsResponse;
  createQuestionnaireQuestionBulk: CreateQuestionnaireQuestionBulkResponse;
  createRateBulk: CreateRateBulkResponse;
  createRateForTrips: CreateRateForTripsResponse;
  createRateGroupBulk: CreateRateGroupBulkResponse;
  createRateItemBulk: CreateRateItemBulkResponse;
  createRatingBulk: CreateRatingBulkResponse;
  createRatingRemarkBulk: CreateRatingRemarkBulkResponse;
  createRoleBulk: CreateRoleBulkResponse;
  createStopBulk: CreateStopBulkResponse;
  createTimeFrameBulk: CreateTimeFrameBulkResponse;
  createTimeFrameRangeBulk: CreateTimeFrameRangeBulkResponse;
  createTripDocumentBulk: CreateTripDocumentBulkResponse;
  createTripDocumentDownloadUrl: CreateTripDownloadUrlResponse;
  createTripDocumentPresignedUploadUrl: CreateTripDocumentPresignedUploadUrlResponse;
  createTrips: CreateTripsResponse;
  createUserAvailabilityBulk: CreateUserAvailabilityBulkResponse;
  createUserBulk: CreateUserBulkResponse;
  createVariableTimeBulk: CreateVariableTimeBulkResponse;
  createVehicleBulk: CreateVehicleBulkResponse;
  createWidgetBulk: CreateWidgetBulkResponse;
  deleteAccidentIssueBulk: DeleteAccidentIssueBulkResponse;
  deleteAccidentIssueDocumentBulk: DeleteAccidentIssueDocumentBulkResponse;
  deleteAirlineBulk: DeleteProviderBulkResponse;
  deleteAirportHasVehicleBulk: DeleteAirportHasVehicleBulkResponse;
  deleteBufferTimeBulk: DeleteBufferTimeBulkResponse;
  deleteBufferTimes: DeleteBufferTimesResponse;
  deleteClientBulk: DeleteProviderBulkResponse;
  deleteCombineRuleBulk: DeleteCombineRuleBulkResponse;
  deleteCombineRuleHistoryBulk: DeleteCombineRuleHistoryBulkResponse;
  deleteCommunicationBulk: DeleteCommunicationBulkResponse;
  deleteCompletionBulk: DeleteCompletionBulkResponse;
  deleteCrewCountRequirementBulk: DeleteCrewCountRequirementBulkResponse;
  deleteDashboardBulk: DeleteDashboardBulkResponse;
  deleteDispatchIssueBulk: DeleteDispatchIssueBulkResponse;
  deleteDispatchIssueCausedByBulk: DeleteDispatchIssueCausedByBulkResponse;
  deleteDispatchIssueDocumentBulk: DeleteDispatchIssueDocumentBulkResponse;
  deleteDispatchSummaryBulk: DeleteDispatchSummaryBulkResponse;
  deleteDispatchSummaryDocumentBulk: DeleteDispatchSummaryDocumentBulkResponse;
  deleteDispatchSummaryMarketBulk: DeleteDispatchSummaryMarketBulkResponse;
  deleteDtrLocationBulk: DeleteDtrLocationBulkResponse;
  deleteEmailBulk: DeleteEmailBulkResponse;
  deleteFcrBulk: DeleteFcrBulkResponse;
  deleteFlagBulk: DeleteFlagBulkResponse;
  deleteFlagHasPotentialTripBulk: DeleteFlagHasPotentialTripBulkResponse;
  deleteFlagHasTripBulk: DeleteFlagHasTripBulkResponse;
  deleteGroupBulk: DeleteGroupBulkResponse;
  deleteGroupHasPermissionBulk: DeleteGroupHasPermissionBulkResponse;
  deleteGroupHasUserBulk: DeleteGroupHasUserBulkResponse;
  deleteImageBulk: DeleteImageBulkResponse;
  deleteImportBulk: DeleteImportBulkResponse;
  deleteIncidentIssueBulk: DeleteIncidentIssueBulkResponse;
  deleteIncidentIssueDocumentBulk: DeleteIncidentIssueDocumentBulkResponse;
  deleteLicenseBulk: DeleteLicenseBulkResponse;
  deleteLocationBulk: DeleteLocationBulkResponse;
  deleteLostAndFoundIssueBulk: DeleteLostAndFoundIssueBulkResponse;
  deleteLostAndFoundIssueDocumentBulk: DeleteLostAndFoundIssueDocumentBulkResponse;
  deleteManifestHistoryBulk: DeleteManifestHistoryBulkResponse;
  deleteManifestHistoryRouteBulk: DeleteManifestHistoryRouteBulkResponse;
  deletePermissionHasRoleBulk: DeletePermissionHasRoleBulkResponse;
  deletePermissionHasUserBulk: DeletePermissionHasUserBulkResponse;
  deletePickupPointBulk: DeletePickupPointBulkResponse;
  deleteProviderBulk: DeleteProviderBulkResponse;
  deleteProviderLocationMappingBulk: DeleteProviderLocationMappingBulkResponse;
  deletePunchPolicyBulk: DeletePunchPolicyBulkResponse;
  deleteQueryHistoryBulk: DeleteQueryHistoryBulkResponse;
  deleteQuestionnaireAnswerOptionBulk: DeleteQuestionnaireAnswerOptionBulkResponse;
  deleteQuestionnaireAnswerTypeBulk: DeleteQuestionnaireAnswerTypeBulkResponse;
  deleteQuestionnaireCategoryBulk: DeleteQuestionnaireCategoryBulkResponse;
  deleteQuestionnaireQuestionBulk: DeleteQuestionnaireQuestionBulkResponse;
  deleteRateBulk: DeleteRateBulkResponse;
  deleteRateGroupBulk: DeleteRateGroupBulkResponse;
  deleteRateItemBulk: DeleteRateItemBulkResponse;
  deleteRoleBulk: DeleteRoleBulkResponse;
  deleteStopBulk: DeleteStopBulkResponse;
  deleteTimeFrameBulk: DeleteTimeFrameBulkResponse;
  deleteTimeFrameRangeBulk: DeleteTimeFrameRangeBulkResponse;
  deleteTripBulk: DeleteTripBulkResponse;
  deleteTripDocumentBulk: DeleteTripDocumentBulkResponse;
  deleteTripHardBulk: DeleteTripHardBulkResponse;
  deleteUserAvailabilityAndUnassignBulk: DeleteUserAvailabilityBulkResponse;
  deleteUserAvailabilityBulk: DeleteUserAvailabilityBulkResponse;
  deleteUserAvailabilitySeriesAndUnassignBulk: DeleteUserAvailabilityBulkResponse;
  deleteUserAvailabilitySeriesBulk: DeleteUserAvailabilityBulkResponse;
  deleteUserBulk: DeleteUserBulkResponse;
  deleteVariableTimeBulk: DeleteVariableTimeBulkResponse;
  deleteVehicleBulk: DeleteVehicleBulkResponse;
  deleteWidgetBulk: DeleteWidgetBulkResponse;
  deviceMutation?: Maybe<DeviceMutationResponse>;
  downloadChatHistoryAsCsv: GetReportAsCsvResponse;
  downloadDriveTimeReportPDF: DownloadDriveTimeReportPdfResponse;
  downloadInvoiceDocument: DownloadInvoiceDocumentResponse;
  downloadQuestionnaireAnswerOptionAsCSV: DownloadQuestionnaireAnswerOptionAsCsvResponse;
  downloadQuestionnaireAnswerTypeAsCSV: DownloadQuestionnaireAnswerTypeAsCsvResponse;
  downloadQuestionnaireCategoryAsCSV: DownloadQuestionnaireCategoryAsCsvResponse;
  downloadQuestionnaireQuestionAsCSV: DownloadQuestionnaireQuestionAsCsvResponse;
  downloadTrainingReportPDF: DownloadTrainingReportPdfResponse;
  forgotPassword: ForgotPasswordResponse;
  generateDriveTimeReportPDF: GenerateDriveTimeReportPdfResponse;
  generateInvoiceDocument: GenerateInvoiceDocumentResponse;
  generateInvoiceDocumentUploadUrl: GenerateInvoiceDocumentUploadUrlResponse;
  generatePunchHistoryUploadUrls: GeneratePunchHistoryUploadUrlsResponse;
  generateTrainingReportPDF: GenerateTrainingReportPdfResponse;
  generateUploadProfileImageUrl: GenerateUploadProfileImageUrlResponse;
  getPredictiveDriveTimeReportAsCSV: GetPredictiveDriveTimeReportAsCsvResponse;
  login: LoginResponse;
  reportImportProblem: ReportImportProblemResponse;
  reportProblem?: Maybe<ReportProblemResponse>;
  resetPasswordLinkCode: ResetPasswordLinkCodeResponse;
  resubmitManifestHistory: ResubmitManifestHistoryResponse;
  resubmitQueryHistory: ResubmitQueryHistoryResponse;
  runApplyRateToSimilarTrips: RunApplyRateToSimilarTripsResponse;
  runArchiveImports: RunArchiveImportsResponse;
  runArchiveInvoices: RunArchiveInvoicesResponse;
  runAssignDriver: RunAssignDriverResponse;
  runAssignVehicleToDriverBulk: RunAssignVehicleToDriverBulkResponse;
  runAutoCombineDriverTrips: RunAutoCombineDriverTripsResponse;
  runCompletionOnTrip: RunCompletionOnTripResponse;
  runDownloadImport: RunDownloadImportResponse;
  runDownloadInvoice: RunDownloadInvoiceResponse;
  runDownloadLatestInvoiceDocument: RunDownloadLatestInvoiceDocumentResponse;
  runIngestImports: RunIngestImportsResponse;
  runOverrideImports: RunOverrideImportsResponse;
  runParseImportLocations: RunParseImportLocationsResponse;
  runParseImports: RunParseImportsResponse;
  runPreviewImports: RunPreviewImportsResponse;
  runPreviewInvoice: RunPreviewInvoiceResponse;
  runRateAmountOnTrips: RunRateAmountOnTripsResponse;
  runRateOverride: RunRateOverrideResponse;
  runRemoveCompletionOnTrip: RunRemoveCompletionOnTripResponse;
  runReportIndexer: RunReportIndexerResponse;
  runResetUserPasswordBulk: RunResetUserPasswordBulkResponse;
  runRollbackImports: RunRollbackImportsResponse;
  runSaveAndSendInvoice: RunSaveAndSendInvoiceResponse;
  runSaveAsInvoice: RunSaveAsInvoiceResponse;
  runSaveInvoice: RunSaveInvoiceResponse;
  runScheduleAutomation: RunScheduleAutomationResponse;
  runUnarchiveInvoices: RunUnarchiveInvoicesResponse;
  runUnassignDriver: RunUnassignDriverResponse;
  runUpdateUserProfileBulk: RunUpdateUserProfileBulkResponse;
  runUpdateUserVehicleBulk: RunUpdateUserVehicleBulkResponse;
  saveQuestionnaireAnswer: SaveQuestionnaireAnswerResponse;
  scheduleAutomationRunDriverAssignment: ScheduleAutomationRunDriverAssignmentResponse;
  sendInvoiceEmail: SendInvoiceEmailResponse;
  setQuestionnaireCategoryGroups: SetQuestionnaireCategoryGroupsResponse;
  startEvaluation: StartEvaluationResponse;
  submitCategory: SubmitCategoryResponse;
  submitEvaluation: SubmitEvaluationResponse;
  undeleteTripBulk: UndeleteTripBulkResponse;
  updateAccidentIssueBulk: UpdateAccidentIssueBulkResponse;
  updateAccidentIssueDocumentBulk: UpdateAccidentIssueDocumentBulkResponse;
  updateAirlineBulk: UpdateProviderBulkResponse;
  updateBufferTimeBulk: UpdateBufferTimeBulkResponse;
  updateClientBulk: UpdateProviderBulkResponse;
  updateCombineRuleBulk: UpdateCombineRuleBulkResponse;
  updateCombineRuleHistoryBulk: UpdateCombineRuleHistoryBulkResponse;
  updateCompletionBulk: UpdateCompletionBulkResponse;
  updateCrewCountRequirementBulk: UpdateCrewCountRequirementBulkResponse;
  updateDashboardBulk: UpdateDashboardBulkResponse;
  updateDispatchIssueBulk: UpdateDispatchIssueBulkResponse;
  updateDispatchIssueCausedByBulk: UpdateDispatchIssueCausedByBulkResponse;
  updateDispatchIssueDocumentBulk: UpdateDispatchIssueDocumentBulkResponse;
  updateDispatchSummaryBulk: UpdateDispatchSummaryBulkResponse;
  updateDispatchSummaryDocumentBulk: UpdateDispatchSummaryDocumentBulkResponse;
  updateDispatchSummaryMarketBulk: UpdateDispatchSummaryMarketBulkResponse;
  updateDtrLocationBulk: UpdateDtrLocationBulkResponse;
  updateEmailBulk: UpdateEmailBulkResponse;
  updateFlagBulk: UpdateFlagBulkResponse;
  updateFullWidgetBulk: UpdateFullWidgetBulkResponse;
  updateImportBulk: UpdateImportBulkResponse;
  updateImportProvider: UpdateImportProviderResponse;
  updateImportsStatus: UpdateImportsStatusResponse;
  updateIncidentIssueBulk: UpdateIncidentIssueBulkResponse;
  updateIncidentIssueDocumentBulk: UpdateIncidentIssueDocumentBulkResponse;
  updateLicenseBulk: UpdateLicenseBulkResponse;
  updateLocationBulk: UpdateLocationBulkResponse;
  updateLocationById: UpdateLocationByIdResponse;
  updateLostAndFoundIssueBulk: UpdateLostAndFoundIssueBulkResponse;
  updateLostAndFoundIssueDocumentBulk: UpdateLostAndFoundIssueDocumentBulkResponse;
  updatePasswords: UpdatePasswordsResponse;
  updatePickupPointBulk: UpdatePickupPointBulkResponse;
  updatePotentialTripBulk: UpdatePotentialTripBulkResponse;
  updateProviderBulk: UpdateProviderBulkResponse;
  updateProviderLocationMappingBulk: UpdateProviderLocationMappingBulkResponse;
  updatePunchPolicyBulk: UpdatePunchPolicyBulkResponse;
  updateQueryHistoryBulk: UpdateQueryHistoryBulkResponse;
  updateQuestionnaireAnswerOptionBulk: UpdateQuestionnaireAnswerOptionBulkResponse;
  updateQuestionnaireAnswerTypeBulk: UpdateQuestionnaireAnswerTypeBulkResponse;
  updateQuestionnaireCategoryBulk: UpdateQuestionnaireCategoryBulkResponse;
  updateQuestionnaireQuestionBulk: UpdateQuestionnaireQuestionBulkResponse;
  updateRateBulk: UpdateRateBulkResponse;
  updateRateItemBulk: UpdateRateItemBulkResponse;
  updateRateOnTrips: UpdateRateOnTripsResponse;
  updateStagedTripBulk: UpdateStagedTripBulkResponse;
  updateStopBulk: UpdateStopBulkResponse;
  updateTimeFrameBulk: UpdateTimeFrameBulkResponse;
  updateTimeFrameRangeBulk: UpdateTimeFrameRangeBulkResponse;
  updateTrackFlightBulk: UpdateTrackFlightBulkResponse;
  updateTripBulk: UpdateTripBulkResponse;
  updateTripDocumentBulk: UpdateTripDocumentBulkResponse;
  updateUserActivationBulk: UpdateUserActivationBulkResponse;
  updateUserAvailabilityBulk: UpdateUserAvailabilityBulkResponse;
  updateUserAvailabilitySeriesBulk: UpdateUserAvailabilityBulkResponse;
  updateUserBulk: UpdateUserBulkResponse;
  updateVariableTimeBulk: UpdateVariableTimeBulkResponse;
  updateVehicleBulk: UpdateVehicleBulkResponse;
};


export type MutationCompleteDtrManifestImportArgs = {
  input: CompleteDtrManifestImportInput;
};


export type MutationAddLocationAliasesArgs = {
  input: AddLocationAliasesInput;
};


export type MutationApproveUserAvailabilityArgs = {
  input: ApproveUserAvailabilityInput;
};


export type MutationCombineTripsArgs = {
  input: CreateCombineTripInput;
};


export type MutationCreateAccidentIssueBulkArgs = {
  input: CreateAccidentIssueBulkInput;
};


export type MutationCreateAccidentIssueDocumentBulkArgs = {
  input: CreateAccidentIssueDocumentBulkInput;
};


export type MutationCreateAccidentIssueDocumentPresignedUploadUrlArgs = {
  input: CreateIssuePresignedUrlInput;
};


export type MutationCreateActivityBulkArgs = {
  input: CreateActivityBulkInput;
};


export type MutationCreateAirlineBulkArgs = {
  input: CreateProviderBulkInput;
};


export type MutationCreateAirportHasVehicleBulkArgs = {
  input: CreateAirportHasVehicleBulkInput;
};


export type MutationCreateBufferTimeBulkArgs = {
  input: CreateBufferTimeBulkInput;
};


export type MutationCreateBufferTimesArgs = {
  input: CreateBufferTimesInput;
};


export type MutationCreateClientBulkArgs = {
  input: CreateProviderBulkInput;
};


export type MutationCreateCombineRuleBulkArgs = {
  input: CreateCombineRuleBulkInput;
};


export type MutationCreateCombineRuleHistoryBulkArgs = {
  input: CreateCombineRuleHistoryBulkInput;
};


export type MutationCreateCombineRuleWithCombineRuleHistoryBulkArgs = {
  input: CreateCombineRuleWithCombineRuleHistoryBulkInput;
};


export type MutationCreateCommunicationBulkArgs = {
  input: CreateCommunicationBulkInput;
};


export type MutationCreateCompletionBulkArgs = {
  input: CreateCompletionBulkInput;
};


export type MutationCreateCrewCountRequirementBulkArgs = {
  input: CreateCrewCountRequirementBulkInput;
};


export type MutationCreateCrewTripArgs = {
  input: CreateCrewTripInput;
};


export type MutationCreateDashboardBulkArgs = {
  input: CreateDashboardBulkInput;
};


export type MutationCreateDispatchIssueBulkArgs = {
  input: CreateDispatchIssueBulkInput;
};


export type MutationCreateDispatchIssueCausedByBulkArgs = {
  input: CreateDispatchIssueCausedByBulkInput;
};


export type MutationCreateDispatchIssueDocumentBulkArgs = {
  input: CreateDispatchIssueDocumentBulkInput;
};


export type MutationCreateDispatchIssueDocumentPresignedUploadUrlArgs = {
  input: CreateIssuePresignedUrlInput;
};


export type MutationCreateDispatchSummaryBulkArgs = {
  input: CreateDispatchSummaryBulkInput;
};


export type MutationCreateDispatchSummaryDocumentBulkArgs = {
  input: CreateDispatchSummaryDocumentBulkInput;
};


export type MutationCreateDispatchSummaryDocumentPresignedUploadUrlArgs = {
  input: CreateIssuePresignedUrlInput;
};


export type MutationCreateDispatchSummaryMarketBulkArgs = {
  input: CreateDispatchSummaryMarketBulkInput;
};


export type MutationCreateDownloadImportUrLsArgs = {
  input: CreateDownloadImportUrLsInput;
};


export type MutationCreateDtrImportArgs = {
  input: CreateDtrImportInput;
};


export type MutationCreateDtrLocationBulkArgs = {
  input: CreateDtrLocationBulkInput;
};


export type MutationCreateEmailBulkArgs = {
  input: CreateEmailBulkInput;
};


export type MutationCreateFcrBulkArgs = {
  input: CreateFcrBulkInput;
};


export type MutationCreateFlagBulkArgs = {
  input: CreateFlagBulkInput;
};


export type MutationCreateFlagHasPotentialTripBulkArgs = {
  input: CreateFlagHasPotentialTripBulkInput;
};


export type MutationCreateFlagHasTripBulkArgs = {
  input: CreateFlagHasTripBulkInput;
};


export type MutationCreateGroupBulkArgs = {
  input: CreateGroupBulkInput;
};


export type MutationCreateGroupHasPermissionBulkArgs = {
  input: CreateGroupHasPermissionBulkInput;
};


export type MutationCreateGroupHasUserBulkArgs = {
  input: CreateGroupHasUserBulkInput;
};


export type MutationCreateImageBulkArgs = {
  input: CreateImageBulkInput;
};


export type MutationCreateImportsArgs = {
  input: CreateImportsInput;
};


export type MutationCreateIncidentIssueBulkArgs = {
  input: CreateIncidentIssueBulkInput;
};


export type MutationCreateIncidentIssueDocumentBulkArgs = {
  input: CreateIncidentIssueDocumentBulkInput;
};


export type MutationCreateIncidentIssueDocumentPresignedUploadUrlArgs = {
  input: CreateIssuePresignedUrlInput;
};


export type MutationCreateLicenseBulkArgs = {
  input: CreateLicenseBulkInput;
};


export type MutationCreateLocationBulkArgs = {
  input: CreateLocationBulkInput;
};


export type MutationCreateLocationsArgs = {
  input: CreateLocationsInput;
};


export type MutationCreateLostAndFoundIssueBulkArgs = {
  input: CreateLostAndFoundIssueBulkInput;
};


export type MutationCreateLostAndFoundIssueDocumentBulkArgs = {
  input: CreateLostAndFoundIssueDocumentBulkInput;
};


export type MutationCreateLostAndFoundIssueDocumentPresignedUploadUrlArgs = {
  input: CreateIssuePresignedUrlInput;
};


export type MutationCreatePermissionHasRoleBulkArgs = {
  input: CreatePermissionHasRoleBulkInput;
};


export type MutationCreatePermissionHasUserBulkArgs = {
  input: CreatePermissionHasUserBulkInput;
};


export type MutationCreatePickupPointBulkArgs = {
  input: CreatePickupPointBulkInput;
};


export type MutationCreatePotentialTripBulkArgs = {
  input: CreatePotentialTripBulkInput;
};


export type MutationCreateProviderBulkArgs = {
  input: CreateProviderBulkInput;
};


export type MutationCreateProviderLocationMappingBulkArgs = {
  input: CreateProviderLocationMappingBulkInput;
};


export type MutationCreatePunchPolicyBulkArgs = {
  input: CreatePunchPolicyBulkInput;
};


export type MutationCreateQueryHistoryBulkArgs = {
  input: CreateQueryHistoryBulkInput;
};


export type MutationCreateQuestionnaireAnswerOptionBulkArgs = {
  input: CreateQuestionnaireAnswerOptionBulkInput;
};


export type MutationCreateQuestionnaireAnswerTypeBulkArgs = {
  input: CreateQuestionnaireAnswerTypeBulkInput;
};


export type MutationCreateQuestionnaireCategoryBulkArgs = {
  input: CreateQuestionnaireCategoryBulkInput;
};


export type MutationCreateQuestionnaireCategoryWithGroupsArgs = {
  input: CreateQuestionnaireCategoryWithGroupsInput;
};


export type MutationCreateQuestionnaireQuestionBulkArgs = {
  input: CreateQuestionnaireQuestionBulkInput;
};


export type MutationCreateRateBulkArgs = {
  input: CreateRateBulkInput;
};


export type MutationCreateRateForTripsArgs = {
  input: CreateRateForTripsInput;
};


export type MutationCreateRateGroupBulkArgs = {
  input: CreateRateGroupBulkInput;
};


export type MutationCreateRateItemBulkArgs = {
  input: CreateRateItemBulkInput;
};


export type MutationCreateRatingBulkArgs = {
  input: CreateRatingBulkInput;
};


export type MutationCreateRatingRemarkBulkArgs = {
  input: CreateRatingRemarkBulkInput;
};


export type MutationCreateRoleBulkArgs = {
  input: CreateRoleBulkInput;
};


export type MutationCreateStopBulkArgs = {
  input: CreateStopBulkInput;
};


export type MutationCreateTimeFrameBulkArgs = {
  input: CreateTimeFrameBulkInput;
};


export type MutationCreateTimeFrameRangeBulkArgs = {
  input: CreateTimeFrameRangeBulkInput;
};


export type MutationCreateTripDocumentBulkArgs = {
  input: CreateTripDocumentBulkInput;
};


export type MutationCreateTripDocumentDownloadUrlArgs = {
  input: CreateTripDownloadUrlInput;
};


export type MutationCreateTripDocumentPresignedUploadUrlArgs = {
  input: CreateTripDocumentPresignedUploadUrlInput;
};


export type MutationCreateTripsArgs = {
  input: CreateTripsInput;
};


export type MutationCreateUserAvailabilityBulkArgs = {
  input: CreateUserAvailabilityBulkInput;
};


export type MutationCreateUserBulkArgs = {
  input: CreateUserBulkInput;
};


export type MutationCreateVariableTimeBulkArgs = {
  input: CreateVariableTimeBulkInput;
};


export type MutationCreateVehicleBulkArgs = {
  input: CreateVehicleBulkInput;
};


export type MutationCreateWidgetBulkArgs = {
  input: CreateWidgetBulkInput;
};


export type MutationDeleteAccidentIssueBulkArgs = {
  input: DeleteAccidentIssueBulkInput;
};


export type MutationDeleteAccidentIssueDocumentBulkArgs = {
  input: DeleteAccidentIssueDocumentBulkInput;
};


export type MutationDeleteAirlineBulkArgs = {
  input: DeleteProviderBulkInput;
};


export type MutationDeleteAirportHasVehicleBulkArgs = {
  input: DeleteAirportHasVehicleBulkInput;
};


export type MutationDeleteBufferTimeBulkArgs = {
  input: DeleteBufferTimeBulkInput;
};


export type MutationDeleteBufferTimesArgs = {
  input: DeleteBufferTimesInput;
};


export type MutationDeleteClientBulkArgs = {
  input: DeleteProviderBulkInput;
};


export type MutationDeleteCombineRuleBulkArgs = {
  input: DeleteCombineRuleBulkInput;
};


export type MutationDeleteCombineRuleHistoryBulkArgs = {
  input: DeleteCombineRuleHistoryBulkInput;
};


export type MutationDeleteCommunicationBulkArgs = {
  input: DeleteCommunicationBulkInput;
};


export type MutationDeleteCompletionBulkArgs = {
  input: DeleteCompletionBulkInput;
};


export type MutationDeleteCrewCountRequirementBulkArgs = {
  input: DeleteCrewCountRequirementBulkInput;
};


export type MutationDeleteDashboardBulkArgs = {
  input: DeleteDashboardBulkInput;
};


export type MutationDeleteDispatchIssueBulkArgs = {
  input: DeleteDispatchIssueBulkInput;
};


export type MutationDeleteDispatchIssueCausedByBulkArgs = {
  input: DeleteDispatchIssueCausedByBulkInput;
};


export type MutationDeleteDispatchIssueDocumentBulkArgs = {
  input: DeleteDispatchIssueDocumentBulkInput;
};


export type MutationDeleteDispatchSummaryBulkArgs = {
  input: DeleteDispatchSummaryBulkInput;
};


export type MutationDeleteDispatchSummaryDocumentBulkArgs = {
  input: DeleteDispatchSummaryDocumentBulkInput;
};


export type MutationDeleteDispatchSummaryMarketBulkArgs = {
  input: DeleteDispatchSummaryMarketBulkInput;
};


export type MutationDeleteDtrLocationBulkArgs = {
  input: DeleteDtrLocationBulkInput;
};


export type MutationDeleteEmailBulkArgs = {
  input: DeleteEmailBulkInput;
};


export type MutationDeleteFcrBulkArgs = {
  input: DeleteFcrBulkInput;
};


export type MutationDeleteFlagBulkArgs = {
  input: DeleteFlagBulkInput;
};


export type MutationDeleteFlagHasPotentialTripBulkArgs = {
  input: DeleteFlagHasPotentialTripBulkInput;
};


export type MutationDeleteFlagHasTripBulkArgs = {
  input: DeleteFlagHasTripBulkInput;
};


export type MutationDeleteGroupBulkArgs = {
  input: DeleteGroupBulkInput;
};


export type MutationDeleteGroupHasPermissionBulkArgs = {
  input: DeleteGroupHasPermissionBulkInput;
};


export type MutationDeleteGroupHasUserBulkArgs = {
  input: DeleteGroupHasUserBulkInput;
};


export type MutationDeleteImageBulkArgs = {
  input: DeleteImageBulkInput;
};


export type MutationDeleteImportBulkArgs = {
  input: DeleteImportBulkInput;
};


export type MutationDeleteIncidentIssueBulkArgs = {
  input: DeleteIncidentIssueBulkInput;
};


export type MutationDeleteIncidentIssueDocumentBulkArgs = {
  input: DeleteIncidentIssueDocumentBulkInput;
};


export type MutationDeleteLicenseBulkArgs = {
  input: DeleteLicenseBulkInput;
};


export type MutationDeleteLocationBulkArgs = {
  input: DeleteLocationBulkInput;
};


export type MutationDeleteLostAndFoundIssueBulkArgs = {
  input: DeleteLostAndFoundIssueBulkInput;
};


export type MutationDeleteLostAndFoundIssueDocumentBulkArgs = {
  input: DeleteLostAndFoundIssueDocumentBulkInput;
};


export type MutationDeleteManifestHistoryBulkArgs = {
  input: DeleteManifestHistoryBulkInput;
};


export type MutationDeleteManifestHistoryRouteBulkArgs = {
  input: DeleteManifestHistoryRouteBulkInput;
};


export type MutationDeletePermissionHasRoleBulkArgs = {
  input: DeletePermissionHasRoleBulkInput;
};


export type MutationDeletePermissionHasUserBulkArgs = {
  input: DeletePermissionHasUserBulkInput;
};


export type MutationDeletePickupPointBulkArgs = {
  input: DeletePickupPointBulkInput;
};


export type MutationDeleteProviderBulkArgs = {
  input: DeleteProviderBulkInput;
};


export type MutationDeleteProviderLocationMappingBulkArgs = {
  input: DeleteProviderLocationMappingBulkInput;
};


export type MutationDeletePunchPolicyBulkArgs = {
  input: DeletePunchPolicyBulkInput;
};


export type MutationDeleteQueryHistoryBulkArgs = {
  input: DeleteQueryHistoryBulkInput;
};


export type MutationDeleteQuestionnaireAnswerOptionBulkArgs = {
  input: DeleteQuestionnaireAnswerOptionBulkInput;
};


export type MutationDeleteQuestionnaireAnswerTypeBulkArgs = {
  input: DeleteQuestionnaireAnswerTypeBulkInput;
};


export type MutationDeleteQuestionnaireCategoryBulkArgs = {
  input: DeleteQuestionnaireCategoryBulkInput;
};


export type MutationDeleteQuestionnaireQuestionBulkArgs = {
  input: DeleteQuestionnaireQuestionBulkInput;
};


export type MutationDeleteRateBulkArgs = {
  input: DeleteRateBulkInput;
};


export type MutationDeleteRateGroupBulkArgs = {
  input: DeleteRateGroupBulkInput;
};


export type MutationDeleteRateItemBulkArgs = {
  input: DeleteRateItemBulkInput;
};


export type MutationDeleteRoleBulkArgs = {
  input: DeleteRoleBulkInput;
};


export type MutationDeleteStopBulkArgs = {
  input: DeleteStopBulkInput;
};


export type MutationDeleteTimeFrameBulkArgs = {
  input: DeleteTimeFrameBulkInput;
};


export type MutationDeleteTimeFrameRangeBulkArgs = {
  input: DeleteTimeFrameRangeBulkInput;
};


export type MutationDeleteTripBulkArgs = {
  input: DeleteTripBulkInput;
};


export type MutationDeleteTripDocumentBulkArgs = {
  input: DeleteTripDocumentBulkInput;
};


export type MutationDeleteTripHardBulkArgs = {
  input: DeleteTripHardBulkInput;
};


export type MutationDeleteUserAvailabilityAndUnassignBulkArgs = {
  input: DeleteUserAvailabilityBulkInput;
};


export type MutationDeleteUserAvailabilityBulkArgs = {
  input: DeleteUserAvailabilityBulkInput;
};


export type MutationDeleteUserAvailabilitySeriesAndUnassignBulkArgs = {
  input: DeleteUserAvailabilityBulkInput;
};


export type MutationDeleteUserAvailabilitySeriesBulkArgs = {
  input: DeleteUserAvailabilityBulkInput;
};


export type MutationDeleteUserBulkArgs = {
  input: DeleteUserBulkInput;
};


export type MutationDeleteVariableTimeBulkArgs = {
  input: DeleteVariableTimeBulkInput;
};


export type MutationDeleteVehicleBulkArgs = {
  input: DeleteVehicleBulkInput;
};


export type MutationDeleteWidgetBulkArgs = {
  input: DeleteWidgetBulkInput;
};


export type MutationDownloadChatHistoryAsCsvArgs = {
  input: SearchChatHistoryInput;
};


export type MutationDownloadDriveTimeReportPdfArgs = {
  input: DownloadDriveTimeReportPdfInput;
};


export type MutationDownloadInvoiceDocumentArgs = {
  input: DownloadInvoiceDocumentInput;
};


export type MutationDownloadQuestionnaireAnswerOptionAsCsvArgs = {
  input: DownloadQuestionnaireAnswerOptionAsCsvInput;
};


export type MutationDownloadQuestionnaireAnswerTypeAsCsvArgs = {
  input: DownloadQuestionnaireAnswerTypeAsCsvInput;
};


export type MutationDownloadQuestionnaireCategoryAsCsvArgs = {
  input: DownloadQuestionnaireCategoryAsCsvInput;
};


export type MutationDownloadQuestionnaireQuestionAsCsvArgs = {
  input: DownloadQuestionnaireQuestionAsCsvInput;
};


export type MutationDownloadTrainingReportPdfArgs = {
  input: DownloadTrainingReportPdfInput;
};


export type MutationForgotPasswordArgs = {
  input: ForgotPasswordInput;
};


export type MutationGenerateDriveTimeReportPdfArgs = {
  input: GenerateDriveTimeReportPdfInput;
};


export type MutationGenerateInvoiceDocumentArgs = {
  input: GenerateInvoiceDocumentInput;
};


export type MutationGenerateInvoiceDocumentUploadUrlArgs = {
  input: GenerateInvoiceDocumentUploadUrlInput;
};


export type MutationGeneratePunchHistoryUploadUrlsArgs = {
  input: GeneratePunchHistoryUploadUrlsInput;
};


export type MutationGenerateTrainingReportPdfArgs = {
  input: GenerateTrainingReportPdfInput;
};


export type MutationGenerateUploadProfileImageUrlArgs = {
  input: GenerateUploadProfileImageUrlInput;
};


export type MutationGetPredictiveDriveTimeReportAsCsvArgs = {
  input: GetPredictiveDriveTimeReportAsCsvInput;
};


export type MutationLoginArgs = {
  input: LoginInput;
};


export type MutationReportImportProblemArgs = {
  input: ReportImportProblemInput;
};


export type MutationReportProblemArgs = {
  input: ReportProblemInput;
};


export type MutationResetPasswordLinkCodeArgs = {
  input: ResetPasswordLinkCodeInput;
};


export type MutationResubmitManifestHistoryArgs = {
  input: ResubmitManifestHistoryInput;
};


export type MutationResubmitQueryHistoryArgs = {
  input: ResubmitQueryHistoryInput;
};


export type MutationRunApplyRateToSimilarTripsArgs = {
  input: RunApplyRateToSimilarTripsInput;
};


export type MutationRunArchiveImportsArgs = {
  input: RunArchiveImportsInput;
};


export type MutationRunArchiveInvoicesArgs = {
  input: RunArchiveInvoicesInput;
};


export type MutationRunAssignDriverArgs = {
  input: RunAssignDriverInput;
};


export type MutationRunAssignVehicleToDriverBulkArgs = {
  input: RunAssignVehicleToDriverBulkInput;
};


export type MutationRunAutoCombineDriverTripsArgs = {
  input: RunAutoCombineDriverTripsInput;
};


export type MutationRunCompletionOnTripArgs = {
  input: RunCompletionOnTripInput;
};


export type MutationRunDownloadImportArgs = {
  input: RunDownloadImportInput;
};


export type MutationRunDownloadInvoiceArgs = {
  input: RunDownloadInvoiceInput;
};


export type MutationRunDownloadLatestInvoiceDocumentArgs = {
  input: RunDownloadLatestInvoiceDocumentInput;
};


export type MutationRunIngestImportsArgs = {
  input: RunIngestImportsInput;
};


export type MutationRunOverrideImportsArgs = {
  input: RunOverrideImportsInput;
};


export type MutationRunParseImportLocationsArgs = {
  input: RunParseImportLocationsInput;
};


export type MutationRunParseImportsArgs = {
  input: RunParseImportsInput;
};


export type MutationRunPreviewImportsArgs = {
  input: RunPreviewImportsInput;
};


export type MutationRunPreviewInvoiceArgs = {
  input: RunPreviewInvoiceInput;
};


export type MutationRunRateAmountOnTripsArgs = {
  input: RunRateAmountOnTripsInput;
};


export type MutationRunRateOverrideArgs = {
  input: RunRateOverrideInput;
};


export type MutationRunRemoveCompletionOnTripArgs = {
  input: RunRemoveCompletionOnTripInput;
};


export type MutationRunResetUserPasswordBulkArgs = {
  input: RunResetUserPasswordBulkInput;
};


export type MutationRunRollbackImportsArgs = {
  input: RunRollbackImportsInput;
};


export type MutationRunSaveAndSendInvoiceArgs = {
  input: RunSaveAndSendInvoiceInput;
};


export type MutationRunSaveAsInvoiceArgs = {
  input: RunSaveAsInvoiceInput;
};


export type MutationRunSaveInvoiceArgs = {
  input: RunSaveInvoiceInput;
};


export type MutationRunScheduleAutomationArgs = {
  input: RunScheduleAutomationInput;
};


export type MutationRunUnarchiveInvoicesArgs = {
  input: RunUnarchiveInvoicesInput;
};


export type MutationRunUnassignDriverArgs = {
  input: RunUnassignDriverInput;
};


export type MutationRunUpdateUserProfileBulkArgs = {
  input: RunUpdateUserProfileBulkInput;
};


export type MutationRunUpdateUserVehicleBulkArgs = {
  input: RunUpdateUserVehicleBulkInput;
};


export type MutationSaveQuestionnaireAnswerArgs = {
  input: SaveQuestionnaireAnswerInput;
};


export type MutationScheduleAutomationRunDriverAssignmentArgs = {
  input: ScheduleAutomationRunDriverAssignmentInput;
};


export type MutationSendInvoiceEmailArgs = {
  input: SendInvoiceEmailInput;
};


export type MutationSetQuestionnaireCategoryGroupsArgs = {
  input: SetQuestionnaireCategoryGroupsInput;
};


export type MutationStartEvaluationArgs = {
  input: StartEvaluationInput;
};


export type MutationSubmitCategoryArgs = {
  input: SubmitCategoryInput;
};


export type MutationSubmitEvaluationArgs = {
  input: SubmitEvaluationInput;
};


export type MutationUndeleteTripBulkArgs = {
  input: UndeleteTripBulkInput;
};


export type MutationUpdateAccidentIssueBulkArgs = {
  input: UpdateAccidentIssueBulkInput;
};


export type MutationUpdateAccidentIssueDocumentBulkArgs = {
  input: UpdateAccidentIssueDocumentBulkInput;
};


export type MutationUpdateAirlineBulkArgs = {
  input: UpdateProviderBulkInput;
};


export type MutationUpdateBufferTimeBulkArgs = {
  input: UpdateBufferTimeBulkInput;
};


export type MutationUpdateClientBulkArgs = {
  input: UpdateProviderBulkInput;
};


export type MutationUpdateCombineRuleBulkArgs = {
  input: UpdateCombineRuleBulkInput;
};


export type MutationUpdateCombineRuleHistoryBulkArgs = {
  input: UpdateCombineRuleHistoryBulkInput;
};


export type MutationUpdateCompletionBulkArgs = {
  input: UpdateCompletionBulkInput;
};


export type MutationUpdateCrewCountRequirementBulkArgs = {
  input: UpdateCrewCountRequirementBulkInput;
};


export type MutationUpdateDashboardBulkArgs = {
  input: UpdateDashboardBulkInput;
};


export type MutationUpdateDispatchIssueBulkArgs = {
  input: UpdateDispatchIssueBulkInput;
};


export type MutationUpdateDispatchIssueCausedByBulkArgs = {
  input: UpdateDispatchIssueCausedByBulkInput;
};


export type MutationUpdateDispatchIssueDocumentBulkArgs = {
  input: UpdateDispatchIssueDocumentBulkInput;
};


export type MutationUpdateDispatchSummaryBulkArgs = {
  input: UpdateDispatchSummaryBulkInput;
};


export type MutationUpdateDispatchSummaryDocumentBulkArgs = {
  input: UpdateDispatchSummaryDocumentBulkInput;
};


export type MutationUpdateDispatchSummaryMarketBulkArgs = {
  input: UpdateDispatchSummaryMarketBulkInput;
};


export type MutationUpdateDtrLocationBulkArgs = {
  input: UpdateDtrLocationBulkInput;
};


export type MutationUpdateEmailBulkArgs = {
  input: UpdateEmailBulkInput;
};


export type MutationUpdateFlagBulkArgs = {
  input: UpdateFlagBulkInput;
};


export type MutationUpdateFullWidgetBulkArgs = {
  input: UpdateFullWidgetBulkInput;
};


export type MutationUpdateImportBulkArgs = {
  input: UpdateImportBulkInput;
};


export type MutationUpdateImportProviderArgs = {
  input: UpdateImportProviderInput;
};


export type MutationUpdateImportsStatusArgs = {
  input: UpdateImportsStatusInput;
};


export type MutationUpdateIncidentIssueBulkArgs = {
  input: UpdateIncidentIssueBulkInput;
};


export type MutationUpdateIncidentIssueDocumentBulkArgs = {
  input: UpdateIncidentIssueDocumentBulkInput;
};


export type MutationUpdateLicenseBulkArgs = {
  input: UpdateLicenseBulkInput;
};


export type MutationUpdateLocationBulkArgs = {
  input: UpdateLocationBulkInput;
};


export type MutationUpdateLocationByIdArgs = {
  input: UpdateLocationByIdInput;
};


export type MutationUpdateLostAndFoundIssueBulkArgs = {
  input: UpdateLostAndFoundIssueBulkInput;
};


export type MutationUpdateLostAndFoundIssueDocumentBulkArgs = {
  input: UpdateLostAndFoundIssueDocumentBulkInput;
};


export type MutationUpdatePasswordsArgs = {
  input: UpdatePasswordsInput;
};


export type MutationUpdatePickupPointBulkArgs = {
  input: UpdatePickupPointBulkInput;
};


export type MutationUpdatePotentialTripBulkArgs = {
  input: UpdatePotentialTripBulkInput;
};


export type MutationUpdateProviderBulkArgs = {
  input: UpdateProviderBulkInput;
};


export type MutationUpdateProviderLocationMappingBulkArgs = {
  input: UpdateProviderLocationMappingBulkInput;
};


export type MutationUpdatePunchPolicyBulkArgs = {
  input: UpdatePunchPolicyBulkInput;
};


export type MutationUpdateQueryHistoryBulkArgs = {
  input: UpdateQueryHistoryBulkInput;
};


export type MutationUpdateQuestionnaireAnswerOptionBulkArgs = {
  input: UpdateQuestionnaireAnswerOptionBulkInput;
};


export type MutationUpdateQuestionnaireAnswerTypeBulkArgs = {
  input: UpdateQuestionnaireAnswerTypeBulkInput;
};


export type MutationUpdateQuestionnaireCategoryBulkArgs = {
  input: UpdateQuestionnaireCategoryBulkInput;
};


export type MutationUpdateQuestionnaireQuestionBulkArgs = {
  input: UpdateQuestionnaireQuestionBulkInput;
};


export type MutationUpdateRateBulkArgs = {
  input: UpdateRateBulkInput;
};


export type MutationUpdateRateItemBulkArgs = {
  input: UpdateRateItemBulkInput;
};


export type MutationUpdateRateOnTripsArgs = {
  input: UpdateRateOnTripsInput;
};


export type MutationUpdateStagedTripBulkArgs = {
  input: UpdateStagedTripBulkInput;
};


export type MutationUpdateStopBulkArgs = {
  input: UpdateStopBulkInput;
};


export type MutationUpdateTimeFrameBulkArgs = {
  input: UpdateTimeFrameBulkInput;
};


export type MutationUpdateTimeFrameRangeBulkArgs = {
  input: UpdateTimeFrameRangeBulkInput;
};


export type MutationUpdateTrackFlightBulkArgs = {
  input: UpdateTrackFlightBulkInput;
};


export type MutationUpdateTripBulkArgs = {
  input: UpdateTripBulkInput;
};


export type MutationUpdateTripDocumentBulkArgs = {
  input: UpdateTripDocumentBulkInput;
};


export type MutationUpdateUserActivationBulkArgs = {
  input: UpdateUserActivationBulkInput;
};


export type MutationUpdateUserAvailabilityBulkArgs = {
  input: UpdateUserAvailabilityBulkInput;
};


export type MutationUpdateUserAvailabilitySeriesBulkArgs = {
  input: UpdateUserAvailabilityBulkInput;
};


export type MutationUpdateUserBulkArgs = {
  input: UpdateUserBulkInput;
};


export type MutationUpdateVariableTimeBulkArgs = {
  input: UpdateVariableTimeBulkInput;
};


export type MutationUpdateVehicleBulkArgs = {
  input: UpdateVehicleBulkInput;
};

export type MutationCrud = {
  __typename?: 'MutationCrud';
  createAccidentIssueBulk: CreateAccidentIssueBulkResponse;
  createAccidentIssueDocumentBulk: CreateAccidentIssueDocumentBulkResponse;
  createActivityBulk: CreateActivityBulkResponse;
  createActivityObjectBulk: CreateActivityObjectBulkResponse;
  createAirportBulk: CreateAirportBulkResponse;
  createAirportGroupBulk: CreateAirportGroupBulkResponse;
  createAirportHasCompanyBulk: CreateAirportHasCompanyBulkResponse;
  createAirportHasGroupBulk: CreateAirportHasGroupBulkResponse;
  createAirportHasLocationBulk: CreateAirportHasLocationBulkResponse;
  createAirportHasManagerEmailBulk: CreateAirportHasManagerEmailBulkResponse;
  createAirportHasRateBulk: CreateAirportHasRateBulkResponse;
  createAirportHasVehicleBulk: CreateAirportHasVehicleBulkResponse;
  createAlertSubscriptionBulk: CreateAlertSubscriptionBulkResponse;
  createAliasBulk: CreateAliasBulkResponse;
  createApiKeyBulk: CreateApiKeyBulkResponse;
  createAuditSnapshotBulk: CreateAuditSnapshotBulkResponse;
  createAutoCombineRuleBulk: CreateAutoCombineRuleBulkResponse;
  createAutomationHistoryAirportBulk: CreateAutomationHistoryAirportBulkResponse;
  createAutomationHistoryBulk: CreateAutomationHistoryBulkResponse;
  createAutomationHistoryLogBulk: CreateAutomationHistoryLogBulkResponse;
  createAutomationReportBulk: CreateAutomationReportBulkResponse;
  createAutomationTripAssignmentReasonBulk: CreateAutomationTripAssignmentReasonBulkResponse;
  createAutomationTripBulk: CreateAutomationTripBulkResponse;
  createAutomationTripLogBulk: CreateAutomationTripLogBulkResponse;
  createBufferTimeBulk: CreateBufferTimeBulkResponse;
  createCancellationRuleBulk: CreateCancellationRuleBulkResponse;
  createCharityAmountHistoryBulk: CreateCharityAmountHistoryBulkResponse;
  createCharityBulk: CreateCharityBulkResponse;
  createCharityRatingHistoryBulk: CreateCharityRatingHistoryBulkResponse;
  createCharityRatingHistoryReportBulk: CreateCharityRatingHistoryReportBulkResponse;
  createChatQuickReplyMessageBulk: CreateChatQuickReplyMessageBulkResponse;
  createCheckinEventBulk: CreateCheckinEventBulkResponse;
  createCombineRuleBulk: CreateCombineRuleBulkResponse;
  createCombineRuleHistoryBulk: CreateCombineRuleHistoryBulkResponse;
  createCommunicationBulk: CreateCommunicationBulkResponse;
  createCompanyBulk: CreateCompanyBulkResponse;
  createCompletionBulk: CreateCompletionBulkResponse;
  createCompletionTypeBulk: CreateCompletionTypeBulkResponse;
  createContractBulk: CreateContractBulkResponse;
  createContractEmailBulk: CreateContractEmailBulkResponse;
  createContractNumberBulk: CreateContractNumberBulkResponse;
  createCountryRegionBulk: CreateCountryRegionBulkResponse;
  createCrewCountRequirementBulk: CreateCrewCountRequirementBulkResponse;
  createDashboardBulk: CreateDashboardBulkResponse;
  createDefectBulk: CreateDefectBulkResponse;
  createDeviceBulk: CreateDeviceBulkResponse;
  createDeviceMetricBulk: CreateDeviceMetricBulkResponse;
  createDispatchIssueBulk: CreateDispatchIssueBulkResponse;
  createDispatchIssueCausedByBulk: CreateDispatchIssueCausedByBulkResponse;
  createDispatchIssueDocumentBulk: CreateDispatchIssueDocumentBulkResponse;
  createDispatchSummaryBulk: CreateDispatchSummaryBulkResponse;
  createDispatchSummaryDocumentBulk: CreateDispatchSummaryDocumentBulkResponse;
  createDispatchSummaryMarketBulk: CreateDispatchSummaryMarketBulkResponse;
  createDistanceBulk: CreateDistanceBulkResponse;
  createDriverEtaBulk: CreateDriverEtaBulkResponse;
  createDriverVehicleAssignmentBulk: CreateDriverVehicleAssignmentBulkResponse;
  createDtrLocationBulk: CreateDtrLocationBulkResponse;
  createDvirBulk: CreateDvirBulkResponse;
  createDvirSignatureBulk: CreateDvirSignatureBulkResponse;
  createEmailBulk: CreateEmailBulkResponse;
  createEquivalentTripBulk: CreateEquivalentTripBulkResponse;
  createEventBulk: CreateEventBulkResponse;
  createFcrBulk: CreateFcrBulkResponse;
  createFcrTypeBulk: CreateFcrTypeBulkResponse;
  createFlagBulk: CreateFlagBulkResponse;
  createFlagHasPotentialTripBulk: CreateFlagHasPotentialTripBulkResponse;
  createFlagHasStagedTripBulk: CreateFlagHasStagedTripBulkResponse;
  createFlagHasTripBulk: CreateFlagHasTripBulkResponse;
  createFlightHistoryBulk: CreateFlightHistoryBulkResponse;
  createGeneratedDocumentBulk: CreateGeneratedDocumentBulkResponse;
  createGeneratedDocumentLogBulk: CreateGeneratedDocumentLogBulkResponse;
  createGroupBulk: CreateGroupBulkResponse;
  createGroupHasPermissionBulk: CreateGroupHasPermissionBulkResponse;
  createGroupHasUserBulk: CreateGroupHasUserBulkResponse;
  createImageBulk: CreateImageBulkResponse;
  createImportBulk: CreateImportBulkResponse;
  createImportEmailBulk: CreateImportEmailBulkResponse;
  createImportFailureBulk: CreateImportFailureBulkResponse;
  createImportLogBulk: CreateImportLogBulkResponse;
  createImportOcrCacheBulk: CreateImportOcrCacheBulkResponse;
  createIncidentIssueBulk: CreateIncidentIssueBulkResponse;
  createIncidentIssueDocumentBulk: CreateIncidentIssueDocumentBulkResponse;
  createIndexBulk: CreateIndexBulkResponse;
  createInvoiceAirportBulk: CreateInvoiceAirportBulkResponse;
  createInvoiceBulk: CreateInvoiceBulkResponse;
  createInvoiceClientBulk: CreateInvoiceClientBulkResponse;
  createInvoiceCustomChargeBulk: CreateInvoiceCustomChargeBulkResponse;
  createInvoiceDocumentBulk: CreateInvoiceDocumentBulkResponse;
  createInvoiceEmailBulk: CreateInvoiceEmailBulkResponse;
  createInvoiceHeaderBulk: CreateInvoiceHeaderBulkResponse;
  createInvoiceIataCodeBulk: CreateInvoiceIataCodeBulkResponse;
  createInvoiceLineItemBulk: CreateInvoiceLineItemBulkResponse;
  createInvoiceProviderCacheBulk: CreateInvoiceProviderCacheBulkResponse;
  createInvoiceTermBulk: CreateInvoiceTermBulkResponse;
  createInvoiceTotalSummaryBulk: CreateInvoiceTotalSummaryBulkResponse;
  createInvoiceTripBulk: CreateInvoiceTripBulkResponse;
  createInvoiceTripStatusBulk: CreateInvoiceTripStatusBulkResponse;
  createInvoiceTypeBulk: CreateInvoiceTypeBulkResponse;
  createInvoiceUserCacheBulk: CreateInvoiceUserCacheBulkResponse;
  createIssueBulk: CreateIssueBulkResponse;
  createLicenseBulk: CreateLicenseBulkResponse;
  createLicenseTypeBulk: CreateLicenseTypeBulkResponse;
  createLineItemTypeBulk: CreateLineItemTypeBulkResponse;
  createLocationBulk: CreateLocationBulkResponse;
  createLoginEventBulk: CreateLoginEventBulkResponse;
  createLostAndFoundIssueBulk: CreateLostAndFoundIssueBulkResponse;
  createLostAndFoundIssueDocumentBulk: CreateLostAndFoundIssueDocumentBulkResponse;
  createManifestHistoryBulk: CreateManifestHistoryBulkResponse;
  createManifestHistoryRouteBulk: CreateManifestHistoryRouteBulkResponse;
  createManifestProviderCacheBulk: CreateManifestProviderCacheBulkResponse;
  createManifestUserCacheBulk: CreateManifestUserCacheBulkResponse;
  createMessageBulk: CreateMessageBulkResponse;
  createNotificationBulk: CreateNotificationBulkResponse;
  createNotificationHasEventBulk: CreateNotificationHasEventBulkResponse;
  createParsedTripBulk: CreateParsedTripBulkResponse;
  createPermissionBulk: CreatePermissionBulkResponse;
  createPermissionHasRoleBulk: CreatePermissionHasRoleBulkResponse;
  createPermissionHasUserBulk: CreatePermissionHasUserBulkResponse;
  createPickupPointBulk: CreatePickupPointBulkResponse;
  createPotentialTripBulk: CreatePotentialTripBulkResponse;
  createProviderAliasBulk: CreateProviderAliasBulkResponse;
  createProviderBulk: CreateProviderBulkResponse;
  createProviderCacheBulk: CreateProviderCacheBulkResponse;
  createProviderLocationMappingBulk: CreateProviderLocationMappingBulkResponse;
  createPunchBulk: CreatePunchBulkResponse;
  createPunchHistoryBulk: CreatePunchHistoryBulkResponse;
  createPunchPolicyBulk: CreatePunchPolicyBulkResponse;
  createQueryHistoryBulk: CreateQueryHistoryBulkResponse;
  createQuestionnaireAnswerOptionBulk: CreateQuestionnaireAnswerOptionBulkResponse;
  createQuestionnaireAnswerTypeBulk: CreateQuestionnaireAnswerTypeBulkResponse;
  createQuestionnaireAttemptAnswerOptionSnapshotBulk: CreateQuestionnaireAttemptAnswerOptionSnapshotBulkResponse;
  createQuestionnaireAttemptBulk: CreateQuestionnaireAttemptBulkResponse;
  createQuestionnaireAttemptCategorySnapshotAllowedGroupBulk: CreateQuestionnaireAttemptCategorySnapshotAllowedGroupBulkResponse;
  createQuestionnaireAttemptCategorySnapshotBulk: CreateQuestionnaireAttemptCategorySnapshotBulkResponse;
  createQuestionnaireAttemptCategorySnapshotGroupBulk: CreateQuestionnaireAttemptCategorySnapshotGroupBulkResponse;
  createQuestionnaireAttemptNoteBulk: CreateQuestionnaireAttemptNoteBulkResponse;
  createQuestionnaireAttemptQuestionSnapshotBulk: CreateQuestionnaireAttemptQuestionSnapshotBulkResponse;
  createQuestionnaireCategoryBulk: CreateQuestionnaireCategoryBulkResponse;
  createQuestionnaireQuestionBulk: CreateQuestionnaireQuestionBulkResponse;
  createRateBulk: CreateRateBulkResponse;
  createRateGroupBulk: CreateRateGroupBulkResponse;
  createRateHistoryBulk: CreateRateHistoryBulkResponse;
  createRateItemBulk: CreateRateItemBulkResponse;
  createRatingBulk: CreateRatingBulkResponse;
  createRatingCacheBulk: CreateRatingCacheBulkResponse;
  createRatingCacheRemarkBulk: CreateRatingCacheRemarkBulkResponse;
  createRatingRemarkBulk: CreateRatingRemarkBulkResponse;
  createRatingTypeBulk: CreateRatingTypeBulkResponse;
  createRoleBulk: CreateRoleBulkResponse;
  createSettingsBulk: CreateSettingsBulkResponse;
  createSocialDistanceRuleBulk: CreateSocialDistanceRuleBulkResponse;
  createStagedTripBulk: CreateStagedTripBulkResponse;
  createStopBulk: CreateStopBulkResponse;
  createStorageBulk: CreateStorageBulkResponse;
  createTimeFrameBulk: CreateTimeFrameBulkResponse;
  createTimeFrameRangeBulk: CreateTimeFrameRangeBulkResponse;
  createTrackFlightBulk: CreateTrackFlightBulkResponse;
  createTrainingUserCacheBulk: CreateTrainingUserCacheBulkResponse;
  createTripBulk: CreateTripBulkResponse;
  createTripDocumentBulk: CreateTripDocumentBulkResponse;
  createTripHasImportBulk: CreateTripHasImportBulkResponse;
  createTripScheduleTriggerBulk: CreateTripScheduleTriggerBulkResponse;
  createUpdateStrategyBulk: CreateUpdateStrategyBulkResponse;
  createUserAvailabilityBulk: CreateUserAvailabilityBulkResponse;
  createUserBulk: CreateUserBulkResponse;
  createUserCacheBulk: CreateUserCacheBulkResponse;
  createUserHasAirportBulk: CreateUserHasAirportBulkResponse;
  createVariableTimeBulk: CreateVariableTimeBulkResponse;
  createVehicleBulk: CreateVehicleBulkResponse;
  createWidgetBulk: CreateWidgetBulkResponse;
  createWidgetFilterBulk: CreateWidgetFilterBulkResponse;
  deleteAccidentIssueBulk: DeleteAccidentIssueBulkResponse;
  deleteAccidentIssueDocumentBulk: DeleteAccidentIssueDocumentBulkResponse;
  deleteActivityBulk: DeleteActivityBulkResponse;
  deleteActivityObjectBulk: DeleteActivityObjectBulkResponse;
  deleteAirportBulk: DeleteAirportBulkResponse;
  deleteAirportGroupBulk: DeleteAirportGroupBulkResponse;
  deleteAirportHasCompanyBulk: DeleteAirportHasCompanyBulkResponse;
  deleteAirportHasGroupBulk: DeleteAirportHasGroupBulkResponse;
  deleteAirportHasLocationBulk: DeleteAirportHasLocationBulkResponse;
  deleteAirportHasManagerEmailBulk: DeleteAirportHasManagerEmailBulkResponse;
  deleteAirportHasRateBulk: DeleteAirportHasRateBulkResponse;
  deleteAirportHasVehicleBulk: DeleteAirportHasVehicleBulkResponse;
  deleteAlertSubscriptionBulk: DeleteAlertSubscriptionBulkResponse;
  deleteAliasBulk: DeleteAliasBulkResponse;
  deleteApiKeyBulk: DeleteApiKeyBulkResponse;
  deleteAuditSnapshotBulk: DeleteAuditSnapshotBulkResponse;
  deleteAutoCombineRuleBulk: DeleteAutoCombineRuleBulkResponse;
  deleteAutomationHistoryAirportBulk: DeleteAutomationHistoryAirportBulkResponse;
  deleteAutomationHistoryBulk: DeleteAutomationHistoryBulkResponse;
  deleteAutomationHistoryLogBulk: DeleteAutomationHistoryLogBulkResponse;
  deleteAutomationReportBulk: DeleteAutomationReportBulkResponse;
  deleteAutomationTripAssignmentReasonBulk: DeleteAutomationTripAssignmentReasonBulkResponse;
  deleteAutomationTripBulk: DeleteAutomationTripBulkResponse;
  deleteAutomationTripLogBulk: DeleteAutomationTripLogBulkResponse;
  deleteBufferTimeBulk: DeleteBufferTimeBulkResponse;
  deleteCancellationRuleBulk: DeleteCancellationRuleBulkResponse;
  deleteCharityAmountHistoryBulk: DeleteCharityAmountHistoryBulkResponse;
  deleteCharityBulk: DeleteCharityBulkResponse;
  deleteCharityRatingHistoryBulk: DeleteCharityRatingHistoryBulkResponse;
  deleteCharityRatingHistoryReportBulk: DeleteCharityRatingHistoryReportBulkResponse;
  deleteChatQuickReplyMessageBulk: DeleteChatQuickReplyMessageBulkResponse;
  deleteCheckinEventBulk: DeleteCheckinEventBulkResponse;
  deleteCombineRuleBulk: DeleteCombineRuleBulkResponse;
  deleteCombineRuleHistoryBulk: DeleteCombineRuleHistoryBulkResponse;
  deleteCommunicationBulk: DeleteCommunicationBulkResponse;
  deleteCompanyBulk: DeleteCompanyBulkResponse;
  deleteCompletionBulk: DeleteCompletionBulkResponse;
  deleteCompletionTypeBulk: DeleteCompletionTypeBulkResponse;
  deleteContractBulk: DeleteContractBulkResponse;
  deleteContractEmailBulk: DeleteContractEmailBulkResponse;
  deleteContractNumberBulk: DeleteContractNumberBulkResponse;
  deleteCountryRegionBulk: DeleteCountryRegionBulkResponse;
  deleteCrewCountRequirementBulk: DeleteCrewCountRequirementBulkResponse;
  deleteDashboardBulk: DeleteDashboardBulkResponse;
  deleteDefectBulk: DeleteDefectBulkResponse;
  deleteDeviceBulk: DeleteDeviceBulkResponse;
  deleteDeviceMetricBulk: DeleteDeviceMetricBulkResponse;
  deleteDispatchIssueBulk: DeleteDispatchIssueBulkResponse;
  deleteDispatchIssueCausedByBulk: DeleteDispatchIssueCausedByBulkResponse;
  deleteDispatchIssueDocumentBulk: DeleteDispatchIssueDocumentBulkResponse;
  deleteDispatchSummaryBulk: DeleteDispatchSummaryBulkResponse;
  deleteDispatchSummaryDocumentBulk: DeleteDispatchSummaryDocumentBulkResponse;
  deleteDispatchSummaryMarketBulk: DeleteDispatchSummaryMarketBulkResponse;
  deleteDistanceBulk: DeleteDistanceBulkResponse;
  deleteDriverEtaBulk: DeleteDriverEtaBulkResponse;
  deleteDriverVehicleAssignmentBulk: DeleteDriverVehicleAssignmentBulkResponse;
  deleteDtrLocationBulk: DeleteDtrLocationBulkResponse;
  deleteDvirBulk: DeleteDvirBulkResponse;
  deleteDvirSignatureBulk: DeleteDvirSignatureBulkResponse;
  deleteEmailBulk: DeleteEmailBulkResponse;
  deleteEquivalentTripBulk: DeleteEquivalentTripBulkResponse;
  deleteEventBulk: DeleteEventBulkResponse;
  deleteFcrBulk: DeleteFcrBulkResponse;
  deleteFcrTypeBulk: DeleteFcrTypeBulkResponse;
  deleteFlagBulk: DeleteFlagBulkResponse;
  deleteFlagHasPotentialTripBulk: DeleteFlagHasPotentialTripBulkResponse;
  deleteFlagHasStagedTripBulk: DeleteFlagHasStagedTripBulkResponse;
  deleteFlagHasTripBulk: DeleteFlagHasTripBulkResponse;
  deleteFlightHistoryBulk: DeleteFlightHistoryBulkResponse;
  deleteGeneratedDocumentBulk: DeleteGeneratedDocumentBulkResponse;
  deleteGeneratedDocumentLogBulk: DeleteGeneratedDocumentLogBulkResponse;
  deleteGroupBulk: DeleteGroupBulkResponse;
  deleteGroupHasPermissionBulk: DeleteGroupHasPermissionBulkResponse;
  deleteGroupHasUserBulk: DeleteGroupHasUserBulkResponse;
  deleteImageBulk: DeleteImageBulkResponse;
  deleteImportBulk: DeleteImportBulkResponse;
  deleteImportEmailBulk: DeleteImportEmailBulkResponse;
  deleteImportFailureBulk: DeleteImportFailureBulkResponse;
  deleteImportLogBulk: DeleteImportLogBulkResponse;
  deleteImportOcrCacheBulk: DeleteImportOcrCacheBulkResponse;
  deleteIncidentIssueBulk: DeleteIncidentIssueBulkResponse;
  deleteIncidentIssueDocumentBulk: DeleteIncidentIssueDocumentBulkResponse;
  deleteIndexBulk: DeleteIndexBulkResponse;
  deleteInvoiceAirportBulk: DeleteInvoiceAirportBulkResponse;
  deleteInvoiceBulk: DeleteInvoiceBulkResponse;
  deleteInvoiceClientBulk: DeleteInvoiceClientBulkResponse;
  deleteInvoiceCustomChargeBulk: DeleteInvoiceCustomChargeBulkResponse;
  deleteInvoiceDocumentBulk: DeleteInvoiceDocumentBulkResponse;
  deleteInvoiceEmailBulk: DeleteInvoiceEmailBulkResponse;
  deleteInvoiceHeaderBulk: DeleteInvoiceHeaderBulkResponse;
  deleteInvoiceIataCodeBulk: DeleteInvoiceIataCodeBulkResponse;
  deleteInvoiceLineItemBulk: DeleteInvoiceLineItemBulkResponse;
  deleteInvoiceProviderCacheBulk: DeleteInvoiceProviderCacheBulkResponse;
  deleteInvoiceTermBulk: DeleteInvoiceTermBulkResponse;
  deleteInvoiceTotalSummaryBulk: DeleteInvoiceTotalSummaryBulkResponse;
  deleteInvoiceTripBulk: DeleteInvoiceTripBulkResponse;
  deleteInvoiceTripStatusBulk: DeleteInvoiceTripStatusBulkResponse;
  deleteInvoiceTypeBulk: DeleteInvoiceTypeBulkResponse;
  deleteInvoiceUserCacheBulk: DeleteInvoiceUserCacheBulkResponse;
  deleteIssueBulk: DeleteIssueBulkResponse;
  deleteLicenseBulk: DeleteLicenseBulkResponse;
  deleteLicenseTypeBulk: DeleteLicenseTypeBulkResponse;
  deleteLineItemTypeBulk: DeleteLineItemTypeBulkResponse;
  deleteLocationBulk: DeleteLocationBulkResponse;
  deleteLoginEventBulk: DeleteLoginEventBulkResponse;
  deleteLostAndFoundIssueBulk: DeleteLostAndFoundIssueBulkResponse;
  deleteLostAndFoundIssueDocumentBulk: DeleteLostAndFoundIssueDocumentBulkResponse;
  deleteManifestHistoryBulk: DeleteManifestHistoryBulkResponse;
  deleteManifestHistoryRouteBulk: DeleteManifestHistoryRouteBulkResponse;
  deleteManifestProviderCacheBulk: DeleteManifestProviderCacheBulkResponse;
  deleteManifestUserCacheBulk: DeleteManifestUserCacheBulkResponse;
  deleteMessageBulk: DeleteMessageBulkResponse;
  deleteNotificationBulk: DeleteNotificationBulkResponse;
  deleteNotificationHasEventBulk: DeleteNotificationHasEventBulkResponse;
  deleteParsedTripBulk: DeleteParsedTripBulkResponse;
  deletePermissionBulk: DeletePermissionBulkResponse;
  deletePermissionHasRoleBulk: DeletePermissionHasRoleBulkResponse;
  deletePermissionHasUserBulk: DeletePermissionHasUserBulkResponse;
  deletePickupPointBulk: DeletePickupPointBulkResponse;
  deletePotentialTripBulk: DeletePotentialTripBulkResponse;
  deleteProviderAliasBulk: DeleteProviderAliasBulkResponse;
  deleteProviderBulk: DeleteProviderBulkResponse;
  deleteProviderCacheBulk: DeleteProviderCacheBulkResponse;
  deleteProviderLocationMappingBulk: DeleteProviderLocationMappingBulkResponse;
  deletePunchBulk: DeletePunchBulkResponse;
  deletePunchHistoryBulk: DeletePunchHistoryBulkResponse;
  deletePunchPolicyBulk: DeletePunchPolicyBulkResponse;
  deleteQueryHistoryBulk: DeleteQueryHistoryBulkResponse;
  deleteQuestionnaireAnswerOptionBulk: DeleteQuestionnaireAnswerOptionBulkResponse;
  deleteQuestionnaireAnswerTypeBulk: DeleteQuestionnaireAnswerTypeBulkResponse;
  deleteQuestionnaireAttemptAnswerOptionSnapshotBulk: DeleteQuestionnaireAttemptAnswerOptionSnapshotBulkResponse;
  deleteQuestionnaireAttemptBulk: DeleteQuestionnaireAttemptBulkResponse;
  deleteQuestionnaireAttemptCategorySnapshotAllowedGroupBulk: DeleteQuestionnaireAttemptCategorySnapshotAllowedGroupBulkResponse;
  deleteQuestionnaireAttemptCategorySnapshotBulk: DeleteQuestionnaireAttemptCategorySnapshotBulkResponse;
  deleteQuestionnaireAttemptCategorySnapshotGroupBulk: DeleteQuestionnaireAttemptCategorySnapshotGroupBulkResponse;
  deleteQuestionnaireAttemptNoteBulk: DeleteQuestionnaireAttemptNoteBulkResponse;
  deleteQuestionnaireAttemptQuestionSnapshotBulk: DeleteQuestionnaireAttemptQuestionSnapshotBulkResponse;
  deleteQuestionnaireCategoryBulk: DeleteQuestionnaireCategoryBulkResponse;
  deleteQuestionnaireQuestionBulk: DeleteQuestionnaireQuestionBulkResponse;
  deleteRateBulk: DeleteRateBulkResponse;
  deleteRateGroupBulk: DeleteRateGroupBulkResponse;
  deleteRateHistoryBulk: DeleteRateHistoryBulkResponse;
  deleteRateItemBulk: DeleteRateItemBulkResponse;
  deleteRatingBulk: DeleteRatingBulkResponse;
  deleteRatingCacheBulk: DeleteRatingCacheBulkResponse;
  deleteRatingCacheRemarkBulk: DeleteRatingCacheRemarkBulkResponse;
  deleteRatingRemarkBulk: DeleteRatingRemarkBulkResponse;
  deleteRatingTypeBulk: DeleteRatingTypeBulkResponse;
  deleteRoleBulk: DeleteRoleBulkResponse;
  deleteSettingsBulk: DeleteSettingsBulkResponse;
  deleteSocialDistanceRuleBulk: DeleteSocialDistanceRuleBulkResponse;
  deleteStagedTripBulk: DeleteStagedTripBulkResponse;
  deleteStopBulk: DeleteStopBulkResponse;
  deleteStorageBulk: DeleteStorageBulkResponse;
  deleteTimeFrameBulk: DeleteTimeFrameBulkResponse;
  deleteTimeFrameRangeBulk: DeleteTimeFrameRangeBulkResponse;
  deleteTrackFlightBulk: DeleteTrackFlightBulkResponse;
  deleteTrainingUserCacheBulk: DeleteTrainingUserCacheBulkResponse;
  deleteTripBulk: DeleteTripBulkResponse;
  deleteTripDocumentBulk: DeleteTripDocumentBulkResponse;
  deleteTripHasImportBulk: DeleteTripHasImportBulkResponse;
  deleteTripScheduleTriggerBulk: DeleteTripScheduleTriggerBulkResponse;
  deleteUpdateStrategyBulk: DeleteUpdateStrategyBulkResponse;
  deleteUserAvailabilityBulk: DeleteUserAvailabilityBulkResponse;
  deleteUserBulk: DeleteUserBulkResponse;
  deleteUserCacheBulk: DeleteUserCacheBulkResponse;
  deleteUserHasAirportBulk: DeleteUserHasAirportBulkResponse;
  deleteVariableTimeBulk: DeleteVariableTimeBulkResponse;
  deleteVehicleBulk: DeleteVehicleBulkResponse;
  deleteWidgetBulk: DeleteWidgetBulkResponse;
  deleteWidgetFilterBulk: DeleteWidgetFilterBulkResponse;
  downloadAccidentIssueAsCSV: DownloadAccidentIssueAsCsvResponse;
  downloadAccidentIssueDocumentAsCSV: DownloadAccidentIssueDocumentAsCsvResponse;
  downloadAccidentIssueWithCacheAsCSV: DownloadAccidentIssueWithCacheAsCsvResponse;
  downloadActivityAsCSV: DownloadActivityAsCsvResponse;
  downloadActivityDisplayMessageAsCSV: DownloadActivityDisplayMessageAsCsvResponse;
  downloadActivityLogAsCSV: DownloadActivityLogAsCsvResponse;
  downloadActivityLogPayloadAsCSV: DownloadActivityLogPayloadAsCsvResponse;
  downloadActivityLogPayloadChildAsCSV: DownloadActivityLogPayloadChildAsCsvResponse;
  downloadActivityLogWithCacheAsCSV: DownloadActivityLogWithCacheAsCsvResponse;
  downloadActivityObjectAsCSV: DownloadActivityObjectAsCsvResponse;
  downloadActivityUserCacheAsCSV: DownloadActivityUserCacheAsCsvResponse;
  downloadAirportAsCSV: DownloadAirportAsCsvResponse;
  downloadAirportGroupAsCSV: DownloadAirportGroupAsCsvResponse;
  downloadAirportHasCompanyAsCSV: DownloadAirportHasCompanyAsCsvResponse;
  downloadAirportHasGroupAsCSV: DownloadAirportHasGroupAsCsvResponse;
  downloadAirportHasLocationAsCSV: DownloadAirportHasLocationAsCsvResponse;
  downloadAirportHasManagerEmailAsCSV: DownloadAirportHasManagerEmailAsCsvResponse;
  downloadAirportHasRateAsCSV: DownloadAirportHasRateAsCsvResponse;
  downloadAirportHasVehicleAsCSV: DownloadAirportHasVehicleAsCsvResponse;
  downloadAirportWithCompanyAsCSV: DownloadAirportWithCompanyAsCsvResponse;
  downloadAirportWithGroupAsCSV: DownloadAirportWithGroupAsCsvResponse;
  downloadAirportWithLocationAsCSV: DownloadAirportWithLocationAsCsvResponse;
  downloadAirportWithVehicleAsCSV: DownloadAirportWithVehicleAsCsvResponse;
  downloadAlertSubscriptionAsCSV: DownloadAlertSubscriptionAsCsvResponse;
  downloadAliasAsCSV: DownloadAliasAsCsvResponse;
  downloadApiKeyAsCSV: DownloadApiKeyAsCsvResponse;
  downloadAuditSnapshotAsCSV: DownloadAuditSnapshotAsCsvResponse;
  downloadAuditSnapshotWithNameAsCSV: DownloadAuditSnapshotWithNameAsCsvResponse;
  downloadAutoCombineRuleAsCSV: DownloadAutoCombineRuleAsCsvResponse;
  downloadAutoCombineRuleWithContractAsCSV: DownloadAutoCombineRuleWithContractAsCsvResponse;
  downloadAutomationHistoryAirportAsCSV: DownloadAutomationHistoryAirportAsCsvResponse;
  downloadAutomationHistoryAsCSV: DownloadAutomationHistoryAsCsvResponse;
  downloadAutomationHistoryLogAsCSV: DownloadAutomationHistoryLogAsCsvResponse;
  downloadAutomationHistoryWithAirportAsCSV: DownloadAutomationHistoryWithAirportAsCsvResponse;
  downloadAutomationReportAsCSV: DownloadAutomationReportAsCsvResponse;
  downloadAutomationReportWithAutomationHistoryAsCSV: DownloadAutomationReportWithAutomationHistoryAsCsvResponse;
  downloadAutomationTripAsCSV: DownloadAutomationTripAsCsvResponse;
  downloadAutomationTripAssignmentReasonAsCSV: DownloadAutomationTripAssignmentReasonAsCsvResponse;
  downloadAutomationTripLogAsCSV: DownloadAutomationTripLogAsCsvResponse;
  downloadBufferTimeAsCSV: DownloadBufferTimeAsCsvResponse;
  downloadBufferTimeWithContractAsCSV: DownloadBufferTimeWithContractAsCsvResponse;
  downloadCancellationRuleAsCSV: DownloadCancellationRuleAsCsvResponse;
  downloadCharityAmountHistoryAsCSV: DownloadCharityAmountHistoryAsCsvResponse;
  downloadCharityAsCSV: DownloadCharityAsCsvResponse;
  downloadCharityRatingHistoryAsCSV: DownloadCharityRatingHistoryAsCsvResponse;
  downloadCharityRatingHistoryReportAsCSV: DownloadCharityRatingHistoryReportAsCsvResponse;
  downloadCharityRatingHistoryWithUserAsCSV: DownloadCharityRatingHistoryWithUserAsCsvResponse;
  downloadCharityWithAmountHistoryAsCSV: DownloadCharityWithAmountHistoryAsCsvResponse;
  downloadChatQuickReplyMessageAsCSV: DownloadChatQuickReplyMessageAsCsvResponse;
  downloadCheckinEventAsCSV: DownloadCheckinEventAsCsvResponse;
  downloadClosestRateItemAsCSV: DownloadClosestRateItemAsCsvResponse;
  downloadCombineRuleAsCSV: DownloadCombineRuleAsCsvResponse;
  downloadCombineRuleHistoryAsCSV: DownloadCombineRuleHistoryAsCsvResponse;
  downloadCombineRuleHistoryWithContractAsCSV: DownloadCombineRuleHistoryWithContractAsCsvResponse;
  downloadCombineRuleWithContractAsCSV: DownloadCombineRuleWithContractAsCsvResponse;
  downloadCommunicationAsCSV: DownloadCommunicationAsCsvResponse;
  downloadCompanyAsCSV: DownloadCompanyAsCsvResponse;
  downloadCompletionAsCSV: DownloadCompletionAsCsvResponse;
  downloadCompletionTypeAsCSV: DownloadCompletionTypeAsCsvResponse;
  downloadCompletionWithTypeAsCSV: DownloadCompletionWithTypeAsCsvResponse;
  downloadContractAsCSV: DownloadContractAsCsvResponse;
  downloadContractEmailAsCSV: DownloadContractEmailAsCsvResponse;
  downloadContractNumberAsCSV: DownloadContractNumberAsCsvResponse;
  downloadCountryRegionAsCSV: DownloadCountryRegionAsCsvResponse;
  downloadCrewCountRequirementAsCSV: DownloadCrewCountRequirementAsCsvResponse;
  downloadDashboardAsCSV: DownloadDashboardAsCsvResponse;
  downloadDefectAsCSV: DownloadDefectAsCsvResponse;
  downloadDeviceAsCSV: DownloadDeviceAsCsvResponse;
  downloadDeviceMetricAsCSV: DownloadDeviceMetricAsCsvResponse;
  downloadDeviceMetricWithUserAsCSV: DownloadDeviceMetricWithUserAsCsvResponse;
  downloadDispatchIssueAsCSV: DownloadDispatchIssueAsCsvResponse;
  downloadDispatchIssueCausedByAsCSV: DownloadDispatchIssueCausedByAsCsvResponse;
  downloadDispatchIssueCausedByWithCacheAsCSV: DownloadDispatchIssueCausedByWithCacheAsCsvResponse;
  downloadDispatchIssueDocumentAsCSV: DownloadDispatchIssueDocumentAsCsvResponse;
  downloadDispatchIssueWithCacheAsCSV: DownloadDispatchIssueWithCacheAsCsvResponse;
  downloadDispatchSummaryAsCSV: DownloadDispatchSummaryAsCsvResponse;
  downloadDispatchSummaryDocumentAsCSV: DownloadDispatchSummaryDocumentAsCsvResponse;
  downloadDispatchSummaryMarketAsCSV: DownloadDispatchSummaryMarketAsCsvResponse;
  downloadDispatchSummaryWithCacheAsCSV: DownloadDispatchSummaryWithCacheAsCsvResponse;
  downloadDistanceAsCSV: DownloadDistanceAsCsvResponse;
  downloadDriverEtaAsCSV: DownloadDriverEtaAsCsvResponse;
  downloadDriverEtaWithPreviousTripAsCSV: DownloadDriverEtaWithPreviousTripAsCsvResponse;
  downloadDriverVehicleAssignmentAsCSV: DownloadDriverVehicleAssignmentAsCsvResponse;
  downloadDtrLocationAsCSV: DownloadDtrLocationAsCsvResponse;
  downloadDvirAsCSV: DownloadDvirAsCsvResponse;
  downloadDvirSignatureAsCSV: DownloadDvirSignatureAsCsvResponse;
  downloadEmailAsCSV: DownloadEmailAsCsvResponse;
  downloadEquivalentTripAsCSV: DownloadEquivalentTripAsCsvResponse;
  downloadEventAsCSV: DownloadEventAsCsvResponse;
  downloadFcrAsCSV: DownloadFcrAsCsvResponse;
  downloadFcrTypeAsCSV: DownloadFcrTypeAsCsvResponse;
  downloadFlagAsCSV: DownloadFlagAsCsvResponse;
  downloadFlagHasPotentialTripAsCSV: DownloadFlagHasPotentialTripAsCsvResponse;
  downloadFlagHasStagedTripAsCSV: DownloadFlagHasStagedTripAsCsvResponse;
  downloadFlagHasTripAsCSV: DownloadFlagHasTripAsCsvResponse;
  downloadFlagWithTripAsCSV: DownloadFlagWithTripAsCsvResponse;
  downloadFlightHistoryAsCSV: DownloadFlightHistoryAsCsvResponse;
  downloadGeneratedDocumentAsCSV: DownloadGeneratedDocumentAsCsvResponse;
  downloadGeneratedDocumentLogAsCSV: DownloadGeneratedDocumentLogAsCsvResponse;
  downloadGroupAsCSV: DownloadGroupAsCsvResponse;
  downloadGroupHasPermissionAsCSV: DownloadGroupHasPermissionAsCsvResponse;
  downloadGroupHasUserAsCSV: DownloadGroupHasUserAsCsvResponse;
  downloadGroupHasUserWithPermissionsAsCSV: DownloadGroupHasUserWithPermissionsAsCsvResponse;
  downloadImageAsCSV: DownloadImageAsCsvResponse;
  downloadImportAsCSV: DownloadImportAsCsvResponse;
  downloadImportEmailAsCSV: DownloadImportEmailAsCsvResponse;
  downloadImportFailureAsCSV: DownloadImportFailureAsCsvResponse;
  downloadImportLogAsCSV: DownloadImportLogAsCsvResponse;
  downloadImportOcrCacheAsCSV: DownloadImportOcrCacheAsCsvResponse;
  downloadImportWithAirportAsCSV: DownloadImportWithAirportAsCsvResponse;
  downloadImportWithAirportWithCacheAsCSV: DownloadImportWithAirportWithCacheAsCsvResponse;
  downloadIncidentIssueAsCSV: DownloadIncidentIssueAsCsvResponse;
  downloadIncidentIssueDocumentAsCSV: DownloadIncidentIssueDocumentAsCsvResponse;
  downloadIncidentIssueWithCacheAsCSV: DownloadIncidentIssueWithCacheAsCsvResponse;
  downloadIndexAsCSV: DownloadIndexAsCsvResponse;
  downloadInvoiceAirportAsCSV: DownloadInvoiceAirportAsCsvResponse;
  downloadInvoiceAsCSV: DownloadInvoiceAsCsvResponse;
  downloadInvoiceClientAsCSV: DownloadInvoiceClientAsCsvResponse;
  downloadInvoiceCustomChargeAsCSV: DownloadInvoiceCustomChargeAsCsvResponse;
  downloadInvoiceDocumentAsCSV: DownloadInvoiceDocumentAsCsvResponse;
  downloadInvoiceDocumentWithSummaryAsCSV: DownloadInvoiceDocumentWithSummaryAsCsvResponse;
  downloadInvoiceEmailAsCSV: DownloadInvoiceEmailAsCsvResponse;
  downloadInvoiceHeaderAsCSV: DownloadInvoiceHeaderAsCsvResponse;
  downloadInvoiceIataCodeAsCSV: DownloadInvoiceIataCodeAsCsvResponse;
  downloadInvoiceLineItemAsCSV: DownloadInvoiceLineItemAsCsvResponse;
  downloadInvoiceProviderCacheAsCSV: DownloadInvoiceProviderCacheAsCsvResponse;
  downloadInvoiceTermAsCSV: DownloadInvoiceTermAsCsvResponse;
  downloadInvoiceTotalSummaryAsCSV: DownloadInvoiceTotalSummaryAsCsvResponse;
  downloadInvoiceTripAsCSV: DownloadInvoiceTripAsCsvResponse;
  downloadInvoiceTripStatusAsCSV: DownloadInvoiceTripStatusAsCsvResponse;
  downloadInvoiceTypeAsCSV: DownloadInvoiceTypeAsCsvResponse;
  downloadInvoiceUserCacheAsCSV: DownloadInvoiceUserCacheAsCsvResponse;
  downloadIssueAsCSV: DownloadIssueAsCsvResponse;
  downloadLatestRateAsCSV: DownloadLatestRateAsCsvResponse;
  downloadLatestRateHistoryAsCSV: DownloadLatestRateHistoryAsCsvResponse;
  downloadLicenseAsCSV: DownloadLicenseAsCsvResponse;
  downloadLicenseTypeAsCSV: DownloadLicenseTypeAsCsvResponse;
  downloadLineItemTypeAsCSV: DownloadLineItemTypeAsCsvResponse;
  downloadLocationAsCSV: DownloadLocationAsCsvResponse;
  downloadLocationWithAirportAndAliasAsCSV: DownloadLocationWithAirportAndAliasAsCsvResponse;
  downloadLocationWithPunchPolicyAsCSV: DownloadLocationWithPunchPolicyAsCsvResponse;
  downloadLoginEventAsCSV: DownloadLoginEventAsCsvResponse;
  downloadLostAndFoundIssueAsCSV: DownloadLostAndFoundIssueAsCsvResponse;
  downloadLostAndFoundIssueDocumentAsCSV: DownloadLostAndFoundIssueDocumentAsCsvResponse;
  downloadLostAndFoundIssueWithCacheAsCSV: DownloadLostAndFoundIssueWithCacheAsCsvResponse;
  downloadManifestHistoryAsCSV: DownloadManifestHistoryAsCsvResponse;
  downloadManifestHistoryRouteAsCSV: DownloadManifestHistoryRouteAsCsvResponse;
  downloadManifestHistoryWithRouteAsCSV: DownloadManifestHistoryWithRouteAsCsvResponse;
  downloadManifestProviderCacheAsCSV: DownloadManifestProviderCacheAsCsvResponse;
  downloadManifestUserCacheAsCSV: DownloadManifestUserCacheAsCsvResponse;
  downloadMessageAsCSV: DownloadMessageAsCsvResponse;
  downloadNotificationAsCSV: DownloadNotificationAsCsvResponse;
  downloadNotificationHasEventAsCSV: DownloadNotificationHasEventAsCsvResponse;
  downloadParsedTripAsCSV: DownloadParsedTripAsCsvResponse;
  downloadPermissionAsCSV: DownloadPermissionAsCsvResponse;
  downloadPermissionHasRoleAsCSV: DownloadPermissionHasRoleAsCsvResponse;
  downloadPermissionHasRoleWithPermissionsAsCSV: DownloadPermissionHasRoleWithPermissionsAsCsvResponse;
  downloadPermissionHasUserAsCSV: DownloadPermissionHasUserAsCsvResponse;
  downloadPermissionHasUserWithPermissionsAsCSV: DownloadPermissionHasUserWithPermissionsAsCsvResponse;
  downloadPickupPointAsCSV: DownloadPickupPointAsCsvResponse;
  downloadPotentialTripAsCSV: DownloadPotentialTripAsCsvResponse;
  downloadProviderAliasAsCSV: DownloadProviderAliasAsCsvResponse;
  downloadProviderAsCSV: DownloadProviderAsCsvResponse;
  downloadProviderCacheAsCSV: DownloadProviderCacheAsCsvResponse;
  downloadProviderLocationMappingAsCSV: DownloadProviderLocationMappingAsCsvResponse;
  downloadProviderWithAliasAsCSV: DownloadProviderWithAliasAsCsvResponse;
  downloadProviderWithContractAsCSV: DownloadProviderWithContractAsCsvResponse;
  downloadProviderWithUpdateStrategyAsCSV: DownloadProviderWithUpdateStrategyAsCsvResponse;
  downloadPunchAsCSV: DownloadPunchAsCsvResponse;
  downloadPunchHistoryAsCSV: DownloadPunchHistoryAsCsvResponse;
  downloadPunchPolicyAsCSV: DownloadPunchPolicyAsCsvResponse;
  downloadQueryHistoryAsCSV: DownloadQueryHistoryAsCsvResponse;
  downloadQuestionnaireAnswerOptionAsCSV: DownloadQuestionnaireAnswerOptionAsCsvResponse;
  downloadQuestionnaireAnswerTypeAsCSV: DownloadQuestionnaireAnswerTypeAsCsvResponse;
  downloadQuestionnaireAttemptAnswerOptionSnapshotAsCSV: DownloadQuestionnaireAttemptAnswerOptionSnapshotAsCsvResponse;
  downloadQuestionnaireAttemptAsCSV: DownloadQuestionnaireAttemptAsCsvResponse;
  downloadQuestionnaireAttemptCategorySnapshotAllowedGroupAsCSV: DownloadQuestionnaireAttemptCategorySnapshotAllowedGroupAsCsvResponse;
  downloadQuestionnaireAttemptCategorySnapshotAsCSV: DownloadQuestionnaireAttemptCategorySnapshotAsCsvResponse;
  downloadQuestionnaireAttemptCategorySnapshotGroupAsCSV: DownloadQuestionnaireAttemptCategorySnapshotGroupAsCsvResponse;
  downloadQuestionnaireAttemptNoteAsCSV: DownloadQuestionnaireAttemptNoteAsCsvResponse;
  downloadQuestionnaireAttemptQuestionSnapshotAsCSV: DownloadQuestionnaireAttemptQuestionSnapshotAsCsvResponse;
  downloadQuestionnaireCategoryAsCSV: DownloadQuestionnaireCategoryAsCsvResponse;
  downloadQuestionnaireQuestionAsCSV: DownloadQuestionnaireQuestionAsCsvResponse;
  downloadRateAsCSV: DownloadRateAsCsvResponse;
  downloadRateGroupAsCSV: DownloadRateGroupAsCsvResponse;
  downloadRateGroupWithLatestRateHistoryAsCSV: DownloadRateGroupWithLatestRateHistoryAsCsvResponse;
  downloadRateHistoryAsCSV: DownloadRateHistoryAsCsvResponse;
  downloadRateHistoryWithRateGroupAsCSV: DownloadRateHistoryWithRateGroupAsCsvResponse;
  downloadRateItemAsCSV: DownloadRateItemAsCsvResponse;
  downloadRateItemWithLatestRateHistoryAsCSV: DownloadRateItemWithLatestRateHistoryAsCsvResponse;
  downloadRatingAsCSV: DownloadRatingAsCsvResponse;
  downloadRatingCacheAsCSV: DownloadRatingCacheAsCsvResponse;
  downloadRatingCacheRemarkAsCSV: DownloadRatingCacheRemarkAsCsvResponse;
  downloadRatingRemarkAsCSV: DownloadRatingRemarkAsCsvResponse;
  downloadRatingRemarksWithRatingAsCSV: DownloadRatingRemarksWithRatingAsCsvResponse;
  downloadRatingTypeAsCSV: DownloadRatingTypeAsCsvResponse;
  downloadRatingWithRemarksAsCSV: DownloadRatingWithRemarksAsCsvResponse;
  downloadRoleAsCSV: DownloadRoleAsCsvResponse;
  downloadSettingsAsCSV: DownloadSettingsAsCsvResponse;
  downloadSocialDistanceRuleAsCSV: DownloadSocialDistanceRuleAsCsvResponse;
  downloadStagedTripAsCSV: DownloadStagedTripAsCsvResponse;
  downloadStopAsCSV: DownloadStopAsCsvResponse;
  downloadStorageAsCSV: DownloadStorageAsCsvResponse;
  downloadTimeFrameAsCSV: DownloadTimeFrameAsCsvResponse;
  downloadTimeFrameRangeAsCSV: DownloadTimeFrameRangeAsCsvResponse;
  downloadTrackFlightAsCSV: DownloadTrackFlightAsCsvResponse;
  downloadTrainingUserCacheAsCSV: DownloadTrainingUserCacheAsCsvResponse;
  downloadTripAsCSV: DownloadTripAsCsvResponse;
  downloadTripDocumentAsCSV: DownloadTripDocumentAsCsvResponse;
  downloadTripDocumentWithCacheAsCSV: DownloadTripDocumentWithCacheAsCsvResponse;
  downloadTripHasImportAsCSV: DownloadTripHasImportAsCsvResponse;
  downloadTripScheduleTriggerAsCSV: DownloadTripScheduleTriggerAsCsvResponse;
  downloadTripWithCompletionAndRateAsCSV: DownloadTripWithCompletionAndRateAsCsvResponse;
  downloadTripWithCompletionAsCSV: DownloadTripWithCompletionAsCsvResponse;
  downloadTripWithFcrInnerJoinAsCSV: DownloadTripWithFcrInnerJoinAsCsvResponse;
  downloadTripWithFlagInnerJoinAsCSV: DownloadTripWithFlagInnerJoinAsCsvResponse;
  downloadTripWithRateAsCSV: DownloadTripWithRateAsCsvResponse;
  downloadTripWithRateForAuditReportAsCSV: DownloadTripWithRateForAuditReportAsCsvResponse;
  downloadTripWithTrackFlightAsCSV: DownloadTripWithTrackFlightAsCsvResponse;
  downloadTripWithUtcAsCSV: DownloadTripWithUtcAsCsvResponse;
  downloadUniqueTripAsCSV: DownloadUniqueTripAsCsvResponse;
  downloadUpdateStrategyAsCSV: DownloadUpdateStrategyAsCsvResponse;
  downloadUserAsCSV: DownloadUserAsCsvResponse;
  downloadUserAvailabilityAsCSV: DownloadUserAvailabilityAsCsvResponse;
  downloadUserAvailabilityWithDatetimesAsCSV: DownloadUserAvailabilityWithDatetimesAsCsvResponse;
  downloadUserCacheAsCSV: DownloadUserCacheAsCsvResponse;
  downloadUserHasAirportAsCSV: DownloadUserHasAirportAsCsvResponse;
  downloadUserWithAvailabilityAndPermissionsAsCSV: DownloadUserWithAvailabilityAndPermissionsAsCsvResponse;
  downloadUserWithMarketAsCSV: DownloadUserWithMarketAsCsvResponse;
  downloadUserWithPermissionsAsCSV: DownloadUserWithPermissionsAsCsvResponse;
  downloadVariableTimeAsCSV: DownloadVariableTimeAsCsvResponse;
  downloadVehicleAsCSV: DownloadVehicleAsCsvResponse;
  downloadWidgetAsCSV: DownloadWidgetAsCsvResponse;
  downloadWidgetFilterAsCSV: DownloadWidgetFilterAsCsvResponse;
  searchAccidentIssue: SearchAccidentIssueResponse;
  searchAccidentIssueDocument: SearchAccidentIssueDocumentResponse;
  searchAccidentIssueWithCache: SearchAccidentIssueWithCacheResponse;
  searchActivity: SearchActivityResponse;
  searchActivityDisplayMessage: SearchActivityDisplayMessageResponse;
  searchActivityLog: SearchActivityLogResponse;
  searchActivityLogPayload: SearchActivityLogPayloadResponse;
  searchActivityLogPayloadChild: SearchActivityLogPayloadChildResponse;
  searchActivityLogWithCache: SearchActivityLogWithCacheResponse;
  searchActivityObject: SearchActivityObjectResponse;
  searchActivityUserCache: SearchActivityUserCacheResponse;
  searchAirport: SearchAirportResponse;
  searchAirportGroup: SearchAirportGroupResponse;
  searchAirportHasCompany: SearchAirportHasCompanyResponse;
  searchAirportHasGroup: SearchAirportHasGroupResponse;
  searchAirportHasLocation: SearchAirportHasLocationResponse;
  searchAirportHasManagerEmail: SearchAirportHasManagerEmailResponse;
  searchAirportHasRate: SearchAirportHasRateResponse;
  searchAirportHasVehicle: SearchAirportHasVehicleResponse;
  searchAirportWithCompany: SearchAirportWithCompanyResponse;
  searchAirportWithGroup: SearchAirportWithGroupResponse;
  searchAirportWithLocation: SearchAirportWithLocationResponse;
  searchAirportWithVehicle: SearchAirportWithVehicleResponse;
  searchAlertSubscription: SearchAlertSubscriptionResponse;
  searchAlias: SearchAliasResponse;
  searchApiKey: SearchApiKeyResponse;
  searchAuditSnapshot: SearchAuditSnapshotResponse;
  searchAuditSnapshotWithName: SearchAuditSnapshotWithNameResponse;
  searchAutoCombineRule: SearchAutoCombineRuleResponse;
  searchAutoCombineRuleWithContract: SearchAutoCombineRuleWithContractResponse;
  searchAutomationHistory: SearchAutomationHistoryResponse;
  searchAutomationHistoryAirport: SearchAutomationHistoryAirportResponse;
  searchAutomationHistoryLog: SearchAutomationHistoryLogResponse;
  searchAutomationHistoryWithAirport: SearchAutomationHistoryWithAirportResponse;
  searchAutomationReport: SearchAutomationReportResponse;
  searchAutomationReportWithAutomationHistory: SearchAutomationReportWithAutomationHistoryResponse;
  searchAutomationTrip: SearchAutomationTripResponse;
  searchAutomationTripAssignmentReason: SearchAutomationTripAssignmentReasonResponse;
  searchAutomationTripLog: SearchAutomationTripLogResponse;
  searchBufferTime: SearchBufferTimeResponse;
  searchBufferTimeWithContract: SearchBufferTimeWithContractResponse;
  searchCancellationRule: SearchCancellationRuleResponse;
  searchCharity: SearchCharityResponse;
  searchCharityAmountHistory: SearchCharityAmountHistoryResponse;
  searchCharityRatingHistory: SearchCharityRatingHistoryResponse;
  searchCharityRatingHistoryReport: SearchCharityRatingHistoryReportResponse;
  searchCharityRatingHistoryWithUser: SearchCharityRatingHistoryWithUserResponse;
  searchCharityWithAmountHistory: SearchCharityWithAmountHistoryResponse;
  searchChatQuickReplyMessage: SearchChatQuickReplyMessageResponse;
  searchCheckinEvent: SearchCheckinEventResponse;
  searchClosestRateItem: SearchClosestRateItemResponse;
  searchCombineRule: SearchCombineRuleResponse;
  searchCombineRuleHistory: SearchCombineRuleHistoryResponse;
  searchCombineRuleHistoryWithContract: SearchCombineRuleHistoryWithContractResponse;
  searchCombineRuleWithContract: SearchCombineRuleWithContractResponse;
  searchCommunication: SearchCommunicationResponse;
  searchCompany: SearchCompanyResponse;
  searchCompletion: SearchCompletionResponse;
  searchCompletionType: SearchCompletionTypeResponse;
  searchCompletionWithType: SearchCompletionWithTypeResponse;
  searchContract: SearchContractResponse;
  searchContractEmail: SearchContractEmailResponse;
  searchContractNumber: SearchContractNumberResponse;
  searchCountryRegion: SearchCountryRegionResponse;
  searchCrewCountRequirement: SearchCrewCountRequirementResponse;
  searchDashboard: SearchDashboardResponse;
  searchDefect: SearchDefectResponse;
  searchDevice: SearchDeviceResponse;
  searchDeviceMetric: SearchDeviceMetricResponse;
  searchDeviceMetricWithUser: SearchDeviceMetricWithUserResponse;
  searchDispatchIssue: SearchDispatchIssueResponse;
  searchDispatchIssueCausedBy: SearchDispatchIssueCausedByResponse;
  searchDispatchIssueCausedByWithCache: SearchDispatchIssueCausedByWithCacheResponse;
  searchDispatchIssueDocument: SearchDispatchIssueDocumentResponse;
  searchDispatchIssueWithCache: SearchDispatchIssueWithCacheResponse;
  searchDispatchSummary: SearchDispatchSummaryResponse;
  searchDispatchSummaryDocument: SearchDispatchSummaryDocumentResponse;
  searchDispatchSummaryMarket: SearchDispatchSummaryMarketResponse;
  searchDispatchSummaryWithCache: SearchDispatchSummaryWithCacheResponse;
  searchDistance: SearchDistanceResponse;
  searchDriverEta: SearchDriverEtaResponse;
  searchDriverEtaWithPreviousTrip: SearchDriverEtaWithPreviousTripResponse;
  searchDriverVehicleAssignment: SearchDriverVehicleAssignmentResponse;
  searchDtrLocation: SearchDtrLocationResponse;
  searchDvir: SearchDvirResponse;
  searchDvirSignature: SearchDvirSignatureResponse;
  searchEmail: SearchEmailResponse;
  searchEquivalentTrip: SearchEquivalentTripResponse;
  searchEvent: SearchEventResponse;
  searchFcr: SearchFcrResponse;
  searchFcrType: SearchFcrTypeResponse;
  searchFlag: SearchFlagResponse;
  searchFlagHasPotentialTrip: SearchFlagHasPotentialTripResponse;
  searchFlagHasStagedTrip: SearchFlagHasStagedTripResponse;
  searchFlagHasTrip: SearchFlagHasTripResponse;
  searchFlagWithTrip: SearchFlagWithTripResponse;
  searchFlightHistory: SearchFlightHistoryResponse;
  searchGeneratedDocument: SearchGeneratedDocumentResponse;
  searchGeneratedDocumentLog: SearchGeneratedDocumentLogResponse;
  searchGroup: SearchGroupResponse;
  searchGroupHasPermission: SearchGroupHasPermissionResponse;
  searchGroupHasUser: SearchGroupHasUserResponse;
  searchGroupHasUserWithPermissions: SearchGroupHasUserWithPermissionsResponse;
  searchImage: SearchImageResponse;
  searchImport: SearchImportResponse;
  searchImportEmail: SearchImportEmailResponse;
  searchImportFailure: SearchImportFailureResponse;
  searchImportLog: SearchImportLogResponse;
  searchImportOcrCache: SearchImportOcrCacheResponse;
  searchImportWithAirport: SearchImportWithAirportResponse;
  searchImportWithAirportWithCache: SearchImportWithAirportWithCacheResponse;
  searchIncidentIssue: SearchIncidentIssueResponse;
  searchIncidentIssueDocument: SearchIncidentIssueDocumentResponse;
  searchIncidentIssueWithCache: SearchIncidentIssueWithCacheResponse;
  searchIndex: SearchIndexResponse;
  searchInvoice: SearchInvoiceResponse;
  searchInvoiceAirport: SearchInvoiceAirportResponse;
  searchInvoiceClient: SearchInvoiceClientResponse;
  searchInvoiceCustomCharge: SearchInvoiceCustomChargeResponse;
  searchInvoiceDocument: SearchInvoiceDocumentResponse;
  searchInvoiceDocumentWithSummary: SearchInvoiceDocumentWithSummaryResponse;
  searchInvoiceEmail: SearchInvoiceEmailResponse;
  searchInvoiceHeader: SearchInvoiceHeaderResponse;
  searchInvoiceIataCode: SearchInvoiceIataCodeResponse;
  searchInvoiceLineItem: SearchInvoiceLineItemResponse;
  searchInvoiceProviderCache: SearchInvoiceProviderCacheResponse;
  searchInvoiceTerm: SearchInvoiceTermResponse;
  searchInvoiceTotalSummary: SearchInvoiceTotalSummaryResponse;
  searchInvoiceTrip: SearchInvoiceTripResponse;
  searchInvoiceTripStatus: SearchInvoiceTripStatusResponse;
  searchInvoiceType: SearchInvoiceTypeResponse;
  searchInvoiceUserCache: SearchInvoiceUserCacheResponse;
  searchIssue: SearchIssueResponse;
  searchLatestRate: SearchLatestRateResponse;
  searchLatestRateHistory: SearchLatestRateHistoryResponse;
  searchLicense: SearchLicenseResponse;
  searchLicenseType: SearchLicenseTypeResponse;
  searchLineItemType: SearchLineItemTypeResponse;
  searchLocation: SearchLocationResponse;
  searchLocationWithAirportAndAlias: SearchLocationWithAirportAndAliasResponse;
  searchLocationWithPunchPolicy: SearchLocationWithPunchPolicyResponse;
  searchLoginEvent: SearchLoginEventResponse;
  searchLostAndFoundIssue: SearchLostAndFoundIssueResponse;
  searchLostAndFoundIssueDocument: SearchLostAndFoundIssueDocumentResponse;
  searchLostAndFoundIssueWithCache: SearchLostAndFoundIssueWithCacheResponse;
  searchManifestHistory: SearchManifestHistoryResponse;
  searchManifestHistoryRoute: SearchManifestHistoryRouteResponse;
  searchManifestHistoryWithRoute: SearchManifestHistoryWithRouteResponse;
  searchManifestProviderCache: SearchManifestProviderCacheResponse;
  searchManifestUserCache: SearchManifestUserCacheResponse;
  searchMessage: SearchMessageResponse;
  searchNotification: SearchNotificationResponse;
  searchNotificationHasEvent: SearchNotificationHasEventResponse;
  searchParsedTrip: SearchParsedTripResponse;
  searchPermission: SearchPermissionResponse;
  searchPermissionHasRole: SearchPermissionHasRoleResponse;
  searchPermissionHasRoleWithPermissions: SearchPermissionHasRoleWithPermissionsResponse;
  searchPermissionHasUser: SearchPermissionHasUserResponse;
  searchPermissionHasUserWithPermissions: SearchPermissionHasUserWithPermissionsResponse;
  searchPickupPoint: SearchPickupPointResponse;
  searchPotentialTrip: SearchPotentialTripResponse;
  searchProvider: SearchProviderResponse;
  searchProviderAlias: SearchProviderAliasResponse;
  searchProviderCache: SearchProviderCacheResponse;
  searchProviderLocationMapping: SearchProviderLocationMappingResponse;
  searchProviderWithAlias: SearchProviderWithAliasResponse;
  searchProviderWithContract: SearchProviderWithContractResponse;
  searchProviderWithUpdateStrategy: SearchProviderWithUpdateStrategyResponse;
  searchPunch: SearchPunchResponse;
  searchPunchHistory: SearchPunchHistoryResponse;
  searchPunchPolicy: SearchPunchPolicyResponse;
  searchQueryHistory: SearchQueryHistoryResponse;
  searchQuestionnaireAnswerOption: SearchQuestionnaireAnswerOptionResponse;
  searchQuestionnaireAnswerType: SearchQuestionnaireAnswerTypeResponse;
  searchQuestionnaireAttempt: SearchQuestionnaireAttemptResponse;
  searchQuestionnaireAttemptAnswerOptionSnapshot: SearchQuestionnaireAttemptAnswerOptionSnapshotResponse;
  searchQuestionnaireAttemptCategorySnapshot: SearchQuestionnaireAttemptCategorySnapshotResponse;
  searchQuestionnaireAttemptCategorySnapshotAllowedGroup: SearchQuestionnaireAttemptCategorySnapshotAllowedGroupResponse;
  searchQuestionnaireAttemptCategorySnapshotGroup: SearchQuestionnaireAttemptCategorySnapshotGroupResponse;
  searchQuestionnaireAttemptNote: SearchQuestionnaireAttemptNoteResponse;
  searchQuestionnaireAttemptQuestionSnapshot: SearchQuestionnaireAttemptQuestionSnapshotResponse;
  searchQuestionnaireCategory: SearchQuestionnaireCategoryResponse;
  searchQuestionnaireQuestion: SearchQuestionnaireQuestionResponse;
  searchRate: SearchRateResponse;
  searchRateGroup: SearchRateGroupResponse;
  searchRateGroupWithLatestRateHistory: SearchRateGroupWithLatestRateHistoryResponse;
  searchRateHistory: SearchRateHistoryResponse;
  searchRateHistoryWithRateGroup: SearchRateHistoryWithRateGroupResponse;
  searchRateItem: SearchRateItemResponse;
  searchRateItemWithLatestRateHistory: SearchRateItemWithLatestRateHistoryResponse;
  searchRating: SearchRatingResponse;
  searchRatingCache: SearchRatingCacheResponse;
  searchRatingCacheRemark: SearchRatingCacheRemarkResponse;
  searchRatingRemark: SearchRatingRemarkResponse;
  searchRatingRemarksWithRating: SearchRatingRemarksWithRatingResponse;
  searchRatingType: SearchRatingTypeResponse;
  searchRatingWithRemarks: SearchRatingWithRemarksResponse;
  searchRole: SearchRoleResponse;
  searchSettings: SearchSettingsResponse;
  searchSocialDistanceRule: SearchSocialDistanceRuleResponse;
  searchStagedTrip: SearchStagedTripResponse;
  searchStop: SearchStopResponse;
  searchStorage: SearchStorageResponse;
  searchTimeFrame: SearchTimeFrameResponse;
  searchTimeFrameRange: SearchTimeFrameRangeResponse;
  searchTrackFlight: SearchTrackFlightResponse;
  searchTrainingUserCache: SearchTrainingUserCacheResponse;
  searchTrip: SearchTripResponse;
  searchTripDocument: SearchTripDocumentResponse;
  searchTripDocumentWithCache: SearchTripDocumentWithCacheResponse;
  searchTripHasImport: SearchTripHasImportResponse;
  searchTripScheduleTrigger: SearchTripScheduleTriggerResponse;
  searchTripWithCompletion: SearchTripWithCompletionResponse;
  searchTripWithCompletionAndRate: SearchTripWithCompletionAndRateResponse;
  searchTripWithFcrInnerJoin: SearchTripWithFcrInnerJoinResponse;
  searchTripWithFlagInnerJoin: SearchTripWithFlagInnerJoinResponse;
  searchTripWithRate: SearchTripWithRateResponse;
  searchTripWithRateForAuditReport: SearchTripWithRateForAuditReportResponse;
  searchTripWithTrackFlight: SearchTripWithTrackFlightResponse;
  searchTripWithUtc: SearchTripWithUtcResponse;
  searchUniqueTrip: SearchUniqueTripResponse;
  searchUpdateStrategy: SearchUpdateStrategyResponse;
  searchUser: SearchUserResponse;
  searchUserAvailability: SearchUserAvailabilityResponse;
  searchUserAvailabilityWithDatetimes: SearchUserAvailabilityWithDatetimesResponse;
  searchUserCache: SearchUserCacheResponse;
  searchUserHasAirport: SearchUserHasAirportResponse;
  searchUserWithAvailabilityAndPermissions: SearchUserWithAvailabilityAndPermissionsResponse;
  searchUserWithMarket: SearchUserWithMarketResponse;
  searchUserWithPermissions: SearchUserWithPermissionsResponse;
  searchVariableTime: SearchVariableTimeResponse;
  searchVehicle: SearchVehicleResponse;
  searchWidget: SearchWidgetResponse;
  searchWidgetFilter: SearchWidgetFilterResponse;
  updateAccidentIssueBulk: UpdateAccidentIssueBulkResponse;
  updateAccidentIssueDocumentBulk: UpdateAccidentIssueDocumentBulkResponse;
  updateActivityBulk: UpdateActivityBulkResponse;
  updateActivityObjectBulk: UpdateActivityObjectBulkResponse;
  updateAirportBulk: UpdateAirportBulkResponse;
  updateAirportGroupBulk: UpdateAirportGroupBulkResponse;
  updateAirportHasCompanyBulk: UpdateAirportHasCompanyBulkResponse;
  updateAirportHasGroupBulk: UpdateAirportHasGroupBulkResponse;
  updateAirportHasLocationBulk: UpdateAirportHasLocationBulkResponse;
  updateAirportHasManagerEmailBulk: UpdateAirportHasManagerEmailBulkResponse;
  updateAirportHasRateBulk: UpdateAirportHasRateBulkResponse;
  updateAirportHasVehicleBulk: UpdateAirportHasVehicleBulkResponse;
  updateAlertSubscriptionBulk: UpdateAlertSubscriptionBulkResponse;
  updateAliasBulk: UpdateAliasBulkResponse;
  updateApiKeyBulk: UpdateApiKeyBulkResponse;
  updateAuditSnapshotBulk: UpdateAuditSnapshotBulkResponse;
  updateAutoCombineRuleBulk: UpdateAutoCombineRuleBulkResponse;
  updateAutomationHistoryAirportBulk: UpdateAutomationHistoryAirportBulkResponse;
  updateAutomationHistoryBulk: UpdateAutomationHistoryBulkResponse;
  updateAutomationHistoryLogBulk: UpdateAutomationHistoryLogBulkResponse;
  updateAutomationReportBulk: UpdateAutomationReportBulkResponse;
  updateAutomationTripAssignmentReasonBulk: UpdateAutomationTripAssignmentReasonBulkResponse;
  updateAutomationTripBulk: UpdateAutomationTripBulkResponse;
  updateAutomationTripLogBulk: UpdateAutomationTripLogBulkResponse;
  updateBufferTimeBulk: UpdateBufferTimeBulkResponse;
  updateCancellationRuleBulk: UpdateCancellationRuleBulkResponse;
  updateCharityAmountHistoryBulk: UpdateCharityAmountHistoryBulkResponse;
  updateCharityBulk: UpdateCharityBulkResponse;
  updateCharityRatingHistoryBulk: UpdateCharityRatingHistoryBulkResponse;
  updateCharityRatingHistoryReportBulk: UpdateCharityRatingHistoryReportBulkResponse;
  updateChatQuickReplyMessageBulk: UpdateChatQuickReplyMessageBulkResponse;
  updateCheckinEventBulk: UpdateCheckinEventBulkResponse;
  updateCombineRuleBulk: UpdateCombineRuleBulkResponse;
  updateCombineRuleHistoryBulk: UpdateCombineRuleHistoryBulkResponse;
  updateCommunicationBulk: UpdateCommunicationBulkResponse;
  updateCompanyBulk: UpdateCompanyBulkResponse;
  updateCompletionBulk: UpdateCompletionBulkResponse;
  updateCompletionTypeBulk: UpdateCompletionTypeBulkResponse;
  updateContractBulk: UpdateContractBulkResponse;
  updateContractEmailBulk: UpdateContractEmailBulkResponse;
  updateContractNumberBulk: UpdateContractNumberBulkResponse;
  updateCountryRegionBulk: UpdateCountryRegionBulkResponse;
  updateCrewCountRequirementBulk: UpdateCrewCountRequirementBulkResponse;
  updateDashboardBulk: UpdateDashboardBulkResponse;
  updateDefectBulk: UpdateDefectBulkResponse;
  updateDeviceBulk: UpdateDeviceBulkResponse;
  updateDeviceMetricBulk: UpdateDeviceMetricBulkResponse;
  updateDispatchIssueBulk: UpdateDispatchIssueBulkResponse;
  updateDispatchIssueCausedByBulk: UpdateDispatchIssueCausedByBulkResponse;
  updateDispatchIssueDocumentBulk: UpdateDispatchIssueDocumentBulkResponse;
  updateDispatchSummaryBulk: UpdateDispatchSummaryBulkResponse;
  updateDispatchSummaryDocumentBulk: UpdateDispatchSummaryDocumentBulkResponse;
  updateDispatchSummaryMarketBulk: UpdateDispatchSummaryMarketBulkResponse;
  updateDistanceBulk: UpdateDistanceBulkResponse;
  updateDriverEtaBulk: UpdateDriverEtaBulkResponse;
  updateDriverVehicleAssignmentBulk: UpdateDriverVehicleAssignmentBulkResponse;
  updateDtrLocationBulk: UpdateDtrLocationBulkResponse;
  updateDvirBulk: UpdateDvirBulkResponse;
  updateDvirSignatureBulk: UpdateDvirSignatureBulkResponse;
  updateEmailBulk: UpdateEmailBulkResponse;
  updateEquivalentTripBulk: UpdateEquivalentTripBulkResponse;
  updateEventBulk: UpdateEventBulkResponse;
  updateFcrBulk: UpdateFcrBulkResponse;
  updateFcrTypeBulk: UpdateFcrTypeBulkResponse;
  updateFlagBulk: UpdateFlagBulkResponse;
  updateFlagHasPotentialTripBulk: UpdateFlagHasPotentialTripBulkResponse;
  updateFlagHasStagedTripBulk: UpdateFlagHasStagedTripBulkResponse;
  updateFlagHasTripBulk: UpdateFlagHasTripBulkResponse;
  updateFlightHistoryBulk: UpdateFlightHistoryBulkResponse;
  updateGeneratedDocumentBulk: UpdateGeneratedDocumentBulkResponse;
  updateGeneratedDocumentLogBulk: UpdateGeneratedDocumentLogBulkResponse;
  updateGroupBulk: UpdateGroupBulkResponse;
  updateGroupHasPermissionBulk: UpdateGroupHasPermissionBulkResponse;
  updateGroupHasUserBulk: UpdateGroupHasUserBulkResponse;
  updateImageBulk: UpdateImageBulkResponse;
  updateImportBulk: UpdateImportBulkResponse;
  updateImportEmailBulk: UpdateImportEmailBulkResponse;
  updateImportFailureBulk: UpdateImportFailureBulkResponse;
  updateImportLogBulk: UpdateImportLogBulkResponse;
  updateImportOcrCacheBulk: UpdateImportOcrCacheBulkResponse;
  updateIncidentIssueBulk: UpdateIncidentIssueBulkResponse;
  updateIncidentIssueDocumentBulk: UpdateIncidentIssueDocumentBulkResponse;
  updateIndexBulk: UpdateIndexBulkResponse;
  updateInvoiceAirportBulk: UpdateInvoiceAirportBulkResponse;
  updateInvoiceBulk: UpdateInvoiceBulkResponse;
  updateInvoiceClientBulk: UpdateInvoiceClientBulkResponse;
  updateInvoiceCustomChargeBulk: UpdateInvoiceCustomChargeBulkResponse;
  updateInvoiceDocumentBulk: UpdateInvoiceDocumentBulkResponse;
  updateInvoiceEmailBulk: UpdateInvoiceEmailBulkResponse;
  updateInvoiceHeaderBulk: UpdateInvoiceHeaderBulkResponse;
  updateInvoiceIataCodeBulk: UpdateInvoiceIataCodeBulkResponse;
  updateInvoiceLineItemBulk: UpdateInvoiceLineItemBulkResponse;
  updateInvoiceProviderCacheBulk: UpdateInvoiceProviderCacheBulkResponse;
  updateInvoiceTermBulk: UpdateInvoiceTermBulkResponse;
  updateInvoiceTotalSummaryBulk: UpdateInvoiceTotalSummaryBulkResponse;
  updateInvoiceTripBulk: UpdateInvoiceTripBulkResponse;
  updateInvoiceTripStatusBulk: UpdateInvoiceTripStatusBulkResponse;
  updateInvoiceTypeBulk: UpdateInvoiceTypeBulkResponse;
  updateInvoiceUserCacheBulk: UpdateInvoiceUserCacheBulkResponse;
  updateIssueBulk: UpdateIssueBulkResponse;
  updateLicenseBulk: UpdateLicenseBulkResponse;
  updateLicenseTypeBulk: UpdateLicenseTypeBulkResponse;
  updateLineItemTypeBulk: UpdateLineItemTypeBulkResponse;
  updateLocationBulk: UpdateLocationBulkResponse;
  updateLoginEventBulk: UpdateLoginEventBulkResponse;
  updateLostAndFoundIssueBulk: UpdateLostAndFoundIssueBulkResponse;
  updateLostAndFoundIssueDocumentBulk: UpdateLostAndFoundIssueDocumentBulkResponse;
  updateManifestHistoryBulk: UpdateManifestHistoryBulkResponse;
  updateManifestHistoryRouteBulk: UpdateManifestHistoryRouteBulkResponse;
  updateManifestProviderCacheBulk: UpdateManifestProviderCacheBulkResponse;
  updateManifestUserCacheBulk: UpdateManifestUserCacheBulkResponse;
  updateMessageBulk: UpdateMessageBulkResponse;
  updateNotificationBulk: UpdateNotificationBulkResponse;
  updateNotificationHasEventBulk: UpdateNotificationHasEventBulkResponse;
  updateParsedTripBulk: UpdateParsedTripBulkResponse;
  updatePermissionBulk: UpdatePermissionBulkResponse;
  updatePermissionHasRoleBulk: UpdatePermissionHasRoleBulkResponse;
  updatePermissionHasUserBulk: UpdatePermissionHasUserBulkResponse;
  updatePickupPointBulk: UpdatePickupPointBulkResponse;
  updatePotentialTripBulk: UpdatePotentialTripBulkResponse;
  updateProviderAliasBulk: UpdateProviderAliasBulkResponse;
  updateProviderBulk: UpdateProviderBulkResponse;
  updateProviderCacheBulk: UpdateProviderCacheBulkResponse;
  updateProviderLocationMappingBulk: UpdateProviderLocationMappingBulkResponse;
  updatePunchBulk: UpdatePunchBulkResponse;
  updatePunchHistoryBulk: UpdatePunchHistoryBulkResponse;
  updatePunchPolicyBulk: UpdatePunchPolicyBulkResponse;
  updateQueryHistoryBulk: UpdateQueryHistoryBulkResponse;
  updateQuestionnaireAnswerOptionBulk: UpdateQuestionnaireAnswerOptionBulkResponse;
  updateQuestionnaireAnswerTypeBulk: UpdateQuestionnaireAnswerTypeBulkResponse;
  updateQuestionnaireAttemptAnswerOptionSnapshotBulk: UpdateQuestionnaireAttemptAnswerOptionSnapshotBulkResponse;
  updateQuestionnaireAttemptBulk: UpdateQuestionnaireAttemptBulkResponse;
  updateQuestionnaireAttemptCategorySnapshotAllowedGroupBulk: UpdateQuestionnaireAttemptCategorySnapshotAllowedGroupBulkResponse;
  updateQuestionnaireAttemptCategorySnapshotBulk: UpdateQuestionnaireAttemptCategorySnapshotBulkResponse;
  updateQuestionnaireAttemptCategorySnapshotGroupBulk: UpdateQuestionnaireAttemptCategorySnapshotGroupBulkResponse;
  updateQuestionnaireAttemptNoteBulk: UpdateQuestionnaireAttemptNoteBulkResponse;
  updateQuestionnaireAttemptQuestionSnapshotBulk: UpdateQuestionnaireAttemptQuestionSnapshotBulkResponse;
  updateQuestionnaireCategoryBulk: UpdateQuestionnaireCategoryBulkResponse;
  updateQuestionnaireQuestionBulk: UpdateQuestionnaireQuestionBulkResponse;
  updateRateBulk: UpdateRateBulkResponse;
  updateRateGroupBulk: UpdateRateGroupBulkResponse;
  updateRateHistoryBulk: UpdateRateHistoryBulkResponse;
  updateRateItemBulk: UpdateRateItemBulkResponse;
  updateRatingBulk: UpdateRatingBulkResponse;
  updateRatingCacheBulk: UpdateRatingCacheBulkResponse;
  updateRatingCacheRemarkBulk: UpdateRatingCacheRemarkBulkResponse;
  updateRatingRemarkBulk: UpdateRatingRemarkBulkResponse;
  updateRatingTypeBulk: UpdateRatingTypeBulkResponse;
  updateRoleBulk: UpdateRoleBulkResponse;
  updateSettingsBulk: UpdateSettingsBulkResponse;
  updateSocialDistanceRuleBulk: UpdateSocialDistanceRuleBulkResponse;
  updateStagedTripBulk: UpdateStagedTripBulkResponse;
  updateStopBulk: UpdateStopBulkResponse;
  updateStorageBulk: UpdateStorageBulkResponse;
  updateTimeFrameBulk: UpdateTimeFrameBulkResponse;
  updateTimeFrameRangeBulk: UpdateTimeFrameRangeBulkResponse;
  updateTrackFlightBulk: UpdateTrackFlightBulkResponse;
  updateTrainingUserCacheBulk: UpdateTrainingUserCacheBulkResponse;
  updateTripBulk: UpdateTripBulkResponse;
  updateTripDocumentBulk: UpdateTripDocumentBulkResponse;
  updateTripHasImportBulk: UpdateTripHasImportBulkResponse;
  updateTripScheduleTriggerBulk: UpdateTripScheduleTriggerBulkResponse;
  updateUpdateStrategyBulk: UpdateUpdateStrategyBulkResponse;
  updateUserAvailabilityBulk: UpdateUserAvailabilityBulkResponse;
  updateUserBulk: UpdateUserBulkResponse;
  updateUserCacheBulk: UpdateUserCacheBulkResponse;
  updateUserHasAirportBulk: UpdateUserHasAirportBulkResponse;
  updateVariableTimeBulk: UpdateVariableTimeBulkResponse;
  updateVehicleBulk: UpdateVehicleBulkResponse;
  updateWidgetBulk: UpdateWidgetBulkResponse;
  updateWidgetFilterBulk: UpdateWidgetFilterBulkResponse;
};


export type MutationCrudCreateAccidentIssueBulkArgs = {
  input: CreateAccidentIssueBulkInput;
};


export type MutationCrudCreateAccidentIssueDocumentBulkArgs = {
  input: CreateAccidentIssueDocumentBulkInput;
};


export type MutationCrudCreateActivityBulkArgs = {
  input: CreateActivityBulkInput;
};


export type MutationCrudCreateActivityObjectBulkArgs = {
  input: CreateActivityObjectBulkInput;
};


export type MutationCrudCreateAirportBulkArgs = {
  input: CreateAirportBulkInput;
};


export type MutationCrudCreateAirportGroupBulkArgs = {
  input: CreateAirportGroupBulkInput;
};


export type MutationCrudCreateAirportHasCompanyBulkArgs = {
  input: CreateAirportHasCompanyBulkInput;
};


export type MutationCrudCreateAirportHasGroupBulkArgs = {
  input: CreateAirportHasGroupBulkInput;
};


export type MutationCrudCreateAirportHasLocationBulkArgs = {
  input: CreateAirportHasLocationBulkInput;
};


export type MutationCrudCreateAirportHasManagerEmailBulkArgs = {
  input: CreateAirportHasManagerEmailBulkInput;
};


export type MutationCrudCreateAirportHasRateBulkArgs = {
  input: CreateAirportHasRateBulkInput;
};


export type MutationCrudCreateAirportHasVehicleBulkArgs = {
  input: CreateAirportHasVehicleBulkInput;
};


export type MutationCrudCreateAlertSubscriptionBulkArgs = {
  input: CreateAlertSubscriptionBulkInput;
};


export type MutationCrudCreateAliasBulkArgs = {
  input: CreateAliasBulkInput;
};


export type MutationCrudCreateApiKeyBulkArgs = {
  input: CreateApiKeyBulkInput;
};


export type MutationCrudCreateAuditSnapshotBulkArgs = {
  input: CreateAuditSnapshotBulkInput;
};


export type MutationCrudCreateAutoCombineRuleBulkArgs = {
  input: CreateAutoCombineRuleBulkInput;
};


export type MutationCrudCreateAutomationHistoryAirportBulkArgs = {
  input: CreateAutomationHistoryAirportBulkInput;
};


export type MutationCrudCreateAutomationHistoryBulkArgs = {
  input: CreateAutomationHistoryBulkInput;
};


export type MutationCrudCreateAutomationHistoryLogBulkArgs = {
  input: CreateAutomationHistoryLogBulkInput;
};


export type MutationCrudCreateAutomationReportBulkArgs = {
  input: CreateAutomationReportBulkInput;
};


export type MutationCrudCreateAutomationTripAssignmentReasonBulkArgs = {
  input: CreateAutomationTripAssignmentReasonBulkInput;
};


export type MutationCrudCreateAutomationTripBulkArgs = {
  input: CreateAutomationTripBulkInput;
};


export type MutationCrudCreateAutomationTripLogBulkArgs = {
  input: CreateAutomationTripLogBulkInput;
};


export type MutationCrudCreateBufferTimeBulkArgs = {
  input: CreateBufferTimeBulkInput;
};


export type MutationCrudCreateCancellationRuleBulkArgs = {
  input: CreateCancellationRuleBulkInput;
};


export type MutationCrudCreateCharityAmountHistoryBulkArgs = {
  input: CreateCharityAmountHistoryBulkInput;
};


export type MutationCrudCreateCharityBulkArgs = {
  input: CreateCharityBulkInput;
};


export type MutationCrudCreateCharityRatingHistoryBulkArgs = {
  input: CreateCharityRatingHistoryBulkInput;
};


export type MutationCrudCreateCharityRatingHistoryReportBulkArgs = {
  input: CreateCharityRatingHistoryReportBulkInput;
};


export type MutationCrudCreateChatQuickReplyMessageBulkArgs = {
  input: CreateChatQuickReplyMessageBulkInput;
};


export type MutationCrudCreateCheckinEventBulkArgs = {
  input: CreateCheckinEventBulkInput;
};


export type MutationCrudCreateCombineRuleBulkArgs = {
  input: CreateCombineRuleBulkInput;
};


export type MutationCrudCreateCombineRuleHistoryBulkArgs = {
  input: CreateCombineRuleHistoryBulkInput;
};


export type MutationCrudCreateCommunicationBulkArgs = {
  input: CreateCommunicationBulkInput;
};


export type MutationCrudCreateCompanyBulkArgs = {
  input: CreateCompanyBulkInput;
};


export type MutationCrudCreateCompletionBulkArgs = {
  input: CreateCompletionBulkInput;
};


export type MutationCrudCreateCompletionTypeBulkArgs = {
  input: CreateCompletionTypeBulkInput;
};


export type MutationCrudCreateContractBulkArgs = {
  input: CreateContractBulkInput;
};


export type MutationCrudCreateContractEmailBulkArgs = {
  input: CreateContractEmailBulkInput;
};


export type MutationCrudCreateContractNumberBulkArgs = {
  input: CreateContractNumberBulkInput;
};


export type MutationCrudCreateCountryRegionBulkArgs = {
  input: CreateCountryRegionBulkInput;
};


export type MutationCrudCreateCrewCountRequirementBulkArgs = {
  input: CreateCrewCountRequirementBulkInput;
};


export type MutationCrudCreateDashboardBulkArgs = {
  input: CreateDashboardBulkInput;
};


export type MutationCrudCreateDefectBulkArgs = {
  input: CreateDefectBulkInput;
};


export type MutationCrudCreateDeviceBulkArgs = {
  input: CreateDeviceBulkInput;
};


export type MutationCrudCreateDeviceMetricBulkArgs = {
  input: CreateDeviceMetricBulkInput;
};


export type MutationCrudCreateDispatchIssueBulkArgs = {
  input: CreateDispatchIssueBulkInput;
};


export type MutationCrudCreateDispatchIssueCausedByBulkArgs = {
  input: CreateDispatchIssueCausedByBulkInput;
};


export type MutationCrudCreateDispatchIssueDocumentBulkArgs = {
  input: CreateDispatchIssueDocumentBulkInput;
};


export type MutationCrudCreateDispatchSummaryBulkArgs = {
  input: CreateDispatchSummaryBulkInput;
};


export type MutationCrudCreateDispatchSummaryDocumentBulkArgs = {
  input: CreateDispatchSummaryDocumentBulkInput;
};


export type MutationCrudCreateDispatchSummaryMarketBulkArgs = {
  input: CreateDispatchSummaryMarketBulkInput;
};


export type MutationCrudCreateDistanceBulkArgs = {
  input: CreateDistanceBulkInput;
};


export type MutationCrudCreateDriverEtaBulkArgs = {
  input: CreateDriverEtaBulkInput;
};


export type MutationCrudCreateDriverVehicleAssignmentBulkArgs = {
  input: CreateDriverVehicleAssignmentBulkInput;
};


export type MutationCrudCreateDtrLocationBulkArgs = {
  input: CreateDtrLocationBulkInput;
};


export type MutationCrudCreateDvirBulkArgs = {
  input: CreateDvirBulkInput;
};


export type MutationCrudCreateDvirSignatureBulkArgs = {
  input: CreateDvirSignatureBulkInput;
};


export type MutationCrudCreateEmailBulkArgs = {
  input: CreateEmailBulkInput;
};


export type MutationCrudCreateEquivalentTripBulkArgs = {
  input: CreateEquivalentTripBulkInput;
};


export type MutationCrudCreateEventBulkArgs = {
  input: CreateEventBulkInput;
};


export type MutationCrudCreateFcrBulkArgs = {
  input: CreateFcrBulkInput;
};


export type MutationCrudCreateFcrTypeBulkArgs = {
  input: CreateFcrTypeBulkInput;
};


export type MutationCrudCreateFlagBulkArgs = {
  input: CreateFlagBulkInput;
};


export type MutationCrudCreateFlagHasPotentialTripBulkArgs = {
  input: CreateFlagHasPotentialTripBulkInput;
};


export type MutationCrudCreateFlagHasStagedTripBulkArgs = {
  input: CreateFlagHasStagedTripBulkInput;
};


export type MutationCrudCreateFlagHasTripBulkArgs = {
  input: CreateFlagHasTripBulkInput;
};


export type MutationCrudCreateFlightHistoryBulkArgs = {
  input: CreateFlightHistoryBulkInput;
};


export type MutationCrudCreateGeneratedDocumentBulkArgs = {
  input: CreateGeneratedDocumentBulkInput;
};


export type MutationCrudCreateGeneratedDocumentLogBulkArgs = {
  input: CreateGeneratedDocumentLogBulkInput;
};


export type MutationCrudCreateGroupBulkArgs = {
  input: CreateGroupBulkInput;
};


export type MutationCrudCreateGroupHasPermissionBulkArgs = {
  input: CreateGroupHasPermissionBulkInput;
};


export type MutationCrudCreateGroupHasUserBulkArgs = {
  input: CreateGroupHasUserBulkInput;
};


export type MutationCrudCreateImageBulkArgs = {
  input: CreateImageBulkInput;
};


export type MutationCrudCreateImportBulkArgs = {
  input: CreateImportBulkInput;
};


export type MutationCrudCreateImportEmailBulkArgs = {
  input: CreateImportEmailBulkInput;
};


export type MutationCrudCreateImportFailureBulkArgs = {
  input: CreateImportFailureBulkInput;
};


export type MutationCrudCreateImportLogBulkArgs = {
  input: CreateImportLogBulkInput;
};


export type MutationCrudCreateImportOcrCacheBulkArgs = {
  input: CreateImportOcrCacheBulkInput;
};


export type MutationCrudCreateIncidentIssueBulkArgs = {
  input: CreateIncidentIssueBulkInput;
};


export type MutationCrudCreateIncidentIssueDocumentBulkArgs = {
  input: CreateIncidentIssueDocumentBulkInput;
};


export type MutationCrudCreateIndexBulkArgs = {
  input: CreateIndexBulkInput;
};


export type MutationCrudCreateInvoiceAirportBulkArgs = {
  input: CreateInvoiceAirportBulkInput;
};


export type MutationCrudCreateInvoiceBulkArgs = {
  input: CreateInvoiceBulkInput;
};


export type MutationCrudCreateInvoiceClientBulkArgs = {
  input: CreateInvoiceClientBulkInput;
};


export type MutationCrudCreateInvoiceCustomChargeBulkArgs = {
  input: CreateInvoiceCustomChargeBulkInput;
};


export type MutationCrudCreateInvoiceDocumentBulkArgs = {
  input: CreateInvoiceDocumentBulkInput;
};


export type MutationCrudCreateInvoiceEmailBulkArgs = {
  input: CreateInvoiceEmailBulkInput;
};


export type MutationCrudCreateInvoiceHeaderBulkArgs = {
  input: CreateInvoiceHeaderBulkInput;
};


export type MutationCrudCreateInvoiceIataCodeBulkArgs = {
  input: CreateInvoiceIataCodeBulkInput;
};


export type MutationCrudCreateInvoiceLineItemBulkArgs = {
  input: CreateInvoiceLineItemBulkInput;
};


export type MutationCrudCreateInvoiceProviderCacheBulkArgs = {
  input: CreateInvoiceProviderCacheBulkInput;
};


export type MutationCrudCreateInvoiceTermBulkArgs = {
  input: CreateInvoiceTermBulkInput;
};


export type MutationCrudCreateInvoiceTotalSummaryBulkArgs = {
  input: CreateInvoiceTotalSummaryBulkInput;
};


export type MutationCrudCreateInvoiceTripBulkArgs = {
  input: CreateInvoiceTripBulkInput;
};


export type MutationCrudCreateInvoiceTripStatusBulkArgs = {
  input: CreateInvoiceTripStatusBulkInput;
};


export type MutationCrudCreateInvoiceTypeBulkArgs = {
  input: CreateInvoiceTypeBulkInput;
};


export type MutationCrudCreateInvoiceUserCacheBulkArgs = {
  input: CreateInvoiceUserCacheBulkInput;
};


export type MutationCrudCreateIssueBulkArgs = {
  input: CreateIssueBulkInput;
};


export type MutationCrudCreateLicenseBulkArgs = {
  input: CreateLicenseBulkInput;
};


export type MutationCrudCreateLicenseTypeBulkArgs = {
  input: CreateLicenseTypeBulkInput;
};


export type MutationCrudCreateLineItemTypeBulkArgs = {
  input: CreateLineItemTypeBulkInput;
};


export type MutationCrudCreateLocationBulkArgs = {
  input: CreateLocationBulkInput;
};


export type MutationCrudCreateLoginEventBulkArgs = {
  input: CreateLoginEventBulkInput;
};


export type MutationCrudCreateLostAndFoundIssueBulkArgs = {
  input: CreateLostAndFoundIssueBulkInput;
};


export type MutationCrudCreateLostAndFoundIssueDocumentBulkArgs = {
  input: CreateLostAndFoundIssueDocumentBulkInput;
};


export type MutationCrudCreateManifestHistoryBulkArgs = {
  input: CreateManifestHistoryBulkInput;
};


export type MutationCrudCreateManifestHistoryRouteBulkArgs = {
  input: CreateManifestHistoryRouteBulkInput;
};


export type MutationCrudCreateManifestProviderCacheBulkArgs = {
  input: CreateManifestProviderCacheBulkInput;
};


export type MutationCrudCreateManifestUserCacheBulkArgs = {
  input: CreateManifestUserCacheBulkInput;
};


export type MutationCrudCreateMessageBulkArgs = {
  input: CreateMessageBulkInput;
};


export type MutationCrudCreateNotificationBulkArgs = {
  input: CreateNotificationBulkInput;
};


export type MutationCrudCreateNotificationHasEventBulkArgs = {
  input: CreateNotificationHasEventBulkInput;
};


export type MutationCrudCreateParsedTripBulkArgs = {
  input: CreateParsedTripBulkInput;
};


export type MutationCrudCreatePermissionBulkArgs = {
  input: CreatePermissionBulkInput;
};


export type MutationCrudCreatePermissionHasRoleBulkArgs = {
  input: CreatePermissionHasRoleBulkInput;
};


export type MutationCrudCreatePermissionHasUserBulkArgs = {
  input: CreatePermissionHasUserBulkInput;
};


export type MutationCrudCreatePickupPointBulkArgs = {
  input: CreatePickupPointBulkInput;
};


export type MutationCrudCreatePotentialTripBulkArgs = {
  input: CreatePotentialTripBulkInput;
};


export type MutationCrudCreateProviderAliasBulkArgs = {
  input: CreateProviderAliasBulkInput;
};


export type MutationCrudCreateProviderBulkArgs = {
  input: CreateProviderBulkInput;
};


export type MutationCrudCreateProviderCacheBulkArgs = {
  input: CreateProviderCacheBulkInput;
};


export type MutationCrudCreateProviderLocationMappingBulkArgs = {
  input: CreateProviderLocationMappingBulkInput;
};


export type MutationCrudCreatePunchBulkArgs = {
  input: CreatePunchBulkInput;
};


export type MutationCrudCreatePunchHistoryBulkArgs = {
  input: CreatePunchHistoryBulkInput;
};


export type MutationCrudCreatePunchPolicyBulkArgs = {
  input: CreatePunchPolicyBulkInput;
};


export type MutationCrudCreateQueryHistoryBulkArgs = {
  input: CreateQueryHistoryBulkInput;
};


export type MutationCrudCreateQuestionnaireAnswerOptionBulkArgs = {
  input: CreateQuestionnaireAnswerOptionBulkInput;
};


export type MutationCrudCreateQuestionnaireAnswerTypeBulkArgs = {
  input: CreateQuestionnaireAnswerTypeBulkInput;
};


export type MutationCrudCreateQuestionnaireAttemptAnswerOptionSnapshotBulkArgs = {
  input: CreateQuestionnaireAttemptAnswerOptionSnapshotBulkInput;
};


export type MutationCrudCreateQuestionnaireAttemptBulkArgs = {
  input: CreateQuestionnaireAttemptBulkInput;
};


export type MutationCrudCreateQuestionnaireAttemptCategorySnapshotAllowedGroupBulkArgs = {
  input: CreateQuestionnaireAttemptCategorySnapshotAllowedGroupBulkInput;
};


export type MutationCrudCreateQuestionnaireAttemptCategorySnapshotBulkArgs = {
  input: CreateQuestionnaireAttemptCategorySnapshotBulkInput;
};


export type MutationCrudCreateQuestionnaireAttemptCategorySnapshotGroupBulkArgs = {
  input: CreateQuestionnaireAttemptCategorySnapshotGroupBulkInput;
};


export type MutationCrudCreateQuestionnaireAttemptNoteBulkArgs = {
  input: CreateQuestionnaireAttemptNoteBulkInput;
};


export type MutationCrudCreateQuestionnaireAttemptQuestionSnapshotBulkArgs = {
  input: CreateQuestionnaireAttemptQuestionSnapshotBulkInput;
};


export type MutationCrudCreateQuestionnaireCategoryBulkArgs = {
  input: CreateQuestionnaireCategoryBulkInput;
};


export type MutationCrudCreateQuestionnaireQuestionBulkArgs = {
  input: CreateQuestionnaireQuestionBulkInput;
};


export type MutationCrudCreateRateBulkArgs = {
  input: CreateRateBulkInput;
};


export type MutationCrudCreateRateGroupBulkArgs = {
  input: CreateRateGroupBulkInput;
};


export type MutationCrudCreateRateHistoryBulkArgs = {
  input: CreateRateHistoryBulkInput;
};


export type MutationCrudCreateRateItemBulkArgs = {
  input: CreateRateItemBulkInput;
};


export type MutationCrudCreateRatingBulkArgs = {
  input: CreateRatingBulkInput;
};


export type MutationCrudCreateRatingCacheBulkArgs = {
  input: CreateRatingCacheBulkInput;
};


export type MutationCrudCreateRatingCacheRemarkBulkArgs = {
  input: CreateRatingCacheRemarkBulkInput;
};


export type MutationCrudCreateRatingRemarkBulkArgs = {
  input: CreateRatingRemarkBulkInput;
};


export type MutationCrudCreateRatingTypeBulkArgs = {
  input: CreateRatingTypeBulkInput;
};


export type MutationCrudCreateRoleBulkArgs = {
  input: CreateRoleBulkInput;
};


export type MutationCrudCreateSettingsBulkArgs = {
  input: CreateSettingsBulkInput;
};


export type MutationCrudCreateSocialDistanceRuleBulkArgs = {
  input: CreateSocialDistanceRuleBulkInput;
};


export type MutationCrudCreateStagedTripBulkArgs = {
  input: CreateStagedTripBulkInput;
};


export type MutationCrudCreateStopBulkArgs = {
  input: CreateStopBulkInput;
};


export type MutationCrudCreateStorageBulkArgs = {
  input: CreateStorageBulkInput;
};


export type MutationCrudCreateTimeFrameBulkArgs = {
  input: CreateTimeFrameBulkInput;
};


export type MutationCrudCreateTimeFrameRangeBulkArgs = {
  input: CreateTimeFrameRangeBulkInput;
};


export type MutationCrudCreateTrackFlightBulkArgs = {
  input: CreateTrackFlightBulkInput;
};


export type MutationCrudCreateTrainingUserCacheBulkArgs = {
  input: CreateTrainingUserCacheBulkInput;
};


export type MutationCrudCreateTripBulkArgs = {
  input: CreateTripBulkInput;
};


export type MutationCrudCreateTripDocumentBulkArgs = {
  input: CreateTripDocumentBulkInput;
};


export type MutationCrudCreateTripHasImportBulkArgs = {
  input: CreateTripHasImportBulkInput;
};


export type MutationCrudCreateTripScheduleTriggerBulkArgs = {
  input: CreateTripScheduleTriggerBulkInput;
};


export type MutationCrudCreateUpdateStrategyBulkArgs = {
  input: CreateUpdateStrategyBulkInput;
};


export type MutationCrudCreateUserAvailabilityBulkArgs = {
  input: CreateUserAvailabilityBulkInput;
};


export type MutationCrudCreateUserBulkArgs = {
  input: CreateUserBulkInput;
};


export type MutationCrudCreateUserCacheBulkArgs = {
  input: CreateUserCacheBulkInput;
};


export type MutationCrudCreateUserHasAirportBulkArgs = {
  input: CreateUserHasAirportBulkInput;
};


export type MutationCrudCreateVariableTimeBulkArgs = {
  input: CreateVariableTimeBulkInput;
};


export type MutationCrudCreateVehicleBulkArgs = {
  input: CreateVehicleBulkInput;
};


export type MutationCrudCreateWidgetBulkArgs = {
  input: CreateWidgetBulkInput;
};


export type MutationCrudCreateWidgetFilterBulkArgs = {
  input: CreateWidgetFilterBulkInput;
};


export type MutationCrudDeleteAccidentIssueBulkArgs = {
  input: DeleteAccidentIssueBulkInput;
};


export type MutationCrudDeleteAccidentIssueDocumentBulkArgs = {
  input: DeleteAccidentIssueDocumentBulkInput;
};


export type MutationCrudDeleteActivityBulkArgs = {
  input: DeleteActivityBulkInput;
};


export type MutationCrudDeleteActivityObjectBulkArgs = {
  input: DeleteActivityObjectBulkInput;
};


export type MutationCrudDeleteAirportBulkArgs = {
  input: DeleteAirportBulkInput;
};


export type MutationCrudDeleteAirportGroupBulkArgs = {
  input: DeleteAirportGroupBulkInput;
};


export type MutationCrudDeleteAirportHasCompanyBulkArgs = {
  input: DeleteAirportHasCompanyBulkInput;
};


export type MutationCrudDeleteAirportHasGroupBulkArgs = {
  input: DeleteAirportHasGroupBulkInput;
};


export type MutationCrudDeleteAirportHasLocationBulkArgs = {
  input: DeleteAirportHasLocationBulkInput;
};


export type MutationCrudDeleteAirportHasManagerEmailBulkArgs = {
  input: DeleteAirportHasManagerEmailBulkInput;
};


export type MutationCrudDeleteAirportHasRateBulkArgs = {
  input: DeleteAirportHasRateBulkInput;
};


export type MutationCrudDeleteAirportHasVehicleBulkArgs = {
  input: DeleteAirportHasVehicleBulkInput;
};


export type MutationCrudDeleteAlertSubscriptionBulkArgs = {
  input: DeleteAlertSubscriptionBulkInput;
};


export type MutationCrudDeleteAliasBulkArgs = {
  input: DeleteAliasBulkInput;
};


export type MutationCrudDeleteApiKeyBulkArgs = {
  input: DeleteApiKeyBulkInput;
};


export type MutationCrudDeleteAuditSnapshotBulkArgs = {
  input: DeleteAuditSnapshotBulkInput;
};


export type MutationCrudDeleteAutoCombineRuleBulkArgs = {
  input: DeleteAutoCombineRuleBulkInput;
};


export type MutationCrudDeleteAutomationHistoryAirportBulkArgs = {
  input: DeleteAutomationHistoryAirportBulkInput;
};


export type MutationCrudDeleteAutomationHistoryBulkArgs = {
  input: DeleteAutomationHistoryBulkInput;
};


export type MutationCrudDeleteAutomationHistoryLogBulkArgs = {
  input: DeleteAutomationHistoryLogBulkInput;
};


export type MutationCrudDeleteAutomationReportBulkArgs = {
  input: DeleteAutomationReportBulkInput;
};


export type MutationCrudDeleteAutomationTripAssignmentReasonBulkArgs = {
  input: DeleteAutomationTripAssignmentReasonBulkInput;
};


export type MutationCrudDeleteAutomationTripBulkArgs = {
  input: DeleteAutomationTripBulkInput;
};


export type MutationCrudDeleteAutomationTripLogBulkArgs = {
  input: DeleteAutomationTripLogBulkInput;
};


export type MutationCrudDeleteBufferTimeBulkArgs = {
  input: DeleteBufferTimeBulkInput;
};


export type MutationCrudDeleteCancellationRuleBulkArgs = {
  input: DeleteCancellationRuleBulkInput;
};


export type MutationCrudDeleteCharityAmountHistoryBulkArgs = {
  input: DeleteCharityAmountHistoryBulkInput;
};


export type MutationCrudDeleteCharityBulkArgs = {
  input: DeleteCharityBulkInput;
};


export type MutationCrudDeleteCharityRatingHistoryBulkArgs = {
  input: DeleteCharityRatingHistoryBulkInput;
};


export type MutationCrudDeleteCharityRatingHistoryReportBulkArgs = {
  input: DeleteCharityRatingHistoryReportBulkInput;
};


export type MutationCrudDeleteChatQuickReplyMessageBulkArgs = {
  input: DeleteChatQuickReplyMessageBulkInput;
};


export type MutationCrudDeleteCheckinEventBulkArgs = {
  input: DeleteCheckinEventBulkInput;
};


export type MutationCrudDeleteCombineRuleBulkArgs = {
  input: DeleteCombineRuleBulkInput;
};


export type MutationCrudDeleteCombineRuleHistoryBulkArgs = {
  input: DeleteCombineRuleHistoryBulkInput;
};


export type MutationCrudDeleteCommunicationBulkArgs = {
  input: DeleteCommunicationBulkInput;
};


export type MutationCrudDeleteCompanyBulkArgs = {
  input: DeleteCompanyBulkInput;
};


export type MutationCrudDeleteCompletionBulkArgs = {
  input: DeleteCompletionBulkInput;
};


export type MutationCrudDeleteCompletionTypeBulkArgs = {
  input: DeleteCompletionTypeBulkInput;
};


export type MutationCrudDeleteContractBulkArgs = {
  input: DeleteContractBulkInput;
};


export type MutationCrudDeleteContractEmailBulkArgs = {
  input: DeleteContractEmailBulkInput;
};


export type MutationCrudDeleteContractNumberBulkArgs = {
  input: DeleteContractNumberBulkInput;
};


export type MutationCrudDeleteCountryRegionBulkArgs = {
  input: DeleteCountryRegionBulkInput;
};


export type MutationCrudDeleteCrewCountRequirementBulkArgs = {
  input: DeleteCrewCountRequirementBulkInput;
};


export type MutationCrudDeleteDashboardBulkArgs = {
  input: DeleteDashboardBulkInput;
};


export type MutationCrudDeleteDefectBulkArgs = {
  input: DeleteDefectBulkInput;
};


export type MutationCrudDeleteDeviceBulkArgs = {
  input: DeleteDeviceBulkInput;
};


export type MutationCrudDeleteDeviceMetricBulkArgs = {
  input: DeleteDeviceMetricBulkInput;
};


export type MutationCrudDeleteDispatchIssueBulkArgs = {
  input: DeleteDispatchIssueBulkInput;
};


export type MutationCrudDeleteDispatchIssueCausedByBulkArgs = {
  input: DeleteDispatchIssueCausedByBulkInput;
};


export type MutationCrudDeleteDispatchIssueDocumentBulkArgs = {
  input: DeleteDispatchIssueDocumentBulkInput;
};


export type MutationCrudDeleteDispatchSummaryBulkArgs = {
  input: DeleteDispatchSummaryBulkInput;
};


export type MutationCrudDeleteDispatchSummaryDocumentBulkArgs = {
  input: DeleteDispatchSummaryDocumentBulkInput;
};


export type MutationCrudDeleteDispatchSummaryMarketBulkArgs = {
  input: DeleteDispatchSummaryMarketBulkInput;
};


export type MutationCrudDeleteDistanceBulkArgs = {
  input: DeleteDistanceBulkInput;
};


export type MutationCrudDeleteDriverEtaBulkArgs = {
  input: DeleteDriverEtaBulkInput;
};


export type MutationCrudDeleteDriverVehicleAssignmentBulkArgs = {
  input: DeleteDriverVehicleAssignmentBulkInput;
};


export type MutationCrudDeleteDtrLocationBulkArgs = {
  input: DeleteDtrLocationBulkInput;
};


export type MutationCrudDeleteDvirBulkArgs = {
  input: DeleteDvirBulkInput;
};


export type MutationCrudDeleteDvirSignatureBulkArgs = {
  input: DeleteDvirSignatureBulkInput;
};


export type MutationCrudDeleteEmailBulkArgs = {
  input: DeleteEmailBulkInput;
};


export type MutationCrudDeleteEquivalentTripBulkArgs = {
  input: DeleteEquivalentTripBulkInput;
};


export type MutationCrudDeleteEventBulkArgs = {
  input: DeleteEventBulkInput;
};


export type MutationCrudDeleteFcrBulkArgs = {
  input: DeleteFcrBulkInput;
};


export type MutationCrudDeleteFcrTypeBulkArgs = {
  input: DeleteFcrTypeBulkInput;
};


export type MutationCrudDeleteFlagBulkArgs = {
  input: DeleteFlagBulkInput;
};


export type MutationCrudDeleteFlagHasPotentialTripBulkArgs = {
  input: DeleteFlagHasPotentialTripBulkInput;
};


export type MutationCrudDeleteFlagHasStagedTripBulkArgs = {
  input: DeleteFlagHasStagedTripBulkInput;
};


export type MutationCrudDeleteFlagHasTripBulkArgs = {
  input: DeleteFlagHasTripBulkInput;
};


export type MutationCrudDeleteFlightHistoryBulkArgs = {
  input: DeleteFlightHistoryBulkInput;
};


export type MutationCrudDeleteGeneratedDocumentBulkArgs = {
  input: DeleteGeneratedDocumentBulkInput;
};


export type MutationCrudDeleteGeneratedDocumentLogBulkArgs = {
  input: DeleteGeneratedDocumentLogBulkInput;
};


export type MutationCrudDeleteGroupBulkArgs = {
  input: DeleteGroupBulkInput;
};


export type MutationCrudDeleteGroupHasPermissionBulkArgs = {
  input: DeleteGroupHasPermissionBulkInput;
};


export type MutationCrudDeleteGroupHasUserBulkArgs = {
  input: DeleteGroupHasUserBulkInput;
};


export type MutationCrudDeleteImageBulkArgs = {
  input: DeleteImageBulkInput;
};


export type MutationCrudDeleteImportBulkArgs = {
  input: DeleteImportBulkInput;
};


export type MutationCrudDeleteImportEmailBulkArgs = {
  input: DeleteImportEmailBulkInput;
};


export type MutationCrudDeleteImportFailureBulkArgs = {
  input: DeleteImportFailureBulkInput;
};


export type MutationCrudDeleteImportLogBulkArgs = {
  input: DeleteImportLogBulkInput;
};


export type MutationCrudDeleteImportOcrCacheBulkArgs = {
  input: DeleteImportOcrCacheBulkInput;
};


export type MutationCrudDeleteIncidentIssueBulkArgs = {
  input: DeleteIncidentIssueBulkInput;
};


export type MutationCrudDeleteIncidentIssueDocumentBulkArgs = {
  input: DeleteIncidentIssueDocumentBulkInput;
};


export type MutationCrudDeleteIndexBulkArgs = {
  input: DeleteIndexBulkInput;
};


export type MutationCrudDeleteInvoiceAirportBulkArgs = {
  input: DeleteInvoiceAirportBulkInput;
};


export type MutationCrudDeleteInvoiceBulkArgs = {
  input: DeleteInvoiceBulkInput;
};


export type MutationCrudDeleteInvoiceClientBulkArgs = {
  input: DeleteInvoiceClientBulkInput;
};


export type MutationCrudDeleteInvoiceCustomChargeBulkArgs = {
  input: DeleteInvoiceCustomChargeBulkInput;
};


export type MutationCrudDeleteInvoiceDocumentBulkArgs = {
  input: DeleteInvoiceDocumentBulkInput;
};


export type MutationCrudDeleteInvoiceEmailBulkArgs = {
  input: DeleteInvoiceEmailBulkInput;
};


export type MutationCrudDeleteInvoiceHeaderBulkArgs = {
  input: DeleteInvoiceHeaderBulkInput;
};


export type MutationCrudDeleteInvoiceIataCodeBulkArgs = {
  input: DeleteInvoiceIataCodeBulkInput;
};


export type MutationCrudDeleteInvoiceLineItemBulkArgs = {
  input: DeleteInvoiceLineItemBulkInput;
};


export type MutationCrudDeleteInvoiceProviderCacheBulkArgs = {
  input: DeleteInvoiceProviderCacheBulkInput;
};


export type MutationCrudDeleteInvoiceTermBulkArgs = {
  input: DeleteInvoiceTermBulkInput;
};


export type MutationCrudDeleteInvoiceTotalSummaryBulkArgs = {
  input: DeleteInvoiceTotalSummaryBulkInput;
};


export type MutationCrudDeleteInvoiceTripBulkArgs = {
  input: DeleteInvoiceTripBulkInput;
};


export type MutationCrudDeleteInvoiceTripStatusBulkArgs = {
  input: DeleteInvoiceTripStatusBulkInput;
};


export type MutationCrudDeleteInvoiceTypeBulkArgs = {
  input: DeleteInvoiceTypeBulkInput;
};


export type MutationCrudDeleteInvoiceUserCacheBulkArgs = {
  input: DeleteInvoiceUserCacheBulkInput;
};


export type MutationCrudDeleteIssueBulkArgs = {
  input: DeleteIssueBulkInput;
};


export type MutationCrudDeleteLicenseBulkArgs = {
  input: DeleteLicenseBulkInput;
};


export type MutationCrudDeleteLicenseTypeBulkArgs = {
  input: DeleteLicenseTypeBulkInput;
};


export type MutationCrudDeleteLineItemTypeBulkArgs = {
  input: DeleteLineItemTypeBulkInput;
};


export type MutationCrudDeleteLocationBulkArgs = {
  input: DeleteLocationBulkInput;
};


export type MutationCrudDeleteLoginEventBulkArgs = {
  input: DeleteLoginEventBulkInput;
};


export type MutationCrudDeleteLostAndFoundIssueBulkArgs = {
  input: DeleteLostAndFoundIssueBulkInput;
};


export type MutationCrudDeleteLostAndFoundIssueDocumentBulkArgs = {
  input: DeleteLostAndFoundIssueDocumentBulkInput;
};


export type MutationCrudDeleteManifestHistoryBulkArgs = {
  input: DeleteManifestHistoryBulkInput;
};


export type MutationCrudDeleteManifestHistoryRouteBulkArgs = {
  input: DeleteManifestHistoryRouteBulkInput;
};


export type MutationCrudDeleteManifestProviderCacheBulkArgs = {
  input: DeleteManifestProviderCacheBulkInput;
};


export type MutationCrudDeleteManifestUserCacheBulkArgs = {
  input: DeleteManifestUserCacheBulkInput;
};


export type MutationCrudDeleteMessageBulkArgs = {
  input: DeleteMessageBulkInput;
};


export type MutationCrudDeleteNotificationBulkArgs = {
  input: DeleteNotificationBulkInput;
};


export type MutationCrudDeleteNotificationHasEventBulkArgs = {
  input: DeleteNotificationHasEventBulkInput;
};


export type MutationCrudDeleteParsedTripBulkArgs = {
  input: DeleteParsedTripBulkInput;
};


export type MutationCrudDeletePermissionBulkArgs = {
  input: DeletePermissionBulkInput;
};


export type MutationCrudDeletePermissionHasRoleBulkArgs = {
  input: DeletePermissionHasRoleBulkInput;
};


export type MutationCrudDeletePermissionHasUserBulkArgs = {
  input: DeletePermissionHasUserBulkInput;
};


export type MutationCrudDeletePickupPointBulkArgs = {
  input: DeletePickupPointBulkInput;
};


export type MutationCrudDeletePotentialTripBulkArgs = {
  input: DeletePotentialTripBulkInput;
};


export type MutationCrudDeleteProviderAliasBulkArgs = {
  input: DeleteProviderAliasBulkInput;
};


export type MutationCrudDeleteProviderBulkArgs = {
  input: DeleteProviderBulkInput;
};


export type MutationCrudDeleteProviderCacheBulkArgs = {
  input: DeleteProviderCacheBulkInput;
};


export type MutationCrudDeleteProviderLocationMappingBulkArgs = {
  input: DeleteProviderLocationMappingBulkInput;
};


export type MutationCrudDeletePunchBulkArgs = {
  input: DeletePunchBulkInput;
};


export type MutationCrudDeletePunchHistoryBulkArgs = {
  input: DeletePunchHistoryBulkInput;
};


export type MutationCrudDeletePunchPolicyBulkArgs = {
  input: DeletePunchPolicyBulkInput;
};


export type MutationCrudDeleteQueryHistoryBulkArgs = {
  input: DeleteQueryHistoryBulkInput;
};


export type MutationCrudDeleteQuestionnaireAnswerOptionBulkArgs = {
  input: DeleteQuestionnaireAnswerOptionBulkInput;
};


export type MutationCrudDeleteQuestionnaireAnswerTypeBulkArgs = {
  input: DeleteQuestionnaireAnswerTypeBulkInput;
};


export type MutationCrudDeleteQuestionnaireAttemptAnswerOptionSnapshotBulkArgs = {
  input: DeleteQuestionnaireAttemptAnswerOptionSnapshotBulkInput;
};


export type MutationCrudDeleteQuestionnaireAttemptBulkArgs = {
  input: DeleteQuestionnaireAttemptBulkInput;
};


export type MutationCrudDeleteQuestionnaireAttemptCategorySnapshotAllowedGroupBulkArgs = {
  input: DeleteQuestionnaireAttemptCategorySnapshotAllowedGroupBulkInput;
};


export type MutationCrudDeleteQuestionnaireAttemptCategorySnapshotBulkArgs = {
  input: DeleteQuestionnaireAttemptCategorySnapshotBulkInput;
};


export type MutationCrudDeleteQuestionnaireAttemptCategorySnapshotGroupBulkArgs = {
  input: DeleteQuestionnaireAttemptCategorySnapshotGroupBulkInput;
};


export type MutationCrudDeleteQuestionnaireAttemptNoteBulkArgs = {
  input: DeleteQuestionnaireAttemptNoteBulkInput;
};


export type MutationCrudDeleteQuestionnaireAttemptQuestionSnapshotBulkArgs = {
  input: DeleteQuestionnaireAttemptQuestionSnapshotBulkInput;
};


export type MutationCrudDeleteQuestionnaireCategoryBulkArgs = {
  input: DeleteQuestionnaireCategoryBulkInput;
};


export type MutationCrudDeleteQuestionnaireQuestionBulkArgs = {
  input: DeleteQuestionnaireQuestionBulkInput;
};


export type MutationCrudDeleteRateBulkArgs = {
  input: DeleteRateBulkInput;
};


export type MutationCrudDeleteRateGroupBulkArgs = {
  input: DeleteRateGroupBulkInput;
};


export type MutationCrudDeleteRateHistoryBulkArgs = {
  input: DeleteRateHistoryBulkInput;
};


export type MutationCrudDeleteRateItemBulkArgs = {
  input: DeleteRateItemBulkInput;
};


export type MutationCrudDeleteRatingBulkArgs = {
  input: DeleteRatingBulkInput;
};


export type MutationCrudDeleteRatingCacheBulkArgs = {
  input: DeleteRatingCacheBulkInput;
};


export type MutationCrudDeleteRatingCacheRemarkBulkArgs = {
  input: DeleteRatingCacheRemarkBulkInput;
};


export type MutationCrudDeleteRatingRemarkBulkArgs = {
  input: DeleteRatingRemarkBulkInput;
};


export type MutationCrudDeleteRatingTypeBulkArgs = {
  input: DeleteRatingTypeBulkInput;
};


export type MutationCrudDeleteRoleBulkArgs = {
  input: DeleteRoleBulkInput;
};


export type MutationCrudDeleteSettingsBulkArgs = {
  input: DeleteSettingsBulkInput;
};


export type MutationCrudDeleteSocialDistanceRuleBulkArgs = {
  input: DeleteSocialDistanceRuleBulkInput;
};


export type MutationCrudDeleteStagedTripBulkArgs = {
  input: DeleteStagedTripBulkInput;
};


export type MutationCrudDeleteStopBulkArgs = {
  input: DeleteStopBulkInput;
};


export type MutationCrudDeleteStorageBulkArgs = {
  input: DeleteStorageBulkInput;
};


export type MutationCrudDeleteTimeFrameBulkArgs = {
  input: DeleteTimeFrameBulkInput;
};


export type MutationCrudDeleteTimeFrameRangeBulkArgs = {
  input: DeleteTimeFrameRangeBulkInput;
};


export type MutationCrudDeleteTrackFlightBulkArgs = {
  input: DeleteTrackFlightBulkInput;
};


export type MutationCrudDeleteTrainingUserCacheBulkArgs = {
  input: DeleteTrainingUserCacheBulkInput;
};


export type MutationCrudDeleteTripBulkArgs = {
  input: DeleteTripBulkInput;
};


export type MutationCrudDeleteTripDocumentBulkArgs = {
  input: DeleteTripDocumentBulkInput;
};


export type MutationCrudDeleteTripHasImportBulkArgs = {
  input: DeleteTripHasImportBulkInput;
};


export type MutationCrudDeleteTripScheduleTriggerBulkArgs = {
  input: DeleteTripScheduleTriggerBulkInput;
};


export type MutationCrudDeleteUpdateStrategyBulkArgs = {
  input: DeleteUpdateStrategyBulkInput;
};


export type MutationCrudDeleteUserAvailabilityBulkArgs = {
  input: DeleteUserAvailabilityBulkInput;
};


export type MutationCrudDeleteUserBulkArgs = {
  input: DeleteUserBulkInput;
};


export type MutationCrudDeleteUserCacheBulkArgs = {
  input: DeleteUserCacheBulkInput;
};


export type MutationCrudDeleteUserHasAirportBulkArgs = {
  input: DeleteUserHasAirportBulkInput;
};


export type MutationCrudDeleteVariableTimeBulkArgs = {
  input: DeleteVariableTimeBulkInput;
};


export type MutationCrudDeleteVehicleBulkArgs = {
  input: DeleteVehicleBulkInput;
};


export type MutationCrudDeleteWidgetBulkArgs = {
  input: DeleteWidgetBulkInput;
};


export type MutationCrudDeleteWidgetFilterBulkArgs = {
  input: DeleteWidgetFilterBulkInput;
};


export type MutationCrudDownloadAccidentIssueAsCsvArgs = {
  input: DownloadAccidentIssueAsCsvInput;
};


export type MutationCrudDownloadAccidentIssueDocumentAsCsvArgs = {
  input: DownloadAccidentIssueDocumentAsCsvInput;
};


export type MutationCrudDownloadAccidentIssueWithCacheAsCsvArgs = {
  input: DownloadAccidentIssueWithCacheAsCsvInput;
};


export type MutationCrudDownloadActivityAsCsvArgs = {
  input: DownloadActivityAsCsvInput;
};


export type MutationCrudDownloadActivityDisplayMessageAsCsvArgs = {
  input: DownloadActivityDisplayMessageAsCsvInput;
};


export type MutationCrudDownloadActivityLogAsCsvArgs = {
  input: DownloadActivityLogAsCsvInput;
};


export type MutationCrudDownloadActivityLogPayloadAsCsvArgs = {
  input: DownloadActivityLogPayloadAsCsvInput;
};


export type MutationCrudDownloadActivityLogPayloadChildAsCsvArgs = {
  input: DownloadActivityLogPayloadChildAsCsvInput;
};


export type MutationCrudDownloadActivityLogWithCacheAsCsvArgs = {
  input: DownloadActivityLogWithCacheAsCsvInput;
};


export type MutationCrudDownloadActivityObjectAsCsvArgs = {
  input: DownloadActivityObjectAsCsvInput;
};


export type MutationCrudDownloadActivityUserCacheAsCsvArgs = {
  input: DownloadActivityUserCacheAsCsvInput;
};


export type MutationCrudDownloadAirportAsCsvArgs = {
  input: DownloadAirportAsCsvInput;
};


export type MutationCrudDownloadAirportGroupAsCsvArgs = {
  input: DownloadAirportGroupAsCsvInput;
};


export type MutationCrudDownloadAirportHasCompanyAsCsvArgs = {
  input: DownloadAirportHasCompanyAsCsvInput;
};


export type MutationCrudDownloadAirportHasGroupAsCsvArgs = {
  input: DownloadAirportHasGroupAsCsvInput;
};


export type MutationCrudDownloadAirportHasLocationAsCsvArgs = {
  input: DownloadAirportHasLocationAsCsvInput;
};


export type MutationCrudDownloadAirportHasManagerEmailAsCsvArgs = {
  input: DownloadAirportHasManagerEmailAsCsvInput;
};


export type MutationCrudDownloadAirportHasRateAsCsvArgs = {
  input: DownloadAirportHasRateAsCsvInput;
};


export type MutationCrudDownloadAirportHasVehicleAsCsvArgs = {
  input: DownloadAirportHasVehicleAsCsvInput;
};


export type MutationCrudDownloadAirportWithCompanyAsCsvArgs = {
  input: DownloadAirportWithCompanyAsCsvInput;
};


export type MutationCrudDownloadAirportWithGroupAsCsvArgs = {
  input: DownloadAirportWithGroupAsCsvInput;
};


export type MutationCrudDownloadAirportWithLocationAsCsvArgs = {
  input: DownloadAirportWithLocationAsCsvInput;
};


export type MutationCrudDownloadAirportWithVehicleAsCsvArgs = {
  input: DownloadAirportWithVehicleAsCsvInput;
};


export type MutationCrudDownloadAlertSubscriptionAsCsvArgs = {
  input: DownloadAlertSubscriptionAsCsvInput;
};


export type MutationCrudDownloadAliasAsCsvArgs = {
  input: DownloadAliasAsCsvInput;
};


export type MutationCrudDownloadApiKeyAsCsvArgs = {
  input: DownloadApiKeyAsCsvInput;
};


export type MutationCrudDownloadAuditSnapshotAsCsvArgs = {
  input: DownloadAuditSnapshotAsCsvInput;
};


export type MutationCrudDownloadAuditSnapshotWithNameAsCsvArgs = {
  input: DownloadAuditSnapshotWithNameAsCsvInput;
};


export type MutationCrudDownloadAutoCombineRuleAsCsvArgs = {
  input: DownloadAutoCombineRuleAsCsvInput;
};


export type MutationCrudDownloadAutoCombineRuleWithContractAsCsvArgs = {
  input: DownloadAutoCombineRuleWithContractAsCsvInput;
};


export type MutationCrudDownloadAutomationHistoryAirportAsCsvArgs = {
  input: DownloadAutomationHistoryAirportAsCsvInput;
};


export type MutationCrudDownloadAutomationHistoryAsCsvArgs = {
  input: DownloadAutomationHistoryAsCsvInput;
};


export type MutationCrudDownloadAutomationHistoryLogAsCsvArgs = {
  input: DownloadAutomationHistoryLogAsCsvInput;
};


export type MutationCrudDownloadAutomationHistoryWithAirportAsCsvArgs = {
  input: DownloadAutomationHistoryWithAirportAsCsvInput;
};


export type MutationCrudDownloadAutomationReportAsCsvArgs = {
  input: DownloadAutomationReportAsCsvInput;
};


export type MutationCrudDownloadAutomationReportWithAutomationHistoryAsCsvArgs = {
  input: DownloadAutomationReportWithAutomationHistoryAsCsvInput;
};


export type MutationCrudDownloadAutomationTripAsCsvArgs = {
  input: DownloadAutomationTripAsCsvInput;
};


export type MutationCrudDownloadAutomationTripAssignmentReasonAsCsvArgs = {
  input: DownloadAutomationTripAssignmentReasonAsCsvInput;
};


export type MutationCrudDownloadAutomationTripLogAsCsvArgs = {
  input: DownloadAutomationTripLogAsCsvInput;
};


export type MutationCrudDownloadBufferTimeAsCsvArgs = {
  input: DownloadBufferTimeAsCsvInput;
};


export type MutationCrudDownloadBufferTimeWithContractAsCsvArgs = {
  input: DownloadBufferTimeWithContractAsCsvInput;
};


export type MutationCrudDownloadCancellationRuleAsCsvArgs = {
  input: DownloadCancellationRuleAsCsvInput;
};


export type MutationCrudDownloadCharityAmountHistoryAsCsvArgs = {
  input: DownloadCharityAmountHistoryAsCsvInput;
};


export type MutationCrudDownloadCharityAsCsvArgs = {
  input: DownloadCharityAsCsvInput;
};


export type MutationCrudDownloadCharityRatingHistoryAsCsvArgs = {
  input: DownloadCharityRatingHistoryAsCsvInput;
};


export type MutationCrudDownloadCharityRatingHistoryReportAsCsvArgs = {
  input: DownloadCharityRatingHistoryReportAsCsvInput;
};


export type MutationCrudDownloadCharityRatingHistoryWithUserAsCsvArgs = {
  input: DownloadCharityRatingHistoryWithUserAsCsvInput;
};


export type MutationCrudDownloadCharityWithAmountHistoryAsCsvArgs = {
  input: DownloadCharityWithAmountHistoryAsCsvInput;
};


export type MutationCrudDownloadChatQuickReplyMessageAsCsvArgs = {
  input: DownloadChatQuickReplyMessageAsCsvInput;
};


export type MutationCrudDownloadCheckinEventAsCsvArgs = {
  input: DownloadCheckinEventAsCsvInput;
};


export type MutationCrudDownloadClosestRateItemAsCsvArgs = {
  input: DownloadClosestRateItemAsCsvInput;
};


export type MutationCrudDownloadCombineRuleAsCsvArgs = {
  input: DownloadCombineRuleAsCsvInput;
};


export type MutationCrudDownloadCombineRuleHistoryAsCsvArgs = {
  input: DownloadCombineRuleHistoryAsCsvInput;
};


export type MutationCrudDownloadCombineRuleHistoryWithContractAsCsvArgs = {
  input: DownloadCombineRuleHistoryWithContractAsCsvInput;
};


export type MutationCrudDownloadCombineRuleWithContractAsCsvArgs = {
  input: DownloadCombineRuleWithContractAsCsvInput;
};


export type MutationCrudDownloadCommunicationAsCsvArgs = {
  input: DownloadCommunicationAsCsvInput;
};


export type MutationCrudDownloadCompanyAsCsvArgs = {
  input: DownloadCompanyAsCsvInput;
};


export type MutationCrudDownloadCompletionAsCsvArgs = {
  input: DownloadCompletionAsCsvInput;
};


export type MutationCrudDownloadCompletionTypeAsCsvArgs = {
  input: DownloadCompletionTypeAsCsvInput;
};


export type MutationCrudDownloadCompletionWithTypeAsCsvArgs = {
  input: DownloadCompletionWithTypeAsCsvInput;
};


export type MutationCrudDownloadContractAsCsvArgs = {
  input: DownloadContractAsCsvInput;
};


export type MutationCrudDownloadContractEmailAsCsvArgs = {
  input: DownloadContractEmailAsCsvInput;
};


export type MutationCrudDownloadContractNumberAsCsvArgs = {
  input: DownloadContractNumberAsCsvInput;
};


export type MutationCrudDownloadCountryRegionAsCsvArgs = {
  input: DownloadCountryRegionAsCsvInput;
};


export type MutationCrudDownloadCrewCountRequirementAsCsvArgs = {
  input: DownloadCrewCountRequirementAsCsvInput;
};


export type MutationCrudDownloadDashboardAsCsvArgs = {
  input: DownloadDashboardAsCsvInput;
};


export type MutationCrudDownloadDefectAsCsvArgs = {
  input: DownloadDefectAsCsvInput;
};


export type MutationCrudDownloadDeviceAsCsvArgs = {
  input: DownloadDeviceAsCsvInput;
};


export type MutationCrudDownloadDeviceMetricAsCsvArgs = {
  input: DownloadDeviceMetricAsCsvInput;
};


export type MutationCrudDownloadDeviceMetricWithUserAsCsvArgs = {
  input: DownloadDeviceMetricWithUserAsCsvInput;
};


export type MutationCrudDownloadDispatchIssueAsCsvArgs = {
  input: DownloadDispatchIssueAsCsvInput;
};


export type MutationCrudDownloadDispatchIssueCausedByAsCsvArgs = {
  input: DownloadDispatchIssueCausedByAsCsvInput;
};


export type MutationCrudDownloadDispatchIssueCausedByWithCacheAsCsvArgs = {
  input: DownloadDispatchIssueCausedByWithCacheAsCsvInput;
};


export type MutationCrudDownloadDispatchIssueDocumentAsCsvArgs = {
  input: DownloadDispatchIssueDocumentAsCsvInput;
};


export type MutationCrudDownloadDispatchIssueWithCacheAsCsvArgs = {
  input: DownloadDispatchIssueWithCacheAsCsvInput;
};


export type MutationCrudDownloadDispatchSummaryAsCsvArgs = {
  input: DownloadDispatchSummaryAsCsvInput;
};


export type MutationCrudDownloadDispatchSummaryDocumentAsCsvArgs = {
  input: DownloadDispatchSummaryDocumentAsCsvInput;
};


export type MutationCrudDownloadDispatchSummaryMarketAsCsvArgs = {
  input: DownloadDispatchSummaryMarketAsCsvInput;
};


export type MutationCrudDownloadDispatchSummaryWithCacheAsCsvArgs = {
  input: DownloadDispatchSummaryWithCacheAsCsvInput;
};


export type MutationCrudDownloadDistanceAsCsvArgs = {
  input: DownloadDistanceAsCsvInput;
};


export type MutationCrudDownloadDriverEtaAsCsvArgs = {
  input: DownloadDriverEtaAsCsvInput;
};


export type MutationCrudDownloadDriverEtaWithPreviousTripAsCsvArgs = {
  input: DownloadDriverEtaWithPreviousTripAsCsvInput;
};


export type MutationCrudDownloadDriverVehicleAssignmentAsCsvArgs = {
  input: DownloadDriverVehicleAssignmentAsCsvInput;
};


export type MutationCrudDownloadDtrLocationAsCsvArgs = {
  input: DownloadDtrLocationAsCsvInput;
};


export type MutationCrudDownloadDvirAsCsvArgs = {
  input: DownloadDvirAsCsvInput;
};


export type MutationCrudDownloadDvirSignatureAsCsvArgs = {
  input: DownloadDvirSignatureAsCsvInput;
};


export type MutationCrudDownloadEmailAsCsvArgs = {
  input: DownloadEmailAsCsvInput;
};


export type MutationCrudDownloadEquivalentTripAsCsvArgs = {
  input: DownloadEquivalentTripAsCsvInput;
};


export type MutationCrudDownloadEventAsCsvArgs = {
  input: DownloadEventAsCsvInput;
};


export type MutationCrudDownloadFcrAsCsvArgs = {
  input: DownloadFcrAsCsvInput;
};


export type MutationCrudDownloadFcrTypeAsCsvArgs = {
  input: DownloadFcrTypeAsCsvInput;
};


export type MutationCrudDownloadFlagAsCsvArgs = {
  input: DownloadFlagAsCsvInput;
};


export type MutationCrudDownloadFlagHasPotentialTripAsCsvArgs = {
  input: DownloadFlagHasPotentialTripAsCsvInput;
};


export type MutationCrudDownloadFlagHasStagedTripAsCsvArgs = {
  input: DownloadFlagHasStagedTripAsCsvInput;
};


export type MutationCrudDownloadFlagHasTripAsCsvArgs = {
  input: DownloadFlagHasTripAsCsvInput;
};


export type MutationCrudDownloadFlagWithTripAsCsvArgs = {
  input: DownloadFlagWithTripAsCsvInput;
};


export type MutationCrudDownloadFlightHistoryAsCsvArgs = {
  input: DownloadFlightHistoryAsCsvInput;
};


export type MutationCrudDownloadGeneratedDocumentAsCsvArgs = {
  input: DownloadGeneratedDocumentAsCsvInput;
};


export type MutationCrudDownloadGeneratedDocumentLogAsCsvArgs = {
  input: DownloadGeneratedDocumentLogAsCsvInput;
};


export type MutationCrudDownloadGroupAsCsvArgs = {
  input: DownloadGroupAsCsvInput;
};


export type MutationCrudDownloadGroupHasPermissionAsCsvArgs = {
  input: DownloadGroupHasPermissionAsCsvInput;
};


export type MutationCrudDownloadGroupHasUserAsCsvArgs = {
  input: DownloadGroupHasUserAsCsvInput;
};


export type MutationCrudDownloadGroupHasUserWithPermissionsAsCsvArgs = {
  input: DownloadGroupHasUserWithPermissionsAsCsvInput;
};


export type MutationCrudDownloadImageAsCsvArgs = {
  input: DownloadImageAsCsvInput;
};


export type MutationCrudDownloadImportAsCsvArgs = {
  input: DownloadImportAsCsvInput;
};


export type MutationCrudDownloadImportEmailAsCsvArgs = {
  input: DownloadImportEmailAsCsvInput;
};


export type MutationCrudDownloadImportFailureAsCsvArgs = {
  input: DownloadImportFailureAsCsvInput;
};


export type MutationCrudDownloadImportLogAsCsvArgs = {
  input: DownloadImportLogAsCsvInput;
};


export type MutationCrudDownloadImportOcrCacheAsCsvArgs = {
  input: DownloadImportOcrCacheAsCsvInput;
};


export type MutationCrudDownloadImportWithAirportAsCsvArgs = {
  input: DownloadImportWithAirportAsCsvInput;
};


export type MutationCrudDownloadImportWithAirportWithCacheAsCsvArgs = {
  input: DownloadImportWithAirportWithCacheAsCsvInput;
};


export type MutationCrudDownloadIncidentIssueAsCsvArgs = {
  input: DownloadIncidentIssueAsCsvInput;
};


export type MutationCrudDownloadIncidentIssueDocumentAsCsvArgs = {
  input: DownloadIncidentIssueDocumentAsCsvInput;
};


export type MutationCrudDownloadIncidentIssueWithCacheAsCsvArgs = {
  input: DownloadIncidentIssueWithCacheAsCsvInput;
};


export type MutationCrudDownloadIndexAsCsvArgs = {
  input: DownloadIndexAsCsvInput;
};


export type MutationCrudDownloadInvoiceAirportAsCsvArgs = {
  input: DownloadInvoiceAirportAsCsvInput;
};


export type MutationCrudDownloadInvoiceAsCsvArgs = {
  input: DownloadInvoiceAsCsvInput;
};


export type MutationCrudDownloadInvoiceClientAsCsvArgs = {
  input: DownloadInvoiceClientAsCsvInput;
};


export type MutationCrudDownloadInvoiceCustomChargeAsCsvArgs = {
  input: DownloadInvoiceCustomChargeAsCsvInput;
};


export type MutationCrudDownloadInvoiceDocumentAsCsvArgs = {
  input: DownloadInvoiceDocumentAsCsvInput;
};


export type MutationCrudDownloadInvoiceDocumentWithSummaryAsCsvArgs = {
  input: DownloadInvoiceDocumentWithSummaryAsCsvInput;
};


export type MutationCrudDownloadInvoiceEmailAsCsvArgs = {
  input: DownloadInvoiceEmailAsCsvInput;
};


export type MutationCrudDownloadInvoiceHeaderAsCsvArgs = {
  input: DownloadInvoiceHeaderAsCsvInput;
};


export type MutationCrudDownloadInvoiceIataCodeAsCsvArgs = {
  input: DownloadInvoiceIataCodeAsCsvInput;
};


export type MutationCrudDownloadInvoiceLineItemAsCsvArgs = {
  input: DownloadInvoiceLineItemAsCsvInput;
};


export type MutationCrudDownloadInvoiceProviderCacheAsCsvArgs = {
  input: DownloadInvoiceProviderCacheAsCsvInput;
};


export type MutationCrudDownloadInvoiceTermAsCsvArgs = {
  input: DownloadInvoiceTermAsCsvInput;
};


export type MutationCrudDownloadInvoiceTotalSummaryAsCsvArgs = {
  input: DownloadInvoiceTotalSummaryAsCsvInput;
};


export type MutationCrudDownloadInvoiceTripAsCsvArgs = {
  input: DownloadInvoiceTripAsCsvInput;
};


export type MutationCrudDownloadInvoiceTripStatusAsCsvArgs = {
  input: DownloadInvoiceTripStatusAsCsvInput;
};


export type MutationCrudDownloadInvoiceTypeAsCsvArgs = {
  input: DownloadInvoiceTypeAsCsvInput;
};


export type MutationCrudDownloadInvoiceUserCacheAsCsvArgs = {
  input: DownloadInvoiceUserCacheAsCsvInput;
};


export type MutationCrudDownloadIssueAsCsvArgs = {
  input: DownloadIssueAsCsvInput;
};


export type MutationCrudDownloadLatestRateAsCsvArgs = {
  input: DownloadLatestRateAsCsvInput;
};


export type MutationCrudDownloadLatestRateHistoryAsCsvArgs = {
  input: DownloadLatestRateHistoryAsCsvInput;
};


export type MutationCrudDownloadLicenseAsCsvArgs = {
  input: DownloadLicenseAsCsvInput;
};


export type MutationCrudDownloadLicenseTypeAsCsvArgs = {
  input: DownloadLicenseTypeAsCsvInput;
};


export type MutationCrudDownloadLineItemTypeAsCsvArgs = {
  input: DownloadLineItemTypeAsCsvInput;
};


export type MutationCrudDownloadLocationAsCsvArgs = {
  input: DownloadLocationAsCsvInput;
};


export type MutationCrudDownloadLocationWithAirportAndAliasAsCsvArgs = {
  input: DownloadLocationWithAirportAndAliasAsCsvInput;
};


export type MutationCrudDownloadLocationWithPunchPolicyAsCsvArgs = {
  input: DownloadLocationWithPunchPolicyAsCsvInput;
};


export type MutationCrudDownloadLoginEventAsCsvArgs = {
  input: DownloadLoginEventAsCsvInput;
};


export type MutationCrudDownloadLostAndFoundIssueAsCsvArgs = {
  input: DownloadLostAndFoundIssueAsCsvInput;
};


export type MutationCrudDownloadLostAndFoundIssueDocumentAsCsvArgs = {
  input: DownloadLostAndFoundIssueDocumentAsCsvInput;
};


export type MutationCrudDownloadLostAndFoundIssueWithCacheAsCsvArgs = {
  input: DownloadLostAndFoundIssueWithCacheAsCsvInput;
};


export type MutationCrudDownloadManifestHistoryAsCsvArgs = {
  input: DownloadManifestHistoryAsCsvInput;
};


export type MutationCrudDownloadManifestHistoryRouteAsCsvArgs = {
  input: DownloadManifestHistoryRouteAsCsvInput;
};


export type MutationCrudDownloadManifestHistoryWithRouteAsCsvArgs = {
  input: DownloadManifestHistoryWithRouteAsCsvInput;
};


export type MutationCrudDownloadManifestProviderCacheAsCsvArgs = {
  input: DownloadManifestProviderCacheAsCsvInput;
};


export type MutationCrudDownloadManifestUserCacheAsCsvArgs = {
  input: DownloadManifestUserCacheAsCsvInput;
};


export type MutationCrudDownloadMessageAsCsvArgs = {
  input: DownloadMessageAsCsvInput;
};


export type MutationCrudDownloadNotificationAsCsvArgs = {
  input: DownloadNotificationAsCsvInput;
};


export type MutationCrudDownloadNotificationHasEventAsCsvArgs = {
  input: DownloadNotificationHasEventAsCsvInput;
};


export type MutationCrudDownloadParsedTripAsCsvArgs = {
  input: DownloadParsedTripAsCsvInput;
};


export type MutationCrudDownloadPermissionAsCsvArgs = {
  input: DownloadPermissionAsCsvInput;
};


export type MutationCrudDownloadPermissionHasRoleAsCsvArgs = {
  input: DownloadPermissionHasRoleAsCsvInput;
};


export type MutationCrudDownloadPermissionHasRoleWithPermissionsAsCsvArgs = {
  input: DownloadPermissionHasRoleWithPermissionsAsCsvInput;
};


export type MutationCrudDownloadPermissionHasUserAsCsvArgs = {
  input: DownloadPermissionHasUserAsCsvInput;
};


export type MutationCrudDownloadPermissionHasUserWithPermissionsAsCsvArgs = {
  input: DownloadPermissionHasUserWithPermissionsAsCsvInput;
};


export type MutationCrudDownloadPickupPointAsCsvArgs = {
  input: DownloadPickupPointAsCsvInput;
};


export type MutationCrudDownloadPotentialTripAsCsvArgs = {
  input: DownloadPotentialTripAsCsvInput;
};


export type MutationCrudDownloadProviderAliasAsCsvArgs = {
  input: DownloadProviderAliasAsCsvInput;
};


export type MutationCrudDownloadProviderAsCsvArgs = {
  input: DownloadProviderAsCsvInput;
};


export type MutationCrudDownloadProviderCacheAsCsvArgs = {
  input: DownloadProviderCacheAsCsvInput;
};


export type MutationCrudDownloadProviderLocationMappingAsCsvArgs = {
  input: DownloadProviderLocationMappingAsCsvInput;
};


export type MutationCrudDownloadProviderWithAliasAsCsvArgs = {
  input: DownloadProviderWithAliasAsCsvInput;
};


export type MutationCrudDownloadProviderWithContractAsCsvArgs = {
  input: DownloadProviderWithContractAsCsvInput;
};


export type MutationCrudDownloadProviderWithUpdateStrategyAsCsvArgs = {
  input: DownloadProviderWithUpdateStrategyAsCsvInput;
};


export type MutationCrudDownloadPunchAsCsvArgs = {
  input: DownloadPunchAsCsvInput;
};


export type MutationCrudDownloadPunchHistoryAsCsvArgs = {
  input: DownloadPunchHistoryAsCsvInput;
};


export type MutationCrudDownloadPunchPolicyAsCsvArgs = {
  input: DownloadPunchPolicyAsCsvInput;
};


export type MutationCrudDownloadQueryHistoryAsCsvArgs = {
  input: DownloadQueryHistoryAsCsvInput;
};


export type MutationCrudDownloadQuestionnaireAnswerOptionAsCsvArgs = {
  input: DownloadQuestionnaireAnswerOptionAsCsvInput;
};


export type MutationCrudDownloadQuestionnaireAnswerTypeAsCsvArgs = {
  input: DownloadQuestionnaireAnswerTypeAsCsvInput;
};


export type MutationCrudDownloadQuestionnaireAttemptAnswerOptionSnapshotAsCsvArgs = {
  input: DownloadQuestionnaireAttemptAnswerOptionSnapshotAsCsvInput;
};


export type MutationCrudDownloadQuestionnaireAttemptAsCsvArgs = {
  input: DownloadQuestionnaireAttemptAsCsvInput;
};


export type MutationCrudDownloadQuestionnaireAttemptCategorySnapshotAllowedGroupAsCsvArgs = {
  input: DownloadQuestionnaireAttemptCategorySnapshotAllowedGroupAsCsvInput;
};


export type MutationCrudDownloadQuestionnaireAttemptCategorySnapshotAsCsvArgs = {
  input: DownloadQuestionnaireAttemptCategorySnapshotAsCsvInput;
};


export type MutationCrudDownloadQuestionnaireAttemptCategorySnapshotGroupAsCsvArgs = {
  input: DownloadQuestionnaireAttemptCategorySnapshotGroupAsCsvInput;
};


export type MutationCrudDownloadQuestionnaireAttemptNoteAsCsvArgs = {
  input: DownloadQuestionnaireAttemptNoteAsCsvInput;
};


export type MutationCrudDownloadQuestionnaireAttemptQuestionSnapshotAsCsvArgs = {
  input: DownloadQuestionnaireAttemptQuestionSnapshotAsCsvInput;
};


export type MutationCrudDownloadQuestionnaireCategoryAsCsvArgs = {
  input: DownloadQuestionnaireCategoryAsCsvInput;
};


export type MutationCrudDownloadQuestionnaireQuestionAsCsvArgs = {
  input: DownloadQuestionnaireQuestionAsCsvInput;
};


export type MutationCrudDownloadRateAsCsvArgs = {
  input: DownloadRateAsCsvInput;
};


export type MutationCrudDownloadRateGroupAsCsvArgs = {
  input: DownloadRateGroupAsCsvInput;
};


export type MutationCrudDownloadRateGroupWithLatestRateHistoryAsCsvArgs = {
  input: DownloadRateGroupWithLatestRateHistoryAsCsvInput;
};


export type MutationCrudDownloadRateHistoryAsCsvArgs = {
  input: DownloadRateHistoryAsCsvInput;
};


export type MutationCrudDownloadRateHistoryWithRateGroupAsCsvArgs = {
  input: DownloadRateHistoryWithRateGroupAsCsvInput;
};


export type MutationCrudDownloadRateItemAsCsvArgs = {
  input: DownloadRateItemAsCsvInput;
};


export type MutationCrudDownloadRateItemWithLatestRateHistoryAsCsvArgs = {
  input: DownloadRateItemWithLatestRateHistoryAsCsvInput;
};


export type MutationCrudDownloadRatingAsCsvArgs = {
  input: DownloadRatingAsCsvInput;
};


export type MutationCrudDownloadRatingCacheAsCsvArgs = {
  input: DownloadRatingCacheAsCsvInput;
};


export type MutationCrudDownloadRatingCacheRemarkAsCsvArgs = {
  input: DownloadRatingCacheRemarkAsCsvInput;
};


export type MutationCrudDownloadRatingRemarkAsCsvArgs = {
  input: DownloadRatingRemarkAsCsvInput;
};


export type MutationCrudDownloadRatingRemarksWithRatingAsCsvArgs = {
  input: DownloadRatingRemarksWithRatingAsCsvInput;
};


export type MutationCrudDownloadRatingTypeAsCsvArgs = {
  input: DownloadRatingTypeAsCsvInput;
};


export type MutationCrudDownloadRatingWithRemarksAsCsvArgs = {
  input: DownloadRatingWithRemarksAsCsvInput;
};


export type MutationCrudDownloadRoleAsCsvArgs = {
  input: DownloadRoleAsCsvInput;
};


export type MutationCrudDownloadSettingsAsCsvArgs = {
  input: DownloadSettingsAsCsvInput;
};


export type MutationCrudDownloadSocialDistanceRuleAsCsvArgs = {
  input: DownloadSocialDistanceRuleAsCsvInput;
};


export type MutationCrudDownloadStagedTripAsCsvArgs = {
  input: DownloadStagedTripAsCsvInput;
};


export type MutationCrudDownloadStopAsCsvArgs = {
  input: DownloadStopAsCsvInput;
};


export type MutationCrudDownloadStorageAsCsvArgs = {
  input: DownloadStorageAsCsvInput;
};


export type MutationCrudDownloadTimeFrameAsCsvArgs = {
  input: DownloadTimeFrameAsCsvInput;
};


export type MutationCrudDownloadTimeFrameRangeAsCsvArgs = {
  input: DownloadTimeFrameRangeAsCsvInput;
};


export type MutationCrudDownloadTrackFlightAsCsvArgs = {
  input: DownloadTrackFlightAsCsvInput;
};


export type MutationCrudDownloadTrainingUserCacheAsCsvArgs = {
  input: DownloadTrainingUserCacheAsCsvInput;
};


export type MutationCrudDownloadTripAsCsvArgs = {
  input: DownloadTripAsCsvInput;
};


export type MutationCrudDownloadTripDocumentAsCsvArgs = {
  input: DownloadTripDocumentAsCsvInput;
};


export type MutationCrudDownloadTripDocumentWithCacheAsCsvArgs = {
  input: DownloadTripDocumentWithCacheAsCsvInput;
};


export type MutationCrudDownloadTripHasImportAsCsvArgs = {
  input: DownloadTripHasImportAsCsvInput;
};


export type MutationCrudDownloadTripScheduleTriggerAsCsvArgs = {
  input: DownloadTripScheduleTriggerAsCsvInput;
};


export type MutationCrudDownloadTripWithCompletionAndRateAsCsvArgs = {
  input: DownloadTripWithCompletionAndRateAsCsvInput;
};


export type MutationCrudDownloadTripWithCompletionAsCsvArgs = {
  input: DownloadTripWithCompletionAsCsvInput;
};


export type MutationCrudDownloadTripWithFcrInnerJoinAsCsvArgs = {
  input: DownloadTripWithFcrInnerJoinAsCsvInput;
};


export type MutationCrudDownloadTripWithFlagInnerJoinAsCsvArgs = {
  input: DownloadTripWithFlagInnerJoinAsCsvInput;
};


export type MutationCrudDownloadTripWithRateAsCsvArgs = {
  input: DownloadTripWithRateAsCsvInput;
};


export type MutationCrudDownloadTripWithRateForAuditReportAsCsvArgs = {
  input: DownloadTripWithRateForAuditReportAsCsvInput;
};


export type MutationCrudDownloadTripWithTrackFlightAsCsvArgs = {
  input: DownloadTripWithTrackFlightAsCsvInput;
};


export type MutationCrudDownloadTripWithUtcAsCsvArgs = {
  input: DownloadTripWithUtcAsCsvInput;
};


export type MutationCrudDownloadUniqueTripAsCsvArgs = {
  input: DownloadUniqueTripAsCsvInput;
};


export type MutationCrudDownloadUpdateStrategyAsCsvArgs = {
  input: DownloadUpdateStrategyAsCsvInput;
};


export type MutationCrudDownloadUserAsCsvArgs = {
  input: DownloadUserAsCsvInput;
};


export type MutationCrudDownloadUserAvailabilityAsCsvArgs = {
  input: DownloadUserAvailabilityAsCsvInput;
};


export type MutationCrudDownloadUserAvailabilityWithDatetimesAsCsvArgs = {
  input: DownloadUserAvailabilityWithDatetimesAsCsvInput;
};


export type MutationCrudDownloadUserCacheAsCsvArgs = {
  input: DownloadUserCacheAsCsvInput;
};


export type MutationCrudDownloadUserHasAirportAsCsvArgs = {
  input: DownloadUserHasAirportAsCsvInput;
};


export type MutationCrudDownloadUserWithAvailabilityAndPermissionsAsCsvArgs = {
  input: DownloadUserWithAvailabilityAndPermissionsAsCsvInput;
};


export type MutationCrudDownloadUserWithMarketAsCsvArgs = {
  input: DownloadUserWithMarketAsCsvInput;
};


export type MutationCrudDownloadUserWithPermissionsAsCsvArgs = {
  input: DownloadUserWithPermissionsAsCsvInput;
};


export type MutationCrudDownloadVariableTimeAsCsvArgs = {
  input: DownloadVariableTimeAsCsvInput;
};


export type MutationCrudDownloadVehicleAsCsvArgs = {
  input: DownloadVehicleAsCsvInput;
};


export type MutationCrudDownloadWidgetAsCsvArgs = {
  input: DownloadWidgetAsCsvInput;
};


export type MutationCrudDownloadWidgetFilterAsCsvArgs = {
  input: DownloadWidgetFilterAsCsvInput;
};


export type MutationCrudUpdateAccidentIssueBulkArgs = {
  input: UpdateAccidentIssueBulkInput;
};


export type MutationCrudUpdateAccidentIssueDocumentBulkArgs = {
  input: UpdateAccidentIssueDocumentBulkInput;
};


export type MutationCrudUpdateActivityBulkArgs = {
  input: UpdateActivityBulkInput;
};


export type MutationCrudUpdateActivityObjectBulkArgs = {
  input: UpdateActivityObjectBulkInput;
};


export type MutationCrudUpdateAirportBulkArgs = {
  input: UpdateAirportBulkInput;
};


export type MutationCrudUpdateAirportGroupBulkArgs = {
  input: UpdateAirportGroupBulkInput;
};


export type MutationCrudUpdateAirportHasCompanyBulkArgs = {
  input: UpdateAirportHasCompanyBulkInput;
};


export type MutationCrudUpdateAirportHasGroupBulkArgs = {
  input: UpdateAirportHasGroupBulkInput;
};


export type MutationCrudUpdateAirportHasLocationBulkArgs = {
  input: UpdateAirportHasLocationBulkInput;
};


export type MutationCrudUpdateAirportHasManagerEmailBulkArgs = {
  input: UpdateAirportHasManagerEmailBulkInput;
};


export type MutationCrudUpdateAirportHasRateBulkArgs = {
  input: UpdateAirportHasRateBulkInput;
};


export type MutationCrudUpdateAirportHasVehicleBulkArgs = {
  input: UpdateAirportHasVehicleBulkInput;
};


export type MutationCrudUpdateAlertSubscriptionBulkArgs = {
  input: UpdateAlertSubscriptionBulkInput;
};


export type MutationCrudUpdateAliasBulkArgs = {
  input: UpdateAliasBulkInput;
};


export type MutationCrudUpdateApiKeyBulkArgs = {
  input: UpdateApiKeyBulkInput;
};


export type MutationCrudUpdateAuditSnapshotBulkArgs = {
  input: UpdateAuditSnapshotBulkInput;
};


export type MutationCrudUpdateAutoCombineRuleBulkArgs = {
  input: UpdateAutoCombineRuleBulkInput;
};


export type MutationCrudUpdateAutomationHistoryAirportBulkArgs = {
  input: UpdateAutomationHistoryAirportBulkInput;
};


export type MutationCrudUpdateAutomationHistoryBulkArgs = {
  input: UpdateAutomationHistoryBulkInput;
};


export type MutationCrudUpdateAutomationHistoryLogBulkArgs = {
  input: UpdateAutomationHistoryLogBulkInput;
};


export type MutationCrudUpdateAutomationReportBulkArgs = {
  input: UpdateAutomationReportBulkInput;
};


export type MutationCrudUpdateAutomationTripAssignmentReasonBulkArgs = {
  input: UpdateAutomationTripAssignmentReasonBulkInput;
};


export type MutationCrudUpdateAutomationTripBulkArgs = {
  input: UpdateAutomationTripBulkInput;
};


export type MutationCrudUpdateAutomationTripLogBulkArgs = {
  input: UpdateAutomationTripLogBulkInput;
};


export type MutationCrudUpdateBufferTimeBulkArgs = {
  input: UpdateBufferTimeBulkInput;
};


export type MutationCrudUpdateCancellationRuleBulkArgs = {
  input: UpdateCancellationRuleBulkInput;
};


export type MutationCrudUpdateCharityAmountHistoryBulkArgs = {
  input: UpdateCharityAmountHistoryBulkInput;
};


export type MutationCrudUpdateCharityBulkArgs = {
  input: UpdateCharityBulkInput;
};


export type MutationCrudUpdateCharityRatingHistoryBulkArgs = {
  input: UpdateCharityRatingHistoryBulkInput;
};


export type MutationCrudUpdateCharityRatingHistoryReportBulkArgs = {
  input: UpdateCharityRatingHistoryReportBulkInput;
};


export type MutationCrudUpdateChatQuickReplyMessageBulkArgs = {
  input: UpdateChatQuickReplyMessageBulkInput;
};


export type MutationCrudUpdateCheckinEventBulkArgs = {
  input: UpdateCheckinEventBulkInput;
};


export type MutationCrudUpdateCombineRuleBulkArgs = {
  input: UpdateCombineRuleBulkInput;
};


export type MutationCrudUpdateCombineRuleHistoryBulkArgs = {
  input: UpdateCombineRuleHistoryBulkInput;
};


export type MutationCrudUpdateCommunicationBulkArgs = {
  input: UpdateCommunicationBulkInput;
};


export type MutationCrudUpdateCompanyBulkArgs = {
  input: UpdateCompanyBulkInput;
};


export type MutationCrudUpdateCompletionBulkArgs = {
  input: UpdateCompletionBulkInput;
};


export type MutationCrudUpdateCompletionTypeBulkArgs = {
  input: UpdateCompletionTypeBulkInput;
};


export type MutationCrudUpdateContractBulkArgs = {
  input: UpdateContractBulkInput;
};


export type MutationCrudUpdateContractEmailBulkArgs = {
  input: UpdateContractEmailBulkInput;
};


export type MutationCrudUpdateContractNumberBulkArgs = {
  input: UpdateContractNumberBulkInput;
};


export type MutationCrudUpdateCountryRegionBulkArgs = {
  input: UpdateCountryRegionBulkInput;
};


export type MutationCrudUpdateCrewCountRequirementBulkArgs = {
  input: UpdateCrewCountRequirementBulkInput;
};


export type MutationCrudUpdateDashboardBulkArgs = {
  input: UpdateDashboardBulkInput;
};


export type MutationCrudUpdateDefectBulkArgs = {
  input: UpdateDefectBulkInput;
};


export type MutationCrudUpdateDeviceBulkArgs = {
  input: UpdateDeviceBulkInput;
};


export type MutationCrudUpdateDeviceMetricBulkArgs = {
  input: UpdateDeviceMetricBulkInput;
};


export type MutationCrudUpdateDispatchIssueBulkArgs = {
  input: UpdateDispatchIssueBulkInput;
};


export type MutationCrudUpdateDispatchIssueCausedByBulkArgs = {
  input: UpdateDispatchIssueCausedByBulkInput;
};


export type MutationCrudUpdateDispatchIssueDocumentBulkArgs = {
  input: UpdateDispatchIssueDocumentBulkInput;
};


export type MutationCrudUpdateDispatchSummaryBulkArgs = {
  input: UpdateDispatchSummaryBulkInput;
};


export type MutationCrudUpdateDispatchSummaryDocumentBulkArgs = {
  input: UpdateDispatchSummaryDocumentBulkInput;
};


export type MutationCrudUpdateDispatchSummaryMarketBulkArgs = {
  input: UpdateDispatchSummaryMarketBulkInput;
};


export type MutationCrudUpdateDistanceBulkArgs = {
  input: UpdateDistanceBulkInput;
};


export type MutationCrudUpdateDriverEtaBulkArgs = {
  input: UpdateDriverEtaBulkInput;
};


export type MutationCrudUpdateDriverVehicleAssignmentBulkArgs = {
  input: UpdateDriverVehicleAssignmentBulkInput;
};


export type MutationCrudUpdateDtrLocationBulkArgs = {
  input: UpdateDtrLocationBulkInput;
};


export type MutationCrudUpdateDvirBulkArgs = {
  input: UpdateDvirBulkInput;
};


export type MutationCrudUpdateDvirSignatureBulkArgs = {
  input: UpdateDvirSignatureBulkInput;
};


export type MutationCrudUpdateEmailBulkArgs = {
  input: UpdateEmailBulkInput;
};


export type MutationCrudUpdateEquivalentTripBulkArgs = {
  input: UpdateEquivalentTripBulkInput;
};


export type MutationCrudUpdateEventBulkArgs = {
  input: UpdateEventBulkInput;
};


export type MutationCrudUpdateFcrBulkArgs = {
  input: UpdateFcrBulkInput;
};


export type MutationCrudUpdateFcrTypeBulkArgs = {
  input: UpdateFcrTypeBulkInput;
};


export type MutationCrudUpdateFlagBulkArgs = {
  input: UpdateFlagBulkInput;
};


export type MutationCrudUpdateFlagHasPotentialTripBulkArgs = {
  input: UpdateFlagHasPotentialTripBulkInput;
};


export type MutationCrudUpdateFlagHasStagedTripBulkArgs = {
  input: UpdateFlagHasStagedTripBulkInput;
};


export type MutationCrudUpdateFlagHasTripBulkArgs = {
  input: UpdateFlagHasTripBulkInput;
};


export type MutationCrudUpdateFlightHistoryBulkArgs = {
  input: UpdateFlightHistoryBulkInput;
};


export type MutationCrudUpdateGeneratedDocumentBulkArgs = {
  input: UpdateGeneratedDocumentBulkInput;
};


export type MutationCrudUpdateGeneratedDocumentLogBulkArgs = {
  input: UpdateGeneratedDocumentLogBulkInput;
};


export type MutationCrudUpdateGroupBulkArgs = {
  input: UpdateGroupBulkInput;
};


export type MutationCrudUpdateGroupHasPermissionBulkArgs = {
  input: UpdateGroupHasPermissionBulkInput;
};


export type MutationCrudUpdateGroupHasUserBulkArgs = {
  input: UpdateGroupHasUserBulkInput;
};


export type MutationCrudUpdateImageBulkArgs = {
  input: UpdateImageBulkInput;
};


export type MutationCrudUpdateImportBulkArgs = {
  input: UpdateImportBulkInput;
};


export type MutationCrudUpdateImportEmailBulkArgs = {
  input: UpdateImportEmailBulkInput;
};


export type MutationCrudUpdateImportFailureBulkArgs = {
  input: UpdateImportFailureBulkInput;
};


export type MutationCrudUpdateImportLogBulkArgs = {
  input: UpdateImportLogBulkInput;
};


export type MutationCrudUpdateImportOcrCacheBulkArgs = {
  input: UpdateImportOcrCacheBulkInput;
};


export type MutationCrudUpdateIncidentIssueBulkArgs = {
  input: UpdateIncidentIssueBulkInput;
};


export type MutationCrudUpdateIncidentIssueDocumentBulkArgs = {
  input: UpdateIncidentIssueDocumentBulkInput;
};


export type MutationCrudUpdateIndexBulkArgs = {
  input: UpdateIndexBulkInput;
};


export type MutationCrudUpdateInvoiceAirportBulkArgs = {
  input: UpdateInvoiceAirportBulkInput;
};


export type MutationCrudUpdateInvoiceBulkArgs = {
  input: UpdateInvoiceBulkInput;
};


export type MutationCrudUpdateInvoiceClientBulkArgs = {
  input: UpdateInvoiceClientBulkInput;
};


export type MutationCrudUpdateInvoiceCustomChargeBulkArgs = {
  input: UpdateInvoiceCustomChargeBulkInput;
};


export type MutationCrudUpdateInvoiceDocumentBulkArgs = {
  input: UpdateInvoiceDocumentBulkInput;
};


export type MutationCrudUpdateInvoiceEmailBulkArgs = {
  input: UpdateInvoiceEmailBulkInput;
};


export type MutationCrudUpdateInvoiceHeaderBulkArgs = {
  input: UpdateInvoiceHeaderBulkInput;
};


export type MutationCrudUpdateInvoiceIataCodeBulkArgs = {
  input: UpdateInvoiceIataCodeBulkInput;
};


export type MutationCrudUpdateInvoiceLineItemBulkArgs = {
  input: UpdateInvoiceLineItemBulkInput;
};


export type MutationCrudUpdateInvoiceProviderCacheBulkArgs = {
  input: UpdateInvoiceProviderCacheBulkInput;
};


export type MutationCrudUpdateInvoiceTermBulkArgs = {
  input: UpdateInvoiceTermBulkInput;
};


export type MutationCrudUpdateInvoiceTotalSummaryBulkArgs = {
  input: UpdateInvoiceTotalSummaryBulkInput;
};


export type MutationCrudUpdateInvoiceTripBulkArgs = {
  input: UpdateInvoiceTripBulkInput;
};


export type MutationCrudUpdateInvoiceTripStatusBulkArgs = {
  input: UpdateInvoiceTripStatusBulkInput;
};


export type MutationCrudUpdateInvoiceTypeBulkArgs = {
  input: UpdateInvoiceTypeBulkInput;
};


export type MutationCrudUpdateInvoiceUserCacheBulkArgs = {
  input: UpdateInvoiceUserCacheBulkInput;
};


export type MutationCrudUpdateIssueBulkArgs = {
  input: UpdateIssueBulkInput;
};


export type MutationCrudUpdateLicenseBulkArgs = {
  input: UpdateLicenseBulkInput;
};


export type MutationCrudUpdateLicenseTypeBulkArgs = {
  input: UpdateLicenseTypeBulkInput;
};


export type MutationCrudUpdateLineItemTypeBulkArgs = {
  input: UpdateLineItemTypeBulkInput;
};


export type MutationCrudUpdateLocationBulkArgs = {
  input: UpdateLocationBulkInput;
};


export type MutationCrudUpdateLoginEventBulkArgs = {
  input: UpdateLoginEventBulkInput;
};


export type MutationCrudUpdateLostAndFoundIssueBulkArgs = {
  input: UpdateLostAndFoundIssueBulkInput;
};


export type MutationCrudUpdateLostAndFoundIssueDocumentBulkArgs = {
  input: UpdateLostAndFoundIssueDocumentBulkInput;
};


export type MutationCrudUpdateManifestHistoryBulkArgs = {
  input: UpdateManifestHistoryBulkInput;
};


export type MutationCrudUpdateManifestHistoryRouteBulkArgs = {
  input: UpdateManifestHistoryRouteBulkInput;
};


export type MutationCrudUpdateManifestProviderCacheBulkArgs = {
  input: UpdateManifestProviderCacheBulkInput;
};


export type MutationCrudUpdateManifestUserCacheBulkArgs = {
  input: UpdateManifestUserCacheBulkInput;
};


export type MutationCrudUpdateMessageBulkArgs = {
  input: UpdateMessageBulkInput;
};


export type MutationCrudUpdateNotificationBulkArgs = {
  input: UpdateNotificationBulkInput;
};


export type MutationCrudUpdateNotificationHasEventBulkArgs = {
  input: UpdateNotificationHasEventBulkInput;
};


export type MutationCrudUpdateParsedTripBulkArgs = {
  input: UpdateParsedTripBulkInput;
};


export type MutationCrudUpdatePermissionBulkArgs = {
  input: UpdatePermissionBulkInput;
};


export type MutationCrudUpdatePermissionHasRoleBulkArgs = {
  input: UpdatePermissionHasRoleBulkInput;
};


export type MutationCrudUpdatePermissionHasUserBulkArgs = {
  input: UpdatePermissionHasUserBulkInput;
};


export type MutationCrudUpdatePickupPointBulkArgs = {
  input: UpdatePickupPointBulkInput;
};


export type MutationCrudUpdatePotentialTripBulkArgs = {
  input: UpdatePotentialTripBulkInput;
};


export type MutationCrudUpdateProviderAliasBulkArgs = {
  input: UpdateProviderAliasBulkInput;
};


export type MutationCrudUpdateProviderBulkArgs = {
  input: UpdateProviderBulkInput;
};


export type MutationCrudUpdateProviderCacheBulkArgs = {
  input: UpdateProviderCacheBulkInput;
};


export type MutationCrudUpdateProviderLocationMappingBulkArgs = {
  input: UpdateProviderLocationMappingBulkInput;
};


export type MutationCrudUpdatePunchBulkArgs = {
  input: UpdatePunchBulkInput;
};


export type MutationCrudUpdatePunchHistoryBulkArgs = {
  input: UpdatePunchHistoryBulkInput;
};


export type MutationCrudUpdatePunchPolicyBulkArgs = {
  input: UpdatePunchPolicyBulkInput;
};


export type MutationCrudUpdateQueryHistoryBulkArgs = {
  input: UpdateQueryHistoryBulkInput;
};


export type MutationCrudUpdateQuestionnaireAnswerOptionBulkArgs = {
  input: UpdateQuestionnaireAnswerOptionBulkInput;
};


export type MutationCrudUpdateQuestionnaireAnswerTypeBulkArgs = {
  input: UpdateQuestionnaireAnswerTypeBulkInput;
};


export type MutationCrudUpdateQuestionnaireAttemptAnswerOptionSnapshotBulkArgs = {
  input: UpdateQuestionnaireAttemptAnswerOptionSnapshotBulkInput;
};


export type MutationCrudUpdateQuestionnaireAttemptBulkArgs = {
  input: UpdateQuestionnaireAttemptBulkInput;
};


export type MutationCrudUpdateQuestionnaireAttemptCategorySnapshotAllowedGroupBulkArgs = {
  input: UpdateQuestionnaireAttemptCategorySnapshotAllowedGroupBulkInput;
};


export type MutationCrudUpdateQuestionnaireAttemptCategorySnapshotBulkArgs = {
  input: UpdateQuestionnaireAttemptCategorySnapshotBulkInput;
};


export type MutationCrudUpdateQuestionnaireAttemptCategorySnapshotGroupBulkArgs = {
  input: UpdateQuestionnaireAttemptCategorySnapshotGroupBulkInput;
};


export type MutationCrudUpdateQuestionnaireAttemptNoteBulkArgs = {
  input: UpdateQuestionnaireAttemptNoteBulkInput;
};


export type MutationCrudUpdateQuestionnaireAttemptQuestionSnapshotBulkArgs = {
  input: UpdateQuestionnaireAttemptQuestionSnapshotBulkInput;
};


export type MutationCrudUpdateQuestionnaireCategoryBulkArgs = {
  input: UpdateQuestionnaireCategoryBulkInput;
};


export type MutationCrudUpdateQuestionnaireQuestionBulkArgs = {
  input: UpdateQuestionnaireQuestionBulkInput;
};


export type MutationCrudUpdateRateBulkArgs = {
  input: UpdateRateBulkInput;
};


export type MutationCrudUpdateRateGroupBulkArgs = {
  input: UpdateRateGroupBulkInput;
};


export type MutationCrudUpdateRateHistoryBulkArgs = {
  input: UpdateRateHistoryBulkInput;
};


export type MutationCrudUpdateRateItemBulkArgs = {
  input: UpdateRateItemBulkInput;
};


export type MutationCrudUpdateRatingBulkArgs = {
  input: UpdateRatingBulkInput;
};


export type MutationCrudUpdateRatingCacheBulkArgs = {
  input: UpdateRatingCacheBulkInput;
};


export type MutationCrudUpdateRatingCacheRemarkBulkArgs = {
  input: UpdateRatingCacheRemarkBulkInput;
};


export type MutationCrudUpdateRatingRemarkBulkArgs = {
  input: UpdateRatingRemarkBulkInput;
};


export type MutationCrudUpdateRatingTypeBulkArgs = {
  input: UpdateRatingTypeBulkInput;
};


export type MutationCrudUpdateRoleBulkArgs = {
  input: UpdateRoleBulkInput;
};


export type MutationCrudUpdateSettingsBulkArgs = {
  input: UpdateSettingsBulkInput;
};


export type MutationCrudUpdateSocialDistanceRuleBulkArgs = {
  input: UpdateSocialDistanceRuleBulkInput;
};


export type MutationCrudUpdateStagedTripBulkArgs = {
  input: UpdateStagedTripBulkInput;
};


export type MutationCrudUpdateStopBulkArgs = {
  input: UpdateStopBulkInput;
};


export type MutationCrudUpdateStorageBulkArgs = {
  input: UpdateStorageBulkInput;
};


export type MutationCrudUpdateTimeFrameBulkArgs = {
  input: UpdateTimeFrameBulkInput;
};


export type MutationCrudUpdateTimeFrameRangeBulkArgs = {
  input: UpdateTimeFrameRangeBulkInput;
};


export type MutationCrudUpdateTrackFlightBulkArgs = {
  input: UpdateTrackFlightBulkInput;
};


export type MutationCrudUpdateTrainingUserCacheBulkArgs = {
  input: UpdateTrainingUserCacheBulkInput;
};


export type MutationCrudUpdateTripBulkArgs = {
  input: UpdateTripBulkInput;
};


export type MutationCrudUpdateTripDocumentBulkArgs = {
  input: UpdateTripDocumentBulkInput;
};


export type MutationCrudUpdateTripHasImportBulkArgs = {
  input: UpdateTripHasImportBulkInput;
};


export type MutationCrudUpdateTripScheduleTriggerBulkArgs = {
  input: UpdateTripScheduleTriggerBulkInput;
};


export type MutationCrudUpdateUpdateStrategyBulkArgs = {
  input: UpdateUpdateStrategyBulkInput;
};


export type MutationCrudUpdateUserAvailabilityBulkArgs = {
  input: UpdateUserAvailabilityBulkInput;
};


export type MutationCrudUpdateUserBulkArgs = {
  input: UpdateUserBulkInput;
};


export type MutationCrudUpdateUserCacheBulkArgs = {
  input: UpdateUserCacheBulkInput;
};


export type MutationCrudUpdateUserHasAirportBulkArgs = {
  input: UpdateUserHasAirportBulkInput;
};


export type MutationCrudUpdateVariableTimeBulkArgs = {
  input: UpdateVariableTimeBulkInput;
};


export type MutationCrudUpdateVehicleBulkArgs = {
  input: UpdateVehicleBulkInput;
};


export type MutationCrudUpdateWidgetBulkArgs = {
  input: UpdateWidgetBulkInput;
};


export type MutationCrudUpdateWidgetFilterBulkArgs = {
  input: UpdateWidgetFilterBulkInput;
};

export type Node = {
  id: Scalars['ID']['output'];
};

export type Notification = {
  __typename?: 'Notification';
  active: Scalars['Int']['output'];
  allProvider: Scalars['Int']['output'];
  allVendors: Scalars['Int']['output'];
  company: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  method: NotificationMethodEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vendor: Scalars['String']['output'];
};

export type NotificationActivityConnection = {
  __typename?: 'NotificationActivityConnection';
  edges?: Maybe<Array<Maybe<NotificationActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type NotificationActivityEdge = {
  __typename?: 'NotificationActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type NotificationConnection = {
  __typename?: 'NotificationConnection';
  edges?: Maybe<Array<Maybe<NotificationEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<NotificationMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<NotificationSearch>>;
};

export type NotificationEdge = {
  __typename?: 'NotificationEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Notification>;
};

export type NotificationHasEvent = {
  __typename?: 'NotificationHasEvent';
  eventId: Scalars['String']['output'];
  responseId: Scalars['String']['output'];
};

export type NotificationHasEventActivityConnection = {
  __typename?: 'NotificationHasEventActivityConnection';
  edges?: Maybe<Array<Maybe<NotificationHasEventActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationHasEventActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type NotificationHasEventActivityEdge = {
  __typename?: 'NotificationHasEventActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type NotificationHasEventConnection = {
  __typename?: 'NotificationHasEventConnection';
  edges?: Maybe<Array<Maybe<NotificationHasEventEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type NotificationHasEventConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<NotificationHasEventMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<NotificationHasEventSearch>>;
};

export type NotificationHasEventEdge = {
  __typename?: 'NotificationHasEventEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<NotificationHasEvent>;
};

export type NotificationHasEventMaskInput = {
  eventId?: InputMaybe<Scalars['Boolean']['input']>;
  responseId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type NotificationHasEventSearch = {
  eventId?: InputMaybe<Array<StringSearch>>;
  responseId?: InputMaybe<Array<StringSearch>>;
};

export type NotificationMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allProvider?: InputMaybe<Scalars['Boolean']['input']>;
  allVendors?: InputMaybe<Scalars['Boolean']['input']>;
  company?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vendor?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum NotificationMethodEnum {
  Notification = 'NOTIFICATION'
}

export type NotificationMethodEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<NotificationMethodEnum>;
};

export type NotificationSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  allProvider?: InputMaybe<Array<IntSearch>>;
  allVendors?: InputMaybe<Array<IntSearch>>;
  company?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  method?: InputMaybe<Array<NotificationMethodEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vendor?: InputMaybe<Array<StringSearch>>;
};

export type NotificationsNamespaceResponse = {
  __typename?: 'NotificationsNamespaceResponse';
  generalTopics?: Maybe<Array<Scalars['String']['output']>>;
  namespace: Scalars['String']['output'];
};

export type OnTimePerformanceReport = {
  __typename?: 'OnTimePerformanceReport';
  name: Scalars['String']['output'];
  ontimeOverall: Scalars['Int']['output'];
  percentEfficiency: Scalars['Int']['output'];
  percentGps: Scalars['Float']['output'];
  percentLate: Scalars['Int']['output'];
  percentPickup: Scalars['Float']['output'];
  percentReady: Scalars['Float']['output'];
  rating: Scalars['Float']['output'];
  rows?: Maybe<Array<OnTimePerformanceReportChild>>;
  totalDrivers: Scalars['Int']['output'];
  totalGps: Scalars['Int']['output'];
  totalPickups: Scalars['Int']['output'];
  totalReady: Scalars['Int']['output'];
  totalTrips: Scalars['Int']['output'];
};

export type OnTimePerformanceReportChild = {
  __typename?: 'OnTimePerformanceReportChild';
  children?: Maybe<Array<OnTimePerformanceReportChild>>;
  name: Scalars['String']['output'];
  ontimeOverall: Scalars['Int']['output'];
  percentEfficiency: Scalars['Int']['output'];
  percentGps: Scalars['Float']['output'];
  percentLate: Scalars['Int']['output'];
  percentPickup: Scalars['Float']['output'];
  percentReady: Scalars['Float']['output'];
  rating: Scalars['Float']['output'];
  totalGps: Scalars['Int']['output'];
  totalPickups: Scalars['Int']['output'];
  totalReady: Scalars['Int']['output'];
  totalTrips: Scalars['Int']['output'];
};

export enum OnTimePerformanceReportFormatEnum {
  Airport = 'AIRPORT',
  Group = 'GROUP'
}

export enum OnTimePerformanceReportGroupByListItem {
  GroupByCity = 'GROUP_BY_CITY',
  GroupByClient = 'GROUP_BY_CLIENT',
  GroupByDay = 'GROUP_BY_DAY',
  GroupByDriver = 'GROUP_BY_DRIVER',
  GroupByKind = 'GROUP_BY_KIND',
  GroupByMonth = 'GROUP_BY_MONTH',
  GroupByQuarter = 'GROUP_BY_QUARTER',
  GroupByWeek = 'GROUP_BY_WEEK',
  GroupByYear = 'GROUP_BY_YEAR'
}

export type OnTimePerformanceReportTables = {
  __typename?: 'OnTimePerformanceReportTables';
  tables?: Maybe<Array<OnTimePerformanceReport>>;
};

export type OverallPerformance = {
  __typename?: 'OverallPerformance';
  averageRating?: Maybe<Scalars['Float']['output']>;
  totalAmountOfBadReviews?: Maybe<Scalars['Float']['output']>;
  totalAmountOfReviews?: Maybe<Scalars['Float']['output']>;
  totalAmountOfTrips?: Maybe<Scalars['Float']['output']>;
  totalLateTrips?: Maybe<Scalars['Float']['output']>;
  totalRFP?: Maybe<Scalars['Float']['output']>;
  totalWORFP?: Maybe<Scalars['Float']['output']>;
};

export type OverrideImportInput = {
  bufferTimes?: InputMaybe<Array<BufferTimeInput>>;
  importId: Scalars['String']['input'];
  locationMapping?: InputMaybe<Array<LocationMappingInput>>;
  previousImportId?: InputMaybe<Scalars['String']['input']>;
  socialDistance: Scalars['Boolean']['input'];
  tolerance?: InputMaybe<Scalars['Int']['input']>;
};

export type OverrideLocation = {
  __typename?: 'OverrideLocation';
  bufferTimes: Array<BufferTime>;
  clientId: Scalars['String']['output'];
  clientIdDisplayName: Scalars['String']['output'];
  locationDisplayName: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
};

export type OverrideOptions = {
  __typename?: 'OverrideOptions';
  airportCodes: Array<Scalars['String']['output']>;
  allowOverrideLocationMapping: Scalars['Boolean']['output'];
  allowOverrideMissingLocations: Scalars['Boolean']['output'];
  allowOverrideSocialDistancing: Scalars['Boolean']['output'];
  allowOverrideTolerance: Scalars['Boolean']['output'];
  contractId: Scalars['String']['output'];
  elapsedDataChecking: Scalars['Boolean']['output'];
  filename: Scalars['String']['output'];
  importId: Scalars['String']['output'];
  importName: Scalars['String']['output'];
  inaccessibleMarkets?: Maybe<Array<Scalars['String']['output']>>;
  locationMapping: Array<OverrideLocation>;
  missingLocations: Array<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  socialDistancing: Scalars['Boolean']['output'];
  tolerance: Scalars['Int']['output'];
};

export type OverrideOptionsResponse = {
  __typename?: 'OverrideOptionsResponse';
  error?: Maybe<Scalars['String']['output']>;
  overrideOptions?: Maybe<OverrideOptions>;
};

export type PageInfo = {
  __typename?: 'PageInfo';
  endCursor: Scalars['String']['output'];
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
  startCursor: Scalars['String']['output'];
};

export type ParsedTrip = {
  __typename?: 'ParsedTrip';
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  doLocation: Scalars['String']['output'];
  doLocationId?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['Int']['output']>;
  fromManifest: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  importId: Scalars['String']['output'];
  importTime?: Maybe<Scalars['String']['output']>;
  kind: ParsedTripKindEnum;
  loopName?: Maybe<Scalars['String']['output']>;
  pilots: Scalars['Int']['output'];
  puLocation: Scalars['String']['output'];
  puLocationId?: Maybe<Scalars['String']['output']>;
  scheduled: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  tripId: Scalars['String']['output'];
  typeName?: Maybe<ParsedTripTypeNameEnum>;
};

export type ParsedTripActivityConnection = {
  __typename?: 'ParsedTripActivityConnection';
  edges?: Maybe<Array<Maybe<ParsedTripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ParsedTripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ParsedTripActivityEdge = {
  __typename?: 'ParsedTripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ParsedTripConnection = {
  __typename?: 'ParsedTripConnection';
  edges?: Maybe<Array<Maybe<ParsedTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ParsedTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ParsedTripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ParsedTripSearch>>;
};

export type ParsedTripEdge = {
  __typename?: 'ParsedTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ParsedTrip>;
};

export enum ParsedTripKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type ParsedTripKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ParsedTripKindEnum>;
};

export type ParsedTripMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  doLocation?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  fromManifest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importId?: InputMaybe<Scalars['Boolean']['input']>;
  importTime?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  puLocation?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  typeName?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ParsedTripSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  doLocation?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  fromManifest?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importId?: InputMaybe<Array<StringSearch>>;
  importTime?: InputMaybe<Array<StringSearch>>;
  kind?: InputMaybe<Array<ParsedTripKindEnumSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  puLocation?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  typeName?: InputMaybe<Array<ParsedTripTypeNameEnumSearch>>;
};

export enum ParsedTripTypeNameEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type ParsedTripTypeNameEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ParsedTripTypeNameEnum>;
};

export type PerformanceReport = {
  __typename?: 'PerformanceReport';
  dashboard?: Maybe<PerformanceReportDashboard>;
  error?: Maybe<Error>;
};

export type PerformanceReportDashboard = {
  __typename?: 'PerformanceReportDashboard';
  ontime?: Maybe<PerformanceReportOnTime>;
  ratings?: Maybe<PerformanceReportRatings>;
};

export type PerformanceReportInput = {
  airportCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  driverIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  reportFilters?: InputMaybe<Array<ReportFilterEnum>>;
  startDatetime?: InputMaybe<Scalars['String']['input']>;
};

export type PerformanceReportOnTime = {
  __typename?: 'PerformanceReportOnTime';
  inboundMaxOnTime?: Maybe<Scalars['Int']['output']>;
  inboundMaxTrips?: Maybe<Scalars['Int']['output']>;
  inboundOnTime?: Maybe<Scalars['Int']['output']>;
  inboundTrips?: Maybe<Scalars['Int']['output']>;
  outboundMaxOnTime?: Maybe<Scalars['Int']['output']>;
  outboundMaxTrips?: Maybe<Scalars['Int']['output']>;
  outboundOnTime?: Maybe<Scalars['Int']['output']>;
  outboundTrips?: Maybe<Scalars['Int']['output']>;
};

export type PerformanceReportRatings = {
  __typename?: 'PerformanceReportRatings';
  inboundAvgRating?: Maybe<Scalars['Float']['output']>;
  inboundMaxRating?: Maybe<Scalars['Float']['output']>;
  inboundRatings?: Maybe<Scalars['Int']['output']>;
  outboundAvgRating?: Maybe<Scalars['Float']['output']>;
  outboundMaxRating?: Maybe<Scalars['Float']['output']>;
  outboundRatings?: Maybe<Scalars['Int']['output']>;
};

export type Permission = {
  __typename?: 'Permission';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayGroup: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  effect: PermissionEffectEnum;
  entity: Scalars['String']['output'];
  id: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  verb: Scalars['String']['output'];
};

export type PermissionActivityConnection = {
  __typename?: 'PermissionActivityConnection';
  edges?: Maybe<Array<Maybe<PermissionActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type PermissionActivityEdge = {
  __typename?: 'PermissionActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type PermissionConnection = {
  __typename?: 'PermissionConnection';
  edges?: Maybe<Array<Maybe<PermissionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<PermissionMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<PermissionSearch>>;
};

export type PermissionEdge = {
  __typename?: 'PermissionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Permission>;
};

export enum PermissionEffectEnum {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export type PermissionEffectEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<PermissionEffectEnum>;
};

export type PermissionHasRole = {
  __typename?: 'PermissionHasRole';
  permissionId: Scalars['String']['output'];
  roleId: Scalars['String']['output'];
};

export type PermissionHasRoleActivityConnection = {
  __typename?: 'PermissionHasRoleActivityConnection';
  edges?: Maybe<Array<Maybe<PermissionHasRoleActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionHasRoleActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type PermissionHasRoleActivityEdge = {
  __typename?: 'PermissionHasRoleActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type PermissionHasRoleConnection = {
  __typename?: 'PermissionHasRoleConnection';
  edges?: Maybe<Array<Maybe<PermissionHasRoleEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionHasRoleConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<PermissionHasRoleMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<PermissionHasRoleSearch>>;
};

export type PermissionHasRoleEdge = {
  __typename?: 'PermissionHasRoleEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<PermissionHasRole>;
};

export type PermissionHasRoleMaskInput = {
  permissionId?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PermissionHasRoleSearch = {
  permissionId?: InputMaybe<Array<StringSearch>>;
  roleId?: InputMaybe<Array<StringSearch>>;
};

export type PermissionHasRoleWithPermissions = {
  __typename?: 'PermissionHasRoleWithPermissions';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayGroup: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  effect: PermissionHasRoleWithPermissionsEffectEnum;
  entity: Scalars['String']['output'];
  id: Scalars['String']['output'];
  permissionId: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  roleId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  verb: Scalars['String']['output'];
};

export type PermissionHasRoleWithPermissionsActivityConnection = {
  __typename?: 'PermissionHasRoleWithPermissionsActivityConnection';
  edges?: Maybe<Array<Maybe<PermissionHasRoleWithPermissionsActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionHasRoleWithPermissionsActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type PermissionHasRoleWithPermissionsActivityEdge = {
  __typename?: 'PermissionHasRoleWithPermissionsActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type PermissionHasRoleWithPermissionsConnection = {
  __typename?: 'PermissionHasRoleWithPermissionsConnection';
  edges?: Maybe<Array<Maybe<PermissionHasRoleWithPermissionsEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionHasRoleWithPermissionsConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<PermissionHasRoleWithPermissionsMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<PermissionHasRoleWithPermissionsSearch>>;
};

export type PermissionHasRoleWithPermissionsEdge = {
  __typename?: 'PermissionHasRoleWithPermissionsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<PermissionHasRoleWithPermissions>;
};

export enum PermissionHasRoleWithPermissionsEffectEnum {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export type PermissionHasRoleWithPermissionsEffectEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<PermissionHasRoleWithPermissionsEffectEnum>;
};

export type PermissionHasRoleWithPermissionsMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  displayGroup?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  effect?: InputMaybe<Scalars['Boolean']['input']>;
  entity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  permissionId?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  verb?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PermissionHasRoleWithPermissionsSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  displayGroup?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  effect?: InputMaybe<Array<PermissionHasRoleWithPermissionsEffectEnumSearch>>;
  entity?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  permissionId?: InputMaybe<Array<StringSearch>>;
  resource?: InputMaybe<Array<StringSearch>>;
  roleId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  verb?: InputMaybe<Array<StringSearch>>;
};

export type PermissionHasUser = {
  __typename?: 'PermissionHasUser';
  effect: PermissionHasUserEffectEnum;
  permissionId: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type PermissionHasUserActivityConnection = {
  __typename?: 'PermissionHasUserActivityConnection';
  edges?: Maybe<Array<Maybe<PermissionHasUserActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionHasUserActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type PermissionHasUserActivityEdge = {
  __typename?: 'PermissionHasUserActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type PermissionHasUserConnection = {
  __typename?: 'PermissionHasUserConnection';
  edges?: Maybe<Array<Maybe<PermissionHasUserEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionHasUserConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<PermissionHasUserMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<PermissionHasUserSearch>>;
};

export type PermissionHasUserEdge = {
  __typename?: 'PermissionHasUserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<PermissionHasUser>;
};

export enum PermissionHasUserEffectEnum {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export type PermissionHasUserEffectEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<PermissionHasUserEffectEnum>;
};

export type PermissionHasUserMaskInput = {
  effect?: InputMaybe<Scalars['Boolean']['input']>;
  permissionId?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PermissionHasUserSearch = {
  effect?: InputMaybe<Array<PermissionHasUserEffectEnumSearch>>;
  permissionId?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type PermissionHasUserWithPermissions = {
  __typename?: 'PermissionHasUserWithPermissions';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  displayGroup: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
  effect: PermissionHasUserWithPermissionsEffectEnum;
  entity: Scalars['String']['output'];
  id: Scalars['String']['output'];
  permissionId: Scalars['String']['output'];
  resource: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  verb: Scalars['String']['output'];
};

export type PermissionHasUserWithPermissionsActivityConnection = {
  __typename?: 'PermissionHasUserWithPermissionsActivityConnection';
  edges?: Maybe<Array<Maybe<PermissionHasUserWithPermissionsActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionHasUserWithPermissionsActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type PermissionHasUserWithPermissionsActivityEdge = {
  __typename?: 'PermissionHasUserWithPermissionsActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type PermissionHasUserWithPermissionsConnection = {
  __typename?: 'PermissionHasUserWithPermissionsConnection';
  edges?: Maybe<Array<Maybe<PermissionHasUserWithPermissionsEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PermissionHasUserWithPermissionsConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<PermissionHasUserWithPermissionsMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<PermissionHasUserWithPermissionsSearch>>;
};

export type PermissionHasUserWithPermissionsEdge = {
  __typename?: 'PermissionHasUserWithPermissionsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<PermissionHasUserWithPermissions>;
};

export enum PermissionHasUserWithPermissionsEffectEnum {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export type PermissionHasUserWithPermissionsEffectEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<PermissionHasUserWithPermissionsEffectEnum>;
};

export type PermissionHasUserWithPermissionsMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  displayGroup?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  effect?: InputMaybe<Scalars['Boolean']['input']>;
  entity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  permissionId?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
  verb?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PermissionHasUserWithPermissionsSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  displayGroup?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  effect?: InputMaybe<Array<PermissionHasUserWithPermissionsEffectEnumSearch>>;
  entity?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  permissionId?: InputMaybe<Array<StringSearch>>;
  resource?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
  verb?: InputMaybe<Array<StringSearch>>;
};

export type PermissionMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  displayGroup?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  effect?: InputMaybe<Scalars['Boolean']['input']>;
  entity?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  verb?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PermissionSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  displayGroup?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  effect?: InputMaybe<Array<PermissionEffectEnumSearch>>;
  entity?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  resource?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  verb?: InputMaybe<Array<StringSearch>>;
};

export type PickupActualInput = {
  puActualDatetime: Scalars['String']['input'];
  tripId: Array<Scalars['String']['input']>;
};

export type PickupActualResponse = {
  __typename?: 'PickupActualResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type PickupCompletedInput = {
  puCompletedDatetime: Scalars['String']['input'];
  tripId: Array<Scalars['String']['input']>;
};

export type PickupCompletedResponse = {
  __typename?: 'PickupCompletedResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type PickupIncompleteInput = {
  tripId: Array<Scalars['String']['input']>;
};

export type PickupIncompleteResponse = {
  __typename?: 'PickupIncompleteResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type PickupPoint = {
  __typename?: 'PickupPoint';
  coordinates: Point;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  endDatetime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  images?: Maybe<Array<Image>>;
  instructions: Scalars['String']['output'];
  keyword: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  radius: Scalars['Int']['output'];
  startDatetime: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PickupPointActivityConnection = {
  __typename?: 'PickupPointActivityConnection';
  edges?: Maybe<Array<Maybe<PickupPointActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PickupPointActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type PickupPointActivityEdge = {
  __typename?: 'PickupPointActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type PickupPointConnection = {
  __typename?: 'PickupPointConnection';
  edges?: Maybe<Array<Maybe<PickupPointEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PickupPointConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<PickupPointMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<PickupPointSearch>>;
};

export type PickupPointEdge = {
  __typename?: 'PickupPointEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<PickupPoint>;
};

export type PickupPointMaskInput = {
  coordinates?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  instructions?: InputMaybe<Scalars['Boolean']['input']>;
  keyword?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  radius?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PickupPointSearch = {
  coordinates?: InputMaybe<Array<PointSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  instructions?: InputMaybe<Array<StringSearch>>;
  keyword?: InputMaybe<Array<StringSearch>>;
  locationId?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  radius?: InputMaybe<Array<IntSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type Pipeline = {
  function: MetricFunctionEnum;
  key: Scalars['String']['input'];
};

export type Point = {
  __typename?: 'Point';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type PointInput = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type PointSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<PointInput>;
};

export type Points = {
  __typename?: 'Points';
  driveTimeMinutes: Scalars['Float']['output'];
  hourWithOffset: Scalars['Float']['output'];
};

export type PortalAuth = {
  __typename?: 'PortalAuth';
  allowAssignAndAutoCombine: Scalars['Boolean']['output'];
  allowCreateAccidentIssue: Scalars['Boolean']['output'];
  allowCreateClient: Scalars['Boolean']['output'];
  allowCreateDispatchIssue: Scalars['Boolean']['output'];
  allowCreateDispatchSummary: Scalars['Boolean']['output'];
  allowCreateIncidentIssue: Scalars['Boolean']['output'];
  allowCreateLostAndFoundIssue: Scalars['Boolean']['output'];
  allowCreateUserProfile: Scalars['Boolean']['output'];
  allowCustomizeReports: Scalars['Boolean']['output'];
  allowDeleteTripHard: Scalars['Boolean']['output'];
  allowEditTrainingEvaluation: Scalars['Boolean']['output'];
  allowEditTrainingSettings: Scalars['Boolean']['output'];
  allowExportChatHistory: Scalars['Boolean']['output'];
  allowGetDriverEstimatedDriveTime: Scalars['Boolean']['output'];
  allowHideChat: Scalars['Boolean']['output'];
  allowInvoiceDuplicate: Scalars['Boolean']['output'];
  allowOverrideRate: Scalars['Boolean']['output'];
  allowRecordSession: Scalars['Boolean']['output'];
  allowRestoreDeletedTripDocument: Scalars['Boolean']['output'];
  allowRunScheduleAutomation: Scalars['Boolean']['output'];
  allowSaveAndCopyExistingTrips: Scalars['Boolean']['output'];
  allowSearchTripDocument: Scalars['Boolean']['output'];
  allowSearchTripsByRate: Scalars['Boolean']['output'];
  allowSendChat: Scalars['Boolean']['output'];
  allowToViewMap: Scalars['Boolean']['output'];
  allowTripStatusInvoiceFilter: Scalars['Boolean']['output'];
  allowUndeleteTrip: Scalars['Boolean']['output'];
  allowUpdateUserProfile: Scalars['Boolean']['output'];
  allowUploadTripDocument: Scalars['Boolean']['output'];
  allowViewAccidentIssue: Scalars['Boolean']['output'];
  allowViewArchivedImports: Scalars['Boolean']['output'];
  allowViewBufferTime: Scalars['Boolean']['output'];
  allowViewChat: Scalars['Boolean']['output'];
  allowViewChatHistory: Scalars['Boolean']['output'];
  allowViewCombineRule: Scalars['Boolean']['output'];
  allowViewDeletedTripDocument: Scalars['Boolean']['output'];
  allowViewDispatchIssue: Scalars['Boolean']['output'];
  allowViewDispatchSummary: Scalars['Boolean']['output'];
  allowViewDriveTimeTool: Scalars['Boolean']['output'];
  allowViewImportTime: Scalars['Boolean']['output'];
  allowViewIncidentIssue: Scalars['Boolean']['output'];
  allowViewLostAndFoundIssue: Scalars['Boolean']['output'];
  allowViewProviderLocationMapping: Scalars['Boolean']['output'];
  allowViewTrainingChecklist: Scalars['Boolean']['output'];
  allowViewTrainingReport: Scalars['Boolean']['output'];
  allowViewTrainingSettings: Scalars['Boolean']['output'];
  allowViewTripShortcuts: Scalars['Boolean']['output'];
  allowViewUserDashboard: Scalars['Boolean']['output'];
  allowViewUserProfileTab: Scalars['Boolean']['output'];
  allowViewVariableTime: Scalars['Boolean']['output'];
  evaluableTrainingCategoryIds: Array<Scalars['String']['output']>;
};

export type PotentialLocation = {
  __typename?: 'PotentialLocation';
  address?: Maybe<Scalars['String']['output']>;
  airportCode?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  coordinates?: Maybe<Point>;
  countryCode?: Maybe<Scalars['String']['output']>;
  dtr_location_id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type PotentialTrip = {
  __typename?: 'PotentialTrip';
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  bufferMinutes: Scalars['Int']['output'];
  combineId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewId?: Maybe<Scalars['Int']['output']>;
  doLocation?: Maybe<Location>;
  doLocationId: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  flightNumber?: Maybe<Scalars['Int']['output']>;
  fromManifest: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  importId: Scalars['String']['output'];
  importTime?: Maybe<Scalars['String']['output']>;
  kind: PotentialTripKindEnum;
  lastName?: Maybe<Scalars['String']['output']>;
  loopName?: Maybe<Scalars['String']['output']>;
  payerProvider?: Maybe<Provider>;
  payerProviderId: Scalars['String']['output'];
  pilots: Scalars['Int']['output'];
  puLocation?: Maybe<Location>;
  puLocationId: Scalars['String']['output'];
  scheduled: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  split: Scalars['Int']['output'];
  tripId: Scalars['String']['output'];
  typeName?: Maybe<PotentialTripTypeNameEnum>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PotentialTripActivityConnection = {
  __typename?: 'PotentialTripActivityConnection';
  edges?: Maybe<Array<Maybe<PotentialTripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PotentialTripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type PotentialTripActivityEdge = {
  __typename?: 'PotentialTripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type PotentialTripConnection = {
  __typename?: 'PotentialTripConnection';
  edges?: Maybe<Array<Maybe<PotentialTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PotentialTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<PotentialTripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<PotentialTripSearch>>;
};

export type PotentialTripEdge = {
  __typename?: 'PotentialTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<PotentialTrip>;
};

export enum PotentialTripKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type PotentialTripKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<PotentialTripKindEnum>;
};

export type PotentialTripMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  bufferMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewId?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  fromManifest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importId?: InputMaybe<Scalars['Boolean']['input']>;
  importTime?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  typeName?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PotentialTripSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  bufferMinutes?: InputMaybe<Array<IntSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewId?: InputMaybe<Array<IntSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  fromManifest?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importId?: InputMaybe<Array<StringSearch>>;
  importTime?: InputMaybe<Array<StringSearch>>;
  kind?: InputMaybe<Array<PotentialTripKindEnumSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  split?: InputMaybe<Array<IntSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  typeName?: InputMaybe<Array<PotentialTripTypeNameEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum PotentialTripTypeNameEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type PotentialTripTypeNameEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<PotentialTripTypeNameEnum>;
};

export type PredictiveDriveTimeReport = {
  __typename?: 'PredictiveDriveTimeReport';
  tripCount: Scalars['Int']['output'];
  values?: Maybe<Array<Maybe<PredictiveDriveTimeReportRows>>>;
};

export type PredictiveDriveTimeReportRows = {
  __typename?: 'PredictiveDriveTimeReportRows';
  p60: Scalars['String']['output'];
  p80: Scalars['String']['output'];
  p90: Scalars['String']['output'];
  p95: Scalars['String']['output'];
  p99: Scalars['String']['output'];
  period: Scalars['String']['output'];
  timeFrame: Scalars['String']['output'];
  totalTrips: Scalars['Int']['output'];
  weekdayAvg: Scalars['Int']['output'];
  weekendAvg: Scalars['Int']['output'];
};

export type PreviewDetails = {
  __typename?: 'PreviewDetails';
  error?: Maybe<Error>;
  import?: Maybe<Import>;
  notUpdatable?: Maybe<Scalars['Int']['output']>;
  providerRequired?: Maybe<Scalars['Boolean']['output']>;
  stagedTrips?: Maybe<Array<Maybe<StagedTrip>>>;
  updatable?: Maybe<Scalars['Int']['output']>;
  warnings?: Maybe<Array<Error>>;
};

export type PreviousImportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  importId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};

export type Provider = {
  __typename?: 'Provider';
  active: Scalars['Int']['output'];
  addonAutomationAutoIngest?: Maybe<Scalars['Int']['output']>;
  billFrequency?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Scalars['String']['output']>;
  billingCityCode?: Maybe<Scalars['String']['output']>;
  billingStateCode?: Maybe<Scalars['String']['output']>;
  billingZipCode?: Maybe<Scalars['Int']['output']>;
  companyId: Scalars['String']['output'];
  contactPerson?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  emails?: Maybe<Array<Email>>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  iataAirlineCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  importCode?: Maybe<ProviderImportCodeEnum>;
  invoiceTermId?: Maybe<Scalars['String']['output']>;
  mobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  occPhoneNumber?: Maybe<Scalars['String']['output']>;
  primaryAddress?: Maybe<Scalars['String']['output']>;
  primaryCityCode?: Maybe<Scalars['String']['output']>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryLogoUrl?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  primaryStateCode?: Maybe<Scalars['String']['output']>;
  primaryZipCode?: Maybe<Scalars['Int']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  requiresCrewInfo?: Maybe<Scalars['Int']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  type: ProviderTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ProviderActivityConnection = {
  __typename?: 'ProviderActivityConnection';
  edges?: Maybe<Array<Maybe<ProviderActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ProviderActivityEdge = {
  __typename?: 'ProviderActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ProviderAlias = {
  __typename?: 'ProviderAlias';
  alias: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ProviderAliasActivityConnection = {
  __typename?: 'ProviderAliasActivityConnection';
  edges?: Maybe<Array<Maybe<ProviderAliasActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderAliasActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ProviderAliasActivityEdge = {
  __typename?: 'ProviderAliasActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ProviderAliasConnection = {
  __typename?: 'ProviderAliasConnection';
  edges?: Maybe<Array<Maybe<ProviderAliasEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderAliasConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ProviderAliasMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ProviderAliasSearch>>;
};

export type ProviderAliasEdge = {
  __typename?: 'ProviderAliasEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ProviderAlias>;
};

export type ProviderAliasMaskInput = {
  alias?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderAliasSearch = {
  alias?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type ProviderCache = {
  __typename?: 'ProviderCache';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ProviderCacheActivityConnection = {
  __typename?: 'ProviderCacheActivityConnection';
  edges?: Maybe<Array<Maybe<ProviderCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ProviderCacheActivityEdge = {
  __typename?: 'ProviderCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ProviderCacheConnection = {
  __typename?: 'ProviderCacheConnection';
  edges?: Maybe<Array<Maybe<ProviderCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ProviderCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ProviderCacheSearch>>;
};

export type ProviderCacheEdge = {
  __typename?: 'ProviderCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ProviderCache>;
};

export type ProviderCacheMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderCacheSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type ProviderConnection = {
  __typename?: 'ProviderConnection';
  edges?: Maybe<Array<Maybe<ProviderEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ProviderMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ProviderSearch>>;
};

export type ProviderEdge = {
  __typename?: 'ProviderEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Provider>;
};

export type ProviderHasFeature = {
  __typename?: 'ProviderHasFeature';
  features?: Maybe<Array<EnableFeature>>;
  id: Scalars['String']['output'];
};

export enum ProviderImportCodeEnum {
  Aal = 'AAL',
  Api = 'API',
  Dal = 'DAL',
  Skw = 'SKW',
  Sky = 'SKY',
  Swa = 'SWA',
  Train = 'TRAIN',
  TryAll = 'TRY_ALL',
  Ual = 'UAL'
}

export type ProviderImportCodeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderImportCodeEnum>;
};

export type ProviderLocationMapping = {
  __typename?: 'ProviderLocationMapping';
  active: Scalars['Int']['output'];
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  doLocationId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  puLocationId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type ProviderLocationMappingActivityConnection = {
  __typename?: 'ProviderLocationMappingActivityConnection';
  edges?: Maybe<Array<Maybe<ProviderLocationMappingActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderLocationMappingActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ProviderLocationMappingActivityEdge = {
  __typename?: 'ProviderLocationMappingActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ProviderLocationMappingConnection = {
  __typename?: 'ProviderLocationMappingConnection';
  edges?: Maybe<Array<Maybe<ProviderLocationMappingEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderLocationMappingConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ProviderLocationMappingMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ProviderLocationMappingSearch>>;
};

export type ProviderLocationMappingEdge = {
  __typename?: 'ProviderLocationMappingEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ProviderLocationMapping>;
};

export type ProviderLocationMappingMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderLocationMappingSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type ProviderMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addonAutomationAutoIngest?: InputMaybe<Scalars['Boolean']['input']>;
  billFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  billingCityCode?: InputMaybe<Scalars['Boolean']['input']>;
  billingStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  billingZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  contactPerson?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  faxNumber?: InputMaybe<Scalars['Boolean']['input']>;
  iataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importCode?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceTermId?: InputMaybe<Scalars['Boolean']['input']>;
  mobilePhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  occPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAddress?: InputMaybe<Scalars['Boolean']['input']>;
  primaryCityCode?: InputMaybe<Scalars['Boolean']['input']>;
  primaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  primaryLogoUrl?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  primaryStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  primaryZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  referenceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCrewInfo?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  addonAutomationAutoIngest?: InputMaybe<Array<IntSearch>>;
  billFrequency?: InputMaybe<Array<StringSearch>>;
  billingAddress?: InputMaybe<Array<StringSearch>>;
  billingCityCode?: InputMaybe<Array<StringSearch>>;
  billingStateCode?: InputMaybe<Array<StringSearch>>;
  billingZipCode?: InputMaybe<Array<IntSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  contactPerson?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  faxNumber?: InputMaybe<Array<StringSearch>>;
  iataAirlineCode?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importCode?: InputMaybe<Array<ProviderImportCodeEnumSearch>>;
  invoiceTermId?: InputMaybe<Array<StringSearch>>;
  mobilePhoneNumber?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  occPhoneNumber?: InputMaybe<Array<StringSearch>>;
  primaryAddress?: InputMaybe<Array<StringSearch>>;
  primaryCityCode?: InputMaybe<Array<StringSearch>>;
  primaryEmail?: InputMaybe<Array<StringSearch>>;
  primaryLogoUrl?: InputMaybe<Array<StringSearch>>;
  primaryPhoneNumber?: InputMaybe<Array<StringSearch>>;
  primaryStateCode?: InputMaybe<Array<StringSearch>>;
  primaryZipCode?: InputMaybe<Array<IntSearch>>;
  referenceNumber?: InputMaybe<Array<StringSearch>>;
  requiresCrewInfo?: InputMaybe<Array<IntSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<ProviderTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  website?: InputMaybe<Array<StringSearch>>;
};

export enum ProviderTypeEnum {
  Airline = 'AIRLINE',
  Client = 'CLIENT',
  Hotel = 'HOTEL'
}

export type ProviderTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderTypeEnum>;
};

export type ProviderWithAlias = {
  __typename?: 'ProviderWithAlias';
  active: Scalars['Int']['output'];
  addonAutomationAutoIngest?: Maybe<Scalars['Int']['output']>;
  alias: Scalars['String']['output'];
  billFrequency?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Scalars['String']['output']>;
  billingCityCode?: Maybe<Scalars['String']['output']>;
  billingStateCode?: Maybe<Scalars['String']['output']>;
  billingZipCode?: Maybe<Scalars['Int']['output']>;
  companyId: Scalars['String']['output'];
  contactPerson?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  iataAirlineCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  importCode?: Maybe<ProviderWithAliasImportCodeEnum>;
  invoiceTermId?: Maybe<Scalars['String']['output']>;
  mobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  occPhoneNumber?: Maybe<Scalars['String']['output']>;
  primaryAddress?: Maybe<Scalars['String']['output']>;
  primaryCityCode?: Maybe<Scalars['String']['output']>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryLogoUrl?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  primaryStateCode?: Maybe<Scalars['String']['output']>;
  primaryZipCode?: Maybe<Scalars['Int']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  requiresCrewInfo?: Maybe<Scalars['Int']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  type: ProviderWithAliasTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ProviderWithAliasActivityConnection = {
  __typename?: 'ProviderWithAliasActivityConnection';
  edges?: Maybe<Array<Maybe<ProviderWithAliasActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderWithAliasActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ProviderWithAliasActivityEdge = {
  __typename?: 'ProviderWithAliasActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ProviderWithAliasConnection = {
  __typename?: 'ProviderWithAliasConnection';
  edges?: Maybe<Array<Maybe<ProviderWithAliasEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderWithAliasConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ProviderWithAliasMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ProviderWithAliasSearch>>;
};

export type ProviderWithAliasEdge = {
  __typename?: 'ProviderWithAliasEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ProviderWithAlias>;
};

export enum ProviderWithAliasImportCodeEnum {
  Aal = 'AAL',
  Api = 'API',
  Dal = 'DAL',
  Skw = 'SKW',
  Sky = 'SKY',
  Swa = 'SWA',
  Train = 'TRAIN',
  TryAll = 'TRY_ALL',
  Ual = 'UAL'
}

export type ProviderWithAliasImportCodeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderWithAliasImportCodeEnum>;
};

export type ProviderWithAliasMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addonAutomationAutoIngest?: InputMaybe<Scalars['Boolean']['input']>;
  alias?: InputMaybe<Scalars['Boolean']['input']>;
  billFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  billingCityCode?: InputMaybe<Scalars['Boolean']['input']>;
  billingStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  billingZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  contactPerson?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  faxNumber?: InputMaybe<Scalars['Boolean']['input']>;
  iataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importCode?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceTermId?: InputMaybe<Scalars['Boolean']['input']>;
  mobilePhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  occPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAddress?: InputMaybe<Scalars['Boolean']['input']>;
  primaryCityCode?: InputMaybe<Scalars['Boolean']['input']>;
  primaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  primaryLogoUrl?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  primaryStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  primaryZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  referenceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCrewInfo?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderWithAliasSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  addonAutomationAutoIngest?: InputMaybe<Array<IntSearch>>;
  alias?: InputMaybe<Array<StringSearch>>;
  billFrequency?: InputMaybe<Array<StringSearch>>;
  billingAddress?: InputMaybe<Array<StringSearch>>;
  billingCityCode?: InputMaybe<Array<StringSearch>>;
  billingStateCode?: InputMaybe<Array<StringSearch>>;
  billingZipCode?: InputMaybe<Array<IntSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  contactPerson?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  faxNumber?: InputMaybe<Array<StringSearch>>;
  iataAirlineCode?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importCode?: InputMaybe<Array<ProviderWithAliasImportCodeEnumSearch>>;
  invoiceTermId?: InputMaybe<Array<StringSearch>>;
  mobilePhoneNumber?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  occPhoneNumber?: InputMaybe<Array<StringSearch>>;
  primaryAddress?: InputMaybe<Array<StringSearch>>;
  primaryCityCode?: InputMaybe<Array<StringSearch>>;
  primaryEmail?: InputMaybe<Array<StringSearch>>;
  primaryLogoUrl?: InputMaybe<Array<StringSearch>>;
  primaryPhoneNumber?: InputMaybe<Array<StringSearch>>;
  primaryStateCode?: InputMaybe<Array<StringSearch>>;
  primaryZipCode?: InputMaybe<Array<IntSearch>>;
  referenceNumber?: InputMaybe<Array<StringSearch>>;
  requiresCrewInfo?: InputMaybe<Array<IntSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<ProviderWithAliasTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  website?: InputMaybe<Array<StringSearch>>;
};

export enum ProviderWithAliasTypeEnum {
  Airline = 'AIRLINE',
  Client = 'CLIENT',
  Hotel = 'HOTEL'
}

export type ProviderWithAliasTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderWithAliasTypeEnum>;
};

export type ProviderWithContract = {
  __typename?: 'ProviderWithContract';
  active: Scalars['Int']['output'];
  addonAutomationAutoIngest?: Maybe<Scalars['Int']['output']>;
  billFrequency?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Scalars['String']['output']>;
  billingCityCode?: Maybe<Scalars['String']['output']>;
  billingStateCode?: Maybe<Scalars['String']['output']>;
  billingZipCode?: Maybe<Scalars['Int']['output']>;
  companyId: Scalars['String']['output'];
  contactPerson?: Maybe<Scalars['String']['output']>;
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  iataAirlineCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  importCode?: Maybe<ProviderWithContractImportCodeEnum>;
  invoiceTermId?: Maybe<Scalars['String']['output']>;
  mobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  occPhoneNumber?: Maybe<Scalars['String']['output']>;
  primaryAddress?: Maybe<Scalars['String']['output']>;
  primaryCityCode?: Maybe<Scalars['String']['output']>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryLogoUrl?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  primaryStateCode?: Maybe<Scalars['String']['output']>;
  primaryZipCode?: Maybe<Scalars['Int']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  requiresCrewInfo?: Maybe<Scalars['Int']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  type: ProviderWithContractTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ProviderWithContractActivityConnection = {
  __typename?: 'ProviderWithContractActivityConnection';
  edges?: Maybe<Array<Maybe<ProviderWithContractActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderWithContractActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ProviderWithContractActivityEdge = {
  __typename?: 'ProviderWithContractActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type ProviderWithContractConnection = {
  __typename?: 'ProviderWithContractConnection';
  edges?: Maybe<Array<Maybe<ProviderWithContractEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderWithContractConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ProviderWithContractMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ProviderWithContractSearch>>;
};

export type ProviderWithContractEdge = {
  __typename?: 'ProviderWithContractEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ProviderWithContract>;
};

export enum ProviderWithContractImportCodeEnum {
  Aal = 'AAL',
  Api = 'API',
  Dal = 'DAL',
  Skw = 'SKW',
  Sky = 'SKY',
  Swa = 'SWA',
  Train = 'TRAIN',
  TryAll = 'TRY_ALL',
  Ual = 'UAL'
}

export type ProviderWithContractImportCodeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderWithContractImportCodeEnum>;
};

export type ProviderWithContractMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addonAutomationAutoIngest?: InputMaybe<Scalars['Boolean']['input']>;
  billFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  billingCityCode?: InputMaybe<Scalars['Boolean']['input']>;
  billingStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  billingZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  contactPerson?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  faxNumber?: InputMaybe<Scalars['Boolean']['input']>;
  iataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importCode?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceTermId?: InputMaybe<Scalars['Boolean']['input']>;
  mobilePhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  occPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAddress?: InputMaybe<Scalars['Boolean']['input']>;
  primaryCityCode?: InputMaybe<Scalars['Boolean']['input']>;
  primaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  primaryLogoUrl?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  primaryStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  primaryZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  referenceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCrewInfo?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderWithContractSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  addonAutomationAutoIngest?: InputMaybe<Array<IntSearch>>;
  billFrequency?: InputMaybe<Array<StringSearch>>;
  billingAddress?: InputMaybe<Array<StringSearch>>;
  billingCityCode?: InputMaybe<Array<StringSearch>>;
  billingStateCode?: InputMaybe<Array<StringSearch>>;
  billingZipCode?: InputMaybe<Array<IntSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  contactPerson?: InputMaybe<Array<StringSearch>>;
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  faxNumber?: InputMaybe<Array<StringSearch>>;
  iataAirlineCode?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importCode?: InputMaybe<Array<ProviderWithContractImportCodeEnumSearch>>;
  invoiceTermId?: InputMaybe<Array<StringSearch>>;
  mobilePhoneNumber?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  occPhoneNumber?: InputMaybe<Array<StringSearch>>;
  primaryAddress?: InputMaybe<Array<StringSearch>>;
  primaryCityCode?: InputMaybe<Array<StringSearch>>;
  primaryEmail?: InputMaybe<Array<StringSearch>>;
  primaryLogoUrl?: InputMaybe<Array<StringSearch>>;
  primaryPhoneNumber?: InputMaybe<Array<StringSearch>>;
  primaryStateCode?: InputMaybe<Array<StringSearch>>;
  primaryZipCode?: InputMaybe<Array<IntSearch>>;
  referenceNumber?: InputMaybe<Array<StringSearch>>;
  requiresCrewInfo?: InputMaybe<Array<IntSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<ProviderWithContractTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  website?: InputMaybe<Array<StringSearch>>;
};

export enum ProviderWithContractTypeEnum {
  Airline = 'AIRLINE',
  Client = 'CLIENT',
  Hotel = 'HOTEL'
}

export type ProviderWithContractTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderWithContractTypeEnum>;
};

export type ProviderWithUpdateStrategy = {
  __typename?: 'ProviderWithUpdateStrategy';
  active: Scalars['Int']['output'];
  addonAutomationAutoIngest?: Maybe<Scalars['Int']['output']>;
  addonScheduledComparisonWindowMinutes?: Maybe<Scalars['Int']['output']>;
  addonStrategy: ProviderWithUpdateStrategyAddonStrategyEnum;
  addonType: ProviderWithUpdateStrategyAddonTypeEnum;
  billFrequency?: Maybe<Scalars['String']['output']>;
  billingAddress?: Maybe<Scalars['String']['output']>;
  billingCityCode?: Maybe<Scalars['String']['output']>;
  billingStateCode?: Maybe<Scalars['String']['output']>;
  billingZipCode?: Maybe<Scalars['Int']['output']>;
  companyId: Scalars['String']['output'];
  contactPerson?: Maybe<Scalars['String']['output']>;
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customAddonToleranceMinutes?: Maybe<Scalars['Int']['output']>;
  dailyStrategy: ProviderWithUpdateStrategyDailyStrategyEnum;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  faxNumber?: Maybe<Scalars['String']['output']>;
  iataAirlineCode?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  importCode?: Maybe<ProviderWithUpdateStrategyImportCodeEnum>;
  importNameIncludesHotels: Scalars['Int']['output'];
  invoiceTermId?: Maybe<Scalars['String']['output']>;
  manifestAutomationDeleteStrategy: ProviderWithUpdateStrategyManifestAutomationDeleteStrategyEnum;
  manifestStrategy: ProviderWithUpdateStrategyManifestStrategyEnum;
  mobilePhoneNumber?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  occPhoneNumber?: Maybe<Scalars['String']['output']>;
  previewTimeoutMinutes?: Maybe<Scalars['Int']['output']>;
  primaryAddress?: Maybe<Scalars['String']['output']>;
  primaryCityCode?: Maybe<Scalars['String']['output']>;
  primaryEmail?: Maybe<Scalars['String']['output']>;
  primaryLogoUrl?: Maybe<Scalars['String']['output']>;
  primaryPhoneNumber?: Maybe<Scalars['String']['output']>;
  primaryStateCode?: Maybe<Scalars['String']['output']>;
  primaryZipCode?: Maybe<Scalars['Int']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  requiresCrewInfo?: Maybe<Scalars['Int']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  type: ProviderWithUpdateStrategyTypeEnum;
  updateKindFromLocations: Scalars['Int']['output'];
  updateStrategy: ProviderWithUpdateStrategyUpdateStrategyEnum;
  updateStrategyActive: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  website?: Maybe<Scalars['String']['output']>;
};

export type ProviderWithUpdateStrategyActivityConnection = {
  __typename?: 'ProviderWithUpdateStrategyActivityConnection';
  edges?: Maybe<Array<Maybe<ProviderWithUpdateStrategyActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderWithUpdateStrategyActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type ProviderWithUpdateStrategyActivityEdge = {
  __typename?: 'ProviderWithUpdateStrategyActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum ProviderWithUpdateStrategyAddonStrategyEnum {
  Merge = 'MERGE',
  Replace = 'REPLACE',
  ReplaceIfGreater = 'REPLACE_IF_GREATER'
}

export type ProviderWithUpdateStrategyAddonStrategyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderWithUpdateStrategyAddonStrategyEnum>;
};

export enum ProviderWithUpdateStrategyAddonTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type ProviderWithUpdateStrategyAddonTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderWithUpdateStrategyAddonTypeEnum>;
};

export type ProviderWithUpdateStrategyConnection = {
  __typename?: 'ProviderWithUpdateStrategyConnection';
  edges?: Maybe<Array<Maybe<ProviderWithUpdateStrategyEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type ProviderWithUpdateStrategyConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<ProviderWithUpdateStrategyMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ProviderWithUpdateStrategySearch>>;
};

export enum ProviderWithUpdateStrategyDailyStrategyEnum {
  Merge = 'MERGE',
  Replace = 'REPLACE'
}

export type ProviderWithUpdateStrategyDailyStrategyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderWithUpdateStrategyDailyStrategyEnum>;
};

export type ProviderWithUpdateStrategyEdge = {
  __typename?: 'ProviderWithUpdateStrategyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ProviderWithUpdateStrategy>;
};

export enum ProviderWithUpdateStrategyImportCodeEnum {
  Aal = 'AAL',
  Api = 'API',
  Dal = 'DAL',
  Skw = 'SKW',
  Sky = 'SKY',
  Swa = 'SWA',
  Train = 'TRAIN',
  TryAll = 'TRY_ALL',
  Ual = 'UAL'
}

export type ProviderWithUpdateStrategyImportCodeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderWithUpdateStrategyImportCodeEnum>;
};

export enum ProviderWithUpdateStrategyManifestAutomationDeleteStrategyEnum {
  Cancel = 'CANCEL',
  SoftDelete = 'SOFT_DELETE'
}

export type ProviderWithUpdateStrategyManifestAutomationDeleteStrategyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderWithUpdateStrategyManifestAutomationDeleteStrategyEnum>;
};

export enum ProviderWithUpdateStrategyManifestStrategyEnum {
  Merge = 'MERGE',
  Replace = 'REPLACE'
}

export type ProviderWithUpdateStrategyManifestStrategyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderWithUpdateStrategyManifestStrategyEnum>;
};

export type ProviderWithUpdateStrategyMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addonAutomationAutoIngest?: InputMaybe<Scalars['Boolean']['input']>;
  addonScheduledComparisonWindowMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  addonStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  addonType?: InputMaybe<Scalars['Boolean']['input']>;
  billFrequency?: InputMaybe<Scalars['Boolean']['input']>;
  billingAddress?: InputMaybe<Scalars['Boolean']['input']>;
  billingCityCode?: InputMaybe<Scalars['Boolean']['input']>;
  billingStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  billingZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  contactPerson?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  customAddonToleranceMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  dailyStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  faxNumber?: InputMaybe<Scalars['Boolean']['input']>;
  iataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importCode?: InputMaybe<Scalars['Boolean']['input']>;
  importNameIncludesHotels?: InputMaybe<Scalars['Boolean']['input']>;
  invoiceTermId?: InputMaybe<Scalars['Boolean']['input']>;
  manifestAutomationDeleteStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  manifestStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  mobilePhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  occPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  previewTimeoutMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAddress?: InputMaybe<Scalars['Boolean']['input']>;
  primaryCityCode?: InputMaybe<Scalars['Boolean']['input']>;
  primaryEmail?: InputMaybe<Scalars['Boolean']['input']>;
  primaryLogoUrl?: InputMaybe<Scalars['Boolean']['input']>;
  primaryPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  primaryStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  primaryZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  referenceNumber?: InputMaybe<Scalars['Boolean']['input']>;
  requiresCrewInfo?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updateKindFromLocations?: InputMaybe<Scalars['Boolean']['input']>;
  updateStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  updateStrategyActive?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  website?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ProviderWithUpdateStrategySearch = {
  active?: InputMaybe<Array<IntSearch>>;
  addonAutomationAutoIngest?: InputMaybe<Array<IntSearch>>;
  addonScheduledComparisonWindowMinutes?: InputMaybe<Array<IntSearch>>;
  addonStrategy?: InputMaybe<Array<ProviderWithUpdateStrategyAddonStrategyEnumSearch>>;
  addonType?: InputMaybe<Array<ProviderWithUpdateStrategyAddonTypeEnumSearch>>;
  billFrequency?: InputMaybe<Array<StringSearch>>;
  billingAddress?: InputMaybe<Array<StringSearch>>;
  billingCityCode?: InputMaybe<Array<StringSearch>>;
  billingStateCode?: InputMaybe<Array<StringSearch>>;
  billingZipCode?: InputMaybe<Array<IntSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  contactPerson?: InputMaybe<Array<StringSearch>>;
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  customAddonToleranceMinutes?: InputMaybe<Array<IntSearch>>;
  dailyStrategy?: InputMaybe<Array<ProviderWithUpdateStrategyDailyStrategyEnumSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  faxNumber?: InputMaybe<Array<StringSearch>>;
  iataAirlineCode?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importCode?: InputMaybe<Array<ProviderWithUpdateStrategyImportCodeEnumSearch>>;
  importNameIncludesHotels?: InputMaybe<Array<IntSearch>>;
  invoiceTermId?: InputMaybe<Array<StringSearch>>;
  manifestAutomationDeleteStrategy?: InputMaybe<Array<ProviderWithUpdateStrategyManifestAutomationDeleteStrategyEnumSearch>>;
  manifestStrategy?: InputMaybe<Array<ProviderWithUpdateStrategyManifestStrategyEnumSearch>>;
  mobilePhoneNumber?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  occPhoneNumber?: InputMaybe<Array<StringSearch>>;
  previewTimeoutMinutes?: InputMaybe<Array<IntSearch>>;
  primaryAddress?: InputMaybe<Array<StringSearch>>;
  primaryCityCode?: InputMaybe<Array<StringSearch>>;
  primaryEmail?: InputMaybe<Array<StringSearch>>;
  primaryLogoUrl?: InputMaybe<Array<StringSearch>>;
  primaryPhoneNumber?: InputMaybe<Array<StringSearch>>;
  primaryStateCode?: InputMaybe<Array<StringSearch>>;
  primaryZipCode?: InputMaybe<Array<IntSearch>>;
  referenceNumber?: InputMaybe<Array<StringSearch>>;
  requiresCrewInfo?: InputMaybe<Array<IntSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<ProviderWithUpdateStrategyTypeEnumSearch>>;
  updateKindFromLocations?: InputMaybe<Array<IntSearch>>;
  updateStrategy?: InputMaybe<Array<ProviderWithUpdateStrategyUpdateStrategyEnumSearch>>;
  updateStrategyActive?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  website?: InputMaybe<Array<StringSearch>>;
};

export enum ProviderWithUpdateStrategyTypeEnum {
  Airline = 'AIRLINE',
  Client = 'CLIENT',
  Hotel = 'HOTEL'
}

export type ProviderWithUpdateStrategyTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderWithUpdateStrategyTypeEnum>;
};

export enum ProviderWithUpdateStrategyUpdateStrategyEnum {
  Merge = 'MERGE',
  Replace = 'REPLACE'
}

export type ProviderWithUpdateStrategyUpdateStrategyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<ProviderWithUpdateStrategyUpdateStrategyEnum>;
};

export type Punch = {
  __typename?: 'Punch';
  airportCode: Scalars['String']['output'];
  coordinates?: Maybe<Point>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  paylocityCompanyId: Scalars['String']['output'];
  paylocityJobCodeId: Scalars['String']['output'];
  punchDatetime: Scalars['String']['output'];
  type: PunchTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type PunchActivityConnection = {
  __typename?: 'PunchActivityConnection';
  edges?: Maybe<Array<Maybe<PunchActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PunchActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type PunchActivityEdge = {
  __typename?: 'PunchActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type PunchConnection = {
  __typename?: 'PunchConnection';
  edges?: Maybe<Array<Maybe<PunchEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PunchConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<PunchMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<PunchSearch>>;
};

export type PunchEdge = {
  __typename?: 'PunchEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Punch>;
};

export type PunchHistory = {
  __typename?: 'PunchHistory';
  approvalEmployee?: Maybe<Scalars['Int']['output']>;
  approvalSupervisor?: Maybe<Scalars['Int']['output']>;
  approvalSupervisorBy?: Maybe<Scalars['String']['output']>;
  companyCode: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  date: Scalars['String']['output'];
  durationOt1?: Maybe<Scalars['Float']['output']>;
  durationOt2?: Maybe<Scalars['Float']['output']>;
  durationRegular?: Maybe<Scalars['Float']['output']>;
  employeeId: Scalars['String']['output'];
  fileLocation?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  payType: Scalars['String']['output'];
  punchInTime: Scalars['String']['output'];
  punchInType: PunchHistoryPunchInTypeEnum;
  punchOutTime: Scalars['String']['output'];
  punchOutType: PunchHistoryPunchOutTypeEnum;
  unpaidDuration?: Maybe<Scalars['Float']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PunchHistoryActivityConnection = {
  __typename?: 'PunchHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<PunchHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PunchHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type PunchHistoryActivityEdge = {
  __typename?: 'PunchHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type PunchHistoryConnection = {
  __typename?: 'PunchHistoryConnection';
  edges?: Maybe<Array<Maybe<PunchHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PunchHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<PunchHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<PunchHistorySearch>>;
};

export type PunchHistoryEdge = {
  __typename?: 'PunchHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<PunchHistory>;
};

export type PunchHistoryMaskInput = {
  approvalEmployee?: InputMaybe<Scalars['Boolean']['input']>;
  approvalSupervisor?: InputMaybe<Scalars['Boolean']['input']>;
  approvalSupervisorBy?: InputMaybe<Scalars['Boolean']['input']>;
  companyCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  date?: InputMaybe<Scalars['Boolean']['input']>;
  durationOt1?: InputMaybe<Scalars['Boolean']['input']>;
  durationOt2?: InputMaybe<Scalars['Boolean']['input']>;
  durationRegular?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  payType?: InputMaybe<Scalars['Boolean']['input']>;
  punchInTime?: InputMaybe<Scalars['Boolean']['input']>;
  punchInType?: InputMaybe<Scalars['Boolean']['input']>;
  punchOutTime?: InputMaybe<Scalars['Boolean']['input']>;
  punchOutType?: InputMaybe<Scalars['Boolean']['input']>;
  unpaidDuration?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PunchHistoryPunchInTypeEnum {
  Empty = 'EMPTY',
  In = 'IN',
  NonWork = 'NON_WORK',
  Split = 'SPLIT',
  Unknown = 'UNKNOWN'
}

export type PunchHistoryPunchInTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<PunchHistoryPunchInTypeEnum>;
};

export enum PunchHistoryPunchOutTypeEnum {
  Empty = 'EMPTY',
  NonWork = 'NON_WORK',
  Out = 'OUT',
  Split = 'SPLIT',
  Unknown = 'UNKNOWN'
}

export type PunchHistoryPunchOutTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<PunchHistoryPunchOutTypeEnum>;
};

export type PunchHistorySearch = {
  approvalEmployee?: InputMaybe<Array<IntSearch>>;
  approvalSupervisor?: InputMaybe<Array<IntSearch>>;
  approvalSupervisorBy?: InputMaybe<Array<StringSearch>>;
  companyCode?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  date?: InputMaybe<Array<StringSearch>>;
  durationOt1?: InputMaybe<Array<FloatSearch>>;
  durationOt2?: InputMaybe<Array<FloatSearch>>;
  durationRegular?: InputMaybe<Array<FloatSearch>>;
  employeeId?: InputMaybe<Array<StringSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  payType?: InputMaybe<Array<StringSearch>>;
  punchInTime?: InputMaybe<Array<StringSearch>>;
  punchInType?: InputMaybe<Array<PunchHistoryPunchInTypeEnumSearch>>;
  punchOutTime?: InputMaybe<Array<StringSearch>>;
  punchOutType?: InputMaybe<Array<PunchHistoryPunchOutTypeEnumSearch>>;
  unpaidDuration?: InputMaybe<Array<FloatSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type PunchMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  coordinates?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  paylocityCompanyId?: InputMaybe<Scalars['Boolean']['input']>;
  paylocityJobCodeId?: InputMaybe<Scalars['Boolean']['input']>;
  punchDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PunchPolicy = {
  __typename?: 'PunchPolicy';
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  eventEndDatetime?: Maybe<Scalars['String']['output']>;
  eventStartDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  locationId: Scalars['String']['output'];
  minutesIn: Scalars['Int']['output'];
  minutesOut: Scalars['Int']['output'];
  startTime: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type PunchPolicyActivityConnection = {
  __typename?: 'PunchPolicyActivityConnection';
  edges?: Maybe<Array<Maybe<PunchPolicyActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PunchPolicyActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type PunchPolicyActivityEdge = {
  __typename?: 'PunchPolicyActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type PunchPolicyConnection = {
  __typename?: 'PunchPolicyConnection';
  edges?: Maybe<Array<Maybe<PunchPolicyEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type PunchPolicyConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<PunchPolicyMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<PunchPolicySearch>>;
};

export type PunchPolicyEdge = {
  __typename?: 'PunchPolicyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<PunchPolicy>;
};

export type PunchPolicyMaskInput = {
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Boolean']['input']>;
  eventEndDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  eventStartDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Boolean']['input']>;
  minutesIn?: InputMaybe<Scalars['Boolean']['input']>;
  minutesOut?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type PunchPolicySearch = {
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  endTime?: InputMaybe<Array<StringSearch>>;
  eventEndDatetime?: InputMaybe<Array<StringSearch>>;
  eventStartDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  locationId?: InputMaybe<Array<StringSearch>>;
  minutesIn?: InputMaybe<Array<IntSearch>>;
  minutesOut?: InputMaybe<Array<IntSearch>>;
  startTime?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type PunchSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  coordinates?: InputMaybe<Array<PointSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  paylocityCompanyId?: InputMaybe<Array<StringSearch>>;
  paylocityJobCodeId?: InputMaybe<Array<StringSearch>>;
  punchDatetime?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<PunchTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export enum PunchTypeEnum {
  In = 'IN',
  Out = 'OUT'
}

export type PunchTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<PunchTypeEnum>;
};

export type Query = {
  __typename?: 'Query';
  checkEvaluationEligibility: CheckEvaluationEligibilityResponse;
  createAccidentIssueDocumentDownloadUrl: CreateIssueDownloadUrlResponse;
  createDispatchIssueDocumentDownloadUrl: CreateIssueDownloadUrlResponse;
  createIncidentIssueDocumentDownloadUrl: CreateIssueDownloadUrlResponse;
  createLostAndFoundIssueDocumentDownloadUrl: CreateIssueDownloadUrlResponse;
  deviceQuery?: Maybe<DeviceQueryResponse>;
  downloadAccidentIssueWithCacheAsCSV: DownloadAccidentIssueWithCacheAsCsvResponse;
  downloadActivityLogWithCacheAsCSV: DownloadActivityLogWithCacheAsCsvResponse;
  downloadDeviceMetricWithUserAsCSV: DownloadDeviceMetricWithUserAsCsvResponse;
  downloadDispatchIssueWithCacheAsCSV: DownloadDispatchIssueWithCacheAsCsvResponse;
  downloadDispatchSummaryWithCacheAsCSV: DownloadDispatchSummaryWithCacheAsCsvResponse;
  downloadIncidentIssueWithCacheAsCSV: DownloadIncidentIssueWithCacheAsCsvResponse;
  downloadLostAndFoundIssueWithCacheAsCSV: DownloadLostAndFoundIssueWithCacheAsCsvResponse;
  downloadTripTableAsCSV: DownloadTripWithCompletionAndRateAsCsvResponse;
  downloadTripWithCompletionAndRateAsCSV: DownloadTripWithCompletionAndRateAsCsvResponse;
  downloadTripWithFcrInnerJoinAsCSV: DownloadTripWithFcrInnerJoinAsCsvResponse;
  getAvailableUsersForTrip: GetAvailableUsersForTripResponse;
  getCorrectRatesForTrips: GetCorrectRatesForTripsResponse;
  getDeviceConfig: GetDeviceConfigResponse;
  getDriveTimeReport: GetDriveTimeReportResponse;
  getDriveTimeReportAsCSV: GetDriveTimeReportAsCsvResponse;
  getDtrNormalizedAddress: GetNormalizedAddressResponse;
  getDtrScatterPlot: GetDtrScatterPlotResponse;
  getDtrStatistic: GetDtrStatisticResponse;
  getEvaluation: GetEvaluationResponse;
  getFaq: GetFaqResponse;
  getFilters: GetFiltersResponse;
  getFlightStatus: GetFlightStatusResponse;
  getHeaders: GetHeadersResponse;
  getInvoice: GetInvoiceResponse;
  getManifestParsedTrips: GetManifestParsedTripsResponse;
  getMetric: GetMetricResponse;
  getNormalizedAddress: GetNormalizedAddressResponse;
  getOnTimePerformanceReport: GetOnTimePerformanceReportResponse;
  getOnTimePerformanceReportAsCSV: GetOnTimePerformanceReportAsCsvResponse;
  getOverrideImportOptions: GetOverrideImportOptionsResponse;
  getPortalConfig: GetPortalConfigResponse;
  getPredictiveDriveTimeReport: GetPredictiveDriveTimeReportResponse;
  getSummaryReport: GetSummaryReportResponse;
  getTripEta: GetTripEtaResponse;
  getTripsWithWrongContractedRate: GetTripsWithWrongContractedRateResponse;
  node?: Maybe<Node>;
  questionnaireCategoryGroups: Array<QuestionnaireCategoryGroups>;
  reportQuery?: Maybe<ReportQueryResponse>;
  runGetDriverEstimatedDriveTime: RunGetDriverEstimatedDriveTimeResponse;
  runRateOverridePreview: RunRateOverridePreviewResponse;
  searchAccidentIssue: SearchAccidentIssueResponse;
  searchAccidentIssueDocument: SearchAccidentIssueDocumentResponse;
  searchActivity: SearchActivityResponse;
  searchActivityLog: SearchActivityLogResponse;
  searchAirport: SearchAirportResponse;
  searchAirportHasCompany: SearchAirportHasCompanyResponse;
  searchAirportHasVehicle: SearchAirportHasVehicleResponse;
  searchAirportWithGroup: SearchAirportWithGroupResponse;
  searchAirportWithLocation: SearchAirportWithLocationResponse;
  searchAirportWithVehicle: SearchAirportWithVehicleResponse;
  searchAlias: SearchAliasResponse;
  searchAutomationHistoryWithAirport: SearchAutomationHistoryWithAirportResponse;
  searchAutomationTrip: SearchAutomationTripResponse;
  searchBufferTimes: SearchBufferTimeResponse;
  searchChatHistory: SearchChatHistoryResponse;
  searchChatQuickReplyMessage: SearchChatQuickReplyMessageResponse;
  searchCombinableTrips: SearchCombinableTripsResponse;
  searchCombineRuleHistory: SearchCombineRuleHistoryResponse;
  searchCombineRules: SearchCombineRuleResponse;
  searchCommunications: SearchCommunicationResponse;
  searchCompanies: SearchCompaniesResponse;
  searchCrewCountRequirement: SearchCrewCountRequirementResponse;
  searchDashboard: SearchDashboardResponse;
  searchDispatchIssue: SearchDispatchIssueResponse;
  searchDispatchIssueDocument: SearchDispatchIssueDocumentResponse;
  searchDispatchSummary: SearchDispatchSummaryResponse;
  searchDispatchSummaryDocument: SearchDispatchSummaryDocumentResponse;
  searchDispatchSummaryMarket: SearchDispatchSummaryMarketResponse;
  searchDriverEtaWithPreviousTrip: SearchDriverEtaWithPreviousTripResponse;
  searchDtrLocation: SearchDtrLocationResponse;
  searchFcrTypes: SearchFcrTypeResponse;
  searchFcrs: SearchFcrResponse;
  searchFlags: SearchFlagResponse;
  searchGeneratedDocument: SearchGeneratedDocumentResponse;
  searchGroups: SearchGroupResponse;
  searchImports: SearchImportsResponse;
  searchIncidentIssue: SearchIncidentIssueResponse;
  searchIncidentIssueDocument: SearchIncidentIssueDocumentResponse;
  searchInvoiceDocument: SearchInvoiceDocumentResponse;
  searchInvoices: SearchInvoiceResponse;
  searchLocations: SearchLocationsResponse;
  searchLostAndFoundIssue: SearchLostAndFoundIssueResponse;
  searchLostAndFoundIssueDocument: SearchLostAndFoundIssueDocumentResponse;
  searchManifestHistoryWithRoute: SearchManifestHistoryWithRouteResponse;
  searchPermissions: SearchPermissionResponse;
  searchPreviousImports: SearchPreviousImportsResponse;
  searchProviderLocationMapping: SearchProviderLocationMappingResponse;
  searchProviders: SearchProviderResponse;
  searchPunchPolicies: SearchPunchPolicyResponse;
  searchQueryHistory: SearchQueryHistoryResponse;
  searchQuestionnaireAnswerOption: SearchQuestionnaireAnswerOptionResponse;
  searchQuestionnaireAnswerType: SearchQuestionnaireAnswerTypeResponse;
  searchQuestionnaireCategory: SearchQuestionnaireCategoryResponse;
  searchQuestionnaireQuestion: SearchQuestionnaireQuestionResponse;
  searchRates: SearchRateResponse;
  searchRatings: SearchRatingResponse;
  searchRoles: SearchRoleResponse;
  searchStops: SearchStopResponse;
  searchSummaryReportSnapshots?: Maybe<SearchSummaryReportSnapshotsResponse>;
  searchTimeFrame: SearchTimeFrameResponse;
  searchTimeFrameRange: SearchTimeFrameRangeResponse;
  searchTripDocument: SearchTripDocumentResponse;
  searchTrips: SearchTripResponse;
  searchUserHasAirport: SearchUserHasAirportResponse;
  searchUserWithAvailabilityAndPermissions: SearchUserWithAvailabilityAndPermissionsResponse;
  searchUserWithMarket: SearchUserWithMarketResponse;
  searchUserWithPermissions: SearchUserWithPermissionsResponse;
  searchUsers: SearchUserResponse;
  searchVariableTimes: SearchVariableTimeResponse;
  searchVehicles: SearchVehicleResponse;
  searchWidget: SearchWidgetResponse;
};


export type QueryCheckEvaluationEligibilityArgs = {
  input: CheckEvaluationEligibilityInput;
};


export type QueryCreateAccidentIssueDocumentDownloadUrlArgs = {
  input: CreateIssueDownloadUrlInput;
};


export type QueryCreateDispatchIssueDocumentDownloadUrlArgs = {
  input: CreateIssueDownloadUrlInput;
};


export type QueryCreateIncidentIssueDocumentDownloadUrlArgs = {
  input: CreateIssueDownloadUrlInput;
};


export type QueryCreateLostAndFoundIssueDocumentDownloadUrlArgs = {
  input: CreateIssueDownloadUrlInput;
};


export type QueryDownloadAccidentIssueWithCacheAsCsvArgs = {
  input: DownloadAccidentIssueWithCacheAsCsvInput;
};


export type QueryDownloadActivityLogWithCacheAsCsvArgs = {
  input: DownloadActivityLogWithCacheAsCsvInput;
};


export type QueryDownloadDeviceMetricWithUserAsCsvArgs = {
  input: DownloadDeviceMetricWithUserAsCsvInput;
};


export type QueryDownloadDispatchIssueWithCacheAsCsvArgs = {
  input: DownloadDispatchIssueWithCacheAsCsvInput;
};


export type QueryDownloadDispatchSummaryWithCacheAsCsvArgs = {
  input: DownloadDispatchSummaryWithCacheAsCsvInput;
};


export type QueryDownloadIncidentIssueWithCacheAsCsvArgs = {
  input: DownloadIncidentIssueWithCacheAsCsvInput;
};


export type QueryDownloadLostAndFoundIssueWithCacheAsCsvArgs = {
  input: DownloadLostAndFoundIssueWithCacheAsCsvInput;
};


export type QueryDownloadTripTableAsCsvArgs = {
  input: DownloadTripTableAsCsvInput;
};


export type QueryDownloadTripWithCompletionAndRateAsCsvArgs = {
  input: DownloadTripWithCompletionAndRateAsCsvInput;
};


export type QueryDownloadTripWithFcrInnerJoinAsCsvArgs = {
  input: DownloadTripWithFcrInnerJoinAsCsvInput;
};


export type QueryGetAvailableUsersForTripArgs = {
  input: GetAvailableUsersForTripInput;
};


export type QueryGetCorrectRatesForTripsArgs = {
  input: GetCorrectRatesForTripsInput;
};


export type QueryGetDeviceConfigArgs = {
  input: GetDeviceConfigInput;
};


export type QueryGetDriveTimeReportArgs = {
  input: GetDriveTimeReportInput;
};


export type QueryGetDriveTimeReportAsCsvArgs = {
  input: GetDriveTimeReportAsCsvInput;
};


export type QueryGetDtrNormalizedAddressArgs = {
  input: GetNormalizedAddressInput;
};


export type QueryGetDtrScatterPlotArgs = {
  input: GetDtrScatterPlotInput;
};


export type QueryGetDtrStatisticArgs = {
  input: GetDtrStatisticInput;
};


export type QueryGetEvaluationArgs = {
  input: GetEvaluationInput;
};


export type QueryGetFaqArgs = {
  input: GetFaqInput;
};


export type QueryGetFlightStatusArgs = {
  input: GetFlightStatusInput;
};


export type QueryGetHeadersArgs = {
  input: GetHeadersInput;
};


export type QueryGetInvoiceArgs = {
  input: GetInvoiceInput;
};


export type QueryGetManifestParsedTripsArgs = {
  input: GetManifestParsedTripsInput;
};


export type QueryGetMetricArgs = {
  input: GetMetricInput;
};


export type QueryGetNormalizedAddressArgs = {
  input: GetNormalizedAddressInput;
};


export type QueryGetOnTimePerformanceReportArgs = {
  input: GetOnTimePerformanceReportInput;
};


export type QueryGetOnTimePerformanceReportAsCsvArgs = {
  input: GetOnTimePerformanceReportAsCsvInput;
};


export type QueryGetOverrideImportOptionsArgs = {
  input: GetOverrideImportOptionsInput;
};


export type QueryGetPortalConfigArgs = {
  input: GetPortalConfigInput;
};


export type QueryGetPredictiveDriveTimeReportArgs = {
  input: GetPredictiveDriveTimeReportInput;
};


export type QueryGetSummaryReportArgs = {
  input: GetSummaryReportInput;
};


export type QueryGetTripEtaArgs = {
  input: GetTripEtaInput;
};


export type QueryGetTripsWithWrongContractedRateArgs = {
  input: GetTripsWithWrongContractedRateInput;
};


export type QueryNodeArgs = {
  id: Scalars['ID']['input'];
};


export type QueryQuestionnaireCategoryGroupsArgs = {
  input: QuestionnaireCategoryGroupsInput;
};


export type QueryRunGetDriverEstimatedDriveTimeArgs = {
  input: RunGetDriverEstimatedDriveTimeInput;
};


export type QueryRunRateOverridePreviewArgs = {
  input: RunRateOverridePreviewInput;
};


export type QuerySearchChatHistoryArgs = {
  input: SearchChatHistoryInput;
};

export type QueryHistory = {
  __typename?: 'QueryHistory';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  doLocationId: Scalars['String']['output'];
  endDate: Scalars['String']['output'];
  id: Scalars['String']['output'];
  interval: Scalars['String']['output'];
  puLocationId: Scalars['String']['output'];
  startDate: Scalars['String']['output'];
  status: QueryHistoryStatusEnum;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type QueryHistoryActivityConnection = {
  __typename?: 'QueryHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<QueryHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type QueryHistoryActivityEdge = {
  __typename?: 'QueryHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type QueryHistoryConnection = {
  __typename?: 'QueryHistoryConnection';
  edges?: Maybe<Array<Maybe<QueryHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QueryHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<QueryHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<QueryHistorySearch>>;
};

export type QueryHistoryEdge = {
  __typename?: 'QueryHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QueryHistory>;
};

export type QueryHistoryMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  interval?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryHistorySearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  endDate?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  interval?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  startDate?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<QueryHistoryStatusEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export enum QueryHistoryStatusEnum {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  InQueue = 'IN_QUEUE',
  Running = 'RUNNING'
}

export type QueryHistoryStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<QueryHistoryStatusEnum>;
};

export type QuestionnaireAnswerOption = {
  __typename?: 'QuestionnaireAnswerOption';
  active: Scalars['Int']['output'];
  answerTypeId: Scalars['String']['output'];
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  displayLabel: Scalars['String']['output'];
  id: Scalars['String']['output'];
  showsNotes: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireAnswerOptionActivityConnection = {
  __typename?: 'QuestionnaireAnswerOptionActivityConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAnswerOptionActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAnswerOptionActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type QuestionnaireAnswerOptionActivityEdge = {
  __typename?: 'QuestionnaireAnswerOptionActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type QuestionnaireAnswerOptionConnection = {
  __typename?: 'QuestionnaireAnswerOptionConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAnswerOptionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAnswerOptionConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<QuestionnaireAnswerOptionMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<QuestionnaireAnswerOptionSearch>>;
};

export type QuestionnaireAnswerOptionEdge = {
  __typename?: 'QuestionnaireAnswerOptionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QuestionnaireAnswerOption>;
};

export type QuestionnaireAnswerOptionMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  answerTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayLabel?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  showsNotes?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireAnswerOptionSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  answerTypeId?: InputMaybe<Array<StringSearch>>;
  color?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  displayLabel?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  showsNotes?: InputMaybe<Array<IntSearch>>;
  sortOrder?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type QuestionnaireAnswerType = {
  __typename?: 'QuestionnaireAnswerType';
  active: Scalars['Int']['output'];
  allowsNotes: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  notesPlaceholder?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireAnswerTypeActivityConnection = {
  __typename?: 'QuestionnaireAnswerTypeActivityConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAnswerTypeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAnswerTypeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type QuestionnaireAnswerTypeActivityEdge = {
  __typename?: 'QuestionnaireAnswerTypeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type QuestionnaireAnswerTypeConnection = {
  __typename?: 'QuestionnaireAnswerTypeConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAnswerTypeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAnswerTypeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<QuestionnaireAnswerTypeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<QuestionnaireAnswerTypeSearch>>;
};

export type QuestionnaireAnswerTypeEdge = {
  __typename?: 'QuestionnaireAnswerTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QuestionnaireAnswerType>;
};

export type QuestionnaireAnswerTypeMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  allowsNotes?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  notesPlaceholder?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireAnswerTypeSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  allowsNotes?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  displayName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  notesPlaceholder?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type QuestionnaireAttempt = {
  __typename?: 'QuestionnaireAttempt';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  overallResult?: Maybe<QuestionnaireAttemptOverallResultEnum>;
  roleId: Scalars['String']['output'];
  subjectHireDate: Scalars['String']['output'];
  subjectUserId: Scalars['String']['output'];
  submittedAt?: Maybe<Scalars['String']['output']>;
  submittedBy?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireAttemptActivityConnection = {
  __typename?: 'QuestionnaireAttemptActivityConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type QuestionnaireAttemptActivityEdge = {
  __typename?: 'QuestionnaireAttemptActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type QuestionnaireAttemptAnswerOptionSnapshot = {
  __typename?: 'QuestionnaireAttemptAnswerOptionSnapshot';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  displayLabel: Scalars['String']['output'];
  id: Scalars['String']['output'];
  questionnaireAttemptQuestionSnapshotId: Scalars['String']['output'];
  showsNotes: Scalars['Int']['output'];
  sortOrder: Scalars['Int']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireAttemptAnswerOptionSnapshotActivityConnection = {
  __typename?: 'QuestionnaireAttemptAnswerOptionSnapshotActivityConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptAnswerOptionSnapshotActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptAnswerOptionSnapshotActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type QuestionnaireAttemptAnswerOptionSnapshotActivityEdge = {
  __typename?: 'QuestionnaireAttemptAnswerOptionSnapshotActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type QuestionnaireAttemptAnswerOptionSnapshotConnection = {
  __typename?: 'QuestionnaireAttemptAnswerOptionSnapshotConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptAnswerOptionSnapshotEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptAnswerOptionSnapshotConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<QuestionnaireAttemptAnswerOptionSnapshotMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<QuestionnaireAttemptAnswerOptionSnapshotSearch>>;
};

export type QuestionnaireAttemptAnswerOptionSnapshotEdge = {
  __typename?: 'QuestionnaireAttemptAnswerOptionSnapshotEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QuestionnaireAttemptAnswerOptionSnapshot>;
};

export type QuestionnaireAttemptAnswerOptionSnapshotMaskInput = {
  color?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  displayLabel?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireAttemptQuestionSnapshotId?: InputMaybe<Scalars['Boolean']['input']>;
  showsNotes?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireAttemptAnswerOptionSnapshotSearch = {
  color?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  displayLabel?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  questionnaireAttemptQuestionSnapshotId?: InputMaybe<Array<StringSearch>>;
  showsNotes?: InputMaybe<Array<IntSearch>>;
  sortOrder?: InputMaybe<Array<IntSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type QuestionnaireAttemptCategorySnapshot = {
  __typename?: 'QuestionnaireAttemptCategorySnapshot';
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  questionnaireAttemptId: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  submittedAt?: Maybe<Scalars['String']['output']>;
  submittedBy?: Maybe<Scalars['String']['output']>;
  submitterFullName?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireAttemptCategorySnapshotActivityConnection = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotActivityConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptCategorySnapshotActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptCategorySnapshotActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type QuestionnaireAttemptCategorySnapshotActivityEdge = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type QuestionnaireAttemptCategorySnapshotAllowedGroup = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotAllowedGroup';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  questionnaireAttemptCategorySnapshotId: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireAttemptCategorySnapshotAllowedGroupActivityConnection = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotAllowedGroupActivityConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptCategorySnapshotAllowedGroupActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptCategorySnapshotAllowedGroupActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type QuestionnaireAttemptCategorySnapshotAllowedGroupActivityEdge = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotAllowedGroupActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type QuestionnaireAttemptCategorySnapshotAllowedGroupConnection = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotAllowedGroupConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptCategorySnapshotAllowedGroupEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptCategorySnapshotAllowedGroupConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<QuestionnaireAttemptCategorySnapshotAllowedGroupMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<QuestionnaireAttemptCategorySnapshotAllowedGroupSearch>>;
};

export type QuestionnaireAttemptCategorySnapshotAllowedGroupEdge = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotAllowedGroupEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QuestionnaireAttemptCategorySnapshotAllowedGroup>;
};

export type QuestionnaireAttemptCategorySnapshotAllowedGroupMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireAttemptCategorySnapshotId?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireAttemptCategorySnapshotAllowedGroupSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  groupId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  questionnaireAttemptCategorySnapshotId?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type QuestionnaireAttemptCategorySnapshotConnection = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptCategorySnapshotEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptCategorySnapshotConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<QuestionnaireAttemptCategorySnapshotMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<QuestionnaireAttemptCategorySnapshotSearch>>;
};

export type QuestionnaireAttemptCategorySnapshotEdge = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QuestionnaireAttemptCategorySnapshot>;
};

export type QuestionnaireAttemptCategorySnapshotGroup = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotGroup';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  groupId: Scalars['String']['output'];
  groupName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  questionnaireAttemptCategorySnapshotId: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireAttemptCategorySnapshotGroupActivityConnection = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotGroupActivityConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptCategorySnapshotGroupActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptCategorySnapshotGroupActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type QuestionnaireAttemptCategorySnapshotGroupActivityEdge = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotGroupActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type QuestionnaireAttemptCategorySnapshotGroupConnection = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotGroupConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptCategorySnapshotGroupEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptCategorySnapshotGroupConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<QuestionnaireAttemptCategorySnapshotGroupMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<QuestionnaireAttemptCategorySnapshotGroupSearch>>;
};

export type QuestionnaireAttemptCategorySnapshotGroupEdge = {
  __typename?: 'QuestionnaireAttemptCategorySnapshotGroupEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QuestionnaireAttemptCategorySnapshotGroup>;
};

export type QuestionnaireAttemptCategorySnapshotGroupMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['Boolean']['input']>;
  groupName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireAttemptCategorySnapshotId?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireAttemptCategorySnapshotGroupSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  groupId?: InputMaybe<Array<StringSearch>>;
  groupName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  questionnaireAttemptCategorySnapshotId?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type QuestionnaireAttemptCategorySnapshotMaskInput = {
  color?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireAttemptId?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Boolean']['input']>;
  submittedAt?: InputMaybe<Scalars['Boolean']['input']>;
  submittedBy?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireAttemptCategorySnapshotSearch = {
  color?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  questionnaireAttemptId?: InputMaybe<Array<StringSearch>>;
  sortOrder?: InputMaybe<Array<IntSearch>>;
  submittedAt?: InputMaybe<Array<StringSearch>>;
  submittedBy?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type QuestionnaireAttemptConnection = {
  __typename?: 'QuestionnaireAttemptConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<QuestionnaireAttemptMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<QuestionnaireAttemptSearch>>;
};

export type QuestionnaireAttemptEdge = {
  __typename?: 'QuestionnaireAttemptEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QuestionnaireAttempt>;
};

export type QuestionnaireAttemptMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  overallResult?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Boolean']['input']>;
  subjectHireDate?: InputMaybe<Scalars['Boolean']['input']>;
  subjectUserId?: InputMaybe<Scalars['Boolean']['input']>;
  submittedAt?: InputMaybe<Scalars['Boolean']['input']>;
  submittedBy?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireAttemptNote = {
  __typename?: 'QuestionnaireAttemptNote';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  note: Scalars['String']['output'];
  questionnaireAttemptId: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireAttemptNoteActivityConnection = {
  __typename?: 'QuestionnaireAttemptNoteActivityConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptNoteActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptNoteActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type QuestionnaireAttemptNoteActivityEdge = {
  __typename?: 'QuestionnaireAttemptNoteActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type QuestionnaireAttemptNoteConnection = {
  __typename?: 'QuestionnaireAttemptNoteConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptNoteEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptNoteConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<QuestionnaireAttemptNoteMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<QuestionnaireAttemptNoteSearch>>;
};

export type QuestionnaireAttemptNoteEdge = {
  __typename?: 'QuestionnaireAttemptNoteEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QuestionnaireAttemptNote>;
};

export type QuestionnaireAttemptNoteMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  note?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireAttemptId?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireAttemptNoteSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  note?: InputMaybe<Array<StringSearch>>;
  questionnaireAttemptId?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum QuestionnaireAttemptOverallResultEnum {
  Fail = 'FAIL',
  MoreTrainingRequired = 'MORE_TRAINING_REQUIRED',
  Pass = 'PASS'
}

export type QuestionnaireAttemptOverallResultEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<QuestionnaireAttemptOverallResultEnum>;
};

export type QuestionnaireAttemptQuestionSnapshot = {
  __typename?: 'QuestionnaireAttemptQuestionSnapshot';
  answerTypeAllowsNotes: Scalars['Int']['output'];
  answerTypeDisplayName: Scalars['String']['output'];
  answerTypeNotesPlaceholder?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  helperText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  questionText: Scalars['String']['output'];
  questionnaireAttemptCategorySnapshotId: Scalars['String']['output'];
  selectedAnswerNote?: Maybe<Scalars['String']['output']>;
  selectedAnswerOptionId?: Maybe<Scalars['String']['output']>;
  sortOrder: Scalars['Int']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireAttemptQuestionSnapshotActivityConnection = {
  __typename?: 'QuestionnaireAttemptQuestionSnapshotActivityConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptQuestionSnapshotActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptQuestionSnapshotActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type QuestionnaireAttemptQuestionSnapshotActivityEdge = {
  __typename?: 'QuestionnaireAttemptQuestionSnapshotActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type QuestionnaireAttemptQuestionSnapshotConnection = {
  __typename?: 'QuestionnaireAttemptQuestionSnapshotConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireAttemptQuestionSnapshotEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireAttemptQuestionSnapshotConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<QuestionnaireAttemptQuestionSnapshotMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<QuestionnaireAttemptQuestionSnapshotSearch>>;
};

export type QuestionnaireAttemptQuestionSnapshotEdge = {
  __typename?: 'QuestionnaireAttemptQuestionSnapshotEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QuestionnaireAttemptQuestionSnapshot>;
};

export type QuestionnaireAttemptQuestionSnapshotMaskInput = {
  answerTypeAllowsNotes?: InputMaybe<Scalars['Boolean']['input']>;
  answerTypeDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  answerTypeNotesPlaceholder?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  helperText?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  questionText?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireAttemptCategorySnapshotId?: InputMaybe<Scalars['Boolean']['input']>;
  selectedAnswerNote?: InputMaybe<Scalars['Boolean']['input']>;
  selectedAnswerOptionId?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireAttemptQuestionSnapshotSearch = {
  answerTypeAllowsNotes?: InputMaybe<Array<IntSearch>>;
  answerTypeDisplayName?: InputMaybe<Array<StringSearch>>;
  answerTypeNotesPlaceholder?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  helperText?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  questionText?: InputMaybe<Array<StringSearch>>;
  questionnaireAttemptCategorySnapshotId?: InputMaybe<Array<StringSearch>>;
  selectedAnswerNote?: InputMaybe<Array<StringSearch>>;
  selectedAnswerOptionId?: InputMaybe<Array<StringSearch>>;
  sortOrder?: InputMaybe<Array<IntSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type QuestionnaireAttemptSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  overallResult?: InputMaybe<Array<QuestionnaireAttemptOverallResultEnumSearch>>;
  roleId?: InputMaybe<Array<StringSearch>>;
  subjectHireDate?: InputMaybe<Array<StringSearch>>;
  subjectUserId?: InputMaybe<Array<StringSearch>>;
  submittedAt?: InputMaybe<Array<StringSearch>>;
  submittedBy?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type QuestionnaireCategory = {
  __typename?: 'QuestionnaireCategory';
  active: Scalars['Int']['output'];
  answerTypeId?: Maybe<Scalars['String']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  roleId: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireCategoryActivityConnection = {
  __typename?: 'QuestionnaireCategoryActivityConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireCategoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireCategoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type QuestionnaireCategoryActivityEdge = {
  __typename?: 'QuestionnaireCategoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type QuestionnaireCategoryConnection = {
  __typename?: 'QuestionnaireCategoryConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireCategoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireCategoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<QuestionnaireCategoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<QuestionnaireCategorySearch>>;
};

export type QuestionnaireCategoryEdge = {
  __typename?: 'QuestionnaireCategoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QuestionnaireCategory>;
};

export type QuestionnaireCategoryGroup = {
  __typename?: 'QuestionnaireCategoryGroup';
  active: Scalars['Int']['output'];
  groupId: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type QuestionnaireCategoryGroups = {
  __typename?: 'QuestionnaireCategoryGroups';
  groups: Array<QuestionnaireCategoryGroup>;
  questionnaireCategoryId: Scalars['String']['output'];
};

export type QuestionnaireCategoryGroupsInput = {
  questionnaireCategoryIds: Array<Scalars['String']['input']>;
};

export type QuestionnaireCategoryMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  answerTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  color?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  description?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireCategorySearch = {
  active?: InputMaybe<Array<IntSearch>>;
  answerTypeId?: InputMaybe<Array<StringSearch>>;
  color?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  description?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  roleId?: InputMaybe<Array<StringSearch>>;
  sortOrder?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type QuestionnaireCategoryWithGroups = {
  __typename?: 'QuestionnaireCategoryWithGroups';
  category: QuestionnaireCategory;
  groups: Array<QuestionnaireCategoryGroup>;
};

export type QuestionnaireQuestion = {
  __typename?: 'QuestionnaireQuestion';
  active: Scalars['Int']['output'];
  answerTypeId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  helperText?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  questionText: Scalars['String']['output'];
  questionnaireCategoryId: Scalars['String']['output'];
  sortOrder: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type QuestionnaireQuestionActivityConnection = {
  __typename?: 'QuestionnaireQuestionActivityConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireQuestionActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireQuestionActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type QuestionnaireQuestionActivityEdge = {
  __typename?: 'QuestionnaireQuestionActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type QuestionnaireQuestionConnection = {
  __typename?: 'QuestionnaireQuestionConnection';
  edges?: Maybe<Array<Maybe<QuestionnaireQuestionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type QuestionnaireQuestionConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<QuestionnaireQuestionMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<QuestionnaireQuestionSearch>>;
};

export type QuestionnaireQuestionEdge = {
  __typename?: 'QuestionnaireQuestionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<QuestionnaireQuestion>;
};

export type QuestionnaireQuestionMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  answerTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  helperText?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  questionText?: InputMaybe<Scalars['Boolean']['input']>;
  questionnaireCategoryId?: InputMaybe<Scalars['Boolean']['input']>;
  sortOrder?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QuestionnaireQuestionSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  answerTypeId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  helperText?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  questionText?: InputMaybe<Array<StringSearch>>;
  questionnaireCategoryId?: InputMaybe<Array<StringSearch>>;
  sortOrder?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type Rate = {
  __typename?: 'Rate';
  airportCode?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  contractEndDatetime?: Maybe<Scalars['String']['output']>;
  contractId?: Maybe<Scalars['String']['output']>;
  contractStartDatetime?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: RateCurrencyEnum;
  duration?: Maybe<Scalars['Int']['output']>;
  endDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  notes: Scalars['String']['output'];
  payerProvider?: Maybe<Provider>;
  payerProviderId?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['String']['output']>;
  radius: Scalars['Int']['output'];
  rate: Scalars['Float']['output'];
  rateGroupId?: Maybe<Scalars['String']['output']>;
  rateItemId?: Maybe<Scalars['String']['output']>;
  startDatetime?: Maybe<Scalars['String']['output']>;
  thatLocation?: Maybe<Location>;
  thatLocationId: Scalars['String']['output'];
  thisLocation?: Maybe<Location>;
  thisLocationId: Scalars['String']['output'];
  tripDistance?: Maybe<Scalars['Int']['output']>;
  type: RateTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RateActivityConnection = {
  __typename?: 'RateActivityConnection';
  edges?: Maybe<Array<Maybe<RateActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RateActivityEdge = {
  __typename?: 'RateActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RateConnection = {
  __typename?: 'RateConnection';
  edges?: Maybe<Array<Maybe<RateEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RateMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RateSearch>>;
};

export enum RateCurrencyEnum {
  Usd = 'USD'
}

export type RateCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<RateCurrencyEnum>;
};

export type RateEdge = {
  __typename?: 'RateEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Rate>;
};

export type RateGroup = {
  __typename?: 'RateGroup';
  airportCode?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  duration?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  items?: Maybe<Array<RateItem>>;
  payerProvider?: Maybe<Provider>;
  payerProviderId?: Maybe<Scalars['String']['output']>;
  thatLocation?: Maybe<Location>;
  thatLocationId: Scalars['String']['output'];
  thisLocation?: Maybe<Location>;
  thisLocationId: Scalars['String']['output'];
  tripDistance?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RateGroupActivityConnection = {
  __typename?: 'RateGroupActivityConnection';
  edges?: Maybe<Array<Maybe<RateGroupActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateGroupActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RateGroupActivityEdge = {
  __typename?: 'RateGroupActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RateGroupConnection = {
  __typename?: 'RateGroupConnection';
  edges?: Maybe<Array<Maybe<RateGroupEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateGroupConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RateGroupMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RateGroupSearch>>;
};

export type RateGroupEdge = {
  __typename?: 'RateGroupEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RateGroup>;
};

export type RateGroupMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  thatLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  thisLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  tripDistance?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateGroupSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  duration?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  thatLocationId?: InputMaybe<Array<StringSearch>>;
  thisLocationId?: InputMaybe<Array<StringSearch>>;
  tripDistance?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type RateGroupWithLatestRateHistory = {
  __typename?: 'RateGroupWithLatestRateHistory';
  companyId: Scalars['String']['output'];
  payerProviderId?: Maybe<Scalars['String']['output']>;
  rate: Scalars['Float']['output'];
  rateGroupId: Scalars['String']['output'];
  rateHistoryId: Scalars['String']['output'];
  rateItemCurrency: RateGroupWithLatestRateHistoryRateItemCurrencyEnum;
  rateItemEndDatetime?: Maybe<Scalars['String']['output']>;
  rateItemId: Scalars['String']['output'];
  rateItemStartDatetime: Scalars['String']['output'];
  rateItemType: RateGroupWithLatestRateHistoryRateItemTypeEnum;
  thatLocationId: Scalars['String']['output'];
  thisLocationId: Scalars['String']['output'];
};

export type RateGroupWithLatestRateHistoryActivityConnection = {
  __typename?: 'RateGroupWithLatestRateHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<RateGroupWithLatestRateHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateGroupWithLatestRateHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RateGroupWithLatestRateHistoryActivityEdge = {
  __typename?: 'RateGroupWithLatestRateHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RateGroupWithLatestRateHistoryConnection = {
  __typename?: 'RateGroupWithLatestRateHistoryConnection';
  edges?: Maybe<Array<Maybe<RateGroupWithLatestRateHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateGroupWithLatestRateHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RateGroupWithLatestRateHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RateGroupWithLatestRateHistorySearch>>;
};

export type RateGroupWithLatestRateHistoryEdge = {
  __typename?: 'RateGroupWithLatestRateHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RateGroupWithLatestRateHistory>;
};

export type RateGroupWithLatestRateHistoryMaskInput = {
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
  rateGroupId?: InputMaybe<Scalars['Boolean']['input']>;
  rateHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  rateItemCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  rateItemEndDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  rateItemId?: InputMaybe<Scalars['Boolean']['input']>;
  rateItemStartDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  rateItemType?: InputMaybe<Scalars['Boolean']['input']>;
  thatLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  thisLocationId?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum RateGroupWithLatestRateHistoryRateItemCurrencyEnum {
  Usd = 'USD'
}

export type RateGroupWithLatestRateHistoryRateItemCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<RateGroupWithLatestRateHistoryRateItemCurrencyEnum>;
};

export enum RateGroupWithLatestRateHistoryRateItemTypeEnum {
  Contract = 'CONTRACT',
  NonContract = 'NON_CONTRACT'
}

export type RateGroupWithLatestRateHistoryRateItemTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<RateGroupWithLatestRateHistoryRateItemTypeEnum>;
};

export type RateGroupWithLatestRateHistorySearch = {
  companyId?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  rate?: InputMaybe<Array<FloatSearch>>;
  rateGroupId?: InputMaybe<Array<StringSearch>>;
  rateHistoryId?: InputMaybe<Array<StringSearch>>;
  rateItemCurrency?: InputMaybe<Array<RateGroupWithLatestRateHistoryRateItemCurrencyEnumSearch>>;
  rateItemEndDatetime?: InputMaybe<Array<StringSearch>>;
  rateItemId?: InputMaybe<Array<StringSearch>>;
  rateItemStartDatetime?: InputMaybe<Array<StringSearch>>;
  rateItemType?: InputMaybe<Array<RateGroupWithLatestRateHistoryRateItemTypeEnumSearch>>;
  thatLocationId?: InputMaybe<Array<StringSearch>>;
  thisLocationId?: InputMaybe<Array<StringSearch>>;
};

export type RateHistory = {
  __typename?: 'RateHistory';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: RateHistoryCurrencyEnum;
  endDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  message?: Maybe<Scalars['String']['output']>;
  rate: Scalars['Float']['output'];
  rateGroupId: Scalars['String']['output'];
  rateItemId?: Maybe<Scalars['String']['output']>;
  startDatetime?: Maybe<Scalars['String']['output']>;
  type: RateHistoryTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RateHistoryActivityConnection = {
  __typename?: 'RateHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<RateHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RateHistoryActivityEdge = {
  __typename?: 'RateHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RateHistoryConnection = {
  __typename?: 'RateHistoryConnection';
  edges?: Maybe<Array<Maybe<RateHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RateHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RateHistorySearch>>;
};

export enum RateHistoryCurrencyEnum {
  Usd = 'USD'
}

export type RateHistoryCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<RateHistoryCurrencyEnum>;
};

export type RateHistoryEdge = {
  __typename?: 'RateHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RateHistory>;
};

export type RateHistoryMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
  rateGroupId?: InputMaybe<Scalars['Boolean']['input']>;
  rateItemId?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateHistorySearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  currency?: InputMaybe<Array<RateHistoryCurrencyEnumSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  rate?: InputMaybe<Array<FloatSearch>>;
  rateGroupId?: InputMaybe<Array<StringSearch>>;
  rateItemId?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<RateHistoryTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum RateHistoryTypeEnum {
  Adhoc = 'ADHOC',
  Contract = 'CONTRACT',
  NonContract = 'NON_CONTRACT',
  Override = 'OVERRIDE'
}

export type RateHistoryTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<RateHistoryTypeEnum>;
};

export type RateHistoryWithRateGroup = {
  __typename?: 'RateHistoryWithRateGroup';
  airportCode?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: RateHistoryWithRateGroupCurrencyEnum;
  duration?: Maybe<Scalars['Int']['output']>;
  endDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  payerProviderId?: Maybe<Scalars['String']['output']>;
  rate: Scalars['Float']['output'];
  rateGroupId: Scalars['String']['output'];
  rateItemId?: Maybe<Scalars['String']['output']>;
  startDatetime?: Maybe<Scalars['String']['output']>;
  thatLocationId: Scalars['String']['output'];
  thisLocationId: Scalars['String']['output'];
  tripDistance?: Maybe<Scalars['Int']['output']>;
  type: RateHistoryWithRateGroupTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RateHistoryWithRateGroupActivityConnection = {
  __typename?: 'RateHistoryWithRateGroupActivityConnection';
  edges?: Maybe<Array<Maybe<RateHistoryWithRateGroupActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateHistoryWithRateGroupActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RateHistoryWithRateGroupActivityEdge = {
  __typename?: 'RateHistoryWithRateGroupActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RateHistoryWithRateGroupConnection = {
  __typename?: 'RateHistoryWithRateGroupConnection';
  edges?: Maybe<Array<Maybe<RateHistoryWithRateGroupEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateHistoryWithRateGroupConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RateHistoryWithRateGroupMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RateHistoryWithRateGroupSearch>>;
};

export enum RateHistoryWithRateGroupCurrencyEnum {
  Usd = 'USD'
}

export type RateHistoryWithRateGroupCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<RateHistoryWithRateGroupCurrencyEnum>;
};

export type RateHistoryWithRateGroupEdge = {
  __typename?: 'RateHistoryWithRateGroupEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RateHistoryWithRateGroup>;
};

export type RateHistoryWithRateGroupMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
  rateGroupId?: InputMaybe<Scalars['Boolean']['input']>;
  rateItemId?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  thatLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  thisLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  tripDistance?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateHistoryWithRateGroupSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  currency?: InputMaybe<Array<RateHistoryWithRateGroupCurrencyEnumSearch>>;
  duration?: InputMaybe<Array<IntSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  rate?: InputMaybe<Array<FloatSearch>>;
  rateGroupId?: InputMaybe<Array<StringSearch>>;
  rateItemId?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  thatLocationId?: InputMaybe<Array<StringSearch>>;
  thisLocationId?: InputMaybe<Array<StringSearch>>;
  tripDistance?: InputMaybe<Array<IntSearch>>;
  type?: InputMaybe<Array<RateHistoryWithRateGroupTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum RateHistoryWithRateGroupTypeEnum {
  Adhoc = 'ADHOC',
  Contract = 'CONTRACT',
  NonContract = 'NON_CONTRACT',
  Override = 'OVERRIDE'
}

export type RateHistoryWithRateGroupTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<RateHistoryWithRateGroupTypeEnum>;
};

export type RateItem = {
  __typename?: 'RateItem';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: RateItemCurrencyEnum;
  endDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  rate?: Maybe<Scalars['Float']['output']>;
  rateGroupId: Scalars['String']['output'];
  startDatetime: Scalars['String']['output'];
  type: RateItemTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RateItemActivityConnection = {
  __typename?: 'RateItemActivityConnection';
  edges?: Maybe<Array<Maybe<RateItemActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateItemActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RateItemActivityEdge = {
  __typename?: 'RateItemActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RateItemConnection = {
  __typename?: 'RateItemConnection';
  edges?: Maybe<Array<Maybe<RateItemEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateItemConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RateItemMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RateItemSearch>>;
};

export enum RateItemCurrencyEnum {
  Usd = 'USD'
}

export type RateItemCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<RateItemCurrencyEnum>;
};

export type RateItemEdge = {
  __typename?: 'RateItemEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RateItem>;
};

export type RateItemMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  rateGroupId?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateItemSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  currency?: InputMaybe<Array<RateItemCurrencyEnumSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  rateGroupId?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<RateItemTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum RateItemTypeEnum {
  Contract = 'CONTRACT',
  NonContract = 'NON_CONTRACT'
}

export type RateItemTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<RateItemTypeEnum>;
};

export type RateItemWithLatestRateHistory = {
  __typename?: 'RateItemWithLatestRateHistory';
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currency: RateItemWithLatestRateHistoryCurrencyEnum;
  endDatetime?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  payerProviderId?: Maybe<Scalars['String']['output']>;
  rate: Scalars['Float']['output'];
  rateGroupId: Scalars['String']['output'];
  rateHistoryId: Scalars['String']['output'];
  startDatetime: Scalars['String']['output'];
  thatLocationId: Scalars['String']['output'];
  thisLocationId: Scalars['String']['output'];
  type: RateItemWithLatestRateHistoryTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RateItemWithLatestRateHistoryActivityConnection = {
  __typename?: 'RateItemWithLatestRateHistoryActivityConnection';
  edges?: Maybe<Array<Maybe<RateItemWithLatestRateHistoryActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateItemWithLatestRateHistoryActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RateItemWithLatestRateHistoryActivityEdge = {
  __typename?: 'RateItemWithLatestRateHistoryActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RateItemWithLatestRateHistoryConnection = {
  __typename?: 'RateItemWithLatestRateHistoryConnection';
  edges?: Maybe<Array<Maybe<RateItemWithLatestRateHistoryEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RateItemWithLatestRateHistoryConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RateItemWithLatestRateHistoryMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RateItemWithLatestRateHistorySearch>>;
};

export enum RateItemWithLatestRateHistoryCurrencyEnum {
  Usd = 'USD'
}

export type RateItemWithLatestRateHistoryCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<RateItemWithLatestRateHistoryCurrencyEnum>;
};

export type RateItemWithLatestRateHistoryEdge = {
  __typename?: 'RateItemWithLatestRateHistoryEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RateItemWithLatestRateHistory>;
};

export type RateItemWithLatestRateHistoryMaskInput = {
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
  rateGroupId?: InputMaybe<Scalars['Boolean']['input']>;
  rateHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  thatLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  thisLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateItemWithLatestRateHistorySearch = {
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  currency?: InputMaybe<Array<RateItemWithLatestRateHistoryCurrencyEnumSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  rate?: InputMaybe<Array<FloatSearch>>;
  rateGroupId?: InputMaybe<Array<StringSearch>>;
  rateHistoryId?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  thatLocationId?: InputMaybe<Array<StringSearch>>;
  thisLocationId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<RateItemWithLatestRateHistoryTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum RateItemWithLatestRateHistoryTypeEnum {
  Contract = 'CONTRACT',
  NonContract = 'NON_CONTRACT'
}

export type RateItemWithLatestRateHistoryTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<RateItemWithLatestRateHistoryTypeEnum>;
};

export type RateMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  contractEndDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  contractStartDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  duration?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  radius?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  thatLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  thisLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  tripDistance?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RateSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  contractEndDatetime?: InputMaybe<Array<StringSearch>>;
  contractId?: InputMaybe<Array<StringSearch>>;
  contractStartDatetime?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  currency?: InputMaybe<Array<RateCurrencyEnumSearch>>;
  duration?: InputMaybe<Array<IntSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  notes?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  radius?: InputMaybe<Array<IntSearch>>;
  rate?: InputMaybe<Array<FloatSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  thatLocationId?: InputMaybe<Array<StringSearch>>;
  thisLocationId?: InputMaybe<Array<StringSearch>>;
  tripDistance?: InputMaybe<Array<IntSearch>>;
  type?: InputMaybe<Array<RateTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum RateTableConnectionFormatEnum {
  Adhoc = 'ADHOC',
  Contract = 'CONTRACT',
  Current = 'CURRENT',
  NonContract = 'NON_CONTRACT'
}

export type RateTableConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<LatestRateMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  format: RateTableConnectionFormatEnum;
  query?: InputMaybe<Array<LatestRateSearch>>;
};

export enum RateTypeEnum {
  Adhoc = 'ADHOC',
  Contract = 'CONTRACT',
  NonContract = 'NON_CONTRACT',
  Override = 'OVERRIDE'
}

export type RateTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<RateTypeEnum>;
};

export type RateValueInput = {
  currency: RateHistoryCurrencyEnum;
};

export type RateValueResponse = {
  __typename?: 'RateValueResponse';
  rates?: Maybe<Array<FilterOption>>;
};

export type Rating = Node & {
  __typename?: 'Rating';
  comment?: Maybe<Scalars['String']['output']>;
  compliments?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  rating: Scalars['Int']['output'];
  ratingScore?: Maybe<Scalars['Float']['output']>;
  ratingType?: Maybe<RatingType>;
  ratingTypeId: Scalars['String']['output'];
  tripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type RatingActivityConnection = {
  __typename?: 'RatingActivityConnection';
  edges?: Maybe<Array<Maybe<RatingActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RatingActivityEdge = {
  __typename?: 'RatingActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RatingCache = {
  __typename?: 'RatingCache';
  airportCode?: Maybe<Scalars['String']['output']>;
  airportGroupName?: Maybe<Scalars['String']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  companyId?: Maybe<Scalars['String']['output']>;
  companyName?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  kind?: Maybe<Scalars['String']['output']>;
  payerProviderId?: Maybe<Scalars['String']['output']>;
  payerProviderName?: Maybe<Scalars['String']['output']>;
  rating: Scalars['Int']['output'];
  ratingCreatedAt: Scalars['String']['output'];
  ratingScore?: Maybe<Scalars['Float']['output']>;
  ratingTypeName?: Maybe<Scalars['String']['output']>;
  servicerIataAirlineCode?: Maybe<Scalars['String']['output']>;
  tripId: Scalars['String']['output'];
  tripScheduled?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type RatingCacheActivityConnection = {
  __typename?: 'RatingCacheActivityConnection';
  edges?: Maybe<Array<Maybe<RatingCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RatingCacheActivityEdge = {
  __typename?: 'RatingCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RatingCacheConnection = {
  __typename?: 'RatingCacheConnection';
  edges?: Maybe<Array<Maybe<RatingCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RatingCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RatingCacheSearch>>;
};

export type RatingCacheEdge = {
  __typename?: 'RatingCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RatingCache>;
};

export type RatingCacheMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  airportGroupName?: InputMaybe<Scalars['Boolean']['input']>;
  comment?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  companyName?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  driverName?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderName?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Boolean']['input']>;
  ratingCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  ratingScore?: InputMaybe<Scalars['Boolean']['input']>;
  ratingTypeName?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  tripScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RatingCacheRemark = {
  __typename?: 'RatingCacheRemark';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  ratingCacheId: Scalars['String']['output'];
  remark: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RatingCacheRemarkActivityConnection = {
  __typename?: 'RatingCacheRemarkActivityConnection';
  edges?: Maybe<Array<Maybe<RatingCacheRemarkActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingCacheRemarkActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RatingCacheRemarkActivityEdge = {
  __typename?: 'RatingCacheRemarkActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RatingCacheRemarkConnection = {
  __typename?: 'RatingCacheRemarkConnection';
  edges?: Maybe<Array<Maybe<RatingCacheRemarkEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingCacheRemarkConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RatingCacheRemarkMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RatingCacheRemarkSearch>>;
};

export type RatingCacheRemarkEdge = {
  __typename?: 'RatingCacheRemarkEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RatingCacheRemark>;
};

export type RatingCacheRemarkMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  ratingCacheId?: InputMaybe<Scalars['Boolean']['input']>;
  remark?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RatingCacheRemarkSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  ratingCacheId?: InputMaybe<Array<StringSearch>>;
  remark?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type RatingCacheSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  airportGroupName?: InputMaybe<Array<StringSearch>>;
  comment?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  companyName?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  driverName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  kind?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  payerProviderName?: InputMaybe<Array<StringSearch>>;
  rating?: InputMaybe<Array<IntSearch>>;
  ratingCreatedAt?: InputMaybe<Array<StringSearch>>;
  ratingScore?: InputMaybe<Array<FloatSearch>>;
  ratingTypeName?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  tripScheduled?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type RatingConnection = {
  __typename?: 'RatingConnection';
  edges?: Maybe<Array<Maybe<RatingEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RatingMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RatingSearch>>;
};

export type RatingDetails = {
  __typename?: 'RatingDetails';
  averageRating: Scalars['Float']['output'];
  rating?: Maybe<Array<Rating>>;
};

export type RatingEdge = {
  __typename?: 'RatingEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Rating>;
};

export type RatingMaskInput = {
  comment?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Boolean']['input']>;
  ratingScore?: InputMaybe<Scalars['Boolean']['input']>;
  ratingTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RatingRemark = {
  __typename?: 'RatingRemark';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  ratingId: Scalars['String']['output'];
  remark: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RatingRemarkActivityConnection = {
  __typename?: 'RatingRemarkActivityConnection';
  edges?: Maybe<Array<Maybe<RatingRemarkActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingRemarkActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RatingRemarkActivityEdge = {
  __typename?: 'RatingRemarkActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RatingRemarkConnection = {
  __typename?: 'RatingRemarkConnection';
  edges?: Maybe<Array<Maybe<RatingRemarkEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingRemarkConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RatingRemarkMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RatingRemarkSearch>>;
};

export type RatingRemarkEdge = {
  __typename?: 'RatingRemarkEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RatingRemark>;
};

export type RatingRemarkMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  ratingId?: InputMaybe<Scalars['Boolean']['input']>;
  remark?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RatingRemarkSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  ratingId?: InputMaybe<Array<StringSearch>>;
  remark?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type RatingRemarksWithRating = {
  __typename?: 'RatingRemarksWithRating';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  ratingComment?: Maybe<Scalars['String']['output']>;
  ratingCreatedAt?: Maybe<Scalars['String']['output']>;
  ratingCreatedBy?: Maybe<Scalars['String']['output']>;
  ratingId: Scalars['String']['output'];
  ratingRating: Scalars['Int']['output'];
  ratingTripId: Scalars['String']['output'];
  ratingTypeCreatedAt?: Maybe<Scalars['String']['output']>;
  ratingTypeCreatedBy?: Maybe<Scalars['String']['output']>;
  ratingTypeId: Scalars['String']['output'];
  ratingTypeName: Scalars['String']['output'];
  ratingTypeUpdatedAt?: Maybe<Scalars['String']['output']>;
  ratingTypeUpdatedBy?: Maybe<Scalars['String']['output']>;
  ratingUpdatedAt?: Maybe<Scalars['String']['output']>;
  ratingUpdatedBy?: Maybe<Scalars['String']['output']>;
  ratingUserId: Scalars['String']['output'];
  remark: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RatingRemarksWithRatingActivityConnection = {
  __typename?: 'RatingRemarksWithRatingActivityConnection';
  edges?: Maybe<Array<Maybe<RatingRemarksWithRatingActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingRemarksWithRatingActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RatingRemarksWithRatingActivityEdge = {
  __typename?: 'RatingRemarksWithRatingActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RatingRemarksWithRatingConnection = {
  __typename?: 'RatingRemarksWithRatingConnection';
  edges?: Maybe<Array<Maybe<RatingRemarksWithRatingEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingRemarksWithRatingConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RatingRemarksWithRatingMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RatingRemarksWithRatingSearch>>;
};

export type RatingRemarksWithRatingEdge = {
  __typename?: 'RatingRemarksWithRatingEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RatingRemarksWithRating>;
};

export type RatingRemarksWithRatingMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  ratingComment?: InputMaybe<Scalars['Boolean']['input']>;
  ratingCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  ratingCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  ratingId?: InputMaybe<Scalars['Boolean']['input']>;
  ratingRating?: InputMaybe<Scalars['Boolean']['input']>;
  ratingTripId?: InputMaybe<Scalars['Boolean']['input']>;
  ratingTypeCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  ratingTypeCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  ratingTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  ratingTypeName?: InputMaybe<Scalars['Boolean']['input']>;
  ratingTypeUpdatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  ratingTypeUpdatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  ratingUpdatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  ratingUpdatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  ratingUserId?: InputMaybe<Scalars['Boolean']['input']>;
  remark?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RatingRemarksWithRatingSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  ratingComment?: InputMaybe<Array<StringSearch>>;
  ratingCreatedAt?: InputMaybe<Array<StringSearch>>;
  ratingCreatedBy?: InputMaybe<Array<StringSearch>>;
  ratingId?: InputMaybe<Array<StringSearch>>;
  ratingRating?: InputMaybe<Array<IntSearch>>;
  ratingTripId?: InputMaybe<Array<StringSearch>>;
  ratingTypeCreatedAt?: InputMaybe<Array<StringSearch>>;
  ratingTypeCreatedBy?: InputMaybe<Array<StringSearch>>;
  ratingTypeId?: InputMaybe<Array<StringSearch>>;
  ratingTypeName?: InputMaybe<Array<StringSearch>>;
  ratingTypeUpdatedAt?: InputMaybe<Array<StringSearch>>;
  ratingTypeUpdatedBy?: InputMaybe<Array<StringSearch>>;
  ratingUpdatedAt?: InputMaybe<Array<StringSearch>>;
  ratingUpdatedBy?: InputMaybe<Array<StringSearch>>;
  ratingUserId?: InputMaybe<Array<StringSearch>>;
  remark?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type RatingSearch = {
  comment?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  rating?: InputMaybe<Array<IntSearch>>;
  ratingScore?: InputMaybe<Array<FloatSearch>>;
  ratingTypeId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type RatingType = {
  __typename?: 'RatingType';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RatingTypeActivityConnection = {
  __typename?: 'RatingTypeActivityConnection';
  edges?: Maybe<Array<Maybe<RatingTypeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingTypeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RatingTypeActivityEdge = {
  __typename?: 'RatingTypeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RatingTypeConnection = {
  __typename?: 'RatingTypeConnection';
  edges?: Maybe<Array<Maybe<RatingTypeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingTypeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RatingTypeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RatingTypeSearch>>;
};

export type RatingTypeEdge = {
  __typename?: 'RatingTypeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RatingType>;
};

export type RatingTypeMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RatingTypeSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type RatingWithRemarks = {
  __typename?: 'RatingWithRemarks';
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  rating: Scalars['Int']['output'];
  ratingRemarkId: Scalars['String']['output'];
  ratingRemarkRemark: Scalars['String']['output'];
  ratingTypeName: Scalars['String']['output'];
  tripId: Scalars['String']['output'];
  typeId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type RatingWithRemarksActivityConnection = {
  __typename?: 'RatingWithRemarksActivityConnection';
  edges?: Maybe<Array<Maybe<RatingWithRemarksActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingWithRemarksActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RatingWithRemarksActivityEdge = {
  __typename?: 'RatingWithRemarksActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RatingWithRemarksConnection = {
  __typename?: 'RatingWithRemarksConnection';
  edges?: Maybe<Array<Maybe<RatingWithRemarksEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RatingWithRemarksConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RatingWithRemarksMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RatingWithRemarksSearch>>;
};

export type RatingWithRemarksEdge = {
  __typename?: 'RatingWithRemarksEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RatingWithRemarks>;
};

export type RatingWithRemarksMaskInput = {
  comment?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  rating?: InputMaybe<Scalars['Boolean']['input']>;
  ratingRemarkId?: InputMaybe<Scalars['Boolean']['input']>;
  ratingRemarkRemark?: InputMaybe<Scalars['Boolean']['input']>;
  ratingTypeName?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  typeId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RatingWithRemarksSearch = {
  comment?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  rating?: InputMaybe<Array<IntSearch>>;
  ratingRemarkId?: InputMaybe<Array<StringSearch>>;
  ratingRemarkRemark?: InputMaybe<Array<StringSearch>>;
  ratingTypeName?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  typeId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type RatingsAndReviewNode = {
  __typename?: 'RatingsAndReviewNode';
  amountOfStars?: Maybe<Scalars['Int']['output']>;
  datetime?: Maybe<Scalars['String']['output']>;
  flightNumber?: Maybe<Scalars['Int']['output']>;
  ratingId?: Maybe<Scalars['String']['output']>;
  servicerIataAirlineCode?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  tripId: Scalars['ID']['output'];
};

export type RatingsAndReviewsDriverAppInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  airportCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  amountOfStars?: InputMaybe<Scalars['Int']['input']>;
  driverId?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  startDatetime?: InputMaybe<Scalars['String']['input']>;
};

export type RatingsAndReviewsDriverAppResponse = {
  __typename?: 'RatingsAndReviewsDriverAppResponse';
  ratings?: Maybe<RatingsAndReviewsRatings>;
  remarks?: Maybe<Array<RatingsAndReviewsRemarks>>;
  reviews?: Maybe<RatingsAndReviewsReviewsConnection>;
};

export type RatingsAndReviewsEdge = {
  __typename?: 'RatingsAndReviewsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RatingsAndReviewNode>;
};

export type RatingsAndReviewsRatings = {
  __typename?: 'RatingsAndReviewsRatings';
  average?: Maybe<Scalars['Float']['output']>;
  fiveStar?: Maybe<Scalars['Int']['output']>;
  fourStar?: Maybe<Scalars['Int']['output']>;
  oneStar?: Maybe<Scalars['Int']['output']>;
  threeStar?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  twoStar?: Maybe<Scalars['Int']['output']>;
};

export type RatingsAndReviewsRemarks = {
  __typename?: 'RatingsAndReviewsRemarks';
  remark: Scalars['String']['output'];
  totalCount: Scalars['Int']['output'];
};

export type RatingsAndReviewsReviewsConnection = {
  __typename?: 'RatingsAndReviewsReviewsConnection';
  edges?: Maybe<Array<Maybe<RatingsAndReviewsEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type Remark = Node & {
  __typename?: 'Remark';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  message?: Maybe<Scalars['String']['output']>;
  tripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RemarkInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Scalars['String']['input']>;
};

export type RemarkResponse = {
  __typename?: 'RemarkResponse';
  error?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Remark>;
};

export type ReportData = {
  __typename?: 'ReportData';
  filters?: Maybe<Array<FilterObject>>;
  header?: Maybe<Array<KeyValue>>;
  tables?: Maybe<Array<Table>>;
};

export enum ReportFilterEnum {
  Default = 'DEFAULT',
  HasCompletion = 'HAS_COMPLETION',
  HasNoDriver = 'HAS_NO_DRIVER',
  IllegalCombine = 'ILLEGAL_COMBINE',
  Late = 'LATE',
  LegalCombine = 'LEGAL_COMBINE',
  ZeroRate = 'ZERO_RATE'
}

export type ReportFilters = {
  __typename?: 'ReportFilters';
  airlines?: Maybe<Array<Scalars['String']['output']>>;
  airports?: Maybe<Array<Scalars['String']['output']>>;
  buckets?: Maybe<Array<TimeIntervalBucketFilter>>;
  charities?: Maybe<Array<Scalars['String']['output']>>;
  clients?: Maybe<Array<Scalars['String']['output']>>;
  companies?: Maybe<Array<Scalars['String']['output']>>;
  completionTypes?: Maybe<Array<Scalars['String']['output']>>;
  complexFilters?: Maybe<Array<ReportFilterEnum>>;
  csvColumns?: Maybe<Array<ColumnObjectFilter>>;
  currencies?: Maybe<Array<Scalars['String']['output']>>;
  doLocations?: Maybe<Array<Scalars['String']['output']>>;
  drivers?: Maybe<Array<Scalars['String']['output']>>;
  endDatetime?: Maybe<Scalars['String']['output']>;
  fcrReportedBy?: Maybe<Array<Scalars['String']['output']>>;
  groupBy?: Maybe<Scalars['String']['output']>;
  kinds?: Maybe<Array<Scalars['String']['output']>>;
  puLocations?: Maybe<Array<Scalars['String']['output']>>;
  rateTypes?: Maybe<Array<Scalars['String']['output']>>;
  rates?: Maybe<Array<Scalars['String']['output']>>;
  rating?: Maybe<Array<Scalars['String']['output']>>;
  reason?: Maybe<Array<ReportReasonEnum>>;
  reportType?: Maybe<ReportTypeEnum>;
  roleIds?: Maybe<Array<Scalars['String']['output']>>;
  series?: Maybe<ReportSeriesEnum>;
  startDatetime?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Array<Scalars['String']['output']>>;
  thresholds?: Maybe<Array<Scalars['String']['output']>>;
  types?: Maybe<Array<Scalars['String']['output']>>;
};

export enum ReportGroupByEnum {
  Airline = 'AIRLINE',
  City = 'CITY',
  Client = 'CLIENT',
  Date = 'DATE',
  Driver = 'DRIVER',
  Market = 'MARKET',
  Status = 'STATUS',
  Type = 'TYPE',
  Vehicle = 'VEHICLE'
}

export type ReportImportProblemInput = {
  capturedAt?: InputMaybe<Scalars['String']['input']>;
  errors: Scalars['String']['input'];
  importId: Scalars['ID']['input'];
  importType: ImportTypeEnum;
  message: Scalars['String']['input'];
  responses: Scalars['String']['input'];
  screenshot?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userAgent?: InputMaybe<Scalars['String']['input']>;
};

export type ReportImportProblemResponse = {
  __typename?: 'ReportImportProblemResponse';
  error?: Maybe<Error>;
  message: Scalars['String']['output'];
};

export type ReportInput = {
  airlines?: InputMaybe<Array<Scalars['String']['input']>>;
  airports?: InputMaybe<Array<Scalars['String']['input']>>;
  buckets?: InputMaybe<Array<TimeIntervalBucket>>;
  charities?: InputMaybe<Array<Scalars['String']['input']>>;
  clients?: InputMaybe<Array<Scalars['String']['input']>>;
  companies?: InputMaybe<Array<Scalars['String']['input']>>;
  completionTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  complexFilters?: InputMaybe<Array<ReportFilterEnum>>;
  csvColumns?: InputMaybe<Array<ColumnObject>>;
  currencies?: InputMaybe<Array<Scalars['String']['input']>>;
  details?: InputMaybe<Array<RowDetailsInput>>;
  doLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  drivers?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  fcrReportedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  groupBy?: InputMaybe<Scalars['String']['input']>;
  groupByList?: InputMaybe<Array<Scalars['String']['input']>>;
  kinds?: InputMaybe<Array<Scalars['String']['input']>>;
  puLocations?: InputMaybe<Array<Scalars['String']['input']>>;
  rateTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  rates?: InputMaybe<Array<Scalars['String']['input']>>;
  rating?: InputMaybe<Array<Scalars['String']['input']>>;
  reason?: InputMaybe<Array<ReportReasonEnum>>;
  reportType?: InputMaybe<ReportTypeEnum>;
  roleIds?: InputMaybe<Array<Scalars['String']['input']>>;
  series?: InputMaybe<ReportSeriesEnum>;
  snapshotIds?: InputMaybe<Array<Scalars['String']['input']>>;
  startDatetime?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  thresholds?: InputMaybe<Array<Scalars['String']['input']>>;
  types?: InputMaybe<Array<Scalars['String']['input']>>;
  userSessionTimezone?: InputMaybe<Scalars['String']['input']>;
};

export type ReportProblemCrewInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
};

export type ReportProblemCrewResponse = {
  __typename?: 'ReportProblemCrewResponse';
  error?: Maybe<Error>;
  message: Scalars['String']['output'];
};

export type ReportProblemDriverInput = {
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  message: Scalars['String']['input'];
};

export type ReportProblemDriverResponse = {
  __typename?: 'ReportProblemDriverResponse';
  error?: Maybe<Error>;
  message: Scalars['String']['output'];
};

export type ReportProblemInput = {
  images?: InputMaybe<Array<Scalars['String']['input']>>;
  message: Scalars['String']['input'];
};

export type ReportProblemResponse = {
  __typename?: 'ReportProblemResponse';
  error?: Maybe<Error>;
  message: Scalars['String']['output'];
};

export type ReportQueryResponse = {
  __typename?: 'ReportQueryResponse';
  charityReport: GetReportResponse;
  charityReportAsCsv: GetReportAsCsvResponse;
  clientSummaryReport: GetReportResponse;
  clientSummaryReportAsCsv: GetReportAsCsvResponse;
  clientSummaryReportOldAsCsv: GetReportAsCsvResponse;
  clientSummaryReportSnapshotAsCsv: GetReportAsCsvResponse;
  completionReport: GetReportResponse;
  completionReportAsCsv: GetReportAsCsvResponse;
  detailedReport: GetReportResponse;
  detailedReportAsCsv: GetReportAsCsvResponse;
  drivetimeReport: GetReportResponse;
  drivetimeReportAsCsv: GetReportAsCsvResponse;
  fcrReport: GetReportResponse;
  fcrReportAsCsv: GetReportAsCsvResponse;
  genericReport: GetReportResponse;
  kpiReport: GetReportResponse;
  kpiReportAsCsv: GetReportAsCsvResponse;
  onTimePerformanceReport: GetReportResponse;
  onTimePerformanceReportAsCsv: GetReportAsCsvResponse;
  punchReport: GetReportResponse;
  punchReportAsCsv: GetReportAsCsvResponse;
  ratingsReport: GetReportResponse;
  ratingsReportAsCsv: GetReportAsCsvResponse;
  ratingsTable: GetReportResponse;
  trainingReportAsCsv: GetReportAsCsvResponse;
  tripIssueReport: GetReportResponse;
  tripIssueReportAsCsv: GetReportAsCsvResponse;
  vehicleReport: GetReportResponse;
  vehicleReportAsCsv: GetReportAsCsvResponse;
};


export type ReportQueryResponseCharityReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseCharityReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseClientSummaryReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseClientSummaryReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseClientSummaryReportOldAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseClientSummaryReportSnapshotAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseCompletionReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseCompletionReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseDetailedReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseDetailedReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseDrivetimeReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseDrivetimeReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseFcrReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseFcrReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseGenericReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseKpiReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseKpiReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseOnTimePerformanceReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseOnTimePerformanceReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponsePunchReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponsePunchReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseRatingsReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseRatingsReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseRatingsTableArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseTrainingReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseTripIssueReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseTripIssueReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseVehicleReportArgs = {
  input?: InputMaybe<ReportInput>;
};


export type ReportQueryResponseVehicleReportAsCsvArgs = {
  input?: InputMaybe<ReportInput>;
};

export enum ReportReasonEnum {
  Airline = 'AIRLINE',
  Crew = 'CREW',
  Dispatch = 'DISPATCH',
  Driver = 'DRIVER',
  Equipment = 'EQUIPMENT',
  Irop = 'IROP',
  Positive = 'POSITIVE',
  Safety = 'SAFETY',
  Traffic = 'TRAFFIC'
}

export enum ReportSeriesEnum {
  SeriesDay = 'SERIES_DAY',
  SeriesDefault = 'SERIES_DEFAULT',
  SeriesHour = 'SERIES_HOUR',
  SeriesMinute = 'SERIES_MINUTE',
  SeriesMonth = 'SERIES_MONTH',
  SeriesQuarter = 'SERIES_QUARTER',
  SeriesWeek = 'SERIES_WEEK',
  SeriesYear = 'SERIES_YEAR'
}

export enum ReportTypeEnum {
  AccidentReport = 'ACCIDENT_REPORT',
  CharityReport = 'CHARITY_REPORT',
  ClientSummaryReport = 'CLIENT_SUMMARY_REPORT',
  ClientSummaryReportDeprecated = 'CLIENT_SUMMARY_REPORT_DEPRECATED',
  ClientSummaryReportSnapshot = 'CLIENT_SUMMARY_REPORT_SNAPSHOT',
  CompletionReport = 'COMPLETION_REPORT',
  ContractRiskReport = 'CONTRACT_RISK_REPORT',
  DetailedReport = 'DETAILED_REPORT',
  DetailedReportFull = 'DETAILED_REPORT_FULL',
  DispatchIssueReport = 'DISPATCH_ISSUE_REPORT',
  DriveTimeReport = 'DRIVE_TIME_REPORT',
  DriveTimeReportFull = 'DRIVE_TIME_REPORT_FULL',
  FcrReport = 'FCR_REPORT',
  IncidentReport = 'INCIDENT_REPORT',
  KpiReport = 'KPI_REPORT',
  LostAndFoundReport = 'LOST_AND_FOUND_REPORT',
  OntimePerformanceReport = 'ONTIME_PERFORMANCE_REPORT',
  PunchReport = 'PUNCH_REPORT',
  PunchReportDetails = 'PUNCH_REPORT_DETAILS',
  PunchReportSimple = 'PUNCH_REPORT_SIMPLE',
  RatingsReport = 'RATINGS_REPORT',
  RatingsTable = 'RATINGS_TABLE',
  TrainingReport = 'TRAINING_REPORT',
  TripIssueReport = 'TRIP_ISSUE_REPORT',
  Unknown = 'UNKNOWN',
  VehicleReport = 'VEHICLE_REPORT'
}

export type ResetPasswordLinkCodeInput = {
  code: Scalars['String']['input'];
  confirmPassword: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username?: InputMaybe<Scalars['String']['input']>;
};

export type ResetPasswordLinkCodeResponse = {
  __typename?: 'ResetPasswordLinkCodeResponse';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ResubmitManifestHistoryInput = {
  manifestHistoryId: Scalars['ID']['input'];
};

export type ResubmitManifestHistoryResponse = {
  __typename?: 'ResubmitManifestHistoryResponse';
  success: Scalars['Boolean']['output'];
};

export type ResubmitQueryHistoryInput = {
  queryHistoryId: Scalars['ID']['input'];
};

export type ResubmitQueryHistoryResponse = {
  __typename?: 'ResubmitQueryHistoryResponse';
  success: Scalars['Boolean']['output'];
};

export type Role = {
  __typename?: 'Role';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  permissions?: Maybe<Array<Permission>>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type RoleActivityConnection = {
  __typename?: 'RoleActivityConnection';
  edges?: Maybe<Array<Maybe<RoleActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoleActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type RoleActivityEdge = {
  __typename?: 'RoleActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type RoleConnection = {
  __typename?: 'RoleConnection';
  edges?: Maybe<Array<Maybe<RoleEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type RoleConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<RoleMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<RoleSearch>>;
};

export type RoleEdge = {
  __typename?: 'RoleEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Role>;
};

export type RoleMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RoleSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type Row = {
  __typename?: 'Row';
  children?: Maybe<Array<Row>>;
  details?: Maybe<Array<RowDetails>>;
  values?: Maybe<Array<KeyValue>>;
};

export type RowDetails = {
  __typename?: 'RowDetails';
  filters?: Maybe<Array<ReportFilters>>;
  id: Scalars['String']['output'];
};

export type RowDetailsInput = {
  id: Scalars['String']['input'];
};

export type RunApplyRateToSimilarTripsInput = {
  rateIds: Array<Scalars['String']['input']>;
};

export type RunApplyRateToSimilarTripsResponse = {
  __typename?: 'RunApplyRateToSimilarTripsResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type RunArchiveImportsInput = {
  importIds: Array<Scalars['String']['input']>;
};

export type RunArchiveImportsResponse = {
  __typename?: 'RunArchiveImportsResponse';
  error?: Maybe<Error>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type RunArchiveInvoicesInput = {
  invoiceIds: Array<Scalars['Int']['input']>;
};

export type RunArchiveInvoicesResponse = {
  __typename?: 'RunArchiveInvoicesResponse';
  error?: Maybe<Error>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type RunAssignDriverInput = {
  combines?: InputMaybe<Array<CombineTripInput>>;
  driverId: Scalars['String']['input'];
  scheduled?: InputMaybe<Scalars['String']['input']>;
  tripId: Scalars['String']['input'];
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type RunAssignDriverResponse = {
  __typename?: 'RunAssignDriverResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
  vehicle?: Maybe<Vehicle>;
};

export type RunAssignVehicleToDriverBulkInput = {
  input: Array<RunAssignVehicleToDriverInput>;
};

export type RunAssignVehicleToDriverBulkResponse = {
  __typename?: 'RunAssignVehicleToDriverBulkResponse';
  output?: Maybe<Array<Maybe<RunAssignVehicleToDriverResponse>>>;
};

export type RunAssignVehicleToDriverInput = {
  scheduled: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type RunAssignVehicleToDriverResponse = {
  __typename?: 'RunAssignVehicleToDriverResponse';
  error?: Maybe<Error>;
  updated?: Maybe<Scalars['Int']['output']>;
  userId: Scalars['String']['output'];
  vehicleId: Scalars['String']['output'];
};

export type RunAutoCombineDriverTripsInput = {
  airportCode?: InputMaybe<Scalars['String']['input']>;
  doLocationId: Scalars['String']['input'];
  driverId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
  puLocationId: Scalars['String']['input'];
  scheduled: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
  vehicleCapacity?: InputMaybe<Scalars['Int']['input']>;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type RunAutoCombineDriverTripsResponse = {
  __typename?: 'RunAutoCombineDriverTripsResponse';
  highestCombineType?: Maybe<TripCombineTypeEnum>;
  output?: Maybe<Array<TripAndCombineType>>;
  trip?: Maybe<Trip>;
  updated: Scalars['Int']['output'];
};

export type RunCompletionOnTripInput = {
  completion: CreateCompletionInput;
  tripIds: Array<Scalars['String']['input']>;
};

export type RunCompletionOnTripResponse = {
  __typename?: 'RunCompletionOnTripResponse';
  error?: Maybe<Error>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type RunDownloadImportInput = {
  importIds: Array<Scalars['String']['input']>;
};

export type RunDownloadImportResponse = {
  __typename?: 'RunDownloadImportResponse';
  output?: Maybe<Array<DownloadImportUrlResponse>>;
};

export type RunDownloadInvoiceInput = {
  input: InvoiceInput;
};

export type RunDownloadInvoiceResponse = {
  __typename?: 'RunDownloadInvoiceResponse';
  error?: Maybe<Error>;
  output?: Maybe<DownloadInvoiceResponse>;
};

export type RunDownloadLatestInvoiceDocumentInput = {
  invoiceId: Scalars['Int']['input'];
};

export type RunDownloadLatestInvoiceDocumentResponse = {
  __typename?: 'RunDownloadLatestInvoiceDocumentResponse';
  error?: Maybe<Error>;
  output?: Maybe<DownloadInvoiceResponse>;
};

export type RunGetDriverEstimatedDriveTimeInput = {
  driverId: Scalars['String']['input'];
  scheduled: Scalars['String']['input'];
  toLocationId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};

export type RunGetDriverEstimatedDriveTimeResponse = {
  __typename?: 'RunGetDriverEstimatedDriveTimeResponse';
  estimatedTimeMinutes: Scalars['Int']['output'];
  fromLocationId: Scalars['String']['output'];
  fromTrip: Trip;
  toLocationId: Scalars['String']['output'];
  warning?: Maybe<Scalars['String']['output']>;
};

export type RunIngestImportsInput = {
  ingests: Array<RunIngestInput>;
};

export type RunIngestImportsResponse = {
  __typename?: 'RunIngestImportsResponse';
  error?: Maybe<Error>;
  ingests: Array<IngestImportResponse>;
};

export type RunIngestInput = {
  excludeFlagHasTrip?: InputMaybe<Array<IngestFlagHasTripInput>>;
  excludes: Array<Scalars['String']['input']>;
  importId: Scalars['String']['input'];
  keepVehicleAndDriverAssignedOnNonAirportLocationChange?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RunOverrideImportsInput = {
  overrides: Array<OverrideImportInput>;
};

export type RunOverrideImportsResponse = {
  __typename?: 'RunOverrideImportsResponse';
  imports: Array<UpdateResponse>;
};

export type RunParseImportLocationsInput = {
  id: Scalars['ID']['input'];
  importIds: Array<Scalars['String']['input']>;
};

export type RunParseImportLocationsResponse = {
  __typename?: 'RunParseImportLocationsResponse';
  result: Array<UpdateResponse>;
};

export type RunParseImportsInput = {
  id: Scalars['ID']['input'];
  importIds: Array<Scalars['String']['input']>;
};

export type RunParseImportsResponse = {
  __typename?: 'RunParseImportsResponse';
  imports: Array<UpdateResponse>;
};

export type RunPreviewImportsInput = {
  importIds: Array<Scalars['String']['input']>;
  keepVehicleAndDriverAssignedOnNonAirportLocationChange?: InputMaybe<Scalars['Boolean']['input']>;
};

export type RunPreviewImportsResponse = {
  __typename?: 'RunPreviewImportsResponse';
  error?: Maybe<Error>;
  previews?: Maybe<Array<PreviewDetails>>;
};

export type RunPreviewInvoiceInput = {
  input: InvoiceInput;
};

export type RunPreviewInvoiceResponse = {
  __typename?: 'RunPreviewInvoiceResponse';
  customChargeSummary?: Maybe<Array<InvoiceCustomChargeSummary>>;
  error?: Maybe<Error>;
  invoiceTerms?: Maybe<Scalars['String']['output']>;
  output?: Maybe<InvoiceResponse>;
  subtotals?: Maybe<Array<Maybe<InvoiceRateSubtotal>>>;
  summary?: Maybe<InvoiceSummary>;
};

export type RunRateAmountOnTripInput = {
  amount: Scalars['Float']['input'];
  tripId: Scalars['String']['input'];
};

export type RunRateAmountOnTripResponse = {
  __typename?: 'RunRateAmountOnTripResponse';
  created?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Error>;
  rateGroupId?: Maybe<Scalars['String']['output']>;
  rateId?: Maybe<Scalars['String']['output']>;
  tripId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type RunRateAmountOnTripsInput = {
  input: Array<RunRateAmountOnTripInput>;
};

export type RunRateAmountOnTripsResponse = {
  __typename?: 'RunRateAmountOnTripsResponse';
  output?: Maybe<Array<RunRateAmountOnTripResponse>>;
};

export type RunRateOverrideInput = {
  companyId: Scalars['String']['input'];
  currency: RateItemCurrencyEnum;
  endDatetime: Scalars['String']['input'];
  payerProviderId: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
  rateGroupId: Scalars['String']['input'];
  startDatetime: Scalars['String']['input'];
  thatLocationId: Scalars['String']['input'];
  thisLocationId: Scalars['String']['input'];
};

export type RunRateOverridePreviewInput = {
  companyId: Scalars['String']['input'];
  endDatetime: Scalars['String']['input'];
  payerProviderId: Scalars['String']['input'];
  rate: Scalars['Float']['input'];
  startDatetime: Scalars['String']['input'];
  thatLocationId: Scalars['String']['input'];
  thisLocationId: Scalars['String']['input'];
};

export type RunRateOverridePreviewResponse = {
  __typename?: 'RunRateOverridePreviewResponse';
  error?: Maybe<Error>;
  newAmount: Scalars['Float']['output'];
  totalAmount: Scalars['Float']['output'];
  totalTrips: Scalars['Int']['output'];
};

export type RunRateOverrideResponse = {
  __typename?: 'RunRateOverrideResponse';
  error?: Maybe<Error>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type RunRemoveCompletionOnTripInput = {
  tripIds: Array<Scalars['String']['input']>;
};

export type RunRemoveCompletionOnTripResponse = {
  __typename?: 'RunRemoveCompletionOnTripResponse';
  error?: Maybe<Error>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type RunReportIndexerResponse = {
  __typename?: 'RunReportIndexerResponse';
  count?: Maybe<Scalars['Int']['output']>;
  error?: Maybe<Error>;
};

export type RunResetUserPasswordBulkInput = {
  input: Array<RunResetUserPasswordInput>;
};

export type RunResetUserPasswordBulkResponse = {
  __typename?: 'RunResetUserPasswordBulkResponse';
  output: Array<UpdateResponse>;
};

export type RunResetUserPasswordInput = {
  newPassword: Scalars['String']['input'];
  userIds: Array<Scalars['String']['input']>;
};

export type RunRollbackImportResponse = {
  __typename?: 'RunRollbackImportResponse';
  error?: Maybe<Error>;
  failures?: Maybe<Array<IngestTripError>>;
  id: Scalars['String']['output'];
};

export type RunRollbackImportsInput = {
  importIds: Array<Scalars['String']['input']>;
};

export type RunRollbackImportsResponse = {
  __typename?: 'RunRollbackImportsResponse';
  output: Array<RunRollbackImportResponse>;
};

export type RunSaveAndSendInvoiceInput = {
  input: InvoiceInput;
};

export type RunSaveAndSendInvoiceResponse = {
  __typename?: 'RunSaveAndSendInvoiceResponse';
  error?: Maybe<Error>;
  output?: Maybe<InvoiceResponse>;
};

export type RunSaveAsInvoiceInput = {
  input: InvoiceInput;
};

export type RunSaveAsInvoiceResponse = {
  __typename?: 'RunSaveAsInvoiceResponse';
  error?: Maybe<Error>;
  output?: Maybe<InvoiceResponse>;
};

export type RunSaveInvoiceInput = {
  input: InvoiceInput;
};

export type RunSaveInvoiceResponse = {
  __typename?: 'RunSaveInvoiceResponse';
  error?: Maybe<Error>;
  output?: Maybe<InvoiceResponse>;
};

export type RunScheduleAutomationInput = {
  query?: InputMaybe<Array<AutomationTripSearch>>;
  timezoneOffset?: InputMaybe<Scalars['String']['input']>;
};

export type RunScheduleAutomationResponse = {
  __typename?: 'RunScheduleAutomationResponse';
  automationHistory: AutomationHistoryWithAirport;
};

export type RunUnarchiveInvoicesInput = {
  invoiceIds: Array<Scalars['Int']['input']>;
};

export type RunUnarchiveInvoicesResponse = {
  __typename?: 'RunUnarchiveInvoicesResponse';
  error?: Maybe<Error>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type RunUnassignDriverInput = {
  tripId: Scalars['String']['input'];
};

export type RunUnassignDriverResponse = {
  __typename?: 'RunUnassignDriverResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type RunUpdateUserProfileBulkInput = {
  updates?: InputMaybe<Array<RunUpdateUserProfileInput>>;
};

export type RunUpdateUserProfileBulkResponse = {
  __typename?: 'RunUpdateUserProfileBulkResponse';
  response?: Maybe<Array<UpdateResponse>>;
};

export type RunUpdateUserProfileInput = {
  createGroupHasUserBulk?: InputMaybe<Array<CreateGroupHasUserInput>>;
  createLicenseBulk?: InputMaybe<Array<CreateLicenseInput>>;
  createPermissionHasUserBulk?: InputMaybe<Array<CreatePermissionHasUserInput>>;
  deleteGroupHasUserBulk?: InputMaybe<Array<DeleteGroupHasUserInput>>;
  deleteLicenseBulk?: InputMaybe<Array<DeleteLicenseInput>>;
  deletePermissionHasUserBulk?: InputMaybe<Array<DeletePermissionHasUserInput>>;
  query: Array<UserSearch>;
  updateLicenseBulk?: InputMaybe<Array<UpdateLicenseInput>>;
  updateUserValues?: InputMaybe<UpdateUserValuesInput>;
};

export type RunUpdateUserVehicleBulkInput = {
  input: Array<RunUpdateUserVehicleInput>;
};

export type RunUpdateUserVehicleBulkResponse = {
  __typename?: 'RunUpdateUserVehicleBulkResponse';
  output?: Maybe<Array<Maybe<RunUpdateUserVehicleResponse>>>;
};

export type RunUpdateUserVehicleInput = {
  scheduled?: InputMaybe<Scalars['String']['input']>;
  tripId?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type RunUpdateUserVehicleResponse = {
  __typename?: 'RunUpdateUserVehicleResponse';
  error?: Maybe<Error>;
  updated?: Maybe<Scalars['Int']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
};

export type SaveQuestionnaireAnswerInput = {
  answers: Array<SaveQuestionnaireAnswerItemInput>;
};

export type SaveQuestionnaireAnswerItemInput = {
  note?: InputMaybe<Scalars['String']['input']>;
  questionnaireAttemptQuestionSnapshotId: Scalars['String']['input'];
  selectedAnswerOptionSnapshotId?: InputMaybe<Scalars['String']['input']>;
};

export type SaveQuestionnaireAnswerResponse = {
  __typename?: 'SaveQuestionnaireAnswerResponse';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type ScatterPlot = {
  __typename?: 'ScatterPlot';
  values?: Maybe<Array<Maybe<Points>>>;
};

export type ScheduleAutomationRunDriverAssignmentInput = {
  automationHistoryId: Scalars['ID']['input'];
};

export type ScheduleAutomationRunDriverAssignmentResponse = {
  __typename?: 'ScheduleAutomationRunDriverAssignmentResponse';
  automationHistory: AutomationHistoryWithAirport;
};

export type SearchAccidentIssueDocumentResponse = {
  __typename?: 'SearchAccidentIssueDocumentResponse';
  accidentIssueDocumentConnection?: Maybe<AccidentIssueDocumentConnection>;
};


export type SearchAccidentIssueDocumentResponseAccidentIssueDocumentConnectionArgs = {
  input?: InputMaybe<AccidentIssueDocumentConnectionInput>;
};

export type SearchAccidentIssueResponse = {
  __typename?: 'SearchAccidentIssueResponse';
  accidentIssueConnection?: Maybe<AccidentIssueConnection>;
  accidentIssueTableConnection?: Maybe<AccidentIssueWithCacheConnection>;
};


export type SearchAccidentIssueResponseAccidentIssueConnectionArgs = {
  input?: InputMaybe<AccidentIssueConnectionInput>;
};


export type SearchAccidentIssueResponseAccidentIssueTableConnectionArgs = {
  input?: InputMaybe<AccidentIssueWithCacheConnectionInput>;
};

export type SearchAccidentIssueWithCacheResponse = {
  __typename?: 'SearchAccidentIssueWithCacheResponse';
  accidentIssueWithCacheActivityConnection?: Maybe<AccidentIssueWithCacheActivityConnection>;
  accidentIssueWithCacheConnection?: Maybe<AccidentIssueWithCacheConnection>;
};


export type SearchAccidentIssueWithCacheResponseAccidentIssueWithCacheActivityConnectionArgs = {
  input?: InputMaybe<AccidentIssueWithCacheActivityConnectionInput>;
};


export type SearchAccidentIssueWithCacheResponseAccidentIssueWithCacheConnectionArgs = {
  input?: InputMaybe<AccidentIssueWithCacheConnectionInput>;
};

export type SearchActivityDisplayMessageResponse = {
  __typename?: 'SearchActivityDisplayMessageResponse';
  activityDisplayMessageActivityConnection?: Maybe<ActivityDisplayMessageActivityConnection>;
  activityDisplayMessageConnection?: Maybe<ActivityDisplayMessageConnection>;
};


export type SearchActivityDisplayMessageResponseActivityDisplayMessageActivityConnectionArgs = {
  input?: InputMaybe<ActivityDisplayMessageActivityConnectionInput>;
};


export type SearchActivityDisplayMessageResponseActivityDisplayMessageConnectionArgs = {
  input?: InputMaybe<ActivityDisplayMessageConnectionInput>;
};

export type SearchActivityLogPayloadChildResponse = {
  __typename?: 'SearchActivityLogPayloadChildResponse';
  activityLogPayloadChildActivityConnection?: Maybe<ActivityLogPayloadChildActivityConnection>;
  activityLogPayloadChildConnection?: Maybe<ActivityLogPayloadChildConnection>;
};


export type SearchActivityLogPayloadChildResponseActivityLogPayloadChildActivityConnectionArgs = {
  input?: InputMaybe<ActivityLogPayloadChildActivityConnectionInput>;
};


export type SearchActivityLogPayloadChildResponseActivityLogPayloadChildConnectionArgs = {
  input?: InputMaybe<ActivityLogPayloadChildConnectionInput>;
};

export type SearchActivityLogPayloadResponse = {
  __typename?: 'SearchActivityLogPayloadResponse';
  activityLogPayloadActivityConnection?: Maybe<ActivityLogPayloadActivityConnection>;
  activityLogPayloadConnection?: Maybe<ActivityLogPayloadConnection>;
};


export type SearchActivityLogPayloadResponseActivityLogPayloadActivityConnectionArgs = {
  input?: InputMaybe<ActivityLogPayloadActivityConnectionInput>;
};


export type SearchActivityLogPayloadResponseActivityLogPayloadConnectionArgs = {
  input?: InputMaybe<ActivityLogPayloadConnectionInput>;
};

export type SearchActivityLogResponse = {
  __typename?: 'SearchActivityLogResponse';
  activityLogConnection?: Maybe<ActivityLogConnection>;
};


export type SearchActivityLogResponseActivityLogConnectionArgs = {
  input?: InputMaybe<ActivityLogConnectionInput>;
};

export type SearchActivityLogWithCacheResponse = {
  __typename?: 'SearchActivityLogWithCacheResponse';
  activityLogWithCacheActivityConnection?: Maybe<ActivityLogWithCacheActivityConnection>;
  activityLogWithCacheConnection?: Maybe<ActivityLogWithCacheConnection>;
};


export type SearchActivityLogWithCacheResponseActivityLogWithCacheActivityConnectionArgs = {
  input?: InputMaybe<ActivityLogWithCacheActivityConnectionInput>;
};


export type SearchActivityLogWithCacheResponseActivityLogWithCacheConnectionArgs = {
  input?: InputMaybe<ActivityLogWithCacheConnectionInput>;
};

export type SearchActivityObjectResponse = {
  __typename?: 'SearchActivityObjectResponse';
  activityObjectActivityConnection?: Maybe<ActivityObjectActivityConnection>;
  activityObjectConnection?: Maybe<ActivityObjectConnection>;
};


export type SearchActivityObjectResponseActivityObjectActivityConnectionArgs = {
  input?: InputMaybe<ActivityObjectActivityConnectionInput>;
};


export type SearchActivityObjectResponseActivityObjectConnectionArgs = {
  input?: InputMaybe<ActivityObjectConnectionInput>;
};

export type SearchActivityResponse = {
  __typename?: 'SearchActivityResponse';
  activityConnection?: Maybe<ActivityConnection>;
};


export type SearchActivityResponseActivityConnectionArgs = {
  input?: InputMaybe<ActivityConnectionInput>;
};

export type SearchActivityUserCacheResponse = {
  __typename?: 'SearchActivityUserCacheResponse';
  activityUserCacheActivityConnection?: Maybe<ActivityUserCacheActivityConnection>;
  activityUserCacheConnection?: Maybe<ActivityUserCacheConnection>;
};


export type SearchActivityUserCacheResponseActivityUserCacheActivityConnectionArgs = {
  input?: InputMaybe<ActivityUserCacheActivityConnectionInput>;
};


export type SearchActivityUserCacheResponseActivityUserCacheConnectionArgs = {
  input?: InputMaybe<ActivityUserCacheConnectionInput>;
};

export type SearchAirportGroupResponse = {
  __typename?: 'SearchAirportGroupResponse';
  airportGroupActivityConnection?: Maybe<AirportGroupActivityConnection>;
  airportGroupConnection?: Maybe<AirportGroupConnection>;
};


export type SearchAirportGroupResponseAirportGroupActivityConnectionArgs = {
  input?: InputMaybe<AirportGroupActivityConnectionInput>;
};


export type SearchAirportGroupResponseAirportGroupConnectionArgs = {
  input?: InputMaybe<AirportGroupConnectionInput>;
};

export type SearchAirportHasCompanyResponse = {
  __typename?: 'SearchAirportHasCompanyResponse';
  airportHasCompanyConnection?: Maybe<AirportHasCompanyConnection>;
};


export type SearchAirportHasCompanyResponseAirportHasCompanyConnectionArgs = {
  input?: InputMaybe<AirportHasCompanyConnectionInput>;
};

export type SearchAirportHasGroupResponse = {
  __typename?: 'SearchAirportHasGroupResponse';
  airportHasGroupActivityConnection?: Maybe<AirportHasGroupActivityConnection>;
  airportHasGroupConnection?: Maybe<AirportHasGroupConnection>;
};


export type SearchAirportHasGroupResponseAirportHasGroupActivityConnectionArgs = {
  input?: InputMaybe<AirportHasGroupActivityConnectionInput>;
};


export type SearchAirportHasGroupResponseAirportHasGroupConnectionArgs = {
  input?: InputMaybe<AirportHasGroupConnectionInput>;
};

export type SearchAirportHasLocationResponse = {
  __typename?: 'SearchAirportHasLocationResponse';
  airportHasLocationActivityConnection?: Maybe<AirportHasLocationActivityConnection>;
  airportHasLocationConnection?: Maybe<AirportHasLocationConnection>;
};


export type SearchAirportHasLocationResponseAirportHasLocationActivityConnectionArgs = {
  input?: InputMaybe<AirportHasLocationActivityConnectionInput>;
};


export type SearchAirportHasLocationResponseAirportHasLocationConnectionArgs = {
  input?: InputMaybe<AirportHasLocationConnectionInput>;
};

export type SearchAirportHasManagerEmailResponse = {
  __typename?: 'SearchAirportHasManagerEmailResponse';
  airportHasManagerEmailActivityConnection?: Maybe<AirportHasManagerEmailActivityConnection>;
  airportHasManagerEmailConnection?: Maybe<AirportHasManagerEmailConnection>;
};


export type SearchAirportHasManagerEmailResponseAirportHasManagerEmailActivityConnectionArgs = {
  input?: InputMaybe<AirportHasManagerEmailActivityConnectionInput>;
};


export type SearchAirportHasManagerEmailResponseAirportHasManagerEmailConnectionArgs = {
  input?: InputMaybe<AirportHasManagerEmailConnectionInput>;
};

export type SearchAirportHasRateResponse = {
  __typename?: 'SearchAirportHasRateResponse';
  airportHasRateActivityConnection?: Maybe<AirportHasRateActivityConnection>;
  airportHasRateConnection?: Maybe<AirportHasRateConnection>;
};


export type SearchAirportHasRateResponseAirportHasRateActivityConnectionArgs = {
  input?: InputMaybe<AirportHasRateActivityConnectionInput>;
};


export type SearchAirportHasRateResponseAirportHasRateConnectionArgs = {
  input?: InputMaybe<AirportHasRateConnectionInput>;
};

export type SearchAirportHasVehicleResponse = {
  __typename?: 'SearchAirportHasVehicleResponse';
  airportHasVehicleConnection?: Maybe<AirportHasVehicleConnection>;
};


export type SearchAirportHasVehicleResponseAirportHasVehicleConnectionArgs = {
  input?: InputMaybe<AirportHasVehicleConnectionInput>;
};

export type SearchAirportResponse = {
  __typename?: 'SearchAirportResponse';
  airportConnection?: Maybe<AirportConnection>;
};


export type SearchAirportResponseAirportConnectionArgs = {
  input?: InputMaybe<AirportConnectionInput>;
};

export type SearchAirportWithCompanyResponse = {
  __typename?: 'SearchAirportWithCompanyResponse';
  airportWithCompanyActivityConnection?: Maybe<AirportWithCompanyActivityConnection>;
  airportWithCompanyConnection?: Maybe<AirportWithCompanyConnection>;
};


export type SearchAirportWithCompanyResponseAirportWithCompanyActivityConnectionArgs = {
  input?: InputMaybe<AirportWithCompanyActivityConnectionInput>;
};


export type SearchAirportWithCompanyResponseAirportWithCompanyConnectionArgs = {
  input?: InputMaybe<AirportWithCompanyConnectionInput>;
};

export type SearchAirportWithGroupResponse = {
  __typename?: 'SearchAirportWithGroupResponse';
  airportWithGroupConnection?: Maybe<AirportWithGroupConnection>;
};


export type SearchAirportWithGroupResponseAirportWithGroupConnectionArgs = {
  input?: InputMaybe<AirportWithGroupConnectionInput>;
};

export type SearchAirportWithLocationResponse = {
  __typename?: 'SearchAirportWithLocationResponse';
  airportWithLocationConnection?: Maybe<AirportWithLocationConnection>;
};


export type SearchAirportWithLocationResponseAirportWithLocationConnectionArgs = {
  input?: InputMaybe<AirportWithLocationConnectionInput>;
};

export type SearchAirportWithVehicleResponse = {
  __typename?: 'SearchAirportWithVehicleResponse';
  airportWithVehicleConnection?: Maybe<AirportWithVehicleConnection>;
};


export type SearchAirportWithVehicleResponseAirportWithVehicleConnectionArgs = {
  input?: InputMaybe<AirportWithVehicleConnectionInput>;
};

export type SearchAlertSubscriptionResponse = {
  __typename?: 'SearchAlertSubscriptionResponse';
  alertSubscriptionActivityConnection?: Maybe<AlertSubscriptionActivityConnection>;
  alertSubscriptionConnection?: Maybe<AlertSubscriptionConnection>;
};


export type SearchAlertSubscriptionResponseAlertSubscriptionActivityConnectionArgs = {
  input?: InputMaybe<AlertSubscriptionActivityConnectionInput>;
};


export type SearchAlertSubscriptionResponseAlertSubscriptionConnectionArgs = {
  input?: InputMaybe<AlertSubscriptionConnectionInput>;
};

export type SearchAliasResponse = {
  __typename?: 'SearchAliasResponse';
  aliasConnection?: Maybe<AliasConnection>;
};


export type SearchAliasResponseAliasConnectionArgs = {
  input?: InputMaybe<AliasConnectionInput>;
};

export type SearchApiKeyResponse = {
  __typename?: 'SearchApiKeyResponse';
  apiKeyActivityConnection?: Maybe<ApiKeyActivityConnection>;
  apiKeyConnection?: Maybe<ApiKeyConnection>;
};


export type SearchApiKeyResponseApiKeyActivityConnectionArgs = {
  input?: InputMaybe<ApiKeyActivityConnectionInput>;
};


export type SearchApiKeyResponseApiKeyConnectionArgs = {
  input?: InputMaybe<ApiKeyConnectionInput>;
};

export type SearchAuditSnapshotResponse = {
  __typename?: 'SearchAuditSnapshotResponse';
  auditSnapshotActivityConnection?: Maybe<AuditSnapshotActivityConnection>;
  auditSnapshotConnection?: Maybe<AuditSnapshotConnection>;
};


export type SearchAuditSnapshotResponseAuditSnapshotActivityConnectionArgs = {
  input?: InputMaybe<AuditSnapshotActivityConnectionInput>;
};


export type SearchAuditSnapshotResponseAuditSnapshotConnectionArgs = {
  input?: InputMaybe<AuditSnapshotConnectionInput>;
};

export type SearchAuditSnapshotWithNameResponse = {
  __typename?: 'SearchAuditSnapshotWithNameResponse';
  auditSnapshotWithNameActivityConnection?: Maybe<AuditSnapshotWithNameActivityConnection>;
  auditSnapshotWithNameConnection?: Maybe<AuditSnapshotWithNameConnection>;
};


export type SearchAuditSnapshotWithNameResponseAuditSnapshotWithNameActivityConnectionArgs = {
  input?: InputMaybe<AuditSnapshotWithNameActivityConnectionInput>;
};


export type SearchAuditSnapshotWithNameResponseAuditSnapshotWithNameConnectionArgs = {
  input?: InputMaybe<AuditSnapshotWithNameConnectionInput>;
};

export type SearchAutoCombineRuleResponse = {
  __typename?: 'SearchAutoCombineRuleResponse';
  autoCombineRuleActivityConnection?: Maybe<AutoCombineRuleActivityConnection>;
  autoCombineRuleConnection?: Maybe<AutoCombineRuleConnection>;
};


export type SearchAutoCombineRuleResponseAutoCombineRuleActivityConnectionArgs = {
  input?: InputMaybe<AutoCombineRuleActivityConnectionInput>;
};


export type SearchAutoCombineRuleResponseAutoCombineRuleConnectionArgs = {
  input?: InputMaybe<AutoCombineRuleConnectionInput>;
};

export type SearchAutoCombineRuleWithContractResponse = {
  __typename?: 'SearchAutoCombineRuleWithContractResponse';
  autoCombineRuleWithContractActivityConnection?: Maybe<AutoCombineRuleWithContractActivityConnection>;
  autoCombineRuleWithContractConnection?: Maybe<AutoCombineRuleWithContractConnection>;
};


export type SearchAutoCombineRuleWithContractResponseAutoCombineRuleWithContractActivityConnectionArgs = {
  input?: InputMaybe<AutoCombineRuleWithContractActivityConnectionInput>;
};


export type SearchAutoCombineRuleWithContractResponseAutoCombineRuleWithContractConnectionArgs = {
  input?: InputMaybe<AutoCombineRuleWithContractConnectionInput>;
};

export type SearchAutomationHistoryAirportResponse = {
  __typename?: 'SearchAutomationHistoryAirportResponse';
  automationHistoryAirportActivityConnection?: Maybe<AutomationHistoryAirportActivityConnection>;
  automationHistoryAirportConnection?: Maybe<AutomationHistoryAirportConnection>;
};


export type SearchAutomationHistoryAirportResponseAutomationHistoryAirportActivityConnectionArgs = {
  input?: InputMaybe<AutomationHistoryAirportActivityConnectionInput>;
};


export type SearchAutomationHistoryAirportResponseAutomationHistoryAirportConnectionArgs = {
  input?: InputMaybe<AutomationHistoryAirportConnectionInput>;
};

export type SearchAutomationHistoryLogResponse = {
  __typename?: 'SearchAutomationHistoryLogResponse';
  automationHistoryLogActivityConnection?: Maybe<AutomationHistoryLogActivityConnection>;
  automationHistoryLogConnection?: Maybe<AutomationHistoryLogConnection>;
};


export type SearchAutomationHistoryLogResponseAutomationHistoryLogActivityConnectionArgs = {
  input?: InputMaybe<AutomationHistoryLogActivityConnectionInput>;
};


export type SearchAutomationHistoryLogResponseAutomationHistoryLogConnectionArgs = {
  input?: InputMaybe<AutomationHistoryLogConnectionInput>;
};

export type SearchAutomationHistoryResponse = {
  __typename?: 'SearchAutomationHistoryResponse';
  automationHistoryActivityConnection?: Maybe<AutomationHistoryActivityConnection>;
  automationHistoryConnection?: Maybe<AutomationHistoryConnection>;
};


export type SearchAutomationHistoryResponseAutomationHistoryActivityConnectionArgs = {
  input?: InputMaybe<AutomationHistoryActivityConnectionInput>;
};


export type SearchAutomationHistoryResponseAutomationHistoryConnectionArgs = {
  input?: InputMaybe<AutomationHistoryConnectionInput>;
};

export type SearchAutomationHistoryWithAirportResponse = {
  __typename?: 'SearchAutomationHistoryWithAirportResponse';
  automationHistoryWithAirportConnection?: Maybe<AutomationHistoryWithAirportConnection>;
};


export type SearchAutomationHistoryWithAirportResponseAutomationHistoryWithAirportConnectionArgs = {
  input?: InputMaybe<AutomationHistoryWithAirportConnectionInput>;
};

export type SearchAutomationReportResponse = {
  __typename?: 'SearchAutomationReportResponse';
  automationReportActivityConnection?: Maybe<AutomationReportActivityConnection>;
  automationReportConnection?: Maybe<AutomationReportConnection>;
};


export type SearchAutomationReportResponseAutomationReportActivityConnectionArgs = {
  input?: InputMaybe<AutomationReportActivityConnectionInput>;
};


export type SearchAutomationReportResponseAutomationReportConnectionArgs = {
  input?: InputMaybe<AutomationReportConnectionInput>;
};

export type SearchAutomationReportWithAutomationHistoryResponse = {
  __typename?: 'SearchAutomationReportWithAutomationHistoryResponse';
  automationReportWithAutomationHistoryActivityConnection?: Maybe<AutomationReportWithAutomationHistoryActivityConnection>;
  automationReportWithAutomationHistoryConnection?: Maybe<AutomationReportWithAutomationHistoryConnection>;
};


export type SearchAutomationReportWithAutomationHistoryResponseAutomationReportWithAutomationHistoryActivityConnectionArgs = {
  input?: InputMaybe<AutomationReportWithAutomationHistoryActivityConnectionInput>;
};


export type SearchAutomationReportWithAutomationHistoryResponseAutomationReportWithAutomationHistoryConnectionArgs = {
  input?: InputMaybe<AutomationReportWithAutomationHistoryConnectionInput>;
};

export type SearchAutomationTripAssignmentReasonResponse = {
  __typename?: 'SearchAutomationTripAssignmentReasonResponse';
  automationTripAssignmentReasonActivityConnection?: Maybe<AutomationTripAssignmentReasonActivityConnection>;
  automationTripAssignmentReasonConnection?: Maybe<AutomationTripAssignmentReasonConnection>;
};


export type SearchAutomationTripAssignmentReasonResponseAutomationTripAssignmentReasonActivityConnectionArgs = {
  input?: InputMaybe<AutomationTripAssignmentReasonActivityConnectionInput>;
};


export type SearchAutomationTripAssignmentReasonResponseAutomationTripAssignmentReasonConnectionArgs = {
  input?: InputMaybe<AutomationTripAssignmentReasonConnectionInput>;
};

export type SearchAutomationTripLogResponse = {
  __typename?: 'SearchAutomationTripLogResponse';
  automationTripLogActivityConnection?: Maybe<AutomationTripLogActivityConnection>;
  automationTripLogConnection?: Maybe<AutomationTripLogConnection>;
};


export type SearchAutomationTripLogResponseAutomationTripLogActivityConnectionArgs = {
  input?: InputMaybe<AutomationTripLogActivityConnectionInput>;
};


export type SearchAutomationTripLogResponseAutomationTripLogConnectionArgs = {
  input?: InputMaybe<AutomationTripLogConnectionInput>;
};

export type SearchAutomationTripResponse = {
  __typename?: 'SearchAutomationTripResponse';
  automationTripAssignmentReasonConnection?: Maybe<AutomationTripAssignmentReasonConnection>;
  automationTripConnection?: Maybe<AutomationTripConnection>;
  automationTripPreviewConnection?: Maybe<AutomationTripConnection>;
};


export type SearchAutomationTripResponseAutomationTripAssignmentReasonConnectionArgs = {
  input?: InputMaybe<AutomationTripAssignmentReasonConnectionInput>;
};


export type SearchAutomationTripResponseAutomationTripConnectionArgs = {
  input?: InputMaybe<AutomationTripConnectionInput>;
};


export type SearchAutomationTripResponseAutomationTripPreviewConnectionArgs = {
  input?: InputMaybe<AutomationTripConnectionInput>;
};

export type SearchBufferTimeResponse = {
  __typename?: 'SearchBufferTimeResponse';
  bufferTimeTableConnection?: Maybe<BufferTimeConnection>;
};


export type SearchBufferTimeResponseBufferTimeTableConnectionArgs = {
  input?: InputMaybe<BufferTimeWithContractConnectionInput>;
};

export type SearchBufferTimeWithContractResponse = {
  __typename?: 'SearchBufferTimeWithContractResponse';
  bufferTimeWithContractActivityConnection?: Maybe<BufferTimeWithContractActivityConnection>;
  bufferTimeWithContractConnection?: Maybe<BufferTimeWithContractConnection>;
};


export type SearchBufferTimeWithContractResponseBufferTimeWithContractActivityConnectionArgs = {
  input?: InputMaybe<BufferTimeWithContractActivityConnectionInput>;
};


export type SearchBufferTimeWithContractResponseBufferTimeWithContractConnectionArgs = {
  input?: InputMaybe<BufferTimeWithContractConnectionInput>;
};

export type SearchCancellationRuleResponse = {
  __typename?: 'SearchCancellationRuleResponse';
  cancellationRuleActivityConnection?: Maybe<CancellationRuleActivityConnection>;
  cancellationRuleConnection?: Maybe<CancellationRuleConnection>;
};


export type SearchCancellationRuleResponseCancellationRuleActivityConnectionArgs = {
  input?: InputMaybe<CancellationRuleActivityConnectionInput>;
};


export type SearchCancellationRuleResponseCancellationRuleConnectionArgs = {
  input?: InputMaybe<CancellationRuleConnectionInput>;
};

export type SearchCharityAmountHistoryResponse = {
  __typename?: 'SearchCharityAmountHistoryResponse';
  charityAmountHistoryActivityConnection?: Maybe<CharityAmountHistoryActivityConnection>;
  charityAmountHistoryConnection?: Maybe<CharityAmountHistoryConnection>;
};


export type SearchCharityAmountHistoryResponseCharityAmountHistoryActivityConnectionArgs = {
  input?: InputMaybe<CharityAmountHistoryActivityConnectionInput>;
};


export type SearchCharityAmountHistoryResponseCharityAmountHistoryConnectionArgs = {
  input?: InputMaybe<CharityAmountHistoryConnectionInput>;
};

export type SearchCharityRatingHistoryReportResponse = {
  __typename?: 'SearchCharityRatingHistoryReportResponse';
  charityRatingHistoryReportActivityConnection?: Maybe<CharityRatingHistoryReportActivityConnection>;
  charityRatingHistoryReportConnection?: Maybe<CharityRatingHistoryReportConnection>;
};


export type SearchCharityRatingHistoryReportResponseCharityRatingHistoryReportActivityConnectionArgs = {
  input?: InputMaybe<CharityRatingHistoryReportActivityConnectionInput>;
};


export type SearchCharityRatingHistoryReportResponseCharityRatingHistoryReportConnectionArgs = {
  input?: InputMaybe<CharityRatingHistoryReportConnectionInput>;
};

export type SearchCharityRatingHistoryResponse = {
  __typename?: 'SearchCharityRatingHistoryResponse';
  charityRatingHistoryActivityConnection?: Maybe<CharityRatingHistoryActivityConnection>;
  charityRatingHistoryConnection?: Maybe<CharityRatingHistoryConnection>;
};


export type SearchCharityRatingHistoryResponseCharityRatingHistoryActivityConnectionArgs = {
  input?: InputMaybe<CharityRatingHistoryActivityConnectionInput>;
};


export type SearchCharityRatingHistoryResponseCharityRatingHistoryConnectionArgs = {
  input?: InputMaybe<CharityRatingHistoryConnectionInput>;
};

export type SearchCharityRatingHistoryWithUserResponse = {
  __typename?: 'SearchCharityRatingHistoryWithUserResponse';
  charityRatingHistoryWithUserActivityConnection?: Maybe<CharityRatingHistoryWithUserActivityConnection>;
  charityRatingHistoryWithUserConnection?: Maybe<CharityRatingHistoryWithUserConnection>;
};


export type SearchCharityRatingHistoryWithUserResponseCharityRatingHistoryWithUserActivityConnectionArgs = {
  input?: InputMaybe<CharityRatingHistoryWithUserActivityConnectionInput>;
};


export type SearchCharityRatingHistoryWithUserResponseCharityRatingHistoryWithUserConnectionArgs = {
  input?: InputMaybe<CharityRatingHistoryWithUserConnectionInput>;
};

export type SearchCharityResponse = {
  __typename?: 'SearchCharityResponse';
  charityActivityConnection?: Maybe<CharityActivityConnection>;
  charityConnection?: Maybe<CharityConnection>;
};


export type SearchCharityResponseCharityActivityConnectionArgs = {
  input?: InputMaybe<CharityActivityConnectionInput>;
};


export type SearchCharityResponseCharityConnectionArgs = {
  input?: InputMaybe<CharityConnectionInput>;
};

export type SearchCharityWithAmountHistoryResponse = {
  __typename?: 'SearchCharityWithAmountHistoryResponse';
  charityWithAmountHistoryActivityConnection?: Maybe<CharityWithAmountHistoryActivityConnection>;
  charityWithAmountHistoryConnection?: Maybe<CharityWithAmountHistoryConnection>;
};


export type SearchCharityWithAmountHistoryResponseCharityWithAmountHistoryActivityConnectionArgs = {
  input?: InputMaybe<CharityWithAmountHistoryActivityConnectionInput>;
};


export type SearchCharityWithAmountHistoryResponseCharityWithAmountHistoryConnectionArgs = {
  input?: InputMaybe<CharityWithAmountHistoryConnectionInput>;
};

export type SearchChatHistoryInput = {
  airline?: InputMaybe<Scalars['String']['input']>;
  endDatetime: Scalars['String']['input'];
  keyword?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  startDatetime: Scalars['String']['input'];
  userName?: InputMaybe<Scalars['String']['input']>;
};

export type SearchChatHistoryResponse = {
  __typename?: 'SearchChatHistoryResponse';
  messages: Array<ChatHistoryMessage>;
  total: Scalars['Int']['output'];
};

export type SearchChatQuickReplyMessageResponse = {
  __typename?: 'SearchChatQuickReplyMessageResponse';
  chatQuickReplyMessageConnection?: Maybe<ChatQuickReplyMessageConnection>;
};


export type SearchChatQuickReplyMessageResponseChatQuickReplyMessageConnectionArgs = {
  input?: InputMaybe<ChatQuickReplyMessageConnectionInput>;
};

export type SearchCheckinEventResponse = {
  __typename?: 'SearchCheckinEventResponse';
  checkinEventActivityConnection?: Maybe<CheckinEventActivityConnection>;
  checkinEventConnection?: Maybe<CheckinEventConnection>;
};


export type SearchCheckinEventResponseCheckinEventActivityConnectionArgs = {
  input?: InputMaybe<CheckinEventActivityConnectionInput>;
};


export type SearchCheckinEventResponseCheckinEventConnectionArgs = {
  input?: InputMaybe<CheckinEventConnectionInput>;
};

export type SearchClosestRateItemResponse = {
  __typename?: 'SearchClosestRateItemResponse';
  closestRateItemActivityConnection?: Maybe<ClosestRateItemActivityConnection>;
  closestRateItemConnection?: Maybe<ClosestRateItemConnection>;
};


export type SearchClosestRateItemResponseClosestRateItemActivityConnectionArgs = {
  input?: InputMaybe<ClosestRateItemActivityConnectionInput>;
};


export type SearchClosestRateItemResponseClosestRateItemConnectionArgs = {
  input?: InputMaybe<ClosestRateItemConnectionInput>;
};

export type SearchCombinableTripConnection = {
  __typename?: 'SearchCombinableTripConnection';
  edges?: Maybe<Array<Maybe<CombinableTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SearchCombinableTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripSearch>>;
};

export type SearchCombinableTripsResponse = {
  __typename?: 'SearchCombinableTripsResponse';
  combinableTripsConnection?: Maybe<SearchCombinableTripConnection>;
};


export type SearchCombinableTripsResponseCombinableTripsConnectionArgs = {
  input?: InputMaybe<SearchCombinableTripConnectionInput>;
};

export type SearchCombineRuleHistoryResponse = {
  __typename?: 'SearchCombineRuleHistoryResponse';
  combineRuleHistoryActivityConnection?: Maybe<CombineRuleHistoryActivityConnection>;
  combineRuleHistoryConnection?: Maybe<CombineRuleHistoryConnection>;
};


export type SearchCombineRuleHistoryResponseCombineRuleHistoryActivityConnectionArgs = {
  input?: InputMaybe<CombineRuleHistoryActivityConnectionInput>;
};


export type SearchCombineRuleHistoryResponseCombineRuleHistoryConnectionArgs = {
  input?: InputMaybe<CombineRuleHistoryConnectionInput>;
};

export type SearchCombineRuleHistoryWithContractResponse = {
  __typename?: 'SearchCombineRuleHistoryWithContractResponse';
  combineRuleHistoryWithContractActivityConnection?: Maybe<CombineRuleHistoryWithContractActivityConnection>;
  combineRuleHistoryWithContractConnection?: Maybe<CombineRuleHistoryWithContractConnection>;
};


export type SearchCombineRuleHistoryWithContractResponseCombineRuleHistoryWithContractActivityConnectionArgs = {
  input?: InputMaybe<CombineRuleHistoryWithContractActivityConnectionInput>;
};


export type SearchCombineRuleHistoryWithContractResponseCombineRuleHistoryWithContractConnectionArgs = {
  input?: InputMaybe<CombineRuleHistoryWithContractConnectionInput>;
};

export type SearchCombineRuleResponse = {
  __typename?: 'SearchCombineRuleResponse';
  combineRuleConnection?: Maybe<CombineRuleConnection>;
  combineRuleTableConnection?: Maybe<CombineRuleConnection>;
};


export type SearchCombineRuleResponseCombineRuleConnectionArgs = {
  input?: InputMaybe<CombineRuleConnectionInput>;
};


export type SearchCombineRuleResponseCombineRuleTableConnectionArgs = {
  input?: InputMaybe<CombineRuleWithContractConnectionInput>;
};

export type SearchCombineRuleWithContractResponse = {
  __typename?: 'SearchCombineRuleWithContractResponse';
  combineRuleWithContractActivityConnection?: Maybe<CombineRuleWithContractActivityConnection>;
  combineRuleWithContractConnection?: Maybe<CombineRuleWithContractConnection>;
};


export type SearchCombineRuleWithContractResponseCombineRuleWithContractActivityConnectionArgs = {
  input?: InputMaybe<CombineRuleWithContractActivityConnectionInput>;
};


export type SearchCombineRuleWithContractResponseCombineRuleWithContractConnectionArgs = {
  input?: InputMaybe<CombineRuleWithContractConnectionInput>;
};

export type SearchCommunicationResponse = {
  __typename?: 'SearchCommunicationResponse';
  communicationConnection?: Maybe<CommunicationConnection>;
};


export type SearchCommunicationResponseCommunicationConnectionArgs = {
  input?: InputMaybe<CommunicationConnectionInput>;
};

export type SearchCompaniesResponse = {
  __typename?: 'SearchCompaniesResponse';
  companyConnection?: Maybe<CompanyConnection>;
};


export type SearchCompaniesResponseCompanyConnectionArgs = {
  input?: InputMaybe<CompanyConnectionInput>;
};

export type SearchCompanyResponse = {
  __typename?: 'SearchCompanyResponse';
  companyActivityConnection?: Maybe<CompanyActivityConnection>;
  companyConnection?: Maybe<CompanyConnection>;
};


export type SearchCompanyResponseCompanyActivityConnectionArgs = {
  input?: InputMaybe<CompanyActivityConnectionInput>;
};


export type SearchCompanyResponseCompanyConnectionArgs = {
  input?: InputMaybe<CompanyConnectionInput>;
};

export type SearchCompletionResponse = {
  __typename?: 'SearchCompletionResponse';
  completionActivityConnection?: Maybe<CompletionActivityConnection>;
  completionConnection?: Maybe<CompletionConnection>;
};


export type SearchCompletionResponseCompletionActivityConnectionArgs = {
  input?: InputMaybe<CompletionActivityConnectionInput>;
};


export type SearchCompletionResponseCompletionConnectionArgs = {
  input?: InputMaybe<CompletionConnectionInput>;
};

export type SearchCompletionTypeResponse = {
  __typename?: 'SearchCompletionTypeResponse';
  completionTypeActivityConnection?: Maybe<CompletionTypeActivityConnection>;
  completionTypeConnection?: Maybe<CompletionTypeConnection>;
};


export type SearchCompletionTypeResponseCompletionTypeActivityConnectionArgs = {
  input?: InputMaybe<CompletionTypeActivityConnectionInput>;
};


export type SearchCompletionTypeResponseCompletionTypeConnectionArgs = {
  input?: InputMaybe<CompletionTypeConnectionInput>;
};

export type SearchCompletionWithTypeResponse = {
  __typename?: 'SearchCompletionWithTypeResponse';
  completionWithTypeActivityConnection?: Maybe<CompletionWithTypeActivityConnection>;
  completionWithTypeConnection?: Maybe<CompletionWithTypeConnection>;
};


export type SearchCompletionWithTypeResponseCompletionWithTypeActivityConnectionArgs = {
  input?: InputMaybe<CompletionWithTypeActivityConnectionInput>;
};


export type SearchCompletionWithTypeResponseCompletionWithTypeConnectionArgs = {
  input?: InputMaybe<CompletionWithTypeConnectionInput>;
};

export type SearchContractEmailResponse = {
  __typename?: 'SearchContractEmailResponse';
  contractEmailActivityConnection?: Maybe<ContractEmailActivityConnection>;
  contractEmailConnection?: Maybe<ContractEmailConnection>;
};


export type SearchContractEmailResponseContractEmailActivityConnectionArgs = {
  input?: InputMaybe<ContractEmailActivityConnectionInput>;
};


export type SearchContractEmailResponseContractEmailConnectionArgs = {
  input?: InputMaybe<ContractEmailConnectionInput>;
};

export type SearchContractNumberResponse = {
  __typename?: 'SearchContractNumberResponse';
  contractNumberActivityConnection?: Maybe<ContractNumberActivityConnection>;
  contractNumberConnection?: Maybe<ContractNumberConnection>;
};


export type SearchContractNumberResponseContractNumberActivityConnectionArgs = {
  input?: InputMaybe<ContractNumberActivityConnectionInput>;
};


export type SearchContractNumberResponseContractNumberConnectionArgs = {
  input?: InputMaybe<ContractNumberConnectionInput>;
};

export type SearchContractResponse = {
  __typename?: 'SearchContractResponse';
  contractActivityConnection?: Maybe<ContractActivityConnection>;
  contractConnection?: Maybe<ContractConnection>;
};


export type SearchContractResponseContractActivityConnectionArgs = {
  input?: InputMaybe<ContractActivityConnectionInput>;
};


export type SearchContractResponseContractConnectionArgs = {
  input?: InputMaybe<ContractConnectionInput>;
};

export type SearchCountryRegionResponse = {
  __typename?: 'SearchCountryRegionResponse';
  countryRegionActivityConnection?: Maybe<CountryRegionActivityConnection>;
  countryRegionConnection?: Maybe<CountryRegionConnection>;
};


export type SearchCountryRegionResponseCountryRegionActivityConnectionArgs = {
  input?: InputMaybe<CountryRegionActivityConnectionInput>;
};


export type SearchCountryRegionResponseCountryRegionConnectionArgs = {
  input?: InputMaybe<CountryRegionConnectionInput>;
};

export type SearchCrewCountRequirementResponse = {
  __typename?: 'SearchCrewCountRequirementResponse';
  crewCountRequirementConnection?: Maybe<CrewCountRequirementConnection>;
};


export type SearchCrewCountRequirementResponseCrewCountRequirementConnectionArgs = {
  input?: InputMaybe<CrewCountRequirementConnectionInput>;
};

export type SearchDashboardResponse = {
  __typename?: 'SearchDashboardResponse';
  dashboardConnection?: Maybe<DashboardConnection>;
};


export type SearchDashboardResponseDashboardConnectionArgs = {
  input?: InputMaybe<DashboardConnectionInput>;
};

export type SearchDefectResponse = {
  __typename?: 'SearchDefectResponse';
  defectActivityConnection?: Maybe<DefectActivityConnection>;
  defectConnection?: Maybe<DefectConnection>;
};


export type SearchDefectResponseDefectActivityConnectionArgs = {
  input?: InputMaybe<DefectActivityConnectionInput>;
};


export type SearchDefectResponseDefectConnectionArgs = {
  input?: InputMaybe<DefectConnectionInput>;
};

export type SearchDeviceMetricResponse = {
  __typename?: 'SearchDeviceMetricResponse';
  deviceMetricActivityConnection?: Maybe<DeviceMetricActivityConnection>;
  deviceMetricConnection?: Maybe<DeviceMetricConnection>;
};


export type SearchDeviceMetricResponseDeviceMetricActivityConnectionArgs = {
  input?: InputMaybe<DeviceMetricActivityConnectionInput>;
};


export type SearchDeviceMetricResponseDeviceMetricConnectionArgs = {
  input?: InputMaybe<DeviceMetricConnectionInput>;
};

export type SearchDeviceMetricWithUserResponse = {
  __typename?: 'SearchDeviceMetricWithUserResponse';
  deviceMetricWithUserActivityConnection?: Maybe<DeviceMetricWithUserActivityConnection>;
  deviceMetricWithUserConnection?: Maybe<DeviceMetricWithUserConnection>;
};


export type SearchDeviceMetricWithUserResponseDeviceMetricWithUserActivityConnectionArgs = {
  input?: InputMaybe<DeviceMetricWithUserActivityConnectionInput>;
};


export type SearchDeviceMetricWithUserResponseDeviceMetricWithUserConnectionArgs = {
  input?: InputMaybe<DeviceMetricWithUserConnectionInput>;
};

export type SearchDeviceResponse = {
  __typename?: 'SearchDeviceResponse';
  deviceActivityConnection?: Maybe<DeviceActivityConnection>;
  deviceConnection?: Maybe<DeviceConnection>;
};


export type SearchDeviceResponseDeviceActivityConnectionArgs = {
  input?: InputMaybe<DeviceActivityConnectionInput>;
};


export type SearchDeviceResponseDeviceConnectionArgs = {
  input?: InputMaybe<DeviceConnectionInput>;
};

export type SearchDispatchIssueCausedByResponse = {
  __typename?: 'SearchDispatchIssueCausedByResponse';
  dispatchIssueCausedByConnection?: Maybe<DispatchIssueCausedByConnection>;
};


export type SearchDispatchIssueCausedByResponseDispatchIssueCausedByConnectionArgs = {
  input?: InputMaybe<DispatchIssueCausedByConnectionInput>;
};

export type SearchDispatchIssueCausedByWithCacheResponse = {
  __typename?: 'SearchDispatchIssueCausedByWithCacheResponse';
  dispatchIssueCausedByWithCacheActivityConnection?: Maybe<DispatchIssueCausedByWithCacheActivityConnection>;
  dispatchIssueCausedByWithCacheConnection?: Maybe<DispatchIssueCausedByWithCacheConnection>;
};


export type SearchDispatchIssueCausedByWithCacheResponseDispatchIssueCausedByWithCacheActivityConnectionArgs = {
  input?: InputMaybe<DispatchIssueCausedByWithCacheActivityConnectionInput>;
};


export type SearchDispatchIssueCausedByWithCacheResponseDispatchIssueCausedByWithCacheConnectionArgs = {
  input?: InputMaybe<DispatchIssueCausedByWithCacheConnectionInput>;
};

export type SearchDispatchIssueDocumentResponse = {
  __typename?: 'SearchDispatchIssueDocumentResponse';
  dispatchIssueDocumentConnection?: Maybe<DispatchIssueDocumentConnection>;
};


export type SearchDispatchIssueDocumentResponseDispatchIssueDocumentConnectionArgs = {
  input?: InputMaybe<DispatchIssueDocumentConnectionInput>;
};

export type SearchDispatchIssueResponse = {
  __typename?: 'SearchDispatchIssueResponse';
  dispatchIssueConnection?: Maybe<DispatchIssueConnection>;
  dispatchIssueTableConnection?: Maybe<DispatchIssueWithCacheConnection>;
};


export type SearchDispatchIssueResponseDispatchIssueConnectionArgs = {
  input?: InputMaybe<DispatchIssueConnectionInput>;
};


export type SearchDispatchIssueResponseDispatchIssueTableConnectionArgs = {
  input?: InputMaybe<DispatchIssueWithCacheConnectionInput>;
};

export type SearchDispatchIssueWithCacheResponse = {
  __typename?: 'SearchDispatchIssueWithCacheResponse';
  dispatchIssueWithCacheActivityConnection?: Maybe<DispatchIssueWithCacheActivityConnection>;
  dispatchIssueWithCacheConnection?: Maybe<DispatchIssueWithCacheConnection>;
};


export type SearchDispatchIssueWithCacheResponseDispatchIssueWithCacheActivityConnectionArgs = {
  input?: InputMaybe<DispatchIssueWithCacheActivityConnectionInput>;
};


export type SearchDispatchIssueWithCacheResponseDispatchIssueWithCacheConnectionArgs = {
  input?: InputMaybe<DispatchIssueWithCacheConnectionInput>;
};

export type SearchDispatchSummaryDocumentResponse = {
  __typename?: 'SearchDispatchSummaryDocumentResponse';
  dispatchSummaryDocumentConnection?: Maybe<DispatchSummaryDocumentConnection>;
};


export type SearchDispatchSummaryDocumentResponseDispatchSummaryDocumentConnectionArgs = {
  input?: InputMaybe<DispatchSummaryDocumentConnectionInput>;
};

export type SearchDispatchSummaryMarketResponse = {
  __typename?: 'SearchDispatchSummaryMarketResponse';
  dispatchSummaryMarketConnection?: Maybe<DispatchSummaryMarketConnection>;
};


export type SearchDispatchSummaryMarketResponseDispatchSummaryMarketConnectionArgs = {
  input?: InputMaybe<DispatchSummaryMarketConnectionInput>;
};

export type SearchDispatchSummaryResponse = {
  __typename?: 'SearchDispatchSummaryResponse';
  dispatchSummaryConnection?: Maybe<DispatchSummaryConnection>;
  dispatchSummaryTableConnection?: Maybe<DispatchSummaryWithCacheConnection>;
};


export type SearchDispatchSummaryResponseDispatchSummaryConnectionArgs = {
  input?: InputMaybe<DispatchSummaryConnectionInput>;
};


export type SearchDispatchSummaryResponseDispatchSummaryTableConnectionArgs = {
  input?: InputMaybe<DispatchSummaryWithCacheConnectionInput>;
};

export type SearchDispatchSummaryWithCacheResponse = {
  __typename?: 'SearchDispatchSummaryWithCacheResponse';
  dispatchSummaryWithCacheActivityConnection?: Maybe<DispatchSummaryWithCacheActivityConnection>;
  dispatchSummaryWithCacheConnection?: Maybe<DispatchSummaryWithCacheConnection>;
};


export type SearchDispatchSummaryWithCacheResponseDispatchSummaryWithCacheActivityConnectionArgs = {
  input?: InputMaybe<DispatchSummaryWithCacheActivityConnectionInput>;
};


export type SearchDispatchSummaryWithCacheResponseDispatchSummaryWithCacheConnectionArgs = {
  input?: InputMaybe<DispatchSummaryWithCacheConnectionInput>;
};

export type SearchDistanceResponse = {
  __typename?: 'SearchDistanceResponse';
  distanceActivityConnection?: Maybe<DistanceActivityConnection>;
  distanceConnection?: Maybe<DistanceConnection>;
};


export type SearchDistanceResponseDistanceActivityConnectionArgs = {
  input?: InputMaybe<DistanceActivityConnectionInput>;
};


export type SearchDistanceResponseDistanceConnectionArgs = {
  input?: InputMaybe<DistanceConnectionInput>;
};

export type SearchDriverEtaResponse = {
  __typename?: 'SearchDriverEtaResponse';
  driverEtaActivityConnection?: Maybe<DriverEtaActivityConnection>;
  driverEtaConnection?: Maybe<DriverEtaConnection>;
};


export type SearchDriverEtaResponseDriverEtaActivityConnectionArgs = {
  input?: InputMaybe<DriverEtaActivityConnectionInput>;
};


export type SearchDriverEtaResponseDriverEtaConnectionArgs = {
  input?: InputMaybe<DriverEtaConnectionInput>;
};

export type SearchDriverEtaWithPreviousTripResponse = {
  __typename?: 'SearchDriverEtaWithPreviousTripResponse';
  driverEtaWithPreviousTripConnection?: Maybe<DriverEtaWithPreviousTripConnection>;
};


export type SearchDriverEtaWithPreviousTripResponseDriverEtaWithPreviousTripConnectionArgs = {
  input?: InputMaybe<DriverEtaWithPreviousTripConnectionInput>;
};

export type SearchDriverVehicleAssignmentResponse = {
  __typename?: 'SearchDriverVehicleAssignmentResponse';
  driverVehicleAssignmentActivityConnection?: Maybe<DriverVehicleAssignmentActivityConnection>;
  driverVehicleAssignmentConnection?: Maybe<DriverVehicleAssignmentConnection>;
};


export type SearchDriverVehicleAssignmentResponseDriverVehicleAssignmentActivityConnectionArgs = {
  input?: InputMaybe<DriverVehicleAssignmentActivityConnectionInput>;
};


export type SearchDriverVehicleAssignmentResponseDriverVehicleAssignmentConnectionArgs = {
  input?: InputMaybe<DriverVehicleAssignmentConnectionInput>;
};

export type SearchDtrLocationResponse = {
  __typename?: 'SearchDtrLocationResponse';
  dtrLocationConnection?: Maybe<DtrLocationConnection>;
};


export type SearchDtrLocationResponseDtrLocationConnectionArgs = {
  input?: InputMaybe<DtrLocationConnectionInput>;
};

export type SearchDvirResponse = {
  __typename?: 'SearchDvirResponse';
  dvirActivityConnection?: Maybe<DvirActivityConnection>;
  dvirConnection?: Maybe<DvirConnection>;
};


export type SearchDvirResponseDvirActivityConnectionArgs = {
  input?: InputMaybe<DvirActivityConnectionInput>;
};


export type SearchDvirResponseDvirConnectionArgs = {
  input?: InputMaybe<DvirConnectionInput>;
};

export type SearchDvirSignatureResponse = {
  __typename?: 'SearchDvirSignatureResponse';
  dvirSignatureActivityConnection?: Maybe<DvirSignatureActivityConnection>;
  dvirSignatureConnection?: Maybe<DvirSignatureConnection>;
};


export type SearchDvirSignatureResponseDvirSignatureActivityConnectionArgs = {
  input?: InputMaybe<DvirSignatureActivityConnectionInput>;
};


export type SearchDvirSignatureResponseDvirSignatureConnectionArgs = {
  input?: InputMaybe<DvirSignatureConnectionInput>;
};

export type SearchEmailResponse = {
  __typename?: 'SearchEmailResponse';
  emailActivityConnection?: Maybe<EmailActivityConnection>;
  emailConnection?: Maybe<EmailConnection>;
};


export type SearchEmailResponseEmailActivityConnectionArgs = {
  input?: InputMaybe<EmailActivityConnectionInput>;
};


export type SearchEmailResponseEmailConnectionArgs = {
  input?: InputMaybe<EmailConnectionInput>;
};

export type SearchEquivalentTripResponse = {
  __typename?: 'SearchEquivalentTripResponse';
  equivalentTripActivityConnection?: Maybe<EquivalentTripActivityConnection>;
  equivalentTripConnection?: Maybe<EquivalentTripConnection>;
};


export type SearchEquivalentTripResponseEquivalentTripActivityConnectionArgs = {
  input?: InputMaybe<EquivalentTripActivityConnectionInput>;
};


export type SearchEquivalentTripResponseEquivalentTripConnectionArgs = {
  input?: InputMaybe<EquivalentTripConnectionInput>;
};

export type SearchEventResponse = {
  __typename?: 'SearchEventResponse';
  eventActivityConnection?: Maybe<EventActivityConnection>;
  eventConnection?: Maybe<EventConnection>;
};


export type SearchEventResponseEventActivityConnectionArgs = {
  input?: InputMaybe<EventActivityConnectionInput>;
};


export type SearchEventResponseEventConnectionArgs = {
  input?: InputMaybe<EventConnectionInput>;
};

export type SearchFcrResponse = {
  __typename?: 'SearchFcrResponse';
  fcrConnection?: Maybe<FcrConnection>;
  tripWithFcrInnerJoinConnection?: Maybe<TripWithFcrInnerJoinConnection>;
};


export type SearchFcrResponseFcrConnectionArgs = {
  input?: InputMaybe<FcrConnectionInput>;
};


export type SearchFcrResponseTripWithFcrInnerJoinConnectionArgs = {
  input?: InputMaybe<TripWithFcrInnerJoinConnectionInput>;
};

export type SearchFcrTypeResponse = {
  __typename?: 'SearchFcrTypeResponse';
  fcrTypeConnection?: Maybe<FcrTypeConnection>;
};


export type SearchFcrTypeResponseFcrTypeConnectionArgs = {
  input?: InputMaybe<FcrTypeConnectionInput>;
};

export type SearchFlagHasPotentialTripResponse = {
  __typename?: 'SearchFlagHasPotentialTripResponse';
  flagHasPotentialTripActivityConnection?: Maybe<FlagHasPotentialTripActivityConnection>;
  flagHasPotentialTripConnection?: Maybe<FlagHasPotentialTripConnection>;
};


export type SearchFlagHasPotentialTripResponseFlagHasPotentialTripActivityConnectionArgs = {
  input?: InputMaybe<FlagHasPotentialTripActivityConnectionInput>;
};


export type SearchFlagHasPotentialTripResponseFlagHasPotentialTripConnectionArgs = {
  input?: InputMaybe<FlagHasPotentialTripConnectionInput>;
};

export type SearchFlagHasStagedTripResponse = {
  __typename?: 'SearchFlagHasStagedTripResponse';
  flagHasStagedTripActivityConnection?: Maybe<FlagHasStagedTripActivityConnection>;
  flagHasStagedTripConnection?: Maybe<FlagHasStagedTripConnection>;
};


export type SearchFlagHasStagedTripResponseFlagHasStagedTripActivityConnectionArgs = {
  input?: InputMaybe<FlagHasStagedTripActivityConnectionInput>;
};


export type SearchFlagHasStagedTripResponseFlagHasStagedTripConnectionArgs = {
  input?: InputMaybe<FlagHasStagedTripConnectionInput>;
};

export type SearchFlagHasTripResponse = {
  __typename?: 'SearchFlagHasTripResponse';
  flagHasTripActivityConnection?: Maybe<FlagHasTripActivityConnection>;
  flagHasTripConnection?: Maybe<FlagHasTripConnection>;
};


export type SearchFlagHasTripResponseFlagHasTripActivityConnectionArgs = {
  input?: InputMaybe<FlagHasTripActivityConnectionInput>;
};


export type SearchFlagHasTripResponseFlagHasTripConnectionArgs = {
  input?: InputMaybe<FlagHasTripConnectionInput>;
};

export type SearchFlagResponse = {
  __typename?: 'SearchFlagResponse';
  flagConnection?: Maybe<FlagConnection>;
  flagWithTripConnection?: Maybe<FlagWithTripConnection>;
};


export type SearchFlagResponseFlagConnectionArgs = {
  input?: InputMaybe<FlagConnectionInput>;
};


export type SearchFlagResponseFlagWithTripConnectionArgs = {
  input?: InputMaybe<FlagWithTripConnectionInput>;
};

export type SearchFlagWithTripResponse = {
  __typename?: 'SearchFlagWithTripResponse';
  flagWithTripActivityConnection?: Maybe<FlagWithTripActivityConnection>;
  flagWithTripConnection?: Maybe<FlagWithTripConnection>;
};


export type SearchFlagWithTripResponseFlagWithTripActivityConnectionArgs = {
  input?: InputMaybe<FlagWithTripActivityConnectionInput>;
};


export type SearchFlagWithTripResponseFlagWithTripConnectionArgs = {
  input?: InputMaybe<FlagWithTripConnectionInput>;
};

export type SearchFlightHistoryResponse = {
  __typename?: 'SearchFlightHistoryResponse';
  flightHistoryActivityConnection?: Maybe<FlightHistoryActivityConnection>;
  flightHistoryConnection?: Maybe<FlightHistoryConnection>;
};


export type SearchFlightHistoryResponseFlightHistoryActivityConnectionArgs = {
  input?: InputMaybe<FlightHistoryActivityConnectionInput>;
};


export type SearchFlightHistoryResponseFlightHistoryConnectionArgs = {
  input?: InputMaybe<FlightHistoryConnectionInput>;
};

export type SearchGeneratedDocumentLogResponse = {
  __typename?: 'SearchGeneratedDocumentLogResponse';
  generatedDocumentLogActivityConnection?: Maybe<GeneratedDocumentLogActivityConnection>;
  generatedDocumentLogConnection?: Maybe<GeneratedDocumentLogConnection>;
};


export type SearchGeneratedDocumentLogResponseGeneratedDocumentLogActivityConnectionArgs = {
  input?: InputMaybe<GeneratedDocumentLogActivityConnectionInput>;
};


export type SearchGeneratedDocumentLogResponseGeneratedDocumentLogConnectionArgs = {
  input?: InputMaybe<GeneratedDocumentLogConnectionInput>;
};

export type SearchGeneratedDocumentResponse = {
  __typename?: 'SearchGeneratedDocumentResponse';
  generatedDocumentConnection?: Maybe<GeneratedDocumentConnection>;
};


export type SearchGeneratedDocumentResponseGeneratedDocumentConnectionArgs = {
  input?: InputMaybe<GeneratedDocumentConnectionInput>;
};

export type SearchGroupHasPermissionResponse = {
  __typename?: 'SearchGroupHasPermissionResponse';
  groupHasPermissionActivityConnection?: Maybe<GroupHasPermissionActivityConnection>;
  groupHasPermissionConnection?: Maybe<GroupHasPermissionConnection>;
};


export type SearchGroupHasPermissionResponseGroupHasPermissionActivityConnectionArgs = {
  input?: InputMaybe<GroupHasPermissionActivityConnectionInput>;
};


export type SearchGroupHasPermissionResponseGroupHasPermissionConnectionArgs = {
  input?: InputMaybe<GroupHasPermissionConnectionInput>;
};

export type SearchGroupHasUserResponse = {
  __typename?: 'SearchGroupHasUserResponse';
  groupHasUserActivityConnection?: Maybe<GroupHasUserActivityConnection>;
  groupHasUserConnection?: Maybe<GroupHasUserConnection>;
};


export type SearchGroupHasUserResponseGroupHasUserActivityConnectionArgs = {
  input?: InputMaybe<GroupHasUserActivityConnectionInput>;
};


export type SearchGroupHasUserResponseGroupHasUserConnectionArgs = {
  input?: InputMaybe<GroupHasUserConnectionInput>;
};

export type SearchGroupHasUserWithPermissionsResponse = {
  __typename?: 'SearchGroupHasUserWithPermissionsResponse';
  groupHasUserWithPermissionsActivityConnection?: Maybe<GroupHasUserWithPermissionsActivityConnection>;
  groupHasUserWithPermissionsConnection?: Maybe<GroupHasUserWithPermissionsConnection>;
};


export type SearchGroupHasUserWithPermissionsResponseGroupHasUserWithPermissionsActivityConnectionArgs = {
  input?: InputMaybe<GroupHasUserWithPermissionsActivityConnectionInput>;
};


export type SearchGroupHasUserWithPermissionsResponseGroupHasUserWithPermissionsConnectionArgs = {
  input?: InputMaybe<GroupHasUserWithPermissionsConnectionInput>;
};

export type SearchGroupResponse = {
  __typename?: 'SearchGroupResponse';
  groupConnection?: Maybe<GroupConnection>;
};


export type SearchGroupResponseGroupConnectionArgs = {
  input?: InputMaybe<GroupConnectionInput>;
};

export type SearchImageResponse = {
  __typename?: 'SearchImageResponse';
  imageConnection?: Maybe<ImageConnection>;
};


export type SearchImageResponseImageConnectionArgs = {
  input?: InputMaybe<ImageConnectionInput>;
};

export type SearchImportEmailResponse = {
  __typename?: 'SearchImportEmailResponse';
  importEmailActivityConnection?: Maybe<ImportEmailActivityConnection>;
  importEmailConnection?: Maybe<ImportEmailConnection>;
};


export type SearchImportEmailResponseImportEmailActivityConnectionArgs = {
  input?: InputMaybe<ImportEmailActivityConnectionInput>;
};


export type SearchImportEmailResponseImportEmailConnectionArgs = {
  input?: InputMaybe<ImportEmailConnectionInput>;
};

export type SearchImportFailureResponse = {
  __typename?: 'SearchImportFailureResponse';
  importFailureActivityConnection?: Maybe<ImportFailureActivityConnection>;
  importFailureConnection?: Maybe<ImportFailureConnection>;
};


export type SearchImportFailureResponseImportFailureActivityConnectionArgs = {
  input?: InputMaybe<ImportFailureActivityConnectionInput>;
};


export type SearchImportFailureResponseImportFailureConnectionArgs = {
  input?: InputMaybe<ImportFailureConnectionInput>;
};

export type SearchImportLogResponse = {
  __typename?: 'SearchImportLogResponse';
  importLogActivityConnection?: Maybe<ImportLogActivityConnection>;
  importLogConnection?: Maybe<ImportLogConnection>;
};


export type SearchImportLogResponseImportLogActivityConnectionArgs = {
  input?: InputMaybe<ImportLogActivityConnectionInput>;
};


export type SearchImportLogResponseImportLogConnectionArgs = {
  input?: InputMaybe<ImportLogConnectionInput>;
};

export type SearchImportOcrCacheResponse = {
  __typename?: 'SearchImportOcrCacheResponse';
  importOcrCacheActivityConnection?: Maybe<ImportOcrCacheActivityConnection>;
  importOcrCacheConnection?: Maybe<ImportOcrCacheConnection>;
};


export type SearchImportOcrCacheResponseImportOcrCacheActivityConnectionArgs = {
  input?: InputMaybe<ImportOcrCacheActivityConnectionInput>;
};


export type SearchImportOcrCacheResponseImportOcrCacheConnectionArgs = {
  input?: InputMaybe<ImportOcrCacheConnectionInput>;
};

export type SearchImportResponse = {
  __typename?: 'SearchImportResponse';
  importActivityConnection?: Maybe<ImportActivityConnection>;
  importConnection?: Maybe<ImportConnection>;
};


export type SearchImportResponseImportActivityConnectionArgs = {
  input?: InputMaybe<ImportActivityConnectionInput>;
};


export type SearchImportResponseImportConnectionArgs = {
  input?: InputMaybe<ImportConnectionInput>;
};

export type SearchImportWithAirportResponse = {
  __typename?: 'SearchImportWithAirportResponse';
  importWithAirportActivityConnection?: Maybe<ImportWithAirportActivityConnection>;
  importWithAirportConnection?: Maybe<ImportWithAirportConnection>;
};


export type SearchImportWithAirportResponseImportWithAirportActivityConnectionArgs = {
  input?: InputMaybe<ImportWithAirportActivityConnectionInput>;
};


export type SearchImportWithAirportResponseImportWithAirportConnectionArgs = {
  input?: InputMaybe<ImportWithAirportConnectionInput>;
};

export type SearchImportWithAirportWithCacheResponse = {
  __typename?: 'SearchImportWithAirportWithCacheResponse';
  importWithAirportWithCacheActivityConnection?: Maybe<ImportWithAirportWithCacheActivityConnection>;
  importWithAirportWithCacheConnection?: Maybe<ImportWithAirportWithCacheConnection>;
};


export type SearchImportWithAirportWithCacheResponseImportWithAirportWithCacheActivityConnectionArgs = {
  input?: InputMaybe<ImportWithAirportWithCacheActivityConnectionInput>;
};


export type SearchImportWithAirportWithCacheResponseImportWithAirportWithCacheConnectionArgs = {
  input?: InputMaybe<ImportWithAirportWithCacheConnectionInput>;
};

export type SearchImportsResponse = {
  __typename?: 'SearchImportsResponse';
  importConnection?: Maybe<ImportConnection>;
  importWithAirportConnection?: Maybe<ImportConnection>;
};


export type SearchImportsResponseImportConnectionArgs = {
  input?: InputMaybe<ImportConnectionInput>;
};


export type SearchImportsResponseImportWithAirportConnectionArgs = {
  input?: InputMaybe<ImportWithAirportConnectionInput>;
};

export type SearchIncidentIssueDocumentResponse = {
  __typename?: 'SearchIncidentIssueDocumentResponse';
  incidentIssueDocumentConnection?: Maybe<IncidentIssueDocumentConnection>;
};


export type SearchIncidentIssueDocumentResponseIncidentIssueDocumentConnectionArgs = {
  input?: InputMaybe<IncidentIssueDocumentConnectionInput>;
};

export type SearchIncidentIssueResponse = {
  __typename?: 'SearchIncidentIssueResponse';
  incidentIssueConnection?: Maybe<IncidentIssueConnection>;
  incidentIssueTableConnection?: Maybe<IncidentIssueWithCacheConnection>;
};


export type SearchIncidentIssueResponseIncidentIssueConnectionArgs = {
  input?: InputMaybe<IncidentIssueConnectionInput>;
};


export type SearchIncidentIssueResponseIncidentIssueTableConnectionArgs = {
  input?: InputMaybe<IncidentIssueWithCacheConnectionInput>;
};

export type SearchIncidentIssueWithCacheResponse = {
  __typename?: 'SearchIncidentIssueWithCacheResponse';
  incidentIssueWithCacheActivityConnection?: Maybe<IncidentIssueWithCacheActivityConnection>;
  incidentIssueWithCacheConnection?: Maybe<IncidentIssueWithCacheConnection>;
};


export type SearchIncidentIssueWithCacheResponseIncidentIssueWithCacheActivityConnectionArgs = {
  input?: InputMaybe<IncidentIssueWithCacheActivityConnectionInput>;
};


export type SearchIncidentIssueWithCacheResponseIncidentIssueWithCacheConnectionArgs = {
  input?: InputMaybe<IncidentIssueWithCacheConnectionInput>;
};

export type SearchIndexResponse = {
  __typename?: 'SearchIndexResponse';
  indexActivityConnection?: Maybe<IndexActivityConnection>;
  indexConnection?: Maybe<IndexConnection>;
};


export type SearchIndexResponseIndexActivityConnectionArgs = {
  input?: InputMaybe<IndexActivityConnectionInput>;
};


export type SearchIndexResponseIndexConnectionArgs = {
  input?: InputMaybe<IndexConnectionInput>;
};

export type SearchInvoiceAirportResponse = {
  __typename?: 'SearchInvoiceAirportResponse';
  invoiceAirportActivityConnection?: Maybe<InvoiceAirportActivityConnection>;
  invoiceAirportConnection?: Maybe<InvoiceAirportConnection>;
};


export type SearchInvoiceAirportResponseInvoiceAirportActivityConnectionArgs = {
  input?: InputMaybe<InvoiceAirportActivityConnectionInput>;
};


export type SearchInvoiceAirportResponseInvoiceAirportConnectionArgs = {
  input?: InputMaybe<InvoiceAirportConnectionInput>;
};

export type SearchInvoiceClientResponse = {
  __typename?: 'SearchInvoiceClientResponse';
  invoiceClientActivityConnection?: Maybe<InvoiceClientActivityConnection>;
  invoiceClientConnection?: Maybe<InvoiceClientConnection>;
};


export type SearchInvoiceClientResponseInvoiceClientActivityConnectionArgs = {
  input?: InputMaybe<InvoiceClientActivityConnectionInput>;
};


export type SearchInvoiceClientResponseInvoiceClientConnectionArgs = {
  input?: InputMaybe<InvoiceClientConnectionInput>;
};

export type SearchInvoiceCustomChargeResponse = {
  __typename?: 'SearchInvoiceCustomChargeResponse';
  invoiceCustomChargeActivityConnection?: Maybe<InvoiceCustomChargeActivityConnection>;
  invoiceCustomChargeConnection?: Maybe<InvoiceCustomChargeConnection>;
};


export type SearchInvoiceCustomChargeResponseInvoiceCustomChargeActivityConnectionArgs = {
  input?: InputMaybe<InvoiceCustomChargeActivityConnectionInput>;
};


export type SearchInvoiceCustomChargeResponseInvoiceCustomChargeConnectionArgs = {
  input?: InputMaybe<InvoiceCustomChargeConnectionInput>;
};

export type SearchInvoiceDocumentResponse = {
  __typename?: 'SearchInvoiceDocumentResponse';
  invoiceDocumentActivityConnection?: Maybe<InvoiceDocumentActivityConnection>;
  invoiceDocumentConnection?: Maybe<InvoiceDocumentConnection>;
  invoiceDocumentTableConnection?: Maybe<InvoiceDocumentWithSummaryConnection>;
};


export type SearchInvoiceDocumentResponseInvoiceDocumentActivityConnectionArgs = {
  input?: InputMaybe<InvoiceDocumentActivityConnectionInput>;
};


export type SearchInvoiceDocumentResponseInvoiceDocumentConnectionArgs = {
  input?: InputMaybe<InvoiceDocumentConnectionInput>;
};


export type SearchInvoiceDocumentResponseInvoiceDocumentTableConnectionArgs = {
  input?: InputMaybe<InvoiceDocumentWithSummaryConnectionInput>;
};

export type SearchInvoiceDocumentWithSummaryResponse = {
  __typename?: 'SearchInvoiceDocumentWithSummaryResponse';
  invoiceDocumentWithSummaryActivityConnection?: Maybe<InvoiceDocumentWithSummaryActivityConnection>;
  invoiceDocumentWithSummaryConnection?: Maybe<InvoiceDocumentWithSummaryConnection>;
};


export type SearchInvoiceDocumentWithSummaryResponseInvoiceDocumentWithSummaryActivityConnectionArgs = {
  input?: InputMaybe<InvoiceDocumentWithSummaryActivityConnectionInput>;
};


export type SearchInvoiceDocumentWithSummaryResponseInvoiceDocumentWithSummaryConnectionArgs = {
  input?: InputMaybe<InvoiceDocumentWithSummaryConnectionInput>;
};

export type SearchInvoiceEmailResponse = {
  __typename?: 'SearchInvoiceEmailResponse';
  invoiceEmailActivityConnection?: Maybe<InvoiceEmailActivityConnection>;
  invoiceEmailConnection?: Maybe<InvoiceEmailConnection>;
};


export type SearchInvoiceEmailResponseInvoiceEmailActivityConnectionArgs = {
  input?: InputMaybe<InvoiceEmailActivityConnectionInput>;
};


export type SearchInvoiceEmailResponseInvoiceEmailConnectionArgs = {
  input?: InputMaybe<InvoiceEmailConnectionInput>;
};

export type SearchInvoiceHeaderResponse = {
  __typename?: 'SearchInvoiceHeaderResponse';
  invoiceHeaderActivityConnection?: Maybe<InvoiceHeaderActivityConnection>;
  invoiceHeaderConnection?: Maybe<InvoiceHeaderConnection>;
};


export type SearchInvoiceHeaderResponseInvoiceHeaderActivityConnectionArgs = {
  input?: InputMaybe<InvoiceHeaderActivityConnectionInput>;
};


export type SearchInvoiceHeaderResponseInvoiceHeaderConnectionArgs = {
  input?: InputMaybe<InvoiceHeaderConnectionInput>;
};

export type SearchInvoiceIataCodeResponse = {
  __typename?: 'SearchInvoiceIataCodeResponse';
  invoiceIataCodeActivityConnection?: Maybe<InvoiceIataCodeActivityConnection>;
  invoiceIataCodeConnection?: Maybe<InvoiceIataCodeConnection>;
};


export type SearchInvoiceIataCodeResponseInvoiceIataCodeActivityConnectionArgs = {
  input?: InputMaybe<InvoiceIataCodeActivityConnectionInput>;
};


export type SearchInvoiceIataCodeResponseInvoiceIataCodeConnectionArgs = {
  input?: InputMaybe<InvoiceIataCodeConnectionInput>;
};

export type SearchInvoiceLineItemResponse = {
  __typename?: 'SearchInvoiceLineItemResponse';
  invoiceLineItemActivityConnection?: Maybe<InvoiceLineItemActivityConnection>;
  invoiceLineItemConnection?: Maybe<InvoiceLineItemConnection>;
};


export type SearchInvoiceLineItemResponseInvoiceLineItemActivityConnectionArgs = {
  input?: InputMaybe<InvoiceLineItemActivityConnectionInput>;
};


export type SearchInvoiceLineItemResponseInvoiceLineItemConnectionArgs = {
  input?: InputMaybe<InvoiceLineItemConnectionInput>;
};

export type SearchInvoiceProviderCacheResponse = {
  __typename?: 'SearchInvoiceProviderCacheResponse';
  invoiceProviderCacheActivityConnection?: Maybe<InvoiceProviderCacheActivityConnection>;
  invoiceProviderCacheConnection?: Maybe<InvoiceProviderCacheConnection>;
};


export type SearchInvoiceProviderCacheResponseInvoiceProviderCacheActivityConnectionArgs = {
  input?: InputMaybe<InvoiceProviderCacheActivityConnectionInput>;
};


export type SearchInvoiceProviderCacheResponseInvoiceProviderCacheConnectionArgs = {
  input?: InputMaybe<InvoiceProviderCacheConnectionInput>;
};

export type SearchInvoiceResponse = {
  __typename?: 'SearchInvoiceResponse';
  invoiceActivityConnection?: Maybe<InvoiceActivityConnection>;
  invoiceConnection?: Maybe<InvoiceConnection>;
};


export type SearchInvoiceResponseInvoiceActivityConnectionArgs = {
  input?: InputMaybe<InvoiceActivityConnectionInput>;
};


export type SearchInvoiceResponseInvoiceConnectionArgs = {
  input?: InputMaybe<InvoiceConnectionInput>;
};

export type SearchInvoiceTermResponse = {
  __typename?: 'SearchInvoiceTermResponse';
  invoiceTermActivityConnection?: Maybe<InvoiceTermActivityConnection>;
  invoiceTermConnection?: Maybe<InvoiceTermConnection>;
};


export type SearchInvoiceTermResponseInvoiceTermActivityConnectionArgs = {
  input?: InputMaybe<InvoiceTermActivityConnectionInput>;
};


export type SearchInvoiceTermResponseInvoiceTermConnectionArgs = {
  input?: InputMaybe<InvoiceTermConnectionInput>;
};

export type SearchInvoiceTotalSummaryResponse = {
  __typename?: 'SearchInvoiceTotalSummaryResponse';
  invoiceTotalSummaryActivityConnection?: Maybe<InvoiceTotalSummaryActivityConnection>;
  invoiceTotalSummaryConnection?: Maybe<InvoiceTotalSummaryConnection>;
};


export type SearchInvoiceTotalSummaryResponseInvoiceTotalSummaryActivityConnectionArgs = {
  input?: InputMaybe<InvoiceTotalSummaryActivityConnectionInput>;
};


export type SearchInvoiceTotalSummaryResponseInvoiceTotalSummaryConnectionArgs = {
  input?: InputMaybe<InvoiceTotalSummaryConnectionInput>;
};

export type SearchInvoiceTripResponse = {
  __typename?: 'SearchInvoiceTripResponse';
  invoiceTripActivityConnection?: Maybe<InvoiceTripActivityConnection>;
  invoiceTripConnection?: Maybe<InvoiceTripConnection>;
};


export type SearchInvoiceTripResponseInvoiceTripActivityConnectionArgs = {
  input?: InputMaybe<InvoiceTripActivityConnectionInput>;
};


export type SearchInvoiceTripResponseInvoiceTripConnectionArgs = {
  input?: InputMaybe<InvoiceTripConnectionInput>;
};

export type SearchInvoiceTripStatusResponse = {
  __typename?: 'SearchInvoiceTripStatusResponse';
  invoiceTripStatusActivityConnection?: Maybe<InvoiceTripStatusActivityConnection>;
  invoiceTripStatusConnection?: Maybe<InvoiceTripStatusConnection>;
};


export type SearchInvoiceTripStatusResponseInvoiceTripStatusActivityConnectionArgs = {
  input?: InputMaybe<InvoiceTripStatusActivityConnectionInput>;
};


export type SearchInvoiceTripStatusResponseInvoiceTripStatusConnectionArgs = {
  input?: InputMaybe<InvoiceTripStatusConnectionInput>;
};

export type SearchInvoiceTypeResponse = {
  __typename?: 'SearchInvoiceTypeResponse';
  invoiceTypeActivityConnection?: Maybe<InvoiceTypeActivityConnection>;
  invoiceTypeConnection?: Maybe<InvoiceTypeConnection>;
};


export type SearchInvoiceTypeResponseInvoiceTypeActivityConnectionArgs = {
  input?: InputMaybe<InvoiceTypeActivityConnectionInput>;
};


export type SearchInvoiceTypeResponseInvoiceTypeConnectionArgs = {
  input?: InputMaybe<InvoiceTypeConnectionInput>;
};

export type SearchInvoiceUserCacheResponse = {
  __typename?: 'SearchInvoiceUserCacheResponse';
  invoiceUserCacheActivityConnection?: Maybe<InvoiceUserCacheActivityConnection>;
  invoiceUserCacheConnection?: Maybe<InvoiceUserCacheConnection>;
};


export type SearchInvoiceUserCacheResponseInvoiceUserCacheActivityConnectionArgs = {
  input?: InputMaybe<InvoiceUserCacheActivityConnectionInput>;
};


export type SearchInvoiceUserCacheResponseInvoiceUserCacheConnectionArgs = {
  input?: InputMaybe<InvoiceUserCacheConnectionInput>;
};

export type SearchIssueResponse = {
  __typename?: 'SearchIssueResponse';
  issueActivityConnection?: Maybe<IssueActivityConnection>;
  issueConnection?: Maybe<IssueConnection>;
};


export type SearchIssueResponseIssueActivityConnectionArgs = {
  input?: InputMaybe<IssueActivityConnectionInput>;
};


export type SearchIssueResponseIssueConnectionArgs = {
  input?: InputMaybe<IssueConnectionInput>;
};

export type SearchLatestRateHistoryResponse = {
  __typename?: 'SearchLatestRateHistoryResponse';
  latestRateHistoryActivityConnection?: Maybe<LatestRateHistoryActivityConnection>;
  latestRateHistoryConnection?: Maybe<LatestRateHistoryConnection>;
};


export type SearchLatestRateHistoryResponseLatestRateHistoryActivityConnectionArgs = {
  input?: InputMaybe<LatestRateHistoryActivityConnectionInput>;
};


export type SearchLatestRateHistoryResponseLatestRateHistoryConnectionArgs = {
  input?: InputMaybe<LatestRateHistoryConnectionInput>;
};

export type SearchLatestRateResponse = {
  __typename?: 'SearchLatestRateResponse';
  latestRateActivityConnection?: Maybe<LatestRateActivityConnection>;
  latestRateConnection?: Maybe<LatestRateConnection>;
};


export type SearchLatestRateResponseLatestRateActivityConnectionArgs = {
  input?: InputMaybe<LatestRateActivityConnectionInput>;
};


export type SearchLatestRateResponseLatestRateConnectionArgs = {
  input?: InputMaybe<LatestRateConnectionInput>;
};

export type SearchLicenseResponse = {
  __typename?: 'SearchLicenseResponse';
  licenseActivityConnection?: Maybe<LicenseActivityConnection>;
  licenseConnection?: Maybe<LicenseConnection>;
};


export type SearchLicenseResponseLicenseActivityConnectionArgs = {
  input?: InputMaybe<LicenseActivityConnectionInput>;
};


export type SearchLicenseResponseLicenseConnectionArgs = {
  input?: InputMaybe<LicenseConnectionInput>;
};

export type SearchLicenseTypeResponse = {
  __typename?: 'SearchLicenseTypeResponse';
  licenseTypeActivityConnection?: Maybe<LicenseTypeActivityConnection>;
  licenseTypeConnection?: Maybe<LicenseTypeConnection>;
};


export type SearchLicenseTypeResponseLicenseTypeActivityConnectionArgs = {
  input?: InputMaybe<LicenseTypeActivityConnectionInput>;
};


export type SearchLicenseTypeResponseLicenseTypeConnectionArgs = {
  input?: InputMaybe<LicenseTypeConnectionInput>;
};

export type SearchLineItemTypeResponse = {
  __typename?: 'SearchLineItemTypeResponse';
  lineItemTypeActivityConnection?: Maybe<LineItemTypeActivityConnection>;
  lineItemTypeConnection?: Maybe<LineItemTypeConnection>;
};


export type SearchLineItemTypeResponseLineItemTypeActivityConnectionArgs = {
  input?: InputMaybe<LineItemTypeActivityConnectionInput>;
};


export type SearchLineItemTypeResponseLineItemTypeConnectionArgs = {
  input?: InputMaybe<LineItemTypeConnectionInput>;
};

export type SearchLocationResponse = {
  __typename?: 'SearchLocationResponse';
  locationActivityConnection?: Maybe<LocationActivityConnection>;
  locationConnection?: Maybe<LocationConnection>;
};


export type SearchLocationResponseLocationActivityConnectionArgs = {
  input?: InputMaybe<LocationActivityConnectionInput>;
};


export type SearchLocationResponseLocationConnectionArgs = {
  input?: InputMaybe<LocationConnectionInput>;
};

export type SearchLocationWithAirportAndAliasResponse = {
  __typename?: 'SearchLocationWithAirportAndAliasResponse';
  locationWithAirportAndAliasActivityConnection?: Maybe<LocationWithAirportAndAliasActivityConnection>;
  locationWithAirportAndAliasConnection?: Maybe<LocationWithAirportAndAliasConnection>;
};


export type SearchLocationWithAirportAndAliasResponseLocationWithAirportAndAliasActivityConnectionArgs = {
  input?: InputMaybe<LocationWithAirportAndAliasActivityConnectionInput>;
};


export type SearchLocationWithAirportAndAliasResponseLocationWithAirportAndAliasConnectionArgs = {
  input?: InputMaybe<LocationWithAirportAndAliasConnectionInput>;
};

export type SearchLocationWithPunchPolicyResponse = {
  __typename?: 'SearchLocationWithPunchPolicyResponse';
  locationWithPunchPolicyActivityConnection?: Maybe<LocationWithPunchPolicyActivityConnection>;
  locationWithPunchPolicyConnection?: Maybe<LocationWithPunchPolicyConnection>;
};


export type SearchLocationWithPunchPolicyResponseLocationWithPunchPolicyActivityConnectionArgs = {
  input?: InputMaybe<LocationWithPunchPolicyActivityConnectionInput>;
};


export type SearchLocationWithPunchPolicyResponseLocationWithPunchPolicyConnectionArgs = {
  input?: InputMaybe<LocationWithPunchPolicyConnectionInput>;
};

export type SearchLocationsResponse = {
  __typename?: 'SearchLocationsResponse';
  locationConnection?: Maybe<LocationConnection>;
  locationWithAirportConnection?: Maybe<LocationConnection>;
  locationWithPunchPolicyConnection?: Maybe<LocationConnection>;
};


export type SearchLocationsResponseLocationConnectionArgs = {
  input?: InputMaybe<LocationConnectionInput>;
};


export type SearchLocationsResponseLocationWithAirportConnectionArgs = {
  input?: InputMaybe<AirportWithLocationConnectionInput>;
};


export type SearchLocationsResponseLocationWithPunchPolicyConnectionArgs = {
  input?: InputMaybe<LocationWithPunchPolicyConnectionInput>;
};

export type SearchLoginEventResponse = {
  __typename?: 'SearchLoginEventResponse';
  loginEventActivityConnection?: Maybe<LoginEventActivityConnection>;
  loginEventConnection?: Maybe<LoginEventConnection>;
};


export type SearchLoginEventResponseLoginEventActivityConnectionArgs = {
  input?: InputMaybe<LoginEventActivityConnectionInput>;
};


export type SearchLoginEventResponseLoginEventConnectionArgs = {
  input?: InputMaybe<LoginEventConnectionInput>;
};

export type SearchLostAndFoundIssueDocumentResponse = {
  __typename?: 'SearchLostAndFoundIssueDocumentResponse';
  lostAndFoundIssueDocumentConnection?: Maybe<LostAndFoundIssueDocumentConnection>;
};


export type SearchLostAndFoundIssueDocumentResponseLostAndFoundIssueDocumentConnectionArgs = {
  input?: InputMaybe<LostAndFoundIssueDocumentConnectionInput>;
};

export type SearchLostAndFoundIssueResponse = {
  __typename?: 'SearchLostAndFoundIssueResponse';
  lostAndFoundIssueConnection?: Maybe<LostAndFoundIssueConnection>;
  lostAndFoundIssueTableConnection?: Maybe<LostAndFoundIssueWithCacheConnection>;
};


export type SearchLostAndFoundIssueResponseLostAndFoundIssueConnectionArgs = {
  input?: InputMaybe<LostAndFoundIssueConnectionInput>;
};


export type SearchLostAndFoundIssueResponseLostAndFoundIssueTableConnectionArgs = {
  input?: InputMaybe<LostAndFoundIssueWithCacheConnectionInput>;
};

export type SearchLostAndFoundIssueWithCacheResponse = {
  __typename?: 'SearchLostAndFoundIssueWithCacheResponse';
  lostAndFoundIssueWithCacheActivityConnection?: Maybe<LostAndFoundIssueWithCacheActivityConnection>;
  lostAndFoundIssueWithCacheConnection?: Maybe<LostAndFoundIssueWithCacheConnection>;
};


export type SearchLostAndFoundIssueWithCacheResponseLostAndFoundIssueWithCacheActivityConnectionArgs = {
  input?: InputMaybe<LostAndFoundIssueWithCacheActivityConnectionInput>;
};


export type SearchLostAndFoundIssueWithCacheResponseLostAndFoundIssueWithCacheConnectionArgs = {
  input?: InputMaybe<LostAndFoundIssueWithCacheConnectionInput>;
};

export type SearchManifestHistoryResponse = {
  __typename?: 'SearchManifestHistoryResponse';
  manifestHistoryActivityConnection?: Maybe<ManifestHistoryActivityConnection>;
  manifestHistoryConnection?: Maybe<ManifestHistoryConnection>;
};


export type SearchManifestHistoryResponseManifestHistoryActivityConnectionArgs = {
  input?: InputMaybe<ManifestHistoryActivityConnectionInput>;
};


export type SearchManifestHistoryResponseManifestHistoryConnectionArgs = {
  input?: InputMaybe<ManifestHistoryConnectionInput>;
};

export type SearchManifestHistoryRouteResponse = {
  __typename?: 'SearchManifestHistoryRouteResponse';
  manifestHistoryRouteActivityConnection?: Maybe<ManifestHistoryRouteActivityConnection>;
  manifestHistoryRouteConnection?: Maybe<ManifestHistoryRouteConnection>;
};


export type SearchManifestHistoryRouteResponseManifestHistoryRouteActivityConnectionArgs = {
  input?: InputMaybe<ManifestHistoryRouteActivityConnectionInput>;
};


export type SearchManifestHistoryRouteResponseManifestHistoryRouteConnectionArgs = {
  input?: InputMaybe<ManifestHistoryRouteConnectionInput>;
};

export type SearchManifestHistoryWithRouteResponse = {
  __typename?: 'SearchManifestHistoryWithRouteResponse';
  manifestHistoryWithRouteConnection?: Maybe<ManifestHistoryWithRouteConnection>;
};


export type SearchManifestHistoryWithRouteResponseManifestHistoryWithRouteConnectionArgs = {
  input?: InputMaybe<ManifestHistoryWithRouteConnectionInput>;
};

export type SearchManifestProviderCacheResponse = {
  __typename?: 'SearchManifestProviderCacheResponse';
  manifestProviderCacheActivityConnection?: Maybe<ManifestProviderCacheActivityConnection>;
  manifestProviderCacheConnection?: Maybe<ManifestProviderCacheConnection>;
};


export type SearchManifestProviderCacheResponseManifestProviderCacheActivityConnectionArgs = {
  input?: InputMaybe<ManifestProviderCacheActivityConnectionInput>;
};


export type SearchManifestProviderCacheResponseManifestProviderCacheConnectionArgs = {
  input?: InputMaybe<ManifestProviderCacheConnectionInput>;
};

export type SearchManifestUserCacheResponse = {
  __typename?: 'SearchManifestUserCacheResponse';
  manifestUserCacheActivityConnection?: Maybe<ManifestUserCacheActivityConnection>;
  manifestUserCacheConnection?: Maybe<ManifestUserCacheConnection>;
};


export type SearchManifestUserCacheResponseManifestUserCacheActivityConnectionArgs = {
  input?: InputMaybe<ManifestUserCacheActivityConnectionInput>;
};


export type SearchManifestUserCacheResponseManifestUserCacheConnectionArgs = {
  input?: InputMaybe<ManifestUserCacheConnectionInput>;
};

export type SearchMessageResponse = {
  __typename?: 'SearchMessageResponse';
  messageActivityConnection?: Maybe<MessageActivityConnection>;
  messageConnection?: Maybe<MessageConnection>;
};


export type SearchMessageResponseMessageActivityConnectionArgs = {
  input?: InputMaybe<MessageActivityConnectionInput>;
};


export type SearchMessageResponseMessageConnectionArgs = {
  input?: InputMaybe<MessageConnectionInput>;
};

export type SearchNotificationHasEventResponse = {
  __typename?: 'SearchNotificationHasEventResponse';
  notificationHasEventActivityConnection?: Maybe<NotificationHasEventActivityConnection>;
  notificationHasEventConnection?: Maybe<NotificationHasEventConnection>;
};


export type SearchNotificationHasEventResponseNotificationHasEventActivityConnectionArgs = {
  input?: InputMaybe<NotificationHasEventActivityConnectionInput>;
};


export type SearchNotificationHasEventResponseNotificationHasEventConnectionArgs = {
  input?: InputMaybe<NotificationHasEventConnectionInput>;
};

export type SearchNotificationResponse = {
  __typename?: 'SearchNotificationResponse';
  notificationActivityConnection?: Maybe<NotificationActivityConnection>;
  notificationConnection?: Maybe<NotificationConnection>;
};


export type SearchNotificationResponseNotificationActivityConnectionArgs = {
  input?: InputMaybe<NotificationActivityConnectionInput>;
};


export type SearchNotificationResponseNotificationConnectionArgs = {
  input?: InputMaybe<NotificationConnectionInput>;
};

export type SearchParsedTripResponse = {
  __typename?: 'SearchParsedTripResponse';
  parsedTripActivityConnection?: Maybe<ParsedTripActivityConnection>;
  parsedTripConnection?: Maybe<ParsedTripConnection>;
};


export type SearchParsedTripResponseParsedTripActivityConnectionArgs = {
  input?: InputMaybe<ParsedTripActivityConnectionInput>;
};


export type SearchParsedTripResponseParsedTripConnectionArgs = {
  input?: InputMaybe<ParsedTripConnectionInput>;
};

export type SearchPermissionHasRoleResponse = {
  __typename?: 'SearchPermissionHasRoleResponse';
  permissionHasRoleActivityConnection?: Maybe<PermissionHasRoleActivityConnection>;
  permissionHasRoleConnection?: Maybe<PermissionHasRoleConnection>;
};


export type SearchPermissionHasRoleResponsePermissionHasRoleActivityConnectionArgs = {
  input?: InputMaybe<PermissionHasRoleActivityConnectionInput>;
};


export type SearchPermissionHasRoleResponsePermissionHasRoleConnectionArgs = {
  input?: InputMaybe<PermissionHasRoleConnectionInput>;
};

export type SearchPermissionHasRoleWithPermissionsResponse = {
  __typename?: 'SearchPermissionHasRoleWithPermissionsResponse';
  permissionHasRoleWithPermissionsActivityConnection?: Maybe<PermissionHasRoleWithPermissionsActivityConnection>;
  permissionHasRoleWithPermissionsConnection?: Maybe<PermissionHasRoleWithPermissionsConnection>;
};


export type SearchPermissionHasRoleWithPermissionsResponsePermissionHasRoleWithPermissionsActivityConnectionArgs = {
  input?: InputMaybe<PermissionHasRoleWithPermissionsActivityConnectionInput>;
};


export type SearchPermissionHasRoleWithPermissionsResponsePermissionHasRoleWithPermissionsConnectionArgs = {
  input?: InputMaybe<PermissionHasRoleWithPermissionsConnectionInput>;
};

export type SearchPermissionHasUserResponse = {
  __typename?: 'SearchPermissionHasUserResponse';
  permissionHasUserActivityConnection?: Maybe<PermissionHasUserActivityConnection>;
  permissionHasUserConnection?: Maybe<PermissionHasUserConnection>;
};


export type SearchPermissionHasUserResponsePermissionHasUserActivityConnectionArgs = {
  input?: InputMaybe<PermissionHasUserActivityConnectionInput>;
};


export type SearchPermissionHasUserResponsePermissionHasUserConnectionArgs = {
  input?: InputMaybe<PermissionHasUserConnectionInput>;
};

export type SearchPermissionHasUserWithPermissionsResponse = {
  __typename?: 'SearchPermissionHasUserWithPermissionsResponse';
  permissionHasUserWithPermissionsActivityConnection?: Maybe<PermissionHasUserWithPermissionsActivityConnection>;
  permissionHasUserWithPermissionsConnection?: Maybe<PermissionHasUserWithPermissionsConnection>;
};


export type SearchPermissionHasUserWithPermissionsResponsePermissionHasUserWithPermissionsActivityConnectionArgs = {
  input?: InputMaybe<PermissionHasUserWithPermissionsActivityConnectionInput>;
};


export type SearchPermissionHasUserWithPermissionsResponsePermissionHasUserWithPermissionsConnectionArgs = {
  input?: InputMaybe<PermissionHasUserWithPermissionsConnectionInput>;
};

export type SearchPermissionResponse = {
  __typename?: 'SearchPermissionResponse';
  permissionConnection?: Maybe<PermissionConnection>;
};


export type SearchPermissionResponsePermissionConnectionArgs = {
  input?: InputMaybe<PermissionConnectionInput>;
};

export type SearchPickupPointResponse = {
  __typename?: 'SearchPickupPointResponse';
  pickupPointConnection?: Maybe<PickupPointConnection>;
};


export type SearchPickupPointResponsePickupPointConnectionArgs = {
  input?: InputMaybe<PickupPointConnectionInput>;
};

export type SearchPotentialTripResponse = {
  __typename?: 'SearchPotentialTripResponse';
  potentialTripActivityConnection?: Maybe<PotentialTripActivityConnection>;
  potentialTripConnection?: Maybe<PotentialTripConnection>;
};


export type SearchPotentialTripResponsePotentialTripActivityConnectionArgs = {
  input?: InputMaybe<PotentialTripActivityConnectionInput>;
};


export type SearchPotentialTripResponsePotentialTripConnectionArgs = {
  input?: InputMaybe<PotentialTripConnectionInput>;
};

export type SearchPreviousImportsResponse = {
  __typename?: 'SearchPreviousImportsResponse';
  previousImportConnection?: Maybe<ImportConnection>;
};


export type SearchPreviousImportsResponsePreviousImportConnectionArgs = {
  input?: InputMaybe<PreviousImportConnectionInput>;
};

export type SearchProviderAliasResponse = {
  __typename?: 'SearchProviderAliasResponse';
  providerAliasActivityConnection?: Maybe<ProviderAliasActivityConnection>;
  providerAliasConnection?: Maybe<ProviderAliasConnection>;
};


export type SearchProviderAliasResponseProviderAliasActivityConnectionArgs = {
  input?: InputMaybe<ProviderAliasActivityConnectionInput>;
};


export type SearchProviderAliasResponseProviderAliasConnectionArgs = {
  input?: InputMaybe<ProviderAliasConnectionInput>;
};

export type SearchProviderCacheResponse = {
  __typename?: 'SearchProviderCacheResponse';
  providerCacheActivityConnection?: Maybe<ProviderCacheActivityConnection>;
  providerCacheConnection?: Maybe<ProviderCacheConnection>;
};


export type SearchProviderCacheResponseProviderCacheActivityConnectionArgs = {
  input?: InputMaybe<ProviderCacheActivityConnectionInput>;
};


export type SearchProviderCacheResponseProviderCacheConnectionArgs = {
  input?: InputMaybe<ProviderCacheConnectionInput>;
};

export type SearchProviderLocationMappingResponse = {
  __typename?: 'SearchProviderLocationMappingResponse';
  providerLocationMappingConnection?: Maybe<ProviderLocationMappingConnection>;
};


export type SearchProviderLocationMappingResponseProviderLocationMappingConnectionArgs = {
  input?: InputMaybe<ProviderLocationMappingConnectionInput>;
};

export type SearchProviderResponse = {
  __typename?: 'SearchProviderResponse';
  airlineConnection?: Maybe<ProviderConnection>;
  clientConnection?: Maybe<ProviderConnection>;
  providerConnection?: Maybe<ProviderConnection>;
};


export type SearchProviderResponseAirlineConnectionArgs = {
  input?: InputMaybe<ProviderConnectionInput>;
};


export type SearchProviderResponseClientConnectionArgs = {
  input?: InputMaybe<ProviderConnectionInput>;
};


export type SearchProviderResponseProviderConnectionArgs = {
  input?: InputMaybe<ProviderConnectionInput>;
};

export type SearchProviderWithAliasResponse = {
  __typename?: 'SearchProviderWithAliasResponse';
  providerWithAliasActivityConnection?: Maybe<ProviderWithAliasActivityConnection>;
  providerWithAliasConnection?: Maybe<ProviderWithAliasConnection>;
};


export type SearchProviderWithAliasResponseProviderWithAliasActivityConnectionArgs = {
  input?: InputMaybe<ProviderWithAliasActivityConnectionInput>;
};


export type SearchProviderWithAliasResponseProviderWithAliasConnectionArgs = {
  input?: InputMaybe<ProviderWithAliasConnectionInput>;
};

export type SearchProviderWithContractResponse = {
  __typename?: 'SearchProviderWithContractResponse';
  providerWithContractActivityConnection?: Maybe<ProviderWithContractActivityConnection>;
  providerWithContractConnection?: Maybe<ProviderWithContractConnection>;
};


export type SearchProviderWithContractResponseProviderWithContractActivityConnectionArgs = {
  input?: InputMaybe<ProviderWithContractActivityConnectionInput>;
};


export type SearchProviderWithContractResponseProviderWithContractConnectionArgs = {
  input?: InputMaybe<ProviderWithContractConnectionInput>;
};

export type SearchProviderWithUpdateStrategyResponse = {
  __typename?: 'SearchProviderWithUpdateStrategyResponse';
  providerWithUpdateStrategyActivityConnection?: Maybe<ProviderWithUpdateStrategyActivityConnection>;
  providerWithUpdateStrategyConnection?: Maybe<ProviderWithUpdateStrategyConnection>;
};


export type SearchProviderWithUpdateStrategyResponseProviderWithUpdateStrategyActivityConnectionArgs = {
  input?: InputMaybe<ProviderWithUpdateStrategyActivityConnectionInput>;
};


export type SearchProviderWithUpdateStrategyResponseProviderWithUpdateStrategyConnectionArgs = {
  input?: InputMaybe<ProviderWithUpdateStrategyConnectionInput>;
};

export type SearchPunchHistoryResponse = {
  __typename?: 'SearchPunchHistoryResponse';
  punchHistoryActivityConnection?: Maybe<PunchHistoryActivityConnection>;
  punchHistoryConnection?: Maybe<PunchHistoryConnection>;
};


export type SearchPunchHistoryResponsePunchHistoryActivityConnectionArgs = {
  input?: InputMaybe<PunchHistoryActivityConnectionInput>;
};


export type SearchPunchHistoryResponsePunchHistoryConnectionArgs = {
  input?: InputMaybe<PunchHistoryConnectionInput>;
};

export type SearchPunchPolicyResponse = {
  __typename?: 'SearchPunchPolicyResponse';
  punchPolicyConnection?: Maybe<PunchPolicyConnection>;
};


export type SearchPunchPolicyResponsePunchPolicyConnectionArgs = {
  input?: InputMaybe<PunchPolicyConnectionInput>;
};

export type SearchPunchResponse = {
  __typename?: 'SearchPunchResponse';
  punchActivityConnection?: Maybe<PunchActivityConnection>;
  punchConnection?: Maybe<PunchConnection>;
};


export type SearchPunchResponsePunchActivityConnectionArgs = {
  input?: InputMaybe<PunchActivityConnectionInput>;
};


export type SearchPunchResponsePunchConnectionArgs = {
  input?: InputMaybe<PunchConnectionInput>;
};

export type SearchQueryHistoryResponse = {
  __typename?: 'SearchQueryHistoryResponse';
  queryHistoryConnection?: Maybe<QueryHistoryConnection>;
};


export type SearchQueryHistoryResponseQueryHistoryConnectionArgs = {
  input?: InputMaybe<QueryHistoryConnectionInput>;
};

export type SearchQuestionnaireAnswerOptionResponse = {
  __typename?: 'SearchQuestionnaireAnswerOptionResponse';
  questionnaireAnswerOptionConnection?: Maybe<QuestionnaireAnswerOptionConnection>;
};


export type SearchQuestionnaireAnswerOptionResponseQuestionnaireAnswerOptionConnectionArgs = {
  input?: InputMaybe<QuestionnaireAnswerOptionConnectionInput>;
};

export type SearchQuestionnaireAnswerTypeResponse = {
  __typename?: 'SearchQuestionnaireAnswerTypeResponse';
  questionnaireAnswerTypeConnection?: Maybe<QuestionnaireAnswerTypeConnection>;
};


export type SearchQuestionnaireAnswerTypeResponseQuestionnaireAnswerTypeConnectionArgs = {
  input?: InputMaybe<QuestionnaireAnswerTypeConnectionInput>;
};

export type SearchQuestionnaireAttemptAnswerOptionSnapshotResponse = {
  __typename?: 'SearchQuestionnaireAttemptAnswerOptionSnapshotResponse';
  questionnaireAttemptAnswerOptionSnapshotActivityConnection?: Maybe<QuestionnaireAttemptAnswerOptionSnapshotActivityConnection>;
  questionnaireAttemptAnswerOptionSnapshotConnection?: Maybe<QuestionnaireAttemptAnswerOptionSnapshotConnection>;
};


export type SearchQuestionnaireAttemptAnswerOptionSnapshotResponseQuestionnaireAttemptAnswerOptionSnapshotActivityConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptAnswerOptionSnapshotActivityConnectionInput>;
};


export type SearchQuestionnaireAttemptAnswerOptionSnapshotResponseQuestionnaireAttemptAnswerOptionSnapshotConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptAnswerOptionSnapshotConnectionInput>;
};

export type SearchQuestionnaireAttemptCategorySnapshotAllowedGroupResponse = {
  __typename?: 'SearchQuestionnaireAttemptCategorySnapshotAllowedGroupResponse';
  questionnaireAttemptCategorySnapshotAllowedGroupActivityConnection?: Maybe<QuestionnaireAttemptCategorySnapshotAllowedGroupActivityConnection>;
  questionnaireAttemptCategorySnapshotAllowedGroupConnection?: Maybe<QuestionnaireAttemptCategorySnapshotAllowedGroupConnection>;
};


export type SearchQuestionnaireAttemptCategorySnapshotAllowedGroupResponseQuestionnaireAttemptCategorySnapshotAllowedGroupActivityConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptCategorySnapshotAllowedGroupActivityConnectionInput>;
};


export type SearchQuestionnaireAttemptCategorySnapshotAllowedGroupResponseQuestionnaireAttemptCategorySnapshotAllowedGroupConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptCategorySnapshotAllowedGroupConnectionInput>;
};

export type SearchQuestionnaireAttemptCategorySnapshotGroupResponse = {
  __typename?: 'SearchQuestionnaireAttemptCategorySnapshotGroupResponse';
  questionnaireAttemptCategorySnapshotGroupActivityConnection?: Maybe<QuestionnaireAttemptCategorySnapshotGroupActivityConnection>;
  questionnaireAttemptCategorySnapshotGroupConnection?: Maybe<QuestionnaireAttemptCategorySnapshotGroupConnection>;
};


export type SearchQuestionnaireAttemptCategorySnapshotGroupResponseQuestionnaireAttemptCategorySnapshotGroupActivityConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptCategorySnapshotGroupActivityConnectionInput>;
};


export type SearchQuestionnaireAttemptCategorySnapshotGroupResponseQuestionnaireAttemptCategorySnapshotGroupConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptCategorySnapshotGroupConnectionInput>;
};

export type SearchQuestionnaireAttemptCategorySnapshotResponse = {
  __typename?: 'SearchQuestionnaireAttemptCategorySnapshotResponse';
  questionnaireAttemptCategorySnapshotActivityConnection?: Maybe<QuestionnaireAttemptCategorySnapshotActivityConnection>;
  questionnaireAttemptCategorySnapshotConnection?: Maybe<QuestionnaireAttemptCategorySnapshotConnection>;
};


export type SearchQuestionnaireAttemptCategorySnapshotResponseQuestionnaireAttemptCategorySnapshotActivityConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptCategorySnapshotActivityConnectionInput>;
};


export type SearchQuestionnaireAttemptCategorySnapshotResponseQuestionnaireAttemptCategorySnapshotConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptCategorySnapshotConnectionInput>;
};

export type SearchQuestionnaireAttemptNoteResponse = {
  __typename?: 'SearchQuestionnaireAttemptNoteResponse';
  questionnaireAttemptNoteActivityConnection?: Maybe<QuestionnaireAttemptNoteActivityConnection>;
  questionnaireAttemptNoteConnection?: Maybe<QuestionnaireAttemptNoteConnection>;
};


export type SearchQuestionnaireAttemptNoteResponseQuestionnaireAttemptNoteActivityConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptNoteActivityConnectionInput>;
};


export type SearchQuestionnaireAttemptNoteResponseQuestionnaireAttemptNoteConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptNoteConnectionInput>;
};

export type SearchQuestionnaireAttemptQuestionSnapshotResponse = {
  __typename?: 'SearchQuestionnaireAttemptQuestionSnapshotResponse';
  questionnaireAttemptQuestionSnapshotActivityConnection?: Maybe<QuestionnaireAttemptQuestionSnapshotActivityConnection>;
  questionnaireAttemptQuestionSnapshotConnection?: Maybe<QuestionnaireAttemptQuestionSnapshotConnection>;
};


export type SearchQuestionnaireAttemptQuestionSnapshotResponseQuestionnaireAttemptQuestionSnapshotActivityConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptQuestionSnapshotActivityConnectionInput>;
};


export type SearchQuestionnaireAttemptQuestionSnapshotResponseQuestionnaireAttemptQuestionSnapshotConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptQuestionSnapshotConnectionInput>;
};

export type SearchQuestionnaireAttemptResponse = {
  __typename?: 'SearchQuestionnaireAttemptResponse';
  questionnaireAttemptActivityConnection?: Maybe<QuestionnaireAttemptActivityConnection>;
  questionnaireAttemptConnection?: Maybe<QuestionnaireAttemptConnection>;
};


export type SearchQuestionnaireAttemptResponseQuestionnaireAttemptActivityConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptActivityConnectionInput>;
};


export type SearchQuestionnaireAttemptResponseQuestionnaireAttemptConnectionArgs = {
  input?: InputMaybe<QuestionnaireAttemptConnectionInput>;
};

export type SearchQuestionnaireCategoryResponse = {
  __typename?: 'SearchQuestionnaireCategoryResponse';
  questionnaireCategoryConnection?: Maybe<QuestionnaireCategoryConnection>;
};


export type SearchQuestionnaireCategoryResponseQuestionnaireCategoryConnectionArgs = {
  input?: InputMaybe<QuestionnaireCategoryConnectionInput>;
};

export type SearchQuestionnaireQuestionResponse = {
  __typename?: 'SearchQuestionnaireQuestionResponse';
  questionnaireQuestionConnection?: Maybe<QuestionnaireQuestionConnection>;
};


export type SearchQuestionnaireQuestionResponseQuestionnaireQuestionConnectionArgs = {
  input?: InputMaybe<QuestionnaireQuestionConnectionInput>;
};

export type SearchRateGroupResponse = {
  __typename?: 'SearchRateGroupResponse';
  rateGroupActivityConnection?: Maybe<RateGroupActivityConnection>;
  rateGroupConnection?: Maybe<RateGroupConnection>;
};


export type SearchRateGroupResponseRateGroupActivityConnectionArgs = {
  input?: InputMaybe<RateGroupActivityConnectionInput>;
};


export type SearchRateGroupResponseRateGroupConnectionArgs = {
  input?: InputMaybe<RateGroupConnectionInput>;
};

export type SearchRateGroupWithLatestRateHistoryResponse = {
  __typename?: 'SearchRateGroupWithLatestRateHistoryResponse';
  rateGroupWithLatestRateHistoryActivityConnection?: Maybe<RateGroupWithLatestRateHistoryActivityConnection>;
  rateGroupWithLatestRateHistoryConnection?: Maybe<RateGroupWithLatestRateHistoryConnection>;
};


export type SearchRateGroupWithLatestRateHistoryResponseRateGroupWithLatestRateHistoryActivityConnectionArgs = {
  input?: InputMaybe<RateGroupWithLatestRateHistoryActivityConnectionInput>;
};


export type SearchRateGroupWithLatestRateHistoryResponseRateGroupWithLatestRateHistoryConnectionArgs = {
  input?: InputMaybe<RateGroupWithLatestRateHistoryConnectionInput>;
};

export type SearchRateHistoryResponse = {
  __typename?: 'SearchRateHistoryResponse';
  rateHistoryActivityConnection?: Maybe<RateHistoryActivityConnection>;
  rateHistoryConnection?: Maybe<RateHistoryConnection>;
};


export type SearchRateHistoryResponseRateHistoryActivityConnectionArgs = {
  input?: InputMaybe<RateHistoryActivityConnectionInput>;
};


export type SearchRateHistoryResponseRateHistoryConnectionArgs = {
  input?: InputMaybe<RateHistoryConnectionInput>;
};

export type SearchRateHistoryWithRateGroupResponse = {
  __typename?: 'SearchRateHistoryWithRateGroupResponse';
  rateHistoryWithRateGroupActivityConnection?: Maybe<RateHistoryWithRateGroupActivityConnection>;
  rateHistoryWithRateGroupConnection?: Maybe<RateHistoryWithRateGroupConnection>;
};


export type SearchRateHistoryWithRateGroupResponseRateHistoryWithRateGroupActivityConnectionArgs = {
  input?: InputMaybe<RateHistoryWithRateGroupActivityConnectionInput>;
};


export type SearchRateHistoryWithRateGroupResponseRateHistoryWithRateGroupConnectionArgs = {
  input?: InputMaybe<RateHistoryWithRateGroupConnectionInput>;
};

export type SearchRateItemResponse = {
  __typename?: 'SearchRateItemResponse';
  rateItemActivityConnection?: Maybe<RateItemActivityConnection>;
  rateItemConnection?: Maybe<RateItemConnection>;
};


export type SearchRateItemResponseRateItemActivityConnectionArgs = {
  input?: InputMaybe<RateItemActivityConnectionInput>;
};


export type SearchRateItemResponseRateItemConnectionArgs = {
  input?: InputMaybe<RateItemConnectionInput>;
};

export type SearchRateItemWithLatestRateHistoryResponse = {
  __typename?: 'SearchRateItemWithLatestRateHistoryResponse';
  rateItemWithLatestRateHistoryActivityConnection?: Maybe<RateItemWithLatestRateHistoryActivityConnection>;
  rateItemWithLatestRateHistoryConnection?: Maybe<RateItemWithLatestRateHistoryConnection>;
};


export type SearchRateItemWithLatestRateHistoryResponseRateItemWithLatestRateHistoryActivityConnectionArgs = {
  input?: InputMaybe<RateItemWithLatestRateHistoryActivityConnectionInput>;
};


export type SearchRateItemWithLatestRateHistoryResponseRateItemWithLatestRateHistoryConnectionArgs = {
  input?: InputMaybe<RateItemWithLatestRateHistoryConnectionInput>;
};

export type SearchRateResponse = {
  __typename?: 'SearchRateResponse';
  activeRateItemWithLatestRateHistory?: Maybe<RateItemWithLatestRateHistoryConnection>;
  latestRateConnection?: Maybe<LatestRateConnection>;
  rateConnection?: Maybe<RateConnection>;
  rateGroupConnection?: Maybe<RateGroupConnection>;
  rateHistoryConnection?: Maybe<RateHistoryConnection>;
  rateTableConnection?: Maybe<LatestRateConnection>;
};


export type SearchRateResponseActiveRateItemWithLatestRateHistoryArgs = {
  input?: InputMaybe<RateItemWithLatestRateHistoryConnectionInput>;
};


export type SearchRateResponseLatestRateConnectionArgs = {
  input?: InputMaybe<LatestRateConnectionInput>;
};


export type SearchRateResponseRateConnectionArgs = {
  input?: InputMaybe<RateConnectionInput>;
};


export type SearchRateResponseRateGroupConnectionArgs = {
  input?: InputMaybe<RateGroupConnectionInput>;
};


export type SearchRateResponseRateHistoryConnectionArgs = {
  input?: InputMaybe<RateHistoryConnectionInput>;
};


export type SearchRateResponseRateTableConnectionArgs = {
  input?: InputMaybe<RateTableConnectionInput>;
};

export type SearchRatingCacheRemarkResponse = {
  __typename?: 'SearchRatingCacheRemarkResponse';
  ratingCacheRemarkActivityConnection?: Maybe<RatingCacheRemarkActivityConnection>;
  ratingCacheRemarkConnection?: Maybe<RatingCacheRemarkConnection>;
};


export type SearchRatingCacheRemarkResponseRatingCacheRemarkActivityConnectionArgs = {
  input?: InputMaybe<RatingCacheRemarkActivityConnectionInput>;
};


export type SearchRatingCacheRemarkResponseRatingCacheRemarkConnectionArgs = {
  input?: InputMaybe<RatingCacheRemarkConnectionInput>;
};

export type SearchRatingCacheResponse = {
  __typename?: 'SearchRatingCacheResponse';
  ratingCacheActivityConnection?: Maybe<RatingCacheActivityConnection>;
  ratingCacheConnection?: Maybe<RatingCacheConnection>;
};


export type SearchRatingCacheResponseRatingCacheActivityConnectionArgs = {
  input?: InputMaybe<RatingCacheActivityConnectionInput>;
};


export type SearchRatingCacheResponseRatingCacheConnectionArgs = {
  input?: InputMaybe<RatingCacheConnectionInput>;
};

export type SearchRatingRemarkResponse = {
  __typename?: 'SearchRatingRemarkResponse';
  ratingRemarkActivityConnection?: Maybe<RatingRemarkActivityConnection>;
  ratingRemarkConnection?: Maybe<RatingRemarkConnection>;
};


export type SearchRatingRemarkResponseRatingRemarkActivityConnectionArgs = {
  input?: InputMaybe<RatingRemarkActivityConnectionInput>;
};


export type SearchRatingRemarkResponseRatingRemarkConnectionArgs = {
  input?: InputMaybe<RatingRemarkConnectionInput>;
};

export type SearchRatingRemarksWithRatingResponse = {
  __typename?: 'SearchRatingRemarksWithRatingResponse';
  ratingRemarksWithRatingActivityConnection?: Maybe<RatingRemarksWithRatingActivityConnection>;
  ratingRemarksWithRatingConnection?: Maybe<RatingRemarksWithRatingConnection>;
};


export type SearchRatingRemarksWithRatingResponseRatingRemarksWithRatingActivityConnectionArgs = {
  input?: InputMaybe<RatingRemarksWithRatingActivityConnectionInput>;
};


export type SearchRatingRemarksWithRatingResponseRatingRemarksWithRatingConnectionArgs = {
  input?: InputMaybe<RatingRemarksWithRatingConnectionInput>;
};

export type SearchRatingResponse = {
  __typename?: 'SearchRatingResponse';
  ratingConnection?: Maybe<RatingConnection>;
};


export type SearchRatingResponseRatingConnectionArgs = {
  input?: InputMaybe<RatingConnectionInput>;
};

export type SearchRatingTypeResponse = {
  __typename?: 'SearchRatingTypeResponse';
  ratingTypeActivityConnection?: Maybe<RatingTypeActivityConnection>;
  ratingTypeConnection?: Maybe<RatingTypeConnection>;
};


export type SearchRatingTypeResponseRatingTypeActivityConnectionArgs = {
  input?: InputMaybe<RatingTypeActivityConnectionInput>;
};


export type SearchRatingTypeResponseRatingTypeConnectionArgs = {
  input?: InputMaybe<RatingTypeConnectionInput>;
};

export type SearchRatingWithRemarksResponse = {
  __typename?: 'SearchRatingWithRemarksResponse';
  ratingWithRemarksActivityConnection?: Maybe<RatingWithRemarksActivityConnection>;
  ratingWithRemarksConnection?: Maybe<RatingWithRemarksConnection>;
};


export type SearchRatingWithRemarksResponseRatingWithRemarksActivityConnectionArgs = {
  input?: InputMaybe<RatingWithRemarksActivityConnectionInput>;
};


export type SearchRatingWithRemarksResponseRatingWithRemarksConnectionArgs = {
  input?: InputMaybe<RatingWithRemarksConnectionInput>;
};

export type SearchRoleResponse = {
  __typename?: 'SearchRoleResponse';
  roleConnection?: Maybe<RoleConnection>;
};


export type SearchRoleResponseRoleConnectionArgs = {
  input?: InputMaybe<RoleConnectionInput>;
};

export type SearchSettingsResponse = {
  __typename?: 'SearchSettingsResponse';
  settingsActivityConnection?: Maybe<SettingsActivityConnection>;
  settingsConnection?: Maybe<SettingsConnection>;
};


export type SearchSettingsResponseSettingsActivityConnectionArgs = {
  input?: InputMaybe<SettingsActivityConnectionInput>;
};


export type SearchSettingsResponseSettingsConnectionArgs = {
  input?: InputMaybe<SettingsConnectionInput>;
};

export type SearchSocialDistanceRuleResponse = {
  __typename?: 'SearchSocialDistanceRuleResponse';
  socialDistanceRuleActivityConnection?: Maybe<SocialDistanceRuleActivityConnection>;
  socialDistanceRuleConnection?: Maybe<SocialDistanceRuleConnection>;
};


export type SearchSocialDistanceRuleResponseSocialDistanceRuleActivityConnectionArgs = {
  input?: InputMaybe<SocialDistanceRuleActivityConnectionInput>;
};


export type SearchSocialDistanceRuleResponseSocialDistanceRuleConnectionArgs = {
  input?: InputMaybe<SocialDistanceRuleConnectionInput>;
};

export type SearchStagedTripResponse = {
  __typename?: 'SearchStagedTripResponse';
  stagedTripActivityConnection?: Maybe<StagedTripActivityConnection>;
  stagedTripConnection?: Maybe<StagedTripConnection>;
};


export type SearchStagedTripResponseStagedTripActivityConnectionArgs = {
  input?: InputMaybe<StagedTripActivityConnectionInput>;
};


export type SearchStagedTripResponseStagedTripConnectionArgs = {
  input?: InputMaybe<StagedTripConnectionInput>;
};

export type SearchStagedTripsResponse = {
  __typename?: 'SearchStagedTripsResponse';
  stagedTripConnection?: Maybe<StagedTripConnection>;
};


export type SearchStagedTripsResponseStagedTripConnectionArgs = {
  input?: InputMaybe<StagedTripConnectionInput>;
};

export type SearchStopResponse = {
  __typename?: 'SearchStopResponse';
  stopConnection?: Maybe<StopConnection>;
};


export type SearchStopResponseStopConnectionArgs = {
  input?: InputMaybe<StopConnectionInput>;
};

export type SearchStorageResponse = {
  __typename?: 'SearchStorageResponse';
  storageActivityConnection?: Maybe<StorageActivityConnection>;
  storageConnection?: Maybe<StorageConnection>;
};


export type SearchStorageResponseStorageActivityConnectionArgs = {
  input?: InputMaybe<StorageActivityConnectionInput>;
};


export type SearchStorageResponseStorageConnectionArgs = {
  input?: InputMaybe<StorageConnectionInput>;
};

export type SearchSummaryReportSnapshotsResponse = {
  __typename?: 'SearchSummaryReportSnapshotsResponse';
  summaryReportSnapshotConnection?: Maybe<AuditSnapshotWithNameConnection>;
};


export type SearchSummaryReportSnapshotsResponseSummaryReportSnapshotConnectionArgs = {
  input?: InputMaybe<AuditSnapshotWithNameConnectionInput>;
};

export type SearchTimeFrameRangeResponse = {
  __typename?: 'SearchTimeFrameRangeResponse';
  timeFrameRangeConnection?: Maybe<TimeFrameRangeConnection>;
};


export type SearchTimeFrameRangeResponseTimeFrameRangeConnectionArgs = {
  input?: InputMaybe<TimeFrameRangeConnectionInput>;
};

export type SearchTimeFrameResponse = {
  __typename?: 'SearchTimeFrameResponse';
  timeFrameConnection?: Maybe<TimeFrameConnection>;
};


export type SearchTimeFrameResponseTimeFrameConnectionArgs = {
  input?: InputMaybe<TimeFrameConnectionInput>;
};

export type SearchTrackFlightResponse = {
  __typename?: 'SearchTrackFlightResponse';
  trackFlightConnection?: Maybe<TrackFlightConnection>;
};


export type SearchTrackFlightResponseTrackFlightConnectionArgs = {
  input?: InputMaybe<TrackFlightConnectionInput>;
};

export type SearchTrainingUserCacheResponse = {
  __typename?: 'SearchTrainingUserCacheResponse';
  trainingUserCacheActivityConnection?: Maybe<TrainingUserCacheActivityConnection>;
  trainingUserCacheConnection?: Maybe<TrainingUserCacheConnection>;
};


export type SearchTrainingUserCacheResponseTrainingUserCacheActivityConnectionArgs = {
  input?: InputMaybe<TrainingUserCacheActivityConnectionInput>;
};


export type SearchTrainingUserCacheResponseTrainingUserCacheConnectionArgs = {
  input?: InputMaybe<TrainingUserCacheConnectionInput>;
};

export type SearchTripDocumentResponse = {
  __typename?: 'SearchTripDocumentResponse';
  tripDocumentConnection?: Maybe<TripDocumentConnection>;
  tripDocumentWithCacheConnection?: Maybe<TripDocumentWithCacheConnection>;
};


export type SearchTripDocumentResponseTripDocumentConnectionArgs = {
  input?: InputMaybe<TripDocumentConnectionInput>;
};


export type SearchTripDocumentResponseTripDocumentWithCacheConnectionArgs = {
  input?: InputMaybe<TripDocumentWithCacheConnectionInput>;
};

export type SearchTripDocumentWithCacheResponse = {
  __typename?: 'SearchTripDocumentWithCacheResponse';
  tripDocumentWithCacheActivityConnection?: Maybe<TripDocumentWithCacheActivityConnection>;
  tripDocumentWithCacheConnection?: Maybe<TripDocumentWithCacheConnection>;
};


export type SearchTripDocumentWithCacheResponseTripDocumentWithCacheActivityConnectionArgs = {
  input?: InputMaybe<TripDocumentWithCacheActivityConnectionInput>;
};


export type SearchTripDocumentWithCacheResponseTripDocumentWithCacheConnectionArgs = {
  input?: InputMaybe<TripDocumentWithCacheConnectionInput>;
};

export type SearchTripHasImportResponse = {
  __typename?: 'SearchTripHasImportResponse';
  tripHasImportActivityConnection?: Maybe<TripHasImportActivityConnection>;
  tripHasImportConnection?: Maybe<TripHasImportConnection>;
};


export type SearchTripHasImportResponseTripHasImportActivityConnectionArgs = {
  input?: InputMaybe<TripHasImportActivityConnectionInput>;
};


export type SearchTripHasImportResponseTripHasImportConnectionArgs = {
  input?: InputMaybe<TripHasImportConnectionInput>;
};

export type SearchTripResponse = {
  __typename?: 'SearchTripResponse';
  tripConnection?: Maybe<TripConnection>;
  tripConnectionDriverApp?: Maybe<TripConnection>;
  tripTableConnection?: Maybe<TripConnection>;
};


export type SearchTripResponseTripConnectionArgs = {
  input?: InputMaybe<TripConnectionInput>;
};


export type SearchTripResponseTripConnectionDriverAppArgs = {
  input?: InputMaybe<TripConnectionInput>;
};


export type SearchTripResponseTripTableConnectionArgs = {
  input?: InputMaybe<TripTableConnectionInput>;
};

export type SearchTripScheduleTriggerResponse = {
  __typename?: 'SearchTripScheduleTriggerResponse';
  tripScheduleTriggerActivityConnection?: Maybe<TripScheduleTriggerActivityConnection>;
  tripScheduleTriggerConnection?: Maybe<TripScheduleTriggerConnection>;
};


export type SearchTripScheduleTriggerResponseTripScheduleTriggerActivityConnectionArgs = {
  input?: InputMaybe<TripScheduleTriggerActivityConnectionInput>;
};


export type SearchTripScheduleTriggerResponseTripScheduleTriggerConnectionArgs = {
  input?: InputMaybe<TripScheduleTriggerConnectionInput>;
};

export type SearchTripWithCompletionAndRateResponse = {
  __typename?: 'SearchTripWithCompletionAndRateResponse';
  tripWithCompletionAndRateActivityConnection?: Maybe<TripWithCompletionAndRateActivityConnection>;
  tripWithCompletionAndRateConnection?: Maybe<TripWithCompletionAndRateConnection>;
};


export type SearchTripWithCompletionAndRateResponseTripWithCompletionAndRateActivityConnectionArgs = {
  input?: InputMaybe<TripWithCompletionAndRateActivityConnectionInput>;
};


export type SearchTripWithCompletionAndRateResponseTripWithCompletionAndRateConnectionArgs = {
  input?: InputMaybe<TripWithCompletionAndRateConnectionInput>;
};

export type SearchTripWithCompletionResponse = {
  __typename?: 'SearchTripWithCompletionResponse';
  tripWithCompletionActivityConnection?: Maybe<TripWithCompletionActivityConnection>;
  tripWithCompletionConnection?: Maybe<TripWithCompletionConnection>;
};


export type SearchTripWithCompletionResponseTripWithCompletionActivityConnectionArgs = {
  input?: InputMaybe<TripWithCompletionActivityConnectionInput>;
};


export type SearchTripWithCompletionResponseTripWithCompletionConnectionArgs = {
  input?: InputMaybe<TripWithCompletionConnectionInput>;
};

export type SearchTripWithFcrInnerJoinResponse = {
  __typename?: 'SearchTripWithFcrInnerJoinResponse';
  tripWithFcrInnerJoinActivityConnection?: Maybe<TripWithFcrInnerJoinActivityConnection>;
  tripWithFcrInnerJoinConnection?: Maybe<TripWithFcrInnerJoinConnection>;
};


export type SearchTripWithFcrInnerJoinResponseTripWithFcrInnerJoinActivityConnectionArgs = {
  input?: InputMaybe<TripWithFcrInnerJoinActivityConnectionInput>;
};


export type SearchTripWithFcrInnerJoinResponseTripWithFcrInnerJoinConnectionArgs = {
  input?: InputMaybe<TripWithFcrInnerJoinConnectionInput>;
};

export type SearchTripWithFlagInnerJoinResponse = {
  __typename?: 'SearchTripWithFlagInnerJoinResponse';
  tripWithFlagInnerJoinActivityConnection?: Maybe<TripWithFlagInnerJoinActivityConnection>;
  tripWithFlagInnerJoinConnection?: Maybe<TripWithFlagInnerJoinConnection>;
};


export type SearchTripWithFlagInnerJoinResponseTripWithFlagInnerJoinActivityConnectionArgs = {
  input?: InputMaybe<TripWithFlagInnerJoinActivityConnectionInput>;
};


export type SearchTripWithFlagInnerJoinResponseTripWithFlagInnerJoinConnectionArgs = {
  input?: InputMaybe<TripWithFlagInnerJoinConnectionInput>;
};

export type SearchTripWithRateForAuditReportResponse = {
  __typename?: 'SearchTripWithRateForAuditReportResponse';
  tripWithRateForAuditReportActivityConnection?: Maybe<TripWithRateForAuditReportActivityConnection>;
  tripWithRateForAuditReportConnection?: Maybe<TripWithRateForAuditReportConnection>;
};


export type SearchTripWithRateForAuditReportResponseTripWithRateForAuditReportActivityConnectionArgs = {
  input?: InputMaybe<TripWithRateForAuditReportActivityConnectionInput>;
};


export type SearchTripWithRateForAuditReportResponseTripWithRateForAuditReportConnectionArgs = {
  input?: InputMaybe<TripWithRateForAuditReportConnectionInput>;
};

export type SearchTripWithRateResponse = {
  __typename?: 'SearchTripWithRateResponse';
  tripWithRateActivityConnection?: Maybe<TripWithRateActivityConnection>;
  tripWithRateConnection?: Maybe<TripWithRateConnection>;
};


export type SearchTripWithRateResponseTripWithRateActivityConnectionArgs = {
  input?: InputMaybe<TripWithRateActivityConnectionInput>;
};


export type SearchTripWithRateResponseTripWithRateConnectionArgs = {
  input?: InputMaybe<TripWithRateConnectionInput>;
};

export type SearchTripWithTrackFlightResponse = {
  __typename?: 'SearchTripWithTrackFlightResponse';
  tripWithTrackFlightActivityConnection?: Maybe<TripWithTrackFlightActivityConnection>;
  tripWithTrackFlightConnection?: Maybe<TripWithTrackFlightConnection>;
};


export type SearchTripWithTrackFlightResponseTripWithTrackFlightActivityConnectionArgs = {
  input?: InputMaybe<TripWithTrackFlightActivityConnectionInput>;
};


export type SearchTripWithTrackFlightResponseTripWithTrackFlightConnectionArgs = {
  input?: InputMaybe<TripWithTrackFlightConnectionInput>;
};

export type SearchTripWithUtcResponse = {
  __typename?: 'SearchTripWithUtcResponse';
  tripWithUtcActivityConnection?: Maybe<TripWithUtcActivityConnection>;
  tripWithUtcConnection?: Maybe<TripWithUtcConnection>;
};


export type SearchTripWithUtcResponseTripWithUtcActivityConnectionArgs = {
  input?: InputMaybe<TripWithUtcActivityConnectionInput>;
};


export type SearchTripWithUtcResponseTripWithUtcConnectionArgs = {
  input?: InputMaybe<TripWithUtcConnectionInput>;
};

export enum SearchTypeEnum {
  Default = 'DEFAULT',
  Inornull = 'INORNULL',
  Isnotnull = 'ISNOTNULL',
  Isnull = 'ISNULL',
  Like = 'LIKE',
  Notin = 'NOTIN',
  Notinornull = 'NOTINORNULL',
  Or = 'OR',
  Range = 'RANGE'
}

export type SearchUniqueTripResponse = {
  __typename?: 'SearchUniqueTripResponse';
  uniqueTripActivityConnection?: Maybe<UniqueTripActivityConnection>;
  uniqueTripConnection?: Maybe<UniqueTripConnection>;
};


export type SearchUniqueTripResponseUniqueTripActivityConnectionArgs = {
  input?: InputMaybe<UniqueTripActivityConnectionInput>;
};


export type SearchUniqueTripResponseUniqueTripConnectionArgs = {
  input?: InputMaybe<UniqueTripConnectionInput>;
};

export type SearchUpdateStrategyResponse = {
  __typename?: 'SearchUpdateStrategyResponse';
  updateStrategyActivityConnection?: Maybe<UpdateStrategyActivityConnection>;
  updateStrategyConnection?: Maybe<UpdateStrategyConnection>;
};


export type SearchUpdateStrategyResponseUpdateStrategyActivityConnectionArgs = {
  input?: InputMaybe<UpdateStrategyActivityConnectionInput>;
};


export type SearchUpdateStrategyResponseUpdateStrategyConnectionArgs = {
  input?: InputMaybe<UpdateStrategyConnectionInput>;
};

export type SearchUserAvailabilityDriverAppInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  airportCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  driverIds?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  sortDate?: InputMaybe<Scalars['String']['input']>;
  startDatetime: Scalars['String']['input'];
  types?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type SearchUserAvailabilityResponse = {
  __typename?: 'SearchUserAvailabilityResponse';
  userAvailabilityActivityConnection?: Maybe<UserAvailabilityActivityConnection>;
  userAvailabilityConnection?: Maybe<UserAvailabilityConnection>;
};


export type SearchUserAvailabilityResponseUserAvailabilityActivityConnectionArgs = {
  input?: InputMaybe<UserAvailabilityActivityConnectionInput>;
};


export type SearchUserAvailabilityResponseUserAvailabilityConnectionArgs = {
  input?: InputMaybe<UserAvailabilityConnectionInput>;
};

export type SearchUserAvailabilityWithDatetimesResponse = {
  __typename?: 'SearchUserAvailabilityWithDatetimesResponse';
  userAvailabilityWithDatetimesActivityConnection?: Maybe<UserAvailabilityWithDatetimesActivityConnection>;
  userAvailabilityWithDatetimesConnection?: Maybe<UserAvailabilityWithDatetimesConnection>;
};


export type SearchUserAvailabilityWithDatetimesResponseUserAvailabilityWithDatetimesActivityConnectionArgs = {
  input?: InputMaybe<UserAvailabilityWithDatetimesActivityConnectionInput>;
};


export type SearchUserAvailabilityWithDatetimesResponseUserAvailabilityWithDatetimesConnectionArgs = {
  input?: InputMaybe<UserAvailabilityWithDatetimesConnectionInput>;
};

export type SearchUserCacheResponse = {
  __typename?: 'SearchUserCacheResponse';
  userCacheActivityConnection?: Maybe<UserCacheActivityConnection>;
  userCacheConnection?: Maybe<UserCacheConnection>;
};


export type SearchUserCacheResponseUserCacheActivityConnectionArgs = {
  input?: InputMaybe<UserCacheActivityConnectionInput>;
};


export type SearchUserCacheResponseUserCacheConnectionArgs = {
  input?: InputMaybe<UserCacheConnectionInput>;
};

export type SearchUserHasAirportResponse = {
  __typename?: 'SearchUserHasAirportResponse';
  userHasAirportConnection?: Maybe<UserHasAirportConnection>;
};


export type SearchUserHasAirportResponseUserHasAirportConnectionArgs = {
  input?: InputMaybe<UserHasAirportConnectionInput>;
};

export type SearchUserResponse = {
  __typename?: 'SearchUserResponse';
  userConnection?: Maybe<UserConnection>;
  userWithAirportAppendAvailabilityConnection?: Maybe<UserConnection>;
  userWithAirportConnection?: Maybe<UserConnection>;
};


export type SearchUserResponseUserConnectionArgs = {
  input?: InputMaybe<UserConnectionInput>;
};


export type SearchUserResponseUserWithAirportAppendAvailabilityConnectionArgs = {
  input?: InputMaybe<UserWithAirportAppendAvailabilityConnectionInput>;
};


export type SearchUserResponseUserWithAirportConnectionArgs = {
  input?: InputMaybe<UserWithAirportConnectionInput>;
};

export type SearchUserWithAvailabilityAndPermissionsResponse = {
  __typename?: 'SearchUserWithAvailabilityAndPermissionsResponse';
  userWithAvailabilityAndPermissionsGroupByUserConnection?: Maybe<UserWithAvailabilityAndPermissionsGroupByUserConnection>;
};


export type SearchUserWithAvailabilityAndPermissionsResponseUserWithAvailabilityAndPermissionsGroupByUserConnectionArgs = {
  input?: InputMaybe<UserWithAvailabilityAndPermissionsGroupByUserConnectionInput>;
};

export type SearchUserWithMarketResponse = {
  __typename?: 'SearchUserWithMarketResponse';
  userWithMarketConnection?: Maybe<UserWithMarketConnection>;
};


export type SearchUserWithMarketResponseUserWithMarketConnectionArgs = {
  input?: InputMaybe<UserWithMarketConnectionInput>;
};

export type SearchUserWithPermissionsResponse = {
  __typename?: 'SearchUserWithPermissionsResponse';
  userWithPermissionsConnection?: Maybe<UserWithPermissionsConnection>;
};


export type SearchUserWithPermissionsResponseUserWithPermissionsConnectionArgs = {
  input?: InputMaybe<UserWithPermissionsConnectionInput>;
};

export type SearchVariableTimeResponse = {
  __typename?: 'SearchVariableTimeResponse';
  variableTimeConnection?: Maybe<VariableTimeConnection>;
};


export type SearchVariableTimeResponseVariableTimeConnectionArgs = {
  input?: InputMaybe<VariableTimeConnectionInput>;
};

export type SearchVehicleResponse = {
  __typename?: 'SearchVehicleResponse';
  vehicleConnection?: Maybe<VehicleConnection>;
  vehicleWithAirportConnection?: Maybe<VehicleConnection>;
};


export type SearchVehicleResponseVehicleConnectionArgs = {
  input?: InputMaybe<VehicleConnectionInput>;
};


export type SearchVehicleResponseVehicleWithAirportConnectionArgs = {
  input?: InputMaybe<AirportWithVehicleConnectionInput>;
};

export type SearchWidgetFilterResponse = {
  __typename?: 'SearchWidgetFilterResponse';
  widgetFilterActivityConnection?: Maybe<WidgetFilterActivityConnection>;
  widgetFilterConnection?: Maybe<WidgetFilterConnection>;
};


export type SearchWidgetFilterResponseWidgetFilterActivityConnectionArgs = {
  input?: InputMaybe<WidgetFilterActivityConnectionInput>;
};


export type SearchWidgetFilterResponseWidgetFilterConnectionArgs = {
  input?: InputMaybe<WidgetFilterConnectionInput>;
};

export type SearchWidgetResponse = {
  __typename?: 'SearchWidgetResponse';
  widgetConnection?: Maybe<WidgetConnection>;
};


export type SearchWidgetResponseWidgetConnectionArgs = {
  input?: InputMaybe<WidgetConnectionInput>;
};

export type SendInvoiceEmailInput = {
  documentId: Scalars['String']['input'];
  invoiceId: Scalars['Int']['input'];
  toEmails: Array<Scalars['String']['input']>;
};

export type SendInvoiceEmailResponse = {
  __typename?: 'SendInvoiceEmailResponse';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type SetQuestionnaireCategoryGroupsInput = {
  groupIds: Array<Scalars['String']['input']>;
  questionnaireCategoryId: Scalars['String']['input'];
};

export type SetQuestionnaireCategoryGroupsResponse = {
  __typename?: 'SetQuestionnaireCategoryGroupsResponse';
  output: QuestionnaireCategoryGroups;
};

export type Settings = {
  __typename?: 'Settings';
  chatReadTime?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewChatReadTime?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  messageReadTime?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  outboundLateAlertMinutes?: Maybe<Scalars['Int']['output']>;
  passwordExpirationDays?: Maybe<Scalars['Int']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleTrackingVendor?: Maybe<SettingsVehicleTrackingVendorEnum>;
  vehicleTrackingVendorToken?: Maybe<Scalars['String']['output']>;
};

export type SettingsActivityConnection = {
  __typename?: 'SettingsActivityConnection';
  edges?: Maybe<Array<Maybe<SettingsActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SettingsActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type SettingsActivityEdge = {
  __typename?: 'SettingsActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type SettingsConnection = {
  __typename?: 'SettingsConnection';
  edges?: Maybe<Array<Maybe<SettingsEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SettingsConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<SettingsMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<SettingsSearch>>;
};

export type SettingsEdge = {
  __typename?: 'SettingsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Settings>;
};

export type SettingsMaskInput = {
  chatReadTime?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewChatReadTime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  messageReadTime?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  outboundLateAlertMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  passwordExpirationDays?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTrackingVendor?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTrackingVendorToken?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SettingsSearch = {
  chatReadTime?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewChatReadTime?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  messageReadTime?: InputMaybe<Array<IntSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  outboundLateAlertMinutes?: InputMaybe<Array<IntSearch>>;
  passwordExpirationDays?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleTrackingVendor?: InputMaybe<Array<SettingsVehicleTrackingVendorEnumSearch>>;
  vehicleTrackingVendorToken?: InputMaybe<Array<StringSearch>>;
};

export enum SettingsVehicleTrackingVendorEnum {
  Fleetmatics = 'FLEETMATICS',
  Samsara = 'SAMSARA'
}

export type SettingsVehicleTrackingVendorEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<SettingsVehicleTrackingVendorEnum>;
};

export type SocialDistanceRule = {
  __typename?: 'SocialDistanceRule';
  active: Scalars['Int']['output'];
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  max: Scalars['Int']['output'];
  type?: Maybe<SocialDistanceRuleTypeEnum>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type SocialDistanceRuleActivityConnection = {
  __typename?: 'SocialDistanceRuleActivityConnection';
  edges?: Maybe<Array<Maybe<SocialDistanceRuleActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SocialDistanceRuleActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type SocialDistanceRuleActivityEdge = {
  __typename?: 'SocialDistanceRuleActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type SocialDistanceRuleConnection = {
  __typename?: 'SocialDistanceRuleConnection';
  edges?: Maybe<Array<Maybe<SocialDistanceRuleEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type SocialDistanceRuleConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<SocialDistanceRuleMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<SocialDistanceRuleSearch>>;
};

export type SocialDistanceRuleEdge = {
  __typename?: 'SocialDistanceRuleEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<SocialDistanceRule>;
};

export type SocialDistanceRuleMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  max?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type SocialDistanceRuleSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  max?: InputMaybe<Array<IntSearch>>;
  type?: InputMaybe<Array<SocialDistanceRuleTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum SocialDistanceRuleTypeEnum {
  Addon = 'ADDON',
  Daily = 'DAILY',
  Manifest = 'MANIFEST',
  Training = 'TRAINING'
}

export type SocialDistanceRuleTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<SocialDistanceRuleTypeEnum>;
};

export enum SortDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type SortOptions = {
  direction?: InputMaybe<SortDirectionEnum>;
  index?: InputMaybe<Scalars['Int']['input']>;
};

export type StagedTrip = {
  __typename?: 'StagedTrip';
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  bufferMinutes: Scalars['Int']['output'];
  combineId?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewId?: Maybe<Scalars['Int']['output']>;
  doLocation?: Maybe<Location>;
  doLocationId: Scalars['String']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  flightNumber?: Maybe<Scalars['Int']['output']>;
  fromManifest: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  importId: Scalars['String']['output'];
  importTime?: Maybe<Scalars['String']['output']>;
  ingestAction: StagedTripIngestActionEnum;
  kind: StagedTripKindEnum;
  lastName?: Maybe<Scalars['String']['output']>;
  loopName?: Maybe<Scalars['String']['output']>;
  payerProvider?: Maybe<Provider>;
  payerProviderId: Scalars['String']['output'];
  pilots: Scalars['Int']['output'];
  potentialTripId?: Maybe<Scalars['String']['output']>;
  puLocation?: Maybe<Location>;
  puLocationId: Scalars['String']['output'];
  scheduled: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  split: Scalars['Int']['output'];
  statusName: StagedTripStatusNameEnum;
  traceId: Scalars['String']['output'];
  tripId: Scalars['String']['output'];
  typeName: StagedTripTypeNameEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  warnings?: Maybe<Array<Maybe<Error>>>;
};

export type StagedTripActivityConnection = {
  __typename?: 'StagedTripActivityConnection';
  edges?: Maybe<Array<Maybe<StagedTripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StagedTripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type StagedTripActivityEdge = {
  __typename?: 'StagedTripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type StagedTripConnection = {
  __typename?: 'StagedTripConnection';
  edges?: Maybe<Array<Maybe<StagedTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StagedTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<StagedTripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<StagedTripSearch>>;
};

export type StagedTripEdge = {
  __typename?: 'StagedTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<StagedTrip>;
};

export enum StagedTripIngestActionEnum {
  Create = 'CREATE',
  Delete = 'DELETE',
  Exclude = 'EXCLUDE',
  Noop = 'NOOP',
  Not = 'NOT',
  Replace = 'REPLACE',
  Restore = 'RESTORE',
  SoftDelete = 'SOFT_DELETE',
  Update = 'UPDATE'
}

export type StagedTripIngestActionEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<StagedTripIngestActionEnum>;
};

export enum StagedTripKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type StagedTripKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<StagedTripKindEnum>;
};

export type StagedTripMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  bufferMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewId?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  fromManifest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importId?: InputMaybe<Scalars['Boolean']['input']>;
  importTime?: InputMaybe<Scalars['Boolean']['input']>;
  ingestAction?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  potentialTripId?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
  statusName?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  typeName?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StagedTripSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  bufferMinutes?: InputMaybe<Array<IntSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewId?: InputMaybe<Array<IntSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  fromManifest?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importId?: InputMaybe<Array<StringSearch>>;
  importTime?: InputMaybe<Array<StringSearch>>;
  ingestAction?: InputMaybe<Array<StagedTripIngestActionEnumSearch>>;
  kind?: InputMaybe<Array<StagedTripKindEnumSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  potentialTripId?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  split?: InputMaybe<Array<IntSearch>>;
  statusName?: InputMaybe<Array<StagedTripStatusNameEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  typeName?: InputMaybe<Array<StagedTripTypeNameEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum StagedTripStatusNameEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type StagedTripStatusNameEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<StagedTripStatusNameEnum>;
};

export enum StagedTripTypeNameEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type StagedTripTypeNameEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<StagedTripTypeNameEnum>;
};

export type StartEvaluationInput = {
  evaluatorUserId: Scalars['String']['input'];
  subjectUserId: Scalars['String']['input'];
};

export type StartEvaluationResponse = {
  __typename?: 'StartEvaluationResponse';
  attemptId: Scalars['String']['output'];
  error?: Maybe<Error>;
};

export type Statistic = {
  __typename?: 'Statistic';
  avgDt: Scalars['Int']['output'];
  maxDt: Scalars['Int']['output'];
  minDt: Scalars['Int']['output'];
  p60: Scalars['Int']['output'];
  p80: Scalars['Int']['output'];
  p90: Scalars['Int']['output'];
  p95: Scalars['Int']['output'];
  p99: Scalars['Int']['output'];
  stdDeviationLowerBound: Scalars['Int']['output'];
  stdDeviationUpperBound: Scalars['Int']['output'];
  timeStamp: Scalars['String']['output'];
};

export enum StatusNameEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type StealTripsInput = {
  tripIds: Array<Scalars['String']['input']>;
};

export type StealTripsResponse = {
  __typename?: 'StealTripsResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type Stop = Node & {
  __typename?: 'Stop';
  actual?: Maybe<Scalars['String']['output']>;
  airportCode?: Maybe<Scalars['String']['output']>;
  completed?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  location?: Maybe<Location>;
  locationId: Scalars['String']['output'];
  scheduled: Scalars['String']['output'];
  trip?: Maybe<Trip>;
  tripId: Scalars['String']['output'];
  type: StopTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type StopActivityConnection = {
  __typename?: 'StopActivityConnection';
  edges?: Maybe<Array<Maybe<StopActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StopActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type StopActivityEdge = {
  __typename?: 'StopActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type StopConnection = {
  __typename?: 'StopConnection';
  edges?: Maybe<Array<Maybe<StopEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StopConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<StopMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<StopSearch>>;
};

export type StopEdge = {
  __typename?: 'StopEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Stop>;
};

export type StopMaskInput = {
  actual?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  completed?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StopSearch = {
  actual?: InputMaybe<Array<StringSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  completed?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  locationId?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<StopTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum StopTypeEnum {
  Do = 'DO',
  Pu = 'PU'
}

export type StopTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<StopTypeEnum>;
};

export type Storage = {
  __typename?: 'Storage';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  key: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
};

export type StorageActivityConnection = {
  __typename?: 'StorageActivityConnection';
  edges?: Maybe<Array<Maybe<StorageActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StorageActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type StorageActivityEdge = {
  __typename?: 'StorageActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type StorageConnection = {
  __typename?: 'StorageConnection';
  edges?: Maybe<Array<Maybe<StorageEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type StorageConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<StorageMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<StorageSearch>>;
};

export type StorageEdge = {
  __typename?: 'StorageEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Storage>;
};

export type StorageMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  key?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
};

export type StorageSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  key?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
  value?: InputMaybe<Array<StringSearch>>;
};

export type StringSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<Scalars['String']['input']>;
};

export enum StyleEnum {
  ColorGreen = 'COLOR_GREEN',
  ColorRed = 'COLOR_RED',
  Subtext = 'SUBTEXT'
}

export type StyledValue = {
  __typename?: 'StyledValue';
  description?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  styles?: Maybe<Array<StyleEnum>>;
  value: Scalars['String']['output'];
};

export type Styler = {
  __typename?: 'Styler';
  property: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type SubmitCategoryInput = {
  questionnaireAttemptCategorySnapshotId: Scalars['String']['input'];
};

export type SubmitCategoryResponse = {
  __typename?: 'SubmitCategoryResponse';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type SubmitEvaluationInput = {
  evaluationId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  overallResult: QuestionnaireAttemptOverallResultEnum;
};

export type SubmitEvaluationResponse = {
  __typename?: 'SubmitEvaluationResponse';
  error?: Maybe<Error>;
  success: Scalars['Boolean']['output'];
};

export type SubmitFeedbackDriverInput = {
  market?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type SubmitFeedbackDriverResponse = {
  __typename?: 'SubmitFeedbackDriverResponse';
  error?: Maybe<Error>;
  message: Scalars['String']['output'];
};

export type SubmitFitForDutyDriverInput = {
  answers: Array<FitForDutyAnswer>;
};

export type SubmitFitForDutyDriverResponse = {
  __typename?: 'SubmitFitForDutyDriverResponse';
  error?: Maybe<Error>;
  message: Scalars['String']['output'];
  updated: Scalars['Int']['output'];
};

export type SuccessResponse = {
  __typename?: 'SuccessResponse';
  success: Scalars['Boolean']['output'];
};

export type Summary = {
  __typename?: 'Summary';
  average: Scalars['Float']['output'];
  children?: Maybe<Array<Maybe<Summary>>>;
  count: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
  total: Scalars['Float']['output'];
  values?: Maybe<Array<Maybe<SummaryValue>>>;
};

export enum SummaryReportFormatEnum {
  Airline = 'AIRLINE',
  Market = 'MARKET'
}

export type SummaryValue = {
  __typename?: 'SummaryValue';
  amount: Scalars['Float']['output'];
  count: Scalars['Int']['output'];
  total: Scalars['Float']['output'];
};

export type Table = {
  __typename?: 'Table';
  children?: Maybe<Array<Row>>;
  details?: Maybe<Array<TableDetails>>;
  metadata?: Maybe<Metadata>;
};

export type TableDetails = {
  __typename?: 'TableDetails';
  filters?: Maybe<Array<ReportFilters>>;
  id: Scalars['String']['output'];
};

export type TimeFrame = {
  __typename?: 'TimeFrame';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type TimeFrameActivityConnection = {
  __typename?: 'TimeFrameActivityConnection';
  edges?: Maybe<Array<Maybe<TimeFrameActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimeFrameActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TimeFrameActivityEdge = {
  __typename?: 'TimeFrameActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type TimeFrameConnection = {
  __typename?: 'TimeFrameConnection';
  edges?: Maybe<Array<Maybe<TimeFrameEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimeFrameConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TimeFrameMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TimeFrameSearch>>;
};

export type TimeFrameEdge = {
  __typename?: 'TimeFrameEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TimeFrame>;
};

export type TimeFrameMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimeFrameRange = {
  __typename?: 'TimeFrameRange';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  timeFrameId: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TimeFrameRangeActivityConnection = {
  __typename?: 'TimeFrameRangeActivityConnection';
  edges?: Maybe<Array<Maybe<TimeFrameRangeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimeFrameRangeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TimeFrameRangeActivityEdge = {
  __typename?: 'TimeFrameRangeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type TimeFrameRangeConnection = {
  __typename?: 'TimeFrameRangeConnection';
  edges?: Maybe<Array<Maybe<TimeFrameRangeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TimeFrameRangeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TimeFrameRangeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TimeFrameRangeSearch>>;
};

export type TimeFrameRangeEdge = {
  __typename?: 'TimeFrameRangeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TimeFrameRange>;
};

export type TimeFrameRangeMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['Boolean']['input']>;
  timeFrameId?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TimeFrameRangeSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  endTime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  startTime?: InputMaybe<Array<StringSearch>>;
  timeFrameId?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type TimeFrameSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type TimeIntervalBucket = {
  hour: Scalars['Int']['input'];
  minute: Scalars['Int']['input'];
  name: Scalars['String']['input'];
};

export type TimeIntervalBucketFilter = {
  __typename?: 'TimeIntervalBucketFilter';
  hour: Scalars['Int']['output'];
  minute: Scalars['Int']['output'];
  name: Scalars['String']['output'];
};

export type TrackFlight = {
  __typename?: 'TrackFlight';
  actual?: Maybe<Scalars['String']['output']>;
  arrivalGate?: Maybe<Scalars['String']['output']>;
  arrivalTerminal?: Maybe<Scalars['String']['output']>;
  arrivalTimezone?: Maybe<Scalars['String']['output']>;
  arrivalUtcOffsetHours?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  departureGate?: Maybe<Scalars['String']['output']>;
  departureTerminal?: Maybe<Scalars['String']['output']>;
  departureTimezone?: Maybe<Scalars['String']['output']>;
  departureUtcOffsetHours?: Maybe<Scalars['String']['output']>;
  flightHistoryId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  label?: Maybe<TrackFlightLabelEnum>;
  landedAt?: Maybe<Scalars['String']['output']>;
  lastPingTime?: Maybe<Scalars['String']['output']>;
  lastWebhookReceivedAt?: Maybe<Scalars['String']['output']>;
  nextPingTime?: Maybe<Scalars['String']['output']>;
  number: Scalars['Int']['output'];
  raw: Scalars['String']['output'];
  scheduled: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  status?: Maybe<Scalars['String']['output']>;
  trackerProvider?: Maybe<Scalars['String']['output']>;
  tripId: Scalars['String']['output'];
  type?: Maybe<TrackFlightTypeEnum>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TrackFlightActivityConnection = {
  __typename?: 'TrackFlightActivityConnection';
  edges?: Maybe<Array<Maybe<TrackFlightActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TrackFlightActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TrackFlightActivityEdge = {
  __typename?: 'TrackFlightActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type TrackFlightConnection = {
  __typename?: 'TrackFlightConnection';
  edges?: Maybe<Array<Maybe<TrackFlightEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TrackFlightConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TrackFlightMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TrackFlightSearch>>;
};

export type TrackFlightEdge = {
  __typename?: 'TrackFlightEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TrackFlight>;
};

export enum TrackFlightLabelEnum {
  Cancelled = 'CANCELLED',
  Delayed = 'DELAYED',
  EnRoute = 'EN_ROUTE',
  Gated = 'GATED',
  Landed = 'LANDED',
  Unknown = 'UNKNOWN'
}

export type TrackFlightLabelEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TrackFlightLabelEnum>;
};

export type TrackFlightMaskInput = {
  actual?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalGate?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalUtcOffsetHours?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  departureGate?: InputMaybe<Scalars['Boolean']['input']>;
  departureTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  departureTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  departureUtcOffsetHours?: InputMaybe<Scalars['Boolean']['input']>;
  flightHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  landedAt?: InputMaybe<Scalars['Boolean']['input']>;
  lastPingTime?: InputMaybe<Scalars['Boolean']['input']>;
  lastWebhookReceivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  nextPingTime?: InputMaybe<Scalars['Boolean']['input']>;
  number?: InputMaybe<Scalars['Boolean']['input']>;
  raw?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  trackerProvider?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrackFlightSearch = {
  actual?: InputMaybe<Array<StringSearch>>;
  arrivalGate?: InputMaybe<Array<StringSearch>>;
  arrivalTerminal?: InputMaybe<Array<StringSearch>>;
  arrivalTimezone?: InputMaybe<Array<StringSearch>>;
  arrivalUtcOffsetHours?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  departureGate?: InputMaybe<Array<StringSearch>>;
  departureTerminal?: InputMaybe<Array<StringSearch>>;
  departureTimezone?: InputMaybe<Array<StringSearch>>;
  departureUtcOffsetHours?: InputMaybe<Array<StringSearch>>;
  flightHistoryId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  label?: InputMaybe<Array<TrackFlightLabelEnumSearch>>;
  landedAt?: InputMaybe<Array<StringSearch>>;
  lastPingTime?: InputMaybe<Array<StringSearch>>;
  lastWebhookReceivedAt?: InputMaybe<Array<StringSearch>>;
  nextPingTime?: InputMaybe<Array<StringSearch>>;
  number?: InputMaybe<Array<IntSearch>>;
  raw?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<StringSearch>>;
  trackerProvider?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<TrackFlightTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum TrackFlightTypeEnum {
  Domestic = 'DOMESTIC',
  International = 'INTERNATIONAL',
  Unknown = 'UNKNOWN'
}

export type TrackFlightTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TrackFlightTypeEnum>;
};

export type TrainingUserCache = {
  __typename?: 'TrainingUserCache';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  primaryAirportCode?: Maybe<Scalars['String']['output']>;
  roleId?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type TrainingUserCacheActivityConnection = {
  __typename?: 'TrainingUserCacheActivityConnection';
  edges?: Maybe<Array<Maybe<TrainingUserCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TrainingUserCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TrainingUserCacheActivityEdge = {
  __typename?: 'TrainingUserCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type TrainingUserCacheConnection = {
  __typename?: 'TrainingUserCacheConnection';
  edges?: Maybe<Array<Maybe<TrainingUserCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TrainingUserCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TrainingUserCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TrainingUserCacheSearch>>;
};

export type TrainingUserCacheEdge = {
  __typename?: 'TrainingUserCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TrainingUserCache>;
};

export type TrainingUserCacheMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TrainingUserCacheSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  primaryAirportCode?: InputMaybe<Array<StringSearch>>;
  roleId?: InputMaybe<Array<StringSearch>>;
  startDate?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type Trip = Node & {
  __typename?: 'Trip';
  accidentIssueCount?: Maybe<Scalars['Int']['output']>;
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  combineId?: Maybe<Scalars['String']['output']>;
  combineType?: Maybe<TripCombineTypeEnum>;
  communicationCount?: Maybe<Scalars['Int']['output']>;
  communications?: Maybe<Array<Communication>>;
  companyId: Scalars['String']['output'];
  completion?: Maybe<Completion>;
  completionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewId?: Maybe<Scalars['Int']['output']>;
  curbsideAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  dispatchIssueCount?: Maybe<Scalars['Int']['output']>;
  doActualDatetime?: Maybe<Scalars['String']['output']>;
  doAirportCode?: Maybe<Scalars['String']['output']>;
  doLocation?: Maybe<Location>;
  doLocationId: Scalars['String']['output'];
  document?: Maybe<Array<TripDocumentAndPresignedUrl>>;
  driver?: Maybe<User>;
  driverCrewCount?: Maybe<Scalars['Int']['output']>;
  driverEtaDatetime?: Maybe<Scalars['String']['output']>;
  driverEtaId?: Maybe<Scalars['String']['output']>;
  driverEtaMinutes?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  etaMinutes?: Maybe<Scalars['Int']['output']>;
  fcrCount?: Maybe<Scalars['Int']['output']>;
  fcrs?: Maybe<Array<Fcr>>;
  firstName?: Maybe<Scalars['String']['output']>;
  flags?: Maybe<Array<FlagWithTrip>>;
  flightNumber: Scalars['Int']['output'];
  fromManifest: Scalars['Int']['output'];
  hasPaperwork?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  importTime?: Maybe<Scalars['String']['output']>;
  incidentIssueCount?: Maybe<Scalars['Int']['output']>;
  isIllegalCombine?: Maybe<Scalars['Int']['output']>;
  isLate?: Maybe<Scalars['Boolean']['output']>;
  issues?: Maybe<Array<Issue>>;
  kind: TripKindEnum;
  lastName?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['Int']['output']>;
  loopName: Scalars['String']['output'];
  lostAndFoundIssueCount?: Maybe<Scalars['Int']['output']>;
  manifestImportId?: Maybe<Scalars['String']['output']>;
  offset: Scalars['String']['output'];
  payerProvider?: Maybe<Provider>;
  payerProviderId: Scalars['String']['output'];
  pilots: Scalars['Int']['output'];
  plannedAt?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  providerId: Scalars['String']['output'];
  puActualDatetime?: Maybe<Scalars['String']['output']>;
  puCompletedDatetime?: Maybe<Scalars['String']['output']>;
  puGpsDatetime?: Maybe<Scalars['String']['output']>;
  puLocation?: Maybe<Location>;
  puLocationId: Scalars['String']['output'];
  rate?: Maybe<Rate>;
  rateHistoryId?: Maybe<Scalars['String']['output']>;
  rateId?: Maybe<Scalars['String']['output']>;
  ratings?: Maybe<Array<Rating>>;
  remarks?: Maybe<Array<Activity>>;
  scheduled: Scalars['String']['output'];
  scheduledUtc?: Maybe<Scalars['String']['output']>;
  servicerIataAirlineCode: Scalars['String']['output'];
  split: Scalars['Int']['output'];
  state?: Maybe<TripState>;
  status: TripStatusEnum;
  stopCount?: Maybe<Scalars['Int']['output']>;
  stops?: Maybe<Array<Stop>>;
  traceId?: Maybe<Scalars['String']['output']>;
  trackFlight?: Maybe<TrackFlight>;
  trackFlightId?: Maybe<Scalars['String']['output']>;
  type: TripTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<Vehicle>;
  vehicleId?: Maybe<Scalars['String']['output']>;
};

export type TripActivityConnection = {
  __typename?: 'TripActivityConnection';
  edges?: Maybe<Array<Maybe<TripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripActivityEdge = {
  __typename?: 'TripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type TripAndCombineType = {
  __typename?: 'TripAndCombineType';
  combineType: TripCombineTypeEnum;
  trips?: Maybe<Array<Trip>>;
};

export enum TripCombineTypeEnum {
  Illegal = 'ILLEGAL',
  IllegalOverCapacity = 'ILLEGAL_OVER_CAPACITY',
  Legal = 'LEGAL',
  LegalOverCapacity = 'LEGAL_OVER_CAPACITY'
}

export type TripCombineTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripCombineTypeEnum>;
};

export type TripConnection = {
  __typename?: 'TripConnection';
  edges?: Maybe<Array<Maybe<TripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripSearch>>;
};

export type TripDetails = {
  __typename?: 'TripDetails';
  onTimePercentage: Scalars['Float']['output'];
  totalAmountOfTrips: Scalars['Int']['output'];
};

export type TripDocument = {
  __typename?: 'TripDocument';
  contentType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  fileLocation: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  md5: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  tripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TripDocumentActivityConnection = {
  __typename?: 'TripDocumentActivityConnection';
  edges?: Maybe<Array<Maybe<TripDocumentActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripDocumentActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripDocumentActivityEdge = {
  __typename?: 'TripDocumentActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type TripDocumentAndPresignedUrl = {
  __typename?: 'TripDocumentAndPresignedURL';
  document?: Maybe<TripDocument>;
  presignedUrl?: Maybe<Scalars['String']['output']>;
};

export type TripDocumentConnection = {
  __typename?: 'TripDocumentConnection';
  edges?: Maybe<Array<Maybe<TripDocumentEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripDocumentConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripDocumentMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripDocumentSearch>>;
};

export type TripDocumentEdge = {
  __typename?: 'TripDocumentEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TripDocument>;
};

export type TripDocumentMaskInput = {
  contentType?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  fileSize?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TripDocumentSearch = {
  contentType?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  fileSize?: InputMaybe<Array<IntSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type TripDocumentWithCache = {
  __typename?: 'TripDocumentWithCache';
  contentType: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  createdByFirstName: Scalars['String']['output'];
  createdByLastName: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  deletedByFirstName: Scalars['String']['output'];
  deletedByLastName: Scalars['String']['output'];
  fileLocation: Scalars['String']['output'];
  fileSize: Scalars['Int']['output'];
  filename: Scalars['String']['output'];
  id: Scalars['String']['output'];
  md5: Scalars['String']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  tripId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type TripDocumentWithCacheActivityConnection = {
  __typename?: 'TripDocumentWithCacheActivityConnection';
  edges?: Maybe<Array<Maybe<TripDocumentWithCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripDocumentWithCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripDocumentWithCacheActivityEdge = {
  __typename?: 'TripDocumentWithCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type TripDocumentWithCacheConnection = {
  __typename?: 'TripDocumentWithCacheConnection';
  edges?: Maybe<Array<Maybe<TripDocumentWithCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripDocumentWithCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripDocumentWithCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripDocumentWithCacheSearch>>;
};

export type TripDocumentWithCacheEdge = {
  __typename?: 'TripDocumentWithCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TripDocumentWithCache>;
};

export type TripDocumentWithCacheMaskInput = {
  contentType?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  createdByFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  createdByLastName?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  deletedByLastName?: InputMaybe<Scalars['Boolean']['input']>;
  fileLocation?: InputMaybe<Scalars['Boolean']['input']>;
  fileSize?: InputMaybe<Scalars['Boolean']['input']>;
  filename?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  md5?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TripDocumentWithCacheSearch = {
  contentType?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  createdByFirstName?: InputMaybe<Array<StringSearch>>;
  createdByLastName?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  deletedByFirstName?: InputMaybe<Array<StringSearch>>;
  deletedByLastName?: InputMaybe<Array<StringSearch>>;
  fileLocation?: InputMaybe<Array<StringSearch>>;
  fileSize?: InputMaybe<Array<IntSearch>>;
  filename?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  md5?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type TripDownloadUrlObject = {
  __typename?: 'TripDownloadURLObject';
  contentType?: Maybe<Scalars['String']['output']>;
  error?: Maybe<Error>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TripEdge = {
  __typename?: 'TripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Trip>;
};

export type TripHasImport = {
  __typename?: 'TripHasImport';
  importId: Scalars['String']['output'];
  tripId: Scalars['String']['output'];
};

export type TripHasImportActivityConnection = {
  __typename?: 'TripHasImportActivityConnection';
  edges?: Maybe<Array<Maybe<TripHasImportActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripHasImportActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripHasImportActivityEdge = {
  __typename?: 'TripHasImportActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type TripHasImportConnection = {
  __typename?: 'TripHasImportConnection';
  edges?: Maybe<Array<Maybe<TripHasImportEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripHasImportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripHasImportMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripHasImportSearch>>;
};

export type TripHasImportEdge = {
  __typename?: 'TripHasImportEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TripHasImport>;
};

export type TripHasImportMaskInput = {
  importId?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TripHasImportSearch = {
  importId?: InputMaybe<Array<StringSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
};

export enum TripKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type TripKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripKindEnum>;
};

export type TripMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  combineType?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  completionId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewId?: InputMaybe<Scalars['Boolean']['input']>;
  curbsideAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  doActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  doAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  driverCrewCount?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  etaMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  fromManifest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importTime?: InputMaybe<Scalars['Boolean']['input']>;
  isIllegalCombine?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  manifestImportId?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  plannedAt?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  puActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puCompletedDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puGpsDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  rateHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  rateId?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TripPerformance = {
  __typename?: 'TripPerformance';
  averageRating?: Maybe<Scalars['Float']['output']>;
  onTimePercentage?: Maybe<Scalars['Float']['output']>;
  totalAmountOfTrips?: Maybe<Scalars['Float']['output']>;
  totalLateTrips?: Maybe<Scalars['Float']['output']>;
  totalOnTimeTrips?: Maybe<Scalars['Float']['output']>;
  tripKind?: Maybe<TripKindEnum>;
};

export type TripRequiresDriverCrewCountInput = {
  tripId: Scalars['String']['input'];
};

export type TripRequiresDriverCrewCountResponse = {
  __typename?: 'TripRequiresDriverCrewCountResponse';
  required: Scalars['Boolean']['output'];
};

export type TripResponse = {
  __typename?: 'TripResponse';
  error?: Maybe<Scalars['String']['output']>;
  node?: Maybe<Trip>;
};

export type TripScheduleTrigger = {
  __typename?: 'TripScheduleTrigger';
  accidentIssueCount?: Maybe<Scalars['Int']['output']>;
  communicationCount: Scalars['Int']['output'];
  completionTypeDisplayName?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  dispatchIssueCount?: Maybe<Scalars['Int']['output']>;
  doLocationAddress?: Maybe<Scalars['String']['output']>;
  doLocationCityName?: Maybe<Scalars['String']['output']>;
  doLocationCoordinates?: Maybe<Point>;
  doLocationId?: Maybe<Scalars['String']['output']>;
  doLocationName?: Maybe<Scalars['String']['output']>;
  doLocationPhoneNumber?: Maybe<Scalars['String']['output']>;
  doLocationStateCode?: Maybe<Scalars['String']['output']>;
  doLocationZipCode?: Maybe<Scalars['String']['output']>;
  driverAvatar?: Maybe<Scalars['String']['output']>;
  driverEmployeeId?: Maybe<Scalars['String']['output']>;
  driverEtaDatetime?: Maybe<Scalars['String']['output']>;
  driverEtaId?: Maybe<Scalars['String']['output']>;
  driverEtaMinutes?: Maybe<Scalars['Int']['output']>;
  driverFirstName?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  driverLastName?: Maybe<Scalars['String']['output']>;
  fcrCount: Scalars['Int']['output'];
  flagColors?: Maybe<Scalars['String']['output']>;
  hasPaperwork?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  incidentIssueCount?: Maybe<Scalars['Int']['output']>;
  latestScheduled?: Maybe<Scalars['String']['output']>;
  latestScheduledUtc?: Maybe<Scalars['String']['output']>;
  latestTriggerUsed?: Maybe<Scalars['String']['output']>;
  lostAndFoundIssueCount?: Maybe<Scalars['Int']['output']>;
  payerProviderDisplayName?: Maybe<Scalars['String']['output']>;
  payerProviderId?: Maybe<Scalars['String']['output']>;
  puLocationAddress?: Maybe<Scalars['String']['output']>;
  puLocationCityName?: Maybe<Scalars['String']['output']>;
  puLocationCoordinates?: Maybe<Point>;
  puLocationId?: Maybe<Scalars['String']['output']>;
  puLocationName?: Maybe<Scalars['String']['output']>;
  puLocationPhoneNumber?: Maybe<Scalars['String']['output']>;
  puLocationStateCode?: Maybe<Scalars['String']['output']>;
  puLocationZipCode?: Maybe<Scalars['String']['output']>;
  scheduledUtc: Scalars['String']['output'];
  stopCount: Scalars['Int']['output'];
  tripId: Scalars['String']['output'];
  vehicleCapacity?: Maybe<Scalars['Int']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
  vehicleMake?: Maybe<Scalars['String']['output']>;
  vehicleModel?: Maybe<Scalars['String']['output']>;
  vehiclePhoneNumber?: Maybe<Scalars['String']['output']>;
  vehicleTrackingId?: Maybe<Scalars['String']['output']>;
};

export type TripScheduleTriggerActivityConnection = {
  __typename?: 'TripScheduleTriggerActivityConnection';
  edges?: Maybe<Array<Maybe<TripScheduleTriggerActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripScheduleTriggerActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripScheduleTriggerActivityEdge = {
  __typename?: 'TripScheduleTriggerActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type TripScheduleTriggerConnection = {
  __typename?: 'TripScheduleTriggerConnection';
  edges?: Maybe<Array<Maybe<TripScheduleTriggerEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripScheduleTriggerConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripScheduleTriggerMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripScheduleTriggerSearch>>;
};

export type TripScheduleTriggerEdge = {
  __typename?: 'TripScheduleTriggerEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TripScheduleTrigger>;
};

export type TripScheduleTriggerMaskInput = {
  accidentIssueCount?: InputMaybe<Scalars['Boolean']['input']>;
  communicationCount?: InputMaybe<Scalars['Boolean']['input']>;
  completionTypeDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  dispatchIssueCount?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationAddress?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationCityName?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationCoordinates?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationName?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  driverAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  driverEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  driverEtaDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  driverEtaId?: InputMaybe<Scalars['Boolean']['input']>;
  driverEtaMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  driverFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  driverLastName?: InputMaybe<Scalars['Boolean']['input']>;
  fcrCount?: InputMaybe<Scalars['Boolean']['input']>;
  flagColors?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaperwork?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  incidentIssueCount?: InputMaybe<Scalars['Boolean']['input']>;
  latestScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  latestScheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  latestTriggerUsed?: InputMaybe<Scalars['Boolean']['input']>;
  lostAndFoundIssueCount?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationAddress?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationCityName?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationCoordinates?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationName?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  stopCount?: InputMaybe<Scalars['Boolean']['input']>;
  tripId?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleMake?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleModel?: InputMaybe<Scalars['Boolean']['input']>;
  vehiclePhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTrackingId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TripScheduleTriggerSearch = {
  accidentIssueCount?: InputMaybe<Array<IntSearch>>;
  communicationCount?: InputMaybe<Array<IntSearch>>;
  completionTypeDisplayName?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  dispatchIssueCount?: InputMaybe<Array<IntSearch>>;
  doLocationAddress?: InputMaybe<Array<StringSearch>>;
  doLocationCityName?: InputMaybe<Array<StringSearch>>;
  doLocationCoordinates?: InputMaybe<Array<PointSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  doLocationName?: InputMaybe<Array<StringSearch>>;
  doLocationPhoneNumber?: InputMaybe<Array<StringSearch>>;
  doLocationStateCode?: InputMaybe<Array<StringSearch>>;
  doLocationZipCode?: InputMaybe<Array<StringSearch>>;
  driverAvatar?: InputMaybe<Array<StringSearch>>;
  driverEmployeeId?: InputMaybe<Array<StringSearch>>;
  driverEtaDatetime?: InputMaybe<Array<StringSearch>>;
  driverEtaId?: InputMaybe<Array<StringSearch>>;
  driverEtaMinutes?: InputMaybe<Array<IntSearch>>;
  driverFirstName?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  driverLastName?: InputMaybe<Array<StringSearch>>;
  fcrCount?: InputMaybe<Array<IntSearch>>;
  flagColors?: InputMaybe<Array<StringSearch>>;
  hasPaperwork?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  incidentIssueCount?: InputMaybe<Array<IntSearch>>;
  latestScheduled?: InputMaybe<Array<StringSearch>>;
  latestScheduledUtc?: InputMaybe<Array<StringSearch>>;
  latestTriggerUsed?: InputMaybe<Array<StringSearch>>;
  lostAndFoundIssueCount?: InputMaybe<Array<IntSearch>>;
  payerProviderDisplayName?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  puLocationAddress?: InputMaybe<Array<StringSearch>>;
  puLocationCityName?: InputMaybe<Array<StringSearch>>;
  puLocationCoordinates?: InputMaybe<Array<PointSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  puLocationName?: InputMaybe<Array<StringSearch>>;
  puLocationPhoneNumber?: InputMaybe<Array<StringSearch>>;
  puLocationStateCode?: InputMaybe<Array<StringSearch>>;
  puLocationZipCode?: InputMaybe<Array<StringSearch>>;
  scheduledUtc?: InputMaybe<Array<StringSearch>>;
  stopCount?: InputMaybe<Array<IntSearch>>;
  tripId?: InputMaybe<Array<StringSearch>>;
  vehicleCapacity?: InputMaybe<Array<IntSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  vehicleMake?: InputMaybe<Array<StringSearch>>;
  vehicleModel?: InputMaybe<Array<StringSearch>>;
  vehiclePhoneNumber?: InputMaybe<Array<StringSearch>>;
  vehicleTrackingId?: InputMaybe<Array<StringSearch>>;
};

export type TripSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  combineType?: InputMaybe<Array<TripCombineTypeEnumSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  completionId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewId?: InputMaybe<Array<IntSearch>>;
  curbsideAt?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  doActualDatetime?: InputMaybe<Array<StringSearch>>;
  doAirportCode?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  driverCrewCount?: InputMaybe<Array<IntSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  etaMinutes?: InputMaybe<Array<IntSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  fromManifest?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importTime?: InputMaybe<Array<StringSearch>>;
  isIllegalCombine?: InputMaybe<Array<IntSearch>>;
  kind?: InputMaybe<Array<TripKindEnumSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  legacyId?: InputMaybe<Array<IntSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  manifestImportId?: InputMaybe<Array<StringSearch>>;
  offset?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  plannedAt?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  puActualDatetime?: InputMaybe<Array<StringSearch>>;
  puCompletedDatetime?: InputMaybe<Array<StringSearch>>;
  puGpsDatetime?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  rateHistoryId?: InputMaybe<Array<StringSearch>>;
  rateId?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  split?: InputMaybe<Array<IntSearch>>;
  status?: InputMaybe<Array<TripStatusEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  trackFlightId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<TripTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
};

export type TripState = {
  __typename?: 'TripState';
  completion?: Maybe<Completion>;
  datetimeOfChange?: Maybe<Scalars['String']['output']>;
  displayName: Scalars['String']['output'];
  displayNameShort: Scalars['String']['output'];
};

export enum TripStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type TripStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripStatusEnum>;
};

export type TripTableConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  format: TripTableFormatEnum;
  keyword?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Array<TripTableSearch>>;
};

export enum TripTableFormatEnum {
  All = 'ALL',
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Current = 'CURRENT',
  Deleted = 'DELETED',
  Fcr = 'FCR',
  FlagTrips = 'FLAG_TRIPS',
  IllegalCombine = 'ILLEGAL_COMBINE',
  Incomplete = 'INCOMPLETE',
  LegalCombine = 'LEGAL_COMBINE',
  LoopTrips = 'LOOP_TRIPS',
  NoPaperwork = 'NO_PAPERWORK',
  NoShow = 'NO_SHOW',
  Priority = 'PRIORITY',
  TaxiCalled = 'TAXI_CALLED',
  Unassigned = 'UNASSIGNED',
  United = 'UNITED',
  ZeroRates = 'ZERO_RATES'
}

export type TripTableSearch = {
  accidentIssueCount?: InputMaybe<Array<IntSearch>>;
  actual?: InputMaybe<Array<StringSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  dispatchIssueCount?: InputMaybe<Array<IntSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  doLocationName?: InputMaybe<Array<StringSearch>>;
  driverEmployeeId?: InputMaybe<Array<StringSearch>>;
  driverFirstName?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  driverLastName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  hasPaperwork?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  incidentIssueCount?: InputMaybe<Array<IntSearch>>;
  kind?: InputMaybe<Array<TripWithCompletionKindEnumSearch>>;
  latestScheduled?: InputMaybe<Array<StringSearch>>;
  latestScheduledUtc?: InputMaybe<Array<StringSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  lostAndFoundIssueCount?: InputMaybe<Array<IntSearch>>;
  payerProviderDisplayName?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  puLocationName?: InputMaybe<Array<StringSearch>>;
  rateAmount?: InputMaybe<Array<FloatSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  scheduledUtc?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<TripWithCompletionStatusEnumSearch>>;
  type?: InputMaybe<Array<TripWithCompletionTypeEnumSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  vehicleTrackingId?: InputMaybe<Array<StringSearch>>;
};

export enum TripTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type TripTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripTypeEnum>;
};

export type TripWithCompletion = {
  __typename?: 'TripWithCompletion';
  actual?: Maybe<Scalars['String']['output']>;
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  combineId?: Maybe<Scalars['String']['output']>;
  combineType?: Maybe<TripWithCompletionCombineTypeEnum>;
  companyId: Scalars['String']['output'];
  completionCost: Scalars['Float']['output'];
  completionDatetime: Scalars['String']['output'];
  completionId?: Maybe<Scalars['String']['output']>;
  completionTypeId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewId?: Maybe<Scalars['Int']['output']>;
  curbsideAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  doActualDatetime?: Maybe<Scalars['String']['output']>;
  doAirportCode?: Maybe<Scalars['String']['output']>;
  doLocationId: Scalars['String']['output'];
  driverCrewCount?: Maybe<Scalars['Int']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  etaMinutes?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flightNumber: Scalars['Int']['output'];
  fromManifest: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  importTime?: Maybe<Scalars['String']['output']>;
  isIllegalCombine?: Maybe<Scalars['Int']['output']>;
  kind: TripWithCompletionKindEnum;
  lastName?: Maybe<Scalars['String']['output']>;
  latestScheduled?: Maybe<Scalars['String']['output']>;
  latestScheduledUtc?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['Int']['output']>;
  loopName: Scalars['String']['output'];
  manifestImportId?: Maybe<Scalars['String']['output']>;
  offset: Scalars['String']['output'];
  payerProviderId: Scalars['String']['output'];
  pilots: Scalars['Int']['output'];
  plannedAt?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  puActualDatetime?: Maybe<Scalars['String']['output']>;
  puCompletedDatetime?: Maybe<Scalars['String']['output']>;
  puGpsDatetime?: Maybe<Scalars['String']['output']>;
  puLocationId: Scalars['String']['output'];
  rateHistoryId?: Maybe<Scalars['String']['output']>;
  rateId?: Maybe<Scalars['String']['output']>;
  scheduled: Scalars['String']['output'];
  scheduledUtc: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  split: Scalars['Int']['output'];
  status: TripWithCompletionStatusEnum;
  traceId?: Maybe<Scalars['String']['output']>;
  trackFlightId?: Maybe<Scalars['String']['output']>;
  trackFlightOrigin?: Maybe<TripWithCompletionTrackFlightOriginEnum>;
  type: TripWithCompletionTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
};

export type TripWithCompletionActivityConnection = {
  __typename?: 'TripWithCompletionActivityConnection';
  edges?: Maybe<Array<Maybe<TripWithCompletionActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithCompletionActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripWithCompletionActivityEdge = {
  __typename?: 'TripWithCompletionActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type TripWithCompletionAndRate = {
  __typename?: 'TripWithCompletionAndRate';
  accidentIssueCount?: Maybe<Scalars['Int']['output']>;
  actual?: Maybe<Scalars['String']['output']>;
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  cachedDoLocationId?: Maybe<Scalars['String']['output']>;
  cachedDriverId?: Maybe<Scalars['String']['output']>;
  cachedPayerProviderId?: Maybe<Scalars['String']['output']>;
  cachedPuLocationId?: Maybe<Scalars['String']['output']>;
  cachedVehicleId?: Maybe<Scalars['String']['output']>;
  combineId?: Maybe<Scalars['String']['output']>;
  combineType?: Maybe<TripWithCompletionAndRateCombineTypeEnum>;
  communicationCount: Scalars['Int']['output'];
  companyId: Scalars['String']['output'];
  completionComment: Scalars['String']['output'];
  completionCost: Scalars['Float']['output'];
  completionCreatedAt?: Maybe<Scalars['String']['output']>;
  completionCreatedBy?: Maybe<Scalars['String']['output']>;
  completionCurrency: TripWithCompletionAndRateCompletionCurrencyEnum;
  completionDatetime: Scalars['String']['output'];
  completionDistanceMeters: Scalars['Int']['output'];
  completionEfficiency: Scalars['Float']['output'];
  completionEquivalency: Scalars['Float']['output'];
  completionId?: Maybe<Scalars['String']['output']>;
  completionTypeDisplayName?: Maybe<Scalars['String']['output']>;
  completionTypeId: Scalars['String']['output'];
  completionUpdatedAt?: Maybe<Scalars['String']['output']>;
  completionUpdatedBy?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewId?: Maybe<Scalars['Int']['output']>;
  curbsideAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  dispatchIssueCount?: Maybe<Scalars['Int']['output']>;
  doActualDatetime?: Maybe<Scalars['String']['output']>;
  doAirportCode?: Maybe<Scalars['String']['output']>;
  doLocationAddress?: Maybe<Scalars['String']['output']>;
  doLocationCityName?: Maybe<Scalars['String']['output']>;
  doLocationCoordinates?: Maybe<Point>;
  doLocationId: Scalars['String']['output'];
  doLocationName?: Maybe<Scalars['String']['output']>;
  doLocationPhoneNumber?: Maybe<Scalars['String']['output']>;
  doLocationStateCode?: Maybe<Scalars['String']['output']>;
  doLocationZipCode?: Maybe<Scalars['String']['output']>;
  driverAvatar?: Maybe<Scalars['String']['output']>;
  driverCrewCount?: Maybe<Scalars['Int']['output']>;
  driverEmployeeId?: Maybe<Scalars['String']['output']>;
  driverEtaDatetime?: Maybe<Scalars['String']['output']>;
  driverEtaId?: Maybe<Scalars['String']['output']>;
  driverEtaMinutes?: Maybe<Scalars['Int']['output']>;
  driverFirstName?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  driverLastName?: Maybe<Scalars['String']['output']>;
  etaMinutes?: Maybe<Scalars['Int']['output']>;
  fcrCount: Scalars['Int']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  flagColors?: Maybe<Scalars['String']['output']>;
  flightNumber: Scalars['Int']['output'];
  fromManifest: Scalars['Int']['output'];
  hasPaperwork?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  importTime?: Maybe<Scalars['String']['output']>;
  incidentIssueCount?: Maybe<Scalars['Int']['output']>;
  isIllegalCombine?: Maybe<Scalars['Int']['output']>;
  kind: TripWithCompletionAndRateKindEnum;
  lastName?: Maybe<Scalars['String']['output']>;
  latestScheduled?: Maybe<Scalars['String']['output']>;
  latestScheduledUtc?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['Int']['output']>;
  loopName: Scalars['String']['output'];
  lostAndFoundIssueCount?: Maybe<Scalars['Int']['output']>;
  manifestImportId?: Maybe<Scalars['String']['output']>;
  offset: Scalars['String']['output'];
  payerProviderDisplayName?: Maybe<Scalars['String']['output']>;
  payerProviderId: Scalars['String']['output'];
  pilots: Scalars['Int']['output'];
  plannedAt?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  puActualDatetime?: Maybe<Scalars['String']['output']>;
  puCompletedDatetime?: Maybe<Scalars['String']['output']>;
  puGpsDatetime?: Maybe<Scalars['String']['output']>;
  puLocationAddress?: Maybe<Scalars['String']['output']>;
  puLocationCityName?: Maybe<Scalars['String']['output']>;
  puLocationCoordinates?: Maybe<Point>;
  puLocationId: Scalars['String']['output'];
  puLocationName?: Maybe<Scalars['String']['output']>;
  puLocationPhoneNumber?: Maybe<Scalars['String']['output']>;
  puLocationStateCode?: Maybe<Scalars['String']['output']>;
  puLocationZipCode?: Maybe<Scalars['String']['output']>;
  rateAmount: Scalars['Float']['output'];
  rateCreatedAt?: Maybe<Scalars['String']['output']>;
  rateCreatedBy?: Maybe<Scalars['String']['output']>;
  rateCurrency: TripWithCompletionAndRateRateCurrencyEnum;
  rateEndDatetime?: Maybe<Scalars['String']['output']>;
  rateGroupId: Scalars['String']['output'];
  rateHistoryId?: Maybe<Scalars['String']['output']>;
  rateId?: Maybe<Scalars['String']['output']>;
  rateStartDatetime?: Maybe<Scalars['String']['output']>;
  rateType: TripWithCompletionAndRateRateTypeEnum;
  rateUpdatedAt?: Maybe<Scalars['String']['output']>;
  rateUpdatedBy?: Maybe<Scalars['String']['output']>;
  scheduled: Scalars['String']['output'];
  scheduledUtc: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  split: Scalars['Int']['output'];
  status: TripWithCompletionAndRateStatusEnum;
  stopCount: Scalars['Int']['output'];
  traceId?: Maybe<Scalars['String']['output']>;
  trackFlightArrivalGate?: Maybe<Scalars['String']['output']>;
  trackFlightArrivalTerminal?: Maybe<Scalars['String']['output']>;
  trackFlightId: Scalars['String']['output'];
  trackFlightLabel?: Maybe<TripWithCompletionAndRateTrackFlightLabelEnum>;
  trackFlightLastPingTime?: Maybe<Scalars['String']['output']>;
  trackFlightOrigin?: Maybe<TripWithCompletionAndRateTrackFlightOriginEnum>;
  type: TripWithCompletionAndRateTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleCapacity?: Maybe<Scalars['Int']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
  vehicleMake?: Maybe<Scalars['String']['output']>;
  vehicleModel?: Maybe<Scalars['String']['output']>;
  vehiclePhoneNumber?: Maybe<Scalars['String']['output']>;
  vehicleTrackingId?: Maybe<Scalars['String']['output']>;
};

export type TripWithCompletionAndRateActivityConnection = {
  __typename?: 'TripWithCompletionAndRateActivityConnection';
  edges?: Maybe<Array<Maybe<TripWithCompletionAndRateActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithCompletionAndRateActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripWithCompletionAndRateActivityEdge = {
  __typename?: 'TripWithCompletionAndRateActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum TripWithCompletionAndRateCombineTypeEnum {
  Illegal = 'ILLEGAL',
  IllegalOverCapacity = 'ILLEGAL_OVER_CAPACITY',
  Legal = 'LEGAL',
  LegalOverCapacity = 'LEGAL_OVER_CAPACITY'
}

export type TripWithCompletionAndRateCombineTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionAndRateCombineTypeEnum>;
};

export enum TripWithCompletionAndRateCompletionCurrencyEnum {
  Usd = 'USD'
}

export type TripWithCompletionAndRateCompletionCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionAndRateCompletionCurrencyEnum>;
};

export type TripWithCompletionAndRateConnection = {
  __typename?: 'TripWithCompletionAndRateConnection';
  edges?: Maybe<Array<Maybe<TripWithCompletionAndRateEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithCompletionAndRateConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripWithCompletionAndRateMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripWithCompletionAndRateSearch>>;
};

export type TripWithCompletionAndRateEdge = {
  __typename?: 'TripWithCompletionAndRateEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TripWithCompletionAndRate>;
};

export enum TripWithCompletionAndRateKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type TripWithCompletionAndRateKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionAndRateKindEnum>;
};

export type TripWithCompletionAndRateMaskInput = {
  accidentIssueCount?: InputMaybe<Scalars['Boolean']['input']>;
  actual?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  cachedDoLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  cachedDriverId?: InputMaybe<Scalars['Boolean']['input']>;
  cachedPayerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  cachedPuLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  cachedVehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  combineType?: InputMaybe<Scalars['Boolean']['input']>;
  communicationCount?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  completionComment?: InputMaybe<Scalars['Boolean']['input']>;
  completionCost?: InputMaybe<Scalars['Boolean']['input']>;
  completionCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  completionCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  completionCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  completionDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  completionDistanceMeters?: InputMaybe<Scalars['Boolean']['input']>;
  completionEfficiency?: InputMaybe<Scalars['Boolean']['input']>;
  completionEquivalency?: InputMaybe<Scalars['Boolean']['input']>;
  completionId?: InputMaybe<Scalars['Boolean']['input']>;
  completionTypeDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  completionTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  completionUpdatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  completionUpdatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewId?: InputMaybe<Scalars['Boolean']['input']>;
  curbsideAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  dispatchIssueCount?: InputMaybe<Scalars['Boolean']['input']>;
  doActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  doAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationAddress?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationCityName?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationCoordinates?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationName?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  driverAvatar?: InputMaybe<Scalars['Boolean']['input']>;
  driverCrewCount?: InputMaybe<Scalars['Boolean']['input']>;
  driverEmployeeId?: InputMaybe<Scalars['Boolean']['input']>;
  driverEtaDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  driverEtaId?: InputMaybe<Scalars['Boolean']['input']>;
  driverEtaMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  driverFirstName?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  driverLastName?: InputMaybe<Scalars['Boolean']['input']>;
  etaMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  fcrCount?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  flagColors?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  fromManifest?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaperwork?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importTime?: InputMaybe<Scalars['Boolean']['input']>;
  incidentIssueCount?: InputMaybe<Scalars['Boolean']['input']>;
  isIllegalCombine?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  latestScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  latestScheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  lostAndFoundIssueCount?: InputMaybe<Scalars['Boolean']['input']>;
  manifestImportId?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  plannedAt?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  puActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puCompletedDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puGpsDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationAddress?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationCityName?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationCoordinates?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationName?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationPhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationStateCode?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationZipCode?: InputMaybe<Scalars['Boolean']['input']>;
  rateAmount?: InputMaybe<Scalars['Boolean']['input']>;
  rateCreatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  rateCreatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  rateCurrency?: InputMaybe<Scalars['Boolean']['input']>;
  rateEndDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  rateGroupId?: InputMaybe<Scalars['Boolean']['input']>;
  rateHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  rateId?: InputMaybe<Scalars['Boolean']['input']>;
  rateStartDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  rateType?: InputMaybe<Scalars['Boolean']['input']>;
  rateUpdatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  rateUpdatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  stopCount?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightArrivalGate?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightArrivalTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightId?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightLabel?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightLastPingTime?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightOrigin?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleCapacity?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleMake?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleModel?: InputMaybe<Scalars['Boolean']['input']>;
  vehiclePhoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleTrackingId?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TripWithCompletionAndRateRateCurrencyEnum {
  Usd = 'USD'
}

export type TripWithCompletionAndRateRateCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionAndRateRateCurrencyEnum>;
};

export enum TripWithCompletionAndRateRateTypeEnum {
  Adhoc = 'ADHOC',
  Contract = 'CONTRACT',
  NonContract = 'NON_CONTRACT',
  Override = 'OVERRIDE'
}

export type TripWithCompletionAndRateRateTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionAndRateRateTypeEnum>;
};

export type TripWithCompletionAndRateSearch = {
  accidentIssueCount?: InputMaybe<Array<IntSearch>>;
  actual?: InputMaybe<Array<StringSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  cachedDoLocationId?: InputMaybe<Array<StringSearch>>;
  cachedDriverId?: InputMaybe<Array<StringSearch>>;
  cachedPayerProviderId?: InputMaybe<Array<StringSearch>>;
  cachedPuLocationId?: InputMaybe<Array<StringSearch>>;
  cachedVehicleId?: InputMaybe<Array<StringSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  combineType?: InputMaybe<Array<TripWithCompletionAndRateCombineTypeEnumSearch>>;
  communicationCount?: InputMaybe<Array<IntSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  completionComment?: InputMaybe<Array<StringSearch>>;
  completionCost?: InputMaybe<Array<FloatSearch>>;
  completionCreatedAt?: InputMaybe<Array<StringSearch>>;
  completionCreatedBy?: InputMaybe<Array<StringSearch>>;
  completionCurrency?: InputMaybe<Array<TripWithCompletionAndRateCompletionCurrencyEnumSearch>>;
  completionDatetime?: InputMaybe<Array<StringSearch>>;
  completionDistanceMeters?: InputMaybe<Array<IntSearch>>;
  completionEfficiency?: InputMaybe<Array<FloatSearch>>;
  completionEquivalency?: InputMaybe<Array<FloatSearch>>;
  completionId?: InputMaybe<Array<StringSearch>>;
  completionTypeDisplayName?: InputMaybe<Array<StringSearch>>;
  completionTypeId?: InputMaybe<Array<StringSearch>>;
  completionUpdatedAt?: InputMaybe<Array<StringSearch>>;
  completionUpdatedBy?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewId?: InputMaybe<Array<IntSearch>>;
  curbsideAt?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  dispatchIssueCount?: InputMaybe<Array<IntSearch>>;
  doActualDatetime?: InputMaybe<Array<StringSearch>>;
  doAirportCode?: InputMaybe<Array<StringSearch>>;
  doLocationAddress?: InputMaybe<Array<StringSearch>>;
  doLocationCityName?: InputMaybe<Array<StringSearch>>;
  doLocationCoordinates?: InputMaybe<Array<PointSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  doLocationName?: InputMaybe<Array<StringSearch>>;
  doLocationPhoneNumber?: InputMaybe<Array<StringSearch>>;
  doLocationStateCode?: InputMaybe<Array<StringSearch>>;
  doLocationZipCode?: InputMaybe<Array<StringSearch>>;
  driverAvatar?: InputMaybe<Array<StringSearch>>;
  driverCrewCount?: InputMaybe<Array<IntSearch>>;
  driverEmployeeId?: InputMaybe<Array<StringSearch>>;
  driverEtaDatetime?: InputMaybe<Array<StringSearch>>;
  driverEtaId?: InputMaybe<Array<StringSearch>>;
  driverEtaMinutes?: InputMaybe<Array<IntSearch>>;
  driverFirstName?: InputMaybe<Array<StringSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  driverLastName?: InputMaybe<Array<StringSearch>>;
  etaMinutes?: InputMaybe<Array<IntSearch>>;
  fcrCount?: InputMaybe<Array<IntSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  flagColors?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  fromManifest?: InputMaybe<Array<IntSearch>>;
  hasPaperwork?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importTime?: InputMaybe<Array<StringSearch>>;
  incidentIssueCount?: InputMaybe<Array<IntSearch>>;
  isIllegalCombine?: InputMaybe<Array<IntSearch>>;
  kind?: InputMaybe<Array<TripWithCompletionAndRateKindEnumSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  latestScheduled?: InputMaybe<Array<StringSearch>>;
  latestScheduledUtc?: InputMaybe<Array<StringSearch>>;
  legacyId?: InputMaybe<Array<IntSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  lostAndFoundIssueCount?: InputMaybe<Array<IntSearch>>;
  manifestImportId?: InputMaybe<Array<StringSearch>>;
  offset?: InputMaybe<Array<StringSearch>>;
  payerProviderDisplayName?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  plannedAt?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  puActualDatetime?: InputMaybe<Array<StringSearch>>;
  puCompletedDatetime?: InputMaybe<Array<StringSearch>>;
  puGpsDatetime?: InputMaybe<Array<StringSearch>>;
  puLocationAddress?: InputMaybe<Array<StringSearch>>;
  puLocationCityName?: InputMaybe<Array<StringSearch>>;
  puLocationCoordinates?: InputMaybe<Array<PointSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  puLocationName?: InputMaybe<Array<StringSearch>>;
  puLocationPhoneNumber?: InputMaybe<Array<StringSearch>>;
  puLocationStateCode?: InputMaybe<Array<StringSearch>>;
  puLocationZipCode?: InputMaybe<Array<StringSearch>>;
  rateAmount?: InputMaybe<Array<FloatSearch>>;
  rateCreatedAt?: InputMaybe<Array<StringSearch>>;
  rateCreatedBy?: InputMaybe<Array<StringSearch>>;
  rateCurrency?: InputMaybe<Array<TripWithCompletionAndRateRateCurrencyEnumSearch>>;
  rateEndDatetime?: InputMaybe<Array<StringSearch>>;
  rateGroupId?: InputMaybe<Array<StringSearch>>;
  rateHistoryId?: InputMaybe<Array<StringSearch>>;
  rateId?: InputMaybe<Array<StringSearch>>;
  rateStartDatetime?: InputMaybe<Array<StringSearch>>;
  rateType?: InputMaybe<Array<TripWithCompletionAndRateRateTypeEnumSearch>>;
  rateUpdatedAt?: InputMaybe<Array<StringSearch>>;
  rateUpdatedBy?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  scheduledUtc?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  split?: InputMaybe<Array<IntSearch>>;
  status?: InputMaybe<Array<TripWithCompletionAndRateStatusEnumSearch>>;
  stopCount?: InputMaybe<Array<IntSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  trackFlightArrivalGate?: InputMaybe<Array<StringSearch>>;
  trackFlightArrivalTerminal?: InputMaybe<Array<StringSearch>>;
  trackFlightId?: InputMaybe<Array<StringSearch>>;
  trackFlightLabel?: InputMaybe<Array<TripWithCompletionAndRateTrackFlightLabelEnumSearch>>;
  trackFlightLastPingTime?: InputMaybe<Array<StringSearch>>;
  trackFlightOrigin?: InputMaybe<Array<TripWithCompletionAndRateTrackFlightOriginEnumSearch>>;
  type?: InputMaybe<Array<TripWithCompletionAndRateTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleCapacity?: InputMaybe<Array<IntSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  vehicleMake?: InputMaybe<Array<StringSearch>>;
  vehicleModel?: InputMaybe<Array<StringSearch>>;
  vehiclePhoneNumber?: InputMaybe<Array<StringSearch>>;
  vehicleTrackingId?: InputMaybe<Array<StringSearch>>;
};

export enum TripWithCompletionAndRateStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type TripWithCompletionAndRateStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionAndRateStatusEnum>;
};

export enum TripWithCompletionAndRateTrackFlightLabelEnum {
  Cancelled = 'CANCELLED',
  Delayed = 'DELAYED',
  EnRoute = 'EN_ROUTE',
  Gated = 'GATED',
  Landed = 'LANDED',
  Unknown = 'UNKNOWN'
}

export type TripWithCompletionAndRateTrackFlightLabelEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionAndRateTrackFlightLabelEnum>;
};

export enum TripWithCompletionAndRateTrackFlightOriginEnum {
  Domestic = 'DOMESTIC',
  International = 'INTERNATIONAL',
  Unknown = 'UNKNOWN'
}

export type TripWithCompletionAndRateTrackFlightOriginEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionAndRateTrackFlightOriginEnum>;
};

export enum TripWithCompletionAndRateTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type TripWithCompletionAndRateTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionAndRateTypeEnum>;
};

export enum TripWithCompletionCombineTypeEnum {
  Illegal = 'ILLEGAL',
  IllegalOverCapacity = 'ILLEGAL_OVER_CAPACITY',
  Legal = 'LEGAL',
  LegalOverCapacity = 'LEGAL_OVER_CAPACITY'
}

export type TripWithCompletionCombineTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionCombineTypeEnum>;
};

export type TripWithCompletionConnection = {
  __typename?: 'TripWithCompletionConnection';
  edges?: Maybe<Array<Maybe<TripWithCompletionEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithCompletionConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripWithCompletionMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripWithCompletionSearch>>;
};

export type TripWithCompletionEdge = {
  __typename?: 'TripWithCompletionEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TripWithCompletion>;
};

export enum TripWithCompletionKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type TripWithCompletionKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionKindEnum>;
};

export type TripWithCompletionMaskInput = {
  actual?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  combineType?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  completionCost?: InputMaybe<Scalars['Boolean']['input']>;
  completionDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  completionId?: InputMaybe<Scalars['Boolean']['input']>;
  completionTypeId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewId?: InputMaybe<Scalars['Boolean']['input']>;
  curbsideAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  doActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  doAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  driverCrewCount?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  etaMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  fromManifest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importTime?: InputMaybe<Scalars['Boolean']['input']>;
  isIllegalCombine?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  latestScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  latestScheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  manifestImportId?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  plannedAt?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  puActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puCompletedDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puGpsDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  rateHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  rateId?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightId?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightOrigin?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TripWithCompletionSearch = {
  actual?: InputMaybe<Array<StringSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  combineType?: InputMaybe<Array<TripWithCompletionCombineTypeEnumSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  completionCost?: InputMaybe<Array<FloatSearch>>;
  completionDatetime?: InputMaybe<Array<StringSearch>>;
  completionId?: InputMaybe<Array<StringSearch>>;
  completionTypeId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewId?: InputMaybe<Array<IntSearch>>;
  curbsideAt?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  doActualDatetime?: InputMaybe<Array<StringSearch>>;
  doAirportCode?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  driverCrewCount?: InputMaybe<Array<IntSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  etaMinutes?: InputMaybe<Array<IntSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  fromManifest?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importTime?: InputMaybe<Array<StringSearch>>;
  isIllegalCombine?: InputMaybe<Array<IntSearch>>;
  kind?: InputMaybe<Array<TripWithCompletionKindEnumSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  latestScheduled?: InputMaybe<Array<StringSearch>>;
  latestScheduledUtc?: InputMaybe<Array<StringSearch>>;
  legacyId?: InputMaybe<Array<IntSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  manifestImportId?: InputMaybe<Array<StringSearch>>;
  offset?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  plannedAt?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  puActualDatetime?: InputMaybe<Array<StringSearch>>;
  puCompletedDatetime?: InputMaybe<Array<StringSearch>>;
  puGpsDatetime?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  rateHistoryId?: InputMaybe<Array<StringSearch>>;
  rateId?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  scheduledUtc?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  split?: InputMaybe<Array<IntSearch>>;
  status?: InputMaybe<Array<TripWithCompletionStatusEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  trackFlightId?: InputMaybe<Array<StringSearch>>;
  trackFlightOrigin?: InputMaybe<Array<TripWithCompletionTrackFlightOriginEnumSearch>>;
  type?: InputMaybe<Array<TripWithCompletionTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
};

export enum TripWithCompletionStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type TripWithCompletionStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionStatusEnum>;
};

export enum TripWithCompletionTrackFlightOriginEnum {
  Domestic = 'DOMESTIC',
  International = 'INTERNATIONAL',
  Unknown = 'UNKNOWN'
}

export type TripWithCompletionTrackFlightOriginEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionTrackFlightOriginEnum>;
};

export enum TripWithCompletionTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type TripWithCompletionTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithCompletionTypeEnum>;
};

export type TripWithFcrInnerJoin = {
  __typename?: 'TripWithFcrInnerJoin';
  accidentIssueCount?: Maybe<Scalars['Int']['output']>;
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  combineId?: Maybe<Scalars['String']['output']>;
  combineType?: Maybe<TripWithFcrInnerJoinCombineTypeEnum>;
  companyId: Scalars['String']['output'];
  completionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewId?: Maybe<Scalars['Int']['output']>;
  curbsideAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  dispatchIssueCount?: Maybe<Scalars['Int']['output']>;
  doActualDatetime?: Maybe<Scalars['String']['output']>;
  doAirportCode?: Maybe<Scalars['String']['output']>;
  doLocationId: Scalars['String']['output'];
  driverCrewCount?: Maybe<Scalars['Int']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  etaMinutes?: Maybe<Scalars['Int']['output']>;
  fcrCause?: Maybe<Scalars['String']['output']>;
  fcrDescription?: Maybe<Scalars['String']['output']>;
  fcrId: Scalars['String']['output'];
  fcrReason: Scalars['String']['output'];
  fcrReporter?: Maybe<TripWithFcrInnerJoinFcrReporterEnum>;
  firstName?: Maybe<Scalars['String']['output']>;
  flightNumber: Scalars['Int']['output'];
  fromManifest: Scalars['Int']['output'];
  hasPaperwork?: Maybe<Scalars['Int']['output']>;
  id: Scalars['String']['output'];
  importTime?: Maybe<Scalars['String']['output']>;
  incidentIssueCount?: Maybe<Scalars['Int']['output']>;
  isIllegalCombine?: Maybe<Scalars['Int']['output']>;
  kind: TripWithFcrInnerJoinKindEnum;
  lastName?: Maybe<Scalars['String']['output']>;
  latestScheduled?: Maybe<Scalars['String']['output']>;
  latestScheduledUtc?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['Int']['output']>;
  loopName: Scalars['String']['output'];
  lostAndFoundIssueCount?: Maybe<Scalars['Int']['output']>;
  manifestImportId?: Maybe<Scalars['String']['output']>;
  offset: Scalars['String']['output'];
  payerProviderId: Scalars['String']['output'];
  pilots: Scalars['Int']['output'];
  plannedAt?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  providerDisplayName?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  puActualDatetime?: Maybe<Scalars['String']['output']>;
  puCompletedDatetime?: Maybe<Scalars['String']['output']>;
  puGpsDatetime?: Maybe<Scalars['String']['output']>;
  puLocationId: Scalars['String']['output'];
  rateHistoryId?: Maybe<Scalars['String']['output']>;
  rateId?: Maybe<Scalars['String']['output']>;
  scheduled: Scalars['String']['output'];
  scheduledUtc: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  split: Scalars['Int']['output'];
  status: TripWithFcrInnerJoinStatusEnum;
  traceId?: Maybe<Scalars['String']['output']>;
  trackFlightId?: Maybe<Scalars['String']['output']>;
  type: TripWithFcrInnerJoinTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
};

export type TripWithFcrInnerJoinActivityConnection = {
  __typename?: 'TripWithFcrInnerJoinActivityConnection';
  edges?: Maybe<Array<Maybe<TripWithFcrInnerJoinActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithFcrInnerJoinActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripWithFcrInnerJoinActivityEdge = {
  __typename?: 'TripWithFcrInnerJoinActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum TripWithFcrInnerJoinCombineTypeEnum {
  Illegal = 'ILLEGAL',
  IllegalOverCapacity = 'ILLEGAL_OVER_CAPACITY',
  Legal = 'LEGAL',
  LegalOverCapacity = 'LEGAL_OVER_CAPACITY'
}

export type TripWithFcrInnerJoinCombineTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithFcrInnerJoinCombineTypeEnum>;
};

export type TripWithFcrInnerJoinConnection = {
  __typename?: 'TripWithFcrInnerJoinConnection';
  edges?: Maybe<Array<Maybe<TripWithFcrInnerJoinEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithFcrInnerJoinConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripWithFcrInnerJoinMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripWithFcrInnerJoinSearch>>;
};

export type TripWithFcrInnerJoinEdge = {
  __typename?: 'TripWithFcrInnerJoinEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TripWithFcrInnerJoin>;
};

export enum TripWithFcrInnerJoinFcrReporterEnum {
  FlightAttendant = 'FLIGHT_ATTENDANT',
  Pilot = 'PILOT',
  Unknown = 'UNKNOWN'
}

export type TripWithFcrInnerJoinFcrReporterEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithFcrInnerJoinFcrReporterEnum>;
};

export enum TripWithFcrInnerJoinKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type TripWithFcrInnerJoinKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithFcrInnerJoinKindEnum>;
};

export type TripWithFcrInnerJoinMaskInput = {
  accidentIssueCount?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  combineType?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  completionId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewId?: InputMaybe<Scalars['Boolean']['input']>;
  curbsideAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  dispatchIssueCount?: InputMaybe<Scalars['Boolean']['input']>;
  doActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  doAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  driverCrewCount?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  etaMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  fcrCause?: InputMaybe<Scalars['Boolean']['input']>;
  fcrDescription?: InputMaybe<Scalars['Boolean']['input']>;
  fcrId?: InputMaybe<Scalars['Boolean']['input']>;
  fcrReason?: InputMaybe<Scalars['Boolean']['input']>;
  fcrReporter?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  fromManifest?: InputMaybe<Scalars['Boolean']['input']>;
  hasPaperwork?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importTime?: InputMaybe<Scalars['Boolean']['input']>;
  incidentIssueCount?: InputMaybe<Scalars['Boolean']['input']>;
  isIllegalCombine?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  latestScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  latestScheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  lostAndFoundIssueCount?: InputMaybe<Scalars['Boolean']['input']>;
  manifestImportId?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  plannedAt?: InputMaybe<Scalars['Boolean']['input']>;
  providerDisplayName?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  puActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puCompletedDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puGpsDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  rateHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  rateId?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TripWithFcrInnerJoinSearch = {
  accidentIssueCount?: InputMaybe<Array<IntSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  combineType?: InputMaybe<Array<TripWithFcrInnerJoinCombineTypeEnumSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  completionId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewId?: InputMaybe<Array<IntSearch>>;
  curbsideAt?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  dispatchIssueCount?: InputMaybe<Array<IntSearch>>;
  doActualDatetime?: InputMaybe<Array<StringSearch>>;
  doAirportCode?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  driverCrewCount?: InputMaybe<Array<IntSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  etaMinutes?: InputMaybe<Array<IntSearch>>;
  fcrCause?: InputMaybe<Array<StringSearch>>;
  fcrDescription?: InputMaybe<Array<StringSearch>>;
  fcrId?: InputMaybe<Array<StringSearch>>;
  fcrReason?: InputMaybe<Array<StringSearch>>;
  fcrReporter?: InputMaybe<Array<TripWithFcrInnerJoinFcrReporterEnumSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  fromManifest?: InputMaybe<Array<IntSearch>>;
  hasPaperwork?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importTime?: InputMaybe<Array<StringSearch>>;
  incidentIssueCount?: InputMaybe<Array<IntSearch>>;
  isIllegalCombine?: InputMaybe<Array<IntSearch>>;
  kind?: InputMaybe<Array<TripWithFcrInnerJoinKindEnumSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  latestScheduled?: InputMaybe<Array<StringSearch>>;
  latestScheduledUtc?: InputMaybe<Array<StringSearch>>;
  legacyId?: InputMaybe<Array<IntSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  lostAndFoundIssueCount?: InputMaybe<Array<IntSearch>>;
  manifestImportId?: InputMaybe<Array<StringSearch>>;
  offset?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  plannedAt?: InputMaybe<Array<StringSearch>>;
  providerDisplayName?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  puActualDatetime?: InputMaybe<Array<StringSearch>>;
  puCompletedDatetime?: InputMaybe<Array<StringSearch>>;
  puGpsDatetime?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  rateHistoryId?: InputMaybe<Array<StringSearch>>;
  rateId?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  scheduledUtc?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  split?: InputMaybe<Array<IntSearch>>;
  status?: InputMaybe<Array<TripWithFcrInnerJoinStatusEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  trackFlightId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<TripWithFcrInnerJoinTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
};

export enum TripWithFcrInnerJoinStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type TripWithFcrInnerJoinStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithFcrInnerJoinStatusEnum>;
};

export enum TripWithFcrInnerJoinTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type TripWithFcrInnerJoinTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithFcrInnerJoinTypeEnum>;
};

export type TripWithFlagInnerJoin = {
  __typename?: 'TripWithFlagInnerJoin';
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  combineId?: Maybe<Scalars['String']['output']>;
  combineType?: Maybe<TripWithFlagInnerJoinCombineTypeEnum>;
  companyId: Scalars['String']['output'];
  completionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewId?: Maybe<Scalars['Int']['output']>;
  curbsideAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  doActualDatetime?: Maybe<Scalars['String']['output']>;
  doAirportCode?: Maybe<Scalars['String']['output']>;
  doLocationId: Scalars['String']['output'];
  driverCrewCount?: Maybe<Scalars['Int']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  etaMinutes?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flightNumber: Scalars['Int']['output'];
  fromManifest: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  importTime?: Maybe<Scalars['String']['output']>;
  isIllegalCombine?: Maybe<Scalars['Int']['output']>;
  kind: TripWithFlagInnerJoinKindEnum;
  lastName?: Maybe<Scalars['String']['output']>;
  latestScheduled?: Maybe<Scalars['String']['output']>;
  latestScheduledUtc?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['Int']['output']>;
  loopName: Scalars['String']['output'];
  manifestImportId?: Maybe<Scalars['String']['output']>;
  offset: Scalars['String']['output'];
  payerProviderId: Scalars['String']['output'];
  pilots: Scalars['Int']['output'];
  plannedAt?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  puActualDatetime?: Maybe<Scalars['String']['output']>;
  puCompletedDatetime?: Maybe<Scalars['String']['output']>;
  puGpsDatetime?: Maybe<Scalars['String']['output']>;
  puLocationId: Scalars['String']['output'];
  rateHistoryId?: Maybe<Scalars['String']['output']>;
  rateId?: Maybe<Scalars['String']['output']>;
  scheduled: Scalars['String']['output'];
  scheduledUtc: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  split: Scalars['Int']['output'];
  status: TripWithFlagInnerJoinStatusEnum;
  traceId?: Maybe<Scalars['String']['output']>;
  trackFlightId?: Maybe<Scalars['String']['output']>;
  type: TripWithFlagInnerJoinTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
};

export type TripWithFlagInnerJoinActivityConnection = {
  __typename?: 'TripWithFlagInnerJoinActivityConnection';
  edges?: Maybe<Array<Maybe<TripWithFlagInnerJoinActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithFlagInnerJoinActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripWithFlagInnerJoinActivityEdge = {
  __typename?: 'TripWithFlagInnerJoinActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum TripWithFlagInnerJoinCombineTypeEnum {
  Illegal = 'ILLEGAL',
  IllegalOverCapacity = 'ILLEGAL_OVER_CAPACITY',
  Legal = 'LEGAL',
  LegalOverCapacity = 'LEGAL_OVER_CAPACITY'
}

export type TripWithFlagInnerJoinCombineTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithFlagInnerJoinCombineTypeEnum>;
};

export type TripWithFlagInnerJoinConnection = {
  __typename?: 'TripWithFlagInnerJoinConnection';
  edges?: Maybe<Array<Maybe<TripWithFlagInnerJoinEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithFlagInnerJoinConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripWithFlagInnerJoinMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripWithFlagInnerJoinSearch>>;
};

export type TripWithFlagInnerJoinEdge = {
  __typename?: 'TripWithFlagInnerJoinEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TripWithFlagInnerJoin>;
};

export enum TripWithFlagInnerJoinKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type TripWithFlagInnerJoinKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithFlagInnerJoinKindEnum>;
};

export type TripWithFlagInnerJoinMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  combineType?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  completionId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewId?: InputMaybe<Scalars['Boolean']['input']>;
  curbsideAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  doActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  doAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  driverCrewCount?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  etaMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  fromManifest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importTime?: InputMaybe<Scalars['Boolean']['input']>;
  isIllegalCombine?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  latestScheduled?: InputMaybe<Scalars['Boolean']['input']>;
  latestScheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  manifestImportId?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  plannedAt?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  puActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puCompletedDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puGpsDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  rateHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  rateId?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TripWithFlagInnerJoinSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  combineType?: InputMaybe<Array<TripWithFlagInnerJoinCombineTypeEnumSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  completionId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewId?: InputMaybe<Array<IntSearch>>;
  curbsideAt?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  doActualDatetime?: InputMaybe<Array<StringSearch>>;
  doAirportCode?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  driverCrewCount?: InputMaybe<Array<IntSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  etaMinutes?: InputMaybe<Array<IntSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  fromManifest?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importTime?: InputMaybe<Array<StringSearch>>;
  isIllegalCombine?: InputMaybe<Array<IntSearch>>;
  kind?: InputMaybe<Array<TripWithFlagInnerJoinKindEnumSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  latestScheduled?: InputMaybe<Array<StringSearch>>;
  latestScheduledUtc?: InputMaybe<Array<StringSearch>>;
  legacyId?: InputMaybe<Array<IntSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  manifestImportId?: InputMaybe<Array<StringSearch>>;
  offset?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  plannedAt?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  puActualDatetime?: InputMaybe<Array<StringSearch>>;
  puCompletedDatetime?: InputMaybe<Array<StringSearch>>;
  puGpsDatetime?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  rateHistoryId?: InputMaybe<Array<StringSearch>>;
  rateId?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  scheduledUtc?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  split?: InputMaybe<Array<IntSearch>>;
  status?: InputMaybe<Array<TripWithFlagInnerJoinStatusEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  trackFlightId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<TripWithFlagInnerJoinTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
};

export enum TripWithFlagInnerJoinStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type TripWithFlagInnerJoinStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithFlagInnerJoinStatusEnum>;
};

export enum TripWithFlagInnerJoinTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type TripWithFlagInnerJoinTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithFlagInnerJoinTypeEnum>;
};

export type TripWithRate = {
  __typename?: 'TripWithRate';
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  combineId?: Maybe<Scalars['String']['output']>;
  combineType?: Maybe<TripWithRateCombineTypeEnum>;
  companyId: Scalars['String']['output'];
  completionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewId?: Maybe<Scalars['Int']['output']>;
  curbsideAt?: Maybe<Scalars['String']['output']>;
  currency: TripWithRateCurrencyEnum;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  doActualDatetime?: Maybe<Scalars['String']['output']>;
  doAirportCode?: Maybe<Scalars['String']['output']>;
  doLocationId: Scalars['String']['output'];
  driverCrewCount?: Maybe<Scalars['Int']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  etaMinutes?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flightNumber: Scalars['Int']['output'];
  fromManifest: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  importTime?: Maybe<Scalars['String']['output']>;
  isIllegalCombine?: Maybe<Scalars['Int']['output']>;
  kind: TripWithRateKindEnum;
  lastName?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['Int']['output']>;
  loopName: Scalars['String']['output'];
  manifestImportId?: Maybe<Scalars['String']['output']>;
  offset: Scalars['String']['output'];
  payerProviderId: Scalars['String']['output'];
  pilots: Scalars['Int']['output'];
  plannedAt?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  puActualDatetime?: Maybe<Scalars['String']['output']>;
  puCompletedDatetime?: Maybe<Scalars['String']['output']>;
  puGpsDatetime?: Maybe<Scalars['String']['output']>;
  puLocationId: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  rateGroupId: Scalars['String']['output'];
  rateHistoryId?: Maybe<Scalars['String']['output']>;
  rateId?: Maybe<Scalars['String']['output']>;
  scheduled: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  split: Scalars['Int']['output'];
  status: TripWithRateStatusEnum;
  traceId?: Maybe<Scalars['String']['output']>;
  trackFlightId?: Maybe<Scalars['String']['output']>;
  type: TripWithRateTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
};

export type TripWithRateActivityConnection = {
  __typename?: 'TripWithRateActivityConnection';
  edges?: Maybe<Array<Maybe<TripWithRateActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithRateActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripWithRateActivityEdge = {
  __typename?: 'TripWithRateActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type TripWithRateChange = {
  __typename?: 'TripWithRateChange';
  newRate?: Maybe<Rate>;
  newRateId?: Maybe<Scalars['String']['output']>;
  oldRate?: Maybe<Rate>;
  oldRateId?: Maybe<Scalars['String']['output']>;
  trip?: Maybe<Trip>;
};

export enum TripWithRateCombineTypeEnum {
  Illegal = 'ILLEGAL',
  IllegalOverCapacity = 'ILLEGAL_OVER_CAPACITY',
  Legal = 'LEGAL',
  LegalOverCapacity = 'LEGAL_OVER_CAPACITY'
}

export type TripWithRateCombineTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithRateCombineTypeEnum>;
};

export type TripWithRateConnection = {
  __typename?: 'TripWithRateConnection';
  edges?: Maybe<Array<Maybe<TripWithRateEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithRateConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripWithRateMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripWithRateSearch>>;
};

export enum TripWithRateCurrencyEnum {
  Usd = 'USD'
}

export type TripWithRateCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithRateCurrencyEnum>;
};

export type TripWithRateEdge = {
  __typename?: 'TripWithRateEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TripWithRate>;
};

export type TripWithRateForAuditReport = {
  __typename?: 'TripWithRateForAuditReport';
  airportCode: Scalars['String']['output'];
  combineId?: Maybe<Scalars['String']['output']>;
  combineType?: Maybe<TripWithRateForAuditReportCombineTypeEnum>;
  companyId: Scalars['String']['output'];
  currency: TripWithRateForAuditReportCurrencyEnum;
  deletedAt?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  payerProviderId: Scalars['String']['output'];
  rate: Scalars['Float']['output'];
  rateId?: Maybe<Scalars['String']['output']>;
  rateType: TripWithRateForAuditReportRateTypeEnum;
  scheduled: Scalars['String']['output'];
  status: TripWithRateForAuditReportStatusEnum;
  type: TripWithRateForAuditReportTypeEnum;
};

export type TripWithRateForAuditReportActivityConnection = {
  __typename?: 'TripWithRateForAuditReportActivityConnection';
  edges?: Maybe<Array<Maybe<TripWithRateForAuditReportActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithRateForAuditReportActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripWithRateForAuditReportActivityEdge = {
  __typename?: 'TripWithRateForAuditReportActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum TripWithRateForAuditReportCombineTypeEnum {
  Illegal = 'ILLEGAL',
  IllegalOverCapacity = 'ILLEGAL_OVER_CAPACITY',
  Legal = 'LEGAL',
  LegalOverCapacity = 'LEGAL_OVER_CAPACITY'
}

export type TripWithRateForAuditReportCombineTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithRateForAuditReportCombineTypeEnum>;
};

export type TripWithRateForAuditReportConnection = {
  __typename?: 'TripWithRateForAuditReportConnection';
  edges?: Maybe<Array<Maybe<TripWithRateForAuditReportEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithRateForAuditReportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripWithRateForAuditReportMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripWithRateForAuditReportSearch>>;
};

export enum TripWithRateForAuditReportCurrencyEnum {
  Usd = 'USD'
}

export type TripWithRateForAuditReportCurrencyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithRateForAuditReportCurrencyEnum>;
};

export type TripWithRateForAuditReportEdge = {
  __typename?: 'TripWithRateForAuditReportEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TripWithRateForAuditReport>;
};

export type TripWithRateForAuditReportMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  combineType?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
  rateId?: InputMaybe<Scalars['Boolean']['input']>;
  rateType?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum TripWithRateForAuditReportRateTypeEnum {
  Adhoc = 'ADHOC',
  Contract = 'CONTRACT',
  NonContract = 'NON_CONTRACT',
  Override = 'OVERRIDE'
}

export type TripWithRateForAuditReportRateTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithRateForAuditReportRateTypeEnum>;
};

export type TripWithRateForAuditReportSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  combineType?: InputMaybe<Array<TripWithRateForAuditReportCombineTypeEnumSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  currency?: InputMaybe<Array<TripWithRateForAuditReportCurrencyEnumSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  rate?: InputMaybe<Array<FloatSearch>>;
  rateId?: InputMaybe<Array<StringSearch>>;
  rateType?: InputMaybe<Array<TripWithRateForAuditReportRateTypeEnumSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  status?: InputMaybe<Array<TripWithRateForAuditReportStatusEnumSearch>>;
  type?: InputMaybe<Array<TripWithRateForAuditReportTypeEnumSearch>>;
};

export enum TripWithRateForAuditReportStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type TripWithRateForAuditReportStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithRateForAuditReportStatusEnum>;
};

export enum TripWithRateForAuditReportTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type TripWithRateForAuditReportTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithRateForAuditReportTypeEnum>;
};

export enum TripWithRateKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type TripWithRateKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithRateKindEnum>;
};

export type TripWithRateMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  combineType?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  completionId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewId?: InputMaybe<Scalars['Boolean']['input']>;
  curbsideAt?: InputMaybe<Scalars['Boolean']['input']>;
  currency?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  doActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  doAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  driverCrewCount?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  etaMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  fromManifest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importTime?: InputMaybe<Scalars['Boolean']['input']>;
  isIllegalCombine?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  manifestImportId?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  plannedAt?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  puActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puCompletedDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puGpsDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  rate?: InputMaybe<Scalars['Boolean']['input']>;
  rateGroupId?: InputMaybe<Scalars['Boolean']['input']>;
  rateHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  rateId?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TripWithRateSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  combineType?: InputMaybe<Array<TripWithRateCombineTypeEnumSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  completionId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewId?: InputMaybe<Array<IntSearch>>;
  curbsideAt?: InputMaybe<Array<StringSearch>>;
  currency?: InputMaybe<Array<TripWithRateCurrencyEnumSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  doActualDatetime?: InputMaybe<Array<StringSearch>>;
  doAirportCode?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  driverCrewCount?: InputMaybe<Array<IntSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  etaMinutes?: InputMaybe<Array<IntSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  fromManifest?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importTime?: InputMaybe<Array<StringSearch>>;
  isIllegalCombine?: InputMaybe<Array<IntSearch>>;
  kind?: InputMaybe<Array<TripWithRateKindEnumSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  legacyId?: InputMaybe<Array<IntSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  manifestImportId?: InputMaybe<Array<StringSearch>>;
  offset?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  plannedAt?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  puActualDatetime?: InputMaybe<Array<StringSearch>>;
  puCompletedDatetime?: InputMaybe<Array<StringSearch>>;
  puGpsDatetime?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  rate?: InputMaybe<Array<FloatSearch>>;
  rateGroupId?: InputMaybe<Array<StringSearch>>;
  rateHistoryId?: InputMaybe<Array<StringSearch>>;
  rateId?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  split?: InputMaybe<Array<IntSearch>>;
  status?: InputMaybe<Array<TripWithRateStatusEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  trackFlightId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<TripWithRateTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
};

export enum TripWithRateStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type TripWithRateStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithRateStatusEnum>;
};

export enum TripWithRateTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type TripWithRateTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithRateTypeEnum>;
};

export type TripWithTrackFlight = {
  __typename?: 'TripWithTrackFlight';
  actual?: Maybe<Scalars['String']['output']>;
  airportCode: Scalars['String']['output'];
  arrivalGate?: Maybe<Scalars['String']['output']>;
  arrivalTerminal?: Maybe<Scalars['String']['output']>;
  arrivalTimezone?: Maybe<Scalars['String']['output']>;
  arrivalUtcOffsetHours?: Maybe<Scalars['String']['output']>;
  attendants: Scalars['Int']['output'];
  combineId?: Maybe<Scalars['String']['output']>;
  combineType?: Maybe<TripWithTrackFlightCombineTypeEnum>;
  companyId: Scalars['String']['output'];
  completionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewId?: Maybe<Scalars['Int']['output']>;
  curbsideAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  departureGate?: Maybe<Scalars['String']['output']>;
  departureTerminal?: Maybe<Scalars['String']['output']>;
  departureTimezone?: Maybe<Scalars['String']['output']>;
  departureUtcOffsetHours?: Maybe<Scalars['String']['output']>;
  doActualDatetime?: Maybe<Scalars['String']['output']>;
  doAirportCode?: Maybe<Scalars['String']['output']>;
  doLocationId: Scalars['String']['output'];
  driverCrewCount?: Maybe<Scalars['Int']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  etaMinutes?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flightNumber: Scalars['Int']['output'];
  fromManifest: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  importTime?: Maybe<Scalars['String']['output']>;
  isIllegalCombine?: Maybe<Scalars['Int']['output']>;
  kind: TripWithTrackFlightKindEnum;
  label?: Maybe<TripWithTrackFlightLabelEnum>;
  lastName?: Maybe<Scalars['String']['output']>;
  lastPingTime?: Maybe<Scalars['String']['output']>;
  lastWebhookReceivedAt?: Maybe<Scalars['String']['output']>;
  latestScheduledUtc?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['Int']['output']>;
  loopName: Scalars['String']['output'];
  manifestImportId?: Maybe<Scalars['String']['output']>;
  nextPingTime?: Maybe<Scalars['String']['output']>;
  offset: Scalars['String']['output'];
  payerProviderId: Scalars['String']['output'];
  pilots: Scalars['Int']['output'];
  plannedAt?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  puActualDatetime?: Maybe<Scalars['String']['output']>;
  puCompletedDatetime?: Maybe<Scalars['String']['output']>;
  puGpsDatetime?: Maybe<Scalars['String']['output']>;
  puLocationId: Scalars['String']['output'];
  rateHistoryId?: Maybe<Scalars['String']['output']>;
  rateId?: Maybe<Scalars['String']['output']>;
  scheduled: Scalars['String']['output'];
  scheduledUtc: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  split: Scalars['Int']['output'];
  status: TripWithTrackFlightStatusEnum;
  traceId?: Maybe<Scalars['String']['output']>;
  trackFlightId?: Maybe<Scalars['String']['output']>;
  trackFlightIdNew: Scalars['String']['output'];
  trackFlightStatus?: Maybe<Scalars['String']['output']>;
  trackFlightType?: Maybe<TripWithTrackFlightTrackFlightTypeEnum>;
  trackerProvider?: Maybe<Scalars['String']['output']>;
  type: TripWithTrackFlightTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
};

export type TripWithTrackFlightActivityConnection = {
  __typename?: 'TripWithTrackFlightActivityConnection';
  edges?: Maybe<Array<Maybe<TripWithTrackFlightActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithTrackFlightActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripWithTrackFlightActivityEdge = {
  __typename?: 'TripWithTrackFlightActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum TripWithTrackFlightCombineTypeEnum {
  Illegal = 'ILLEGAL',
  IllegalOverCapacity = 'ILLEGAL_OVER_CAPACITY',
  Legal = 'LEGAL',
  LegalOverCapacity = 'LEGAL_OVER_CAPACITY'
}

export type TripWithTrackFlightCombineTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithTrackFlightCombineTypeEnum>;
};

export type TripWithTrackFlightConnection = {
  __typename?: 'TripWithTrackFlightConnection';
  edges?: Maybe<Array<Maybe<TripWithTrackFlightEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithTrackFlightConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripWithTrackFlightMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripWithTrackFlightSearch>>;
};

export type TripWithTrackFlightEdge = {
  __typename?: 'TripWithTrackFlightEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TripWithTrackFlight>;
};

export enum TripWithTrackFlightKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type TripWithTrackFlightKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithTrackFlightKindEnum>;
};

export enum TripWithTrackFlightLabelEnum {
  Cancelled = 'CANCELLED',
  Delayed = 'DELAYED',
  EnRoute = 'EN_ROUTE',
  Gated = 'GATED',
  Landed = 'LANDED',
  Unknown = 'UNKNOWN'
}

export type TripWithTrackFlightLabelEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithTrackFlightLabelEnum>;
};

export type TripWithTrackFlightMaskInput = {
  actual?: InputMaybe<Scalars['Boolean']['input']>;
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalGate?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  arrivalUtcOffsetHours?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  combineType?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  completionId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewId?: InputMaybe<Scalars['Boolean']['input']>;
  curbsideAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  departureGate?: InputMaybe<Scalars['Boolean']['input']>;
  departureTerminal?: InputMaybe<Scalars['Boolean']['input']>;
  departureTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  departureUtcOffsetHours?: InputMaybe<Scalars['Boolean']['input']>;
  doActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  doAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  driverCrewCount?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  etaMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  fromManifest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importTime?: InputMaybe<Scalars['Boolean']['input']>;
  isIllegalCombine?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  label?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  lastPingTime?: InputMaybe<Scalars['Boolean']['input']>;
  lastWebhookReceivedAt?: InputMaybe<Scalars['Boolean']['input']>;
  latestScheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  manifestImportId?: InputMaybe<Scalars['Boolean']['input']>;
  nextPingTime?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  plannedAt?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  puActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puCompletedDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puGpsDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  rateHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  rateId?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightId?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightIdNew?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightStatus?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightType?: InputMaybe<Scalars['Boolean']['input']>;
  trackerProvider?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TripWithTrackFlightSearch = {
  actual?: InputMaybe<Array<StringSearch>>;
  airportCode?: InputMaybe<Array<StringSearch>>;
  arrivalGate?: InputMaybe<Array<StringSearch>>;
  arrivalTerminal?: InputMaybe<Array<StringSearch>>;
  arrivalTimezone?: InputMaybe<Array<StringSearch>>;
  arrivalUtcOffsetHours?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  combineType?: InputMaybe<Array<TripWithTrackFlightCombineTypeEnumSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  completionId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewId?: InputMaybe<Array<IntSearch>>;
  curbsideAt?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  departureGate?: InputMaybe<Array<StringSearch>>;
  departureTerminal?: InputMaybe<Array<StringSearch>>;
  departureTimezone?: InputMaybe<Array<StringSearch>>;
  departureUtcOffsetHours?: InputMaybe<Array<StringSearch>>;
  doActualDatetime?: InputMaybe<Array<StringSearch>>;
  doAirportCode?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  driverCrewCount?: InputMaybe<Array<IntSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  etaMinutes?: InputMaybe<Array<IntSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  fromManifest?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importTime?: InputMaybe<Array<StringSearch>>;
  isIllegalCombine?: InputMaybe<Array<IntSearch>>;
  kind?: InputMaybe<Array<TripWithTrackFlightKindEnumSearch>>;
  label?: InputMaybe<Array<TripWithTrackFlightLabelEnumSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  lastPingTime?: InputMaybe<Array<StringSearch>>;
  lastWebhookReceivedAt?: InputMaybe<Array<StringSearch>>;
  latestScheduledUtc?: InputMaybe<Array<StringSearch>>;
  legacyId?: InputMaybe<Array<IntSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  manifestImportId?: InputMaybe<Array<StringSearch>>;
  nextPingTime?: InputMaybe<Array<StringSearch>>;
  offset?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  plannedAt?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  puActualDatetime?: InputMaybe<Array<StringSearch>>;
  puCompletedDatetime?: InputMaybe<Array<StringSearch>>;
  puGpsDatetime?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  rateHistoryId?: InputMaybe<Array<StringSearch>>;
  rateId?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  scheduledUtc?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  split?: InputMaybe<Array<IntSearch>>;
  status?: InputMaybe<Array<TripWithTrackFlightStatusEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  trackFlightId?: InputMaybe<Array<StringSearch>>;
  trackFlightIdNew?: InputMaybe<Array<StringSearch>>;
  trackFlightStatus?: InputMaybe<Array<StringSearch>>;
  trackFlightType?: InputMaybe<Array<TripWithTrackFlightTrackFlightTypeEnumSearch>>;
  trackerProvider?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<TripWithTrackFlightTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
};

export enum TripWithTrackFlightStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type TripWithTrackFlightStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithTrackFlightStatusEnum>;
};

export enum TripWithTrackFlightTrackFlightTypeEnum {
  Domestic = 'DOMESTIC',
  International = 'INTERNATIONAL',
  Unknown = 'UNKNOWN'
}

export type TripWithTrackFlightTrackFlightTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithTrackFlightTrackFlightTypeEnum>;
};

export enum TripWithTrackFlightTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type TripWithTrackFlightTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithTrackFlightTypeEnum>;
};

export type TripWithUtc = {
  __typename?: 'TripWithUtc';
  airportCode: Scalars['String']['output'];
  attendants: Scalars['Int']['output'];
  combineId?: Maybe<Scalars['String']['output']>;
  combineType?: Maybe<TripWithUtcCombineTypeEnum>;
  companyId: Scalars['String']['output'];
  completionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  crewId?: Maybe<Scalars['Int']['output']>;
  curbsideAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  doActualDatetime?: Maybe<Scalars['String']['output']>;
  doAirportCode?: Maybe<Scalars['String']['output']>;
  doLocationId: Scalars['String']['output'];
  driverCrewCount?: Maybe<Scalars['Int']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  etaMinutes?: Maybe<Scalars['Int']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  flightNumber: Scalars['Int']['output'];
  fromManifest: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  importTime?: Maybe<Scalars['String']['output']>;
  isIllegalCombine?: Maybe<Scalars['Int']['output']>;
  kind: TripWithUtcKindEnum;
  lastName?: Maybe<Scalars['String']['output']>;
  legacyId?: Maybe<Scalars['Int']['output']>;
  loopName: Scalars['String']['output'];
  manifestImportId?: Maybe<Scalars['String']['output']>;
  offset: Scalars['String']['output'];
  payerProviderId: Scalars['String']['output'];
  pilots: Scalars['Int']['output'];
  plannedAt?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['String']['output'];
  puActualDatetime?: Maybe<Scalars['String']['output']>;
  puCompletedDatetime?: Maybe<Scalars['String']['output']>;
  puGpsDatetime?: Maybe<Scalars['String']['output']>;
  puLocationId: Scalars['String']['output'];
  rateHistoryId?: Maybe<Scalars['String']['output']>;
  rateId?: Maybe<Scalars['String']['output']>;
  scheduled: Scalars['String']['output'];
  scheduledUtc: Scalars['String']['output'];
  servicerIataAirlineCode: Scalars['String']['output'];
  split: Scalars['Int']['output'];
  status: TripWithUtcStatusEnum;
  traceId?: Maybe<Scalars['String']['output']>;
  trackFlightId?: Maybe<Scalars['String']['output']>;
  type: TripWithUtcTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
};

export type TripWithUtcActivityConnection = {
  __typename?: 'TripWithUtcActivityConnection';
  edges?: Maybe<Array<Maybe<TripWithUtcActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithUtcActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type TripWithUtcActivityEdge = {
  __typename?: 'TripWithUtcActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum TripWithUtcCombineTypeEnum {
  Illegal = 'ILLEGAL',
  IllegalOverCapacity = 'ILLEGAL_OVER_CAPACITY',
  Legal = 'LEGAL',
  LegalOverCapacity = 'LEGAL_OVER_CAPACITY'
}

export type TripWithUtcCombineTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithUtcCombineTypeEnum>;
};

export type TripWithUtcConnection = {
  __typename?: 'TripWithUtcConnection';
  edges?: Maybe<Array<Maybe<TripWithUtcEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type TripWithUtcConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<TripWithUtcMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<TripWithUtcSearch>>;
};

export type TripWithUtcEdge = {
  __typename?: 'TripWithUtcEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<TripWithUtc>;
};

export enum TripWithUtcKindEnum {
  Arr = 'ARR',
  Dep = 'DEP'
}

export type TripWithUtcKindEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithUtcKindEnum>;
};

export type TripWithUtcMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  attendants?: InputMaybe<Scalars['Boolean']['input']>;
  combineId?: InputMaybe<Scalars['Boolean']['input']>;
  combineType?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  completionId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  crewId?: InputMaybe<Scalars['Boolean']['input']>;
  curbsideAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  doActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  doAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  driverCrewCount?: InputMaybe<Scalars['Boolean']['input']>;
  driverId?: InputMaybe<Scalars['Boolean']['input']>;
  etaMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  fromManifest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importTime?: InputMaybe<Scalars['Boolean']['input']>;
  isIllegalCombine?: InputMaybe<Scalars['Boolean']['input']>;
  kind?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  legacyId?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  manifestImportId?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Boolean']['input']>;
  payerProviderId?: InputMaybe<Scalars['Boolean']['input']>;
  pilots?: InputMaybe<Scalars['Boolean']['input']>;
  plannedAt?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  puActualDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puCompletedDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puGpsDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  rateHistoryId?: InputMaybe<Scalars['Boolean']['input']>;
  rateId?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  scheduledUtc?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
  status?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  trackFlightId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TripWithUtcSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  attendants?: InputMaybe<Array<IntSearch>>;
  combineId?: InputMaybe<Array<StringSearch>>;
  combineType?: InputMaybe<Array<TripWithUtcCombineTypeEnumSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  completionId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  crewId?: InputMaybe<Array<IntSearch>>;
  curbsideAt?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  doActualDatetime?: InputMaybe<Array<StringSearch>>;
  doAirportCode?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  driverCrewCount?: InputMaybe<Array<IntSearch>>;
  driverId?: InputMaybe<Array<StringSearch>>;
  etaMinutes?: InputMaybe<Array<IntSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  fromManifest?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importTime?: InputMaybe<Array<StringSearch>>;
  isIllegalCombine?: InputMaybe<Array<IntSearch>>;
  kind?: InputMaybe<Array<TripWithUtcKindEnumSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  legacyId?: InputMaybe<Array<IntSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  manifestImportId?: InputMaybe<Array<StringSearch>>;
  offset?: InputMaybe<Array<StringSearch>>;
  payerProviderId?: InputMaybe<Array<StringSearch>>;
  pilots?: InputMaybe<Array<IntSearch>>;
  plannedAt?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  puActualDatetime?: InputMaybe<Array<StringSearch>>;
  puCompletedDatetime?: InputMaybe<Array<StringSearch>>;
  puGpsDatetime?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  rateHistoryId?: InputMaybe<Array<StringSearch>>;
  rateId?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  scheduledUtc?: InputMaybe<Array<StringSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  split?: InputMaybe<Array<IntSearch>>;
  status?: InputMaybe<Array<TripWithUtcStatusEnumSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  trackFlightId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<TripWithUtcTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
};

export enum TripWithUtcStatusEnum {
  Active = 'ACTIVE',
  Cancelled = 'CANCELLED'
}

export type TripWithUtcStatusEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithUtcStatusEnum>;
};

export enum TripWithUtcTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type TripWithUtcTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<TripWithUtcTypeEnum>;
};

export enum TypeNameEnum {
  Addon = 'ADDON',
  Manifest = 'MANIFEST',
  Special = 'SPECIAL'
}

export type UndeleteTripBulkInput = {
  tripIds?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UndeleteTripBulkResponse = {
  __typename?: 'UndeleteTripBulkResponse';
  error?: Maybe<Error>;
  undeleted: Scalars['Int']['output'];
};

export type UniqueTrip = {
  __typename?: 'UniqueTrip';
  companyId: Scalars['String']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  doLocationId: Scalars['String']['output'];
  flightNumber: Scalars['Int']['output'];
  fromManifest: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  loopName: Scalars['String']['output'];
  providerId: Scalars['String']['output'];
  puLocationId: Scalars['String']['output'];
  scheduled: Scalars['String']['output'];
  split: Scalars['Int']['output'];
};

export type UniqueTripActivityConnection = {
  __typename?: 'UniqueTripActivityConnection';
  edges?: Maybe<Array<Maybe<UniqueTripActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UniqueTripActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type UniqueTripActivityEdge = {
  __typename?: 'UniqueTripActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type UniqueTripConnection = {
  __typename?: 'UniqueTripConnection';
  edges?: Maybe<Array<Maybe<UniqueTripEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UniqueTripConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<UniqueTripMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<UniqueTripSearch>>;
};

export type UniqueTripEdge = {
  __typename?: 'UniqueTripEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<UniqueTrip>;
};

export type UniqueTripMaskInput = {
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  doLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  flightNumber?: InputMaybe<Scalars['Boolean']['input']>;
  fromManifest?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  loopName?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  puLocationId?: InputMaybe<Scalars['Boolean']['input']>;
  scheduled?: InputMaybe<Scalars['Boolean']['input']>;
  split?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UniqueTripSearch = {
  companyId?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  doLocationId?: InputMaybe<Array<StringSearch>>;
  flightNumber?: InputMaybe<Array<IntSearch>>;
  fromManifest?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  loopName?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  puLocationId?: InputMaybe<Array<StringSearch>>;
  scheduled?: InputMaybe<Array<StringSearch>>;
  split?: InputMaybe<Array<IntSearch>>;
};

export type UpdateAccidentIssueBulkInput = {
  updates: Array<UpdateAccidentIssueInput>;
};

export type UpdateAccidentIssueBulkResponse = {
  __typename?: 'UpdateAccidentIssueBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAccidentIssueDocumentBulkInput = {
  updates: Array<UpdateAccidentIssueDocumentInput>;
};

export type UpdateAccidentIssueDocumentBulkResponse = {
  __typename?: 'UpdateAccidentIssueDocumentBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAccidentIssueDocumentInput = {
  query: Array<AccidentIssueDocumentSearch>;
  value: UpdateAccidentIssueDocumentValuesInput;
};

export type UpdateAccidentIssueDocumentValuesInput = {
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  fileLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  fileSize?: InputMaybe<Array<Scalars['Int']['input']>>;
  filename?: InputMaybe<Array<Scalars['String']['input']>>;
  issueId?: InputMaybe<Array<Scalars['String']['input']>>;
  md5?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAccidentIssueInput = {
  query: Array<AccidentIssueSearch>;
  value: UpdateAccidentIssueValuesInput;
};

export type UpdateAccidentIssueValuesInput = {
  accidentDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  additionalDriverScheduled?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  anyoneInjured?: InputMaybe<Array<AccidentIssueAnyoneInjuredEnum>>;
  canVehicleBeDriven?: InputMaybe<Array<AccidentIssueCanVehicleBeDrivenEnum>>;
  damageToOtherVehicles?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Array<Scalars['String']['input']>>;
  didDriverCallHelp?: InputMaybe<Array<AccidentIssueDidDriverCallHelpEnum>>;
  dispatcherContactedManager?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dispatcherId?: InputMaybe<Array<Scalars['String']['input']>>;
  driverContactedManager?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  driverId?: InputMaybe<Array<Scalars['String']['input']>>;
  infoOfCrewMembers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  infoOfInjuredParties?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medicalNeeded?: InputMaybe<Array<AccidentIssueMedicalNeededEnum>>;
  outboundDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  outboundFlightName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  outboundFlightNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  safetyId?: InputMaybe<Array<Scalars['String']['input']>>;
  safetyNotified?: InputMaybe<Array<AccidentIssueSafetyNotifiedEnum>>;
  samsaraCameraWorking?: InputMaybe<Array<InputMaybe<AccidentIssueSamsaraCameraWorkingEnum>>>;
  specificLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  stationText?: InputMaybe<Array<Scalars['String']['input']>>;
  thirdPartyInformation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  typeOfMedicalAttention?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleId?: InputMaybe<Array<Scalars['String']['input']>>;
  wasCeoCalled?: InputMaybe<Array<AccidentIssueWasCeoCalledEnum>>;
  wasCrewInvolved?: InputMaybe<Array<AccidentIssueWasCrewInvolvedEnum>>;
  wasDriverAtFault?: InputMaybe<Array<AccidentIssueWasDriverAtFaultEnum>>;
  wasThirdPartyInvolved?: InputMaybe<Array<AccidentIssueWasThirdPartyInvolvedEnum>>;
};

export type UpdateActivityBulkInput = {
  updates: Array<UpdateActivityInput>;
};

export type UpdateActivityBulkResponse = {
  __typename?: 'UpdateActivityBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateActivityInput = {
  query: Array<ActivitySearch>;
  value: UpdateActivityValuesInput;
};

export type UpdateActivityObjectBulkInput = {
  updates: Array<UpdateActivityObjectInput>;
};

export type UpdateActivityObjectBulkResponse = {
  __typename?: 'UpdateActivityObjectBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateActivityObjectInput = {
  query: Array<ActivityObjectSearch>;
  value: UpdateActivityObjectValuesInput;
};

export type UpdateActivityObjectValuesInput = {
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  url?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateActivityValuesInput = {
  field?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formerObjectId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  formerValue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  message?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  objectId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sourceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  subjectId?: InputMaybe<Array<Scalars['String']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<ActivityTypeEnum>>;
  value?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  via?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAirportBulkInput = {
  updates: Array<UpdateAirportInput>;
};

export type UpdateAirportBulkResponse = {
  __typename?: 'UpdateAirportBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAirportGroupBulkInput = {
  updates: Array<UpdateAirportGroupInput>;
};

export type UpdateAirportGroupBulkResponse = {
  __typename?: 'UpdateAirportGroupBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAirportGroupInput = {
  query: Array<AirportGroupSearch>;
  value: UpdateAirportGroupValuesInput;
};

export type UpdateAirportGroupValuesInput = {
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAirportHasCompanyBulkInput = {
  updates: Array<UpdateAirportHasCompanyInput>;
};

export type UpdateAirportHasCompanyBulkResponse = {
  __typename?: 'UpdateAirportHasCompanyBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAirportHasCompanyInput = {
  query: Array<AirportHasCompanySearch>;
  value: UpdateAirportHasCompanyValuesInput;
};

export type UpdateAirportHasCompanyValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAirportHasGroupBulkInput = {
  updates: Array<UpdateAirportHasGroupInput>;
};

export type UpdateAirportHasGroupBulkResponse = {
  __typename?: 'UpdateAirportHasGroupBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAirportHasGroupInput = {
  query: Array<AirportHasGroupSearch>;
  value: UpdateAirportHasGroupValuesInput;
};

export type UpdateAirportHasGroupValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  groupId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAirportHasLocationBulkInput = {
  updates: Array<UpdateAirportHasLocationInput>;
};

export type UpdateAirportHasLocationBulkResponse = {
  __typename?: 'UpdateAirportHasLocationBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAirportHasLocationInput = {
  query: Array<AirportHasLocationSearch>;
  value: UpdateAirportHasLocationValuesInput;
};

export type UpdateAirportHasLocationValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAirportHasManagerEmailBulkInput = {
  updates: Array<UpdateAirportHasManagerEmailInput>;
};

export type UpdateAirportHasManagerEmailBulkResponse = {
  __typename?: 'UpdateAirportHasManagerEmailBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAirportHasManagerEmailInput = {
  query: Array<AirportHasManagerEmailSearch>;
  value: UpdateAirportHasManagerEmailValuesInput;
};

export type UpdateAirportHasManagerEmailValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  emailAddress?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAirportHasRateBulkInput = {
  updates: Array<UpdateAirportHasRateInput>;
};

export type UpdateAirportHasRateBulkResponse = {
  __typename?: 'UpdateAirportHasRateBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAirportHasRateInput = {
  query: Array<AirportHasRateSearch>;
  value: UpdateAirportHasRateValuesInput;
};

export type UpdateAirportHasRateValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  rate?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type UpdateAirportHasVehicleBulkInput = {
  updates: Array<UpdateAirportHasVehicleInput>;
};

export type UpdateAirportHasVehicleBulkResponse = {
  __typename?: 'UpdateAirportHasVehicleBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAirportHasVehicleInput = {
  query: Array<AirportHasVehicleSearch>;
  value: UpdateAirportHasVehicleValuesInput;
};

export type UpdateAirportHasVehicleValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAirportInput = {
  query: Array<AirportSearch>;
  value: UpdateAirportValuesInput;
};

export type UpdateAirportValuesInput = {
  cityCode?: InputMaybe<Array<Scalars['String']['input']>>;
  cityName?: InputMaybe<Array<Scalars['String']['input']>>;
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  countryId?: InputMaybe<Array<Scalars['String']['input']>>;
  elevation?: InputMaybe<Array<Scalars['Int']['input']>>;
  icao?: InputMaybe<Array<Scalars['String']['input']>>;
  location?: InputMaybe<Array<PointInput>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  stateCode?: InputMaybe<Array<Scalars['String']['input']>>;
  timezone?: InputMaybe<Array<Scalars['String']['input']>>;
  url?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAlertSubscriptionBulkInput = {
  updates: Array<UpdateAlertSubscriptionInput>;
};

export type UpdateAlertSubscriptionBulkResponse = {
  __typename?: 'UpdateAlertSubscriptionBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAlertSubscriptionInput = {
  query: Array<AlertSubscriptionSearch>;
  value: UpdateAlertSubscriptionValuesInput;
};

export type UpdateAlertSubscriptionValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  arrivalDate?: InputMaybe<Array<Scalars['String']['input']>>;
  externalAlertId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalVendor?: InputMaybe<Array<AlertSubscriptionExternalVendorEnum>>;
  flightNumber?: InputMaybe<Array<Scalars['Int']['input']>>;
  raw?: InputMaybe<Array<Scalars['String']['input']>>;
  servicerIataAirlineCode?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAliasBulkInput = {
  updates: Array<UpdateAliasInput>;
};

export type UpdateAliasBulkResponse = {
  __typename?: 'UpdateAliasBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAliasInput = {
  query: Array<AliasSearch>;
  value: UpdateAliasValuesInput;
};

export type UpdateAliasValuesInput = {
  locationId?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateApiKeyBulkInput = {
  updates: Array<UpdateApiKeyInput>;
};

export type UpdateApiKeyBulkResponse = {
  __typename?: 'UpdateApiKeyBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateApiKeyInput = {
  query: Array<ApiKeySearch>;
  value: UpdateApiKeyValuesInput;
};

export type UpdateApiKeyValuesInput = {
  expiresAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  keyHash?: InputMaybe<Array<Scalars['String']['input']>>;
  keyHint?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastUsedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAuditSnapshotBulkInput = {
  updates: Array<UpdateAuditSnapshotInput>;
};

export type UpdateAuditSnapshotBulkResponse = {
  __typename?: 'UpdateAuditSnapshotBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAuditSnapshotInput = {
  query: Array<AuditSnapshotSearch>;
  value: UpdateAuditSnapshotValuesInput;
};

export type UpdateAuditSnapshotValuesInput = {
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  data?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateAutoCombineRuleBulkInput = {
  updates: Array<UpdateAutoCombineRuleInput>;
};

export type UpdateAutoCombineRuleBulkResponse = {
  __typename?: 'UpdateAutoCombineRuleBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAutoCombineRuleInput = {
  query: Array<AutoCombineRuleSearch>;
  value: UpdateAutoCombineRuleValuesInput;
};

export type UpdateAutoCombineRuleValuesInput = {
  combineStrategy?: InputMaybe<Array<AutoCombineRuleCombineStrategyEnum>>;
  considerVehicle?: InputMaybe<Array<Scalars['Int']['input']>>;
  contractId?: InputMaybe<Array<Scalars['String']['input']>>;
  importType?: InputMaybe<Array<InputMaybe<AutoCombineRuleImportTypeEnum>>>;
  kind?: InputMaybe<Array<AutoCombineRuleKindEnum>>;
  maxCombine?: InputMaybe<Array<Scalars['Int']['input']>>;
  maxCombineType?: InputMaybe<Array<AutoCombineRuleMaxCombineTypeEnum>>;
  pickupWindow?: InputMaybe<Array<Scalars['Int']['input']>>;
  updateScheduled?: InputMaybe<Array<AutoCombineRuleUpdateScheduledEnum>>;
};

export type UpdateAutomationHistoryAirportBulkInput = {
  updates: Array<UpdateAutomationHistoryAirportInput>;
};

export type UpdateAutomationHistoryAirportBulkResponse = {
  __typename?: 'UpdateAutomationHistoryAirportBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAutomationHistoryAirportInput = {
  query: Array<AutomationHistoryAirportSearch>;
  value: UpdateAutomationHistoryAirportValuesInput;
};

export type UpdateAutomationHistoryAirportValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  automationHistoryId?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAutomationHistoryBulkInput = {
  updates: Array<UpdateAutomationHistoryInput>;
};

export type UpdateAutomationHistoryBulkResponse = {
  __typename?: 'UpdateAutomationHistoryBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAutomationHistoryInput = {
  query: Array<AutomationHistorySearch>;
  value: UpdateAutomationHistoryValuesInput;
};

export type UpdateAutomationHistoryLogBulkInput = {
  updates: Array<UpdateAutomationHistoryLogInput>;
};

export type UpdateAutomationHistoryLogBulkResponse = {
  __typename?: 'UpdateAutomationHistoryLogBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAutomationHistoryLogInput = {
  query: Array<AutomationHistoryLogSearch>;
  value: UpdateAutomationHistoryLogValuesInput;
};

export type UpdateAutomationHistoryLogValuesInput = {
  automationHistoryId?: InputMaybe<Array<Scalars['String']['input']>>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAutomationHistoryValuesInput = {
  driverAssigmentFailedCount?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<AutomationHistoryStatusEnum>>;
  totalTripsProcessed?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalTripsToBeProcessed?: InputMaybe<Array<Scalars['Int']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAutomationReportBulkInput = {
  updates: Array<UpdateAutomationReportInput>;
};

export type UpdateAutomationReportBulkResponse = {
  __typename?: 'UpdateAutomationReportBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAutomationReportInput = {
  query: Array<AutomationReportSearch>;
  value: UpdateAutomationReportValuesInput;
};

export type UpdateAutomationReportValuesInput = {
  automatedTrips?: InputMaybe<Array<Scalars['Int']['input']>>;
  automationHistoryId?: InputMaybe<Array<Scalars['String']['input']>>;
  changedTrips?: InputMaybe<Array<Scalars['Int']['input']>>;
  cutoffAt?: InputMaybe<Array<Scalars['String']['input']>>;
  manualTrips?: InputMaybe<Array<Scalars['Int']['input']>>;
  timeSavedSeconds?: InputMaybe<Array<Scalars['Int']['input']>>;
  totalTrips?: InputMaybe<Array<Scalars['Int']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  unchangedTrips?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateAutomationTripAssignmentReasonBulkInput = {
  updates: Array<UpdateAutomationTripAssignmentReasonInput>;
};

export type UpdateAutomationTripAssignmentReasonBulkResponse = {
  __typename?: 'UpdateAutomationTripAssignmentReasonBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAutomationTripAssignmentReasonInput = {
  query: Array<AutomationTripAssignmentReasonSearch>;
  value: UpdateAutomationTripAssignmentReasonValuesInput;
};

export type UpdateAutomationTripAssignmentReasonValuesInput = {
  automationTripId?: InputMaybe<Array<Scalars['String']['input']>>;
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  displayMessage?: InputMaybe<Array<Scalars['String']['input']>>;
  errorMessage?: InputMaybe<Array<Scalars['String']['input']>>;
  title?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAutomationTripBulkInput = {
  updates: Array<UpdateAutomationTripInput>;
};

export type UpdateAutomationTripBulkResponse = {
  __typename?: 'UpdateAutomationTripBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAutomationTripInput = {
  query: Array<AutomationTripSearch>;
  value: UpdateAutomationTripValuesInput;
};

export type UpdateAutomationTripLogBulkInput = {
  updates: Array<UpdateAutomationTripLogInput>;
};

export type UpdateAutomationTripLogBulkResponse = {
  __typename?: 'UpdateAutomationTripLogBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateAutomationTripLogInput = {
  query: Array<AutomationTripLogSearch>;
  value: UpdateAutomationTripLogValuesInput;
};

export type UpdateAutomationTripLogValuesInput = {
  automationTripId?: InputMaybe<Array<Scalars['String']['input']>>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateAutomationTripValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  attendants?: InputMaybe<Array<Scalars['Int']['input']>>;
  automationHistoryId?: InputMaybe<Array<Scalars['String']['input']>>;
  cachedDoLocationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cachedPayerProviderId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cachedPuLocationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  combineId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doLocationCoordinates?: InputMaybe<Array<InputMaybe<PointInput>>>;
  doLocationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverAtCutoffFullName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverAtCutoffId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverFirstName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverFullName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverLastName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Array<AutomationTripKindEnum>>;
  loopName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newDriverFullName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  newDriverId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Array<Scalars['String']['input']>>;
  payerProviderDisplayName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pilots?: InputMaybe<Array<Scalars['Int']['input']>>;
  puGpsDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  puLocationCoordinates?: InputMaybe<Array<InputMaybe<PointInput>>>;
  puLocationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduled?: InputMaybe<Array<Scalars['String']['input']>>;
  servicerIataAirlineCode?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<AutomationTripStatusEnum>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<AutomationTripTypeEnum>>;
  vehicleId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleTrackingId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateBufferTimeBulkInput = {
  updates: Array<UpdateBufferTimeInput>;
};

export type UpdateBufferTimeBulkResponse = {
  __typename?: 'UpdateBufferTimeBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateBufferTimeInput = {
  query: Array<BufferTimeSearch>;
  value: UpdateBufferTimeValuesInput;
};

export type UpdateBufferTimeValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  bufferMinutes?: InputMaybe<Array<Scalars['Int']['input']>>;
  contractId?: InputMaybe<Array<Scalars['String']['input']>>;
  endLocationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endTime?: InputMaybe<Array<Scalars['String']['input']>>;
  startLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  startTime?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCancellationRuleBulkInput = {
  updates: Array<UpdateCancellationRuleInput>;
};

export type UpdateCancellationRuleBulkResponse = {
  __typename?: 'UpdateCancellationRuleBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCancellationRuleInput = {
  query: Array<CancellationRuleSearch>;
  value: UpdateCancellationRuleValuesInput;
};

export type UpdateCancellationRuleValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  endLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  from?: InputMaybe<Array<Scalars['Int']['input']>>;
  percentage?: InputMaybe<Array<Scalars['String']['input']>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
  startLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  to?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateCharityAmountHistoryBulkInput = {
  updates: Array<UpdateCharityAmountHistoryInput>;
};

export type UpdateCharityAmountHistoryBulkResponse = {
  __typename?: 'UpdateCharityAmountHistoryBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCharityAmountHistoryInput = {
  query: Array<CharityAmountHistorySearch>;
  value: UpdateCharityAmountHistoryValuesInput;
};

export type UpdateCharityAmountHistoryValuesInput = {
  amount?: InputMaybe<Array<Scalars['Float']['input']>>;
  charityId?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateCharityBulkInput = {
  updates: Array<UpdateCharityInput>;
};

export type UpdateCharityBulkResponse = {
  __typename?: 'UpdateCharityBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCharityInput = {
  query: Array<CharitySearch>;
  value: UpdateCharityValuesInput;
};

export type UpdateCharityRatingHistoryBulkInput = {
  updates: Array<UpdateCharityRatingHistoryInput>;
};

export type UpdateCharityRatingHistoryBulkResponse = {
  __typename?: 'UpdateCharityRatingHistoryBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCharityRatingHistoryInput = {
  query: Array<CharityRatingHistorySearch>;
  value: UpdateCharityRatingHistoryValuesInput;
};

export type UpdateCharityRatingHistoryReportBulkInput = {
  updates: Array<UpdateCharityRatingHistoryReportInput>;
};

export type UpdateCharityRatingHistoryReportBulkResponse = {
  __typename?: 'UpdateCharityRatingHistoryReportBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCharityRatingHistoryReportInput = {
  query: Array<CharityRatingHistoryReportSearch>;
  value: UpdateCharityRatingHistoryReportValuesInput;
};

export type UpdateCharityRatingHistoryReportValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  amount?: InputMaybe<Array<Scalars['Float']['input']>>;
  avatar?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  charityId?: InputMaybe<Array<Scalars['String']['input']>>;
  charityName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerDisplayName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
  rating?: InputMaybe<Array<Scalars['Int']['input']>>;
  ratingId?: InputMaybe<Array<Scalars['String']['input']>>;
  userFirstName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userLastName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  username?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateCharityRatingHistoryValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  amount?: InputMaybe<Array<Scalars['Float']['input']>>;
  charityId?: InputMaybe<Array<Scalars['String']['input']>>;
  providerDisplayName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
  rating?: InputMaybe<Array<Scalars['Int']['input']>>;
  ratingId?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateCharityValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  crewFindDriverBannerDisplayMessage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  crewRateDriverTooltipDisplayMessage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  crewTripCompleteBannerDisplayMessage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverLoginBannerDisplayMessage?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logoUrl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  totalGoalAmount?: InputMaybe<Array<Scalars['Float']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateChatQuickReplyMessageBulkInput = {
  updates: Array<UpdateChatQuickReplyMessageInput>;
};

export type UpdateChatQuickReplyMessageBulkResponse = {
  __typename?: 'UpdateChatQuickReplyMessageBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateChatQuickReplyMessageInput = {
  query: Array<ChatQuickReplyMessageSearch>;
  value: UpdateChatQuickReplyMessageValuesInput;
};

export type UpdateChatQuickReplyMessageValuesInput = {
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateCheckinEventBulkInput = {
  updates: Array<UpdateCheckinEventInput>;
};

export type UpdateCheckinEventBulkResponse = {
  __typename?: 'UpdateCheckinEventBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCheckinEventInput = {
  query: Array<CheckinEventSearch>;
  value: UpdateCheckinEventValuesInput;
};

export type UpdateCheckinEventValuesInput = {
  app?: InputMaybe<Array<Scalars['String']['input']>>;
  datetime?: InputMaybe<Array<Scalars['String']['input']>>;
  ipAddress?: InputMaybe<Array<Scalars['String']['input']>>;
  platform?: InputMaybe<Array<Scalars['String']['input']>>;
  sessionId?: InputMaybe<Array<Scalars['String']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
  userAgent?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCombineRuleBulkInput = {
  updates: Array<UpdateCombineRuleInput>;
};

export type UpdateCombineRuleBulkResponse = {
  __typename?: 'UpdateCombineRuleBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCombineRuleHistoryBulkInput = {
  updates: Array<UpdateCombineRuleHistoryInput>;
};

export type UpdateCombineRuleHistoryBulkResponse = {
  __typename?: 'UpdateCombineRuleHistoryBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCombineRuleHistoryInput = {
  query: Array<CombineRuleHistorySearch>;
  value: UpdateCombineRuleHistoryValuesInput;
};

export type UpdateCombineRuleHistoryValuesInput = {
  combineRuleId?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<Array<Scalars['Float']['input']>>;
  startDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCombineRuleInput = {
  query: Array<CombineRuleSearch>;
  value: UpdateCombineRuleValuesInput;
};

export type UpdateCombineRuleValuesInput = {
  contractId?: InputMaybe<Array<Scalars['String']['input']>>;
  discount?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  illegalCombine?: InputMaybe<Array<CombineRuleIllegalCombineEnum>>;
  pickupWindow?: InputMaybe<Array<Scalars['Int']['input']>>;
  turnaroundThreshold?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateCommunicationBulkInput = {
  updates: Array<UpdateCommunicationInput>;
};

export type UpdateCommunicationBulkResponse = {
  __typename?: 'UpdateCommunicationBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCommunicationInput = {
  query: Array<CommunicationSearch>;
  value: UpdateCommunicationValuesInput;
};

export type UpdateCommunicationValuesInput = {
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCompanyBulkInput = {
  updates: Array<UpdateCompanyInput>;
};

export type UpdateCompanyBulkResponse = {
  __typename?: 'UpdateCompanyBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCompanyInput = {
  query: Array<CompanySearch>;
  value: UpdateCompanyValuesInput;
};

export type UpdateCompanyValuesInput = {
  address?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  adminEmail?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cityName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dispatchPhone?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceEmail?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invoiceFax?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invoicePhone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  logo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  settingsId?: InputMaybe<Array<Scalars['String']['input']>>;
  stateCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  website?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zipCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateCompletionBulkInput = {
  updates: Array<UpdateCompletionInput>;
};

export type UpdateCompletionBulkResponse = {
  __typename?: 'UpdateCompletionBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCompletionInput = {
  query: Array<CompletionSearch>;
  value: UpdateCompletionValuesInput;
};

export type UpdateCompletionTypeBulkInput = {
  updates: Array<UpdateCompletionTypeInput>;
};

export type UpdateCompletionTypeBulkResponse = {
  __typename?: 'UpdateCompletionTypeBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCompletionTypeInput = {
  query: Array<CompletionTypeSearch>;
  value: UpdateCompletionTypeValuesInput;
};

export type UpdateCompletionTypeValuesInput = {
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCompletionValuesInput = {
  comment?: InputMaybe<Array<Scalars['String']['input']>>;
  completionTypeId?: InputMaybe<Array<Scalars['String']['input']>>;
  cost?: InputMaybe<Array<Scalars['Float']['input']>>;
  currency?: InputMaybe<Array<CompletionCurrencyEnum>>;
  datetime?: InputMaybe<Array<Scalars['String']['input']>>;
  distanceMeters?: InputMaybe<Array<Scalars['Int']['input']>>;
  efficiency?: InputMaybe<Array<Scalars['Float']['input']>>;
  equivalency?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type UpdateContractBulkInput = {
  updates: Array<UpdateContractInput>;
};

export type UpdateContractBulkResponse = {
  __typename?: 'UpdateContractBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateContractEmailBulkInput = {
  updates: Array<UpdateContractEmailInput>;
};

export type UpdateContractEmailBulkResponse = {
  __typename?: 'UpdateContractEmailBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateContractEmailInput = {
  query: Array<ContractEmailSearch>;
  value: UpdateContractEmailValuesInput;
};

export type UpdateContractEmailValuesInput = {
  contractId?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<ContractEmailTypeEnum>>;
};

export type UpdateContractInput = {
  query: Array<ContractSearch>;
  value: UpdateContractValuesInput;
};

export type UpdateContractNumberBulkInput = {
  updates: Array<UpdateContractNumberInput>;
};

export type UpdateContractNumberBulkResponse = {
  __typename?: 'UpdateContractNumberBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateContractNumberInput = {
  query: Array<ContractNumberSearch>;
  value: UpdateContractNumberValuesInput;
};

export type UpdateContractNumberValuesInput = {
  contractId?: InputMaybe<Array<Scalars['String']['input']>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<ContractNumberTypeEnum>>;
};

export type UpdateContractValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  allowCombines?: InputMaybe<Array<Scalars['Int']['input']>>;
  allowCrewCreateTrip?: InputMaybe<Array<Scalars['Int']['input']>>;
  automateAddons?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  enableBufferTime?: InputMaybe<Array<Scalars['Int']['input']>>;
  enableSocialDistancing?: InputMaybe<Array<Scalars['Int']['input']>>;
  invoiceTermId?: InputMaybe<Array<Scalars['String']['input']>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCountryRegionBulkInput = {
  updates: Array<UpdateCountryRegionInput>;
};

export type UpdateCountryRegionBulkResponse = {
  __typename?: 'UpdateCountryRegionBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCountryRegionInput = {
  query: Array<CountryRegionSearch>;
  value: UpdateCountryRegionValuesInput;
};

export type UpdateCountryRegionValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  country?: InputMaybe<Array<Scalars['String']['input']>>;
  stateAbbrev?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stateProvince?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateCrewCountRequirementBulkInput = {
  updates: Array<UpdateCrewCountRequirementInput>;
};

export type UpdateCrewCountRequirementBulkResponse = {
  __typename?: 'UpdateCrewCountRequirementBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateCrewCountRequirementInput = {
  query: Array<CrewCountRequirementSearch>;
  value: UpdateCrewCountRequirementValuesInput;
};

export type UpdateCrewCountRequirementValuesInput = {
  airportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  enabled?: InputMaybe<Array<Scalars['Int']['input']>>;
  flightNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payerProviderId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateDashboardBulkInput = {
  updates: Array<UpdateDashboardInput>;
};

export type UpdateDashboardBulkResponse = {
  __typename?: 'UpdateDashboardBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDashboardInput = {
  query: Array<DashboardSearch>;
  value: UpdateDashboardValuesInput;
};

export type UpdateDashboardValuesInput = {
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDefectBulkInput = {
  updates: Array<UpdateDefectInput>;
};

export type UpdateDefectBulkResponse = {
  __typename?: 'UpdateDefectBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDefectInput = {
  query: Array<DefectSearch>;
  value: UpdateDefectValuesInput;
};

export type UpdateDefectValuesInput = {
  comment?: InputMaybe<Array<Scalars['String']['input']>>;
  dvirId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalCreatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalDefectId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalResolvedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isResolved?: InputMaybe<Array<Scalars['Int']['input']>>;
  mechanicNotes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mechanicNotesUpdatedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resolvedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resolvedByUserName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resolvedByUserType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDeviceBulkInput = {
  updates: Array<UpdateDeviceInput>;
};

export type UpdateDeviceBulkResponse = {
  __typename?: 'UpdateDeviceBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDeviceInput = {
  query: Array<DeviceSearch>;
  value: UpdateDeviceValuesInput;
};

export type UpdateDeviceMetricBulkInput = {
  updates: Array<UpdateDeviceMetricInput>;
};

export type UpdateDeviceMetricBulkResponse = {
  __typename?: 'UpdateDeviceMetricBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDeviceMetricInput = {
  query: Array<DeviceMetricSearch>;
  value: UpdateDeviceMetricValuesInput;
};

export type UpdateDeviceMetricValuesInput = {
  metricName?: InputMaybe<Array<DeviceMetricMetricNameEnum>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDeviceValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  appName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastSeenAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  platform?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  token?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDispatchIssueBulkInput = {
  updates: Array<UpdateDispatchIssueInput>;
};

export type UpdateDispatchIssueBulkResponse = {
  __typename?: 'UpdateDispatchIssueBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDispatchIssueCausedByBulkInput = {
  updates: Array<UpdateDispatchIssueCausedByInput>;
};

export type UpdateDispatchIssueCausedByBulkResponse = {
  __typename?: 'UpdateDispatchIssueCausedByBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDispatchIssueCausedByInput = {
  query: Array<DispatchIssueCausedBySearch>;
  value: UpdateDispatchIssueCausedByValuesInput;
};

export type UpdateDispatchIssueCausedByValuesInput = {
  causedById?: InputMaybe<Array<Scalars['String']['input']>>;
  dispatchIssueId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDispatchIssueDocumentBulkInput = {
  updates: Array<UpdateDispatchIssueDocumentInput>;
};

export type UpdateDispatchIssueDocumentBulkResponse = {
  __typename?: 'UpdateDispatchIssueDocumentBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDispatchIssueDocumentInput = {
  query: Array<DispatchIssueDocumentSearch>;
  value: UpdateDispatchIssueDocumentValuesInput;
};

export type UpdateDispatchIssueDocumentValuesInput = {
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  fileLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  fileSize?: InputMaybe<Array<Scalars['Int']['input']>>;
  filename?: InputMaybe<Array<Scalars['String']['input']>>;
  issueId?: InputMaybe<Array<Scalars['String']['input']>>;
  md5?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateDispatchIssueInput = {
  query: Array<DispatchIssueSearch>;
  value: UpdateDispatchIssueValuesInput;
};

export type UpdateDispatchIssueValuesInput = {
  crewMemberGiftCardCount?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  crewMemberName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  crewMemberPhone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  datetime?: InputMaybe<Array<Scalars['String']['input']>>;
  dispatcherId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverPhone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightIssueDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  flightLate?: InputMaybe<Array<DispatchIssueFlightLateEnum>>;
  flightType?: InputMaybe<Array<InputMaybe<DispatchIssueFlightTypeEnum>>>;
  managerId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  outboundFlightInfo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pushTime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recoveryCompleted?: InputMaybe<Array<InputMaybe<DispatchIssueRecoveryCompletedEnum>>>;
  recoveryFlightDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recoveryFlightName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recoveryFlightNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  recoveryNeeded?: InputMaybe<Array<DispatchIssueRecoveryNeededEnum>>;
  rootCause?: InputMaybe<Array<DispatchIssueRootCauseEnum>>;
  rootCauseDescription?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduledTime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  station?: InputMaybe<Array<Scalars['String']['input']>>;
  taxiCost?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  taxiDetails?: InputMaybe<Array<InputMaybe<DispatchIssueTaxiDetailsEnum>>>;
  taxiUsed?: InputMaybe<Array<InputMaybe<DispatchIssueTaxiUsedEnum>>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateDispatchSummaryBulkInput = {
  updates: Array<UpdateDispatchSummaryInput>;
};

export type UpdateDispatchSummaryBulkResponse = {
  __typename?: 'UpdateDispatchSummaryBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDispatchSummaryDocumentBulkInput = {
  updates: Array<UpdateDispatchSummaryDocumentInput>;
};

export type UpdateDispatchSummaryDocumentBulkResponse = {
  __typename?: 'UpdateDispatchSummaryDocumentBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDispatchSummaryDocumentInput = {
  query: Array<DispatchSummaryDocumentSearch>;
  value: UpdateDispatchSummaryDocumentValuesInput;
};

export type UpdateDispatchSummaryDocumentValuesInput = {
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  fileLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  fileSize?: InputMaybe<Array<Scalars['Int']['input']>>;
  filename?: InputMaybe<Array<Scalars['String']['input']>>;
  md5?: InputMaybe<Array<Scalars['String']['input']>>;
  summaryId?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateDispatchSummaryInput = {
  query: Array<DispatchSummarySearch>;
  value: UpdateDispatchSummaryValuesInput;
};

export type UpdateDispatchSummaryMarketBulkInput = {
  updates: Array<UpdateDispatchSummaryMarketInput>;
};

export type UpdateDispatchSummaryMarketBulkResponse = {
  __typename?: 'UpdateDispatchSummaryMarketBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDispatchSummaryMarketInput = {
  query: Array<DispatchSummaryMarketSearch>;
  value: UpdateDispatchSummaryMarketValuesInput;
};

export type UpdateDispatchSummaryMarketValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  comment?: InputMaybe<Array<Scalars['String']['input']>>;
  dispatchSummaryId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDispatchSummaryValuesInput = {
  callVolume?: InputMaybe<Array<DispatchSummaryCallVolumeEnum>>;
  chatVolume?: InputMaybe<Array<InputMaybe<DispatchSummaryChatVolumeEnum>>>;
  commentsFaxallCheck?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  commentsRepeatDistractedOffenders?: InputMaybe<Array<Scalars['String']['input']>>;
  commentsRepeatSpeedingOffenders?: InputMaybe<Array<Scalars['String']['input']>>;
  dispatcherAssetCamerasWorking?: InputMaybe<Array<DispatchSummaryDispatcherAssetCamerasWorkingEnum>>;
  dispatcherAssetCamerasWorkingNotes?: InputMaybe<Array<Scalars['String']['input']>>;
  dispatcherDayOverview?: InputMaybe<Array<Scalars['String']['input']>>;
  dispatcherEightByEightIssue?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dispatcherId?: InputMaybe<Array<Scalars['String']['input']>>;
  dispatcherPassdown?: InputMaybe<Array<Scalars['String']['input']>>;
  dispatcherServiceIssues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dispatcherShift?: InputMaybe<Array<DispatchSummaryDispatcherShiftEnum>>;
  dispatcherSoftwareIssues?: InputMaybe<Array<Scalars['String']['input']>>;
  dispatcherStation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dispatcherStationVansIssues?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dispatcherWasThereEightByEightIssue?: InputMaybe<Array<InputMaybe<DispatchSummaryDispatcherWasThereEightByEightIssueEnum>>>;
  manifestsDrivingIssues?: InputMaybe<Array<Scalars['String']['input']>>;
  manifestsTaxis?: InputMaybe<Array<Scalars['String']['input']>>;
  manifestsTrainingIssues?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateDistanceBulkInput = {
  updates: Array<UpdateDistanceInput>;
};

export type UpdateDistanceBulkResponse = {
  __typename?: 'UpdateDistanceBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDistanceInput = {
  query: Array<DistanceSearch>;
  value: UpdateDistanceValuesInput;
};

export type UpdateDistanceValuesInput = {
  cachedAt?: InputMaybe<Array<Scalars['String']['input']>>;
  distanceText?: InputMaybe<Array<Scalars['String']['input']>>;
  distanceValue?: InputMaybe<Array<Scalars['Int']['input']>>;
  durationInTrafficText?: InputMaybe<Array<Scalars['String']['input']>>;
  durationInTrafficValue?: InputMaybe<Array<Scalars['Int']['input']>>;
  durationText?: InputMaybe<Array<Scalars['String']['input']>>;
  durationValue?: InputMaybe<Array<Scalars['Int']['input']>>;
  fromLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  toLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDriverCrewCountInput = {
  crewCount: Scalars['Int']['input'];
  tripId: Scalars['String']['input'];
};

export type UpdateDriverCrewCountResponse = {
  __typename?: 'UpdateDriverCrewCountResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type UpdateDriverEtaBulkInput = {
  updates: Array<UpdateDriverEtaInput>;
};

export type UpdateDriverEtaBulkResponse = {
  __typename?: 'UpdateDriverEtaBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDriverEtaInput = {
  query: Array<DriverEtaSearch>;
  value: UpdateDriverEtaValuesInput;
};

export type UpdateDriverEtaValuesInput = {
  driverId?: InputMaybe<Array<Scalars['String']['input']>>;
  etaDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  etaMinutes?: InputMaybe<Array<Scalars['Int']['input']>>;
  previousTripId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDriverVehicleAssignmentBulkInput = {
  updates: Array<UpdateDriverVehicleAssignmentInput>;
};

export type UpdateDriverVehicleAssignmentBulkResponse = {
  __typename?: 'UpdateDriverVehicleAssignmentBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDriverVehicleAssignmentInput = {
  query: Array<DriverVehicleAssignmentSearch>;
  value: UpdateDriverVehicleAssignmentValuesInput;
};

export type UpdateDriverVehicleAssignmentValuesInput = {
  driverId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverName?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalDriverId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalVehicleId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalVendor?: InputMaybe<Array<Scalars['String']['input']>>;
  startDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleTrackingId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDtrLocationBulkInput = {
  updates: Array<UpdateDtrLocationInput>;
};

export type UpdateDtrLocationBulkResponse = {
  __typename?: 'UpdateDtrLocationBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDtrLocationInput = {
  query: Array<DtrLocationSearch>;
  value: UpdateDtrLocationValuesInput;
};

export type UpdateDtrLocationValuesInput = {
  address?: InputMaybe<Array<Scalars['String']['input']>>;
  airportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cityName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  coordinates?: InputMaybe<Array<PointInput>>;
  countryCode?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stateCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
  zipCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateDvirBulkInput = {
  updates: Array<UpdateDvirInput>;
};

export type UpdateDvirBulkResponse = {
  __typename?: 'UpdateDvirBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDvirInput = {
  query: Array<DvirSearch>;
  value: UpdateDvirValuesInput;
};

export type UpdateDvirSignatureBulkInput = {
  updates: Array<UpdateDvirSignatureInput>;
};

export type UpdateDvirSignatureBulkResponse = {
  __typename?: 'UpdateDvirSignatureBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateDvirSignatureInput = {
  query: Array<DvirSignatureSearch>;
  value: UpdateDvirSignatureValuesInput;
};

export type UpdateDvirSignatureValuesInput = {
  dvirId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalUserId?: InputMaybe<Array<Scalars['String']['input']>>;
  signedAt?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  userName?: InputMaybe<Array<Scalars['String']['input']>>;
  userType?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateDvirValuesInput = {
  driverId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverName?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventType?: InputMaybe<Array<Scalars['String']['input']>>;
  externalDriverId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalDvirId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalEventId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalOrgId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalTrailerId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalVehicleId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalVendor?: InputMaybe<Array<DvirExternalVendorEnum>>;
  externalWebhookId?: InputMaybe<Array<Scalars['String']['input']>>;
  formattedLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  mechanicNotes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  needsCorrection?: InputMaybe<Array<Scalars['Int']['input']>>;
  odometerMeters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  safetyStatus?: InputMaybe<Array<Scalars['String']['input']>>;
  startDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trailerName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleLicensePlate?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleModel?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleSerial?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleTrackingId?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleVin?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateEmailBulkInput = {
  updates: Array<UpdateEmailInput>;
};

export type UpdateEmailBulkResponse = {
  __typename?: 'UpdateEmailBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateEmailInput = {
  query: Array<EmailSearch>;
  value: UpdateEmailValuesInput;
};

export type UpdateEmailValuesInput = {
  address?: InputMaybe<Array<Scalars['String']['input']>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<EmailTypeEnum>>;
};

export type UpdateEquivalentTripBulkInput = {
  updates: Array<UpdateEquivalentTripInput>;
};

export type UpdateEquivalentTripBulkResponse = {
  __typename?: 'UpdateEquivalentTripBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateEquivalentTripInput = {
  query: Array<EquivalentTripSearch>;
  value: UpdateEquivalentTripValuesInput;
};

export type UpdateEquivalentTripValuesInput = {
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  count?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endLocationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startLocationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateEventBulkInput = {
  updates: Array<UpdateEventInput>;
};

export type UpdateEventBulkResponse = {
  __typename?: 'UpdateEventBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateEventInput = {
  query: Array<EventSearch>;
  value: UpdateEventValuesInput;
};

export type UpdateEventValuesInput = {
  active?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  source?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<EventStatusEnum>>>;
};

export type UpdateFcrBulkInput = {
  updates: Array<UpdateFcrInput>;
};

export type UpdateFcrBulkResponse = {
  __typename?: 'UpdateFcrBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateFcrInput = {
  query: Array<FcrSearch>;
  value: UpdateFcrValuesInput;
};

export type UpdateFcrTypeBulkInput = {
  updates: Array<UpdateFcrTypeInput>;
};

export type UpdateFcrTypeBulkResponse = {
  __typename?: 'UpdateFcrTypeBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateFcrTypeInput = {
  query: Array<FcrTypeSearch>;
  value: UpdateFcrTypeValuesInput;
};

export type UpdateFcrTypeValuesInput = {
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateFcrValuesInput = {
  cause?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fcrReporter?: InputMaybe<Array<InputMaybe<FcrFcrReporterEnum>>>;
  fcrTypeId?: InputMaybe<Array<Scalars['String']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateFlagBulkInput = {
  updates: Array<UpdateFlagInput>;
};

export type UpdateFlagBulkResponse = {
  __typename?: 'UpdateFlagBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateFlagHasPotentialTripBulkInput = {
  updates: Array<UpdateFlagHasPotentialTripInput>;
};

export type UpdateFlagHasPotentialTripBulkResponse = {
  __typename?: 'UpdateFlagHasPotentialTripBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateFlagHasPotentialTripInput = {
  query: Array<FlagHasPotentialTripSearch>;
  value: UpdateFlagHasPotentialTripValuesInput;
};

export type UpdateFlagHasPotentialTripValuesInput = {
  flagId?: InputMaybe<Array<Scalars['String']['input']>>;
  potentialTripId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateFlagHasStagedTripBulkInput = {
  updates: Array<UpdateFlagHasStagedTripInput>;
};

export type UpdateFlagHasStagedTripBulkResponse = {
  __typename?: 'UpdateFlagHasStagedTripBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateFlagHasStagedTripInput = {
  query: Array<FlagHasStagedTripSearch>;
  value: UpdateFlagHasStagedTripValuesInput;
};

export type UpdateFlagHasStagedTripValuesInput = {
  flagId?: InputMaybe<Array<Scalars['String']['input']>>;
  stagedTripId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateFlagHasTripBulkInput = {
  updates: Array<UpdateFlagHasTripInput>;
};

export type UpdateFlagHasTripBulkResponse = {
  __typename?: 'UpdateFlagHasTripBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateFlagHasTripInput = {
  query: Array<FlagHasTripSearch>;
  value: UpdateFlagHasTripValuesInput;
};

export type UpdateFlagHasTripValuesInput = {
  flagId?: InputMaybe<Array<Scalars['String']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateFlagInput = {
  query: Array<FlagSearch>;
  value: UpdateFlagValuesInput;
};

export type UpdateFlagValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  color?: InputMaybe<Array<Scalars['String']['input']>>;
  companyId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  global?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateFlightHistoryBulkInput = {
  updates: Array<UpdateFlightHistoryInput>;
};

export type UpdateFlightHistoryBulkResponse = {
  __typename?: 'UpdateFlightHistoryBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateFlightHistoryInput = {
  query: Array<FlightHistorySearch>;
  value: UpdateFlightHistoryValuesInput;
};

export type UpdateFlightHistoryValuesInput = {
  actual?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  actualUtc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  arrivalAirportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  arrivalDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  arrivalDatetimeUtc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  arrivalDelayMinutes?: InputMaybe<Array<Scalars['Int']['input']>>;
  arrivalGate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  arrivalTerminal?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  arrivalTimezone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  arrivalUtcOffsetHours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departureAirportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  departureDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departureDatetimeUtc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departureDelayMinutes?: InputMaybe<Array<Scalars['Int']['input']>>;
  departureGate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departureTerminal?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departureTimezone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departureUtcOffsetHours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  divertedAirportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  estimatedArrivalDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  estimatedArrivalDatetimeUtc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  estimatedDepartureDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  estimatedDepartureDatetimeUtc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  externalAlertId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalId?: InputMaybe<Array<Scalars['String']['input']>>;
  externalVendor?: InputMaybe<Array<FlightHistoryExternalVendorEnum>>;
  flightNumber?: InputMaybe<Array<Scalars['String']['input']>>;
  label?: InputMaybe<Array<FlightHistoryLabelEnum>>;
  landedDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  landedDatetimeUtc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  raw?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduled?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduledUtc?: InputMaybe<Array<Scalars['String']['input']>>;
  servicerIataAirlineCode?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<FlightHistoryTypeEnum>>;
};

export type UpdateFullWidgetBulkInput = {
  updates: Array<UpdateFullWidgetInput>;
};

export type UpdateFullWidgetBulkResponse = {
  __typename?: 'UpdateFullWidgetBulkResponse';
  response: UpdateResponse;
};

export type UpdateFullWidgetInput = {
  filters?: InputMaybe<Array<InputMaybe<CreateWidgetFilterInput>>>;
  id: Scalars['String']['input'];
  value: UpdateWidgetValuesInput;
};

export type UpdateGeneratedDocumentBulkInput = {
  updates: Array<UpdateGeneratedDocumentInput>;
};

export type UpdateGeneratedDocumentBulkResponse = {
  __typename?: 'UpdateGeneratedDocumentBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateGeneratedDocumentInput = {
  query: Array<GeneratedDocumentSearch>;
  value: UpdateGeneratedDocumentValuesInput;
};

export type UpdateGeneratedDocumentLogBulkInput = {
  updates: Array<UpdateGeneratedDocumentLogInput>;
};

export type UpdateGeneratedDocumentLogBulkResponse = {
  __typename?: 'UpdateGeneratedDocumentLogBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateGeneratedDocumentLogInput = {
  query: Array<GeneratedDocumentLogSearch>;
  value: UpdateGeneratedDocumentLogValuesInput;
};

export type UpdateGeneratedDocumentLogValuesInput = {
  generatedDocumentId?: InputMaybe<Array<Scalars['String']['input']>>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateGeneratedDocumentValuesInput = {
  docSource?: InputMaybe<Array<Scalars['String']['input']>>;
  fileLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  fileS3Bucket?: InputMaybe<Array<Scalars['String']['input']>>;
  filename?: InputMaybe<Array<Scalars['String']['input']>>;
  generationCompletedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  generationStartedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resourceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<GeneratedDocumentStatusEnum>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateGroupBulkInput = {
  updates: Array<UpdateGroupInput>;
};

export type UpdateGroupBulkResponse = {
  __typename?: 'UpdateGroupBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateGroupHasPermissionBulkInput = {
  updates: Array<UpdateGroupHasPermissionInput>;
};

export type UpdateGroupHasPermissionBulkResponse = {
  __typename?: 'UpdateGroupHasPermissionBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateGroupHasPermissionInput = {
  query: Array<GroupHasPermissionSearch>;
  value: UpdateGroupHasPermissionValuesInput;
};

export type UpdateGroupHasPermissionValuesInput = {
  groupId?: InputMaybe<Array<Scalars['String']['input']>>;
  permissionId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateGroupHasUserBulkInput = {
  updates: Array<UpdateGroupHasUserInput>;
};

export type UpdateGroupHasUserBulkResponse = {
  __typename?: 'UpdateGroupHasUserBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateGroupHasUserInput = {
  query: Array<GroupHasUserSearch>;
  value: UpdateGroupHasUserValuesInput;
};

export type UpdateGroupHasUserValuesInput = {
  groupId?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateGroupInput = {
  query: Array<GroupSearch>;
  value: UpdateGroupValuesInput;
};

export type UpdateGroupValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<GroupTypeEnum>>;
};

export type UpdateImageBulkInput = {
  updates: Array<UpdateImageInput>;
};

export type UpdateImageBulkResponse = {
  __typename?: 'UpdateImageBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateImageInput = {
  query: Array<ImageSearch>;
  value: UpdateImageValuesInput;
};

export type UpdateImageValuesInput = {
  filename?: InputMaybe<Array<Scalars['String']['input']>>;
  md5?: InputMaybe<Array<Scalars['String']['input']>>;
  path?: InputMaybe<Array<Scalars['String']['input']>>;
  pickupPointId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateImportBulkInput = {
  updates: Array<UpdateImportInput>;
};

export type UpdateImportBulkResponse = {
  __typename?: 'UpdateImportBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateImportEmailBulkInput = {
  updates: Array<UpdateImportEmailInput>;
};

export type UpdateImportEmailBulkResponse = {
  __typename?: 'UpdateImportEmailBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateImportEmailInput = {
  query: Array<ImportEmailSearch>;
  value: UpdateImportEmailValuesInput;
};

export type UpdateImportEmailValuesInput = {
  date?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileLocation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  md5?: InputMaybe<Array<Scalars['String']['input']>>;
  originalFileLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  subject?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateImportFailureBulkInput = {
  updates: Array<UpdateImportFailureInput>;
};

export type UpdateImportFailureBulkResponse = {
  __typename?: 'UpdateImportFailureBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateImportFailureInput = {
  query: Array<ImportFailureSearch>;
  value: UpdateImportFailureValuesInput;
};

export type UpdateImportFailureValuesInput = {
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  errorCode?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  errorMessage?: InputMaybe<Array<Scalars['String']['input']>>;
  importId?: InputMaybe<Array<Scalars['String']['input']>>;
  importType?: InputMaybe<Array<ImportFailureImportTypeEnum>>;
  ingestAction?: InputMaybe<Array<InputMaybe<ImportFailureIngestActionEnum>>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
  stagedTripId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<ImportFailureTypeEnum>>;
};

export type UpdateImportInput = {
  query: Array<ImportSearch>;
  value: UpdateImportValuesInput;
};

export type UpdateImportLogBulkInput = {
  updates: Array<UpdateImportLogInput>;
};

export type UpdateImportLogBulkResponse = {
  __typename?: 'UpdateImportLogBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateImportLogInput = {
  query: Array<ImportLogSearch>;
  value: UpdateImportLogValuesInput;
};

export type UpdateImportLogValuesInput = {
  importId?: InputMaybe<Array<Scalars['String']['input']>>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateImportOcrCacheBulkInput = {
  updates: Array<UpdateImportOcrCacheInput>;
};

export type UpdateImportOcrCacheBulkResponse = {
  __typename?: 'UpdateImportOcrCacheBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateImportOcrCacheInput = {
  query: Array<ImportOcrCacheSearch>;
  value: UpdateImportOcrCacheValuesInput;
};

export type UpdateImportOcrCacheValuesInput = {
  importId?: InputMaybe<Array<Scalars['String']['input']>>;
  providerId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  text?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateImportProviderInput = {
  importId: Scalars['String']['input'];
  providerId: Scalars['String']['input'];
};

export type UpdateImportProviderResponse = {
  __typename?: 'UpdateImportProviderResponse';
  error?: Maybe<Error>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type UpdateImportStatusInput = {
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
  status: Scalars['String']['input'];
};

export type UpdateImportValuesInput = {
  airlineIcaoCode?: InputMaybe<Array<Scalars['String']['input']>>;
  archivedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  archivedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cancelled?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  createTripTolerance?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  created?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  deleted?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  emailId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  excluded?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fileLocation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  from?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ingestCompleted?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ingestStarted?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ingestedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  md5?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  noticeDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previewType?: InputMaybe<Array<InputMaybe<ImportPreviewTypeEnum>>>;
  previewedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  previousImportId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
  rollbackBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rolledBackAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rolledBackBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<ImportStatusEnum>>;
  total?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type?: InputMaybe<Array<ImportTypeEnum>>;
  unchanged?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  updated?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  version?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateImportsStatusInput = {
  imports: Array<UpdateImportStatusInput>;
};

export type UpdateImportsStatusResponse = {
  __typename?: 'UpdateImportsStatusResponse';
  imports: Array<UpdateResponse>;
};

export type UpdateIncidentIssueBulkInput = {
  updates: Array<UpdateIncidentIssueInput>;
};

export type UpdateIncidentIssueBulkResponse = {
  __typename?: 'UpdateIncidentIssueBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateIncidentIssueDocumentBulkInput = {
  updates: Array<UpdateIncidentIssueDocumentInput>;
};

export type UpdateIncidentIssueDocumentBulkResponse = {
  __typename?: 'UpdateIncidentIssueDocumentBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateIncidentIssueDocumentInput = {
  query: Array<IncidentIssueDocumentSearch>;
  value: UpdateIncidentIssueDocumentValuesInput;
};

export type UpdateIncidentIssueDocumentValuesInput = {
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  fileLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  fileSize?: InputMaybe<Array<Scalars['Int']['input']>>;
  filename?: InputMaybe<Array<Scalars['String']['input']>>;
  issueId?: InputMaybe<Array<Scalars['String']['input']>>;
  md5?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateIncidentIssueInput = {
  query: Array<IncidentIssueSearch>;
  value: UpdateIncidentIssueValuesInput;
};

export type UpdateIncidentIssueValuesInput = {
  crewInfo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  crewInvolved?: InputMaybe<Array<IncidentIssueCrewInvolvedEnum>>;
  description?: InputMaybe<Array<Scalars['String']['input']>>;
  dispatcherId?: InputMaybe<Array<Scalars['String']['input']>>;
  driverId?: InputMaybe<Array<Scalars['String']['input']>>;
  incidentDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  incidentOccurance?: InputMaybe<Array<IncidentIssueIncidentOccuranceEnum>>;
  incidentOccuranceOther?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  incidentWitnesses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  managerId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medicalAttentionType?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  medicalInjuries?: InputMaybe<Array<InputMaybe<IncidentIssueMedicalInjuriesEnum>>>;
  medicalNeeded?: InputMaybe<Array<InputMaybe<IncidentIssueMedicalNeededEnum>>>;
  outboundDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  outboundFlightName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  outboundFlightNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  propertyDamage?: InputMaybe<Array<IncidentIssuePropertyDamageEnum>>;
  propertyDamageDescription?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  recoveryInfo?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  samsaraCameraWorking?: InputMaybe<Array<InputMaybe<IncidentIssueSamsaraCameraWorkingEnum>>>;
  station?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateIndexBulkInput = {
  updates: Array<UpdateIndexInput>;
};

export type UpdateIndexBulkResponse = {
  __typename?: 'UpdateIndexBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateIndexInput = {
  query: Array<IndexSearch>;
  value: UpdateIndexValuesInput;
};

export type UpdateIndexValuesInput = {
  checkpoint?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateInvoiceAirportBulkInput = {
  updates: Array<UpdateInvoiceAirportInput>;
};

export type UpdateInvoiceAirportBulkResponse = {
  __typename?: 'UpdateInvoiceAirportBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceAirportInput = {
  query: Array<InvoiceAirportSearch>;
  value: UpdateInvoiceAirportValuesInput;
};

export type UpdateInvoiceAirportValuesInput = {
  code?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceId?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateInvoiceBulkInput = {
  updates: Array<UpdateInvoiceInput>;
};

export type UpdateInvoiceBulkResponse = {
  __typename?: 'UpdateInvoiceBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceClientBulkInput = {
  updates: Array<UpdateInvoiceClientInput>;
};

export type UpdateInvoiceClientBulkResponse = {
  __typename?: 'UpdateInvoiceClientBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceClientInput = {
  query: Array<InvoiceClientSearch>;
  value: UpdateInvoiceClientValuesInput;
};

export type UpdateInvoiceClientValuesInput = {
  address?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invoiceId?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateInvoiceCustomChargeBulkInput = {
  updates: Array<UpdateInvoiceCustomChargeInput>;
};

export type UpdateInvoiceCustomChargeBulkResponse = {
  __typename?: 'UpdateInvoiceCustomChargeBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceCustomChargeInput = {
  query: Array<InvoiceCustomChargeSearch>;
  value: UpdateInvoiceCustomChargeValuesInput;
};

export type UpdateInvoiceCustomChargeValuesInput = {
  cost?: InputMaybe<Array<Scalars['Float']['input']>>;
  index?: InputMaybe<Array<Scalars['Int']['input']>>;
  invoiceId?: InputMaybe<Array<Scalars['Int']['input']>>;
  note?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateInvoiceDocumentBulkInput = {
  updates: Array<UpdateInvoiceDocumentInput>;
};

export type UpdateInvoiceDocumentBulkResponse = {
  __typename?: 'UpdateInvoiceDocumentBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceDocumentInput = {
  query: Array<InvoiceDocumentSearch>;
  value: UpdateInvoiceDocumentValuesInput;
};

export type UpdateInvoiceDocumentValuesInput = {
  amendment?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fileLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  filename?: InputMaybe<Array<Scalars['String']['input']>>;
  genDocumentId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  genDocumentStatus?: InputMaybe<Array<InputMaybe<InvoiceDocumentGenDocumentStatusEnum>>>;
  index?: InputMaybe<Array<Scalars['Int']['input']>>;
  invoiceId?: InputMaybe<Array<Scalars['Int']['input']>>;
  md5?: InputMaybe<Array<Scalars['String']['input']>>;
  sendEmailOnCompletion?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  sendEmailRecipients?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sentAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sentBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateInvoiceEmailBulkInput = {
  updates: Array<UpdateInvoiceEmailInput>;
};

export type UpdateInvoiceEmailBulkResponse = {
  __typename?: 'UpdateInvoiceEmailBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceEmailInput = {
  query: Array<InvoiceEmailSearch>;
  value: UpdateInvoiceEmailValuesInput;
};

export type UpdateInvoiceEmailValuesInput = {
  address?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceId?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateInvoiceHeaderBulkInput = {
  updates: Array<UpdateInvoiceHeaderInput>;
};

export type UpdateInvoiceHeaderBulkResponse = {
  __typename?: 'UpdateInvoiceHeaderBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceHeaderInput = {
  query: Array<InvoiceHeaderSearch>;
  value: UpdateInvoiceHeaderValuesInput;
};

export type UpdateInvoiceHeaderValuesInput = {
  invoiceId?: InputMaybe<Array<Scalars['Int']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateInvoiceIataCodeBulkInput = {
  updates: Array<UpdateInvoiceIataCodeInput>;
};

export type UpdateInvoiceIataCodeBulkResponse = {
  __typename?: 'UpdateInvoiceIataCodeBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceIataCodeInput = {
  query: Array<InvoiceIataCodeSearch>;
  value: UpdateInvoiceIataCodeValuesInput;
};

export type UpdateInvoiceIataCodeValuesInput = {
  iataCode?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceId?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateInvoiceInput = {
  query: Array<InvoiceSearch>;
  value: UpdateInvoiceValuesInput;
};

export type UpdateInvoiceLineItemBulkInput = {
  updates: Array<UpdateInvoiceLineItemInput>;
};

export type UpdateInvoiceLineItemBulkResponse = {
  __typename?: 'UpdateInvoiceLineItemBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceLineItemInput = {
  query: Array<InvoiceLineItemSearch>;
  value: UpdateInvoiceLineItemValuesInput;
};

export type UpdateInvoiceLineItemValuesInput = {
  invoiceId?: InputMaybe<Array<Scalars['Int']['input']>>;
  lineItemTypeId?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  total?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdateInvoiceProviderCacheBulkInput = {
  updates: Array<UpdateInvoiceProviderCacheInput>;
};

export type UpdateInvoiceProviderCacheBulkResponse = {
  __typename?: 'UpdateInvoiceProviderCacheBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceProviderCacheInput = {
  query: Array<InvoiceProviderCacheSearch>;
  value: UpdateInvoiceProviderCacheValuesInput;
};

export type UpdateInvoiceProviderCacheValuesInput = {
  displayName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateInvoiceTermBulkInput = {
  updates: Array<UpdateInvoiceTermInput>;
};

export type UpdateInvoiceTermBulkResponse = {
  __typename?: 'UpdateInvoiceTermBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceTermInput = {
  query: Array<InvoiceTermSearch>;
  value: UpdateInvoiceTermValuesInput;
};

export type UpdateInvoiceTermValuesInput = {
  type?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateInvoiceTotalSummaryBulkInput = {
  updates: Array<UpdateInvoiceTotalSummaryInput>;
};

export type UpdateInvoiceTotalSummaryBulkResponse = {
  __typename?: 'UpdateInvoiceTotalSummaryBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceTotalSummaryInput = {
  query: Array<InvoiceTotalSummarySearch>;
  value: UpdateInvoiceTotalSummaryValuesInput;
};

export type UpdateInvoiceTotalSummaryValuesInput = {
  airlines?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  airports?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  chargeType?: InputMaybe<Array<InvoiceTotalSummaryChargeTypeEnum>>;
  clientAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  clientName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dueDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  emails?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Array<InvoiceTotalSummaryFormatEnum>>;
  grandSubtotal?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grandTotal?: InputMaybe<Array<Scalars['Float']['input']>>;
  headers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  invoiceDate?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceDocumentId?: InputMaybe<Array<Scalars['String']['input']>>;
  invoiceId?: InputMaybe<Array<Scalars['Int']['input']>>;
  lineItemCount?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lineItemTotal?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  payerProviderId?: InputMaybe<Array<Scalars['String']['input']>>;
  startDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<InvoiceTotalSummaryStatusEnum>>;
  subtotal?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalSavings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalTrips?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  totalTripsBilled?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  tripStatuses?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  uniqueId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateInvoiceTripBulkInput = {
  updates: Array<UpdateInvoiceTripInput>;
};

export type UpdateInvoiceTripBulkResponse = {
  __typename?: 'UpdateInvoiceTripBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceTripInput = {
  query: Array<InvoiceTripSearch>;
  value: UpdateInvoiceTripValuesInput;
};

export type UpdateInvoiceTripStatusBulkInput = {
  updates: Array<UpdateInvoiceTripStatusInput>;
};

export type UpdateInvoiceTripStatusBulkResponse = {
  __typename?: 'UpdateInvoiceTripStatusBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceTripStatusInput = {
  query: Array<InvoiceTripStatusSearch>;
  value: UpdateInvoiceTripStatusValuesInput;
};

export type UpdateInvoiceTripStatusValuesInput = {
  invoiceId?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Array<InvoiceTripStatusStatusEnum>>;
};

export type UpdateInvoiceTripValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  attendants?: InputMaybe<Array<Scalars['Int']['input']>>;
  combineId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  combineType?: InputMaybe<Array<InputMaybe<InvoiceTripCombineTypeEnum>>>;
  crewId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  currency?: InputMaybe<Array<InputMaybe<InvoiceTripCurrencyEnum>>>;
  discount?: InputMaybe<Array<Scalars['Float']['input']>>;
  doLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightNumber?: InputMaybe<Array<Scalars['Int']['input']>>;
  importTime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  index?: InputMaybe<Array<Scalars['Int']['input']>>;
  invoiceId?: InputMaybe<Array<Scalars['Int']['input']>>;
  kind?: InputMaybe<Array<InvoiceTripKindEnum>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pilots?: InputMaybe<Array<Scalars['Int']['input']>>;
  puLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  rate?: InputMaybe<Array<Scalars['Float']['input']>>;
  rateId?: InputMaybe<Array<Scalars['String']['input']>>;
  savings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  scheduled?: InputMaybe<Array<Scalars['String']['input']>>;
  servicerIataAirlineCode?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<InvoiceTripStatusEnum>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<InvoiceTripTypeEnum>>;
};

export type UpdateInvoiceTypeBulkInput = {
  updates: Array<UpdateInvoiceTypeInput>;
};

export type UpdateInvoiceTypeBulkResponse = {
  __typename?: 'UpdateInvoiceTypeBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceTypeInput = {
  query: Array<InvoiceTypeSearch>;
  value: UpdateInvoiceTypeValuesInput;
};

export type UpdateInvoiceTypeValuesInput = {
  invoiceId?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Array<InvoiceTypeTypeEnum>>;
};

export type UpdateInvoiceUserCacheBulkInput = {
  updates: Array<UpdateInvoiceUserCacheInput>;
};

export type UpdateInvoiceUserCacheBulkResponse = {
  __typename?: 'UpdateInvoiceUserCacheBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateInvoiceUserCacheInput = {
  query: Array<InvoiceUserCacheSearch>;
  value: UpdateInvoiceUserCacheValuesInput;
};

export type UpdateInvoiceUserCacheValuesInput = {
  firstName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateInvoiceValuesInput = {
  chargeType?: InputMaybe<Array<InvoiceChargeTypeEnum>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  due?: InputMaybe<Array<Scalars['String']['input']>>;
  endDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  format?: InputMaybe<Array<InvoiceFormatEnum>>;
  grandSubtotal?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  grandTotal?: InputMaybe<Array<Scalars['Float']['input']>>;
  hasDiscounts?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  invoiced?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  netBillableTrips?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  payerProviderId?: InputMaybe<Array<Scalars['String']['input']>>;
  startDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<InvoiceStatusEnum>>;
  subTotal?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  total?: InputMaybe<Array<Scalars['Float']['input']>>;
  totalDiscountedTrips?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  totalSavings?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  totalTripsBilled?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  uniqueId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateIssueBulkInput = {
  updates: Array<UpdateIssueInput>;
};

export type UpdateIssueBulkResponse = {
  __typename?: 'UpdateIssueBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateIssueInput = {
  query: Array<IssueSearch>;
  value: UpdateIssueValuesInput;
};

export type UpdateIssueValuesInput = {
  driverId?: InputMaybe<Array<Scalars['String']['input']>>;
  message?: InputMaybe<Array<Scalars['String']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateLicenseBulkInput = {
  updates: Array<UpdateLicenseInput>;
};

export type UpdateLicenseBulkResponse = {
  __typename?: 'UpdateLicenseBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateLicenseInput = {
  query: Array<LicenseSearch>;
  value: UpdateLicenseValuesInput;
};

export type UpdateLicenseTypeBulkInput = {
  updates: Array<UpdateLicenseTypeInput>;
};

export type UpdateLicenseTypeBulkResponse = {
  __typename?: 'UpdateLicenseTypeBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateLicenseTypeInput = {
  query: Array<LicenseTypeSearch>;
  value: UpdateLicenseTypeValuesInput;
};

export type UpdateLicenseTypeValuesInput = {
  displayName?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateLicenseValuesInput = {
  expirationDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  licenseTypeId?: InputMaybe<Array<Scalars['String']['input']>>;
  number?: InputMaybe<Array<Scalars['String']['input']>>;
  stateCode?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateLineItemTypeBulkInput = {
  updates: Array<UpdateLineItemTypeInput>;
};

export type UpdateLineItemTypeBulkResponse = {
  __typename?: 'UpdateLineItemTypeBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateLineItemTypeInput = {
  query: Array<LineItemTypeSearch>;
  value: UpdateLineItemTypeValuesInput;
};

export type UpdateLineItemTypeValuesInput = {
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateLocationBulkInput = {
  updates: Array<UpdateLocationInput>;
};

export type UpdateLocationBulkResponse = {
  __typename?: 'UpdateLocationBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateLocationByIdInput = {
  airportCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  aliases?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId: Scalars['String']['input'];
  value: UpdateLocationValuesInput;
};

export type UpdateLocationByIdResponse = {
  __typename?: 'UpdateLocationByIdResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type UpdateLocationInput = {
  query: Array<LocationSearch>;
  value: UpdateLocationValuesInput;
};

export type UpdateLocationValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  address?: InputMaybe<Array<Scalars['String']['input']>>;
  cityName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  coordinates?: InputMaybe<Array<PointInput>>;
  countryCode?: InputMaybe<Array<Scalars['String']['input']>>;
  legacyId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryAirportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  radius?: InputMaybe<Array<Scalars['Int']['input']>>;
  stateCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<LocationTypeEnum>>;
  zipCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateLoginEventBulkInput = {
  updates: Array<UpdateLoginEventInput>;
};

export type UpdateLoginEventBulkResponse = {
  __typename?: 'UpdateLoginEventBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateLoginEventInput = {
  query: Array<LoginEventSearch>;
  value: UpdateLoginEventValuesInput;
};

export type UpdateLoginEventValuesInput = {
  cityName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  datetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  ipAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userAgent?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateLostAndFoundIssueBulkInput = {
  updates: Array<UpdateLostAndFoundIssueInput>;
};

export type UpdateLostAndFoundIssueBulkResponse = {
  __typename?: 'UpdateLostAndFoundIssueBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateLostAndFoundIssueDocumentBulkInput = {
  updates: Array<UpdateLostAndFoundIssueDocumentInput>;
};

export type UpdateLostAndFoundIssueDocumentBulkResponse = {
  __typename?: 'UpdateLostAndFoundIssueDocumentBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateLostAndFoundIssueDocumentInput = {
  query: Array<LostAndFoundIssueDocumentSearch>;
  value: UpdateLostAndFoundIssueDocumentValuesInput;
};

export type UpdateLostAndFoundIssueDocumentValuesInput = {
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  fileLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  fileSize?: InputMaybe<Array<Scalars['Int']['input']>>;
  filename?: InputMaybe<Array<Scalars['String']['input']>>;
  issueId?: InputMaybe<Array<Scalars['String']['input']>>;
  md5?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateLostAndFoundIssueInput = {
  query: Array<LostAndFoundIssueSearch>;
  value: UpdateLostAndFoundIssueValuesInput;
};

export type UpdateLostAndFoundIssueValuesInput = {
  crewAirportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  crewDriverName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  crewFlightName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  crewFlightNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  crewMemberEmail?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  crewMemberName?: InputMaybe<Array<Scalars['String']['input']>>;
  crewMemberPhone?: InputMaybe<Array<Scalars['String']['input']>>;
  datetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Array<Scalars['String']['input']>>;
  dispatcherId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  itemLost?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  outboundDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  outboundFlightName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  outboundFlightNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  returnStatus?: InputMaybe<Array<InputMaybe<LostAndFoundIssueReturnStatusEnum>>>;
  shippingAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shippingCity?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shippingCost?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  shippingMethod?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shippingStateCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  shippingZipCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trackingNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateManifestHistoryBulkInput = {
  updates: Array<UpdateManifestHistoryInput>;
};

export type UpdateManifestHistoryBulkResponse = {
  __typename?: 'UpdateManifestHistoryBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateManifestHistoryInput = {
  query: Array<ManifestHistorySearch>;
  value: UpdateManifestHistoryValuesInput;
};

export type UpdateManifestHistoryRouteBulkInput = {
  updates: Array<UpdateManifestHistoryRouteInput>;
};

export type UpdateManifestHistoryRouteBulkResponse = {
  __typename?: 'UpdateManifestHistoryRouteBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateManifestHistoryRouteInput = {
  query: Array<ManifestHistoryRouteSearch>;
  value: UpdateManifestHistoryRouteValuesInput;
};

export type UpdateManifestHistoryRouteValuesInput = {
  doLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  manifestHistoryId?: InputMaybe<Array<Scalars['String']['input']>>;
  puLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<ManifestHistoryRouteStatusEnum>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateManifestHistoryValuesInput = {
  filename?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  manifestImportId?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateManifestProviderCacheBulkInput = {
  updates: Array<UpdateManifestProviderCacheInput>;
};

export type UpdateManifestProviderCacheBulkResponse = {
  __typename?: 'UpdateManifestProviderCacheBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateManifestProviderCacheInput = {
  query: Array<ManifestProviderCacheSearch>;
  value: UpdateManifestProviderCacheValuesInput;
};

export type UpdateManifestProviderCacheValuesInput = {
  displayName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateManifestUserCacheBulkInput = {
  updates: Array<UpdateManifestUserCacheInput>;
};

export type UpdateManifestUserCacheBulkResponse = {
  __typename?: 'UpdateManifestUserCacheBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateManifestUserCacheInput = {
  query: Array<ManifestUserCacheSearch>;
  value: UpdateManifestUserCacheValuesInput;
};

export type UpdateManifestUserCacheValuesInput = {
  employeeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateMessageBulkInput = {
  updates: Array<UpdateMessageInput>;
};

export type UpdateMessageBulkResponse = {
  __typename?: 'UpdateMessageBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateMessageInput = {
  query: Array<MessageSearch>;
  value: UpdateMessageValuesInput;
};

export type UpdateMessageValuesInput = {
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  content?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<MessageTypeEnum>>;
};

export type UpdateNotificationBulkInput = {
  updates: Array<UpdateNotificationInput>;
};

export type UpdateNotificationBulkResponse = {
  __typename?: 'UpdateNotificationBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateNotificationHasEventBulkInput = {
  updates: Array<UpdateNotificationHasEventInput>;
};

export type UpdateNotificationHasEventBulkResponse = {
  __typename?: 'UpdateNotificationHasEventBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateNotificationHasEventInput = {
  query: Array<NotificationHasEventSearch>;
  value: UpdateNotificationHasEventValuesInput;
};

export type UpdateNotificationHasEventValuesInput = {
  eventId?: InputMaybe<Array<Scalars['String']['input']>>;
  responseId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateNotificationInput = {
  query: Array<NotificationSearch>;
  value: UpdateNotificationValuesInput;
};

export type UpdateNotificationValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  allProvider?: InputMaybe<Array<Scalars['Int']['input']>>;
  allVendors?: InputMaybe<Array<Scalars['Int']['input']>>;
  company?: InputMaybe<Array<Scalars['String']['input']>>;
  method?: InputMaybe<Array<NotificationMethodEnum>>;
  vendor?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateParsedTripBulkInput = {
  updates: Array<UpdateParsedTripInput>;
};

export type UpdateParsedTripBulkResponse = {
  __typename?: 'UpdateParsedTripBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateParsedTripInput = {
  query: Array<ParsedTripSearch>;
  value: UpdateParsedTripValuesInput;
};

export type UpdateParsedTripValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  attendants?: InputMaybe<Array<Scalars['Int']['input']>>;
  doLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  doLocationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fromManifest?: InputMaybe<Array<Scalars['Int']['input']>>;
  importId?: InputMaybe<Array<Scalars['String']['input']>>;
  importTime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kind?: InputMaybe<Array<ParsedTripKindEnum>>;
  loopName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  pilots?: InputMaybe<Array<Scalars['Int']['input']>>;
  puLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  puLocationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduled?: InputMaybe<Array<Scalars['String']['input']>>;
  servicerIataAirlineCode?: InputMaybe<Array<Scalars['String']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
  typeName?: InputMaybe<Array<InputMaybe<ParsedTripTypeNameEnum>>>;
};

export type UpdatePasswordInput = {
  confirmPassword: Scalars['String']['input'];
  newPassword: Scalars['String']['input'];
  oldPassword: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdatePasswordsInput = {
  users: Array<UpdatePasswordInput>;
};

export type UpdatePasswordsResponse = {
  __typename?: 'UpdatePasswordsResponse';
  users: Array<UpdateResponse>;
};

export type UpdatePermissionBulkInput = {
  updates: Array<UpdatePermissionInput>;
};

export type UpdatePermissionBulkResponse = {
  __typename?: 'UpdatePermissionBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdatePermissionHasRoleBulkInput = {
  updates: Array<UpdatePermissionHasRoleInput>;
};

export type UpdatePermissionHasRoleBulkResponse = {
  __typename?: 'UpdatePermissionHasRoleBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdatePermissionHasRoleInput = {
  query: Array<PermissionHasRoleSearch>;
  value: UpdatePermissionHasRoleValuesInput;
};

export type UpdatePermissionHasRoleValuesInput = {
  permissionId?: InputMaybe<Array<Scalars['String']['input']>>;
  roleId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdatePermissionHasUserBulkInput = {
  updates: Array<UpdatePermissionHasUserInput>;
};

export type UpdatePermissionHasUserBulkResponse = {
  __typename?: 'UpdatePermissionHasUserBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdatePermissionHasUserInput = {
  query: Array<PermissionHasUserSearch>;
  value: UpdatePermissionHasUserValuesInput;
};

export type UpdatePermissionHasUserValuesInput = {
  effect?: InputMaybe<Array<PermissionHasUserEffectEnum>>;
  permissionId?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdatePermissionInput = {
  query: Array<PermissionSearch>;
  value: UpdatePermissionValuesInput;
};

export type UpdatePermissionValuesInput = {
  description?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayGroup?: InputMaybe<Array<Scalars['String']['input']>>;
  displayName?: InputMaybe<Array<Scalars['String']['input']>>;
  effect?: InputMaybe<Array<PermissionEffectEnum>>;
  entity?: InputMaybe<Array<Scalars['String']['input']>>;
  resource?: InputMaybe<Array<Scalars['String']['input']>>;
  verb?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdatePickupPointBulkInput = {
  updates: Array<UpdatePickupPointInput>;
};

export type UpdatePickupPointBulkResponse = {
  __typename?: 'UpdatePickupPointBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdatePickupPointInput = {
  query: Array<PickupPointSearch>;
  value: UpdatePickupPointValuesInput;
};

export type UpdatePickupPointValuesInput = {
  coordinates?: InputMaybe<Array<PointInput>>;
  endDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  instructions?: InputMaybe<Array<Scalars['String']['input']>>;
  keyword?: InputMaybe<Array<Scalars['String']['input']>>;
  locationId?: InputMaybe<Array<Scalars['String']['input']>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
  radius?: InputMaybe<Array<Scalars['Int']['input']>>;
  startDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdatePotentialTripBulkInput = {
  updates: Array<UpdatePotentialTripInput>;
};

export type UpdatePotentialTripBulkResponse = {
  __typename?: 'UpdatePotentialTripBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdatePotentialTripInput = {
  query: Array<PotentialTripSearch>;
  value: UpdatePotentialTripValuesInput;
};

export type UpdatePotentialTripValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  attendants?: InputMaybe<Array<Scalars['Int']['input']>>;
  bufferMinutes?: InputMaybe<Array<Scalars['Int']['input']>>;
  combineId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  crewId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  doLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fromManifest?: InputMaybe<Array<Scalars['Int']['input']>>;
  importId?: InputMaybe<Array<Scalars['String']['input']>>;
  importTime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  kind?: InputMaybe<Array<PotentialTripKindEnum>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loopName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payerProviderId?: InputMaybe<Array<Scalars['String']['input']>>;
  pilots?: InputMaybe<Array<Scalars['Int']['input']>>;
  puLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduled?: InputMaybe<Array<Scalars['String']['input']>>;
  servicerIataAirlineCode?: InputMaybe<Array<Scalars['String']['input']>>;
  split?: InputMaybe<Array<Scalars['Int']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
  typeName?: InputMaybe<Array<InputMaybe<PotentialTripTypeNameEnum>>>;
};

export type UpdateProviderAliasBulkInput = {
  updates: Array<UpdateProviderAliasInput>;
};

export type UpdateProviderAliasBulkResponse = {
  __typename?: 'UpdateProviderAliasBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateProviderAliasInput = {
  query: Array<ProviderAliasSearch>;
  value: UpdateProviderAliasValuesInput;
};

export type UpdateProviderAliasValuesInput = {
  alias?: InputMaybe<Array<Scalars['String']['input']>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateProviderBulkInput = {
  updates: Array<UpdateProviderInput>;
};

export type UpdateProviderBulkResponse = {
  __typename?: 'UpdateProviderBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateProviderCacheBulkInput = {
  updates: Array<UpdateProviderCacheInput>;
};

export type UpdateProviderCacheBulkResponse = {
  __typename?: 'UpdateProviderCacheBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateProviderCacheInput = {
  query: Array<ProviderCacheSearch>;
  value: UpdateProviderCacheValuesInput;
};

export type UpdateProviderCacheValuesInput = {
  displayName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateProviderInput = {
  query: Array<ProviderSearch>;
  value: UpdateProviderValuesInput;
};

export type UpdateProviderLocationMappingBulkInput = {
  updates: Array<UpdateProviderLocationMappingInput>;
};

export type UpdateProviderLocationMappingBulkResponse = {
  __typename?: 'UpdateProviderLocationMappingBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateProviderLocationMappingInput = {
  query: Array<ProviderLocationMappingSearch>;
  value: UpdateProviderLocationMappingValuesInput;
};

export type UpdateProviderLocationMappingValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  contractId?: InputMaybe<Array<Scalars['String']['input']>>;
  doLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
  puLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateProviderValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  addonAutomationAutoIngest?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  billFrequency?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  billingAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  billingCityCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  billingStateCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  billingZipCode?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  contactPerson?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  faxNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  iataAirlineCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  importCode?: InputMaybe<Array<InputMaybe<ProviderImportCodeEnum>>>;
  invoiceTermId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mobilePhoneNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  occPhoneNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryCityCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryEmail?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryLogoUrl?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryPhoneNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryStateCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryZipCode?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  referenceNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  requiresCrewInfo?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<ProviderTypeEnum>>;
  website?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdatePunchBulkInput = {
  updates: Array<UpdatePunchInput>;
};

export type UpdatePunchBulkResponse = {
  __typename?: 'UpdatePunchBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdatePunchHistoryBulkInput = {
  updates: Array<UpdatePunchHistoryInput>;
};

export type UpdatePunchHistoryBulkResponse = {
  __typename?: 'UpdatePunchHistoryBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdatePunchHistoryInput = {
  query: Array<PunchHistorySearch>;
  value: UpdatePunchHistoryValuesInput;
};

export type UpdatePunchHistoryValuesInput = {
  approvalEmployee?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  approvalSupervisor?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  approvalSupervisorBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyCode?: InputMaybe<Array<Scalars['String']['input']>>;
  date?: InputMaybe<Array<Scalars['String']['input']>>;
  durationOt1?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  durationOt2?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  durationRegular?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  employeeId?: InputMaybe<Array<Scalars['String']['input']>>;
  fileLocation?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Array<Scalars['String']['input']>>;
  payType?: InputMaybe<Array<Scalars['String']['input']>>;
  punchInTime?: InputMaybe<Array<Scalars['String']['input']>>;
  punchInType?: InputMaybe<Array<PunchHistoryPunchInTypeEnum>>;
  punchOutTime?: InputMaybe<Array<Scalars['String']['input']>>;
  punchOutType?: InputMaybe<Array<PunchHistoryPunchOutTypeEnum>>;
  unpaidDuration?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
};

export type UpdatePunchInput = {
  query: Array<PunchSearch>;
  value: UpdatePunchValuesInput;
};

export type UpdatePunchPolicyBulkInput = {
  updates: Array<UpdatePunchPolicyInput>;
};

export type UpdatePunchPolicyBulkResponse = {
  __typename?: 'UpdatePunchPolicyBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdatePunchPolicyInput = {
  query: Array<PunchPolicySearch>;
  value: UpdatePunchPolicyValuesInput;
};

export type UpdatePunchPolicyValuesInput = {
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  endTime?: InputMaybe<Array<Scalars['String']['input']>>;
  eventEndDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  eventStartDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationId?: InputMaybe<Array<Scalars['String']['input']>>;
  minutesIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  minutesOut?: InputMaybe<Array<Scalars['Int']['input']>>;
  startTime?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdatePunchValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  coordinates?: InputMaybe<Array<InputMaybe<PointInput>>>;
  paylocityCompanyId?: InputMaybe<Array<Scalars['String']['input']>>;
  paylocityJobCodeId?: InputMaybe<Array<Scalars['String']['input']>>;
  punchDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<PunchTypeEnum>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateQueryHistoryBulkInput = {
  updates: Array<UpdateQueryHistoryInput>;
};

export type UpdateQueryHistoryBulkResponse = {
  __typename?: 'UpdateQueryHistoryBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateQueryHistoryInput = {
  query: Array<QueryHistorySearch>;
  value: UpdateQueryHistoryValuesInput;
};

export type UpdateQueryHistoryValuesInput = {
  doLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  endDate?: InputMaybe<Array<Scalars['String']['input']>>;
  interval?: InputMaybe<Array<Scalars['String']['input']>>;
  puLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<QueryHistoryStatusEnum>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateQuestionnaireAnswerOptionBulkInput = {
  updates: Array<UpdateQuestionnaireAnswerOptionInput>;
};

export type UpdateQuestionnaireAnswerOptionBulkResponse = {
  __typename?: 'UpdateQuestionnaireAnswerOptionBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateQuestionnaireAnswerOptionInput = {
  query: Array<QuestionnaireAnswerOptionSearch>;
  value: UpdateQuestionnaireAnswerOptionValuesInput;
};

export type UpdateQuestionnaireAnswerOptionValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  answerTypeId?: InputMaybe<Array<Scalars['String']['input']>>;
  color?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayLabel?: InputMaybe<Array<Scalars['String']['input']>>;
  showsNotes?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortOrder?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateQuestionnaireAnswerTypeBulkInput = {
  updates: Array<UpdateQuestionnaireAnswerTypeInput>;
};

export type UpdateQuestionnaireAnswerTypeBulkResponse = {
  __typename?: 'UpdateQuestionnaireAnswerTypeBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateQuestionnaireAnswerTypeInput = {
  query: Array<QuestionnaireAnswerTypeSearch>;
  value: UpdateQuestionnaireAnswerTypeValuesInput;
};

export type UpdateQuestionnaireAnswerTypeValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  allowsNotes?: InputMaybe<Array<Scalars['Int']['input']>>;
  displayName?: InputMaybe<Array<Scalars['String']['input']>>;
  notesPlaceholder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateQuestionnaireAttemptAnswerOptionSnapshotBulkInput = {
  updates: Array<UpdateQuestionnaireAttemptAnswerOptionSnapshotInput>;
};

export type UpdateQuestionnaireAttemptAnswerOptionSnapshotBulkResponse = {
  __typename?: 'UpdateQuestionnaireAttemptAnswerOptionSnapshotBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateQuestionnaireAttemptAnswerOptionSnapshotInput = {
  query: Array<QuestionnaireAttemptAnswerOptionSnapshotSearch>;
  value: UpdateQuestionnaireAttemptAnswerOptionSnapshotValuesInput;
};

export type UpdateQuestionnaireAttemptAnswerOptionSnapshotValuesInput = {
  color?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  displayLabel?: InputMaybe<Array<Scalars['String']['input']>>;
  questionnaireAttemptQuestionSnapshotId?: InputMaybe<Array<Scalars['String']['input']>>;
  showsNotes?: InputMaybe<Array<Scalars['Int']['input']>>;
  sortOrder?: InputMaybe<Array<Scalars['Int']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateQuestionnaireAttemptBulkInput = {
  updates: Array<UpdateQuestionnaireAttemptInput>;
};

export type UpdateQuestionnaireAttemptBulkResponse = {
  __typename?: 'UpdateQuestionnaireAttemptBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateQuestionnaireAttemptCategorySnapshotAllowedGroupBulkInput = {
  updates: Array<UpdateQuestionnaireAttemptCategorySnapshotAllowedGroupInput>;
};

export type UpdateQuestionnaireAttemptCategorySnapshotAllowedGroupBulkResponse = {
  __typename?: 'UpdateQuestionnaireAttemptCategorySnapshotAllowedGroupBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateQuestionnaireAttemptCategorySnapshotAllowedGroupInput = {
  query: Array<QuestionnaireAttemptCategorySnapshotAllowedGroupSearch>;
  value: UpdateQuestionnaireAttemptCategorySnapshotAllowedGroupValuesInput;
};

export type UpdateQuestionnaireAttemptCategorySnapshotAllowedGroupValuesInput = {
  groupId?: InputMaybe<Array<Scalars['String']['input']>>;
  questionnaireAttemptCategorySnapshotId?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateQuestionnaireAttemptCategorySnapshotBulkInput = {
  updates: Array<UpdateQuestionnaireAttemptCategorySnapshotInput>;
};

export type UpdateQuestionnaireAttemptCategorySnapshotBulkResponse = {
  __typename?: 'UpdateQuestionnaireAttemptCategorySnapshotBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateQuestionnaireAttemptCategorySnapshotGroupBulkInput = {
  updates: Array<UpdateQuestionnaireAttemptCategorySnapshotGroupInput>;
};

export type UpdateQuestionnaireAttemptCategorySnapshotGroupBulkResponse = {
  __typename?: 'UpdateQuestionnaireAttemptCategorySnapshotGroupBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateQuestionnaireAttemptCategorySnapshotGroupInput = {
  query: Array<QuestionnaireAttemptCategorySnapshotGroupSearch>;
  value: UpdateQuestionnaireAttemptCategorySnapshotGroupValuesInput;
};

export type UpdateQuestionnaireAttemptCategorySnapshotGroupValuesInput = {
  groupId?: InputMaybe<Array<Scalars['String']['input']>>;
  groupName?: InputMaybe<Array<Scalars['String']['input']>>;
  questionnaireAttemptCategorySnapshotId?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateQuestionnaireAttemptCategorySnapshotInput = {
  query: Array<QuestionnaireAttemptCategorySnapshotSearch>;
  value: UpdateQuestionnaireAttemptCategorySnapshotValuesInput;
};

export type UpdateQuestionnaireAttemptCategorySnapshotValuesInput = {
  color?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  questionnaireAttemptId?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<Array<Scalars['Int']['input']>>;
  submittedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submittedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateQuestionnaireAttemptInput = {
  query: Array<QuestionnaireAttemptSearch>;
  value: UpdateQuestionnaireAttemptValuesInput;
};

export type UpdateQuestionnaireAttemptNoteBulkInput = {
  updates: Array<UpdateQuestionnaireAttemptNoteInput>;
};

export type UpdateQuestionnaireAttemptNoteBulkResponse = {
  __typename?: 'UpdateQuestionnaireAttemptNoteBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateQuestionnaireAttemptNoteInput = {
  query: Array<QuestionnaireAttemptNoteSearch>;
  value: UpdateQuestionnaireAttemptNoteValuesInput;
};

export type UpdateQuestionnaireAttemptNoteValuesInput = {
  note?: InputMaybe<Array<Scalars['String']['input']>>;
  questionnaireAttemptId?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateQuestionnaireAttemptQuestionSnapshotBulkInput = {
  updates: Array<UpdateQuestionnaireAttemptQuestionSnapshotInput>;
};

export type UpdateQuestionnaireAttemptQuestionSnapshotBulkResponse = {
  __typename?: 'UpdateQuestionnaireAttemptQuestionSnapshotBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateQuestionnaireAttemptQuestionSnapshotInput = {
  query: Array<QuestionnaireAttemptQuestionSnapshotSearch>;
  value: UpdateQuestionnaireAttemptQuestionSnapshotValuesInput;
};

export type UpdateQuestionnaireAttemptQuestionSnapshotValuesInput = {
  answerTypeAllowsNotes?: InputMaybe<Array<Scalars['Int']['input']>>;
  answerTypeDisplayName?: InputMaybe<Array<Scalars['String']['input']>>;
  answerTypeNotesPlaceholder?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  helperText?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questionText?: InputMaybe<Array<Scalars['String']['input']>>;
  questionnaireAttemptCategorySnapshotId?: InputMaybe<Array<Scalars['String']['input']>>;
  selectedAnswerNote?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  selectedAnswerOptionId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortOrder?: InputMaybe<Array<Scalars['Int']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateQuestionnaireAttemptValuesInput = {
  overallResult?: InputMaybe<Array<InputMaybe<QuestionnaireAttemptOverallResultEnum>>>;
  roleId?: InputMaybe<Array<Scalars['String']['input']>>;
  subjectHireDate?: InputMaybe<Array<Scalars['String']['input']>>;
  subjectUserId?: InputMaybe<Array<Scalars['String']['input']>>;
  submittedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  submittedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateQuestionnaireCategoryBulkInput = {
  updates: Array<UpdateQuestionnaireCategoryInput>;
};

export type UpdateQuestionnaireCategoryBulkResponse = {
  __typename?: 'UpdateQuestionnaireCategoryBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateQuestionnaireCategoryInput = {
  query: Array<QuestionnaireCategorySearch>;
  value: UpdateQuestionnaireCategoryValuesInput;
};

export type UpdateQuestionnaireCategoryValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  answerTypeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  color?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  description?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  roleId?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateQuestionnaireQuestionBulkInput = {
  updates: Array<UpdateQuestionnaireQuestionInput>;
};

export type UpdateQuestionnaireQuestionBulkResponse = {
  __typename?: 'UpdateQuestionnaireQuestionBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateQuestionnaireQuestionInput = {
  query: Array<QuestionnaireQuestionSearch>;
  value: UpdateQuestionnaireQuestionValuesInput;
};

export type UpdateQuestionnaireQuestionValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  answerTypeId?: InputMaybe<Array<Scalars['String']['input']>>;
  helperText?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  questionText?: InputMaybe<Array<Scalars['String']['input']>>;
  questionnaireCategoryId?: InputMaybe<Array<Scalars['String']['input']>>;
  sortOrder?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateRateBulkInput = {
  updates: Array<UpdateRateInput>;
};

export type UpdateRateBulkResponse = {
  __typename?: 'UpdateRateBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateRateGroupBulkInput = {
  updates: Array<UpdateRateGroupInput>;
};

export type UpdateRateGroupBulkResponse = {
  __typename?: 'UpdateRateGroupBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateRateGroupInput = {
  query: Array<RateGroupSearch>;
  value: UpdateRateGroupValuesInput;
};

export type UpdateRateGroupValuesInput = {
  airportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  duration?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  payerProviderId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thatLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  thisLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  tripDistance?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type UpdateRateHistoryBulkInput = {
  updates: Array<UpdateRateHistoryInput>;
};

export type UpdateRateHistoryBulkResponse = {
  __typename?: 'UpdateRateHistoryBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateRateHistoryInput = {
  query: Array<RateHistorySearch>;
  value: UpdateRateHistoryValuesInput;
};

export type UpdateRateHistoryValuesInput = {
  currency?: InputMaybe<Array<RateHistoryCurrencyEnum>>;
  endDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rate?: InputMaybe<Array<Scalars['Float']['input']>>;
  rateGroupId?: InputMaybe<Array<Scalars['String']['input']>>;
  rateItemId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<RateHistoryTypeEnum>>;
};

export type UpdateRateInput = {
  query: Array<RateSearch>;
  value: UpdateRateValuesInput;
};

export type UpdateRateItemBulkInput = {
  updates: Array<UpdateRateItemInput>;
};

export type UpdateRateItemBulkResponse = {
  __typename?: 'UpdateRateItemBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateRateItemInput = {
  query: Array<RateItemSearch>;
  value: UpdateRateItemValuesInput;
};

export type UpdateRateItemValuesInput = {
  currency?: InputMaybe<Array<RateItemCurrencyEnum>>;
  endDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rate?: InputMaybe<Array<Scalars['Float']['input']>>;
  rateGroupId?: InputMaybe<Array<Scalars['String']['input']>>;
  startDatetime?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<RateItemTypeEnum>>;
};

export type UpdateRateOnTripInput = {
  rateHistoryId: Scalars['String']['input'];
  rateId?: InputMaybe<Scalars['String']['input']>;
  tripId: Scalars['String']['input'];
};

export type UpdateRateOnTripResponse = {
  __typename?: 'UpdateRateOnTripResponse';
  error?: Maybe<Error>;
  rateHistoryId?: Maybe<Scalars['String']['output']>;
  rateId?: Maybe<Scalars['String']['output']>;
  tripId?: Maybe<Scalars['String']['output']>;
  updated?: Maybe<Scalars['Int']['output']>;
};

export type UpdateRateOnTripsInput = {
  input: Array<UpdateRateOnTripInput>;
};

export type UpdateRateOnTripsResponse = {
  __typename?: 'UpdateRateOnTripsResponse';
  output?: Maybe<Array<UpdateRateOnTripResponse>>;
};

export type UpdateRateValuesInput = {
  airportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  contractEndDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contractId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contractStartDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency?: InputMaybe<Array<RateCurrencyEnum>>;
  duration?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  endDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  notes?: InputMaybe<Array<Scalars['String']['input']>>;
  payerProviderId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  radius?: InputMaybe<Array<Scalars['Int']['input']>>;
  rate?: InputMaybe<Array<Scalars['Float']['input']>>;
  startDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  thatLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  thisLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  tripDistance?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  type?: InputMaybe<Array<RateTypeEnum>>;
};

export type UpdateRatingBulkInput = {
  updates: Array<UpdateRatingInput>;
};

export type UpdateRatingBulkResponse = {
  __typename?: 'UpdateRatingBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateRatingCacheBulkInput = {
  updates: Array<UpdateRatingCacheInput>;
};

export type UpdateRatingCacheBulkResponse = {
  __typename?: 'UpdateRatingCacheBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateRatingCacheInput = {
  query: Array<RatingCacheSearch>;
  value: UpdateRatingCacheValuesInput;
};

export type UpdateRatingCacheRemarkBulkInput = {
  updates: Array<UpdateRatingCacheRemarkInput>;
};

export type UpdateRatingCacheRemarkBulkResponse = {
  __typename?: 'UpdateRatingCacheRemarkBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateRatingCacheRemarkInput = {
  query: Array<RatingCacheRemarkSearch>;
  value: UpdateRatingCacheRemarkValuesInput;
};

export type UpdateRatingCacheRemarkValuesInput = {
  ratingCacheId?: InputMaybe<Array<Scalars['String']['input']>>;
  remark?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateRatingCacheValuesInput = {
  airportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  airportGroupName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  comment?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payerProviderId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payerProviderName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rating?: InputMaybe<Array<Scalars['Int']['input']>>;
  ratingCreatedAt?: InputMaybe<Array<Scalars['String']['input']>>;
  ratingScore?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ratingTypeName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  servicerIataAirlineCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
  tripScheduled?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateRatingInput = {
  query: Array<RatingSearch>;
  value: UpdateRatingValuesInput;
};

export type UpdateRatingRemarkBulkInput = {
  updates: Array<UpdateRatingRemarkInput>;
};

export type UpdateRatingRemarkBulkResponse = {
  __typename?: 'UpdateRatingRemarkBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateRatingRemarkInput = {
  query: Array<RatingRemarkSearch>;
  value: UpdateRatingRemarkValuesInput;
};

export type UpdateRatingRemarkValuesInput = {
  ratingId?: InputMaybe<Array<Scalars['String']['input']>>;
  remark?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateRatingTypeBulkInput = {
  updates: Array<UpdateRatingTypeInput>;
};

export type UpdateRatingTypeBulkResponse = {
  __typename?: 'UpdateRatingTypeBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateRatingTypeInput = {
  query: Array<RatingTypeSearch>;
  value: UpdateRatingTypeValuesInput;
};

export type UpdateRatingTypeValuesInput = {
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateRatingValuesInput = {
  comment?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rating?: InputMaybe<Array<Scalars['Int']['input']>>;
  ratingScore?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  ratingTypeId?: InputMaybe<Array<Scalars['String']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateRemarksInput = {
  remarks: Array<RemarkInput>;
};

export type UpdateRemarksResponse = {
  __typename?: 'UpdateRemarksResponse';
  remarks: Array<UpdateResponse>;
};

export type UpdateResponse = {
  __typename?: 'UpdateResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type UpdateRoleBulkInput = {
  updates: Array<UpdateRoleInput>;
};

export type UpdateRoleBulkResponse = {
  __typename?: 'UpdateRoleBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateRoleInput = {
  query: Array<RoleSearch>;
  value: UpdateRoleValuesInput;
};

export type UpdateRoleValuesInput = {
  name?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateSettingsBulkInput = {
  updates: Array<UpdateSettingsInput>;
};

export type UpdateSettingsBulkResponse = {
  __typename?: 'UpdateSettingsBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateSettingsInput = {
  query: Array<SettingsSearch>;
  value: UpdateSettingsValuesInput;
};

export type UpdateSettingsValuesInput = {
  chatReadTime?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  crewChatReadTime?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  messageReadTime?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  outboundLateAlertMinutes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  passwordExpirationDays?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  vehicleTrackingVendor?: InputMaybe<Array<InputMaybe<SettingsVehicleTrackingVendorEnum>>>;
  vehicleTrackingVendorToken?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateSocialDistanceRuleBulkInput = {
  updates: Array<UpdateSocialDistanceRuleInput>;
};

export type UpdateSocialDistanceRuleBulkResponse = {
  __typename?: 'UpdateSocialDistanceRuleBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateSocialDistanceRuleInput = {
  query: Array<SocialDistanceRuleSearch>;
  value: UpdateSocialDistanceRuleValuesInput;
};

export type UpdateSocialDistanceRuleValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  contractId?: InputMaybe<Array<Scalars['String']['input']>>;
  max?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Array<InputMaybe<SocialDistanceRuleTypeEnum>>>;
};

export type UpdateStagedTripBulkInput = {
  updates: Array<UpdateStagedTripInput>;
};

export type UpdateStagedTripBulkResponse = {
  __typename?: 'UpdateStagedTripBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateStagedTripInput = {
  query: Array<StagedTripSearch>;
  value: UpdateStagedTripValuesInput;
};

export type UpdateStagedTripValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  attendants?: InputMaybe<Array<Scalars['Int']['input']>>;
  bufferMinutes?: InputMaybe<Array<Scalars['Int']['input']>>;
  combineId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  crewId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  doLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightNumber?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  fromManifest?: InputMaybe<Array<Scalars['Int']['input']>>;
  importId?: InputMaybe<Array<Scalars['String']['input']>>;
  importTime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  ingestAction?: InputMaybe<Array<StagedTripIngestActionEnum>>;
  kind?: InputMaybe<Array<StagedTripKindEnum>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  loopName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payerProviderId?: InputMaybe<Array<Scalars['String']['input']>>;
  pilots?: InputMaybe<Array<Scalars['Int']['input']>>;
  potentialTripId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  puLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduled?: InputMaybe<Array<Scalars['String']['input']>>;
  servicerIataAirlineCode?: InputMaybe<Array<Scalars['String']['input']>>;
  split?: InputMaybe<Array<Scalars['Int']['input']>>;
  statusName?: InputMaybe<Array<StagedTripStatusNameEnum>>;
  traceId?: InputMaybe<Array<Scalars['String']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
  typeName?: InputMaybe<Array<StagedTripTypeNameEnum>>;
};

export type UpdateStopBulkInput = {
  updates: Array<UpdateStopInput>;
};

export type UpdateStopBulkResponse = {
  __typename?: 'UpdateStopBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateStopInput = {
  query: Array<StopSearch>;
  value: UpdateStopValuesInput;
};

export type UpdateStopValuesInput = {
  actual?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  airportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  completed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationId?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduled?: InputMaybe<Array<Scalars['String']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<StopTypeEnum>>;
};

export type UpdateStorageBulkInput = {
  updates: Array<UpdateStorageInput>;
};

export type UpdateStorageBulkResponse = {
  __typename?: 'UpdateStorageBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateStorageInput = {
  query: Array<StorageSearch>;
  value: UpdateStorageValuesInput;
};

export type UpdateStorageValuesInput = {
  key?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  value?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateStrategy = {
  __typename?: 'UpdateStrategy';
  active: Scalars['Int']['output'];
  addonScheduledComparisonWindowMinutes?: Maybe<Scalars['Int']['output']>;
  addonStrategy: UpdateStrategyAddonStrategyEnum;
  addonType: UpdateStrategyAddonTypeEnum;
  contractId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  customAddonToleranceMinutes?: Maybe<Scalars['Int']['output']>;
  dailyStrategy: UpdateStrategyDailyStrategyEnum;
  id: Scalars['String']['output'];
  importNameIncludesHotels: Scalars['Int']['output'];
  manifestAutomationDeleteStrategy: UpdateStrategyManifestAutomationDeleteStrategyEnum;
  manifestStrategy: UpdateStrategyManifestStrategyEnum;
  previewTimeoutMinutes?: Maybe<Scalars['Int']['output']>;
  strategy: UpdateStrategyStrategyEnum;
  updateKindFromLocations: Scalars['Int']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type UpdateStrategyActivityConnection = {
  __typename?: 'UpdateStrategyActivityConnection';
  edges?: Maybe<Array<Maybe<UpdateStrategyActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UpdateStrategyActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type UpdateStrategyActivityEdge = {
  __typename?: 'UpdateStrategyActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export enum UpdateStrategyAddonStrategyEnum {
  Merge = 'MERGE',
  Replace = 'REPLACE',
  ReplaceIfGreater = 'REPLACE_IF_GREATER'
}

export type UpdateStrategyAddonStrategyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<UpdateStrategyAddonStrategyEnum>;
};

export enum UpdateStrategyAddonTypeEnum {
  Add = 'ADD',
  Sch = 'SCH',
  Spl = 'SPL'
}

export type UpdateStrategyAddonTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<UpdateStrategyAddonTypeEnum>;
};

export type UpdateStrategyConnection = {
  __typename?: 'UpdateStrategyConnection';
  edges?: Maybe<Array<Maybe<UpdateStrategyEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UpdateStrategyConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<UpdateStrategyMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<UpdateStrategySearch>>;
};

export enum UpdateStrategyDailyStrategyEnum {
  Merge = 'MERGE',
  Replace = 'REPLACE'
}

export type UpdateStrategyDailyStrategyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<UpdateStrategyDailyStrategyEnum>;
};

export type UpdateStrategyEdge = {
  __typename?: 'UpdateStrategyEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<UpdateStrategy>;
};

export enum UpdateStrategyManifestAutomationDeleteStrategyEnum {
  Cancel = 'CANCEL',
  SoftDelete = 'SOFT_DELETE'
}

export type UpdateStrategyManifestAutomationDeleteStrategyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<UpdateStrategyManifestAutomationDeleteStrategyEnum>;
};

export enum UpdateStrategyManifestStrategyEnum {
  Merge = 'MERGE',
  Replace = 'REPLACE'
}

export type UpdateStrategyManifestStrategyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<UpdateStrategyManifestStrategyEnum>;
};

export type UpdateStrategyMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  addonScheduledComparisonWindowMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  addonStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  addonType?: InputMaybe<Scalars['Boolean']['input']>;
  contractId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  customAddonToleranceMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  dailyStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  importNameIncludesHotels?: InputMaybe<Scalars['Boolean']['input']>;
  manifestAutomationDeleteStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  manifestStrategy?: InputMaybe<Scalars['Boolean']['input']>;
  previewTimeoutMinutes?: InputMaybe<Scalars['Boolean']['input']>;
  strategy?: InputMaybe<Scalars['Boolean']['input']>;
  updateKindFromLocations?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UpdateStrategySearch = {
  active?: InputMaybe<Array<IntSearch>>;
  addonScheduledComparisonWindowMinutes?: InputMaybe<Array<IntSearch>>;
  addonStrategy?: InputMaybe<Array<UpdateStrategyAddonStrategyEnumSearch>>;
  addonType?: InputMaybe<Array<UpdateStrategyAddonTypeEnumSearch>>;
  contractId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  customAddonToleranceMinutes?: InputMaybe<Array<IntSearch>>;
  dailyStrategy?: InputMaybe<Array<UpdateStrategyDailyStrategyEnumSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  importNameIncludesHotels?: InputMaybe<Array<IntSearch>>;
  manifestAutomationDeleteStrategy?: InputMaybe<Array<UpdateStrategyManifestAutomationDeleteStrategyEnumSearch>>;
  manifestStrategy?: InputMaybe<Array<UpdateStrategyManifestStrategyEnumSearch>>;
  previewTimeoutMinutes?: InputMaybe<Array<IntSearch>>;
  strategy?: InputMaybe<Array<UpdateStrategyStrategyEnumSearch>>;
  updateKindFromLocations?: InputMaybe<Array<IntSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export enum UpdateStrategyStrategyEnum {
  Merge = 'MERGE',
  Replace = 'REPLACE'
}

export type UpdateStrategyStrategyEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<UpdateStrategyStrategyEnum>;
};

export type UpdateTimeFrameBulkInput = {
  updates: Array<UpdateTimeFrameInput>;
};

export type UpdateTimeFrameBulkResponse = {
  __typename?: 'UpdateTimeFrameBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateTimeFrameInput = {
  query: Array<TimeFrameSearch>;
  value: UpdateTimeFrameValuesInput;
};

export type UpdateTimeFrameRangeBulkInput = {
  updates: Array<UpdateTimeFrameRangeInput>;
};

export type UpdateTimeFrameRangeBulkResponse = {
  __typename?: 'UpdateTimeFrameRangeBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateTimeFrameRangeInput = {
  query: Array<TimeFrameRangeSearch>;
  value: UpdateTimeFrameRangeValuesInput;
};

export type UpdateTimeFrameRangeValuesInput = {
  endTime?: InputMaybe<Array<Scalars['String']['input']>>;
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  startTime?: InputMaybe<Array<Scalars['String']['input']>>;
  timeFrameId?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateTimeFrameValuesInput = {
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateTrackFlightBulkInput = {
  updates: Array<UpdateTrackFlightInput>;
};

export type UpdateTrackFlightBulkResponse = {
  __typename?: 'UpdateTrackFlightBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateTrackFlightInput = {
  query: Array<TrackFlightSearch>;
  value: UpdateTrackFlightValuesInput;
};

export type UpdateTrackFlightValuesInput = {
  actual?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  arrivalGate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  arrivalTerminal?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  arrivalTimezone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  arrivalUtcOffsetHours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departureGate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departureTerminal?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departureTimezone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  departureUtcOffsetHours?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightHistoryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  label?: InputMaybe<Array<InputMaybe<TrackFlightLabelEnum>>>;
  landedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastPingTime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastWebhookReceivedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nextPingTime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  number?: InputMaybe<Array<Scalars['Int']['input']>>;
  raw?: InputMaybe<Array<Scalars['String']['input']>>;
  scheduled?: InputMaybe<Array<Scalars['String']['input']>>;
  servicerIataAirlineCode?: InputMaybe<Array<Scalars['String']['input']>>;
  status?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trackerProvider?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<InputMaybe<TrackFlightTypeEnum>>>;
};

export type UpdateTrainingUserCacheBulkInput = {
  updates: Array<UpdateTrainingUserCacheInput>;
};

export type UpdateTrainingUserCacheBulkResponse = {
  __typename?: 'UpdateTrainingUserCacheBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateTrainingUserCacheInput = {
  query: Array<TrainingUserCacheSearch>;
  value: UpdateTrainingUserCacheValuesInput;
};

export type UpdateTrainingUserCacheValuesInput = {
  firstName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Array<Scalars['String']['input']>>;
  primaryAirportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateTripBulkInput = {
  updates: Array<UpdateTripInput>;
};

export type UpdateTripBulkResponse = {
  __typename?: 'UpdateTripBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateTripDocumentBulkInput = {
  updates: Array<UpdateTripDocumentInput>;
};

export type UpdateTripDocumentBulkResponse = {
  __typename?: 'UpdateTripDocumentBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateTripDocumentInput = {
  query: Array<TripDocumentSearch>;
  value: UpdateTripDocumentValuesInput;
};

export type UpdateTripDocumentValuesInput = {
  contentType?: InputMaybe<Array<Scalars['String']['input']>>;
  fileLocation?: InputMaybe<Array<Scalars['String']['input']>>;
  fileSize?: InputMaybe<Array<Scalars['Int']['input']>>;
  filename?: InputMaybe<Array<Scalars['String']['input']>>;
  md5?: InputMaybe<Array<Scalars['String']['input']>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateTripHasImportBulkInput = {
  updates: Array<UpdateTripHasImportInput>;
};

export type UpdateTripHasImportBulkResponse = {
  __typename?: 'UpdateTripHasImportBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateTripHasImportInput = {
  query: Array<TripHasImportSearch>;
  value: UpdateTripHasImportValuesInput;
};

export type UpdateTripHasImportValuesInput = {
  importId?: InputMaybe<Array<Scalars['String']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateTripInput = {
  query: Array<TripSearch>;
  value: UpdateTripValuesInput;
};

export type UpdateTripScheduleTriggerBulkInput = {
  updates: Array<UpdateTripScheduleTriggerInput>;
};

export type UpdateTripScheduleTriggerBulkResponse = {
  __typename?: 'UpdateTripScheduleTriggerBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateTripScheduleTriggerInput = {
  query: Array<TripScheduleTriggerSearch>;
  value: UpdateTripScheduleTriggerValuesInput;
};

export type UpdateTripScheduleTriggerValuesInput = {
  accidentIssueCount?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  communicationCount?: InputMaybe<Array<Scalars['Int']['input']>>;
  completionTypeDisplayName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  dispatchIssueCount?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  doLocationAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doLocationCityName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doLocationCoordinates?: InputMaybe<Array<InputMaybe<PointInput>>>;
  doLocationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doLocationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doLocationPhoneNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doLocationStateCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doLocationZipCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverAvatar?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverEmployeeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverEtaDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverEtaId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverEtaMinutes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  driverFirstName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverLastName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  fcrCount?: InputMaybe<Array<Scalars['Int']['input']>>;
  flagColors?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasPaperwork?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  incidentIssueCount?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  latestScheduled?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  latestScheduledUtc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  latestTriggerUsed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lostAndFoundIssueCount?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  payerProviderDisplayName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  payerProviderId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  puLocationAddress?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  puLocationCityName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  puLocationCoordinates?: InputMaybe<Array<InputMaybe<PointInput>>>;
  puLocationId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  puLocationName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  puLocationPhoneNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  puLocationStateCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  puLocationZipCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduledUtc?: InputMaybe<Array<Scalars['String']['input']>>;
  stopCount?: InputMaybe<Array<Scalars['Int']['input']>>;
  tripId?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleCapacity?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  vehicleId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleMake?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModel?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehiclePhoneNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleTrackingId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateTripValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  attendants?: InputMaybe<Array<Scalars['Int']['input']>>;
  combineId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  combineType?: InputMaybe<Array<InputMaybe<TripCombineTypeEnum>>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  completionId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  crewId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  curbsideAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doActualDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doAirportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  doLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  driverCrewCount?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  driverId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  etaMinutes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  firstName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  flightNumber?: InputMaybe<Array<Scalars['Int']['input']>>;
  fromManifest?: InputMaybe<Array<Scalars['Int']['input']>>;
  importTime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isIllegalCombine?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  kind?: InputMaybe<Array<TripKindEnum>>;
  lastName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  legacyId?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  loopName?: InputMaybe<Array<Scalars['String']['input']>>;
  manifestImportId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  offset?: InputMaybe<Array<Scalars['String']['input']>>;
  payerProviderId?: InputMaybe<Array<Scalars['String']['input']>>;
  pilots?: InputMaybe<Array<Scalars['Int']['input']>>;
  plannedAt?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId?: InputMaybe<Array<Scalars['String']['input']>>;
  puActualDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  puCompletedDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  puGpsDatetime?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  puLocationId?: InputMaybe<Array<Scalars['String']['input']>>;
  rateHistoryId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  rateId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  scheduled?: InputMaybe<Array<Scalars['String']['input']>>;
  servicerIataAirlineCode?: InputMaybe<Array<Scalars['String']['input']>>;
  split?: InputMaybe<Array<Scalars['Int']['input']>>;
  status?: InputMaybe<Array<TripStatusEnum>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  trackFlightId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<Array<TripTypeEnum>>;
  vehicleId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateUpdateStrategyBulkInput = {
  updates: Array<UpdateUpdateStrategyInput>;
};

export type UpdateUpdateStrategyBulkResponse = {
  __typename?: 'UpdateUpdateStrategyBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateUpdateStrategyInput = {
  query: Array<UpdateStrategySearch>;
  value: UpdateUpdateStrategyValuesInput;
};

export type UpdateUpdateStrategyValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  addonScheduledComparisonWindowMinutes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  addonStrategy?: InputMaybe<Array<UpdateStrategyAddonStrategyEnum>>;
  addonType?: InputMaybe<Array<UpdateStrategyAddonTypeEnum>>;
  contractId?: InputMaybe<Array<Scalars['String']['input']>>;
  customAddonToleranceMinutes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dailyStrategy?: InputMaybe<Array<UpdateStrategyDailyStrategyEnum>>;
  importNameIncludesHotels?: InputMaybe<Array<Scalars['Int']['input']>>;
  manifestAutomationDeleteStrategy?: InputMaybe<Array<UpdateStrategyManifestAutomationDeleteStrategyEnum>>;
  manifestStrategy?: InputMaybe<Array<UpdateStrategyManifestStrategyEnum>>;
  previewTimeoutMinutes?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  strategy?: InputMaybe<Array<UpdateStrategyStrategyEnum>>;
  updateKindFromLocations?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type UpdateUserActivationBulkInput = {
  users: Array<UpdateUserActivationInput>;
};

export type UpdateUserActivationBulkResponse = {
  __typename?: 'UpdateUserActivationBulkResponse';
  response: Array<UpdateUserActivationResponse>;
  tripsUpdated: Scalars['Int']['output'];
  usersUpdated: Scalars['Int']['output'];
};

export type UpdateUserActivationInput = {
  action: UserActivationActionEnum;
  userId: Scalars['String']['input'];
};

export type UpdateUserActivationResponse = {
  __typename?: 'UpdateUserActivationResponse';
  active: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type UpdateUserAvailabilityBulkInput = {
  updates: Array<UpdateUserAvailabilityInput>;
};

export type UpdateUserAvailabilityBulkResponse = {
  __typename?: 'UpdateUserAvailabilityBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateUserAvailabilityDriverAppInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  value: UpdateUserAvailabilityValuesInput;
};

export type UpdateUserAvailabilityDriverAppResponse = {
  __typename?: 'UpdateUserAvailabilityDriverAppResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type UpdateUserAvailabilityInput = {
  query: Array<UserAvailabilitySearch>;
  value: UpdateUserAvailabilityValuesInput;
};

export type UpdateUserAvailabilitySeriesDriverAppInput = {
  ids?: InputMaybe<Array<Scalars['String']['input']>>;
  value: UpdateUserAvailabilityValuesInput;
};

export type UpdateUserAvailabilitySeriesDriverAppResponse = {
  __typename?: 'UpdateUserAvailabilitySeriesDriverAppResponse';
  error?: Maybe<Error>;
  updated: Scalars['Int']['output'];
};

export type UpdateUserAvailabilityValuesInput = {
  approved?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dayOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDate?: InputMaybe<Array<Scalars['String']['input']>>;
  endTime?: InputMaybe<Array<Scalars['String']['input']>>;
  reason?: InputMaybe<Array<Scalars['String']['input']>>;
  repeatUntil?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  reviewedBy?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startDate?: InputMaybe<Array<Scalars['String']['input']>>;
  startTime?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<UserAvailabilityTypeEnum>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateUserBulkInput = {
  updates: Array<UpdateUserInput>;
};

export type UpdateUserBulkResponse = {
  __typename?: 'UpdateUserBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateUserCacheBulkInput = {
  updates: Array<UpdateUserCacheInput>;
};

export type UpdateUserCacheBulkResponse = {
  __typename?: 'UpdateUserCacheBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateUserCacheInput = {
  query: Array<UserCacheSearch>;
  value: UpdateUserCacheValuesInput;
};

export type UpdateUserCacheValuesInput = {
  employeeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastName?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateUserHasAirportBulkInput = {
  updates: Array<UpdateUserHasAirportInput>;
};

export type UpdateUserHasAirportBulkResponse = {
  __typename?: 'UpdateUserHasAirportBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateUserHasAirportInput = {
  query: Array<UserHasAirportSearch>;
  value: UpdateUserHasAirportValuesInput;
};

export type UpdateUserHasAirportValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  userId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateUserInput = {
  query: Array<UserSearch>;
  value: UpdateUserValuesInput;
};

export type UpdateUserValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  address?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  avatar?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cityName?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  countryCode?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  dob?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email?: InputMaybe<Array<Scalars['String']['input']>>;
  employeeId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  firstName?: InputMaybe<Array<Scalars['String']['input']>>;
  lastLogin?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastLoginOffset?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastLoginTimezone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastLoginUtc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lastName?: InputMaybe<Array<Scalars['String']['input']>>;
  longTrip?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  password?: InputMaybe<Array<Scalars['String']['input']>>;
  phone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  primaryAirportCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  providerId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resetClientIp?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resetCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  resetCreatedAtUtc?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  roleId?: InputMaybe<Array<Scalars['String']['input']>>;
  startDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stateCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  traceId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  username?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  zipCode?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UpdateVariableTimeBulkInput = {
  updates: Array<UpdateVariableTimeInput>;
};

export type UpdateVariableTimeBulkResponse = {
  __typename?: 'UpdateVariableTimeBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateVariableTimeInput = {
  query: Array<VariableTimeSearch>;
  value: UpdateVariableTimeValuesInput;
};

export type UpdateVariableTimeValuesInput = {
  airportCode?: InputMaybe<Array<Scalars['String']['input']>>;
  companyId?: InputMaybe<Array<Scalars['String']['input']>>;
  inboundDomestic?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  inboundInternational?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  outbound?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  servicerIataAirlineCode?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateVehicleBulkInput = {
  updates: Array<UpdateVehicleInput>;
};

export type UpdateVehicleBulkResponse = {
  __typename?: 'UpdateVehicleBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateVehicleInput = {
  query: Array<VehicleSearch>;
  value: UpdateVehicleValuesInput;
};

export type UpdateVehicleValuesInput = {
  active?: InputMaybe<Array<Scalars['Int']['input']>>;
  airportPermitExpirationDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  capacity?: InputMaybe<Array<Scalars['Int']['input']>>;
  emissionPermitExpirationDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  licensePlate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  locationId?: InputMaybe<Array<Scalars['String']['input']>>;
  make?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  model?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  phoneNumber?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  registrationExpirationDate?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  stateRegistered?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tollTag?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  tracker?: InputMaybe<Array<VehicleTrackerEnum>>;
  trackingId?: InputMaybe<Array<Scalars['String']['input']>>;
  vin?: InputMaybe<Array<Scalars['String']['input']>>;
  year?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
};

export type UpdateWidgetBulkInput = {
  updates: Array<UpdateWidgetInput>;
};

export type UpdateWidgetBulkResponse = {
  __typename?: 'UpdateWidgetBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateWidgetFilterBulkInput = {
  updates: Array<UpdateWidgetFilterInput>;
};

export type UpdateWidgetFilterBulkResponse = {
  __typename?: 'UpdateWidgetFilterBulkResponse';
  response: Array<UpdateResponse>;
};

export type UpdateWidgetFilterInput = {
  query: Array<WidgetFilterSearch>;
  value: UpdateWidgetFilterValuesInput;
};

export type UpdateWidgetFilterValuesInput = {
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  value?: InputMaybe<Array<Scalars['String']['input']>>;
  widgetId?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UpdateWidgetInput = {
  query: Array<WidgetSearch>;
  value: UpdateWidgetValuesInput;
};

export type UpdateWidgetValuesInput = {
  dashboardId?: InputMaybe<Array<Scalars['String']['input']>>;
  height?: InputMaybe<Array<Scalars['Int']['input']>>;
  positionX?: InputMaybe<Array<Scalars['Int']['input']>>;
  positionY?: InputMaybe<Array<Scalars['Int']['input']>>;
  type?: InputMaybe<Array<Scalars['String']['input']>>;
  width?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type User = Node & {
  __typename?: 'User';
  active: Scalars['Int']['output'];
  address?: Maybe<Scalars['String']['output']>;
  airportCodes?: Maybe<Array<AirportHasUser>>;
  airports?: Maybe<Array<Scalars['String']['output']>>;
  availability?: Maybe<Array<UserAvailability>>;
  avatar?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  countryCode?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  fullName?: Maybe<Scalars['String']['output']>;
  groups?: Maybe<Array<Group>>;
  id: Scalars['ID']['output'];
  lastLogin?: Maybe<Scalars['String']['output']>;
  lastLoginOffset?: Maybe<Scalars['String']['output']>;
  lastLoginTimezone?: Maybe<Scalars['String']['output']>;
  lastLoginUtc?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  licenses?: Maybe<Array<License>>;
  longTrip?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  performance?: Maybe<DriverPerformance>;
  phone?: Maybe<Scalars['String']['output']>;
  primaryAirportCode?: Maybe<Scalars['String']['output']>;
  provider?: Maybe<Provider>;
  providerId?: Maybe<Scalars['String']['output']>;
  ratingDetails?: Maybe<RatingDetails>;
  ratings?: Maybe<RatingConnection>;
  resetClientIp?: Maybe<Scalars['String']['output']>;
  resetCode?: Maybe<Scalars['String']['output']>;
  resetCreatedAtUtc?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Role>;
  roleId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  tripDetails?: Maybe<TripDetails>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
  vehicleId?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};


export type UserPerformanceArgs = {
  input?: InputMaybe<DriverPerformanceSearchInput>;
};


export type UserRatingDetailsArgs = {
  input?: InputMaybe<RatingConnectionInput>;
};


export type UserRatingsArgs = {
  input?: InputMaybe<RatingConnectionInput>;
};

export enum UserActivationActionEnum {
  Activate = 'ACTIVATE',
  Deactivate = 'DEACTIVATE'
}

export type UserActivityConnection = {
  __typename?: 'UserActivityConnection';
  edges?: Maybe<Array<Maybe<UserActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type UserActivityEdge = {
  __typename?: 'UserActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type UserAvailability = {
  __typename?: 'UserAvailability';
  approved?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dayOfWeek: Scalars['Int']['output'];
  endDate: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  repeatUntil?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  type: UserAvailabilityTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type UserAvailabilityActivityConnection = {
  __typename?: 'UserAvailabilityActivityConnection';
  edges?: Maybe<Array<Maybe<UserAvailabilityActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAvailabilityActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type UserAvailabilityActivityEdge = {
  __typename?: 'UserAvailabilityActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type UserAvailabilityConnection = {
  __typename?: 'UserAvailabilityConnection';
  edges?: Maybe<Array<Maybe<UserAvailabilityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAvailabilityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<UserAvailabilityMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<UserAvailabilitySearch>>;
};

export type UserAvailabilityEdge = {
  __typename?: 'UserAvailabilityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<UserAvailability>;
};

export type UserAvailabilityMaskInput = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['Boolean']['input']>;
  repeatUntil?: InputMaybe<Scalars['Boolean']['input']>;
  reviewedBy?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAvailabilitySearch = {
  approved?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  dayOfWeek?: InputMaybe<Array<IntSearch>>;
  endDate?: InputMaybe<Array<StringSearch>>;
  endTime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  reason?: InputMaybe<Array<StringSearch>>;
  repeatUntil?: InputMaybe<Array<StringSearch>>;
  reviewedBy?: InputMaybe<Array<StringSearch>>;
  startDate?: InputMaybe<Array<StringSearch>>;
  startTime?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<UserAvailabilityTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export enum UserAvailabilityTypeEnum {
  Off = 'OFF',
  On = 'ON'
}

export type UserAvailabilityTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<UserAvailabilityTypeEnum>;
};

export type UserAvailabilityWithDatetimes = {
  __typename?: 'UserAvailabilityWithDatetimes';
  approved?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dayOfWeek: Scalars['Int']['output'];
  endDate: Scalars['String']['output'];
  endDatetime: Scalars['String']['output'];
  endTime: Scalars['String']['output'];
  id: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  repeatUntil?: Maybe<Scalars['String']['output']>;
  reviewedBy?: Maybe<Scalars['String']['output']>;
  startDate: Scalars['String']['output'];
  startDatetime: Scalars['String']['output'];
  startTime: Scalars['String']['output'];
  type: UserAvailabilityWithDatetimesTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
};

export type UserAvailabilityWithDatetimesActivityConnection = {
  __typename?: 'UserAvailabilityWithDatetimesActivityConnection';
  edges?: Maybe<Array<Maybe<UserAvailabilityWithDatetimesActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAvailabilityWithDatetimesActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type UserAvailabilityWithDatetimesActivityEdge = {
  __typename?: 'UserAvailabilityWithDatetimesActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type UserAvailabilityWithDatetimesConnection = {
  __typename?: 'UserAvailabilityWithDatetimesConnection';
  edges?: Maybe<Array<Maybe<UserAvailabilityWithDatetimesEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserAvailabilityWithDatetimesConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<UserAvailabilityWithDatetimesMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<UserAvailabilityWithDatetimesSearch>>;
};

export type UserAvailabilityWithDatetimesEdge = {
  __typename?: 'UserAvailabilityWithDatetimesEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<UserAvailabilityWithDatetimes>;
};

export type UserAvailabilityWithDatetimesMaskInput = {
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Boolean']['input']>;
  endDate?: InputMaybe<Scalars['Boolean']['input']>;
  endDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  endTime?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  reason?: InputMaybe<Scalars['Boolean']['input']>;
  repeatUntil?: InputMaybe<Scalars['Boolean']['input']>;
  reviewedBy?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Boolean']['input']>;
  startDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  startTime?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserAvailabilityWithDatetimesSearch = {
  approved?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  dayOfWeek?: InputMaybe<Array<IntSearch>>;
  endDate?: InputMaybe<Array<StringSearch>>;
  endDatetime?: InputMaybe<Array<StringSearch>>;
  endTime?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  reason?: InputMaybe<Array<StringSearch>>;
  repeatUntil?: InputMaybe<Array<StringSearch>>;
  reviewedBy?: InputMaybe<Array<StringSearch>>;
  startDate?: InputMaybe<Array<StringSearch>>;
  startDatetime?: InputMaybe<Array<StringSearch>>;
  startTime?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<UserAvailabilityWithDatetimesTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export enum UserAvailabilityWithDatetimesTypeEnum {
  Off = 'OFF',
  On = 'ON'
}

export type UserAvailabilityWithDatetimesTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<UserAvailabilityWithDatetimesTypeEnum>;
};

export type UserCache = {
  __typename?: 'UserCache';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type UserCacheActivityConnection = {
  __typename?: 'UserCacheActivityConnection';
  edges?: Maybe<Array<Maybe<UserCacheActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserCacheActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type UserCacheActivityEdge = {
  __typename?: 'UserCacheActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type UserCacheConnection = {
  __typename?: 'UserCacheConnection';
  edges?: Maybe<Array<Maybe<UserCacheEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserCacheConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<UserCacheMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<UserCacheSearch>>;
};

export type UserCacheEdge = {
  __typename?: 'UserCacheEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<UserCache>;
};

export type UserCacheMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserCacheSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  employeeId?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type UserConfig = {
  __typename?: 'UserConfig';
  homepage?: Maybe<Scalars['String']['output']>;
  menus?: Maybe<UserConfigMenu>;
  permissions?: Maybe<Array<UserConfigPermissions>>;
};

export type UserConfigMenu = {
  __typename?: 'UserConfigMenu';
  navigation?: Maybe<Array<UserConfigNavigation>>;
  shortcuts?: Maybe<Array<UserConfigShortcut>>;
};

export type UserConfigNavigation = {
  __typename?: 'UserConfigNavigation';
  icon: Scalars['String']['output'];
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UserConfigPermissions = {
  __typename?: 'UserConfigPermissions';
  resource: Scalars['String']['output'];
  sections: Array<UserConfigSection>;
};

export type UserConfigSection = {
  __typename?: 'UserConfigSection';
  columns: Array<UserConfigTableColumns>;
  filters: Array<UserConfigTableFilters>;
  name: Scalars['String']['output'];
  type: UserConfigSectionTypeEnum;
};

export enum UserConfigSectionTypeEnum {
  Table = 'TABLE'
}

export type UserConfigShortcut = {
  __typename?: 'UserConfigShortcut';
  icon: Scalars['String']['output'];
  label: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export type UserConfigTableColumns = {
  __typename?: 'UserConfigTableColumns';
  allowView: Scalars['Boolean']['output'];
  name: AirlineTripsTableColumnsEnum;
};

export type UserConfigTableFilters = {
  __typename?: 'UserConfigTableFilters';
  allowView: Scalars['Boolean']['output'];
  name: AirlineTripsTableColumnsEnum;
};

export type UserConnection = {
  __typename?: 'UserConnection';
  edges?: Maybe<Array<Maybe<UserEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<UserMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<UserSearch>>;
};

export type UserEdge = {
  __typename?: 'UserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<User>;
};

export type UserHasAirport = {
  __typename?: 'UserHasAirport';
  airportCode: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type UserHasAirportActivityConnection = {
  __typename?: 'UserHasAirportActivityConnection';
  edges?: Maybe<Array<Maybe<UserHasAirportActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasAirportActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type UserHasAirportActivityEdge = {
  __typename?: 'UserHasAirportActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type UserHasAirportConnection = {
  __typename?: 'UserHasAirportConnection';
  edges?: Maybe<Array<Maybe<UserHasAirportEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserHasAirportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<UserHasAirportMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<UserHasAirportSearch>>;
};

export type UserHasAirportEdge = {
  __typename?: 'UserHasAirportEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<UserHasAirport>;
};

export type UserHasAirportMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserHasAirportSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  userId?: InputMaybe<Array<StringSearch>>;
};

export type UserInput = {
  active: Scalars['Boolean']['input'];
  address?: InputMaybe<Scalars['String']['input']>;
  avatar?: InputMaybe<Scalars['String']['input']>;
  averageRating?: InputMaybe<Scalars['Float']['input']>;
  companyId: Scalars['String']['input'];
  countryCode?: InputMaybe<Scalars['Int']['input']>;
  dob?: InputMaybe<Scalars['String']['input']>;
  driverSinceDate?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  employeeId?: InputMaybe<Scalars['String']['input']>;
  first: Scalars['String']['input'];
  id?: InputMaybe<Scalars['ID']['input']>;
  last: Scalars['String']['input'];
  onTimePercentage?: InputMaybe<Scalars['Float']['input']>;
  password: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  roleId: Scalars['String']['input'];
  timezone?: InputMaybe<Scalars['String']['input']>;
  totalAmountOfTrips?: InputMaybe<Scalars['Int']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
};

export type UserMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginOffset?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginUtc?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  longTrip?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  resetClientIp?: InputMaybe<Scalars['Boolean']['input']>;
  resetCode?: InputMaybe<Scalars['Boolean']['input']>;
  resetCreatedAtUtc?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  address?: InputMaybe<Array<StringSearch>>;
  avatar?: InputMaybe<Array<StringSearch>>;
  cityName?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  countryCode?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  dob?: InputMaybe<Array<StringSearch>>;
  email?: InputMaybe<Array<StringSearch>>;
  employeeId?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  lastLogin?: InputMaybe<Array<StringSearch>>;
  lastLoginOffset?: InputMaybe<Array<StringSearch>>;
  lastLoginTimezone?: InputMaybe<Array<StringSearch>>;
  lastLoginUtc?: InputMaybe<Array<StringSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  longTrip?: InputMaybe<Array<IntSearch>>;
  notes?: InputMaybe<Array<StringSearch>>;
  password?: InputMaybe<Array<StringSearch>>;
  phone?: InputMaybe<Array<StringSearch>>;
  primaryAirportCode?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  resetClientIp?: InputMaybe<Array<StringSearch>>;
  resetCode?: InputMaybe<Array<StringSearch>>;
  resetCreatedAtUtc?: InputMaybe<Array<StringSearch>>;
  roleId?: InputMaybe<Array<StringSearch>>;
  startDate?: InputMaybe<Array<StringSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  timezone?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  username?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  zipCode?: InputMaybe<Array<StringSearch>>;
};

export type UserWithAirportAppendAvailabilityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  airportCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  availabilityQuery?: InputMaybe<Array<UserAvailabilityWithDatetimesSearch>>;
  endDatetime: Scalars['String']['input'];
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<UserSearch>>;
  sortDate?: InputMaybe<Scalars['String']['input']>;
  startDatetime: Scalars['String']['input'];
};

export type UserWithAirportConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  airports: Array<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<UserSearch>>;
};

export type UserWithAvailabilityAndPermissions = {
  __typename?: 'UserWithAvailabilityAndPermissions';
  active: Scalars['Int']['output'];
  address?: Maybe<Scalars['String']['output']>;
  approved?: Maybe<Scalars['Int']['output']>;
  availabilityEndDate: Scalars['String']['output'];
  availabilityEndDatetime: Scalars['String']['output'];
  availabilityEndTime: Scalars['String']['output'];
  availabilityId: Scalars['String']['output'];
  availabilityStartDate: Scalars['String']['output'];
  availabilityStartDatetime: Scalars['String']['output'];
  availabilityStartTime: Scalars['String']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  countryCode?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dayOfWeek: Scalars['Int']['output'];
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  effect: UserWithAvailabilityAndPermissionsEffectEnum;
  email: Scalars['String']['output'];
  employeeId?: Maybe<Scalars['String']['output']>;
  entity: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastLogin?: Maybe<Scalars['String']['output']>;
  lastLoginOffset?: Maybe<Scalars['String']['output']>;
  lastLoginTimezone?: Maybe<Scalars['String']['output']>;
  lastLoginUtc?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  longTrip?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  permissionId: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  primaryAirportCode?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  repeatUntil?: Maybe<Scalars['String']['output']>;
  resetClientIp?: Maybe<Scalars['String']['output']>;
  resetCode?: Maybe<Scalars['String']['output']>;
  resetCreatedAtUtc?: Maybe<Scalars['String']['output']>;
  resource: Scalars['String']['output'];
  roleId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  type: UserWithAvailabilityAndPermissionsTypeEnum;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
  vehicleId?: Maybe<Scalars['String']['output']>;
  verb: Scalars['String']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type UserWithAvailabilityAndPermissionsActivityConnection = {
  __typename?: 'UserWithAvailabilityAndPermissionsActivityConnection';
  edges?: Maybe<Array<Maybe<UserWithAvailabilityAndPermissionsActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserWithAvailabilityAndPermissionsActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type UserWithAvailabilityAndPermissionsActivityEdge = {
  __typename?: 'UserWithAvailabilityAndPermissionsActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type UserWithAvailabilityAndPermissionsConnection = {
  __typename?: 'UserWithAvailabilityAndPermissionsConnection';
  edges?: Maybe<Array<Maybe<UserWithAvailabilityAndPermissionsEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserWithAvailabilityAndPermissionsConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<UserWithAvailabilityAndPermissionsMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<UserWithAvailabilityAndPermissionsSearch>>;
};

export type UserWithAvailabilityAndPermissionsEdge = {
  __typename?: 'UserWithAvailabilityAndPermissionsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<UserWithAvailabilityAndPermissions>;
};

export enum UserWithAvailabilityAndPermissionsEffectEnum {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export type UserWithAvailabilityAndPermissionsEffectEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<UserWithAvailabilityAndPermissionsEffectEnum>;
};

export type UserWithAvailabilityAndPermissionsGroupByUser = {
  __typename?: 'UserWithAvailabilityAndPermissionsGroupByUser';
  availability?: Maybe<Array<UserAvailability>>;
  permissions?: Maybe<Array<Permission>>;
  user?: Maybe<UserWithAvailabilityAndPermissions>;
};

export type UserWithAvailabilityAndPermissionsGroupByUserConnection = {
  __typename?: 'UserWithAvailabilityAndPermissionsGroupByUserConnection';
  edges?: Maybe<Array<Maybe<UserWithAvailabilityAndPermissionsGroupByUserEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserWithAvailabilityAndPermissionsGroupByUserConnectionInput = {
  endDatetime?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<UserWithAvailabilityAndPermissionsConnectionInput>;
  sortDate?: InputMaybe<Scalars['String']['input']>;
  startDatetime?: InputMaybe<Scalars['String']['input']>;
};

export type UserWithAvailabilityAndPermissionsGroupByUserEdge = {
  __typename?: 'UserWithAvailabilityAndPermissionsGroupByUserEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<UserWithAvailabilityAndPermissionsGroupByUser>;
};

export type UserWithAvailabilityAndPermissionsMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['Boolean']['input']>;
  approved?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityEndDate?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityEndDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityEndTime?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityId?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityStartDate?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityStartDatetime?: InputMaybe<Scalars['Boolean']['input']>;
  availabilityStartTime?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  dayOfWeek?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['Boolean']['input']>;
  effect?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Boolean']['input']>;
  entity?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginOffset?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginUtc?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  longTrip?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['Boolean']['input']>;
  permissionId?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  repeatUntil?: InputMaybe<Scalars['Boolean']['input']>;
  resetClientIp?: InputMaybe<Scalars['Boolean']['input']>;
  resetCode?: InputMaybe<Scalars['Boolean']['input']>;
  resetCreatedAtUtc?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  verb?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserWithAvailabilityAndPermissionsSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  address?: InputMaybe<Array<StringSearch>>;
  approved?: InputMaybe<Array<IntSearch>>;
  availabilityEndDate?: InputMaybe<Array<StringSearch>>;
  availabilityEndDatetime?: InputMaybe<Array<StringSearch>>;
  availabilityEndTime?: InputMaybe<Array<StringSearch>>;
  availabilityId?: InputMaybe<Array<StringSearch>>;
  availabilityStartDate?: InputMaybe<Array<StringSearch>>;
  availabilityStartDatetime?: InputMaybe<Array<StringSearch>>;
  availabilityStartTime?: InputMaybe<Array<StringSearch>>;
  avatar?: InputMaybe<Array<StringSearch>>;
  cityName?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  countryCode?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  dayOfWeek?: InputMaybe<Array<IntSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  dob?: InputMaybe<Array<StringSearch>>;
  effect?: InputMaybe<Array<UserWithAvailabilityAndPermissionsEffectEnumSearch>>;
  email?: InputMaybe<Array<StringSearch>>;
  employeeId?: InputMaybe<Array<StringSearch>>;
  entity?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  lastLogin?: InputMaybe<Array<StringSearch>>;
  lastLoginOffset?: InputMaybe<Array<StringSearch>>;
  lastLoginTimezone?: InputMaybe<Array<StringSearch>>;
  lastLoginUtc?: InputMaybe<Array<StringSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  longTrip?: InputMaybe<Array<IntSearch>>;
  notes?: InputMaybe<Array<StringSearch>>;
  password?: InputMaybe<Array<StringSearch>>;
  permissionId?: InputMaybe<Array<StringSearch>>;
  phone?: InputMaybe<Array<StringSearch>>;
  primaryAirportCode?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  repeatUntil?: InputMaybe<Array<StringSearch>>;
  resetClientIp?: InputMaybe<Array<StringSearch>>;
  resetCode?: InputMaybe<Array<StringSearch>>;
  resetCreatedAtUtc?: InputMaybe<Array<StringSearch>>;
  resource?: InputMaybe<Array<StringSearch>>;
  roleId?: InputMaybe<Array<StringSearch>>;
  startDate?: InputMaybe<Array<StringSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  timezone?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  type?: InputMaybe<Array<UserWithAvailabilityAndPermissionsTypeEnumSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  username?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  verb?: InputMaybe<Array<StringSearch>>;
  zipCode?: InputMaybe<Array<StringSearch>>;
};

export enum UserWithAvailabilityAndPermissionsTypeEnum {
  Off = 'OFF',
  On = 'ON'
}

export type UserWithAvailabilityAndPermissionsTypeEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<UserWithAvailabilityAndPermissionsTypeEnum>;
};

export type UserWithMarket = {
  __typename?: 'UserWithMarket';
  active: Scalars['Int']['output'];
  address?: Maybe<Scalars['String']['output']>;
  airportCodes: Scalars['String']['output'];
  avatar?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  countryCode?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  employeeId?: Maybe<Scalars['String']['output']>;
  firstName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastLogin?: Maybe<Scalars['String']['output']>;
  lastLoginOffset?: Maybe<Scalars['String']['output']>;
  lastLoginTimezone?: Maybe<Scalars['String']['output']>;
  lastLoginUtc?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  longTrip?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  primaryAirportCode?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  resetClientIp?: Maybe<Scalars['String']['output']>;
  resetCode?: Maybe<Scalars['String']['output']>;
  resetCreatedAtUtc?: Maybe<Scalars['String']['output']>;
  roleId: Scalars['String']['output'];
  roleName: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
  vehicleId?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type UserWithMarketActivityConnection = {
  __typename?: 'UserWithMarketActivityConnection';
  edges?: Maybe<Array<Maybe<UserWithMarketActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserWithMarketActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type UserWithMarketActivityEdge = {
  __typename?: 'UserWithMarketActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type UserWithMarketConnection = {
  __typename?: 'UserWithMarketConnection';
  edges?: Maybe<Array<Maybe<UserWithMarketEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserWithMarketConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<UserWithMarketMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<UserWithMarketSearch>>;
};

export type UserWithMarketEdge = {
  __typename?: 'UserWithMarketEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<UserWithMarket>;
};

export type UserWithMarketMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['Boolean']['input']>;
  airportCodes?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginOffset?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginUtc?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  longTrip?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  resetClientIp?: InputMaybe<Scalars['Boolean']['input']>;
  resetCode?: InputMaybe<Scalars['Boolean']['input']>;
  resetCreatedAtUtc?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Boolean']['input']>;
  roleName?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserWithMarketSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  address?: InputMaybe<Array<StringSearch>>;
  airportCodes?: InputMaybe<Array<StringSearch>>;
  avatar?: InputMaybe<Array<StringSearch>>;
  cityName?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  countryCode?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  dob?: InputMaybe<Array<StringSearch>>;
  email?: InputMaybe<Array<StringSearch>>;
  employeeId?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  lastLogin?: InputMaybe<Array<StringSearch>>;
  lastLoginOffset?: InputMaybe<Array<StringSearch>>;
  lastLoginTimezone?: InputMaybe<Array<StringSearch>>;
  lastLoginUtc?: InputMaybe<Array<StringSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  longTrip?: InputMaybe<Array<IntSearch>>;
  notes?: InputMaybe<Array<StringSearch>>;
  password?: InputMaybe<Array<StringSearch>>;
  phone?: InputMaybe<Array<StringSearch>>;
  primaryAirportCode?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  resetClientIp?: InputMaybe<Array<StringSearch>>;
  resetCode?: InputMaybe<Array<StringSearch>>;
  resetCreatedAtUtc?: InputMaybe<Array<StringSearch>>;
  roleId?: InputMaybe<Array<StringSearch>>;
  roleName?: InputMaybe<Array<StringSearch>>;
  startDate?: InputMaybe<Array<StringSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  timezone?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  username?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  zipCode?: InputMaybe<Array<StringSearch>>;
};

export type UserWithPermissions = {
  __typename?: 'UserWithPermissions';
  active: Scalars['Int']['output'];
  address?: Maybe<Scalars['String']['output']>;
  availability?: Maybe<Array<UserAvailability>>;
  avatar?: Maybe<Scalars['String']['output']>;
  cityName?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  countryCode?: Maybe<Scalars['Int']['output']>;
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  deletedBy?: Maybe<Scalars['String']['output']>;
  dob?: Maybe<Scalars['String']['output']>;
  effect: UserWithPermissionsEffectEnum;
  email: Scalars['String']['output'];
  employeeId?: Maybe<Scalars['String']['output']>;
  entity: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  groupId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  lastLogin?: Maybe<Scalars['String']['output']>;
  lastLoginOffset?: Maybe<Scalars['String']['output']>;
  lastLoginTimezone?: Maybe<Scalars['String']['output']>;
  lastLoginUtc?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  longTrip?: Maybe<Scalars['Int']['output']>;
  notes?: Maybe<Scalars['String']['output']>;
  password: Scalars['String']['output'];
  permissionId: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
  primaryAirportCode?: Maybe<Scalars['String']['output']>;
  providerId?: Maybe<Scalars['String']['output']>;
  resetClientIp?: Maybe<Scalars['String']['output']>;
  resetCode?: Maybe<Scalars['String']['output']>;
  resetCreatedAtUtc?: Maybe<Scalars['String']['output']>;
  resource: Scalars['String']['output'];
  roleId: Scalars['String']['output'];
  startDate?: Maybe<Scalars['String']['output']>;
  stateCode?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['String']['output']>;
  traceId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
  vehicleId?: Maybe<Scalars['String']['output']>;
  verb: Scalars['String']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type UserWithPermissionsActivityConnection = {
  __typename?: 'UserWithPermissionsActivityConnection';
  edges?: Maybe<Array<Maybe<UserWithPermissionsActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserWithPermissionsActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type UserWithPermissionsActivityEdge = {
  __typename?: 'UserWithPermissionsActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type UserWithPermissionsConnection = {
  __typename?: 'UserWithPermissionsConnection';
  edges?: Maybe<Array<Maybe<UserWithPermissionsEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type UserWithPermissionsConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<UserWithPermissionsMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<UserWithPermissionsSearch>>;
};

export type UserWithPermissionsEdge = {
  __typename?: 'UserWithPermissionsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<UserWithPermissions>;
};

export enum UserWithPermissionsEffectEnum {
  Allow = 'ALLOW',
  Deny = 'DENY'
}

export type UserWithPermissionsEffectEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<UserWithPermissionsEffectEnum>;
};

export type UserWithPermissionsMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  address?: InputMaybe<Scalars['Boolean']['input']>;
  avatar?: InputMaybe<Scalars['Boolean']['input']>;
  cityName?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  countryCode?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Boolean']['input']>;
  deletedBy?: InputMaybe<Scalars['Boolean']['input']>;
  dob?: InputMaybe<Scalars['Boolean']['input']>;
  effect?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['Boolean']['input']>;
  employeeId?: InputMaybe<Scalars['Boolean']['input']>;
  entity?: InputMaybe<Scalars['Boolean']['input']>;
  firstName?: InputMaybe<Scalars['Boolean']['input']>;
  groupId?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  lastLogin?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginOffset?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginTimezone?: InputMaybe<Scalars['Boolean']['input']>;
  lastLoginUtc?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['Boolean']['input']>;
  longTrip?: InputMaybe<Scalars['Boolean']['input']>;
  notes?: InputMaybe<Scalars['Boolean']['input']>;
  password?: InputMaybe<Scalars['Boolean']['input']>;
  permissionId?: InputMaybe<Scalars['Boolean']['input']>;
  phone?: InputMaybe<Scalars['Boolean']['input']>;
  primaryAirportCode?: InputMaybe<Scalars['Boolean']['input']>;
  providerId?: InputMaybe<Scalars['Boolean']['input']>;
  resetClientIp?: InputMaybe<Scalars['Boolean']['input']>;
  resetCode?: InputMaybe<Scalars['Boolean']['input']>;
  resetCreatedAtUtc?: InputMaybe<Scalars['Boolean']['input']>;
  resource?: InputMaybe<Scalars['Boolean']['input']>;
  roleId?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['Boolean']['input']>;
  stateCode?: InputMaybe<Scalars['Boolean']['input']>;
  timezone?: InputMaybe<Scalars['Boolean']['input']>;
  traceId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  username?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['Boolean']['input']>;
  verb?: InputMaybe<Scalars['Boolean']['input']>;
  zipCode?: InputMaybe<Scalars['Boolean']['input']>;
};

export type UserWithPermissionsSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  address?: InputMaybe<Array<StringSearch>>;
  avatar?: InputMaybe<Array<StringSearch>>;
  cityName?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  countryCode?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  deletedAt?: InputMaybe<Array<StringSearch>>;
  deletedBy?: InputMaybe<Array<StringSearch>>;
  dob?: InputMaybe<Array<StringSearch>>;
  effect?: InputMaybe<Array<UserWithPermissionsEffectEnumSearch>>;
  email?: InputMaybe<Array<StringSearch>>;
  employeeId?: InputMaybe<Array<StringSearch>>;
  entity?: InputMaybe<Array<StringSearch>>;
  firstName?: InputMaybe<Array<StringSearch>>;
  groupId?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  lastLogin?: InputMaybe<Array<StringSearch>>;
  lastLoginOffset?: InputMaybe<Array<StringSearch>>;
  lastLoginTimezone?: InputMaybe<Array<StringSearch>>;
  lastLoginUtc?: InputMaybe<Array<StringSearch>>;
  lastName?: InputMaybe<Array<StringSearch>>;
  longTrip?: InputMaybe<Array<IntSearch>>;
  notes?: InputMaybe<Array<StringSearch>>;
  password?: InputMaybe<Array<StringSearch>>;
  permissionId?: InputMaybe<Array<StringSearch>>;
  phone?: InputMaybe<Array<StringSearch>>;
  primaryAirportCode?: InputMaybe<Array<StringSearch>>;
  providerId?: InputMaybe<Array<StringSearch>>;
  resetClientIp?: InputMaybe<Array<StringSearch>>;
  resetCode?: InputMaybe<Array<StringSearch>>;
  resetCreatedAtUtc?: InputMaybe<Array<StringSearch>>;
  resource?: InputMaybe<Array<StringSearch>>;
  roleId?: InputMaybe<Array<StringSearch>>;
  startDate?: InputMaybe<Array<StringSearch>>;
  stateCode?: InputMaybe<Array<StringSearch>>;
  timezone?: InputMaybe<Array<StringSearch>>;
  traceId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  username?: InputMaybe<Array<StringSearch>>;
  vehicleId?: InputMaybe<Array<StringSearch>>;
  verb?: InputMaybe<Array<StringSearch>>;
  zipCode?: InputMaybe<Array<StringSearch>>;
};

export type VariableTime = {
  __typename?: 'VariableTime';
  airportCode: Scalars['String']['output'];
  companyId: Scalars['String']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  inboundDomestic?: Maybe<Scalars['Int']['output']>;
  inboundInternational?: Maybe<Scalars['Int']['output']>;
  outbound?: Maybe<Scalars['Int']['output']>;
  servicerIataAirlineCode: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
};

export type VariableTimeActivityConnection = {
  __typename?: 'VariableTimeActivityConnection';
  edges?: Maybe<Array<Maybe<VariableTimeActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VariableTimeActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type VariableTimeActivityEdge = {
  __typename?: 'VariableTimeActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type VariableTimeConnection = {
  __typename?: 'VariableTimeConnection';
  edges?: Maybe<Array<Maybe<VariableTimeEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VariableTimeConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<VariableTimeMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<VariableTimeSearch>>;
};

export type VariableTimeEdge = {
  __typename?: 'VariableTimeEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<VariableTime>;
};

export type VariableTimeMaskInput = {
  airportCode?: InputMaybe<Scalars['Boolean']['input']>;
  companyId?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  inboundDomestic?: InputMaybe<Scalars['Boolean']['input']>;
  inboundInternational?: InputMaybe<Scalars['Boolean']['input']>;
  outbound?: InputMaybe<Scalars['Boolean']['input']>;
  servicerIataAirlineCode?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VariableTimeSearch = {
  airportCode?: InputMaybe<Array<StringSearch>>;
  companyId?: InputMaybe<Array<StringSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  inboundDomestic?: InputMaybe<Array<IntSearch>>;
  inboundInternational?: InputMaybe<Array<IntSearch>>;
  outbound?: InputMaybe<Array<IntSearch>>;
  servicerIataAirlineCode?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
};

export type Vehicle = {
  __typename?: 'Vehicle';
  active: Scalars['Int']['output'];
  airportCodes?: Maybe<Array<AirportHasVehicle>>;
  airportPermitExpirationDate?: Maybe<Scalars['String']['output']>;
  capacity: Scalars['Int']['output'];
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  emissionPermitExpirationDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  location?: Maybe<Location>;
  locationId: Scalars['String']['output'];
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  registrationExpirationDate?: Maybe<Scalars['String']['output']>;
  stateRegistered?: Maybe<Scalars['String']['output']>;
  tollTag?: Maybe<Scalars['String']['output']>;
  tracker: VehicleTrackerEnum;
  trackingId: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  vin: Scalars['String']['output'];
  year?: Maybe<Scalars['Int']['output']>;
};

export type VehicleActivityConnection = {
  __typename?: 'VehicleActivityConnection';
  edges?: Maybe<Array<Maybe<VehicleActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VehicleActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type VehicleActivityEdge = {
  __typename?: 'VehicleActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type VehicleConnection = {
  __typename?: 'VehicleConnection';
  edges?: Maybe<Array<Maybe<VehicleEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type VehicleConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<VehicleMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<VehicleSearch>>;
};

export type VehicleEdge = {
  __typename?: 'VehicleEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Vehicle>;
};

export enum VehicleMakeEnum {
  Ford = 'FORD',
  Mercedes = 'MERCEDES',
  Nissan = 'NISSAN'
}

export type VehicleMaskInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  airportPermitExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  capacity?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  emissionPermitExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  licensePlate?: InputMaybe<Scalars['Boolean']['input']>;
  locationId?: InputMaybe<Scalars['Boolean']['input']>;
  make?: InputMaybe<Scalars['Boolean']['input']>;
  model?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['Boolean']['input']>;
  registrationExpirationDate?: InputMaybe<Scalars['Boolean']['input']>;
  stateRegistered?: InputMaybe<Scalars['Boolean']['input']>;
  tollTag?: InputMaybe<Scalars['Boolean']['input']>;
  tracker?: InputMaybe<Scalars['Boolean']['input']>;
  trackingId?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  vin?: InputMaybe<Scalars['Boolean']['input']>;
  year?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VehicleModelInput = {
  make?: InputMaybe<VehicleMakeEnum>;
};

export type VehicleModelResponse = {
  __typename?: 'VehicleModelResponse';
  models?: Maybe<Array<AcceptInputOption>>;
};

export type VehicleSearch = {
  active?: InputMaybe<Array<IntSearch>>;
  airportPermitExpirationDate?: InputMaybe<Array<StringSearch>>;
  capacity?: InputMaybe<Array<IntSearch>>;
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  emissionPermitExpirationDate?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  licensePlate?: InputMaybe<Array<StringSearch>>;
  locationId?: InputMaybe<Array<StringSearch>>;
  make?: InputMaybe<Array<StringSearch>>;
  model?: InputMaybe<Array<StringSearch>>;
  phoneNumber?: InputMaybe<Array<StringSearch>>;
  registrationExpirationDate?: InputMaybe<Array<StringSearch>>;
  stateRegistered?: InputMaybe<Array<StringSearch>>;
  tollTag?: InputMaybe<Array<StringSearch>>;
  tracker?: InputMaybe<Array<VehicleTrackerEnumSearch>>;
  trackingId?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  vin?: InputMaybe<Array<StringSearch>>;
  year?: InputMaybe<Array<IntSearch>>;
};

export enum VehicleTrackerEnum {
  PhoneGps = 'PHONE_GPS',
  VanTracking = 'VAN_TRACKING'
}

export type VehicleTrackerEnumSearch = {
  sort?: InputMaybe<SortOptions>;
  type: SearchTypeEnum;
  values: Array<VehicleTrackerEnum>;
};

export type Widget = {
  __typename?: 'Widget';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  dashboardId: Scalars['String']['output'];
  filters?: Maybe<Array<WidgetFilter>>;
  height: Scalars['Int']['output'];
  id: Scalars['String']['output'];
  positionX: Scalars['Int']['output'];
  positionY: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  width: Scalars['Int']['output'];
};

export type WidgetActivityConnection = {
  __typename?: 'WidgetActivityConnection';
  edges?: Maybe<Array<Maybe<WidgetActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WidgetActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type WidgetActivityEdge = {
  __typename?: 'WidgetActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type WidgetConnection = {
  __typename?: 'WidgetConnection';
  edges?: Maybe<Array<Maybe<WidgetEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WidgetConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<WidgetMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<WidgetSearch>>;
};

export type WidgetEdge = {
  __typename?: 'WidgetEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Widget>;
};

export type WidgetFilter = {
  __typename?: 'WidgetFilter';
  createdAt?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['String']['output']>;
  updatedBy?: Maybe<Scalars['String']['output']>;
  value: Scalars['String']['output'];
  widgetId: Scalars['String']['output'];
};

export type WidgetFilterActivityConnection = {
  __typename?: 'WidgetFilterActivityConnection';
  edges?: Maybe<Array<Maybe<WidgetFilterActivityEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WidgetFilterActivityConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<ActivityLogSearch>>;
};

export type WidgetFilterActivityEdge = {
  __typename?: 'WidgetFilterActivityEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<ActivityLog>;
};

export type WidgetFilterConnection = {
  __typename?: 'WidgetFilterConnection';
  edges?: Maybe<Array<Maybe<WidgetFilterEdge>>>;
  pageInfo: PageInfo;
  totalCount: Scalars['Int']['output'];
};

export type WidgetFilterConnectionInput = {
  after?: InputMaybe<Scalars['String']['input']>;
  distinctMask?: InputMaybe<WidgetFilterMaskInput>;
  first?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<Array<WidgetFilterSearch>>;
};

export type WidgetFilterEdge = {
  __typename?: 'WidgetFilterEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<WidgetFilter>;
};

export type WidgetFilterMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  value?: InputMaybe<Scalars['Boolean']['input']>;
  widgetId?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetFilterSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  name?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  value?: InputMaybe<Array<StringSearch>>;
  widgetId?: InputMaybe<Array<StringSearch>>;
};

export type WidgetMaskInput = {
  createdAt?: InputMaybe<Scalars['Boolean']['input']>;
  createdBy?: InputMaybe<Scalars['Boolean']['input']>;
  dashboardId?: InputMaybe<Scalars['Boolean']['input']>;
  height?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['Boolean']['input']>;
  positionX?: InputMaybe<Scalars['Boolean']['input']>;
  positionY?: InputMaybe<Scalars['Boolean']['input']>;
  type?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Boolean']['input']>;
  updatedBy?: InputMaybe<Scalars['Boolean']['input']>;
  width?: InputMaybe<Scalars['Boolean']['input']>;
};

export type WidgetSearch = {
  createdAt?: InputMaybe<Array<StringSearch>>;
  createdBy?: InputMaybe<Array<StringSearch>>;
  dashboardId?: InputMaybe<Array<StringSearch>>;
  height?: InputMaybe<Array<IntSearch>>;
  id?: InputMaybe<Array<StringSearch>>;
  positionX?: InputMaybe<Array<IntSearch>>;
  positionY?: InputMaybe<Array<IntSearch>>;
  type?: InputMaybe<Array<StringSearch>>;
  updatedAt?: InputMaybe<Array<StringSearch>>;
  updatedBy?: InputMaybe<Array<StringSearch>>;
  width?: InputMaybe<Array<IntSearch>>;
};

export type ActivityActivityDisplayMessageCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ActivityActivityDisplayMessageCsvColumnEnum;
};

export enum ActivityActivityDisplayMessageCsvColumnEnum {
  ActivityLogId = 'ACTIVITY_LOG_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DisplayMessage = 'DISPLAY_MESSAGE',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ActivityActivityLogCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ActivityActivityLogCsvColumnEnum;
};

export enum ActivityActivityLogCsvColumnEnum {
  Action = 'ACTION',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EventTraceId = 'EVENT_TRACE_ID',
  Field = 'FIELD',
  FormerValue = 'FORMER_VALUE',
  Id = 'ID',
  Message = 'MESSAGE',
  Namespace = 'NAMESPACE',
  ParentNamespace = 'PARENT_NAMESPACE',
  ParentResource = 'PARENT_RESOURCE',
  ParentResourceId = 'PARENT_RESOURCE_ID',
  PayloadId = 'PAYLOAD_ID',
  PlatformName = 'PLATFORM_NAME',
  Resource = 'RESOURCE',
  ResourceId = 'RESOURCE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Value = 'VALUE'
}

export type ActivityActivityLogPayloadCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ActivityActivityLogPayloadCsvColumnEnum;
};

export enum ActivityActivityLogPayloadCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Current = 'CURRENT',
  Id = 'ID',
  Previous = 'PREVIOUS',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ActivityActivityLogPayloadChildCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ActivityActivityLogPayloadChildCsvColumnEnum;
};

export enum ActivityActivityLogPayloadChildCsvColumnEnum {
  ActivityLogPayloadId = 'ACTIVITY_LOG_PAYLOAD_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Data = 'DATA',
  Field = 'FIELD',
  Id = 'ID',
  Namespace = 'NAMESPACE',
  Resource = 'RESOURCE',
  ResourceDisplayName = 'RESOURCE_DISPLAY_NAME',
  ResourceId = 'RESOURCE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ActivityActivityLogWithCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ActivityActivityLogWithCacheCsvColumnEnum;
};

export enum ActivityActivityLogWithCacheCsvColumnEnum {
  Action = 'ACTION',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CreatedByAvatar = 'CREATED_BY_AVATAR',
  CreatedByEmployeeId = 'CREATED_BY_EMPLOYEE_ID',
  CreatedByFirstName = 'CREATED_BY_FIRST_NAME',
  CreatedByLastName = 'CREATED_BY_LAST_NAME',
  CreatedByPrimaryAirportCode = 'CREATED_BY_PRIMARY_AIRPORT_CODE',
  CreatedByRoleId = 'CREATED_BY_ROLE_ID',
  DisplayMessage = 'DISPLAY_MESSAGE',
  EventTraceId = 'EVENT_TRACE_ID',
  Field = 'FIELD',
  FormerValue = 'FORMER_VALUE',
  Id = 'ID',
  Message = 'MESSAGE',
  Namespace = 'NAMESPACE',
  ParentNamespace = 'PARENT_NAMESPACE',
  ParentResource = 'PARENT_RESOURCE',
  ParentResourceId = 'PARENT_RESOURCE_ID',
  PayloadCurrent = 'PAYLOAD_CURRENT',
  PayloadId = 'PAYLOAD_ID',
  PayloadPrevious = 'PAYLOAD_PREVIOUS',
  PlatformName = 'PLATFORM_NAME',
  Resource = 'RESOURCE',
  ResourceId = 'RESOURCE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Value = 'VALUE'
}

export type ActivityActivityUserCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ActivityActivityUserCacheCsvColumnEnum;
};

export enum ActivityActivityUserCacheCsvColumnEnum {
  Avatar = 'AVATAR',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EmployeeId = 'EMPLOYEE_ID',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME',
  PrimaryAirportCode = 'PRIMARY_AIRPORT_CODE',
  RoleId = 'ROLE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type AirportAirportCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AirportAirportCsvColumnEnum;
};

export enum AirportAirportCsvColumnEnum {
  CityCode = 'CITY_CODE',
  CityName = 'CITY_NAME',
  Code = 'CODE',
  Country = 'COUNTRY',
  CountryId = 'COUNTRY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Elevation = 'ELEVATION',
  Icao = 'ICAO',
  Location = 'LOCATION',
  Name = 'NAME',
  StateCode = 'STATE_CODE',
  Timezone = 'TIMEZONE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Url = 'URL'
}

export type AirportAirportGroupCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AirportAirportGroupCsvColumnEnum;
};

export enum AirportAirportGroupCsvColumnEnum {
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type AirportAirportHasCompanyCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AirportAirportHasCompanyCsvColumnEnum;
};

export enum AirportAirportHasCompanyCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CompanyId = 'COMPANY_ID'
}

export type AirportAirportHasGroupCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AirportAirportHasGroupCsvColumnEnum;
};

export enum AirportAirportHasGroupCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  GroupId = 'GROUP_ID'
}

export type AirportAirportHasRateCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AirportAirportHasRateCsvColumnEnum;
};

export enum AirportAirportHasRateCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Rate = 'RATE'
}

export type AirportAirportWithCompanyCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AirportAirportWithCompanyCsvColumnEnum;
};

export enum AirportAirportWithCompanyCsvColumnEnum {
  CityCode = 'CITY_CODE',
  CityName = 'CITY_NAME',
  Code = 'CODE',
  CompanyId = 'COMPANY_ID',
  Country = 'COUNTRY',
  CountryId = 'COUNTRY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Elevation = 'ELEVATION',
  Icao = 'ICAO',
  Location = 'LOCATION',
  Name = 'NAME',
  StateCode = 'STATE_CODE',
  Timezone = 'TIMEZONE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Url = 'URL'
}

export type AirportAirportWithGroupCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AirportAirportWithGroupCsvColumnEnum;
};

export enum AirportAirportWithGroupCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  GroupId = 'GROUP_ID',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type AssetsDefectCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AssetsDefectCsvColumnEnum;
};

export enum AssetsDefectCsvColumnEnum {
  Comment = 'COMMENT',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DvirId = 'DVIR_ID',
  ExternalCreatedAt = 'EXTERNAL_CREATED_AT',
  ExternalDefectId = 'EXTERNAL_DEFECT_ID',
  ExternalResolvedBy = 'EXTERNAL_RESOLVED_BY',
  Id = 'ID',
  IsResolved = 'IS_RESOLVED',
  MechanicNotes = 'MECHANIC_NOTES',
  MechanicNotesUpdatedAt = 'MECHANIC_NOTES_UPDATED_AT',
  ResolvedAt = 'RESOLVED_AT',
  ResolvedByUserName = 'RESOLVED_BY_USER_NAME',
  ResolvedByUserType = 'RESOLVED_BY_USER_TYPE',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type AssetsDriverVehicleAssignmentCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AssetsDriverVehicleAssignmentCsvColumnEnum;
};

export enum AssetsDriverVehicleAssignmentCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DriverId = 'DRIVER_ID',
  DriverName = 'DRIVER_NAME',
  EndDatetime = 'END_DATETIME',
  ExternalDriverId = 'EXTERNAL_DRIVER_ID',
  ExternalVehicleId = 'EXTERNAL_VEHICLE_ID',
  ExternalVendor = 'EXTERNAL_VENDOR',
  Id = 'ID',
  StartDatetime = 'START_DATETIME',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleTrackingId = 'VEHICLE_TRACKING_ID'
}

export type AssetsDvirCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AssetsDvirCsvColumnEnum;
};

export enum AssetsDvirCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DriverId = 'DRIVER_ID',
  DriverName = 'DRIVER_NAME',
  EndDatetime = 'END_DATETIME',
  EventDatetime = 'EVENT_DATETIME',
  EventType = 'EVENT_TYPE',
  ExternalDriverId = 'EXTERNAL_DRIVER_ID',
  ExternalDvirId = 'EXTERNAL_DVIR_ID',
  ExternalEventId = 'EXTERNAL_EVENT_ID',
  ExternalOrgId = 'EXTERNAL_ORG_ID',
  ExternalTrailerId = 'EXTERNAL_TRAILER_ID',
  ExternalVehicleId = 'EXTERNAL_VEHICLE_ID',
  ExternalVendor = 'EXTERNAL_VENDOR',
  ExternalWebhookId = 'EXTERNAL_WEBHOOK_ID',
  FormattedLocation = 'FORMATTED_LOCATION',
  Id = 'ID',
  MechanicNotes = 'MECHANIC_NOTES',
  NeedsCorrection = 'NEEDS_CORRECTION',
  OdometerMeters = 'ODOMETER_METERS',
  SafetyStatus = 'SAFETY_STATUS',
  StartDatetime = 'START_DATETIME',
  TrailerName = 'TRAILER_NAME',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleLicensePlate = 'VEHICLE_LICENSE_PLATE',
  VehicleModel = 'VEHICLE_MODEL',
  VehicleSerial = 'VEHICLE_SERIAL',
  VehicleTrackingId = 'VEHICLE_TRACKING_ID',
  VehicleVin = 'VEHICLE_VIN'
}

export type AssetsDvirSignatureCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AssetsDvirSignatureCsvColumnEnum;
};

export enum AssetsDvirSignatureCsvColumnEnum {
  DvirId = 'DVIR_ID',
  ExternalUserId = 'EXTERNAL_USER_ID',
  Id = 'ID',
  SignedAt = 'SIGNED_AT',
  Type = 'TYPE',
  UserName = 'USER_NAME',
  UserType = 'USER_TYPE'
}

export type AutomationAutomationHistoryAirportCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AutomationAutomationHistoryAirportCsvColumnEnum;
};

export enum AutomationAutomationHistoryAirportCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  AutomationHistoryId = 'AUTOMATION_HISTORY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type AutomationAutomationHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AutomationAutomationHistoryCsvColumnEnum;
};

export enum AutomationAutomationHistoryCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DriverAssigmentFailedCount = 'DRIVER_ASSIGMENT_FAILED_COUNT',
  EndDatetime = 'END_DATETIME',
  Id = 'ID',
  StartDatetime = 'START_DATETIME',
  Status = 'STATUS',
  TotalTripsProcessed = 'TOTAL_TRIPS_PROCESSED',
  TotalTripsToBeProcessed = 'TOTAL_TRIPS_TO_BE_PROCESSED',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type AutomationAutomationHistoryLogCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AutomationAutomationHistoryLogCsvColumnEnum;
};

export enum AutomationAutomationHistoryLogCsvColumnEnum {
  AutomationHistoryId = 'AUTOMATION_HISTORY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  Message = 'MESSAGE',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type AutomationAutomationHistoryWithAirportCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AutomationAutomationHistoryWithAirportCsvColumnEnum;
};

export enum AutomationAutomationHistoryWithAirportCsvColumnEnum {
  AirportCodes = 'AIRPORT_CODES',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DriverAssigmentFailedCount = 'DRIVER_ASSIGMENT_FAILED_COUNT',
  EndDatetime = 'END_DATETIME',
  Id = 'ID',
  StartDatetime = 'START_DATETIME',
  Status = 'STATUS',
  TotalTripsProcessed = 'TOTAL_TRIPS_PROCESSED',
  TotalTripsToBeProcessed = 'TOTAL_TRIPS_TO_BE_PROCESSED',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type AutomationAutomationReportCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AutomationAutomationReportCsvColumnEnum;
};

export enum AutomationAutomationReportCsvColumnEnum {
  AutomatedTrips = 'AUTOMATED_TRIPS',
  AutomationHistoryId = 'AUTOMATION_HISTORY_ID',
  ChangedTrips = 'CHANGED_TRIPS',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CutoffAt = 'CUTOFF_AT',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  ManualTrips = 'MANUAL_TRIPS',
  TimeSavedSeconds = 'TIME_SAVED_SECONDS',
  TotalTrips = 'TOTAL_TRIPS',
  TraceId = 'TRACE_ID',
  UnchangedTrips = 'UNCHANGED_TRIPS',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type AutomationAutomationReportWithAutomationHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AutomationAutomationReportWithAutomationHistoryCsvColumnEnum;
};

export enum AutomationAutomationReportWithAutomationHistoryCsvColumnEnum {
  AirportCodes = 'AIRPORT_CODES',
  AutomatedTrips = 'AUTOMATED_TRIPS',
  AutomationCreatedAt = 'AUTOMATION_CREATED_AT',
  AutomationCreatedBy = 'AUTOMATION_CREATED_BY',
  AutomationHistoryId = 'AUTOMATION_HISTORY_ID',
  AutomationStatus = 'AUTOMATION_STATUS',
  ChangedTrips = 'CHANGED_TRIPS',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CutoffAt = 'CUTOFF_AT',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  EndDatetime = 'END_DATETIME',
  Id = 'ID',
  ManualTrips = 'MANUAL_TRIPS',
  StartDatetime = 'START_DATETIME',
  TimeSavedSeconds = 'TIME_SAVED_SECONDS',
  TotalTrips = 'TOTAL_TRIPS',
  TraceId = 'TRACE_ID',
  UnchangedTrips = 'UNCHANGED_TRIPS',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type AutomationAutomationTripAssignmentReasonCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AutomationAutomationTripAssignmentReasonCsvColumnEnum;
};

export enum AutomationAutomationTripAssignmentReasonCsvColumnEnum {
  AutomationTripId = 'AUTOMATION_TRIP_ID',
  Code = 'CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DisplayMessage = 'DISPLAY_MESSAGE',
  ErrorMessage = 'ERROR_MESSAGE',
  Id = 'ID',
  Title = 'TITLE',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type AutomationAutomationTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AutomationAutomationTripCsvColumnEnum;
};

export enum AutomationAutomationTripCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Attendants = 'ATTENDANTS',
  AutomationHistoryId = 'AUTOMATION_HISTORY_ID',
  CachedDoLocationId = 'CACHED_DO_LOCATION_ID',
  CachedPayerProviderId = 'CACHED_PAYER_PROVIDER_ID',
  CachedPuLocationId = 'CACHED_PU_LOCATION_ID',
  CombineId = 'COMBINE_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DoLocationCoordinates = 'DO_LOCATION_COORDINATES',
  DoLocationName = 'DO_LOCATION_NAME',
  DriverAtCutoffFullName = 'DRIVER_AT_CUTOFF_FULL_NAME',
  DriverAtCutoffId = 'DRIVER_AT_CUTOFF_ID',
  DriverFirstName = 'DRIVER_FIRST_NAME',
  DriverFullName = 'DRIVER_FULL_NAME',
  DriverId = 'DRIVER_ID',
  DriverLastName = 'DRIVER_LAST_NAME',
  FlightNumber = 'FLIGHT_NUMBER',
  Id = 'ID',
  Kind = 'KIND',
  LoopName = 'LOOP_NAME',
  NewDriverFullName = 'NEW_DRIVER_FULL_NAME',
  NewDriverId = 'NEW_DRIVER_ID',
  Offset = 'OFFSET',
  PayerProviderDisplayName = 'PAYER_PROVIDER_DISPLAY_NAME',
  Pilots = 'PILOTS',
  PuGpsDatetime = 'PU_GPS_DATETIME',
  PuLocationCoordinates = 'PU_LOCATION_COORDINATES',
  PuLocationName = 'PU_LOCATION_NAME',
  Scheduled = 'SCHEDULED',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Status = 'STATUS',
  TraceId = 'TRACE_ID',
  TripId = 'TRIP_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID',
  VehicleTrackingId = 'VEHICLE_TRACKING_ID'
}

export type AutomationAutomationTripLogCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: AutomationAutomationTripLogCsvColumnEnum;
};

export enum AutomationAutomationTripLogCsvColumnEnum {
  AutomationTripId = 'AUTOMATION_TRIP_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  Message = 'MESSAGE',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractAutoCombineRuleCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractAutoCombineRuleCsvColumnEnum;
};

export enum ContractAutoCombineRuleCsvColumnEnum {
  CombineStrategy = 'COMBINE_STRATEGY',
  ConsiderVehicle = 'CONSIDER_VEHICLE',
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  ImportType = 'IMPORT_TYPE',
  Kind = 'KIND',
  MaxCombine = 'MAX_COMBINE',
  MaxCombineType = 'MAX_COMBINE_TYPE',
  PickupWindow = 'PICKUP_WINDOW',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UpdateScheduled = 'UPDATE_SCHEDULED'
}

export type ContractAutoCombineRuleWithContractCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractAutoCombineRuleWithContractCsvColumnEnum;
};

export enum ContractAutoCombineRuleWithContractCsvColumnEnum {
  CombineStrategy = 'COMBINE_STRATEGY',
  CompanyId = 'COMPANY_ID',
  ConsiderVehicle = 'CONSIDER_VEHICLE',
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  ImportType = 'IMPORT_TYPE',
  Kind = 'KIND',
  MaxCombine = 'MAX_COMBINE',
  MaxCombineType = 'MAX_COMBINE_TYPE',
  PickupWindow = 'PICKUP_WINDOW',
  ProviderId = 'PROVIDER_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UpdateScheduled = 'UPDATE_SCHEDULED'
}

export type ContractBufferTimeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractBufferTimeCsvColumnEnum;
};

export enum ContractBufferTimeCsvColumnEnum {
  Active = 'ACTIVE',
  AirportCode = 'AIRPORT_CODE',
  BufferMinutes = 'BUFFER_MINUTES',
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EndLocationId = 'END_LOCATION_ID',
  EndTime = 'END_TIME',
  Id = 'ID',
  StartLocationId = 'START_LOCATION_ID',
  StartTime = 'START_TIME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractBufferTimeWithContractCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractBufferTimeWithContractCsvColumnEnum;
};

export enum ContractBufferTimeWithContractCsvColumnEnum {
  Active = 'ACTIVE',
  AirportCode = 'AIRPORT_CODE',
  BufferMinutes = 'BUFFER_MINUTES',
  CompanyId = 'COMPANY_ID',
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EndLocationId = 'END_LOCATION_ID',
  EndTime = 'END_TIME',
  Id = 'ID',
  ProviderId = 'PROVIDER_ID',
  StartLocationId = 'START_LOCATION_ID',
  StartTime = 'START_TIME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractCancellationRuleCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractCancellationRuleCsvColumnEnum;
};

export enum ContractCancellationRuleCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EndLocationId = 'END_LOCATION_ID',
  From = 'FROM',
  Id = 'ID',
  Percentage = 'PERCENTAGE',
  ProviderId = 'PROVIDER_ID',
  StartLocationId = 'START_LOCATION_ID',
  To = 'TO',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractCombineRuleCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractCombineRuleCsvColumnEnum;
};

export enum ContractCombineRuleCsvColumnEnum {
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Discount = 'DISCOUNT',
  Id = 'ID',
  IllegalCombine = 'ILLEGAL_COMBINE',
  PickupWindow = 'PICKUP_WINDOW',
  TurnaroundThreshold = 'TURNAROUND_THRESHOLD',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractCombineRuleHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractCombineRuleHistoryCsvColumnEnum;
};

export enum ContractCombineRuleHistoryCsvColumnEnum {
  CombineRuleId = 'COMBINE_RULE_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Discount = 'DISCOUNT',
  Id = 'ID',
  StartDatetime = 'START_DATETIME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractCombineRuleHistoryWithContractCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractCombineRuleHistoryWithContractCsvColumnEnum;
};

export enum ContractCombineRuleHistoryWithContractCsvColumnEnum {
  CombineRuleId = 'COMBINE_RULE_ID',
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Discount = 'DISCOUNT',
  Id = 'ID',
  ProviderId = 'PROVIDER_ID',
  StartDatetime = 'START_DATETIME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractCombineRuleWithContractCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractCombineRuleWithContractCsvColumnEnum;
};

export enum ContractCombineRuleWithContractCsvColumnEnum {
  CompanyId = 'COMPANY_ID',
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Discount = 'DISCOUNT',
  Id = 'ID',
  IllegalCombine = 'ILLEGAL_COMBINE',
  PickupWindow = 'PICKUP_WINDOW',
  ProviderId = 'PROVIDER_ID',
  TurnaroundThreshold = 'TURNAROUND_THRESHOLD',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractCompanyCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractCompanyCsvColumnEnum;
};

export enum ContractCompanyCsvColumnEnum {
  Address = 'ADDRESS',
  AdminEmail = 'ADMIN_EMAIL',
  CityName = 'CITY_NAME',
  CountryCode = 'COUNTRY_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DispatchPhone = 'DISPATCH_PHONE',
  DisplayName = 'DISPLAY_NAME',
  Id = 'ID',
  InvoiceEmail = 'INVOICE_EMAIL',
  InvoiceFax = 'INVOICE_FAX',
  InvoicePhone = 'INVOICE_PHONE',
  Logo = 'LOGO',
  Name = 'NAME',
  SettingsId = 'SETTINGS_ID',
  StateCode = 'STATE_CODE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Website = 'WEBSITE',
  ZipCode = 'ZIP_CODE'
}

export type ContractContractCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractContractCsvColumnEnum;
};

export enum ContractContractCsvColumnEnum {
  Active = 'ACTIVE',
  AllowCombines = 'ALLOW_COMBINES',
  AllowCrewCreateTrip = 'ALLOW_CREW_CREATE_TRIP',
  AutomateAddons = 'AUTOMATE_ADDONS',
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EnableBufferTime = 'ENABLE_BUFFER_TIME',
  EnableSocialDistancing = 'ENABLE_SOCIAL_DISTANCING',
  Id = 'ID',
  InvoiceTermId = 'INVOICE_TERM_ID',
  ProviderId = 'PROVIDER_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractContractEmailCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractContractEmailCsvColumnEnum;
};

export enum ContractContractEmailCsvColumnEnum {
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Email = 'EMAIL',
  Id = 'ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractContractNumberCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractContractNumberCsvColumnEnum;
};

export enum ContractContractNumberCsvColumnEnum {
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Email = 'EMAIL',
  Id = 'ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractEmailCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractEmailCsvColumnEnum;
};

export enum ContractEmailCsvColumnEnum {
  Address = 'ADDRESS',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  ProviderId = 'PROVIDER_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractEquivalentTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractEquivalentTripCsvColumnEnum;
};

export enum ContractEquivalentTripCsvColumnEnum {
  CompanyId = 'COMPANY_ID',
  Count = 'COUNT',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EndLocationId = 'END_LOCATION_ID',
  Id = 'ID',
  StartLocationId = 'START_LOCATION_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractInvoiceTermCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractInvoiceTermCsvColumnEnum;
};

export enum ContractInvoiceTermCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractMessageCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractMessageCsvColumnEnum;
};

export enum ContractMessageCsvColumnEnum {
  CompanyId = 'COMPANY_ID',
  Content = 'CONTENT',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractProviderAliasCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractProviderAliasCsvColumnEnum;
};

export enum ContractProviderAliasCsvColumnEnum {
  Alias = 'ALIAS',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  ProviderId = 'PROVIDER_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractProviderCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractProviderCsvColumnEnum;
};

export enum ContractProviderCsvColumnEnum {
  Active = 'ACTIVE',
  AddonAutomationAutoIngest = 'ADDON_AUTOMATION_AUTO_INGEST',
  BillingAddress = 'BILLING_ADDRESS',
  BillingCityCode = 'BILLING_CITY_CODE',
  BillingStateCode = 'BILLING_STATE_CODE',
  BillingZipCode = 'BILLING_ZIP_CODE',
  BillFrequency = 'BILL_FREQUENCY',
  CompanyId = 'COMPANY_ID',
  ContactPerson = 'CONTACT_PERSON',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DisplayName = 'DISPLAY_NAME',
  FaxNumber = 'FAX_NUMBER',
  IataAirlineCode = 'IATA_AIRLINE_CODE',
  Id = 'ID',
  ImportCode = 'IMPORT_CODE',
  InvoiceTermId = 'INVOICE_TERM_ID',
  MobilePhoneNumber = 'MOBILE_PHONE_NUMBER',
  Name = 'NAME',
  OccPhoneNumber = 'OCC_PHONE_NUMBER',
  PrimaryAddress = 'PRIMARY_ADDRESS',
  PrimaryCityCode = 'PRIMARY_CITY_CODE',
  PrimaryEmail = 'PRIMARY_EMAIL',
  PrimaryLogoUrl = 'PRIMARY_LOGO_URL',
  PrimaryPhoneNumber = 'PRIMARY_PHONE_NUMBER',
  PrimaryStateCode = 'PRIMARY_STATE_CODE',
  PrimaryZipCode = 'PRIMARY_ZIP_CODE',
  ReferenceNumber = 'REFERENCE_NUMBER',
  RequiresCrewInfo = 'REQUIRES_CREW_INFO',
  TraceId = 'TRACE_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Website = 'WEBSITE'
}

export type ContractProviderLocationMappingCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractProviderLocationMappingCsvColumnEnum;
};

export enum ContractProviderLocationMappingCsvColumnEnum {
  Active = 'ACTIVE',
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DoLocationId = 'DO_LOCATION_ID',
  Id = 'ID',
  ProviderId = 'PROVIDER_ID',
  PuLocationId = 'PU_LOCATION_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractProviderWithAliasCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractProviderWithAliasCsvColumnEnum;
};

export enum ContractProviderWithAliasCsvColumnEnum {
  Active = 'ACTIVE',
  AddonAutomationAutoIngest = 'ADDON_AUTOMATION_AUTO_INGEST',
  Alias = 'ALIAS',
  BillingAddress = 'BILLING_ADDRESS',
  BillingCityCode = 'BILLING_CITY_CODE',
  BillingStateCode = 'BILLING_STATE_CODE',
  BillingZipCode = 'BILLING_ZIP_CODE',
  BillFrequency = 'BILL_FREQUENCY',
  CompanyId = 'COMPANY_ID',
  ContactPerson = 'CONTACT_PERSON',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DisplayName = 'DISPLAY_NAME',
  FaxNumber = 'FAX_NUMBER',
  IataAirlineCode = 'IATA_AIRLINE_CODE',
  Id = 'ID',
  ImportCode = 'IMPORT_CODE',
  InvoiceTermId = 'INVOICE_TERM_ID',
  MobilePhoneNumber = 'MOBILE_PHONE_NUMBER',
  Name = 'NAME',
  OccPhoneNumber = 'OCC_PHONE_NUMBER',
  PrimaryAddress = 'PRIMARY_ADDRESS',
  PrimaryCityCode = 'PRIMARY_CITY_CODE',
  PrimaryEmail = 'PRIMARY_EMAIL',
  PrimaryLogoUrl = 'PRIMARY_LOGO_URL',
  PrimaryPhoneNumber = 'PRIMARY_PHONE_NUMBER',
  PrimaryStateCode = 'PRIMARY_STATE_CODE',
  PrimaryZipCode = 'PRIMARY_ZIP_CODE',
  ReferenceNumber = 'REFERENCE_NUMBER',
  RequiresCrewInfo = 'REQUIRES_CREW_INFO',
  TraceId = 'TRACE_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Website = 'WEBSITE'
}

export type ContractProviderWithContractCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractProviderWithContractCsvColumnEnum;
};

export enum ContractProviderWithContractCsvColumnEnum {
  Active = 'ACTIVE',
  AddonAutomationAutoIngest = 'ADDON_AUTOMATION_AUTO_INGEST',
  BillingAddress = 'BILLING_ADDRESS',
  BillingCityCode = 'BILLING_CITY_CODE',
  BillingStateCode = 'BILLING_STATE_CODE',
  BillingZipCode = 'BILLING_ZIP_CODE',
  BillFrequency = 'BILL_FREQUENCY',
  CompanyId = 'COMPANY_ID',
  ContactPerson = 'CONTACT_PERSON',
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DisplayName = 'DISPLAY_NAME',
  FaxNumber = 'FAX_NUMBER',
  IataAirlineCode = 'IATA_AIRLINE_CODE',
  Id = 'ID',
  ImportCode = 'IMPORT_CODE',
  InvoiceTermId = 'INVOICE_TERM_ID',
  MobilePhoneNumber = 'MOBILE_PHONE_NUMBER',
  Name = 'NAME',
  OccPhoneNumber = 'OCC_PHONE_NUMBER',
  PrimaryAddress = 'PRIMARY_ADDRESS',
  PrimaryCityCode = 'PRIMARY_CITY_CODE',
  PrimaryEmail = 'PRIMARY_EMAIL',
  PrimaryLogoUrl = 'PRIMARY_LOGO_URL',
  PrimaryPhoneNumber = 'PRIMARY_PHONE_NUMBER',
  PrimaryStateCode = 'PRIMARY_STATE_CODE',
  PrimaryZipCode = 'PRIMARY_ZIP_CODE',
  ReferenceNumber = 'REFERENCE_NUMBER',
  RequiresCrewInfo = 'REQUIRES_CREW_INFO',
  TraceId = 'TRACE_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Website = 'WEBSITE'
}

export type ContractProviderWithUpdateStrategyCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractProviderWithUpdateStrategyCsvColumnEnum;
};

export enum ContractProviderWithUpdateStrategyCsvColumnEnum {
  Active = 'ACTIVE',
  AddonAutomationAutoIngest = 'ADDON_AUTOMATION_AUTO_INGEST',
  AddonScheduledComparisonWindowMinutes = 'ADDON_SCHEDULED_COMPARISON_WINDOW_MINUTES',
  AddonStrategy = 'ADDON_STRATEGY',
  AddonType = 'ADDON_TYPE',
  BillingAddress = 'BILLING_ADDRESS',
  BillingCityCode = 'BILLING_CITY_CODE',
  BillingStateCode = 'BILLING_STATE_CODE',
  BillingZipCode = 'BILLING_ZIP_CODE',
  BillFrequency = 'BILL_FREQUENCY',
  CompanyId = 'COMPANY_ID',
  ContactPerson = 'CONTACT_PERSON',
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CustomAddonToleranceMinutes = 'CUSTOM_ADDON_TOLERANCE_MINUTES',
  DailyStrategy = 'DAILY_STRATEGY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DisplayName = 'DISPLAY_NAME',
  FaxNumber = 'FAX_NUMBER',
  IataAirlineCode = 'IATA_AIRLINE_CODE',
  Id = 'ID',
  ImportCode = 'IMPORT_CODE',
  ImportNameIncludesHotels = 'IMPORT_NAME_INCLUDES_HOTELS',
  InvoiceTermId = 'INVOICE_TERM_ID',
  ManifestAutomationDeleteStrategy = 'MANIFEST_AUTOMATION_DELETE_STRATEGY',
  ManifestStrategy = 'MANIFEST_STRATEGY',
  MobilePhoneNumber = 'MOBILE_PHONE_NUMBER',
  Name = 'NAME',
  OccPhoneNumber = 'OCC_PHONE_NUMBER',
  PreviewTimeoutMinutes = 'PREVIEW_TIMEOUT_MINUTES',
  PrimaryAddress = 'PRIMARY_ADDRESS',
  PrimaryCityCode = 'PRIMARY_CITY_CODE',
  PrimaryEmail = 'PRIMARY_EMAIL',
  PrimaryLogoUrl = 'PRIMARY_LOGO_URL',
  PrimaryPhoneNumber = 'PRIMARY_PHONE_NUMBER',
  PrimaryStateCode = 'PRIMARY_STATE_CODE',
  PrimaryZipCode = 'PRIMARY_ZIP_CODE',
  ReferenceNumber = 'REFERENCE_NUMBER',
  RequiresCrewInfo = 'REQUIRES_CREW_INFO',
  TraceId = 'TRACE_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UpdateKindFromLocations = 'UPDATE_KIND_FROM_LOCATIONS',
  UpdateStrategy = 'UPDATE_STRATEGY',
  UpdateStrategyActive = 'UPDATE_STRATEGY_ACTIVE',
  Website = 'WEBSITE'
}

export type ContractSettingsCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractSettingsCsvColumnEnum;
};

export enum ContractSettingsCsvColumnEnum {
  ChatReadTime = 'CHAT_READ_TIME',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewChatReadTime = 'CREW_CHAT_READ_TIME',
  Id = 'ID',
  MessageReadTime = 'MESSAGE_READ_TIME',
  Name = 'NAME',
  OutboundLateAlertMinutes = 'OUTBOUND_LATE_ALERT_MINUTES',
  PasswordExpirationDays = 'PASSWORD_EXPIRATION_DAYS',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleTrackingVendor = 'VEHICLE_TRACKING_VENDOR',
  VehicleTrackingVendorToken = 'VEHICLE_TRACKING_VENDOR_TOKEN'
}

export type ContractSocialDistanceRuleCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractSocialDistanceRuleCsvColumnEnum;
};

export enum ContractSocialDistanceRuleCsvColumnEnum {
  Active = 'ACTIVE',
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Max = 'MAX',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ContractUpdateStrategyCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractUpdateStrategyCsvColumnEnum;
};

export enum ContractUpdateStrategyCsvColumnEnum {
  Active = 'ACTIVE',
  AddonScheduledComparisonWindowMinutes = 'ADDON_SCHEDULED_COMPARISON_WINDOW_MINUTES',
  AddonStrategy = 'ADDON_STRATEGY',
  AddonType = 'ADDON_TYPE',
  ContractId = 'CONTRACT_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CustomAddonToleranceMinutes = 'CUSTOM_ADDON_TOLERANCE_MINUTES',
  DailyStrategy = 'DAILY_STRATEGY',
  Id = 'ID',
  ImportNameIncludesHotels = 'IMPORT_NAME_INCLUDES_HOTELS',
  ManifestAutomationDeleteStrategy = 'MANIFEST_AUTOMATION_DELETE_STRATEGY',
  ManifestStrategy = 'MANIFEST_STRATEGY',
  PreviewTimeoutMinutes = 'PREVIEW_TIMEOUT_MINUTES',
  Strategy = 'STRATEGY',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UpdateKindFromLocations = 'UPDATE_KIND_FROM_LOCATIONS'
}

export type ContractVariableTimeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ContractVariableTimeCsvColumnEnum;
};

export enum ContractVariableTimeCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  InboundDomestic = 'INBOUND_DOMESTIC',
  InboundInternational = 'INBOUND_INTERNATIONAL',
  Outbound = 'OUTBOUND',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type DrivetimereportDtrLocationCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: DrivetimereportDtrLocationCsvColumnEnum;
};

export enum DrivetimereportDtrLocationCsvColumnEnum {
  Address = 'ADDRESS',
  AirportCode = 'AIRPORT_CODE',
  CityName = 'CITY_NAME',
  Coordinates = 'COORDINATES',
  CountryCode = 'COUNTRY_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  Name = 'NAME',
  StateCode = 'STATE_CODE',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID',
  ZipCode = 'ZIP_CODE'
}

export type DrivetimereportManifestHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: DrivetimereportManifestHistoryCsvColumnEnum;
};

export enum DrivetimereportManifestHistoryCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Filename = 'FILENAME',
  Id = 'ID',
  ManifestImportId = 'MANIFEST_IMPORT_ID',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type DrivetimereportManifestHistoryRouteCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: DrivetimereportManifestHistoryRouteCsvColumnEnum;
};

export enum DrivetimereportManifestHistoryRouteCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DoLocationId = 'DO_LOCATION_ID',
  Id = 'ID',
  ManifestHistoryId = 'MANIFEST_HISTORY_ID',
  PuLocationId = 'PU_LOCATION_ID',
  Status = 'STATUS',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type DrivetimereportManifestHistoryWithRouteCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: DrivetimereportManifestHistoryWithRouteCsvColumnEnum;
};

export enum DrivetimereportManifestHistoryWithRouteCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DoLocationId = 'DO_LOCATION_ID',
  Filename = 'FILENAME',
  Id = 'ID',
  ManifestHistoryId = 'MANIFEST_HISTORY_ID',
  ManifestImportId = 'MANIFEST_IMPORT_ID',
  PuLocationId = 'PU_LOCATION_ID',
  RouteCreatedAt = 'ROUTE_CREATED_AT',
  RouteDeletedAt = 'ROUTE_DELETED_AT',
  RouteId = 'ROUTE_ID',
  Status = 'STATUS',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type DrivetimereportQueryHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: DrivetimereportQueryHistoryCsvColumnEnum;
};

export enum DrivetimereportQueryHistoryCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DoLocationId = 'DO_LOCATION_ID',
  EndDate = 'END_DATE',
  Id = 'ID',
  Interval = 'INTERVAL',
  PuLocationId = 'PU_LOCATION_ID',
  StartDate = 'START_DATE',
  Status = 'STATUS',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type DrivetimereportTimeFrameCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: DrivetimereportTimeFrameCsvColumnEnum;
};

export enum DrivetimereportTimeFrameCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  Name = 'NAME',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type DrivetimereportTimeFrameRangeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: DrivetimereportTimeFrameRangeCsvColumnEnum;
};

export enum DrivetimereportTimeFrameRangeCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EndTime = 'END_TIME',
  Id = 'ID',
  Name = 'NAME',
  StartTime = 'START_TIME',
  TimeFrameId = 'TIME_FRAME_ID',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type EventEventCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: EventEventCsvColumnEnum;
};

export enum EventEventCsvColumnEnum {
  Active = 'ACTIVE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Name = 'NAME',
  Source = 'SOURCE',
  Status = 'STATUS',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type EventNotificationCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: EventNotificationCsvColumnEnum;
};

export enum EventNotificationCsvColumnEnum {
  Active = 'ACTIVE',
  AllProvider = 'ALL_PROVIDER',
  AllVendors = 'ALL_VENDORS',
  Company = 'COMPANY',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Method = 'METHOD',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Vendor = 'VENDOR'
}

export type EventNotificationHasEventCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: EventNotificationHasEventCsvColumnEnum;
};

export enum EventNotificationHasEventCsvColumnEnum {
  EventId = 'EVENT_ID',
  ResponseId = 'RESPONSE_ID'
}

export type FieldMapping = {
  displayName: Scalars['String']['input'];
  fieldName: Scalars['String']['input'];
};

export type FlightAlertSubscriptionCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: FlightAlertSubscriptionCsvColumnEnum;
};

export enum FlightAlertSubscriptionCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  ArrivalDate = 'ARRIVAL_DATE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  ExternalAlertId = 'EXTERNAL_ALERT_ID',
  ExternalVendor = 'EXTERNAL_VENDOR',
  FlightNumber = 'FLIGHT_NUMBER',
  Id = 'ID',
  Raw = 'RAW',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type FlightFlightHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: FlightFlightHistoryCsvColumnEnum;
};

export enum FlightFlightHistoryCsvColumnEnum {
  Actual = 'ACTUAL',
  ActualUtc = 'ACTUAL_UTC',
  ArrivalAirportCode = 'ARRIVAL_AIRPORT_CODE',
  ArrivalDatetime = 'ARRIVAL_DATETIME',
  ArrivalDatetimeUtc = 'ARRIVAL_DATETIME_UTC',
  ArrivalDelayMinutes = 'ARRIVAL_DELAY_MINUTES',
  ArrivalGate = 'ARRIVAL_GATE',
  ArrivalTerminal = 'ARRIVAL_TERMINAL',
  ArrivalTimezone = 'ARRIVAL_TIMEZONE',
  ArrivalUtcOffsetHours = 'ARRIVAL_UTC_OFFSET_HOURS',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DepartureAirportCode = 'DEPARTURE_AIRPORT_CODE',
  DepartureDatetime = 'DEPARTURE_DATETIME',
  DepartureDatetimeUtc = 'DEPARTURE_DATETIME_UTC',
  DepartureDelayMinutes = 'DEPARTURE_DELAY_MINUTES',
  DepartureGate = 'DEPARTURE_GATE',
  DepartureTerminal = 'DEPARTURE_TERMINAL',
  DepartureTimezone = 'DEPARTURE_TIMEZONE',
  DepartureUtcOffsetHours = 'DEPARTURE_UTC_OFFSET_HOURS',
  DivertedAirportCode = 'DIVERTED_AIRPORT_CODE',
  EstimatedArrivalDatetime = 'ESTIMATED_ARRIVAL_DATETIME',
  EstimatedArrivalDatetimeUtc = 'ESTIMATED_ARRIVAL_DATETIME_UTC',
  EstimatedDepartureDatetime = 'ESTIMATED_DEPARTURE_DATETIME',
  EstimatedDepartureDatetimeUtc = 'ESTIMATED_DEPARTURE_DATETIME_UTC',
  ExternalAlertId = 'EXTERNAL_ALERT_ID',
  ExternalId = 'EXTERNAL_ID',
  ExternalVendor = 'EXTERNAL_VENDOR',
  FlightNumber = 'FLIGHT_NUMBER',
  Id = 'ID',
  Label = 'LABEL',
  LandedDatetime = 'LANDED_DATETIME',
  LandedDatetimeUtc = 'LANDED_DATETIME_UTC',
  Raw = 'RAW',
  Scheduled = 'SCHEDULED',
  ScheduledUtc = 'SCHEDULED_UTC',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Status = 'STATUS',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type InvoiceInvoiceAirportCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceAirportCsvColumnEnum;
};

export enum InvoiceInvoiceAirportCsvColumnEnum {
  Code = 'CODE',
  Id = 'ID',
  InvoiceId = 'INVOICE_ID'
}

export type InvoiceInvoiceCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceCsvColumnEnum;
};

export enum InvoiceInvoiceCsvColumnEnum {
  ChargeType = 'CHARGE_TYPE',
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Due = 'DUE',
  EndDatetime = 'END_DATETIME',
  Format = 'FORMAT',
  GrandSubtotal = 'GRAND_SUBTOTAL',
  GrandTotal = 'GRAND_TOTAL',
  HasDiscounts = 'HAS_DISCOUNTS',
  Id = 'ID',
  Invoiced = 'INVOICED',
  Name = 'NAME',
  NetBillableTrips = 'NET_BILLABLE_TRIPS',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  StartDatetime = 'START_DATETIME',
  Status = 'STATUS',
  SubTotal = 'SUB_TOTAL',
  Total = 'TOTAL',
  TotalDiscountedTrips = 'TOTAL_DISCOUNTED_TRIPS',
  TotalSavings = 'TOTAL_SAVINGS',
  TotalTripsBilled = 'TOTAL_TRIPS_BILLED',
  UniqueId = 'UNIQUE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type InvoiceInvoiceClientCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceClientCsvColumnEnum;
};

export enum InvoiceInvoiceClientCsvColumnEnum {
  Address = 'ADDRESS',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  InvoiceId = 'INVOICE_ID',
  Name = 'NAME',
  ProviderId = 'PROVIDER_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type InvoiceInvoiceCustomChargeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceCustomChargeCsvColumnEnum;
};

export enum InvoiceInvoiceCustomChargeCsvColumnEnum {
  Cost = 'COST',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Index = 'INDEX',
  InvoiceId = 'INVOICE_ID',
  Note = 'NOTE',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type InvoiceInvoiceDocumentCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceDocumentCsvColumnEnum;
};

export enum InvoiceInvoiceDocumentCsvColumnEnum {
  Amendment = 'AMENDMENT',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  GenDocumentId = 'GEN_DOCUMENT_ID',
  GenDocumentStatus = 'GEN_DOCUMENT_STATUS',
  Id = 'ID',
  Index = 'INDEX',
  InvoiceId = 'INVOICE_ID',
  Md5 = 'MD5',
  SendEmailOnCompletion = 'SEND_EMAIL_ON_COMPLETION',
  SendEmailRecipients = 'SEND_EMAIL_RECIPIENTS',
  SentAt = 'SENT_AT',
  SentBy = 'SENT_BY'
}

export type InvoiceInvoiceDocumentWithSummaryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceDocumentWithSummaryCsvColumnEnum;
};

export enum InvoiceInvoiceDocumentWithSummaryCsvColumnEnum {
  Airlines = 'AIRLINES',
  Airports = 'AIRPORTS',
  Amendment = 'AMENDMENT',
  ChargeType = 'CHARGE_TYPE',
  ClientAddress = 'CLIENT_ADDRESS',
  ClientName = 'CLIENT_NAME',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CreatedByFirstName = 'CREATED_BY_FIRST_NAME',
  CreatedByLastName = 'CREATED_BY_LAST_NAME',
  DueDatetime = 'DUE_DATETIME',
  Emails = 'EMAILS',
  EndDatetime = 'END_DATETIME',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  Format = 'FORMAT',
  GenDocumentId = 'GEN_DOCUMENT_ID',
  GenDocumentStatus = 'GEN_DOCUMENT_STATUS',
  GrandSubtotal = 'GRAND_SUBTOTAL',
  GrandTotal = 'GRAND_TOTAL',
  Headers = 'HEADERS',
  Id = 'ID',
  Index = 'INDEX',
  InvoiceDate = 'INVOICE_DATE',
  InvoiceDocumentId = 'INVOICE_DOCUMENT_ID',
  InvoiceId = 'INVOICE_ID',
  LineItemCount = 'LINE_ITEM_COUNT',
  LineItemTotal = 'LINE_ITEM_TOTAL',
  Md5 = 'MD5',
  PayerProviderDisplayName = 'PAYER_PROVIDER_DISPLAY_NAME',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  SendEmailOnCompletion = 'SEND_EMAIL_ON_COMPLETION',
  SendEmailRecipients = 'SEND_EMAIL_RECIPIENTS',
  SentAt = 'SENT_AT',
  SentBy = 'SENT_BY',
  SentByFirstName = 'SENT_BY_FIRST_NAME',
  SentByLastName = 'SENT_BY_LAST_NAME',
  StartDatetime = 'START_DATETIME',
  Status = 'STATUS',
  Subtotal = 'SUBTOTAL',
  SummaryCreatedAt = 'SUMMARY_CREATED_AT',
  SummaryCreatedBy = 'SUMMARY_CREATED_BY',
  SummaryId = 'SUMMARY_ID',
  SummaryStatus = 'SUMMARY_STATUS',
  TotalSavings = 'TOTAL_SAVINGS',
  TotalTrips = 'TOTAL_TRIPS',
  TotalTripsBilled = 'TOTAL_TRIPS_BILLED',
  TripStatuses = 'TRIP_STATUSES',
  TripTypes = 'TRIP_TYPES',
  UniqueId = 'UNIQUE_ID'
}

export type InvoiceInvoiceEmailCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceEmailCsvColumnEnum;
};

export enum InvoiceInvoiceEmailCsvColumnEnum {
  Address = 'ADDRESS',
  Id = 'ID',
  InvoiceId = 'INVOICE_ID'
}

export type InvoiceInvoiceHeaderCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceHeaderCsvColumnEnum;
};

export enum InvoiceInvoiceHeaderCsvColumnEnum {
  Id = 'ID',
  InvoiceId = 'INVOICE_ID',
  Name = 'NAME'
}

export type InvoiceInvoiceIataCodeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceIataCodeCsvColumnEnum;
};

export enum InvoiceInvoiceIataCodeCsvColumnEnum {
  IataCode = 'IATA_CODE',
  Id = 'ID',
  InvoiceId = 'INVOICE_ID'
}

export type InvoiceInvoiceLineItemCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceLineItemCsvColumnEnum;
};

export enum InvoiceInvoiceLineItemCsvColumnEnum {
  Id = 'ID',
  InvoiceId = 'INVOICE_ID',
  LineItemTypeId = 'LINE_ITEM_TYPE_ID',
  Name = 'NAME',
  Total = 'TOTAL'
}

export type InvoiceInvoiceProviderCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceProviderCacheCsvColumnEnum;
};

export enum InvoiceInvoiceProviderCacheCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DisplayName = 'DISPLAY_NAME',
  Id = 'ID',
  ProviderId = 'PROVIDER_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type InvoiceInvoiceTotalSummaryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceTotalSummaryCsvColumnEnum;
};

export enum InvoiceInvoiceTotalSummaryCsvColumnEnum {
  Airlines = 'AIRLINES',
  Airports = 'AIRPORTS',
  ChargeType = 'CHARGE_TYPE',
  ClientAddress = 'CLIENT_ADDRESS',
  ClientName = 'CLIENT_NAME',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DueDatetime = 'DUE_DATETIME',
  Emails = 'EMAILS',
  EndDatetime = 'END_DATETIME',
  Format = 'FORMAT',
  GrandSubtotal = 'GRAND_SUBTOTAL',
  GrandTotal = 'GRAND_TOTAL',
  Headers = 'HEADERS',
  Id = 'ID',
  InvoiceDate = 'INVOICE_DATE',
  InvoiceDocumentId = 'INVOICE_DOCUMENT_ID',
  InvoiceId = 'INVOICE_ID',
  LineItemCount = 'LINE_ITEM_COUNT',
  LineItemTotal = 'LINE_ITEM_TOTAL',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  StartDatetime = 'START_DATETIME',
  Status = 'STATUS',
  Subtotal = 'SUBTOTAL',
  TotalSavings = 'TOTAL_SAVINGS',
  TotalTrips = 'TOTAL_TRIPS',
  TotalTripsBilled = 'TOTAL_TRIPS_BILLED',
  TripStatuses = 'TRIP_STATUSES',
  TripTypes = 'TRIP_TYPES',
  UniqueId = 'UNIQUE_ID'
}

export type InvoiceInvoiceTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceTripCsvColumnEnum;
};

export enum InvoiceInvoiceTripCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Attendants = 'ATTENDANTS',
  CombineId = 'COMBINE_ID',
  CombineType = 'COMBINE_TYPE',
  CreatedAt = 'CREATED_AT',
  CrewId = 'CREW_ID',
  Currency = 'CURRENCY',
  Discount = 'DISCOUNT',
  DoLocation = 'DO_LOCATION',
  FirstName = 'FIRST_NAME',
  FlightNumber = 'FLIGHT_NUMBER',
  Id = 'ID',
  ImportTime = 'IMPORT_TIME',
  Index = 'INDEX',
  InvoiceId = 'INVOICE_ID',
  Kind = 'KIND',
  LastName = 'LAST_NAME',
  Name = 'NAME',
  Pilots = 'PILOTS',
  PuLocation = 'PU_LOCATION',
  Rate = 'RATE',
  RateId = 'RATE_ID',
  Savings = 'SAVINGS',
  Scheduled = 'SCHEDULED',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Status = 'STATUS',
  TripId = 'TRIP_ID',
  Type = 'TYPE'
}

export type InvoiceInvoiceTripStatusCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceTripStatusCsvColumnEnum;
};

export enum InvoiceInvoiceTripStatusCsvColumnEnum {
  Id = 'ID',
  InvoiceId = 'INVOICE_ID',
  Status = 'STATUS'
}

export type InvoiceInvoiceTypeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceTypeCsvColumnEnum;
};

export enum InvoiceInvoiceTypeCsvColumnEnum {
  Id = 'ID',
  InvoiceId = 'INVOICE_ID',
  Type = 'TYPE'
}

export type InvoiceInvoiceUserCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceInvoiceUserCacheCsvColumnEnum;
};

export enum InvoiceInvoiceUserCacheCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type InvoiceLineItemTypeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: InvoiceLineItemTypeCsvColumnEnum;
};

export enum InvoiceLineItemTypeCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type LocationAirportHasLocationCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: LocationAirportHasLocationCsvColumnEnum;
};

export enum LocationAirportHasLocationCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  LocationId = 'LOCATION_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type LocationAirportWithLocationCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: LocationAirportWithLocationCsvColumnEnum;
};

export enum LocationAirportWithLocationCsvColumnEnum {
  Active = 'ACTIVE',
  Address = 'ADDRESS',
  AirportCode = 'AIRPORT_CODE',
  CityName = 'CITY_NAME',
  Coordinates = 'COORDINATES',
  CountryCode = 'COUNTRY_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  LegacyId = 'LEGACY_ID',
  Name = 'NAME',
  PhoneNumber = 'PHONE_NUMBER',
  PrimaryAirportCode = 'PRIMARY_AIRPORT_CODE',
  Radius = 'RADIUS',
  StateCode = 'STATE_CODE',
  TraceId = 'TRACE_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  ZipCode = 'ZIP_CODE'
}

export type LocationAliasCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: LocationAliasCsvColumnEnum;
};

export enum LocationAliasCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  LocationId = 'LOCATION_ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type LocationCountryRegionCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: LocationCountryRegionCsvColumnEnum;
};

export enum LocationCountryRegionCsvColumnEnum {
  Active = 'ACTIVE',
  Country = 'COUNTRY',
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  StateAbbrev = 'STATE_ABBREV',
  StateProvince = 'STATE_PROVINCE'
}

export type LocationDistanceCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: LocationDistanceCsvColumnEnum;
};

export enum LocationDistanceCsvColumnEnum {
  CachedAt = 'CACHED_AT',
  CreatedAt = 'CREATED_AT',
  DistanceText = 'DISTANCE_TEXT',
  DistanceValue = 'DISTANCE_VALUE',
  DurationInTrafficText = 'DURATION_IN_TRAFFIC_TEXT',
  DurationInTrafficValue = 'DURATION_IN_TRAFFIC_VALUE',
  DurationText = 'DURATION_TEXT',
  DurationValue = 'DURATION_VALUE',
  FromLocationId = 'FROM_LOCATION_ID',
  Id = 'ID',
  ToLocationId = 'TO_LOCATION_ID'
}

export type LocationImageCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: LocationImageCsvColumnEnum;
};

export enum LocationImageCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Filename = 'FILENAME',
  Id = 'ID',
  Md5 = 'MD5',
  Path = 'PATH',
  PickupPointId = 'PICKUP_POINT_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type LocationLocationCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: LocationLocationCsvColumnEnum;
};

export enum LocationLocationCsvColumnEnum {
  Active = 'ACTIVE',
  Address = 'ADDRESS',
  CityName = 'CITY_NAME',
  Coordinates = 'COORDINATES',
  CountryCode = 'COUNTRY_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  LegacyId = 'LEGACY_ID',
  Name = 'NAME',
  PhoneNumber = 'PHONE_NUMBER',
  PrimaryAirportCode = 'PRIMARY_AIRPORT_CODE',
  Radius = 'RADIUS',
  StateCode = 'STATE_CODE',
  TraceId = 'TRACE_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  ZipCode = 'ZIP_CODE'
}

export type LocationLocationWithAirportAndAliasCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: LocationLocationWithAirportAndAliasCsvColumnEnum;
};

export enum LocationLocationWithAirportAndAliasCsvColumnEnum {
  Active = 'ACTIVE',
  Address = 'ADDRESS',
  AirportCode = 'AIRPORT_CODE',
  Alias = 'ALIAS',
  AliasCreatedAt = 'ALIAS_CREATED_AT',
  AliasCreatedBy = 'ALIAS_CREATED_BY',
  AliasId = 'ALIAS_ID',
  AliasUpdatedAt = 'ALIAS_UPDATED_AT',
  AliasUpdatedBy = 'ALIAS_UPDATED_BY',
  CityName = 'CITY_NAME',
  Coordinates = 'COORDINATES',
  CountryCode = 'COUNTRY_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  LegacyId = 'LEGACY_ID',
  Name = 'NAME',
  PhoneNumber = 'PHONE_NUMBER',
  PrimaryAirportCode = 'PRIMARY_AIRPORT_CODE',
  Radius = 'RADIUS',
  StateCode = 'STATE_CODE',
  TraceId = 'TRACE_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  ZipCode = 'ZIP_CODE'
}

export type LocationLocationWithPunchPolicyCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: LocationLocationWithPunchPolicyCsvColumnEnum;
};

export enum LocationLocationWithPunchPolicyCsvColumnEnum {
  Active = 'ACTIVE',
  Address = 'ADDRESS',
  AirportCode = 'AIRPORT_CODE',
  CityName = 'CITY_NAME',
  Coordinates = 'COORDINATES',
  CountryCode = 'COUNTRY_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  EndTime = 'END_TIME',
  EventEndDatetime = 'EVENT_END_DATETIME',
  EventStartDatetime = 'EVENT_START_DATETIME',
  Id = 'ID',
  LegacyId = 'LEGACY_ID',
  Name = 'NAME',
  PhoneNumber = 'PHONE_NUMBER',
  PrimaryAirportCode = 'PRIMARY_AIRPORT_CODE',
  PunchPolicyCompanyId = 'PUNCH_POLICY_COMPANY_ID',
  PunchPolicyCreatedAt = 'PUNCH_POLICY_CREATED_AT',
  PunchPolicyCreatedBy = 'PUNCH_POLICY_CREATED_BY',
  PunchPolicyId = 'PUNCH_POLICY_ID',
  PunchPolicyMinutesIn = 'PUNCH_POLICY_MINUTES_IN',
  PunchPolicyMinutesOut = 'PUNCH_POLICY_MINUTES_OUT',
  PunchPolicyUpdatedAt = 'PUNCH_POLICY_UPDATED_AT',
  PunchPolicyUpdatedBy = 'PUNCH_POLICY_UPDATED_BY',
  Radius = 'RADIUS',
  StartTime = 'START_TIME',
  StateCode = 'STATE_CODE',
  TraceId = 'TRACE_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  ZipCode = 'ZIP_CODE'
}

export type LocationPickupPointCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: LocationPickupPointCsvColumnEnum;
};

export enum LocationPickupPointCsvColumnEnum {
  Coordinates = 'COORDINATES',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EndDatetime = 'END_DATETIME',
  Id = 'ID',
  Instructions = 'INSTRUCTIONS',
  Keyword = 'KEYWORD',
  LocationId = 'LOCATION_ID',
  ProviderId = 'PROVIDER_ID',
  Radius = 'RADIUS',
  StartDatetime = 'START_DATETIME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type LocationPunchPolicyCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: LocationPunchPolicyCsvColumnEnum;
};

export enum LocationPunchPolicyCsvColumnEnum {
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EndTime = 'END_TIME',
  EventEndDatetime = 'EVENT_END_DATETIME',
  EventStartDatetime = 'EVENT_START_DATETIME',
  Id = 'ID',
  LocationId = 'LOCATION_ID',
  MinutesIn = 'MINUTES_IN',
  MinutesOut = 'MINUTES_OUT',
  StartTime = 'START_TIME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ManifestFlagHasPotentialTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestFlagHasPotentialTripCsvColumnEnum;
};

export enum ManifestFlagHasPotentialTripCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  FlagId = 'FLAG_ID',
  PotentialTripId = 'POTENTIAL_TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ManifestFlagHasStagedTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestFlagHasStagedTripCsvColumnEnum;
};

export enum ManifestFlagHasStagedTripCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  FlagId = 'FLAG_ID',
  StagedTripId = 'STAGED_TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ManifestImportCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestImportCsvColumnEnum;
};

export enum ManifestImportCsvColumnEnum {
  AirlineIcaoCode = 'AIRLINE_ICAO_CODE',
  ArchivedAt = 'ARCHIVED_AT',
  ArchivedBy = 'ARCHIVED_BY',
  Cancelled = 'CANCELLED',
  CompanyId = 'COMPANY_ID',
  Created = 'CREATED',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CreateTripTolerance = 'CREATE_TRIP_TOLERANCE',
  Deleted = 'DELETED',
  EmailId = 'EMAIL_ID',
  Excluded = 'EXCLUDED',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  From = 'FROM',
  Id = 'ID',
  IngestedBy = 'INGESTED_BY',
  IngestCompleted = 'INGEST_COMPLETED',
  IngestStarted = 'INGEST_STARTED',
  Md5 = 'MD5',
  Name = 'NAME',
  NoticeDatetime = 'NOTICE_DATETIME',
  PreviewedAt = 'PREVIEWED_AT',
  PreviewType = 'PREVIEW_TYPE',
  PreviousImportId = 'PREVIOUS_IMPORT_ID',
  ProviderId = 'PROVIDER_ID',
  RollbackBy = 'ROLLBACK_BY',
  RolledBackAt = 'ROLLED_BACK_AT',
  RolledBackBy = 'ROLLED_BACK_BY',
  Status = 'STATUS',
  Total = 'TOTAL',
  Type = 'TYPE',
  Unchanged = 'UNCHANGED',
  Updated = 'UPDATED',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Version = 'VERSION'
}

export type ManifestImportEmailCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestImportEmailCsvColumnEnum;
};

export enum ManifestImportEmailCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Date = 'DATE',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  From = 'FROM',
  Id = 'ID',
  Md5 = 'MD5',
  OriginalFileLocation = 'ORIGINAL_FILE_LOCATION',
  Subject = 'SUBJECT',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ManifestImportFailureCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestImportFailureCsvColumnEnum;
};

export enum ManifestImportFailureCsvColumnEnum {
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  ErrorCode = 'ERROR_CODE',
  ErrorMessage = 'ERROR_MESSAGE',
  Id = 'ID',
  ImportId = 'IMPORT_ID',
  ImportType = 'IMPORT_TYPE',
  IngestAction = 'INGEST_ACTION',
  ProviderId = 'PROVIDER_ID',
  StagedTripId = 'STAGED_TRIP_ID',
  TripId = 'TRIP_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ManifestImportLogCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestImportLogCsvColumnEnum;
};

export enum ManifestImportLogCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  ImportId = 'IMPORT_ID',
  Message = 'MESSAGE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ManifestImportOcrCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestImportOcrCacheCsvColumnEnum;
};

export enum ManifestImportOcrCacheCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  ImportId = 'IMPORT_ID',
  ProviderId = 'PROVIDER_ID',
  Text = 'TEXT'
}

export type ManifestImportWithAirportCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestImportWithAirportCsvColumnEnum;
};

export enum ManifestImportWithAirportCsvColumnEnum {
  AirlineIcaoCode = 'AIRLINE_ICAO_CODE',
  AirportCode = 'AIRPORT_CODE',
  ArchivedAt = 'ARCHIVED_AT',
  ArchivedBy = 'ARCHIVED_BY',
  Cancelled = 'CANCELLED',
  CompanyId = 'COMPANY_ID',
  Created = 'CREATED',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CreateTripTolerance = 'CREATE_TRIP_TOLERANCE',
  Deleted = 'DELETED',
  EmailId = 'EMAIL_ID',
  Excluded = 'EXCLUDED',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  From = 'FROM',
  Id = 'ID',
  IngestedBy = 'INGESTED_BY',
  IngestCompleted = 'INGEST_COMPLETED',
  IngestStarted = 'INGEST_STARTED',
  Md5 = 'MD5',
  Name = 'NAME',
  NoticeDatetime = 'NOTICE_DATETIME',
  PreviewedAt = 'PREVIEWED_AT',
  PreviewType = 'PREVIEW_TYPE',
  PreviousImportId = 'PREVIOUS_IMPORT_ID',
  ProviderId = 'PROVIDER_ID',
  RollbackBy = 'ROLLBACK_BY',
  RolledBackAt = 'ROLLED_BACK_AT',
  RolledBackBy = 'ROLLED_BACK_BY',
  Status = 'STATUS',
  Total = 'TOTAL',
  Type = 'TYPE',
  Unchanged = 'UNCHANGED',
  Updated = 'UPDATED',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Version = 'VERSION'
}

export type ManifestImportWithAirportWithCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestImportWithAirportWithCacheCsvColumnEnum;
};

export enum ManifestImportWithAirportWithCacheCsvColumnEnum {
  AirlineIcaoCode = 'AIRLINE_ICAO_CODE',
  AirportCode = 'AIRPORT_CODE',
  ArchivedAt = 'ARCHIVED_AT',
  ArchivedBy = 'ARCHIVED_BY',
  ArchivedByFirstName = 'ARCHIVED_BY_FIRST_NAME',
  ArchivedByLastName = 'ARCHIVED_BY_LAST_NAME',
  Cancelled = 'CANCELLED',
  CompanyId = 'COMPANY_ID',
  Created = 'CREATED',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CreatedByFirstName = 'CREATED_BY_FIRST_NAME',
  CreatedByLastName = 'CREATED_BY_LAST_NAME',
  CreateTripTolerance = 'CREATE_TRIP_TOLERANCE',
  Deleted = 'DELETED',
  EmailId = 'EMAIL_ID',
  Excluded = 'EXCLUDED',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  From = 'FROM',
  Id = 'ID',
  IngestedBy = 'INGESTED_BY',
  IngestedByFirstName = 'INGESTED_BY_FIRST_NAME',
  IngestedByLastName = 'INGESTED_BY_LAST_NAME',
  IngestCompleted = 'INGEST_COMPLETED',
  IngestStarted = 'INGEST_STARTED',
  Md5 = 'MD5',
  Name = 'NAME',
  NoticeDatetime = 'NOTICE_DATETIME',
  PreviewedAt = 'PREVIEWED_AT',
  PreviewType = 'PREVIEW_TYPE',
  PreviousImportId = 'PREVIOUS_IMPORT_ID',
  ProviderDisplayName = 'PROVIDER_DISPLAY_NAME',
  ProviderId = 'PROVIDER_ID',
  RollbackBy = 'ROLLBACK_BY',
  RolledBackAt = 'ROLLED_BACK_AT',
  RolledBackBy = 'ROLLED_BACK_BY',
  RolledBackByFirstName = 'ROLLED_BACK_BY_FIRST_NAME',
  RolledBackByLastName = 'ROLLED_BACK_BY_LAST_NAME',
  Status = 'STATUS',
  Subject = 'SUBJECT',
  Total = 'TOTAL',
  Type = 'TYPE',
  Unchanged = 'UNCHANGED',
  Updated = 'UPDATED',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Version = 'VERSION'
}

export type ManifestManifestProviderCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestManifestProviderCacheCsvColumnEnum;
};

export enum ManifestManifestProviderCacheCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DisplayName = 'DISPLAY_NAME',
  Id = 'ID',
  ProviderId = 'PROVIDER_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ManifestManifestUserCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestManifestUserCacheCsvColumnEnum;
};

export enum ManifestManifestUserCacheCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EmployeeId = 'EMPLOYEE_ID',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type ManifestParsedTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestParsedTripCsvColumnEnum;
};

export enum ManifestParsedTripCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Attendants = 'ATTENDANTS',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DoLocation = 'DO_LOCATION',
  DoLocationId = 'DO_LOCATION_ID',
  FlightNumber = 'FLIGHT_NUMBER',
  FromManifest = 'FROM_MANIFEST',
  Id = 'ID',
  ImportId = 'IMPORT_ID',
  ImportTime = 'IMPORT_TIME',
  Kind = 'KIND',
  LoopName = 'LOOP_NAME',
  Pilots = 'PILOTS',
  PuLocation = 'PU_LOCATION',
  PuLocationId = 'PU_LOCATION_ID',
  Scheduled = 'SCHEDULED',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  TripId = 'TRIP_ID',
  TypeName = 'TYPE_NAME'
}

export type ManifestPotentialTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestPotentialTripCsvColumnEnum;
};

export enum ManifestPotentialTripCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Attendants = 'ATTENDANTS',
  BufferMinutes = 'BUFFER_MINUTES',
  CombineId = 'COMBINE_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewId = 'CREW_ID',
  DoLocationId = 'DO_LOCATION_ID',
  FirstName = 'FIRST_NAME',
  FlightNumber = 'FLIGHT_NUMBER',
  FromManifest = 'FROM_MANIFEST',
  Id = 'ID',
  ImportId = 'IMPORT_ID',
  ImportTime = 'IMPORT_TIME',
  Kind = 'KIND',
  LastName = 'LAST_NAME',
  LoopName = 'LOOP_NAME',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Pilots = 'PILOTS',
  PuLocationId = 'PU_LOCATION_ID',
  Scheduled = 'SCHEDULED',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Split = 'SPLIT',
  TripId = 'TRIP_ID',
  TypeName = 'TYPE_NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ManifestStagedTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ManifestStagedTripCsvColumnEnum;
};

export enum ManifestStagedTripCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Attendants = 'ATTENDANTS',
  BufferMinutes = 'BUFFER_MINUTES',
  CombineId = 'COMBINE_ID',
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewId = 'CREW_ID',
  DoLocationId = 'DO_LOCATION_ID',
  FirstName = 'FIRST_NAME',
  FlightNumber = 'FLIGHT_NUMBER',
  FromManifest = 'FROM_MANIFEST',
  Id = 'ID',
  ImportId = 'IMPORT_ID',
  ImportTime = 'IMPORT_TIME',
  IngestAction = 'INGEST_ACTION',
  Kind = 'KIND',
  LastName = 'LAST_NAME',
  LoopName = 'LOOP_NAME',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Pilots = 'PILOTS',
  PotentialTripId = 'POTENTIAL_TRIP_ID',
  PuLocationId = 'PU_LOCATION_ID',
  Scheduled = 'SCHEDULED',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Split = 'SPLIT',
  StatusName = 'STATUS_NAME',
  TraceId = 'TRACE_ID',
  TripId = 'TRIP_ID',
  TypeName = 'TYPE_NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type PdfgeneratorGeneratedDocumentCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: PdfgeneratorGeneratedDocumentCsvColumnEnum;
};

export enum PdfgeneratorGeneratedDocumentCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DocSource = 'DOC_SOURCE',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  FileS3Bucket = 'FILE_S3_BUCKET',
  GenerationCompletedAt = 'GENERATION_COMPLETED_AT',
  GenerationStartedAt = 'GENERATION_STARTED_AT',
  Id = 'ID',
  ResourceId = 'RESOURCE_ID',
  Status = 'STATUS',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type PdfgeneratorGeneratedDocumentLogCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: PdfgeneratorGeneratedDocumentLogCsvColumnEnum;
};

export enum PdfgeneratorGeneratedDocumentLogCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  GeneratedDocumentId = 'GENERATED_DOCUMENT_ID',
  Id = 'ID',
  Message = 'MESSAGE',
  TraceId = 'TRACE_ID'
}

export type PunchPunchCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: PunchPunchCsvColumnEnum;
};

export enum PunchPunchCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Coordinates = 'COORDINATES',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  PaylocityCompanyId = 'PAYLOCITY_COMPANY_ID',
  PaylocityJobCodeId = 'PAYLOCITY_JOB_CODE_ID',
  PunchDatetime = 'PUNCH_DATETIME',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type ReportAuditSnapshotCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ReportAuditSnapshotCsvColumnEnum;
};

export enum ReportAuditSnapshotCsvColumnEnum {
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Data = 'DATA',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ReportAuditSnapshotWithNameCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ReportAuditSnapshotWithNameCsvColumnEnum;
};

export enum ReportAuditSnapshotWithNameCsvColumnEnum {
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Name = 'NAME'
}

export type ReportCharityRatingHistoryReportCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ReportCharityRatingHistoryReportCsvColumnEnum;
};

export enum ReportCharityRatingHistoryReportCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Amount = 'AMOUNT',
  Avatar = 'AVATAR',
  CharityId = 'CHARITY_ID',
  CharityName = 'CHARITY_NAME',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  ProviderDisplayName = 'PROVIDER_DISPLAY_NAME',
  ProviderId = 'PROVIDER_ID',
  Rating = 'RATING',
  RatingId = 'RATING_ID',
  Username = 'USERNAME',
  UserFirstName = 'USER_FIRST_NAME',
  UserId = 'USER_ID',
  UserLastName = 'USER_LAST_NAME'
}

export type ReportDashboardCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ReportDashboardCsvColumnEnum;
};

export enum ReportDashboardCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type ReportIndexCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ReportIndexCsvColumnEnum;
};

export enum ReportIndexCsvColumnEnum {
  Checkpoint = 'CHECKPOINT',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ReportRatingCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ReportRatingCacheCsvColumnEnum;
};

export enum ReportRatingCacheCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  AirportGroupName = 'AIRPORT_GROUP_NAME',
  Comment = 'COMMENT',
  CompanyId = 'COMPANY_ID',
  CompanyName = 'COMPANY_NAME',
  DriverId = 'DRIVER_ID',
  DriverName = 'DRIVER_NAME',
  FlightNumber = 'FLIGHT_NUMBER',
  Id = 'ID',
  Kind = 'KIND',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  PayerProviderName = 'PAYER_PROVIDER_NAME',
  Rating = 'RATING',
  RatingCreatedAt = 'RATING_CREATED_AT',
  RatingScore = 'RATING_SCORE',
  RatingTypeName = 'RATING_TYPE_NAME',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  TripId = 'TRIP_ID',
  TripScheduled = 'TRIP_SCHEDULED',
  Type = 'TYPE',
  UserId = 'USER_ID'
}

export type ReportRatingCacheRemarkCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ReportRatingCacheRemarkCsvColumnEnum;
};

export enum ReportRatingCacheRemarkCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  RatingCacheId = 'RATING_CACHE_ID',
  Remark = 'REMARK',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type ReportWidgetCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ReportWidgetCsvColumnEnum;
};

export enum ReportWidgetCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DashboardId = 'DASHBOARD_ID',
  Height = 'HEIGHT',
  Id = 'ID',
  PositionX = 'POSITION_X',
  PositionY = 'POSITION_Y',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Width = 'WIDTH'
}

export type ReportWidgetFilterCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: ReportWidgetFilterCsvColumnEnum;
};

export enum ReportWidgetFilterCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Value = 'VALUE',
  WidgetId = 'WIDGET_ID'
}

export type TrainingQuestionnaireAnswerOptionCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TrainingQuestionnaireAnswerOptionCsvColumnEnum;
};

export enum TrainingQuestionnaireAnswerOptionCsvColumnEnum {
  Active = 'ACTIVE',
  AnswerTypeId = 'ANSWER_TYPE_ID',
  Color = 'COLOR',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DisplayLabel = 'DISPLAY_LABEL',
  Id = 'ID',
  ShowsNotes = 'SHOWS_NOTES',
  SortOrder = 'SORT_ORDER',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TrainingQuestionnaireAnswerTypeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TrainingQuestionnaireAnswerTypeCsvColumnEnum;
};

export enum TrainingQuestionnaireAnswerTypeCsvColumnEnum {
  Active = 'ACTIVE',
  AllowsNotes = 'ALLOWS_NOTES',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DisplayName = 'DISPLAY_NAME',
  Id = 'ID',
  NotesPlaceholder = 'NOTES_PLACEHOLDER',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TrainingQuestionnaireAttemptAnswerOptionSnapshotCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TrainingQuestionnaireAttemptAnswerOptionSnapshotCsvColumnEnum;
};

export enum TrainingQuestionnaireAttemptAnswerOptionSnapshotCsvColumnEnum {
  Color = 'COLOR',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DisplayLabel = 'DISPLAY_LABEL',
  Id = 'ID',
  QuestionnaireAttemptQuestionSnapshotId = 'QUESTIONNAIRE_ATTEMPT_QUESTION_SNAPSHOT_ID',
  ShowsNotes = 'SHOWS_NOTES',
  SortOrder = 'SORT_ORDER',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TrainingQuestionnaireAttemptCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TrainingQuestionnaireAttemptCsvColumnEnum;
};

export enum TrainingQuestionnaireAttemptCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  OverallResult = 'OVERALL_RESULT',
  RoleId = 'ROLE_ID',
  SubjectHireDate = 'SUBJECT_HIRE_DATE',
  SubjectUserId = 'SUBJECT_USER_ID',
  SubmittedAt = 'SUBMITTED_AT',
  SubmittedBy = 'SUBMITTED_BY',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TrainingQuestionnaireAttemptCategorySnapshotAllowedGroupCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TrainingQuestionnaireAttemptCategorySnapshotAllowedGroupCsvColumnEnum;
};

export enum TrainingQuestionnaireAttemptCategorySnapshotAllowedGroupCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  GroupId = 'GROUP_ID',
  Id = 'ID',
  QuestionnaireAttemptCategorySnapshotId = 'QUESTIONNAIRE_ATTEMPT_CATEGORY_SNAPSHOT_ID',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TrainingQuestionnaireAttemptCategorySnapshotCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TrainingQuestionnaireAttemptCategorySnapshotCsvColumnEnum;
};

export enum TrainingQuestionnaireAttemptCategorySnapshotCsvColumnEnum {
  Color = 'COLOR',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Description = 'DESCRIPTION',
  Id = 'ID',
  Name = 'NAME',
  QuestionnaireAttemptId = 'QUESTIONNAIRE_ATTEMPT_ID',
  SortOrder = 'SORT_ORDER',
  SubmittedAt = 'SUBMITTED_AT',
  SubmittedBy = 'SUBMITTED_BY',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TrainingQuestionnaireAttemptCategorySnapshotGroupCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TrainingQuestionnaireAttemptCategorySnapshotGroupCsvColumnEnum;
};

export enum TrainingQuestionnaireAttemptCategorySnapshotGroupCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  GroupId = 'GROUP_ID',
  GroupName = 'GROUP_NAME',
  Id = 'ID',
  QuestionnaireAttemptCategorySnapshotId = 'QUESTIONNAIRE_ATTEMPT_CATEGORY_SNAPSHOT_ID',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TrainingQuestionnaireAttemptNoteCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TrainingQuestionnaireAttemptNoteCsvColumnEnum;
};

export enum TrainingQuestionnaireAttemptNoteCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  Note = 'NOTE',
  QuestionnaireAttemptId = 'QUESTIONNAIRE_ATTEMPT_ID',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TrainingQuestionnaireAttemptQuestionSnapshotCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TrainingQuestionnaireAttemptQuestionSnapshotCsvColumnEnum;
};

export enum TrainingQuestionnaireAttemptQuestionSnapshotCsvColumnEnum {
  AnswerTypeAllowsNotes = 'ANSWER_TYPE_ALLOWS_NOTES',
  AnswerTypeDisplayName = 'ANSWER_TYPE_DISPLAY_NAME',
  AnswerTypeNotesPlaceholder = 'ANSWER_TYPE_NOTES_PLACEHOLDER',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  HelperText = 'HELPER_TEXT',
  Id = 'ID',
  QuestionnaireAttemptCategorySnapshotId = 'QUESTIONNAIRE_ATTEMPT_CATEGORY_SNAPSHOT_ID',
  QuestionText = 'QUESTION_TEXT',
  SelectedAnswerNote = 'SELECTED_ANSWER_NOTE',
  SelectedAnswerOptionId = 'SELECTED_ANSWER_OPTION_ID',
  SortOrder = 'SORT_ORDER',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TrainingQuestionnaireCategoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TrainingQuestionnaireCategoryCsvColumnEnum;
};

export enum TrainingQuestionnaireCategoryCsvColumnEnum {
  Active = 'ACTIVE',
  AnswerTypeId = 'ANSWER_TYPE_ID',
  Color = 'COLOR',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Description = 'DESCRIPTION',
  Id = 'ID',
  Name = 'NAME',
  RoleId = 'ROLE_ID',
  SortOrder = 'SORT_ORDER',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TrainingQuestionnaireQuestionCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TrainingQuestionnaireQuestionCsvColumnEnum;
};

export enum TrainingQuestionnaireQuestionCsvColumnEnum {
  Active = 'ACTIVE',
  AnswerTypeId = 'ANSWER_TYPE_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  HelperText = 'HELPER_TEXT',
  Id = 'ID',
  QuestionnaireCategoryId = 'QUESTIONNAIRE_CATEGORY_ID',
  QuestionText = 'QUESTION_TEXT',
  SortOrder = 'SORT_ORDER',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TrainingTrainingUserCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TrainingTrainingUserCacheCsvColumnEnum;
};

export enum TrainingTrainingUserCacheCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME',
  PrimaryAirportCode = 'PRIMARY_AIRPORT_CODE',
  RoleId = 'ROLE_ID',
  StartDate = 'START_DATE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type TripAccidentIssueCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripAccidentIssueCsvColumnEnum;
};

export enum TripAccidentIssueCsvColumnEnum {
  AccidentDatetime = 'ACCIDENT_DATETIME',
  AdditionalDriverScheduled = 'ADDITIONAL_DRIVER_SCHEDULED',
  AnyoneInjured = 'ANYONE_INJURED',
  CanVehicleBeDriven = 'CAN_VEHICLE_BE_DRIVEN',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DamageToOtherVehicles = 'DAMAGE_TO_OTHER_VEHICLES',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Description = 'DESCRIPTION',
  DidDriverCallHelp = 'DID_DRIVER_CALL_HELP',
  DispatcherContactedManager = 'DISPATCHER_CONTACTED_MANAGER',
  DispatcherId = 'DISPATCHER_ID',
  DriverContactedManager = 'DRIVER_CONTACTED_MANAGER',
  DriverId = 'DRIVER_ID',
  Id = 'ID',
  InfoOfCrewMembers = 'INFO_OF_CREW_MEMBERS',
  InfoOfInjuredParties = 'INFO_OF_INJURED_PARTIES',
  MedicalNeeded = 'MEDICAL_NEEDED',
  OutboundDatetime = 'OUTBOUND_DATETIME',
  OutboundFlightName = 'OUTBOUND_FLIGHT_NAME',
  OutboundFlightNumber = 'OUTBOUND_FLIGHT_NUMBER',
  SafetyId = 'SAFETY_ID',
  SafetyNotified = 'SAFETY_NOTIFIED',
  SamsaraCameraWorking = 'SAMSARA_CAMERA_WORKING',
  SpecificLocation = 'SPECIFIC_LOCATION',
  StationText = 'STATION_TEXT',
  ThirdPartyInformation = 'THIRD_PARTY_INFORMATION',
  TraceId = 'TRACE_ID',
  TripId = 'TRIP_ID',
  TypeOfMedicalAttention = 'TYPE_OF_MEDICAL_ATTENTION',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID',
  WasCeoCalled = 'WAS_CEO_CALLED',
  WasCrewInvolved = 'WAS_CREW_INVOLVED',
  WasDriverAtFault = 'WAS_DRIVER_AT_FAULT',
  WasThirdPartyInvolved = 'WAS_THIRD_PARTY_INVOLVED'
}

export type TripAccidentIssueDocumentCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripAccidentIssueDocumentCsvColumnEnum;
};

export enum TripAccidentIssueDocumentCsvColumnEnum {
  ContentType = 'CONTENT_TYPE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  FileSize = 'FILE_SIZE',
  Id = 'ID',
  IssueId = 'ISSUE_ID',
  Md5 = 'MD5',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripAccidentIssueWithCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripAccidentIssueWithCacheCsvColumnEnum;
};

export enum TripAccidentIssueWithCacheCsvColumnEnum {
  AccidentDatetime = 'ACCIDENT_DATETIME',
  AdditionalDriverScheduled = 'ADDITIONAL_DRIVER_SCHEDULED',
  AnyoneInjured = 'ANYONE_INJURED',
  CanVehicleBeDriven = 'CAN_VEHICLE_BE_DRIVEN',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DamageToOtherVehicles = 'DAMAGE_TO_OTHER_VEHICLES',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Description = 'DESCRIPTION',
  DidDriverCallHelp = 'DID_DRIVER_CALL_HELP',
  DispatcherContactedManager = 'DISPATCHER_CONTACTED_MANAGER',
  DispatcherEmployeeId = 'DISPATCHER_EMPLOYEE_ID',
  DispatcherFirstName = 'DISPATCHER_FIRST_NAME',
  DispatcherId = 'DISPATCHER_ID',
  DispatcherLastName = 'DISPATCHER_LAST_NAME',
  DriverContactedManager = 'DRIVER_CONTACTED_MANAGER',
  DriverEmployeeId = 'DRIVER_EMPLOYEE_ID',
  DriverFirstName = 'DRIVER_FIRST_NAME',
  DriverId = 'DRIVER_ID',
  DriverLastName = 'DRIVER_LAST_NAME',
  Id = 'ID',
  InfoOfCrewMembers = 'INFO_OF_CREW_MEMBERS',
  InfoOfInjuredParties = 'INFO_OF_INJURED_PARTIES',
  MedicalNeeded = 'MEDICAL_NEEDED',
  OutboundDatetime = 'OUTBOUND_DATETIME',
  OutboundFlightName = 'OUTBOUND_FLIGHT_NAME',
  OutboundFlightNumber = 'OUTBOUND_FLIGHT_NUMBER',
  SafetyEmployeeId = 'SAFETY_EMPLOYEE_ID',
  SafetyFirstName = 'SAFETY_FIRST_NAME',
  SafetyId = 'SAFETY_ID',
  SafetyLastName = 'SAFETY_LAST_NAME',
  SafetyNotified = 'SAFETY_NOTIFIED',
  SamsaraCameraWorking = 'SAMSARA_CAMERA_WORKING',
  SpecificLocation = 'SPECIFIC_LOCATION',
  StationText = 'STATION_TEXT',
  ThirdPartyInformation = 'THIRD_PARTY_INFORMATION',
  TraceId = 'TRACE_ID',
  TripFlightNumber = 'TRIP_FLIGHT_NUMBER',
  TripId = 'TRIP_ID',
  TripLoopName = 'TRIP_LOOP_NAME',
  TripScheduled = 'TRIP_SCHEDULED',
  TripServicerIataAirlineCode = 'TRIP_SERVICER_IATA_AIRLINE_CODE',
  TypeOfMedicalAttention = 'TYPE_OF_MEDICAL_ATTENTION',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID',
  VehicleTrackingId = 'VEHICLE_TRACKING_ID',
  WasCeoCalled = 'WAS_CEO_CALLED',
  WasCrewInvolved = 'WAS_CREW_INVOLVED',
  WasDriverAtFault = 'WAS_DRIVER_AT_FAULT',
  WasThirdPartyInvolved = 'WAS_THIRD_PARTY_INVOLVED'
}

export type TripActivityCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripActivityCsvColumnEnum;
};

export enum TripActivityCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Field = 'FIELD',
  FormerObjectId = 'FORMER_OBJECT_ID',
  FormerValue = 'FORMER_VALUE',
  Id = 'ID',
  Message = 'MESSAGE',
  ObjectId = 'OBJECT_ID',
  SourceId = 'SOURCE_ID',
  SubjectId = 'SUBJECT_ID',
  TripId = 'TRIP_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Value = 'VALUE',
  Via = 'VIA'
}

export type TripActivityObjectCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripActivityObjectCsvColumnEnum;
};

export enum TripActivityObjectCsvColumnEnum {
  Id = 'ID',
  Name = 'NAME',
  Type = 'TYPE',
  Url = 'URL'
}

export type TripAirportHasManagerEmailCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripAirportHasManagerEmailCsvColumnEnum;
};

export enum TripAirportHasManagerEmailCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EmailAddress = 'EMAIL_ADDRESS',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripAirportHasVehicleCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripAirportHasVehicleCsvColumnEnum;
};

export enum TripAirportHasVehicleCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID'
}

export type TripAirportWithVehicleCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripAirportWithVehicleCsvColumnEnum;
};

export enum TripAirportWithVehicleCsvColumnEnum {
  Active = 'ACTIVE',
  AirportCode = 'AIRPORT_CODE',
  AirportPermitExpirationDate = 'AIRPORT_PERMIT_EXPIRATION_DATE',
  Capacity = 'CAPACITY',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EmissionPermitExpirationDate = 'EMISSION_PERMIT_EXPIRATION_DATE',
  Id = 'ID',
  LicensePlate = 'LICENSE_PLATE',
  LocationId = 'LOCATION_ID',
  Make = 'MAKE',
  Model = 'MODEL',
  PhoneNumber = 'PHONE_NUMBER',
  RegistrationExpirationDate = 'REGISTRATION_EXPIRATION_DATE',
  StateRegistered = 'STATE_REGISTERED',
  TollTag = 'TOLL_TAG',
  Tracker = 'TRACKER',
  TrackingId = 'TRACKING_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Vin = 'VIN',
  Year = 'YEAR'
}

export type TripChatQuickReplyMessageCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripChatQuickReplyMessageCsvColumnEnum;
};

export enum TripChatQuickReplyMessageCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Message = 'MESSAGE',
  Name = 'NAME',
  SortOrder = 'SORT_ORDER',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripCheckinEventCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripCheckinEventCsvColumnEnum;
};

export enum TripCheckinEventCsvColumnEnum {
  App = 'APP',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Datetime = 'DATETIME',
  Id = 'ID',
  IpAddress = 'IP_ADDRESS',
  Platform = 'PLATFORM',
  SessionId = 'SESSION_ID',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserAgent = 'USER_AGENT',
  UserId = 'USER_ID'
}

export type TripClosestRateItemCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripClosestRateItemCsvColumnEnum;
};

export enum TripClosestRateItemCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Currency = 'CURRENCY',
  EndDatetime = 'END_DATETIME',
  Id = 'ID',
  RateGroupId = 'RATE_GROUP_ID',
  Rn = 'RN',
  StartDatetime = 'START_DATETIME',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripCommunicationCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripCommunicationCsvColumnEnum;
};

export enum TripCommunicationCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Message = 'MESSAGE',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripCompletionCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripCompletionCsvColumnEnum;
};

export enum TripCompletionCsvColumnEnum {
  Comment = 'COMMENT',
  CompletionTypeId = 'COMPLETION_TYPE_ID',
  Cost = 'COST',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Currency = 'CURRENCY',
  Datetime = 'DATETIME',
  DistanceMeters = 'DISTANCE_METERS',
  Efficiency = 'EFFICIENCY',
  Equivalency = 'EQUIVALENCY',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripCompletionTypeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripCompletionTypeCsvColumnEnum;
};

export enum TripCompletionTypeCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripCompletionWithTypeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripCompletionWithTypeCsvColumnEnum;
};

export enum TripCompletionWithTypeCsvColumnEnum {
  Comment = 'COMMENT',
  CompletionTypeId = 'COMPLETION_TYPE_ID',
  Cost = 'COST',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Currency = 'CURRENCY',
  Datetime = 'DATETIME',
  DistanceMeters = 'DISTANCE_METERS',
  Efficiency = 'EFFICIENCY',
  Equivalency = 'EQUIVALENCY',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripCrewCountRequirementCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripCrewCountRequirementCsvColumnEnum;
};

export enum TripCrewCountRequirementCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Enabled = 'ENABLED',
  FlightNumber = 'FLIGHT_NUMBER',
  Id = 'ID',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripDispatchIssueCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripDispatchIssueCsvColumnEnum;
};

export enum TripDispatchIssueCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewMemberGiftCardCount = 'CREW_MEMBER_GIFT_CARD_COUNT',
  CrewMemberName = 'CREW_MEMBER_NAME',
  CrewMemberPhone = 'CREW_MEMBER_PHONE',
  Datetime = 'DATETIME',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DispatcherId = 'DISPATCHER_ID',
  DriverId = 'DRIVER_ID',
  DriverPhone = 'DRIVER_PHONE',
  FlightIssueDescription = 'FLIGHT_ISSUE_DESCRIPTION',
  FlightLate = 'FLIGHT_LATE',
  FlightType = 'FLIGHT_TYPE',
  Id = 'ID',
  ManagerId = 'MANAGER_ID',
  OutboundFlightInfo = 'OUTBOUND_FLIGHT_INFO',
  PushTime = 'PUSH_TIME',
  RecoveryCompleted = 'RECOVERY_COMPLETED',
  RecoveryFlightDatetime = 'RECOVERY_FLIGHT_DATETIME',
  RecoveryFlightName = 'RECOVERY_FLIGHT_NAME',
  RecoveryFlightNumber = 'RECOVERY_FLIGHT_NUMBER',
  RecoveryNeeded = 'RECOVERY_NEEDED',
  RootCause = 'ROOT_CAUSE',
  RootCauseDescription = 'ROOT_CAUSE_DESCRIPTION',
  ScheduledTime = 'SCHEDULED_TIME',
  Station = 'STATION',
  TaxiCost = 'TAXI_COST',
  TaxiDetails = 'TAXI_DETAILS',
  TaxiUsed = 'TAXI_USED',
  TraceId = 'TRACE_ID',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID'
}

export type TripDispatchIssueCausedByCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripDispatchIssueCausedByCsvColumnEnum;
};

export enum TripDispatchIssueCausedByCsvColumnEnum {
  CausedById = 'CAUSED_BY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DispatchIssueId = 'DISPATCH_ISSUE_ID',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripDispatchIssueCausedByWithCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripDispatchIssueCausedByWithCacheCsvColumnEnum;
};

export enum TripDispatchIssueCausedByWithCacheCsvColumnEnum {
  CausedByFirstName = 'CAUSED_BY_FIRST_NAME',
  CausedById = 'CAUSED_BY_ID',
  CausedByLastName = 'CAUSED_BY_LAST_NAME',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DispatchIssueId = 'DISPATCH_ISSUE_ID',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripDispatchIssueDocumentCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripDispatchIssueDocumentCsvColumnEnum;
};

export enum TripDispatchIssueDocumentCsvColumnEnum {
  ContentType = 'CONTENT_TYPE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  FileSize = 'FILE_SIZE',
  Id = 'ID',
  IssueId = 'ISSUE_ID',
  Md5 = 'MD5',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripDispatchIssueWithCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripDispatchIssueWithCacheCsvColumnEnum;
};

export enum TripDispatchIssueWithCacheCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewMemberGiftCardCount = 'CREW_MEMBER_GIFT_CARD_COUNT',
  CrewMemberName = 'CREW_MEMBER_NAME',
  CrewMemberPhone = 'CREW_MEMBER_PHONE',
  Datetime = 'DATETIME',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DispatcherEmployeeId = 'DISPATCHER_EMPLOYEE_ID',
  DispatcherFirstName = 'DISPATCHER_FIRST_NAME',
  DispatcherId = 'DISPATCHER_ID',
  DispatcherLastName = 'DISPATCHER_LAST_NAME',
  DriverEmployeeId = 'DRIVER_EMPLOYEE_ID',
  DriverFirstName = 'DRIVER_FIRST_NAME',
  DriverId = 'DRIVER_ID',
  DriverLastName = 'DRIVER_LAST_NAME',
  DriverPhone = 'DRIVER_PHONE',
  FlightIssueDescription = 'FLIGHT_ISSUE_DESCRIPTION',
  FlightLate = 'FLIGHT_LATE',
  FlightType = 'FLIGHT_TYPE',
  Id = 'ID',
  ManagerEmployeeId = 'MANAGER_EMPLOYEE_ID',
  ManagerFirstName = 'MANAGER_FIRST_NAME',
  ManagerId = 'MANAGER_ID',
  ManagerLastName = 'MANAGER_LAST_NAME',
  OutboundFlightInfo = 'OUTBOUND_FLIGHT_INFO',
  PushTime = 'PUSH_TIME',
  RecoveryCompleted = 'RECOVERY_COMPLETED',
  RecoveryFlightDatetime = 'RECOVERY_FLIGHT_DATETIME',
  RecoveryFlightName = 'RECOVERY_FLIGHT_NAME',
  RecoveryFlightNumber = 'RECOVERY_FLIGHT_NUMBER',
  RecoveryNeeded = 'RECOVERY_NEEDED',
  RootCause = 'ROOT_CAUSE',
  RootCauseDescription = 'ROOT_CAUSE_DESCRIPTION',
  ScheduledTime = 'SCHEDULED_TIME',
  Station = 'STATION',
  TaxiCost = 'TAXI_COST',
  TaxiDetails = 'TAXI_DETAILS',
  TaxiUsed = 'TAXI_USED',
  TraceId = 'TRACE_ID',
  TripAirportCode = 'TRIP_AIRPORT_CODE',
  TripFlightNumber = 'TRIP_FLIGHT_NUMBER',
  TripId = 'TRIP_ID',
  TripKind = 'TRIP_KIND',
  TripLoopName = 'TRIP_LOOP_NAME',
  TripScheduled = 'TRIP_SCHEDULED',
  TripServicerIataAirlineCode = 'TRIP_SERVICER_IATA_AIRLINE_CODE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID',
  VehicleTrackingId = 'VEHICLE_TRACKING_ID'
}

export type TripDispatchSummaryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripDispatchSummaryCsvColumnEnum;
};

export enum TripDispatchSummaryCsvColumnEnum {
  CallVolume = 'CALL_VOLUME',
  ChatVolume = 'CHAT_VOLUME',
  CommentsFaxallCheck = 'COMMENTS_FAXALL_CHECK',
  CommentsRepeatDistractedOffenders = 'COMMENTS_REPEAT_DISTRACTED_OFFENDERS',
  CommentsRepeatSpeedingOffenders = 'COMMENTS_REPEAT_SPEEDING_OFFENDERS',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DispatcherAssetCamerasWorking = 'DISPATCHER_ASSET_CAMERAS_WORKING',
  DispatcherAssetCamerasWorkingNotes = 'DISPATCHER_ASSET_CAMERAS_WORKING_NOTES',
  DispatcherDayOverview = 'DISPATCHER_DAY_OVERVIEW',
  DispatcherEightByEightIssue = 'DISPATCHER_EIGHT_BY_EIGHT_ISSUE',
  DispatcherId = 'DISPATCHER_ID',
  DispatcherPassdown = 'DISPATCHER_PASSDOWN',
  DispatcherServiceIssues = 'DISPATCHER_SERVICE_ISSUES',
  DispatcherShift = 'DISPATCHER_SHIFT',
  DispatcherSoftwareIssues = 'DISPATCHER_SOFTWARE_ISSUES',
  DispatcherStation = 'DISPATCHER_STATION',
  DispatcherStationVansIssues = 'DISPATCHER_STATION_VANS_ISSUES',
  DispatcherWasThereEightByEightIssue = 'DISPATCHER_WAS_THERE_EIGHT_BY_EIGHT_ISSUE',
  Id = 'ID',
  ManifestsDrivingIssues = 'MANIFESTS_DRIVING_ISSUES',
  ManifestsTaxis = 'MANIFESTS_TAXIS',
  ManifestsTrainingIssues = 'MANIFESTS_TRAINING_ISSUES',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripDispatchSummaryDocumentCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripDispatchSummaryDocumentCsvColumnEnum;
};

export enum TripDispatchSummaryDocumentCsvColumnEnum {
  ContentType = 'CONTENT_TYPE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  FileSize = 'FILE_SIZE',
  Id = 'ID',
  Md5 = 'MD5',
  SummaryId = 'SUMMARY_ID',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripDispatchSummaryMarketCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripDispatchSummaryMarketCsvColumnEnum;
};

export enum TripDispatchSummaryMarketCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Comment = 'COMMENT',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DispatchSummaryId = 'DISPATCH_SUMMARY_ID',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripDispatchSummaryWithCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripDispatchSummaryWithCacheCsvColumnEnum;
};

export enum TripDispatchSummaryWithCacheCsvColumnEnum {
  CallVolume = 'CALL_VOLUME',
  ChatVolume = 'CHAT_VOLUME',
  CommentsFaxallCheck = 'COMMENTS_FAXALL_CHECK',
  CommentsRepeatDistractedOffenders = 'COMMENTS_REPEAT_DISTRACTED_OFFENDERS',
  CommentsRepeatSpeedingOffenders = 'COMMENTS_REPEAT_SPEEDING_OFFENDERS',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DispatcherAssetCamerasWorking = 'DISPATCHER_ASSET_CAMERAS_WORKING',
  DispatcherAssetCamerasWorkingNotes = 'DISPATCHER_ASSET_CAMERAS_WORKING_NOTES',
  DispatcherDayOverview = 'DISPATCHER_DAY_OVERVIEW',
  DispatcherEightByEightIssue = 'DISPATCHER_EIGHT_BY_EIGHT_ISSUE',
  DispatcherEmployeeId = 'DISPATCHER_EMPLOYEE_ID',
  DispatcherFirstName = 'DISPATCHER_FIRST_NAME',
  DispatcherId = 'DISPATCHER_ID',
  DispatcherLastName = 'DISPATCHER_LAST_NAME',
  DispatcherPassdown = 'DISPATCHER_PASSDOWN',
  DispatcherServiceIssues = 'DISPATCHER_SERVICE_ISSUES',
  DispatcherShift = 'DISPATCHER_SHIFT',
  DispatcherSoftwareIssues = 'DISPATCHER_SOFTWARE_ISSUES',
  DispatcherStation = 'DISPATCHER_STATION',
  DispatcherStationVansIssues = 'DISPATCHER_STATION_VANS_ISSUES',
  DispatcherWasThereEightByEightIssue = 'DISPATCHER_WAS_THERE_EIGHT_BY_EIGHT_ISSUE',
  Id = 'ID',
  ManifestsDrivingIssues = 'MANIFESTS_DRIVING_ISSUES',
  ManifestsTaxis = 'MANIFESTS_TAXIS',
  ManifestsTrainingIssues = 'MANIFESTS_TRAINING_ISSUES',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripDriverEtaCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripDriverEtaCsvColumnEnum;
};

export enum TripDriverEtaCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DriverId = 'DRIVER_ID',
  EtaDatetime = 'ETA_DATETIME',
  EtaMinutes = 'ETA_MINUTES',
  Id = 'ID',
  PreviousTripId = 'PREVIOUS_TRIP_ID',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripDriverEtaWithPreviousTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripDriverEtaWithPreviousTripCsvColumnEnum;
};

export enum TripDriverEtaWithPreviousTripCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DriverId = 'DRIVER_ID',
  EtaDatetime = 'ETA_DATETIME',
  EtaMinutes = 'ETA_MINUTES',
  Id = 'ID',
  PreviousTripFlightNumber = 'PREVIOUS_TRIP_FLIGHT_NUMBER',
  PreviousTripId = 'PREVIOUS_TRIP_ID',
  PreviousTripScheduled = 'PREVIOUS_TRIP_SCHEDULED',
  PreviousTripServicerIataAirlineCode = 'PREVIOUS_TRIP_SERVICER_IATA_AIRLINE_CODE',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripFcrCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripFcrCsvColumnEnum;
};

export enum TripFcrCsvColumnEnum {
  Cause = 'CAUSE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Description = 'DESCRIPTION',
  FcrReporter = 'FCR_REPORTER',
  FcrTypeId = 'FCR_TYPE_ID',
  Id = 'ID',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripFcrTypeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripFcrTypeCsvColumnEnum;
};

export enum TripFcrTypeCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripFlagCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripFlagCsvColumnEnum;
};

export enum TripFlagCsvColumnEnum {
  Active = 'ACTIVE',
  Color = 'COLOR',
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Global = 'GLOBAL',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripFlagHasTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripFlagHasTripCsvColumnEnum;
};

export enum TripFlagHasTripCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  FlagId = 'FLAG_ID',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripFlagWithTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripFlagWithTripCsvColumnEnum;
};

export enum TripFlagWithTripCsvColumnEnum {
  Active = 'ACTIVE',
  Color = 'COLOR',
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Global = 'GLOBAL',
  Id = 'ID',
  Name = 'NAME',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripIncidentIssueCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripIncidentIssueCsvColumnEnum;
};

export enum TripIncidentIssueCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewInfo = 'CREW_INFO',
  CrewInvolved = 'CREW_INVOLVED',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Description = 'DESCRIPTION',
  DispatcherId = 'DISPATCHER_ID',
  DriverId = 'DRIVER_ID',
  Id = 'ID',
  IncidentDatetime = 'INCIDENT_DATETIME',
  IncidentOccurance = 'INCIDENT_OCCURANCE',
  IncidentOccuranceOther = 'INCIDENT_OCCURANCE_OTHER',
  IncidentWitnesses = 'INCIDENT_WITNESSES',
  ManagerId = 'MANAGER_ID',
  MedicalAttentionType = 'MEDICAL_ATTENTION_TYPE',
  MedicalInjuries = 'MEDICAL_INJURIES',
  MedicalNeeded = 'MEDICAL_NEEDED',
  OutboundDatetime = 'OUTBOUND_DATETIME',
  OutboundFlightName = 'OUTBOUND_FLIGHT_NAME',
  OutboundFlightNumber = 'OUTBOUND_FLIGHT_NUMBER',
  PropertyDamage = 'PROPERTY_DAMAGE',
  PropertyDamageDescription = 'PROPERTY_DAMAGE_DESCRIPTION',
  RecoveryInfo = 'RECOVERY_INFO',
  SamsaraCameraWorking = 'SAMSARA_CAMERA_WORKING',
  Station = 'STATION',
  TraceId = 'TRACE_ID',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID'
}

export type TripIncidentIssueDocumentCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripIncidentIssueDocumentCsvColumnEnum;
};

export enum TripIncidentIssueDocumentCsvColumnEnum {
  ContentType = 'CONTENT_TYPE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  FileSize = 'FILE_SIZE',
  Id = 'ID',
  IssueId = 'ISSUE_ID',
  Md5 = 'MD5',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripIncidentIssueWithCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripIncidentIssueWithCacheCsvColumnEnum;
};

export enum TripIncidentIssueWithCacheCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewInfo = 'CREW_INFO',
  CrewInvolved = 'CREW_INVOLVED',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Description = 'DESCRIPTION',
  DispatcherEmployeeId = 'DISPATCHER_EMPLOYEE_ID',
  DispatcherFirstName = 'DISPATCHER_FIRST_NAME',
  DispatcherId = 'DISPATCHER_ID',
  DispatcherLastName = 'DISPATCHER_LAST_NAME',
  DriverEmployeeId = 'DRIVER_EMPLOYEE_ID',
  DriverFirstName = 'DRIVER_FIRST_NAME',
  DriverId = 'DRIVER_ID',
  DriverLastName = 'DRIVER_LAST_NAME',
  Id = 'ID',
  IncidentDatetime = 'INCIDENT_DATETIME',
  IncidentOccurance = 'INCIDENT_OCCURANCE',
  IncidentOccuranceOther = 'INCIDENT_OCCURANCE_OTHER',
  IncidentWitnesses = 'INCIDENT_WITNESSES',
  ManagerEmployeeId = 'MANAGER_EMPLOYEE_ID',
  ManagerFirstName = 'MANAGER_FIRST_NAME',
  ManagerId = 'MANAGER_ID',
  ManagerLastName = 'MANAGER_LAST_NAME',
  MedicalAttentionType = 'MEDICAL_ATTENTION_TYPE',
  MedicalInjuries = 'MEDICAL_INJURIES',
  MedicalNeeded = 'MEDICAL_NEEDED',
  OutboundDatetime = 'OUTBOUND_DATETIME',
  OutboundFlightName = 'OUTBOUND_FLIGHT_NAME',
  OutboundFlightNumber = 'OUTBOUND_FLIGHT_NUMBER',
  PropertyDamage = 'PROPERTY_DAMAGE',
  PropertyDamageDescription = 'PROPERTY_DAMAGE_DESCRIPTION',
  RecoveryInfo = 'RECOVERY_INFO',
  SamsaraCameraWorking = 'SAMSARA_CAMERA_WORKING',
  Station = 'STATION',
  TraceId = 'TRACE_ID',
  TripFlightNumber = 'TRIP_FLIGHT_NUMBER',
  TripId = 'TRIP_ID',
  TripLoopName = 'TRIP_LOOP_NAME',
  TripScheduled = 'TRIP_SCHEDULED',
  TripServicerIataAirlineCode = 'TRIP_SERVICER_IATA_AIRLINE_CODE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID',
  VehicleTrackingId = 'VEHICLE_TRACKING_ID'
}

export type TripIssueCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripIssueCsvColumnEnum;
};

export enum TripIssueCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DriverId = 'DRIVER_ID',
  Id = 'ID',
  Message = 'MESSAGE',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripLatestRateCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripLatestRateCsvColumnEnum;
};

export enum TripLatestRateCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Currency = 'CURRENCY',
  Duration = 'DURATION',
  EndDatetime = 'END_DATETIME',
  Id = 'ID',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Rate = 'RATE',
  RateHistoryId = 'RATE_HISTORY_ID',
  RateItemId = 'RATE_ITEM_ID',
  StartDatetime = 'START_DATETIME',
  ThatLocationId = 'THAT_LOCATION_ID',
  ThisLocationId = 'THIS_LOCATION_ID',
  TripDistance = 'TRIP_DISTANCE',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripLatestRateHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripLatestRateHistoryCsvColumnEnum;
};

export enum TripLatestRateHistoryCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Currency = 'CURRENCY',
  EndDatetime = 'END_DATETIME',
  Id = 'ID',
  Rate = 'RATE',
  RateGroupId = 'RATE_GROUP_ID',
  RateItemId = 'RATE_ITEM_ID',
  Rn = 'RN',
  StartDatetime = 'START_DATETIME',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripLostAndFoundIssueCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripLostAndFoundIssueCsvColumnEnum;
};

export enum TripLostAndFoundIssueCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewAirportCode = 'CREW_AIRPORT_CODE',
  CrewDriverName = 'CREW_DRIVER_NAME',
  CrewFlightName = 'CREW_FLIGHT_NAME',
  CrewFlightNumber = 'CREW_FLIGHT_NUMBER',
  CrewMemberEmail = 'CREW_MEMBER_EMAIL',
  CrewMemberName = 'CREW_MEMBER_NAME',
  CrewMemberPhone = 'CREW_MEMBER_PHONE',
  Datetime = 'DATETIME',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Description = 'DESCRIPTION',
  DispatcherId = 'DISPATCHER_ID',
  DriverId = 'DRIVER_ID',
  Id = 'ID',
  ItemLost = 'ITEM_LOST',
  Notes = 'NOTES',
  OutboundDatetime = 'OUTBOUND_DATETIME',
  OutboundFlightName = 'OUTBOUND_FLIGHT_NAME',
  OutboundFlightNumber = 'OUTBOUND_FLIGHT_NUMBER',
  ReturnStatus = 'RETURN_STATUS',
  ShippingAddress = 'SHIPPING_ADDRESS',
  ShippingCity = 'SHIPPING_CITY',
  ShippingCost = 'SHIPPING_COST',
  ShippingMethod = 'SHIPPING_METHOD',
  ShippingStateCode = 'SHIPPING_STATE_CODE',
  ShippingZipCode = 'SHIPPING_ZIP_CODE',
  TraceId = 'TRACE_ID',
  TrackingNumber = 'TRACKING_NUMBER',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID'
}

export type TripLostAndFoundIssueDocumentCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripLostAndFoundIssueDocumentCsvColumnEnum;
};

export enum TripLostAndFoundIssueDocumentCsvColumnEnum {
  ContentType = 'CONTENT_TYPE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  FileSize = 'FILE_SIZE',
  Id = 'ID',
  IssueId = 'ISSUE_ID',
  Md5 = 'MD5',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripLostAndFoundIssueWithCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripLostAndFoundIssueWithCacheCsvColumnEnum;
};

export enum TripLostAndFoundIssueWithCacheCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewAirportCode = 'CREW_AIRPORT_CODE',
  CrewDriverName = 'CREW_DRIVER_NAME',
  CrewFlightName = 'CREW_FLIGHT_NAME',
  CrewFlightNumber = 'CREW_FLIGHT_NUMBER',
  CrewMemberEmail = 'CREW_MEMBER_EMAIL',
  CrewMemberName = 'CREW_MEMBER_NAME',
  CrewMemberPhone = 'CREW_MEMBER_PHONE',
  Datetime = 'DATETIME',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Description = 'DESCRIPTION',
  DispatcherEmployeeId = 'DISPATCHER_EMPLOYEE_ID',
  DispatcherFirstName = 'DISPATCHER_FIRST_NAME',
  DispatcherId = 'DISPATCHER_ID',
  DispatcherLastName = 'DISPATCHER_LAST_NAME',
  DriverEmployeeId = 'DRIVER_EMPLOYEE_ID',
  DriverFirstName = 'DRIVER_FIRST_NAME',
  DriverId = 'DRIVER_ID',
  DriverLastName = 'DRIVER_LAST_NAME',
  Id = 'ID',
  ItemLost = 'ITEM_LOST',
  Notes = 'NOTES',
  OutboundDatetime = 'OUTBOUND_DATETIME',
  OutboundFlightName = 'OUTBOUND_FLIGHT_NAME',
  OutboundFlightNumber = 'OUTBOUND_FLIGHT_NUMBER',
  ReturnStatus = 'RETURN_STATUS',
  ShippingAddress = 'SHIPPING_ADDRESS',
  ShippingCity = 'SHIPPING_CITY',
  ShippingCost = 'SHIPPING_COST',
  ShippingMethod = 'SHIPPING_METHOD',
  ShippingStateCode = 'SHIPPING_STATE_CODE',
  ShippingZipCode = 'SHIPPING_ZIP_CODE',
  TraceId = 'TRACE_ID',
  TrackingNumber = 'TRACKING_NUMBER',
  TripAirportCode = 'TRIP_AIRPORT_CODE',
  TripFlightNumber = 'TRIP_FLIGHT_NUMBER',
  TripId = 'TRIP_ID',
  TripLoopName = 'TRIP_LOOP_NAME',
  TripScheduled = 'TRIP_SCHEDULED',
  TripServicerIataAirlineCode = 'TRIP_SERVICER_IATA_AIRLINE_CODE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID',
  VehicleTrackingId = 'VEHICLE_TRACKING_ID'
}

export type TripProviderCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripProviderCacheCsvColumnEnum;
};

export enum TripProviderCacheCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DisplayName = 'DISPLAY_NAME',
  Id = 'ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripRateCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripRateCsvColumnEnum;
};

export enum TripRateCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CompanyId = 'COMPANY_ID',
  ContractEndDatetime = 'CONTRACT_END_DATETIME',
  ContractId = 'CONTRACT_ID',
  ContractStartDatetime = 'CONTRACT_START_DATETIME',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Currency = 'CURRENCY',
  Duration = 'DURATION',
  EndDatetime = 'END_DATETIME',
  Id = 'ID',
  Name = 'NAME',
  Notes = 'NOTES',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  ProviderId = 'PROVIDER_ID',
  Radius = 'RADIUS',
  Rate = 'RATE',
  StartDatetime = 'START_DATETIME',
  ThatLocationId = 'THAT_LOCATION_ID',
  ThisLocationId = 'THIS_LOCATION_ID',
  TripDistance = 'TRIP_DISTANCE',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripRateGroupCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripRateGroupCsvColumnEnum;
};

export enum TripRateGroupCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Duration = 'DURATION',
  Id = 'ID',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  ThatLocationId = 'THAT_LOCATION_ID',
  ThisLocationId = 'THIS_LOCATION_ID',
  TripDistance = 'TRIP_DISTANCE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripRateGroupWithLatestRateHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripRateGroupWithLatestRateHistoryCsvColumnEnum;
};

export enum TripRateGroupWithLatestRateHistoryCsvColumnEnum {
  CompanyId = 'COMPANY_ID',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Rate = 'RATE',
  RateGroupId = 'RATE_GROUP_ID',
  RateHistoryId = 'RATE_HISTORY_ID',
  RateItemCurrency = 'RATE_ITEM_CURRENCY',
  RateItemEndDatetime = 'RATE_ITEM_END_DATETIME',
  RateItemId = 'RATE_ITEM_ID',
  RateItemStartDatetime = 'RATE_ITEM_START_DATETIME',
  RateItemType = 'RATE_ITEM_TYPE',
  ThatLocationId = 'THAT_LOCATION_ID',
  ThisLocationId = 'THIS_LOCATION_ID'
}

export type TripRateHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripRateHistoryCsvColumnEnum;
};

export enum TripRateHistoryCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Currency = 'CURRENCY',
  EndDatetime = 'END_DATETIME',
  Id = 'ID',
  Rate = 'RATE',
  RateGroupId = 'RATE_GROUP_ID',
  RateItemId = 'RATE_ITEM_ID',
  StartDatetime = 'START_DATETIME',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripRateHistoryWithRateGroupCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripRateHistoryWithRateGroupCsvColumnEnum;
};

export enum TripRateHistoryWithRateGroupCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Currency = 'CURRENCY',
  Duration = 'DURATION',
  EndDatetime = 'END_DATETIME',
  Id = 'ID',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Rate = 'RATE',
  RateGroupId = 'RATE_GROUP_ID',
  RateItemId = 'RATE_ITEM_ID',
  StartDatetime = 'START_DATETIME',
  ThatLocationId = 'THAT_LOCATION_ID',
  ThisLocationId = 'THIS_LOCATION_ID',
  TripDistance = 'TRIP_DISTANCE',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripRateItemCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripRateItemCsvColumnEnum;
};

export enum TripRateItemCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Currency = 'CURRENCY',
  EndDatetime = 'END_DATETIME',
  Id = 'ID',
  RateGroupId = 'RATE_GROUP_ID',
  StartDatetime = 'START_DATETIME',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripRateItemWithLatestRateHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripRateItemWithLatestRateHistoryCsvColumnEnum;
};

export enum TripRateItemWithLatestRateHistoryCsvColumnEnum {
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Currency = 'CURRENCY',
  EndDatetime = 'END_DATETIME',
  Id = 'ID',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Rate = 'RATE',
  RateGroupId = 'RATE_GROUP_ID',
  RateHistoryId = 'RATE_HISTORY_ID',
  StartDatetime = 'START_DATETIME',
  ThatLocationId = 'THAT_LOCATION_ID',
  ThisLocationId = 'THIS_LOCATION_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripStopCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripStopCsvColumnEnum;
};

export enum TripStopCsvColumnEnum {
  Actual = 'ACTUAL',
  AirportCode = 'AIRPORT_CODE',
  Completed = 'COMPLETED',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  LocationId = 'LOCATION_ID',
  Scheduled = 'SCHEDULED',
  TripId = 'TRIP_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripTrackFlightCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTrackFlightCsvColumnEnum;
};

export enum TripTrackFlightCsvColumnEnum {
  Actual = 'ACTUAL',
  ArrivalGate = 'ARRIVAL_GATE',
  ArrivalTerminal = 'ARRIVAL_TERMINAL',
  ArrivalTimezone = 'ARRIVAL_TIMEZONE',
  ArrivalUtcOffsetHours = 'ARRIVAL_UTC_OFFSET_HOURS',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DepartureGate = 'DEPARTURE_GATE',
  DepartureTerminal = 'DEPARTURE_TERMINAL',
  DepartureTimezone = 'DEPARTURE_TIMEZONE',
  DepartureUtcOffsetHours = 'DEPARTURE_UTC_OFFSET_HOURS',
  FlightHistoryId = 'FLIGHT_HISTORY_ID',
  Id = 'ID',
  Label = 'LABEL',
  LandedAt = 'LANDED_AT',
  LastPingTime = 'LAST_PING_TIME',
  LastWebhookReceivedAt = 'LAST_WEBHOOK_RECEIVED_AT',
  NextPingTime = 'NEXT_PING_TIME',
  Number = 'NUMBER',
  Raw = 'RAW',
  Scheduled = 'SCHEDULED',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Status = 'STATUS',
  TrackerProvider = 'TRACKER_PROVIDER',
  TripId = 'TRIP_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripCsvColumnEnum;
};

export enum TripTripCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Attendants = 'ATTENDANTS',
  CombineId = 'COMBINE_ID',
  CombineType = 'COMBINE_TYPE',
  CompanyId = 'COMPANY_ID',
  CompletionId = 'COMPLETION_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewId = 'CREW_ID',
  CurbsideAt = 'CURBSIDE_AT',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DoActualDatetime = 'DO_ACTUAL_DATETIME',
  DoAirportCode = 'DO_AIRPORT_CODE',
  DoLocationId = 'DO_LOCATION_ID',
  DriverCrewCount = 'DRIVER_CREW_COUNT',
  DriverId = 'DRIVER_ID',
  EtaMinutes = 'ETA_MINUTES',
  FirstName = 'FIRST_NAME',
  FlightNumber = 'FLIGHT_NUMBER',
  FromManifest = 'FROM_MANIFEST',
  Id = 'ID',
  ImportTime = 'IMPORT_TIME',
  IsIllegalCombine = 'IS_ILLEGAL_COMBINE',
  Kind = 'KIND',
  LastName = 'LAST_NAME',
  LegacyId = 'LEGACY_ID',
  LoopName = 'LOOP_NAME',
  ManifestImportId = 'MANIFEST_IMPORT_ID',
  Offset = 'OFFSET',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Pilots = 'PILOTS',
  PlannedAt = 'PLANNED_AT',
  ProviderId = 'PROVIDER_ID',
  PuActualDatetime = 'PU_ACTUAL_DATETIME',
  PuCompletedDatetime = 'PU_COMPLETED_DATETIME',
  PuGpsDatetime = 'PU_GPS_DATETIME',
  PuLocationId = 'PU_LOCATION_ID',
  RateHistoryId = 'RATE_HISTORY_ID',
  RateId = 'RATE_ID',
  Scheduled = 'SCHEDULED',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Split = 'SPLIT',
  Status = 'STATUS',
  TraceId = 'TRACE_ID',
  TrackFlightId = 'TRACK_FLIGHT_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID'
}

export type TripTripDocumentCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripDocumentCsvColumnEnum;
};

export enum TripTripDocumentCsvColumnEnum {
  ContentType = 'CONTENT_TYPE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  FileSize = 'FILE_SIZE',
  Id = 'ID',
  Md5 = 'MD5',
  TraceId = 'TRACE_ID',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripTripDocumentWithCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripDocumentWithCacheCsvColumnEnum;
};

export enum TripTripDocumentWithCacheCsvColumnEnum {
  ContentType = 'CONTENT_TYPE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CreatedByFirstName = 'CREATED_BY_FIRST_NAME',
  CreatedByLastName = 'CREATED_BY_LAST_NAME',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DeletedByFirstName = 'DELETED_BY_FIRST_NAME',
  DeletedByLastName = 'DELETED_BY_LAST_NAME',
  Filename = 'FILENAME',
  FileLocation = 'FILE_LOCATION',
  FileSize = 'FILE_SIZE',
  Id = 'ID',
  Md5 = 'MD5',
  TraceId = 'TRACE_ID',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripTripHasImportCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripHasImportCsvColumnEnum;
};

export enum TripTripHasImportCsvColumnEnum {
  ImportId = 'IMPORT_ID',
  TripId = 'TRIP_ID'
}

export type TripTripScheduleTriggerCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripScheduleTriggerCsvColumnEnum;
};

export enum TripTripScheduleTriggerCsvColumnEnum {
  AccidentIssueCount = 'ACCIDENT_ISSUE_COUNT',
  CommunicationCount = 'COMMUNICATION_COUNT',
  CompletionTypeDisplayName = 'COMPLETION_TYPE_DISPLAY_NAME',
  DeletedAt = 'DELETED_AT',
  DispatchIssueCount = 'DISPATCH_ISSUE_COUNT',
  DoLocationAddress = 'DO_LOCATION_ADDRESS',
  DoLocationCityName = 'DO_LOCATION_CITY_NAME',
  DoLocationCoordinates = 'DO_LOCATION_COORDINATES',
  DoLocationId = 'DO_LOCATION_ID',
  DoLocationName = 'DO_LOCATION_NAME',
  DoLocationPhoneNumber = 'DO_LOCATION_PHONE_NUMBER',
  DoLocationStateCode = 'DO_LOCATION_STATE_CODE',
  DoLocationZipCode = 'DO_LOCATION_ZIP_CODE',
  DriverAvatar = 'DRIVER_AVATAR',
  DriverEmployeeId = 'DRIVER_EMPLOYEE_ID',
  DriverEtaDatetime = 'DRIVER_ETA_DATETIME',
  DriverEtaId = 'DRIVER_ETA_ID',
  DriverEtaMinutes = 'DRIVER_ETA_MINUTES',
  DriverFirstName = 'DRIVER_FIRST_NAME',
  DriverId = 'DRIVER_ID',
  DriverLastName = 'DRIVER_LAST_NAME',
  FcrCount = 'FCR_COUNT',
  FlagColors = 'FLAG_COLORS',
  HasPaperwork = 'HAS_PAPERWORK',
  Id = 'ID',
  IncidentIssueCount = 'INCIDENT_ISSUE_COUNT',
  LatestScheduled = 'LATEST_SCHEDULED',
  LatestScheduledUtc = 'LATEST_SCHEDULED_UTC',
  LatestTriggerUsed = 'LATEST_TRIGGER_USED',
  LostAndFoundIssueCount = 'LOST_AND_FOUND_ISSUE_COUNT',
  PayerProviderDisplayName = 'PAYER_PROVIDER_DISPLAY_NAME',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  PuLocationAddress = 'PU_LOCATION_ADDRESS',
  PuLocationCityName = 'PU_LOCATION_CITY_NAME',
  PuLocationCoordinates = 'PU_LOCATION_COORDINATES',
  PuLocationId = 'PU_LOCATION_ID',
  PuLocationName = 'PU_LOCATION_NAME',
  PuLocationPhoneNumber = 'PU_LOCATION_PHONE_NUMBER',
  PuLocationStateCode = 'PU_LOCATION_STATE_CODE',
  PuLocationZipCode = 'PU_LOCATION_ZIP_CODE',
  ScheduledUtc = 'SCHEDULED_UTC',
  StopCount = 'STOP_COUNT',
  TripId = 'TRIP_ID',
  VehicleCapacity = 'VEHICLE_CAPACITY',
  VehicleId = 'VEHICLE_ID',
  VehicleMake = 'VEHICLE_MAKE',
  VehicleModel = 'VEHICLE_MODEL',
  VehiclePhoneNumber = 'VEHICLE_PHONE_NUMBER',
  VehicleTrackingId = 'VEHICLE_TRACKING_ID'
}

export type TripTripWithCompletionAndRateCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripWithCompletionAndRateCsvColumnEnum;
};

export enum TripTripWithCompletionAndRateCsvColumnEnum {
  AccidentIssueCount = 'ACCIDENT_ISSUE_COUNT',
  Actual = 'ACTUAL',
  AirportCode = 'AIRPORT_CODE',
  Attendants = 'ATTENDANTS',
  CachedDoLocationId = 'CACHED_DO_LOCATION_ID',
  CachedDriverId = 'CACHED_DRIVER_ID',
  CachedPayerProviderId = 'CACHED_PAYER_PROVIDER_ID',
  CachedPuLocationId = 'CACHED_PU_LOCATION_ID',
  CachedVehicleId = 'CACHED_VEHICLE_ID',
  CombineId = 'COMBINE_ID',
  CombineType = 'COMBINE_TYPE',
  CommunicationCount = 'COMMUNICATION_COUNT',
  CompanyId = 'COMPANY_ID',
  CompletionComment = 'COMPLETION_COMMENT',
  CompletionCost = 'COMPLETION_COST',
  CompletionCreatedAt = 'COMPLETION_CREATED_AT',
  CompletionCreatedBy = 'COMPLETION_CREATED_BY',
  CompletionCurrency = 'COMPLETION_CURRENCY',
  CompletionDatetime = 'COMPLETION_DATETIME',
  CompletionDistanceMeters = 'COMPLETION_DISTANCE_METERS',
  CompletionEfficiency = 'COMPLETION_EFFICIENCY',
  CompletionEquivalency = 'COMPLETION_EQUIVALENCY',
  CompletionId = 'COMPLETION_ID',
  CompletionTypeDisplayName = 'COMPLETION_TYPE_DISPLAY_NAME',
  CompletionTypeId = 'COMPLETION_TYPE_ID',
  CompletionUpdatedAt = 'COMPLETION_UPDATED_AT',
  CompletionUpdatedBy = 'COMPLETION_UPDATED_BY',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewId = 'CREW_ID',
  CurbsideAt = 'CURBSIDE_AT',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DispatchIssueCount = 'DISPATCH_ISSUE_COUNT',
  DoActualDatetime = 'DO_ACTUAL_DATETIME',
  DoAirportCode = 'DO_AIRPORT_CODE',
  DoLocationAddress = 'DO_LOCATION_ADDRESS',
  DoLocationCityName = 'DO_LOCATION_CITY_NAME',
  DoLocationCoordinates = 'DO_LOCATION_COORDINATES',
  DoLocationId = 'DO_LOCATION_ID',
  DoLocationName = 'DO_LOCATION_NAME',
  DoLocationPhoneNumber = 'DO_LOCATION_PHONE_NUMBER',
  DoLocationStateCode = 'DO_LOCATION_STATE_CODE',
  DoLocationZipCode = 'DO_LOCATION_ZIP_CODE',
  DriverAvatar = 'DRIVER_AVATAR',
  DriverCrewCount = 'DRIVER_CREW_COUNT',
  DriverEmployeeId = 'DRIVER_EMPLOYEE_ID',
  DriverEtaDatetime = 'DRIVER_ETA_DATETIME',
  DriverEtaId = 'DRIVER_ETA_ID',
  DriverEtaMinutes = 'DRIVER_ETA_MINUTES',
  DriverFirstName = 'DRIVER_FIRST_NAME',
  DriverId = 'DRIVER_ID',
  DriverLastName = 'DRIVER_LAST_NAME',
  EtaMinutes = 'ETA_MINUTES',
  FcrCount = 'FCR_COUNT',
  FirstName = 'FIRST_NAME',
  FlagColors = 'FLAG_COLORS',
  FlightNumber = 'FLIGHT_NUMBER',
  FromManifest = 'FROM_MANIFEST',
  HasPaperwork = 'HAS_PAPERWORK',
  Id = 'ID',
  ImportTime = 'IMPORT_TIME',
  IncidentIssueCount = 'INCIDENT_ISSUE_COUNT',
  IsIllegalCombine = 'IS_ILLEGAL_COMBINE',
  Kind = 'KIND',
  LastName = 'LAST_NAME',
  LatestScheduled = 'LATEST_SCHEDULED',
  LatestScheduledUtc = 'LATEST_SCHEDULED_UTC',
  LegacyId = 'LEGACY_ID',
  LoopName = 'LOOP_NAME',
  LostAndFoundIssueCount = 'LOST_AND_FOUND_ISSUE_COUNT',
  ManifestImportId = 'MANIFEST_IMPORT_ID',
  Offset = 'OFFSET',
  PayerProviderDisplayName = 'PAYER_PROVIDER_DISPLAY_NAME',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Pilots = 'PILOTS',
  PlannedAt = 'PLANNED_AT',
  ProviderId = 'PROVIDER_ID',
  PuActualDatetime = 'PU_ACTUAL_DATETIME',
  PuCompletedDatetime = 'PU_COMPLETED_DATETIME',
  PuGpsDatetime = 'PU_GPS_DATETIME',
  PuLocationAddress = 'PU_LOCATION_ADDRESS',
  PuLocationCityName = 'PU_LOCATION_CITY_NAME',
  PuLocationCoordinates = 'PU_LOCATION_COORDINATES',
  PuLocationId = 'PU_LOCATION_ID',
  PuLocationName = 'PU_LOCATION_NAME',
  PuLocationPhoneNumber = 'PU_LOCATION_PHONE_NUMBER',
  PuLocationStateCode = 'PU_LOCATION_STATE_CODE',
  PuLocationZipCode = 'PU_LOCATION_ZIP_CODE',
  RateAmount = 'RATE_AMOUNT',
  RateCreatedAt = 'RATE_CREATED_AT',
  RateCreatedBy = 'RATE_CREATED_BY',
  RateCurrency = 'RATE_CURRENCY',
  RateEndDatetime = 'RATE_END_DATETIME',
  RateGroupId = 'RATE_GROUP_ID',
  RateHistoryId = 'RATE_HISTORY_ID',
  RateId = 'RATE_ID',
  RateStartDatetime = 'RATE_START_DATETIME',
  RateType = 'RATE_TYPE',
  RateUpdatedAt = 'RATE_UPDATED_AT',
  RateUpdatedBy = 'RATE_UPDATED_BY',
  Scheduled = 'SCHEDULED',
  ScheduledUtc = 'SCHEDULED_UTC',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Split = 'SPLIT',
  Status = 'STATUS',
  StopCount = 'STOP_COUNT',
  TraceId = 'TRACE_ID',
  TrackFlightArrivalGate = 'TRACK_FLIGHT_ARRIVAL_GATE',
  TrackFlightArrivalTerminal = 'TRACK_FLIGHT_ARRIVAL_TERMINAL',
  TrackFlightId = 'TRACK_FLIGHT_ID',
  TrackFlightLabel = 'TRACK_FLIGHT_LABEL',
  TrackFlightLastPingTime = 'TRACK_FLIGHT_LAST_PING_TIME',
  TrackFlightOrigin = 'TRACK_FLIGHT_ORIGIN',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleCapacity = 'VEHICLE_CAPACITY',
  VehicleId = 'VEHICLE_ID',
  VehicleMake = 'VEHICLE_MAKE',
  VehicleModel = 'VEHICLE_MODEL',
  VehiclePhoneNumber = 'VEHICLE_PHONE_NUMBER',
  VehicleTrackingId = 'VEHICLE_TRACKING_ID'
}

export type TripTripWithCompletionCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripWithCompletionCsvColumnEnum;
};

export enum TripTripWithCompletionCsvColumnEnum {
  Actual = 'ACTUAL',
  AirportCode = 'AIRPORT_CODE',
  Attendants = 'ATTENDANTS',
  CombineId = 'COMBINE_ID',
  CombineType = 'COMBINE_TYPE',
  CompanyId = 'COMPANY_ID',
  CompletionCost = 'COMPLETION_COST',
  CompletionDatetime = 'COMPLETION_DATETIME',
  CompletionId = 'COMPLETION_ID',
  CompletionTypeId = 'COMPLETION_TYPE_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewId = 'CREW_ID',
  CurbsideAt = 'CURBSIDE_AT',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DoActualDatetime = 'DO_ACTUAL_DATETIME',
  DoAirportCode = 'DO_AIRPORT_CODE',
  DoLocationId = 'DO_LOCATION_ID',
  DriverCrewCount = 'DRIVER_CREW_COUNT',
  DriverId = 'DRIVER_ID',
  EtaMinutes = 'ETA_MINUTES',
  FirstName = 'FIRST_NAME',
  FlightNumber = 'FLIGHT_NUMBER',
  FromManifest = 'FROM_MANIFEST',
  Id = 'ID',
  ImportTime = 'IMPORT_TIME',
  IsIllegalCombine = 'IS_ILLEGAL_COMBINE',
  Kind = 'KIND',
  LastName = 'LAST_NAME',
  LatestScheduled = 'LATEST_SCHEDULED',
  LatestScheduledUtc = 'LATEST_SCHEDULED_UTC',
  LegacyId = 'LEGACY_ID',
  LoopName = 'LOOP_NAME',
  ManifestImportId = 'MANIFEST_IMPORT_ID',
  Offset = 'OFFSET',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Pilots = 'PILOTS',
  PlannedAt = 'PLANNED_AT',
  ProviderId = 'PROVIDER_ID',
  PuActualDatetime = 'PU_ACTUAL_DATETIME',
  PuCompletedDatetime = 'PU_COMPLETED_DATETIME',
  PuGpsDatetime = 'PU_GPS_DATETIME',
  PuLocationId = 'PU_LOCATION_ID',
  RateHistoryId = 'RATE_HISTORY_ID',
  RateId = 'RATE_ID',
  Scheduled = 'SCHEDULED',
  ScheduledUtc = 'SCHEDULED_UTC',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Split = 'SPLIT',
  Status = 'STATUS',
  TraceId = 'TRACE_ID',
  TrackFlightId = 'TRACK_FLIGHT_ID',
  TrackFlightOrigin = 'TRACK_FLIGHT_ORIGIN',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID'
}

export type TripTripWithFcrInnerJoinCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripWithFcrInnerJoinCsvColumnEnum;
};

export enum TripTripWithFcrInnerJoinCsvColumnEnum {
  AccidentIssueCount = 'ACCIDENT_ISSUE_COUNT',
  AirportCode = 'AIRPORT_CODE',
  Attendants = 'ATTENDANTS',
  CombineId = 'COMBINE_ID',
  CombineType = 'COMBINE_TYPE',
  CompanyId = 'COMPANY_ID',
  CompletionId = 'COMPLETION_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewId = 'CREW_ID',
  CurbsideAt = 'CURBSIDE_AT',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DispatchIssueCount = 'DISPATCH_ISSUE_COUNT',
  DoActualDatetime = 'DO_ACTUAL_DATETIME',
  DoAirportCode = 'DO_AIRPORT_CODE',
  DoLocationId = 'DO_LOCATION_ID',
  DriverCrewCount = 'DRIVER_CREW_COUNT',
  DriverId = 'DRIVER_ID',
  EtaMinutes = 'ETA_MINUTES',
  FcrCause = 'FCR_CAUSE',
  FcrDescription = 'FCR_DESCRIPTION',
  FcrId = 'FCR_ID',
  FcrReason = 'FCR_REASON',
  FcrReporter = 'FCR_REPORTER',
  FirstName = 'FIRST_NAME',
  FlightNumber = 'FLIGHT_NUMBER',
  FromManifest = 'FROM_MANIFEST',
  HasPaperwork = 'HAS_PAPERWORK',
  Id = 'ID',
  ImportTime = 'IMPORT_TIME',
  IncidentIssueCount = 'INCIDENT_ISSUE_COUNT',
  IsIllegalCombine = 'IS_ILLEGAL_COMBINE',
  Kind = 'KIND',
  LastName = 'LAST_NAME',
  LatestScheduled = 'LATEST_SCHEDULED',
  LatestScheduledUtc = 'LATEST_SCHEDULED_UTC',
  LegacyId = 'LEGACY_ID',
  LoopName = 'LOOP_NAME',
  LostAndFoundIssueCount = 'LOST_AND_FOUND_ISSUE_COUNT',
  ManifestImportId = 'MANIFEST_IMPORT_ID',
  Offset = 'OFFSET',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Pilots = 'PILOTS',
  PlannedAt = 'PLANNED_AT',
  ProviderDisplayName = 'PROVIDER_DISPLAY_NAME',
  ProviderId = 'PROVIDER_ID',
  PuActualDatetime = 'PU_ACTUAL_DATETIME',
  PuCompletedDatetime = 'PU_COMPLETED_DATETIME',
  PuGpsDatetime = 'PU_GPS_DATETIME',
  PuLocationId = 'PU_LOCATION_ID',
  RateHistoryId = 'RATE_HISTORY_ID',
  RateId = 'RATE_ID',
  Scheduled = 'SCHEDULED',
  ScheduledUtc = 'SCHEDULED_UTC',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Split = 'SPLIT',
  Status = 'STATUS',
  TraceId = 'TRACE_ID',
  TrackFlightId = 'TRACK_FLIGHT_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID'
}

export type TripTripWithFlagInnerJoinCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripWithFlagInnerJoinCsvColumnEnum;
};

export enum TripTripWithFlagInnerJoinCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Attendants = 'ATTENDANTS',
  CombineId = 'COMBINE_ID',
  CombineType = 'COMBINE_TYPE',
  CompanyId = 'COMPANY_ID',
  CompletionId = 'COMPLETION_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewId = 'CREW_ID',
  CurbsideAt = 'CURBSIDE_AT',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DoActualDatetime = 'DO_ACTUAL_DATETIME',
  DoAirportCode = 'DO_AIRPORT_CODE',
  DoLocationId = 'DO_LOCATION_ID',
  DriverCrewCount = 'DRIVER_CREW_COUNT',
  DriverId = 'DRIVER_ID',
  EtaMinutes = 'ETA_MINUTES',
  FirstName = 'FIRST_NAME',
  FlightNumber = 'FLIGHT_NUMBER',
  FromManifest = 'FROM_MANIFEST',
  Id = 'ID',
  ImportTime = 'IMPORT_TIME',
  IsIllegalCombine = 'IS_ILLEGAL_COMBINE',
  Kind = 'KIND',
  LastName = 'LAST_NAME',
  LatestScheduled = 'LATEST_SCHEDULED',
  LatestScheduledUtc = 'LATEST_SCHEDULED_UTC',
  LegacyId = 'LEGACY_ID',
  LoopName = 'LOOP_NAME',
  ManifestImportId = 'MANIFEST_IMPORT_ID',
  Offset = 'OFFSET',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Pilots = 'PILOTS',
  PlannedAt = 'PLANNED_AT',
  ProviderId = 'PROVIDER_ID',
  PuActualDatetime = 'PU_ACTUAL_DATETIME',
  PuCompletedDatetime = 'PU_COMPLETED_DATETIME',
  PuGpsDatetime = 'PU_GPS_DATETIME',
  PuLocationId = 'PU_LOCATION_ID',
  RateHistoryId = 'RATE_HISTORY_ID',
  RateId = 'RATE_ID',
  Scheduled = 'SCHEDULED',
  ScheduledUtc = 'SCHEDULED_UTC',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Split = 'SPLIT',
  Status = 'STATUS',
  TraceId = 'TRACE_ID',
  TrackFlightId = 'TRACK_FLIGHT_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID'
}

export type TripTripWithRateCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripWithRateCsvColumnEnum;
};

export enum TripTripWithRateCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Attendants = 'ATTENDANTS',
  CombineId = 'COMBINE_ID',
  CombineType = 'COMBINE_TYPE',
  CompanyId = 'COMPANY_ID',
  CompletionId = 'COMPLETION_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewId = 'CREW_ID',
  CurbsideAt = 'CURBSIDE_AT',
  Currency = 'CURRENCY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DoActualDatetime = 'DO_ACTUAL_DATETIME',
  DoAirportCode = 'DO_AIRPORT_CODE',
  DoLocationId = 'DO_LOCATION_ID',
  DriverCrewCount = 'DRIVER_CREW_COUNT',
  DriverId = 'DRIVER_ID',
  EtaMinutes = 'ETA_MINUTES',
  FirstName = 'FIRST_NAME',
  FlightNumber = 'FLIGHT_NUMBER',
  FromManifest = 'FROM_MANIFEST',
  Id = 'ID',
  ImportTime = 'IMPORT_TIME',
  IsIllegalCombine = 'IS_ILLEGAL_COMBINE',
  Kind = 'KIND',
  LastName = 'LAST_NAME',
  LegacyId = 'LEGACY_ID',
  LoopName = 'LOOP_NAME',
  ManifestImportId = 'MANIFEST_IMPORT_ID',
  Offset = 'OFFSET',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Pilots = 'PILOTS',
  PlannedAt = 'PLANNED_AT',
  ProviderId = 'PROVIDER_ID',
  PuActualDatetime = 'PU_ACTUAL_DATETIME',
  PuCompletedDatetime = 'PU_COMPLETED_DATETIME',
  PuGpsDatetime = 'PU_GPS_DATETIME',
  PuLocationId = 'PU_LOCATION_ID',
  Rate = 'RATE',
  RateGroupId = 'RATE_GROUP_ID',
  RateHistoryId = 'RATE_HISTORY_ID',
  RateId = 'RATE_ID',
  Scheduled = 'SCHEDULED',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Split = 'SPLIT',
  Status = 'STATUS',
  TraceId = 'TRACE_ID',
  TrackFlightId = 'TRACK_FLIGHT_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID'
}

export type TripTripWithRateForAuditReportCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripWithRateForAuditReportCsvColumnEnum;
};

export enum TripTripWithRateForAuditReportCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  CombineId = 'COMBINE_ID',
  CombineType = 'COMBINE_TYPE',
  CompanyId = 'COMPANY_ID',
  Currency = 'CURRENCY',
  DeletedAt = 'DELETED_AT',
  Id = 'ID',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Rate = 'RATE',
  RateId = 'RATE_ID',
  RateType = 'RATE_TYPE',
  Scheduled = 'SCHEDULED',
  Status = 'STATUS',
  Type = 'TYPE'
}

export type TripTripWithTrackFlightCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripWithTrackFlightCsvColumnEnum;
};

export enum TripTripWithTrackFlightCsvColumnEnum {
  Actual = 'ACTUAL',
  AirportCode = 'AIRPORT_CODE',
  ArrivalGate = 'ARRIVAL_GATE',
  ArrivalTerminal = 'ARRIVAL_TERMINAL',
  ArrivalTimezone = 'ARRIVAL_TIMEZONE',
  ArrivalUtcOffsetHours = 'ARRIVAL_UTC_OFFSET_HOURS',
  Attendants = 'ATTENDANTS',
  CombineId = 'COMBINE_ID',
  CombineType = 'COMBINE_TYPE',
  CompanyId = 'COMPANY_ID',
  CompletionId = 'COMPLETION_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewId = 'CREW_ID',
  CurbsideAt = 'CURBSIDE_AT',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DepartureGate = 'DEPARTURE_GATE',
  DepartureTerminal = 'DEPARTURE_TERMINAL',
  DepartureTimezone = 'DEPARTURE_TIMEZONE',
  DepartureUtcOffsetHours = 'DEPARTURE_UTC_OFFSET_HOURS',
  DoActualDatetime = 'DO_ACTUAL_DATETIME',
  DoAirportCode = 'DO_AIRPORT_CODE',
  DoLocationId = 'DO_LOCATION_ID',
  DriverCrewCount = 'DRIVER_CREW_COUNT',
  DriverId = 'DRIVER_ID',
  EtaMinutes = 'ETA_MINUTES',
  FirstName = 'FIRST_NAME',
  FlightNumber = 'FLIGHT_NUMBER',
  FromManifest = 'FROM_MANIFEST',
  Id = 'ID',
  ImportTime = 'IMPORT_TIME',
  IsIllegalCombine = 'IS_ILLEGAL_COMBINE',
  Kind = 'KIND',
  Label = 'LABEL',
  LastName = 'LAST_NAME',
  LastPingTime = 'LAST_PING_TIME',
  LastWebhookReceivedAt = 'LAST_WEBHOOK_RECEIVED_AT',
  LatestScheduledUtc = 'LATEST_SCHEDULED_UTC',
  LegacyId = 'LEGACY_ID',
  LoopName = 'LOOP_NAME',
  ManifestImportId = 'MANIFEST_IMPORT_ID',
  NextPingTime = 'NEXT_PING_TIME',
  Offset = 'OFFSET',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Pilots = 'PILOTS',
  PlannedAt = 'PLANNED_AT',
  ProviderId = 'PROVIDER_ID',
  PuActualDatetime = 'PU_ACTUAL_DATETIME',
  PuCompletedDatetime = 'PU_COMPLETED_DATETIME',
  PuGpsDatetime = 'PU_GPS_DATETIME',
  PuLocationId = 'PU_LOCATION_ID',
  RateHistoryId = 'RATE_HISTORY_ID',
  RateId = 'RATE_ID',
  Scheduled = 'SCHEDULED',
  ScheduledUtc = 'SCHEDULED_UTC',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Split = 'SPLIT',
  Status = 'STATUS',
  TraceId = 'TRACE_ID',
  TrackerProvider = 'TRACKER_PROVIDER',
  TrackFlightId = 'TRACK_FLIGHT_ID',
  TrackFlightIdNew = 'TRACK_FLIGHT_ID_NEW',
  TrackFlightStatus = 'TRACK_FLIGHT_STATUS',
  TrackFlightType = 'TRACK_FLIGHT_TYPE',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID'
}

export type TripTripWithUtcCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripTripWithUtcCsvColumnEnum;
};

export enum TripTripWithUtcCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Attendants = 'ATTENDANTS',
  CombineId = 'COMBINE_ID',
  CombineType = 'COMBINE_TYPE',
  CompanyId = 'COMPANY_ID',
  CompletionId = 'COMPLETION_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewId = 'CREW_ID',
  CurbsideAt = 'CURBSIDE_AT',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DoActualDatetime = 'DO_ACTUAL_DATETIME',
  DoAirportCode = 'DO_AIRPORT_CODE',
  DoLocationId = 'DO_LOCATION_ID',
  DriverCrewCount = 'DRIVER_CREW_COUNT',
  DriverId = 'DRIVER_ID',
  EtaMinutes = 'ETA_MINUTES',
  FirstName = 'FIRST_NAME',
  FlightNumber = 'FLIGHT_NUMBER',
  FromManifest = 'FROM_MANIFEST',
  Id = 'ID',
  ImportTime = 'IMPORT_TIME',
  IsIllegalCombine = 'IS_ILLEGAL_COMBINE',
  Kind = 'KIND',
  LastName = 'LAST_NAME',
  LegacyId = 'LEGACY_ID',
  LoopName = 'LOOP_NAME',
  ManifestImportId = 'MANIFEST_IMPORT_ID',
  Offset = 'OFFSET',
  PayerProviderId = 'PAYER_PROVIDER_ID',
  Pilots = 'PILOTS',
  PlannedAt = 'PLANNED_AT',
  ProviderId = 'PROVIDER_ID',
  PuActualDatetime = 'PU_ACTUAL_DATETIME',
  PuCompletedDatetime = 'PU_COMPLETED_DATETIME',
  PuGpsDatetime = 'PU_GPS_DATETIME',
  PuLocationId = 'PU_LOCATION_ID',
  RateHistoryId = 'RATE_HISTORY_ID',
  RateId = 'RATE_ID',
  Scheduled = 'SCHEDULED',
  ScheduledUtc = 'SCHEDULED_UTC',
  ServicerIataAirlineCode = 'SERVICER_IATA_AIRLINE_CODE',
  Split = 'SPLIT',
  Status = 'STATUS',
  TraceId = 'TRACE_ID',
  TrackFlightId = 'TRACK_FLIGHT_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  VehicleId = 'VEHICLE_ID'
}

export type TripUniqueTripCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripUniqueTripCsvColumnEnum;
};

export enum TripUniqueTripCsvColumnEnum {
  CompanyId = 'COMPANY_ID',
  DeletedAt = 'DELETED_AT',
  DoLocationId = 'DO_LOCATION_ID',
  FlightNumber = 'FLIGHT_NUMBER',
  FromManifest = 'FROM_MANIFEST',
  Id = 'ID',
  LoopName = 'LOOP_NAME',
  ProviderId = 'PROVIDER_ID',
  PuLocationId = 'PU_LOCATION_ID',
  Scheduled = 'SCHEDULED',
  Split = 'SPLIT'
}

export type TripUserCacheCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripUserCacheCsvColumnEnum;
};

export enum TripUserCacheCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EmployeeId = 'EMPLOYEE_ID',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type TripVehicleCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: TripVehicleCsvColumnEnum;
};

export enum TripVehicleCsvColumnEnum {
  Active = 'ACTIVE',
  AirportPermitExpirationDate = 'AIRPORT_PERMIT_EXPIRATION_DATE',
  Capacity = 'CAPACITY',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  EmissionPermitExpirationDate = 'EMISSION_PERMIT_EXPIRATION_DATE',
  Id = 'ID',
  LicensePlate = 'LICENSE_PLATE',
  LocationId = 'LOCATION_ID',
  Make = 'MAKE',
  Model = 'MODEL',
  PhoneNumber = 'PHONE_NUMBER',
  RegistrationExpirationDate = 'REGISTRATION_EXPIRATION_DATE',
  StateRegistered = 'STATE_REGISTERED',
  TollTag = 'TOLL_TAG',
  Tracker = 'TRACKER',
  TrackingId = 'TRACKING_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Vin = 'VIN',
  Year = 'YEAR'
}

export type UserApiKeyCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserApiKeyCsvColumnEnum;
};

export enum UserApiKeyCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  ExpiresAt = 'EXPIRES_AT',
  Id = 'ID',
  KeyHash = 'KEY_HASH',
  KeyHint = 'KEY_HINT',
  LastUsedAt = 'LAST_USED_AT',
  Name = 'NAME',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type UserCharityAmountHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserCharityAmountHistoryCsvColumnEnum;
};

export enum UserCharityAmountHistoryCsvColumnEnum {
  Amount = 'AMOUNT',
  CharityId = 'CHARITY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Id = 'ID',
  TraceId = 'TRACE_ID'
}

export type UserCharityCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserCharityCsvColumnEnum;
};

export enum UserCharityCsvColumnEnum {
  Active = 'ACTIVE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewFindDriverBannerDisplayMessage = 'CREW_FIND_DRIVER_BANNER_DISPLAY_MESSAGE',
  CrewRateDriverTooltipDisplayMessage = 'CREW_RATE_DRIVER_TOOLTIP_DISPLAY_MESSAGE',
  CrewTripCompleteBannerDisplayMessage = 'CREW_TRIP_COMPLETE_BANNER_DISPLAY_MESSAGE',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DriverLoginBannerDisplayMessage = 'DRIVER_LOGIN_BANNER_DISPLAY_MESSAGE',
  Id = 'ID',
  LogoUrl = 'LOGO_URL',
  Name = 'NAME',
  TotalGoalAmount = 'TOTAL_GOAL_AMOUNT',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type UserCharityRatingHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserCharityRatingHistoryCsvColumnEnum;
};

export enum UserCharityRatingHistoryCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Amount = 'AMOUNT',
  CharityId = 'CHARITY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  ProviderDisplayName = 'PROVIDER_DISPLAY_NAME',
  ProviderId = 'PROVIDER_ID',
  Rating = 'RATING',
  RatingId = 'RATING_ID',
  UserId = 'USER_ID'
}

export type UserCharityRatingHistoryWithUserCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserCharityRatingHistoryWithUserCsvColumnEnum;
};

export enum UserCharityRatingHistoryWithUserCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  Amount = 'AMOUNT',
  CharityId = 'CHARITY_ID',
  CharityName = 'CHARITY_NAME',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  ProviderDisplayName = 'PROVIDER_DISPLAY_NAME',
  ProviderId = 'PROVIDER_ID',
  Rating = 'RATING',
  RatingId = 'RATING_ID',
  UserFirstName = 'USER_FIRST_NAME',
  UserId = 'USER_ID',
  UserLastName = 'USER_LAST_NAME'
}

export type UserCharityWithAmountHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserCharityWithAmountHistoryCsvColumnEnum;
};

export enum UserCharityWithAmountHistoryCsvColumnEnum {
  Active = 'ACTIVE',
  Amount = 'AMOUNT',
  AmountCreatedAt = 'AMOUNT_CREATED_AT',
  AmountCreatedBy = 'AMOUNT_CREATED_BY',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  CrewFindDriverBannerDisplayMessage = 'CREW_FIND_DRIVER_BANNER_DISPLAY_MESSAGE',
  CrewRateDriverTooltipDisplayMessage = 'CREW_RATE_DRIVER_TOOLTIP_DISPLAY_MESSAGE',
  CrewTripCompleteBannerDisplayMessage = 'CREW_TRIP_COMPLETE_BANNER_DISPLAY_MESSAGE',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  DriverLoginBannerDisplayMessage = 'DRIVER_LOGIN_BANNER_DISPLAY_MESSAGE',
  Id = 'ID',
  LogoUrl = 'LOGO_URL',
  Name = 'NAME',
  TotalGoalAmount = 'TOTAL_GOAL_AMOUNT',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type UserDeviceCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserDeviceCsvColumnEnum;
};

export enum UserDeviceCsvColumnEnum {
  Active = 'ACTIVE',
  AppName = 'APP_NAME',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  LastSeenAt = 'LAST_SEEN_AT',
  Platform = 'PLATFORM',
  Token = 'TOKEN',
  UpdatedAt = 'UPDATED_AT',
  UserId = 'USER_ID'
}

export type UserDeviceMetricCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserDeviceMetricCsvColumnEnum;
};

export enum UserDeviceMetricCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  MetricName = 'METRIC_NAME',
  UserId = 'USER_ID'
}

export type UserDeviceMetricWithUserCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserDeviceMetricWithUserCsvColumnEnum;
};

export enum UserDeviceMetricWithUserCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  MetricName = 'METRIC_NAME',
  UserFirstName = 'USER_FIRST_NAME',
  UserId = 'USER_ID',
  UserLastName = 'USER_LAST_NAME'
}

export type UserGroupCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserGroupCsvColumnEnum;
};

export enum UserGroupCsvColumnEnum {
  Active = 'ACTIVE',
  CompanyId = 'COMPANY_ID',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Name = 'NAME',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type UserGroupHasPermissionCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserGroupHasPermissionCsvColumnEnum;
};

export enum UserGroupHasPermissionCsvColumnEnum {
  GroupId = 'GROUP_ID',
  PermissionId = 'PERMISSION_ID'
}

export type UserGroupHasUserCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserGroupHasUserCsvColumnEnum;
};

export enum UserGroupHasUserCsvColumnEnum {
  GroupId = 'GROUP_ID',
  UserId = 'USER_ID'
}

export type UserGroupHasUserWithPermissionsCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserGroupHasUserWithPermissionsCsvColumnEnum;
};

export enum UserGroupHasUserWithPermissionsCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Description = 'DESCRIPTION',
  DisplayGroup = 'DISPLAY_GROUP',
  DisplayName = 'DISPLAY_NAME',
  Effect = 'EFFECT',
  Entity = 'ENTITY',
  GroupId = 'GROUP_ID',
  Id = 'ID',
  Resource = 'RESOURCE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID',
  Verb = 'VERB'
}

export type UserLicenseCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserLicenseCsvColumnEnum;
};

export enum UserLicenseCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  ExpirationDate = 'EXPIRATION_DATE',
  Id = 'ID',
  LicenseTypeId = 'LICENSE_TYPE_ID',
  Number = 'NUMBER',
  StateCode = 'STATE_CODE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type UserLicenseTypeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserLicenseTypeCsvColumnEnum;
};

export enum UserLicenseTypeCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DisplayName = 'DISPLAY_NAME',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type UserLoginEventCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserLoginEventCsvColumnEnum;
};

export enum UserLoginEventCsvColumnEnum {
  CityName = 'CITY_NAME',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Datetime = 'DATETIME',
  FlightNumber = 'FLIGHT_NUMBER',
  Id = 'ID',
  IpAddress = 'IP_ADDRESS',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserAgent = 'USER_AGENT',
  UserId = 'USER_ID'
}

export type UserPermissionCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserPermissionCsvColumnEnum;
};

export enum UserPermissionCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Description = 'DESCRIPTION',
  DisplayGroup = 'DISPLAY_GROUP',
  DisplayName = 'DISPLAY_NAME',
  Effect = 'EFFECT',
  Entity = 'ENTITY',
  Id = 'ID',
  Resource = 'RESOURCE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Verb = 'VERB'
}

export type UserPermissionHasRoleCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserPermissionHasRoleCsvColumnEnum;
};

export enum UserPermissionHasRoleCsvColumnEnum {
  PermissionId = 'PERMISSION_ID',
  RoleId = 'ROLE_ID'
}

export type UserPermissionHasRoleWithPermissionsCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserPermissionHasRoleWithPermissionsCsvColumnEnum;
};

export enum UserPermissionHasRoleWithPermissionsCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Description = 'DESCRIPTION',
  DisplayGroup = 'DISPLAY_GROUP',
  DisplayName = 'DISPLAY_NAME',
  Effect = 'EFFECT',
  Entity = 'ENTITY',
  Id = 'ID',
  PermissionId = 'PERMISSION_ID',
  Resource = 'RESOURCE',
  RoleId = 'ROLE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Verb = 'VERB'
}

export type UserPermissionHasUserCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserPermissionHasUserCsvColumnEnum;
};

export enum UserPermissionHasUserCsvColumnEnum {
  Effect = 'EFFECT',
  PermissionId = 'PERMISSION_ID',
  UserId = 'USER_ID'
}

export type UserPermissionHasUserWithPermissionsCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserPermissionHasUserWithPermissionsCsvColumnEnum;
};

export enum UserPermissionHasUserWithPermissionsCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Description = 'DESCRIPTION',
  DisplayGroup = 'DISPLAY_GROUP',
  DisplayName = 'DISPLAY_NAME',
  Effect = 'EFFECT',
  Entity = 'ENTITY',
  Id = 'ID',
  PermissionId = 'PERMISSION_ID',
  Resource = 'RESOURCE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID',
  Verb = 'VERB'
}

export type UserPunchHistoryCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserPunchHistoryCsvColumnEnum;
};

export enum UserPunchHistoryCsvColumnEnum {
  ApprovalEmployee = 'APPROVAL_EMPLOYEE',
  ApprovalSupervisor = 'APPROVAL_SUPERVISOR',
  ApprovalSupervisorBy = 'APPROVAL_SUPERVISOR_BY',
  CompanyCode = 'COMPANY_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Date = 'DATE',
  DurationOt1 = 'DURATION_OT1',
  DurationOt2 = 'DURATION_OT2',
  DurationRegular = 'DURATION_REGULAR',
  EmployeeId = 'EMPLOYEE_ID',
  FileLocation = 'FILE_LOCATION',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastName = 'LAST_NAME',
  PayType = 'PAY_TYPE',
  PunchInTime = 'PUNCH_IN_TIME',
  PunchInType = 'PUNCH_IN_TYPE',
  PunchOutTime = 'PUNCH_OUT_TIME',
  PunchOutType = 'PUNCH_OUT_TYPE',
  UnpaidDuration = 'UNPAID_DURATION',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type UserRatingCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserRatingCsvColumnEnum;
};

export enum UserRatingCsvColumnEnum {
  Comment = 'COMMENT',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Rating = 'RATING',
  RatingScore = 'RATING_SCORE',
  RatingTypeId = 'RATING_TYPE_ID',
  TripId = 'TRIP_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type UserRatingRemarkCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserRatingRemarkCsvColumnEnum;
};

export enum UserRatingRemarkCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  RatingId = 'RATING_ID',
  Remark = 'REMARK',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type UserRatingRemarksWithRatingCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserRatingRemarksWithRatingCsvColumnEnum;
};

export enum UserRatingRemarksWithRatingCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  RatingComment = 'RATING_COMMENT',
  RatingCreatedAt = 'RATING_CREATED_AT',
  RatingCreatedBy = 'RATING_CREATED_BY',
  RatingId = 'RATING_ID',
  RatingRating = 'RATING_RATING',
  RatingTripId = 'RATING_TRIP_ID',
  RatingTypeCreatedAt = 'RATING_TYPE_CREATED_AT',
  RatingTypeCreatedBy = 'RATING_TYPE_CREATED_BY',
  RatingTypeId = 'RATING_TYPE_ID',
  RatingTypeName = 'RATING_TYPE_NAME',
  RatingTypeUpdatedAt = 'RATING_TYPE_UPDATED_AT',
  RatingTypeUpdatedBy = 'RATING_TYPE_UPDATED_BY',
  RatingUpdatedAt = 'RATING_UPDATED_AT',
  RatingUpdatedBy = 'RATING_UPDATED_BY',
  RatingUserId = 'RATING_USER_ID',
  Remark = 'REMARK',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type UserRatingTypeCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserRatingTypeCsvColumnEnum;
};

export enum UserRatingTypeCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type UserRatingWithRemarksCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserRatingWithRemarksCsvColumnEnum;
};

export enum UserRatingWithRemarksCsvColumnEnum {
  Comment = 'COMMENT',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Rating = 'RATING',
  RatingRemarkId = 'RATING_REMARK_ID',
  RatingRemarkRemark = 'RATING_REMARK_REMARK',
  RatingTypeName = 'RATING_TYPE_NAME',
  TripId = 'TRIP_ID',
  TypeId = 'TYPE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type UserRoleCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserRoleCsvColumnEnum;
};

export enum UserRoleCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Name = 'NAME',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY'
}

export type UserStorageCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserStorageCsvColumnEnum;
};

export enum UserStorageCsvColumnEnum {
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  Id = 'ID',
  Key = 'KEY',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID',
  Value = 'VALUE'
}

export type UserUserAvailabilityCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserUserAvailabilityCsvColumnEnum;
};

export enum UserUserAvailabilityCsvColumnEnum {
  Approved = 'APPROVED',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DayOfWeek = 'DAY_OF_WEEK',
  EndDate = 'END_DATE',
  EndTime = 'END_TIME',
  Id = 'ID',
  Reason = 'REASON',
  RepeatUntil = 'REPEAT_UNTIL',
  ReviewedBy = 'REVIEWED_BY',
  StartDate = 'START_DATE',
  StartTime = 'START_TIME',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type UserUserAvailabilityWithDatetimesCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserUserAvailabilityWithDatetimesCsvColumnEnum;
};

export enum UserUserAvailabilityWithDatetimesCsvColumnEnum {
  Approved = 'APPROVED',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DayOfWeek = 'DAY_OF_WEEK',
  EndDate = 'END_DATE',
  EndDatetime = 'END_DATETIME',
  EndTime = 'END_TIME',
  Id = 'ID',
  Reason = 'REASON',
  RepeatUntil = 'REPEAT_UNTIL',
  ReviewedBy = 'REVIEWED_BY',
  StartDate = 'START_DATE',
  StartDatetime = 'START_DATETIME',
  StartTime = 'START_TIME',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  UserId = 'USER_ID'
}

export type UserUserCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserUserCsvColumnEnum;
};

export enum UserUserCsvColumnEnum {
  Active = 'ACTIVE',
  Address = 'ADDRESS',
  Avatar = 'AVATAR',
  CityName = 'CITY_NAME',
  CompanyId = 'COMPANY_ID',
  CountryCode = 'COUNTRY_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Dob = 'DOB',
  Email = 'EMAIL',
  EmployeeId = 'EMPLOYEE_ID',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastLogin = 'LAST_LOGIN',
  LastLoginOffset = 'LAST_LOGIN_OFFSET',
  LastLoginTimezone = 'LAST_LOGIN_TIMEZONE',
  LastLoginUtc = 'LAST_LOGIN_UTC',
  LastName = 'LAST_NAME',
  LongTrip = 'LONG_TRIP',
  Notes = 'NOTES',
  Password = 'PASSWORD',
  Phone = 'PHONE',
  PrimaryAirportCode = 'PRIMARY_AIRPORT_CODE',
  ProviderId = 'PROVIDER_ID',
  ResetClientIp = 'RESET_CLIENT_IP',
  ResetCode = 'RESET_CODE',
  ResetCreatedAtUtc = 'RESET_CREATED_AT_UTC',
  RoleId = 'ROLE_ID',
  StartDate = 'START_DATE',
  StateCode = 'STATE_CODE',
  Timezone = 'TIMEZONE',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Username = 'USERNAME',
  VehicleId = 'VEHICLE_ID',
  ZipCode = 'ZIP_CODE'
}

export type UserUserHasAirportCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserUserHasAirportCsvColumnEnum;
};

export enum UserUserHasAirportCsvColumnEnum {
  AirportCode = 'AIRPORT_CODE',
  UserId = 'USER_ID'
}

export type UserUserWithAvailabilityAndPermissionsCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserUserWithAvailabilityAndPermissionsCsvColumnEnum;
};

export enum UserUserWithAvailabilityAndPermissionsCsvColumnEnum {
  Active = 'ACTIVE',
  Address = 'ADDRESS',
  Approved = 'APPROVED',
  AvailabilityEndDate = 'AVAILABILITY_END_DATE',
  AvailabilityEndDatetime = 'AVAILABILITY_END_DATETIME',
  AvailabilityEndTime = 'AVAILABILITY_END_TIME',
  AvailabilityId = 'AVAILABILITY_ID',
  AvailabilityStartDate = 'AVAILABILITY_START_DATE',
  AvailabilityStartDatetime = 'AVAILABILITY_START_DATETIME',
  AvailabilityStartTime = 'AVAILABILITY_START_TIME',
  Avatar = 'AVATAR',
  CityName = 'CITY_NAME',
  CompanyId = 'COMPANY_ID',
  CountryCode = 'COUNTRY_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DayOfWeek = 'DAY_OF_WEEK',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Dob = 'DOB',
  Effect = 'EFFECT',
  Email = 'EMAIL',
  EmployeeId = 'EMPLOYEE_ID',
  Entity = 'ENTITY',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastLogin = 'LAST_LOGIN',
  LastLoginOffset = 'LAST_LOGIN_OFFSET',
  LastLoginTimezone = 'LAST_LOGIN_TIMEZONE',
  LastLoginUtc = 'LAST_LOGIN_UTC',
  LastName = 'LAST_NAME',
  LongTrip = 'LONG_TRIP',
  Notes = 'NOTES',
  Password = 'PASSWORD',
  PermissionId = 'PERMISSION_ID',
  Phone = 'PHONE',
  PrimaryAirportCode = 'PRIMARY_AIRPORT_CODE',
  ProviderId = 'PROVIDER_ID',
  RepeatUntil = 'REPEAT_UNTIL',
  ResetClientIp = 'RESET_CLIENT_IP',
  ResetCode = 'RESET_CODE',
  ResetCreatedAtUtc = 'RESET_CREATED_AT_UTC',
  Resource = 'RESOURCE',
  RoleId = 'ROLE_ID',
  StartDate = 'START_DATE',
  StateCode = 'STATE_CODE',
  Timezone = 'TIMEZONE',
  TraceId = 'TRACE_ID',
  Type = 'TYPE',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Username = 'USERNAME',
  VehicleId = 'VEHICLE_ID',
  Verb = 'VERB',
  ZipCode = 'ZIP_CODE'
}

export type UserUserWithMarketCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserUserWithMarketCsvColumnEnum;
};

export enum UserUserWithMarketCsvColumnEnum {
  Active = 'ACTIVE',
  Address = 'ADDRESS',
  AirportCodes = 'AIRPORT_CODES',
  Avatar = 'AVATAR',
  CityName = 'CITY_NAME',
  CompanyId = 'COMPANY_ID',
  CountryCode = 'COUNTRY_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Dob = 'DOB',
  Email = 'EMAIL',
  EmployeeId = 'EMPLOYEE_ID',
  FirstName = 'FIRST_NAME',
  Id = 'ID',
  LastLogin = 'LAST_LOGIN',
  LastLoginOffset = 'LAST_LOGIN_OFFSET',
  LastLoginTimezone = 'LAST_LOGIN_TIMEZONE',
  LastLoginUtc = 'LAST_LOGIN_UTC',
  LastName = 'LAST_NAME',
  LongTrip = 'LONG_TRIP',
  Notes = 'NOTES',
  Password = 'PASSWORD',
  Phone = 'PHONE',
  PrimaryAirportCode = 'PRIMARY_AIRPORT_CODE',
  ProviderId = 'PROVIDER_ID',
  ResetClientIp = 'RESET_CLIENT_IP',
  ResetCode = 'RESET_CODE',
  ResetCreatedAtUtc = 'RESET_CREATED_AT_UTC',
  RoleId = 'ROLE_ID',
  RoleName = 'ROLE_NAME',
  StartDate = 'START_DATE',
  StateCode = 'STATE_CODE',
  Timezone = 'TIMEZONE',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Username = 'USERNAME',
  VehicleId = 'VEHICLE_ID',
  ZipCode = 'ZIP_CODE'
}

export type UserUserWithPermissionsCsvColumn = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  format?: InputMaybe<DatetimeFormatEnum>;
  type: UserUserWithPermissionsCsvColumnEnum;
};

export enum UserUserWithPermissionsCsvColumnEnum {
  Active = 'ACTIVE',
  Address = 'ADDRESS',
  Avatar = 'AVATAR',
  CityName = 'CITY_NAME',
  CompanyId = 'COMPANY_ID',
  CountryCode = 'COUNTRY_CODE',
  CreatedAt = 'CREATED_AT',
  CreatedBy = 'CREATED_BY',
  DeletedAt = 'DELETED_AT',
  DeletedBy = 'DELETED_BY',
  Dob = 'DOB',
  Effect = 'EFFECT',
  Email = 'EMAIL',
  EmployeeId = 'EMPLOYEE_ID',
  Entity = 'ENTITY',
  FirstName = 'FIRST_NAME',
  GroupId = 'GROUP_ID',
  Id = 'ID',
  LastLogin = 'LAST_LOGIN',
  LastLoginOffset = 'LAST_LOGIN_OFFSET',
  LastLoginTimezone = 'LAST_LOGIN_TIMEZONE',
  LastLoginUtc = 'LAST_LOGIN_UTC',
  LastName = 'LAST_NAME',
  LongTrip = 'LONG_TRIP',
  Notes = 'NOTES',
  Password = 'PASSWORD',
  PermissionId = 'PERMISSION_ID',
  Phone = 'PHONE',
  PrimaryAirportCode = 'PRIMARY_AIRPORT_CODE',
  ProviderId = 'PROVIDER_ID',
  ResetClientIp = 'RESET_CLIENT_IP',
  ResetCode = 'RESET_CODE',
  ResetCreatedAtUtc = 'RESET_CREATED_AT_UTC',
  Resource = 'RESOURCE',
  RoleId = 'ROLE_ID',
  StartDate = 'START_DATE',
  StateCode = 'STATE_CODE',
  Timezone = 'TIMEZONE',
  TraceId = 'TRACE_ID',
  UpdatedAt = 'UPDATED_AT',
  UpdatedBy = 'UPDATED_BY',
  Username = 'USERNAME',
  VehicleId = 'VEHICLE_ID',
  Verb = 'VERB',
  ZipCode = 'ZIP_CODE'
}
